webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

        this.apiToken = '$2y$10$D5j6osoFJ3p3XCrnze4BOURXQ2kr0NEYIoe5fzidg0KXAFDxTcGy';
        this.market_app_name = "eshop";
        this.market_app_temp_co_share = 3;
        this.market_app_default_plan = 697;
        this.app_url = "https://sellpoints.com.ng";
        this.app_name = "MultiShop";
        this.app_default_business_category = 4;
        this.sp_url = "https://sp.afiahub.com";
        this.siteUrl = 'http://share.sellpoints.com.ng/';

        this.video_exts = ['mp4', 'mp3'];

        this.general_banner_image = "";
        this.timeout_msg_wait_period = 8000;
        this.upload_wait_period = 60000;
        this.max_media_upload = "7MB";
        this.app_default_color = "#ff0066";

        this.baseURL = 'https://smp.afiahub.com/api/';
        this.msailbaseURL = 'https://msail.afiahub.com/api/';

        this.imageSellpointsURL = '';
        this.imageProductsURL = '';
        this.imageUsersURL = '';

        this.udb_name = "udbase";
        this.s2gdb_name = "shop2gedadbase";
        this.adr_db_name = "active_dynamic_request_db";
        this.current_s2g_activity_db_name = "activity_shop2gedadbase";
        this.store_db = [{ db_id: 9, db_name: "wishlistdbase", db_tag: "wishlist" }, { db_id: 10, db_name: "saveditemsdbase", db_tag: "saveditems" }, { db_id: 11, db_name: "savedshopsdbase", db_tag: "savedshops" }];
        this.set_sellpoint_db = { tag: "sellpoint", db_name: "sellpoint" };

        this.bdb_name = "businessbase";
        this.bbnksdb_name = "businessbankbase";
        this.bdlsdb_name = "businessdeliverylocationsbase";

        this.upload_media_error_msg = "Something went wrong uploading media, the format may not be supported or file size is too large, please try again";

        this.app_proc_fee_calc = 0.13;
        this.app_gigs_cash_out_proc_fee = 50;

        this.paystack_public_test = 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e';
        this.paystack_secret_test = '';
        this.paystack_public_live = '';
        this.paystack_secret_live = '';
        this.ravepay_public_test = 'FLWPUBK-8b636e40e721ae65285c678950808ef5-X';
        this.ravepay_secret_test = 'FLWSECK-fabdac3eae4762e5aadf5a27cef03d92-X';
        this.ravepay_public_live = '';
        this.ravepay_secret_live = '';

        this.spcomms_subaccount_id = "RS_52B66F9BA73E4B6FBAF82CF9E6530F25";
        this.spcomms_subaccount_bank_ravepay_id = "";
        this.spcomms_subaccount_bank_account_number = "";
        this.spcomms_subaccount_bank_account_name = "";

        this.proxyURL = "https://mediastream.afiahub.com/api/prx/";

        this.ravepay_test_path = "https://ravesandboxapi.flutterwave.com/";
        this.ravepay_live_path = "https://api.ravepay.co/";

        this.ravepay_call_path = this.ravepay_test_path;
        this.ravepay_public_key = this.ravepay_public_test;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: "getStates",
        value: function getStates(context, id) {
            return context.$http.get(this.baseURL + 'states', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getCities",
        value: function getCities(context, id) {
            return context.$http.get(this.baseURL + 'cities/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getUtilities",
        value: function getUtilities(context) {
            return context.$http.get(this.baseURL + 'app/utilities/accounts', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getFolders",
        value: function getFolders(context, folderFor, folderForId) {
            return context.$http.get(this.baseURL + 'app/folders/' + folderFor + '/' + folderForId, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getSetFolders",
        value: function getSetFolders(context, data) {
            return context.$http.post(this.baseURL + 'app/folders', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "validateDataExist",
        value: function validateDataExist(context, data) {
            return context.$http.post(this.baseURL + 'validate/data/exist', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "regUser",
        value: function regUser(context, data) {
            return context.$http.post(this.baseURL + 'users', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "loginUser",
        value: function loginUser(context, data) {
            return context.$http.post(this.baseURL + 'users/login', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "searchForUser",
        value: function searchForUser(context, data) {
            return context.$http.post(this.baseURL + 'users/search', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "activateUserToken",
        value: function activateUserToken(context, id) {
            return context.$http.get(this.baseURL + 'settings/activate/user/token/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "forgotPassword",
        value: function forgotPassword(context, data) {
            return context.$http.post(this.baseURL + 'settings/password/forgot', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "verifyResetPasswordToken",
        value: function verifyResetPasswordToken(context, id) {
            return context.$http.get(this.baseURL + 'settings/verify/reset/token/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "resetForgotPassword",
        value: function resetForgotPassword(context, data) {
            return context.$http.post(this.baseURL + 'settings/password/forgot/reset', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "resetPassword",
        value: function resetPassword(context, data) {
            return context.$http.post(this.baseURL + 'settings/password/reset', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "changeEmail",
        value: function changeEmail(context, data) {
            return context.$http.post(this.baseURL + 'settings/email/reset', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "sessionGuard",
        value: function sessionGuard(context, data) {
            return context.$http.post(this.baseURL + 'auth/sessions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "sessionSyncSet",
        value: function sessionSyncSet(context, id) {
            return context.$http.get(this.baseURL + 'auth/sessions/sync/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "sessionSync",
        value: function sessionSync(context, data) {
            return context.$http.post(this.baseURL + 'auth/sessions/sync', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "sendAppToken",
        value: function sendAppToken(context, data) {
            return context.$http.post(this.baseURL + 'app/tokens', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "checkUserDetails",
        value: function checkUserDetails(context, data) {
            return context.$http.post(this.baseURL + 'users/checks', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProfileDetails",
        value: function editProfileDetails(context, data) {
            return context.$http.put(this.baseURL + 'users', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "makeAppSubscriptionOrder",
        value: function makeAppSubscriptionOrder(context, data) {
            return context.$http.post(this.baseURL + 'app/businesses/subscription/orders', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "updateAppSubscriptionOrder",
        value: function updateAppSubscriptionOrder(context, data) {
            return context.$http.post(this.baseURL + 'app/businesses/subscription/orders/updates', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "can_edit",
        value: function can_edit(context, data) {
            return context.$http.post(this.baseURL + 'auth/validate/ownership', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessMarket",
        value: function getBusinessMarket(context, id) {
            return context.$http.get(this.baseURL + 'businesses/markets/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppDeliveryPartners",
        value: function getAppDeliveryPartners(context, id) {
            return context.$http.get(this.baseURL + 'app/deliverypartners', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addDeliveryPartner",
        value: function addDeliveryPartner(context, data) {
            return context.$http.post(this.baseURL + 'businesses/deliverypartners', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinesses",
        value: function getBusinesses(context, id) {
            return context.$http.get(this.baseURL + 'businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppBusinesses",
        value: function getAppBusinesses(context, id) {
            return context.$http.get(this.baseURL + 'app/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessByUserName",
        value: function getBusinessByUserName(context, id) {
            return context.$http.get(this.baseURL + 'businesses/usernames/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppBusinessByUserName",
        value: function getAppBusinessByUserName(context, id) {
            return context.$http.get(this.baseURL + 'app/businesses/usernames/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessProducts",
        value: function getBusinessProducts(context, id) {
            return context.$http.get(this.baseURL + 'products/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppProducts",
        value: function getAppProducts(context, id, limit) {
            return context.$http.get(this.baseURL + 'products/markets/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppBusinessProducts",
        value: function getAppBusinessProducts(context, id, limit) {
            return context.$http.get(this.baseURL + 'products/app/businesses/' + id + '/' + limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addNewBusiness",
        value: function addNewBusiness(context, data) {
            return context.$http.post(this.baseURL + 'businesses/new', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addExistingBusiness",
        value: function addExistingBusiness(context, data) {
            return context.$http.post(this.baseURL + 'businesses/existing', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "validateBusinessUserName",
        value: function validateBusinessUserName(context, data) {
            return context.$http.post(this.baseURL + 'businesses/validate/username', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setAppSubscriptionUpgradeDetails",
        value: function setAppSubscriptionUpgradeDetails(context, data) {
            return context.$http.post(this.baseURL + 'app/subscription/upgrade/details', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "upgradeBusinessMarketSubscription",
        value: function upgradeBusinessMarketSubscription(context, data) {
            return context.$http.post(this.baseURL + 'app/businesses/markets/upgrades', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "getCategories",
        value: function getCategories(context) {
            return context.$http.get(this.baseURL + 'categories', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getMainCategories",
        value: function getMainCategories(context, id) {
            return context.$http.get(this.baseURL + 'categories/main/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessSubCategories",
        value: function getBusinessSubCategories(context, id) {
            return context.$http.get(this.baseURL + 'categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessCategories",
        value: function getBusinessCategories(context, id) {
            return context.$http.get(this.baseURL + 'businesses/categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getFollowings",
        value: function getFollowings(context, id) {
            return context.$http.get(this.baseURL + 'app/followings/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addFollowing",
        value: function addFollowing(context, data) {
            return context.$http.post(this.baseURL + 'followings', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppMarketCircle",
        value: function getAppMarketCircle(context, id) {
            return context.$http.get(this.baseURL + 'app/marketcircle/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppSubscriptions",
        value: function getAppSubscriptions(context, data) {
            return context.$http.post(this.baseURL + 'app/subscriptions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppSubscriptionOffers",
        value: function getAppSubscriptionOffers(context, data) {
            return context.$http.post(this.baseURL + 'app/subscriptions/offers', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getXPosts",
        value: function getXPosts(context, type, id, offset, limit) {
            return context.$http.get(this.baseURL + 'app/xposts/points/' + type + '/' + id + '/' + offset + '/' + limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getXPostsGroups",
        value: function getXPostsGroups(context, id, offset, limit) {
            return context.$http.get(this.baseURL + 'app/xposts/groups/' + id + '/' + offset + '/' + limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addXPosts",
        value: function addXPosts(context, data) {
            return context.$http.post(this.baseURL + 'xposts', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "getComLogs",
        value: function getComLogs(context, id) {
            return context.$http.get(this.baseURL + 'app/com/members/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "createNewGroup",
        value: function createNewGroup(context, data) {
            return context.$http.post(this.baseURL + 'groups', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addMembersToGroups",
        value: function addMembersToGroups(context, data) {
            return context.$http.post(this.baseURL + 'groups/members', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addNotifications",
        value: function addNotifications(context, data) {
            return context.$http.post(this.baseURL + 'notifications', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "addGallery",
        value: function addGallery(context, data) {
            return context.$http.post(this.baseURL + 'posts/gallery', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "getPointGalleryPosts",
        value: function getPointGalleryPosts(context, id, offset, limit, posts_offset, posts_limit) {
            return context.$http.get(this.baseURL + 'posts/gallery/points/' + id + '/' + offset + '/' + limit + '/' + posts_offset + '/' + posts_limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getGallerySearch",
        value: function getGallerySearch(context, id) {
            return context.$http.get(this.baseURL + 'posts/gallery/url/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editBusinessDetails",
        value: function editBusinessDetails(context, data) {
            return context.$http.put(this.baseURL + 'businesses/details', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setShippingFeeStatus",
        value: function setShippingFeeStatus(context, data) {
            return context.$http.put(this.baseURL + 'businesses/setshippingfeestatus', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addDeliveryOption",
        value: function addDeliveryOption(context, data) {
            return context.$http.post(this.baseURL + 'businesses/deliveryoptions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editDeliveryOption",
        value: function editDeliveryOption(context, data) {
            return context.$http.put(this.baseURL + 'businesses/deliveryoptions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteDeliveryOption",
        value: function deleteDeliveryOption(context, id, data) {
            return context.$http.put(this.baseURL + 'businesses/deliveryoptions/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "switchProcessingFeePay",
        value: function switchProcessingFeePay(context, data) {
            return context.$http.put(this.baseURL + 'businesses/processingfees', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "postBusinessProcessingFeeTransactions",
        value: function postBusinessProcessingFeeTransactions(context, data) {
            return context.$http.post(this.baseURL + 'businesses/processingfees/transactions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessProcessingFeesTransactions",
        value: function getBusinessProcessingFeesTransactions(context, id, offset, limit) {
            return context.$http.get(this.baseURL + 'businesses/processingfees/transactions/' + id + '/' + offset + '/' + limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setBusinessAgentCommissions",
        value: function setBusinessAgentCommissions(context, data) {
            return context.$http.put(this.baseURL + 'businesses/settings/commissions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessDiscountsCoupons",
        value: function getBusinessDiscountsCoupons(context, id) {
            return context.$http.get(this.baseURL + 'businesses/discountscoupons/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessDiscountsAndCoupons",
        value: function getBusinessDiscountsAndCoupons(context, id) {
            return context.$http.get(this.baseURL + 'businesses/discounts/coupons/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setDiscountsAndCoupons",
        value: function setDiscountsAndCoupons(context, data) {
            return context.$http.post(this.baseURL + 'businesses/discounts/coupons', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editDiscountsAndCoupons",
        value: function editDiscountsAndCoupons(context, data) {
            return context.$http.put(this.baseURL + 'businesses/discounts/coupons', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deactivateDiscountsAndCoupons",
        value: function deactivateDiscountsAndCoupons(context, data) {
            return context.$http.put(this.baseURL + 'businesses/discounts/coupons/deactivate', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getGeneralGoods",
        value: function getGeneralGoods(context) {
            return context.$http.get(this.msailbaseURL + 'products/get/categories', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getGeneralGoodsCategoryProducts",
        value: function getGeneralGoodsCategoryProducts(context, id) {
            return context.$http.get(this.msailbaseURL + 'products/categories/products/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProductImages",
        value: function getProductImages(context, id) {
            return context.$http.get(this.baseURL + 'products/images/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteProductImage",
        value: function deleteProductImage(context, id) {
            return context.$http.delete(this.baseURL + 'products/images/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "uploadDataPhoto",
        value: function uploadDataPhoto(context, data) {
            return context.$http.post(this.baseURL + 'uploads', data, {
                headers: {
                    'Origin-Host': this.apiToken,
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
    }, {
        key: "uploadBusinessDataPhoto",
        value: function uploadBusinessDataPhoto(context, data) {
            return context.$http.post(this.baseURL + 'businesses/uploads', data, {
                headers: {
                    'Origin-Host': this.apiToken,
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
    }, {
        key: "getUser",
        value: function getUser(context, id) {
            return context.$http.get(this.baseURL + 'users/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getUserAppSettings",
        value: function getUserAppSettings(context, id) {
            return context.$http.get(this.baseURL + 'app/settings/users/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProductsInBusinessCategories",
        value: function getProductsInBusinessCategories(context, id) {
            return context.$http.get(this.baseURL + 'products/businesses/categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getMarketCategories",
        value: function getMarketCategories(context) {
            return context.$http.get(this.baseURL + 'market/categories', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessMarketGroups",
        value: function getBusinessMarketGroups(context) {
            return context.$http.get(this.baseURL + '/app/businesses/markets/groups', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getFilters",
        value: function getFilters(context) {
            return context.$http.get(this.baseURL + 'filters', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addBusiness",
        value: function addBusiness(context, data) {
            return context.$http.post(this.baseURL + 'businesses', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessNotifications",
        value: function getBusinessNotifications(context, id) {
            return context.$http.get(this.baseURL + 'notifications/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessMessages",
        value: function getBusinessMessages(context, id) {
            return context.$http.get(this.baseURL + 'messages/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessOrders",
        value: function getBusinessOrders(context, id) {
            return context.$http.get(this.baseURL + 'orders/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getNotifications",
        value: function getNotifications(context, id) {
            return context.$http.get(this.baseURL + 'notifications/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "readNotifications",
        value: function readNotifications(context, data) {
            return context.$http.post(this.baseURL + 'notifications/general/updates', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "clickNotifications",
        value: function clickNotifications(context, id) {
            return context.$http.get(this.baseURL + 'notifications/clicks/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getChatLogs",
        value: function getChatLogs(context, id, id2) {
            return context.$http.get(this.baseURL + 'chats/logs/' + id + '/' + id2, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getChatLog",
        value: function getChatLog(context, id, id2, id3) {
            return context.$http.get(this.baseURL + 'chats/logs/' + id + '/' + id2 + '/' + id3, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "postChat",
        value: function postChat(context, data) {
            return context.$http.post(this.baseURL + 'chats/posts', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addCategory",
        value: function addCategory(context, data) {
            return context.$http.post(this.baseURL + 'businesses/categories', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editCategory",
        value: function editCategory(context, data) {
            return context.$http.put(this.baseURL + 'businesses/categories', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProducts",
        value: function getProducts(context, offset, limit) {
            return context.$http.get(this.baseURL + 'products/all/' + offset + '/' + limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getMarketProducts",
        value: function getMarketProducts(context, id) {
            return context.$http.get(this.baseURL + 'products/markets/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getMarketGroupsProducts",
        value: function getMarketGroupsProducts(context, id, offset, limit) {
            return context.$http.get(this.baseURL + 'products/markets/groups/' + id + '/' + offset + '/' + limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getMarketActivityProducts",
        value: function getMarketActivityProducts(context, id, offset, limit) {
            return context.$http.get(this.baseURL + 'products/markets/activities/' + id + '/' + offset + '/' + limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessMarket",
        value: function getBusinessMarket(context, id) {
            return context.$http.get(this.baseURL + 'businesses/markets/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessesOpenToAgents",
        value: function getBusinessesOpenToAgents(context, data) {
            return context.$http.post(this.baseURL + 'businesses/open/agents', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getCategoryProducts",
        value: function getCategoryProducts(context, id) {
            return context.$http.get(this.baseURL + 'products/categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessesOpenAgentsCategoryProducts",
        value: function getBusinessesOpenAgentsCategoryProducts(context, data) {
            return context.$http.post(this.baseURL + 'products/businesses/agents/categories', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessesOpenAgentsProducts",
        value: function getBusinessesOpenAgentsProducts(context) {
            return context.$http.get(this.baseURL + 'products/agents/businesses', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAgentsBusinessCategoryProducts",
        value: function getAgentsBusinessCategoryProducts(context, id) {
            return context.$http.get(this.baseURL + 'products/agents/business/categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getRecommendedProducts",
        value: function getRecommendedProducts(context, id) {
            return context.$http.get(this.baseURL + 'products/recommends/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "searchCategoryProducts",
        value: function searchCategoryProducts(context, name, type) {
            return context.$http.get(this.baseURL + 'products/search/categories/' + name + '/' + type, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "searchProducts",
        value: function searchProducts(context, search) {
            return context.$http.get(this.baseURL + 'products/search/' + search, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "searchBusinessProducts",
        value: function searchBusinessProducts(context, search) {
            return context.$http.get(this.baseURL + 'products/search/businesses/' + search, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProductSearch",
        value: function getProductSearch(context, id) {
            return context.$http.get(this.baseURL + 'products/product/url/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setRelatedProducts",
        value: function setRelatedProducts(context, data) {
            return context.$http.post(this.baseURL + 'products/related', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setProductAgentShip",
        value: function setProductAgentShip(context, data) {
            return context.$http.post(this.baseURL + 'products/ships/agents', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addProduct",
        value: function addProduct(context, data) {
            return context.$http.post(this.baseURL + 'products', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "addProductItem",
        value: function addProductItem(context, data) {
            return context.$http.post(this.baseURL + 'products/items', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addAgentProduct",
        value: function addAgentProduct(context, data) {
            return context.$http.post(this.baseURL + 'products/agents', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "addProductDetail",
        value: function addProductDetail(context, data) {
            return context.$http.post(this.baseURL + 'products/details', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "addProductReview",
        value: function addProductReview(context, data) {
            return context.$http.post(this.baseURL + 'products/reviews', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "setProductITemMOQs",
        value: function setProductITemMOQs(context, data) {
            return context.$http.post(this.baseURL + 'products/moqs', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "addToProductAddons",
        value: function addToProductAddons(context, data) {
            return context.$http.post(this.baseURL + 'products/addons', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "removeProductAddons",
        value: function removeProductAddons(context, data) {
            return context.$http.post(this.baseURL + 'products/addons/reset', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "editProduct",
        value: function editProduct(context, id, data) {
            return context.$http.put(this.baseURL + 'products/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProductSettings",
        value: function editProductSettings(context, id, data) {
            return context.$http.put(this.baseURL + 'products/settings/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProductItemSingle",
        value: function editProductItemSingle(context, id, data) {
            return context.$http.put(this.baseURL + 'products/items/singles/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProductItem",
        value: function editProductItem(context, id, data) {
            return context.$http.put(this.baseURL + 'products/items/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "restockProductItem",
        value: function restockProductItem(context, id, data) {
            return context.$http.put(this.baseURL + 'products/items/restock/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "removeProductItem",
        value: function removeProductItem(context, id, data) {
            return context.$http.put(this.baseURL + 'products/items/remove/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProductItemGroup",
        value: function editProductItemGroup(context, id, data) {
            return context.$http.put(this.baseURL + 'products/itemgroups/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "removeProductItemGroup",
        value: function removeProductItemGroup(context, id, data) {
            return context.$http.put(this.baseURL + 'products/itemgroups/remove/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "removeProduct",
        value: function removeProduct(context, id, data) {
            return context.$http.put(this.baseURL + 'products/remove/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProductDetail",
        value: function editProductDetail(context, id, data) {
            return context.$http.put(this.baseURL + 'products/details/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteProductDetail",
        value: function deleteProductDetail(context, id, data) {
            return context.$http.delete(this.baseURL + 'products/details/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProductDeliveryOptions",
        value: function getProductDeliveryOptions(context, id) {
            return context.$http.get(this.baseURL + 'products/delivery/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setProductDelivery",
        value: function setProductDelivery(context, id, data) {
            return context.$http.put(this.baseURL + 'products/delivery/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setProductShippingFeeStatus",
        value: function setProductShippingFeeStatus(context, data) {
            return context.$http.put(this.baseURL + 'products/set/shippingfeestatus', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setProductDeliveryOption",
        value: function setProductDeliveryOption(context, data) {
            return context.$http.post(this.baseURL + 'products/delivery/fees', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProductInformation",
        value: function getProductInformation(context, id) {
            return context.$http.get(this.baseURL + 'products/information/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addProductInformation",
        value: function addProductInformation(context, data) {
            return context.$http.post(this.baseURL + 'products/information', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "editProductInformation",
        value: function editProductInformation(context, id, data) {
            return context.$http.put(this.baseURL + 'products/information/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteProductInformation",
        value: function deleteProductInformation(context, id, data) {
            return context.$http.delete(this.baseURL + 'products/information/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editGallery",
        value: function editGallery(context, id, data) {
            return context.$http.put(this.baseURL + 'posts/gallery/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteGallery",
        value: function deleteGallery(context, id) {
            return context.$http.delete(this.baseURL + 'posts/gallery/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editGalleryPost",
        value: function editGalleryPost(context, id, data) {
            return context.$http.put(this.baseURL + 'posts/gallery/posts/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteGalleryPost",
        value: function deleteGalleryPost(context, id) {
            return context.$http.delete(this.baseURL + 'posts/gallery/posts/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "resetData",
        value: function resetData(context, type, id) {
            return context.$http.get(this.baseURL + 'data/reset/' + type + '/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteImages",
        value: function deleteImages(context, id, data) {
            return context.$http.put(this.baseURL + 'data/images/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "checkout",
        value: function checkout(context, data) {
            return context.$http.post(this.baseURL + 'orders', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "makeOrderSpinoff",
        value: function makeOrderSpinoff(context, data) {
            return context.$http.post(this.baseURL + 'orders/spinoffs', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "makeCustomOrder",
        value: function makeCustomOrder(context, data) {
            return context.$http.post(this.baseURL + 'map/orders', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "makeDirectPayment",
        value: function makeDirectPayment(context, data) {
            return context.$http.post(this.baseURL + 'payments/make/direct', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getOrderAdditionals",
        value: function getOrderAdditionals(context, data) {
            return context.$http.post(this.baseURL + 'orders/additionals/get', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getOrderChart",
        value: function getOrderChart(context, data) {
            return context.$http.post(this.baseURL + 'orders/charts', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getMapOrderChart",
        value: function getMapOrderChart(context, id) {
            return context.$http.get(this.baseURL + 'map/app/orders/chart/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getCheckoutOrder",
        value: function getCheckoutOrder(context, url) {
            return context.$http.get(this.baseURL + 'orders/url/' + url, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getCheckoutOrderReMake",
        value: function getCheckoutOrderReMake(context, ref) {
            return context.$http.get(this.baseURL + 'orders/remakes/' + ref, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getCheckoutOrders",
        value: function getCheckoutOrders(context, id) {
            return context.$http.get(this.baseURL + 'orders/topays/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getCheckoutGiftCardOrders",
        value: function getCheckoutGiftCardOrders(context, data) {
            return context.$http.post(this.baseURL + 'orders/use/giftcards/requests', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "generatePaymentOrder",
        value: function generatePaymentOrder(context, data) {
            return context.$http.post(this.baseURL + 'orders/paymentorders', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "acceptPaymentOrder",
        value: function acceptPaymentOrder(context, data) {
            return context.$http.post(this.baseURL + 'orders/accept/paymentorders', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getPaymentOrders",
        value: function getPaymentOrders(context, data) {
            return context.$http.post(this.baseURL + 'orders/get/paymentorders', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getUserDeliveryDetails",
        value: function getUserDeliveryDetails(context, id) {
            return context.$http.get(this.baseURL + 'users/deliverydetails/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "preparePayments",
        value: function preparePayments(context, data) {
            return context.$http.post(this.baseURL + 'payments/preparepayments', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "verifyRavePayment",
        value: function verifyRavePayment(context, data) {
            return context.$http.post(this.baseURL + 'data/ext/calls', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "updatePayment",
        value: function updatePayment(context, data) {
            return context.$http.post(this.baseURL + 'payments', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "updatePaymentService",
        value: function updatePaymentService(context, data) {
            return context.$http.post(this.baseURL + 'payments/service', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "updateOrderBasics",
        value: function updateOrderBasics(context, data) {
            return context.$http.post(this.baseURL + 'orders/updates/basics', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "updateOrders",
        value: function updateOrders(context, data) {
            return context.$http.post(this.baseURL + 'orders/updates', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "createOrder",
        value: function createOrder(context, data) {
            return context.$http.post(this.baseURL + 'map/orders/create', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "updatePaymentDetails",
        value: function updatePaymentDetails(context, data) {
            return context.$http.post(this.baseURL + 'payments/updates', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getOrders",
        value: function getOrders(context, id) {
            return context.$http.get(this.baseURL + 'orders/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getOrdersByRefBash",
        value: function getOrdersByRefBash(context, id) {
            return context.$http.get(this.baseURL + 'orders/ref/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppBusinessOrders",
        value: function getAppBusinessOrders(context, id) {
            return context.$http.get(this.baseURL + 'app/orders/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppBusinessOrdersPendingPayments",
        value: function getAppBusinessOrdersPendingPayments(context, id, id2) {
            return context.$http.get(this.baseURL + 'app/payments/pending/' + id + '/' + id2, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getOrderDetails",
        value: function getOrderDetails(context, data) {
            return context.$http.post(this.baseURL + 'orders/details', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppBusinessTransactions",
        value: function getAppBusinessTransactions(context, id) {
            return context.$http.get(this.baseURL + 'app/transactions/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "createCustomData",
        value: function createCustomData(context, data) {
            return context.$http.post(this.baseURL + 'custom/data/sets', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "customSetAgentServices",
        value: function customSetAgentServices(context, data) {
            return context.$http.post(this.baseURL + 'custom/data/set/agentservices', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "customGetAgentServices",
        value: function customGetAgentServices(context, data) {
            return context.$http.post(this.baseURL + 'custom/data/agentservices', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "customGetAgentServiceActivities",
        value: function customGetAgentServiceActivities(context, data) {
            return context.$http.post(this.baseURL + 'custom/data/agentservices/activities', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppBusinessCustomers",
        value: function getAppBusinessCustomers(context, id) {
            return context.$http.get(this.baseURL + 'app/customers/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addService",
        value: function addService(context, data) {
            return context.$http.post(this.baseURL + 'businesses/services', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editService",
        value: function editService(context, data) {
            return context.$http.put(this.baseURL + 'businesses/services', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessDeliveryOptions",
        value: function getBusinessDeliveryOptions(context, id) {
            return context.$http.get(this.baseURL + 'businesses/deliveryoptions/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "checkBusinessPayOnDelivery",
        value: function checkBusinessPayOnDelivery(context, id) {
            return context.$http.get(this.baseURL + 'businesses/checkdeliveryoptions/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "sendBusinessContactForm",
        value: function sendBusinessContactForm(context, data) {
            return context.$http.post(this.baseURL + 'businesses/contacts', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setBusinessFilterOptions",
        value: function setBusinessFilterOptions(context, data) {
            return context.$http.put(this.baseURL + 'businesses/filters', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "removeBusinessFilterOption",
        value: function removeBusinessFilterOption(context, data) {
            return context.$http.post(this.baseURL + 'businesses/filters', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setBusinessBankDetails",
        value: function setBusinessBankDetails(context, data) {
            return context.$http.put(this.baseURL + 'businesses/bankdetails', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getRavepayBanksCHECK_XX",
        value: function getRavepayBanksCHECK_XX(context) {
            return context.$http.get(this.proxyURL + this.ravepay_test_path + 'v2/banks/NG/?public_key=FLWPUBK-8b636e40e721ae65285c678950808ef5-X', {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        }
    }, {
        key: "getRavepayBanks",
        value: function getRavepayBanks(context) {
            return context.$http.get(this.ravepay_call_path + 'v2/banks/NG/?public_key=' + this.ravepay_public_key, {
                headers: { 'Content-Type': 'application/json' }
            });
        }
    }, {
        key: "getRavepayBanksXX",
        value: function getRavepayBanksXX() {
            return axios.get(this.ravepay_call_path + 'v2/banks/NG/?public_key=' + this.ravepay_public_key, {
                headers: { 'Content-Type': 'application/json' }
            });
        }
    }, {
        key: "createRavepaySubaccount",
        value: function createRavepaySubaccount(data) {
            return axios.post(this.ravepay_call_path + 'v2/gpx/subaccounts/create', data, {
                headers: { 'Content-Type': 'application/json' }
            });
        }
    }, {
        key: "transferPayoutRavepay",
        value: function transferPayoutRavepay(data) {
            return axios.post(this.ravepay_call_path + 'v3/transfers', data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + this.ravepay_secret_test
                }
            });
        }
    }, {
        key: "postBusinessGeneralOrders",
        value: function postBusinessGeneralOrders(context, data) {
            return context.$http.post(this.baseURL + 'orders/generalorders', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getGeneralRewardTypes",
        value: function getGeneralRewardTypes(context, id) {
            return context.$http.get(this.baseURL + 'rewards/types', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessRewardSettings",
        value: function getBusinessRewardSettings(context, id) {
            return context.$http.get(this.baseURL + 'businesses/rewards/settings/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "postBusinessRewardSettings",
        value: function postBusinessRewardSettings(context, data) {
            return context.$http.post(this.baseURL + 'businesses/rewards/settings', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "updateBusinessRewardSettings",
        value: function updateBusinessRewardSettings(context, data) {
            return context.$http.put(this.baseURL + 'businesses/rewards/settings', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "updateBusinessGeneralSettings",
        value: function updateBusinessGeneralSettings(context, data) {
            return context.$http.put(this.baseURL + 'businesses/updates', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getUserCollections",
        value: function getUserCollections(context, id) {
            return context.$http.get(this.baseURL + 'collections/users/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAccountCollections",
        value: function getAccountCollections(context, data) {
            return context.$http.post(this.baseURL + 'collections/accounts', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getUserMonies",
        value: function getUserMonies(context, id) {
            return context.$http.get(this.baseURL + 'monies/users/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "postCollectionsServices",
        value: function postCollectionsServices(context, data) {
            return context.$http.post(this.baseURL + 'collections/services', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getActiveBrokers",
        value: function getActiveBrokers(context) {
            return context.$http.get(this.baseURL + 'agentsco/brokers', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "postAgentRequests",
        value: function postAgentRequests(context, data) {
            return context.$http.post(this.baseURL + 'agentsco/requests', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "acceptBrokerRequests",
        value: function acceptBrokerRequests(context, data) {
            return context.$http.post(this.baseURL + 'agentsco/requests/brokers/accept', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setBrokerRequestFee",
        value: function setBrokerRequestFee(context, data) {
            return context.$http.post(this.baseURL + 'agentsco/requests/brokers/fee', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBrokerData",
        value: function getBrokerData(context, id) {
            return context.$http.get(this.baseURL + 'agentsco/brokers/data/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setReferralBash",
        value: function setReferralBash(context, data) {
            return context.$http.post(this.baseURL + 'agentsco/requests/refs', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getReferralBashDetails",
        value: function getReferralBashDetails(context, id) {
            return context.$http.get(this.baseURL + 'agentsco/requests/data/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "regActivity",
        value: function regActivity(context, data) {
            return context.$http.post(this.baseURL + 'activities/registers', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setActivity",
        value: function setActivity(context, data) {
            return context.$http.post(this.baseURL + 'activities/requests/sets', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getActivities",
        value: function getActivities(context, data) {
            return context.$http.post(this.baseURL + 'activities/requests', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "updateActivity",
        value: function updateActivity(context, data) {
            return context.$http.post(this.baseURL + 'activities/requests/updates', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "postMessages",
        value: function postMessages(context, data) {
            return context.$http.post(this.baseURL + 'messages', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "postMessageThreads",
        value: function postMessageThreads(context, data) {
            return context.$http.post(this.baseURL + 'messages/threads', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getUserMessages",
        value: function getUserMessages(context, id) {
            return context.$http.get(this.baseURL + 'messages/users/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(411)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(622),
  /* scopeId */
  "data-v-ba13e012",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_validation__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resources_commons_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mixins_postsco_script_js__ = __webpack_require__(57);








var service = new __WEBPACK_IMPORTED_MODULE_3__services_service__["a" /* default */]();
var validator = new __WEBPACK_IMPORTED_MODULE_4__services_validation__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Settings',
    mixins: [__WEBPACK_IMPORTED_MODULE_5__resources_commons_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__components_mixins_postsco_script_js__["default"]],
    data: function data() {
        var _ref;

        return _ref = {
            header_name: service.app_name,
            kip: 0,
            user: {},
            sellpoints: {},
            sellpoint: {},
            business: {},
            products: {},
            product: {},
            product_item_group: {},
            product_item: {},
            categories: {},
            category: {},
            main_category: {},
            sub_categories: [],
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            sellpoint_gallery: {},
            galleria: {},
            lookbooks: {},
            lookbook: {},
            lookbook_post: {},
            menu_view: {},
            menu_tab_view: {},
            menu_tab_inner_view: {},
            is_view: "",
            is_viewing: "Account",
            is_viewed: "Account",
            is_view_type: "Account",
            img_url: service.imageURL,
            server_query_done: false,
            setPanel: false,
            loading: true,
            action_loading: false,
            disable_btn: false,
            data_processing_message: "",
            data_error_message: "",
            data_success_message: "",
            data_media_error_message: "",
            max_media_info: service.max_upload_image_info,
            max_plan_lookbooks: 0,
            max_plan_lookbook_posts: 0,
            total_lookbooks_added: 0,
            can_add_more_lookbook: false,
            can_add_product_lookbook: false,
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            setSettings: false,
            setting_details: {},

            states: {},
            cities: {},
            dvco_cities: {},
            delivery_partners: {},
            delivery_option: {},
            other_delivery_option: false,
            edit_other_delivery_option: false,
            custom_delivery_option: false,
            set_dvco_delivery_option: false,
            delivery_custom_options: {},
            component_view: { viewProducts: true, viewProduct: false, viewLookbooks: true, viewLookbook: false, viewLookbookPost: false },
            business_details: { delivery_edit: false, delivery_add: false, delivery_option_edit: false, viewDiscounts: true, setDiscount: false },
            product_details: {},
            lookbook_details: {},
            manageList: ["manageBusinesses", "manageProducts", "manageServices", "manageLookbooks"],
            manage: ["manageBusinesses", "manageProducts", "manageServices", "manageLookbooks"],
            discount_coupon: {},
            discount_coupon_is_gift_card: false,
            discount_coupon_is_direct: false,
            managePanel: false,
            manageBusinesses: true,
            manageProducts: false,
            manageServices: false,
            manageLookbooks: false,
            managePosts: false,
            manageOrders: false,
            manageBusinessDetails: false,
            businessComponents: ["BusinessEditing", "BusinessDeliveryShipping", "BusinessCoupons", "BusinessPaymentGateway"],
            business_set_shipping_fee_status: 9,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            product_set_shipping_fee_status: 12,
            set_shipping_fee_status_track: false,

            business_agent: 0,
            business_open_agents_products: {},
            business_product_categories: [],
            business_service_categories: [],
            business_category_type: 0,
            validate_user_name_error: false,
            validate_user_name_message: "",

            product_display_image: {}
        }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'product_item', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'file_info', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'files_info', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'imageForm', ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'imagesFormArray', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'is_product_service', "product"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'max_upload', service.max_media_upload), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'show_product_setting_box', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'showProductItemGroups', ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'tap_01', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'viewing_lookbook', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'viewing_lookbook_post', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'is_viewing_lookbook', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'post', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'posts', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'viewPost', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'group', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'groups', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'group_member', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'view_group_members', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'share_group', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'current_sellpoint_id', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'market_groups', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'app_orders', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'order', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'orders', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'order_chart', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'order_additionals', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'viewOrder', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'viewPendingPayOrder', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'viewPendingPayOrders', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'sellpoint_orders', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'sellpoint_pending_orders', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'sellpoint_transactions', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'processing_fee', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'payment_gateways', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'ravepay_bank_list', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'ravepay_sba', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'set_reward_type_amount_type', "C"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'product_is_wholesale', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'prdItemPriceKey', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'prdItemWholesaleKey', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'businessComponentKey', 1), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'orderComponentKey', 1), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'productVariationComponentKey', 1), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'productOrdersComponentKey', 1), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'attachProductsComponentKey', 1), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'deliveryAddByDcoKey', 1), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'user_settings', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'broker_deal', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'broker_request', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'broker_deals', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'broker_requests', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'market_circle', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'subscriptions', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'subscribers', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'set_sub_view', 'subscriptions'), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'set_order_pending_payment_data', ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'set_pending_payment_data', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'service_duration', ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'service_offers', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'service_offer', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'data_call_to_actions', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'data_components_services', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'component_loading', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'set_menu', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'menu_link', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'back_link_view', 1), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'prev_menu_link', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'current_menu_link', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'prev_menu_tab_view', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'current_menu_tab_view', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'customers', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'customer', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'reco_products', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'has_sellpoints', true), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'productAddView02ComponentKey', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'active_group', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'saved_shops', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'business_app_subscription', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'business_app_subscription_offers', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'subscription_offer', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'business_delivery_options_nodes', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'componentKey', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'componentDeliveryKey', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'sellpoint_categories', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'search_member', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'display_members', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'set_reward_commission', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'business_open_to_agents', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'getService', service), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'data_user', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'invoice_added_items', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'set_product', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'set_products_as_addons', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'set_products_as_available', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'set_product_addons', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'set_order_product_addons', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'set_order_list', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'set_order_addons', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'set_order_data', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'set_order_total_amount', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'set_order_delivery_location', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'set_ordered_items', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'set_detail', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'set_payment_mode', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'business_bank_details', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'business_delivery_locations', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'setEditBankDetails', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'setAddDeliveryLocation', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'set_single_component_view', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'set_user_loggedIn', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'data_processing_messages', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'data_loading', {
            businesses: false,
            business: false,
            categories: false,
            category: false,
            products: false,
            product: false
        }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'product_set_details', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'product_set_items', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'general_goods', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'general_goods_category', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'general_goods_category_products', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'total_sales_today', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'data_error', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'add_general_products', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'set_items_list', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'site_user_type', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'service_charge_balance', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'earnings_balance', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'processing_fee_transactions', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'preset_categories', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'custom_data', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'agent_is_active', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'agent_services', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'agent_services_numbers', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'agent_services_data', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'agent_service_user_data', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'agent_service_business_data', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'agent_service_order_data', {}), _ref;
    },


    methods: {
        back: function back() {
            window.history.back();
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        setMenuTabViewLink: function setMenuTabViewLink(type, view, attr1, attr2) {
            this.$router.push(attr2);
        },
        setMenuTabView: function setMenuTabView(type, view, attr1, attr2) {
            this.menu_tab_inner_view = {};
            this.menu_tab_view = {};
            this.menu_tab_view[view] = true;
        },
        setMenuTabInnerView: function setMenuTabInnerView(view, attr1, attr2) {
            this.menu_tab_inner_view = {};
            this.menu_tab_inner_view[view] = true;

            this.data_processing_message = "";
            this.data_error_message = "";
        },
        toggleMenu: function toggleMenu() {
            if (this.set_menu == false) {
                this.set_menu = true;
            } else if (this.set_menu == true) {
                this.set_menu = false;
            }
        },
        openModal: function openModal(id) {
            document.getElementById(id).style.display = "block";
        },
        closeModal: function closeModal(id) {
            document.getElementById(id).style.display = "none";
        },
        numStrip: function numStrip() {
            if (this.product.product_item_price && this.product.product_item_price > 0) {
                this.product.product_item_price = this.product.product_item_price.replace(/[^0-9.,]/g, '');
            }

            if (this.product.product_item_set_moq_price && this.product.product_item_set_moq_price > 0) {
                this.product.product_item_set_moq_price = this.product.product_item_set_moq_price.replace(/[^0-9.,]/g, '');
            }
            this.prdItemPriceKey++;
        },
        resetComponentView: function resetComponentView(view) {
            if (view == 'business') {
                this.business_details = {};
                this.setCurrentBusiness();
            } else if (view == 'product') {
                this.product_details = {};
            }
            this.setMenuTabInnerView('', '', '');
            this.deactivate_processing();
        },
        setCurrentBusiness: function setCurrentBusiness() {
            var payload = {
                username: this.sellpoint.business_username,
                redir: ''
            };
            this.$store.dispatch('account/setBusiness', payload);
        },
        numStrip01: function numStrip01() {
            if (this.product.product_items[0].product_item_price && this.product.product_items[0].product_item_price > 0) {
                this.product.product_items[0].product_item_price = this.product.product_items[0].product_item_price.replace(/[^0-9.,]/g, '');
            }

            if (this.product.product_items[0].product_item_set_moq_price && this.product.product_items[0].product_item_set_moq_price > 0) {
                this.product.product_items[0].product_item_set_moq_price = this.product.product_items[0].product_item_set_moq_price.replace(/[^0-9.,]/g, '');
            }
            this.prdItemPriceKey++;
        },
        toggleSingleComponent: function toggleSingleComponent(component) {
            var toggle = document.getElementById(component).style.display;
            if (toggle == "block") {
                document.getElementById(component).style.display = "none";
            } else {
                document.getElementById(component).style.display = "block";
            }
        },
        toggleDoubleComponent: function toggleDoubleComponent(component1, component2) {
            var toggle1 = document.getElementById(component1).style.display;
            var toggle2 = document.getElementById(component2).style.display;
            if (toggle1 == "block") {
                document.getElementById(component1).style.display = "none";
                document.getElementById(component2).style.display = "block";
            } else {
                document.getElementById(component1).style.display = "block";
                document.getElementById(component2).style.display = "none";
            }
        },
        toggleTrippleComponent: function toggleTrippleComponent(component1, component2, component3) {
            var toggle1 = document.getElementById(component1).style.display;
            var toggle2 = document.getElementById(component2).style.display;
            var toggle3 = document.getElementById(component3).style.display;
            if (toggle1 == "block") {
                document.getElementById(component1).style.display = "none";
            } else {
                document.getElementById(component1).style.display = "block";
            }
            if (toggle2 == "block") {
                document.getElementById(component2).style.display = "none";
            } else {
                document.getElementById(component2).style.display = "block";
            }
            if (toggle3 == "block") {
                document.getElementById(component3).style.display = "none";
            } else {
                document.getElementById(component3).style.display = "block";
            }
        },
        setMenuComponent: function setMenuComponent(view, view_type, attr1, attr2) {
            this.setPanel = true;

            var top = document.getElementById("topPanel").offsetTop;
            window.scrollTo(0, top);

            this.menu_view = {};
            this.menu_view[view] = true;

            if (this.is_viewing == '') {
                this.is_viewing = view;
            }

            this.setViewTree(view, view_type, attr1, attr2);

            this.resetPageSettings(view);
        },
        resetPageSettings: function resetPageSettings(view) {
            if (view == 'viewBusiness' || view == 'viewBusinessCategory' || view == 'viewBusinessCategoryProduct') {
                this.setPageHeaders(view);
                setTimeout(function () {
                    if (document.getElementById(view) != null) {
                        document.getElementById(view).style.color = service.app_default_color;
                    }
                }, 50);
            }
        },
        activateMenuTabView: function activateMenuTabView(view) {
            var tabs = document.getElementsByClassName('tab-menu-link');
            for (var i = 0; i < tabs.length; i++) {
                tabs[i].style = "color:inherit;";
            }

            var tab_menu = document.getElementById(view);
            if (tab_menu != undefined) {
                tab_menu.style.color = service.app_default_color;
            }
        },
        setComponentLoading: function setComponentLoading(view, attr1, attr2) {
            this.component_loading = {};
            this.component_loading[view] = true;
        },
        setComponent: function setComponent(attr1, attr2) {
            this.data_processing_message = "";
            this.deactivate_processing();

            if (attr1 == 'set-settings-inner') {
                this.setSettings = true;
                this.setting_details = {};
                this.setting_details[attr2] = true;
            }

            if (attr1 == 'manage-panel') {
                this.setPanel = true;
                this.managePanel = true;
                this.manage[0] = true;
            }

            if (attr1 == 'set-business-card-details') {
                this.manageBusinessDetails = true;
                this.setBusinessComponent(attr2);
            }

            if (attr1 == 'set-business-details') {
                this.discount_coupon = {};
                this.business_details = {};
                this.business_details[attr2] = true;
            }

            if (attr1 == 'edit-delivery-option') {
                this.delivery_option.edit_set = false;
                this.business_details = {};
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;

                if (this.delivery_option.business_delivery_is_custom == 0) {
                    this.getCities(this.delivery_option.business_delivery_state, 'edit');
                }
                this.business_details["delivery_option_edit"] = true;
            }

            if (attr1 == 'edit-discount-coupon') {
                this.business_details = {};
                this.discount_coupon.edit = false;
                this.discount_coupon = attr2;
                this.discount_coupon.edit = true;
            }

            if (attr1 == 'manage-businesses') {
                this.manageBusinesses = true;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-products') {
                this.manageBusinesses = false;
                this.manageProducts = true;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-services') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = true;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-lookbooks') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = true;
                this.managePosts = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-posts') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.managePosts = true;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-orders') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.managePosts = false;
                this.manageOrders = true;
            }

            if (attr1 == 'reset-edit') {
                this.discount_coupon = {};
                this.business_details = {};
                this.product_details = {};
                this.lookbook_details = {};
                this.setting_details = {};
                this.main_category = {};
                this.setSettings = false;
                this.viewOrder = false;
                this.viewPendingPayOrder = false;
                this.viewPost = false;
                this.data_success_message = "";
                this.data_error_message = "";
                this.data_processing_message = "";
                this.showProductItemGroups = "";
            }

            if (attr1 == 'reset-component-details') {
                this.manageBusinessDetails = false;
            }

            if (attr1 == "orders") {
                this.order = attr2;
                this.viewOrder = true;
            }

            if (attr1 == "pending_pay_orders") {
                this.order = attr2;
                this.viewPendingPayOrder = true;
            }

            if (attr1 == "posts") {
                this.post = attr2;
                this.viewPost = true;
            }
        },
        setInnerComponent: function setInnerComponent(attr1, attr2) {
            if (attr1 == 'set-product-item-group') {
                this.product.product_item_group = attr2.product_item_group_id;
                this.product.product_item_group_name = attr2.product_item_group_name;
                this.productAddView02ComponentKey++;

                var grps = document.getElementsByClassName('product-item-group');
                for (var i = 0; i < grps.length; i++) {
                    grps[i].style = "border:none;";
                }

                document.getElementById(attr2.product_item_group_id + "PRTGR").style = "border:1px solid #0000CC;min-width:65px; max-width:65px;";
            }
            if (attr1 == 'set-product-item-group-image') {
                this.product.product_item_group_image = attr2;
                var imgs = document.getElementsByClassName('product-item-group-image');
                for (var i = 0; i < imgs.length; i++) {
                    imgs[i].style = "border:none;";
                }
                document.getElementById(attr2 + "PRTG").style.border = "1px solid #0000CC";
            }
        },
        resetAll: function resetAll() {
            this.discount_coupon = {};
            this.business_details = {};
            this.product_details = {};
            this.data_success_message = "";
            this.data_error_message = "";
            this.data_processing_message = "";
        },
        resetMessages: function resetMessages() {
            this.data_success_message = "";
            this.data_error_message = "";
            this.data_processing_message = "";
            this.deactivate_processing();
        },
        resetFormData: function resetFormData() {
            this.file_info = {};
            this.files_info = [];
        },
        setViewTree: function setViewTree(view, view_type, attr1, attr2) {
            if (view_type == "sellpoints" || view_type == "business") {
                this.is_view_type = "business";
            } else {
                this.is_view_type = view_type;
            }

            if (this.is_view_type == "business") {
                var view_array_b1 = ["viewBusiness"];

                var view_array_b2 = ["manageBusiness", "viewBusinessCategory", "newBusinessCategory"];

                var view_array_b3 = ["setBusinessProfile", "setBusinessOrders", "setBusinessShippingInformation", "setBusinessShippingLocations", "setBusinessDiscountsCoupons", "setBusinessPaymentInformation", "setBusinessDeleteRequest"];

                var view_array_bc1 = ["manageBusinessCategory", "viewBusinessCategoryProduct", "newBusinessCategoryProduct"];

                var view_array_bcp1 = ["manageBusinessCategoryProduct"];
                var view_array_bcp2 = ["setBusinessCategoryProductDetails", "setBusinessCategoryProductItems", "setBusinessCategoryProductDiscountCoupons", "setBusinessCategoryProductDeliveryAndReturanInformation", "setBusinessCategoryProductShippingInformation"];

                if (this.is_view == "newBusinessCategoryProduct") {
                    this.product = {};this.resetAll();
                }

                if (this.is_view == "viewBusiness") {
                    this.is_viewed = 'sellpoints';
                } else if (this.is_view == "sellpoints") {
                    this.is_viewed = "Account";
                } else {
                    if (view_array_b2.indexOf(this.is_view) != -1) {
                        this.is_viewed = "viewBusiness";
                    } else if (view_array_b3.indexOf(this.is_view) != -1) {
                        this.is_viewed = "manageBusiness";
                    } else if (view_array_bc1.indexOf(this.is_view) != -1) {
                        this.is_viewed = "viewBusinessCategory";this.businessComponentKey++;
                    } else if (view_array_bcp1.indexOf(this.is_view) != -1) {
                        this.is_viewed = "viewBusinessCategoryProduct";
                    } else if (view_array_bcp2.indexOf(this.is_view) != -1) {
                        this.is_viewed = "manageBusinessCategoryProduct";
                    } else {
                        this.is_viewed = "viewBusiness";
                    }
                }
                this.is_view = this.is_viewed;
            }
        },
        setBusinessComponent: function setBusinessComponent(view, attr1, attr2) {
            if (view == "sellpoints") {
                this.sellpoint = this.sellpoints[0];
                this.setSellpoint();
            }
            this.resetMessages();

            this.setPanel = true;
            this.resetPageSettings(view);
            if (view != "sellpoints") {
                this.sellpoint = attr1;

                this.setSellpoint();
            } else {
                this.setMenuTabView('business', 'viewBusiness');
            }

            this.is_view = view;
            this.is_view_type = "business";
            this.is_viewing = this.sellpoint.business_username;
            var entry_array = ["newBusiness", "newBusinessCategory", "newBusinessCategoryProduct", "newBusinessAgentCategoryProduct"];

            if (entry_array.indexOf(view) != -1) {
                if (view == 'newBusiness') {
                    this.sellpoint = {};this.business = {};this.sellpoint = {};this.business_agent = 0;
                }
                if (view == 'newBusinessCategory') {
                    this.main_category = {};this.category = {};
                }
                if (view == 'newBusinessCategoryProduct') {
                    this.product = {};
                }
                if (view == 'newBusinessAgentCategoryProduct') {
                    this.product = {};
                }
            }

            if (view == 'viewBusiness') {
                this.setMenuTabView('business', 'viewBusiness');
            }
            this.main_category = {};

            var category_array = ["viewBusinessCategory", "editBusinessCategory", "removeBusinessCategory"];

            if (category_array.indexOf(view) != -1) {
                this.category = attr2;

                if (view == 'viewBusinessCategory') {
                    this.getBusinessCategoryProducts();
                    if (this.sellpoint.business_agent == 1) {
                        this.getBusinessAgentCategoryProducts();
                        this.getBusinessesIsOpenAgentCategoryProducts();
                    }
                    this.setMenuTabView('business', 'viewBusinessCategory');
                }
            }

            var product_array = ["viewBusinessCategoryProduct", "editBusinessCategoryProduct", "removeBusinessCategoryProduct"];

            if (product_array.indexOf(view) != -1) {
                this.getSetProduct(attr2, '');

                this.is_viewed = "viewBusinessCategory";

                if (view == 'viewBusinessCategoryProduct') {
                    this.setMenuTabView('business', 'viewBusinessCategoryProduct');
                }
            }

            this.menu_view = {};
            this.menu_view[view] = true;
            this.setViewTree(view, "sellpoints", attr1, attr2);
        },
        getSetProduct: function getSetProduct(item, ref) {
            var _this = this;

            this.loading = true;
            var product_url_name = '';
            if (ref != '') {
                product_url_name = ref;
            } else {
                product_url_name = item.product_url_name;
            }

            if (product_url_name != '') {
                service.getProductSearch(this, product_url_name).then(function (response) {
                    if (response.body.status == 200) {
                        _this.loading = false;
                        _this.product = response.body.data;
                        _this.product_display_image = _this.product.product_images[0];
                        _this.product_item = _this.product.product_items[0];

                        _this.$store.dispatch('account/setProduct', _this.product);

                        if (!_this.product.set_product_addons || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this.product.set_product_addons).length == 0) {
                            _this.product.set_product_addons = [];
                        }

                        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this.category).length === 0) {
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;

                            try {
                                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.sellpoint.business_categories), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    var category = _step.value;

                                    if (_this.product.product_category_id == category.business_category_id) {
                                        _this.category = category;

                                        _this.getBusinessCategoryProducts();
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return) {
                                        _iterator.return();
                                    }
                                } finally {
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }

                        _this.product.product_orders = [];
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.sellpoint.orders), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var ord = _step2.value;
                                var _iteratorNormalCompletion3 = true;
                                var _didIteratorError3 = false;
                                var _iteratorError3 = undefined;

                                try {
                                    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(ord.order_items), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                        var ord_item = _step3.value;

                                        if (_this.product.product_id == ord_item.product_id) {
                                            var ord_array = {};
                                            ord_array.order_product = ord_item.product_id;
                                            ord_array.order_date = ord.order_date;
                                            ord_array.order_time_ago = ord.order_time_ago;
                                            ord_array.order_user = ord.order_user;
                                            ord_array.order_item_quantity = ord_item.order_item_quantity;
                                            ord_array.order_status_id = ord.order_status_id;
                                            ord_array.order_status = ord.order_status;
                                            ord_array.order_status_color = ord.order_status_color;
                                            ord_array.order_payment_status_id = ord.order_payment_status_id;
                                            ord_array.order_payment_status = ord.order_payment_status;
                                            ord_array.order_payment_status_color = ord.order_payment_status_color;
                                            _this.product.product_orders.push(ord_array);
                                            _this.productOrdersComponentKey++;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError3 = true;
                                    _iteratorError3 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                            _iterator3.return();
                                        }
                                    } finally {
                                        if (_didIteratorError3) {
                                            throw _iteratorError3;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                }).catch(function (err) {});
            }
        },
        getSetProductDEPAC: function getSetProductDEPAC(item) {
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.category.category_products), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var prd = _step4.value;

                    if (prd.product_url_name == item.product_url_name) {
                        this.product = prd;
                        this.product_display_image = this.product.product_images[0];
                        this.product_item = this.product.product_items[0];
                    } else {}
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
        },
        setComponentView: function setComponentView(attr1, attr2, attr3) {
            this.resetAll();
            if (attr1 == 'switch-to-viewing-loobook') {
                this.setComponent('manage-lookbooks', '');
                this.lookbook = this.viewing_lookbook;
                this.setComponentView('loobooks', this.viewing_lookbook_post, 'viewLookbookPost');

                this.is_viewing_lookbook = false;
                this.viewing_lookbook = {};
                this.viewing_lookbook_post = {};
            }
            if (attr1 == 'products') {
                if (this.component_view.viewProducts) {
                    this.component_view.viewProducts = false;
                    this.component_view.viewProduct = true;
                    this.product = attr2;

                    this.product_set_shipping_fee_status = this.product.product_set_shipping_fee_status;
                } else if (this.component_view.viewProduct) {
                    this.component_view.viewProducts = true;
                    this.component_view.viewProduct = false;
                }
            }
            if (attr1 == 'lookbooks') {
                if (attr3 == 'viewLookbookPost') {
                    this.component_view.viewLookbooks = false;
                    this.component_view.viewLookbook = false;
                    this.component_view.viewLookbookPost = true;
                    this.lookbook_post = attr2;
                } else if (attr3 == 'viewLookbook') {
                    this.component_view.viewLookbooks = false;
                    this.component_view.viewLookbookPost = false;
                    this.component_view.viewLookbook = true;
                    this.lookbook = attr2;
                } else if (attr3 == 'viewLookbooks') {
                    this.component_view.viewLookbooks = true;
                    this.component_view.viewLookbook = false;
                    this.component_view.viewLookbookPost = false;
                }
            }
        },
        toggleProductItemView: function toggleProductItemView(component, attr2, attr3, attr4) {
            var grps = document.getElementsByClassName('product-item-show-more-details');
            for (var i = 0; i < grps.length; i++) {
                grps[i].style = "display:none;";
            }
            var grps = document.getElementsByClassName('product-item-more-details-hide-btn');
            for (var i = 0; i < grps.length; i++) {
                grps[i].style = "display:none;";
            }
            var grps = document.getElementsByClassName('product-item-more-details-view-btn');
            for (var i = 0; i < grps.length; i++) {
                grps[i].style = "display:block;";
            }

            if (component == "showMoreProductItemDetails") {
                document.getElementById(attr2).style.display = "block";
                document.getElementById(attr3).style.display = "none";
                document.getElementById(attr4).style.display = "block";
            }
            if (component == "hideMoreProductItemDetails") {
                document.getElementById(attr3).style.display = "block";
                document.getElementById(attr4).style.display = "none";
            }
        },
        setProductComponent: function setProductComponent(component, attr2, attr3) {
            this.deactivate_processing();
            this.discount_coupon = {};

            if (component == "show-settings-box") {
                this.show_product_setting_box = true;
            }
            if (component == "hide-settings-box") {
                this.show_product_setting_box = false;
            }

            if (attr2 == 'productitemgroup') {
                this.product_item_group = attr3;
            }
            if (attr2 == 'productitem') {
                this.product_item = attr3;
            }

            if (component == "addProductItemPanel") {
                if (this.product.product_set_groups == 0) {
                    this.showProductItemGroups = 'showfalse';
                }
            }
            if (component == 'setProductDeliveryInformation') {
                this.delivery_option.edit_set = false;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
            }
            if (component == 'editDiscount') {
                this.discount_coupon = attr3;
            }
            if (component == 'deactivateDiscount') {
                this.product_item = attr2;
                this.deactivateDiscountsAndCoupons(attr3);
            }

            this.product_details = {};
            this.product_details[component] = true;
        },
        setLookbookComponent: function setLookbookComponent(component, attr2, attr3) {
            this.deactivate_processing();

            if (component == "viewProductLookbookPost") {
                this.viewing_lookbook = this.lookbook;
                this.viewing_lookbook_post = attr3;
                this.is_viewing_lookbook = true;
                this.setComponent('manage-products', '');
                this.setComponentView('products', attr3.gallery_post_product_details, '');
            } else {

                this.lookbook_details = {};
                this.lookbook_details[component] = true;
            }
        },
        toggleSwitchBusiness: function toggleSwitchBusiness() {
            var x = document.getElementById("businessList");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        switchBusiness: function switchBusiness(sellpoint) {
            this.sellpoint = sellpoint;
            this.galleria = {};
            this.setSellpoint();

            this.toggleSwitchBusiness();
        },
        checkIfVideo: function checkIfVideo(url) {
            if (url != undefined) {
                var ext = url.split('.').pop();
                if (service.video_exts.includes(ext)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        reset: function reset() {
            this.setPanel = false;
            this.managePanel = false;
        },
        getStates: function getStates() {
            var _this2 = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this2.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state, option) {
            var _this3 = this;

            this.activate_processing();
            if (option == "edit") {
                this.edit_city = true;
            } else {
                this.edit_city = false;
            }
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    if (_this3.set_dvco_delivery_option) {
                        _this3.dvco_cities = response.body.data;
                    } else {
                        _this3.cities = response.body.data;
                    }
                    _this3.deactivate_processing();
                } else {
                    _this3.deactivate_processing();
                }
            }).catch(function (err) {
                _this3.deactivate_processing();
            });
        },
        getUserAppSettings: function getUserAppSettings() {
            var _this4 = this;

            service.getUserAppSettings(this, this.user.user_id).then(function (data) {
                if (data.body.status == 200) {
                    _this4.user_settings = data.body.data;
                    _this4.getAgentsCoData();
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getAgentsCoData: function getAgentsCoData() {
            var _this5 = this;

            if (this.user_settings.uis_broker && this.user_settings.uis_broker == 1) {
                service.getBrokerData(this, this.user.user_id).then(function (data) {
                    if (data.body.status == 200) {
                        _this5.broker_deals = data.body.data_deals;
                        _this5.broker_requests = data.body.data_requests;
                    }
                }).catch(function (err) {});
            }
        },
        syncset: function syncset(request_page) {
            var credentials = {
                session_key: localStorage.getItem("sp_token"),
                request_url: service.app_url,
                request_from: service.app_name,
                request_status: "REQUESTING...",
                request: request_page
            };
            if (credentials.session_key != null) {
                service.sessionSync(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var ref = response.body.data;
                        window.location.href = service.sp_url + '/manage/' + ref;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        prepProfile: function prepProfile(type) {
            this.disable_btn = true;
            this.user.agree = true;
            var credentials = {
                user_name: this.user.name,
                user_phone: this.user.phone || '',
                user_email: this.user.email || '',
                user_username: this.user.username || '',
                user_password: this.user.password || ''
            };

            var navi = this.$router;
            var validated = false;

            if (validator.validateString(this.user.name)) {
                if (credentials.user_phone != '' || credentials.user_email != '') {
                    if (credentials.user_email != '' && !validator.validateEmail(this.user.email)) {
                        this.error_messages.email = 'Email is not correct';
                    } else {
                        this.error_messages.email = '';
                        validated = true;
                    }

                    if (credentials.user_phone != '' && !validator.validatePhoneNumber(this.user.phone)) {
                        this.error_messages.phone = 'Phone is not correct';
                    } else {
                        this.error_messages.phone = '';
                        validated = true;
                    }

                    if (credentials.user_username != '') {
                        if (validator.validateString(this.user.username)) {
                            this.error_messages.username = '';
                            validated = true;
                        } else {
                            this.error_messages.username = "Username is not valid";
                            this.disable_btn = false;
                        }
                    }
                } else {
                    this.error_messages.email = 'Please enter either email or phone number or both';
                    this.disable_btn = false;
                }
                if (validated) {
                    if (this.user.agree) {
                        this.setProfile(type);
                        this.disable_btn = false;
                        this.data_validated = false;
                    } else {
                        this.error_messages.terms = 'Please agree to Terms';
                        this.disable_btn = false;
                    }
                } else {
                    this.disable_btn = false;
                }
            } else {
                this.data_error_message = 'Kindly fill all fields';
                this.disable_btn = false;
            }

            this.formComponentKey++;
        },
        setProfile: function setProfile(type) {
            var _this7 = this;

            this.terms_error_message = "";
            this.disable_btn = true;

            var payload = {
                user_name: this.user.name,
                user_username: this.user.username || '',
                user_phone: this.user.phone || '',
                user_email: this.user.email || '',
                user_address: this.user.address || '',
                user_state: this.user.state || '',
                user_city: this.user.city || '',
                user_password: this.user.password,
                user_ref_code: this.ref_code,
                user_group_ref_code: this.group_ref_code
            };

            var navi = this.$router;

            service.regUser(this, payload).then(function (data) {
                var _this6 = this;

                if (data.body.status == 201) {
                    this.data_processing_message = "Account Created";

                    if (data.body.data.user_email != '') {
                        var credentials = {
                            user_email: data.body.data.user_email,
                            user_password: data.body.data.user_password
                        };
                    } else if (data.body.data.user_phone != '') {
                        var credentials = {
                            user_detail: data.body.data.user_phone,
                            user_password: data.body.data.user_password
                        };
                    } else {
                        this.data_error_message = "invalid login credentials";
                        this.disable_btn = false;
                        navi.push("login");
                    }

                    service.loginUser(this, credentials).then(function (response) {
                        if (response.body.status == 200) {
                            var _data = response.body.data;

                            var _self = _this6;
                            localStorage.setItem("sp_user", _data.user_name);
                            var user_data = {
                                "user_name": _data.user_name,
                                "user_id": _data.user_id,
                                "sp_token": _data.user_session_key,
                                "sp_token_key": _data.user_token_key
                            };
                            localforage.setItem(service.udb_name, user_data).then(function (value) {
                                _self.set_user_loggedIn = true;
                                _self.user.user_id = _data.user_id;
                                if (type == 2) {
                                    _self.business.business_name = _data.user_name, _self.setProfileAccount(2);
                                }
                            }).catch(function (err) {});
                        }
                    }).catch(function (err) {
                        if (err.status == 404) {
                            _this6.data_error_message = "invalid login credentials";
                            _this6.disable_btn = false;
                        }
                    });
                } else if (data.body.status == 409) {
                    this.data_error_message = "You already have a Sellpoint Account, please log in with this email or username";

                    setTimeout(function () {
                        navi.push("/login?u=connect");
                    }, 10000);
                    this.disable_btn = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this7.data_error_message = "Something went wrong";
                    _this7.disable_btn = false;
                }
                _this7.disable_btn = false;
            });
        },
        editProfileDetails: function editProfileDetails() {
            var _this8 = this;

            this.data_error = {};
            this.data_processing_message = "";
            this.activate_processing();
            var payload = {
                user_data: this.user.user_id,
                user_name: this.user.user_name,
                user_phone: this.user.user_phone || '',
                user_email: this.user.user_email || ''
            };

            if (payload.user_email == '' && payload.user_phone == '') {
                this.data_processing_message = "Please provide email or phone number";
                this.deactivate_processing();
            } else {
                var data_test = false;
                if (payload.user_email != '') {
                    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    var email_test = re.test(String(this.user.user_email).toLowerCase());
                    if (email_test == false) {
                        data_test = false;
                        this.data_processing_message = "Email is not valid, please check entry";
                        this.deactivate_processing();
                    } else {
                        data_test = true;
                    }
                }
                if (payload.user_phone != '') {
                    var re_phone = /^\d{4}\d{3}\d{4}$/;
                    var phone_test = re_phone.test(String(this.user.user_phone).toLowerCase());
                    if (phone_test == false) {
                        data_test = false;
                        this.data_processing_message = "Phone Number is not valid, please check entry";
                        this.deactivate_processing();
                    } else {
                        data_test = true;
                    }
                }

                if (payload.user_name == '' || payload.user_name == undefined) {
                    data_test = false;
                    this.data_processing_message = "Pleas enter your Name";
                    this.deactivate_processing();
                } else {
                    data_test = true;
                }

                if (data_test) {
                    if (payload.user_name != null) {
                        service.editProfileDetails(this, payload).then(function (data) {
                            if (data.body.status == 200) {
                                this.data_processing_message = "Profile Updated";
                                this.user = data.body.data;

                                localforage.setItem(service.udb_name, this.user).then(function (value) {}).catch(function (err) {});
                                this.deactivate_processing();
                                this.setSettings = false;
                                this.setting_details = {};
                            } else {
                                this.data_processing_message = "Could not edit details, something went wrong, please try again";
                                this.deactivate_processing();
                                this.setSettings = false;
                                this.setting_details = {};
                            }
                        }).catch(function (err) {
                            _this8.data_processing_message = "Could not edit details, something went wrong, please try again";
                            _this8.deactivate_processing();
                            _this8.setSettings = false;
                            _this8.setting_details = {};
                        });
                    }
                } else {
                    this.data_processing_message = "Some errors were found in your form, please fill correctly";
                    this.deactivate_processing();
                }
            }
        },
        setProfileAccount: function setProfileAccount(type) {
            if (type == 2) {
                var payload = {
                    business_name: this.business.business_name,
                    business_user_name: this.business.business_user_name || '',
                    business_category: this.business.business_category || service.app_default_business_category,
                    business_owner: this.user.user_id,
                    business_group: service.market_app_name
                };
                var navi = this.$router;
                if (payload.business_name != '' && payload.business_category > 0) {
                    service.addNewBusiness(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            this.sellpoint = data.body.data;
                            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.sellpoint).length > 0) {
                                localforage.setItem(service.bdb_name, this.sellpoint).then(function (value) {}).catch(function (err) {});
                            }

                            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.sellpoint).length > 0 && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.business_bank_details).length > 0) {
                                console.log(this.sellpoint.business_bank_details);
                                this.sellpoint.business_bank_details = this.business_bank_details;
                                this.setBankDetails();
                            }

                            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.sellpoint).length > 0 && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.delivery_option).length > 0) {
                                var _iteratorNormalCompletion5 = true;
                                var _didIteratorError5 = false;
                                var _iteratorError5 = undefined;

                                try {
                                    for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.business_delivery_locations), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                        var option = _step5.value;

                                        this.delivery_option = option;
                                        this.addDeliveryOption();
                                    }
                                } catch (err) {
                                    _didIteratorError5 = true;
                                    _iteratorError5 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                            _iterator5.return();
                                        }
                                    } finally {
                                        if (_didIteratorError5) {
                                            throw _iteratorError5;
                                        }
                                    }
                                }
                            }

                            this.data_boarding_message = "Account created";
                            setTimeout(function () {
                                navi.push("/create/order");
                            }, 10000);
                        }
                    }).catch(function (err) {});
                }
            }
        },
        setNewBusiness: function setNewBusiness() {
            this.sellpoint = {};this.business = {};this.sellpoint = {};this.business_agent = 0;
            this.setMenuComponent('newBusiness');
        },
        getSellpoints: function getSellpoints(user) {
            var _this9 = this;

            service.getAppBusinesses(this, user).then(function (data) {
                if (data.body.status == 200) {
                    _this9.sellpoints = data.body.data;
                    if (_this9.sellpoints.length > 0) {
                        if (_this9.current_sellpoint_id != 0) {
                            var _iteratorNormalCompletion6 = true;
                            var _didIteratorError6 = false;
                            var _iteratorError6 = undefined;

                            try {
                                for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this9.sellpoints), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                    var sellpoint = _step6.value;

                                    if (sellpoint.business_id == _this9.current_sellpoint_id) {
                                        _this9.sellpoint = sellpoint;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError6 = true;
                                _iteratorError6 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                        _iterator6.return();
                                    }
                                } finally {
                                    if (_didIteratorError6) {
                                        throw _iteratorError6;
                                    }
                                }
                            }
                        } else {
                            _this9.sellpoint = _this9.sellpoints[0];
                        }
                        _this9.business_set_shipping_fee_status = _this9.sellpoint.business_set_shipping_fee_status;

                        _this9.setSellpoint();
                    } else {
                        _this9.has_sellpoints = false;
                        _this9.loading = false;
                    }
                    _this9.loading = false;
                } else {
                    _this9.loading = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this9.loading = false;
                }
            });
        },
        setSellpoint: function setSellpoint() {
            if (this.sellpoint && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.sellpoint).length > 0) {
                if (this.sellpoint.business_custom_type && this.sellpoint.business_custom_type == 0) {
                    this.site_user_type = 2;
                } else if (this.sellpoint.business_custom_type == 10) {
                    this.site_user_type = 3;
                    this.agent_is_active = 1;
                    this.agent_service_user_data = this.user;
                    this.agent_service_business_data = this.sellpoint;
                    var payload = {
                        data_user_is_agent: 1,
                        data_user_agent_user_data: this.agent_service_user_data,
                        data_user_agent_business_data: this.agent_service_business_data
                    };
                    this.resetUser(payload);

                    localforage.setItem(service.bdb_name, this.sellpoint).then(function (value) {}).catch(function (err) {});
                }

                localforage.setItem(service.bdb_name, this.sellpoint).then(function (value) {}).catch(function (err) {});

                if (this.sellpoint.business_category_type == 1) {
                    this.is_product_service = "product";
                }
                if (this.sellpoint.business_category_type == 2) {
                    this.is_product_service = "service";
                }

                this.getAppBusinessSubscription();

                this.getSellpointDetails();

                if (this.site_user_type == 2) {
                    this.getSellpointCategories();

                    this.getSellpointProducts();

                    this.getBusinessDeliveryOptions();

                    this.getBusinessDiscountsAndCoupons();
                }

                if (this.$route.path == '/manage/orders') {
                    this.setPage();
                }

                this.loading = false;
            } else {
                this.loading = false;
            }
        },
        getSellpointDetails: function getSellpointDetails() {
            var _this10 = this;

            service.getBusinessByUserName(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this10.sellpoint = response.body.data;

                    if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this10.sellpoint).length > 0) {
                        localforage.setItem(service.bdb_name, _this10.sellpoint).then(function (value) {}).catch(function (err) {});
                    }

                    _this10.business_delivery_locations = _this10.sellpoint.business_delivery_options;
                    if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this10.business_delivery_locations).length > 0) {
                        localforage.setItem(service.bbdlsdb_name, _this10.business_delivery_locations).then(function (value) {}).catch(function (err) {});
                    }

                    _this10.business_bank_details = _this10.sellpoint.business_bank_details;
                    if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this10.business_bank_details).length > 0) {
                        localforage.setItem(service.bbnksdb_name, _this10.sellpoint.business_bank_details).then(function (value) {}).catch(function (err) {});
                    }

                    if (_this10.$route.name == "BusinessRewards") {
                        _this10.getBusinessRewardSettings();
                    }

                    _this10.setPageCalls();
                }
            }).catch(function (err) {});
        },
        setDBase: function setDBase(dbase, data, component_view) {
            var self = this;
            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(dbase).length > 0) {
                localforage.setItem(dbase.db_name, data).then(function (value) {
                    self.store_data_set = true;
                    if (component_view != '') {
                        self.setComponentView(component_view);
                    }
                }).catch(function (err) {});
            }
        },
        getDBase: function getDBase(dbase) {
            var self = this;
            localforage.getItem(dbase.db_name, function (err, value) {
                if (value != undefined) {
                    if (dbase.tag == "sellpoint") {
                        self.sellpoint = value;
                        self.setSellpoint();
                    }

                    return true;
                } else {
                    return false;
                }
            });
        },
        prepSetData: function prepSetData(data, tag) {
            if (tag == "sellpoint") {
                this.setDBase(service.set_sellpoint_db, data, tag);
            }

            return true;
        },
        prepGetData: function prepGetData(tag) {
            if (tag == "sellpoint") {
                this.getDBase(service.set_sellpoint_db);
            }

            return true;
        },
        setGallery: function setGallery() {
            var _this11 = this;

            service.getPointGalleryPosts(this, this.sellpoint.business_id, 0, this.max_plan_lookbooks, 0, this.max_plan_lookbook_posts).then(function (response) {
                _this11.galleria = response.body.data;

                _this11.total_lookbooks_added = response.body.total_data;

                if (_this11.total_lookbooks_added < _this11.max_plan_lookbooks) {
                    _this11.can_add_more_lookbook = true;
                }
                _this11.deactivate_processing();
            }).catch(function (err) {});
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this12 = this;

            this.data_loading.products = true;
            this.sellpoint.business_market_products_limit = 100;
            service.getAppBusinessProducts(this, this.sellpoint.business_id, this.sellpoint.business_market_products_limit).then(function (response) {
                if (response.body.status == 200) {
                    _this12.products = response.body.data;

                    _this12.$store.dispatch('account/setBusinessProducts', _this12.products);
                }
                _this12.loading = false;
                _this12.data_loading.products = false;
            }).catch(function (err) {});
        },
        getAppDeliveryPartners: function getAppDeliveryPartners() {
            service.getAppDeliveryPartners(this).then(function (data) {
                this.delivery_partners = data.body.data;
            });
        },
        addDeliveryPartner: function addDeliveryPartner(dp) {
            var _this13 = this;

            this.activate_processing();

            var payload = {
                partner: dp.business_delivery_partner || 0,
                business: this.sellpoint.business_id
            };

            var navi = this.$router;
            if (payload.partner != undefined || payload.partner == 0) {
                service.addDeliveryPartner(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_processing_message = "added";
                        this.sellpoint.business_delivery_options = data.body.data;
                        this.setMenuTabInnerView('');
                        this.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this13.data_processing_message = "Something went wrong";
                    _this13.deactivate_processing();
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        acceptBrokerRequest: function acceptBrokerRequest(request) {
            var _this14 = this;

            this.activate_processing();
            this.data_processing_message = "";

            var payload = {
                request_ref: request.broker_request_ref_no };
            service.acceptBrokerRequests(this, payload).then(function (response) {
                if (response.body.status == 201) {} else {
                    _this14.deactivate_processing();
                }
            }).catch(function (err) {
                _this14.deactivate_processing();
            });
        },
        setBrokerRequestFee: function setBrokerRequestFee() {
            var _this15 = this;

            this.activate_processing();
            this.data_processing_message = "";

            var payload = {
                request_ref: this.broker_request.broker_request_ref_no,
                request_fee: this.broker_request.broker_request_fee };
            service.setBrokerRequestFee(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this15.broker_request.broker_request_fee_pay_status = 1;
                    _this15.data_processing_message = "Fee Set;";
                } else {
                    _this15.data_processing_message = "Sorry, could not update;";
                }
                _this15.deactivate_processing();
            }).catch(function (err) {
                _this15.data_processing_message = "Sorry, could not update;";
                _this15.deactivate_processing();
            });
        },
        getBusinessMarketGroups: function getBusinessMarketGroups() {
            service.getBusinessMarketGroups(this).then(function (data) {
                this.market_groups = data.body.data;
            });
        },
        getBusinessDeliveryOptions: function getBusinessDeliveryOptions() {
            var _this16 = this;

            service.getBusinessDeliveryOptions(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this16.sellpoint.business_delivery_options = response.body.data;
                    _this16.sellpoint.business_delivery_options_nodes = response.body.data_business_delivery_options_nodes;
                    _this16.business_delivery_options_nodes = _this16.sellpoint.business_delivery_options_nodes;

                    _this16.$store.dispatch('account/setBusinessShipping', _this16.sellpoint.business_delivery_options_nodes);
                }
                _this16.loading = false;
            }).catch(function (err) {
                _this16.loading = false;
            });
        },
        getCategories: function getCategories() {
            service.getCategories(this).then(function (data) {
                var categories = data.body.data;

                categories.forEach(function (element) {
                    if (element.category_type == 1) {
                        this.business_product_categories.push(element);
                    }
                    if (element.category_type == 2) {
                        this.business_service_categories.push(element);
                    }
                }, this);
            });
        },
        getMainCategories: function getMainCategories(category) {
            var _this17 = this;

            service.getMainCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this17.categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSubCategories: function getSubCategories(category) {
            if (category != undefined) {
                this.sub_categories = category.sub_categories;
            } else {
                this.sub_categories = [];
            }
        },
        getPresetCategories: function getPresetCategories(payload) {
            var _this18 = this;

            service.getCategories(this).then(function (response) {
                if (response.body.status == 200) {
                    _this18.preset_categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this19 = this;

            service.getBusinessCategories(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this19.sellpoint_categories = response.body.data;

                    _this19.sellpoint.business_categories = response.body.data;

                    _this19.$store.dispatch('account/setSellpointCategories', _this19.sellpoint.business_categories);
                }
            }).catch(function (err) {});
        },
        getBusinessCategoryProducts: function getBusinessCategoryProducts(category_view) {
            var _this20 = this;

            if (category_view != '') {
                this.setComponentLoading(category_view);
            } else {
                this.loading = true;
            }
            service.getCategoryProducts(this, this.category.business_category_id).then(function (response) {
                if (response.body.status == 200) {
                    _this20.category.category_products = response.body.data;
                    _this20.attachProductsComponentKey++;

                    _this20.loading = false;
                    _this20.setComponentLoading('');
                }
                _this20.businessComponentKey++;
                _this20.loading = false;
            }).catch(function (err) {
                _this20.loading = false;
            });
        },
        getBusinessesIsOpenAgentCategoryProducts: function getBusinessesIsOpenAgentCategoryProducts() {
            var _this21 = this;

            var payload = {
                'business_category': this.category.business_category,
                'business_parent_category': this.category.business_parent_category_id,
                'business_category_type': this.category.business_category_type
            };
            service.getBusinessesOpenAgentsCategoryProducts(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this21.category.category_business_open_for_agent_products = response.body.data;
                    _this21.businessComponentKey++;
                }
            }).catch(function (err) {});
        },
        getBusinessAgentCategoryProducts: function getBusinessAgentCategoryProducts() {
            var _this22 = this;

            service.getAgentsBusinessCategoryProducts(this, this.category.business_category_id).then(function (response) {
                if (response.body.status == 200) {
                    _this22.category.category_products = response.body.data;
                    _this22.businessComponentKey++;
                }
            }).catch(function (err) {});
        },
        getBusinessesOpenAgentsProducts: function getBusinessesOpenAgentsProducts() {
            var _this23 = this;

            service.getBusinessesOpenAgentsProducts(this).then(function (response) {
                if (response.body.status == 200) {
                    _this23.business_open_agents_products = response.body.data;
                }
            }).catch(function (err) {});
        },
        resetCategoriesSelections: function resetCategoriesSelections() {
            if (this.category.new_listed_category != '') {
                this.main_category = {};
                this.category.new_category = 0;
            }
        },
        addCategory: function addCategory() {
            var _this24 = this;

            this.activate_processing();
            var payload = {
                category_new: this.category.new_category || 0,
                category_new_listed: this.category.new_listed_category || "nill",
                category_parent: this.main_category.category_id || 0,
                business_id: this.sellpoint.business_id
            };

            if (payload.category_parent == 0 && payload.category_new == 0 && payload.category_new_listed == "nill") {
                this.data_error_message = "You did not pick any category, Select or any enter the category name";
                this.deactivate_processing();
            } else {
                service.addCategory(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_processing_message = "Sellpoint Category Added Successfully";
                        this.sellpoint.business_categories = data.body.data;

                        this.$store.dispatch('account/setSellpointCategories', this.sellpoint.business_categories);
                        this.category = {};
                    } else {
                        this.data_error_message = "Sorry could not process request, try again";
                    }

                    var self = this;
                    setTimeout(function () {
                        self.$router.push("/account/business/categories");
                        self.deactivate_processing();
                    }, 1200);

                    this.getSellpointCategories();
                }).catch(function (err) {
                    _this24.data_error_message = "Sorry could not process request, try again";
                    _this24.deactivate_processing();
                });
            }
        },
        editCategory: function editCategory() {
            var _this25 = this;

            this.activate_processing();
            this.category.business_id = this.sellpoint.business_id;
            service.editCategory(this, this.category).then(function (data) {
                if (data.body.status == 200) {
                    this.data_processing_message = "Sellpoint Category edited";
                    this.sellpoint.business_categories = data.body.data;

                    this.$store.dispatch('account/setSellpointCategories', this.sellpoint.business_categories);

                    this.setComponent('reset-edit', '');
                    this.deactivate_processing();
                }
            }).catch(function (err) {
                _this25.data_processing_message = "Sellpoint Category could not be edited";
                _this25.setComponent('reset-edit', '');
            });
        },
        deleteCategory: function deleteCategory() {
            this.setComponent('reset-edit', '');
        },
        validateUserName: function validateUserName() {
            var _this26 = this;

            service.validateBusinessUserName(this, this.business).then(function (response) {
                if (response.body.status != 200) {
                    _this26.validate_user_name_error = true;
                    _this26.validate_user_name_message = "This username already exist";
                    _this26.deactivate_processing();
                } else {
                    _this26.validate_user_name_error = false;
                }
            }).catch(function (err) {
                _this26.validate_user_name_error = true;
                _this26.validate_user_name_message = "This username already exist";
                _this26.deactivate_processing();
            });
        },
        setUpNewBusiness: function setUpNewBusiness() {
            var _this27 = this;

            this.resetAll();

            this.activate_processing();
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: service.market_app_name,
                business_market_group: this.business.business_market_group,
                business_layout: 1,
                business_agent: this.business_agent,
                business_subscription: service.market_app_default_plan,
                business_join_group: this.active_group.group_id || 0
            };
            var navi = this.$router;
            if (this.validate_user_name_error) {
                this.data_error_message = "This Username already exists..";
                this.deactivate_processing();
            } else {
                if (credentials.business_name != undefined && credentials.business_category != undefined) {
                    service.addNewBusiness(this, credentials).then(function (data) {
                        if (data.body.status == 201) {
                            this.business.business_user_name = data.body.data_business_username;
                            this.data_processing_message = "Sellpoint Creation Successful.";

                            this.sellpoint = data.body.data;

                            this.storeSetBusiness(this.sellpoint.business_username, 1);

                            setTimeout(function () {
                                navi.push("/account/business");
                            }, 2000);
                        } else {
                            this.data_error_message = "This Username already exists";
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        if (err) {
                            console.log(err);
                            _this27.data_error_message = "Something went wrong";
                            _this27.deactivate_processing();
                        }
                    });
                } else {
                    this.data_error_message = "Kindly fill all fields";
                    this.deactivate_processing();
                }
            }
        },
        editBusinessDetails: function editBusinessDetails(attr) {
            var _this28 = this;

            this.data_error = {};
            this.activate_processing();
            var payload = {};
            if (attr == "email") {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                var email_test = re.test(String(this.sellpoint.business_contact_email).toLowerCase());
                if (email_test == false) {
                    this.data_error.email = true;
                    this.data_error_message = "Email not valid";
                    this.deactivate_processing();
                } else {
                    var payload = {
                        business_id: this.sellpoint.business_id,
                        business_contact_email: this.sellpoint.business_contact_email
                    };
                }
            } else if (attr == "delivery") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_delivery_information: this.sellpoint.business_delivery_information
                };
            } else {
                var payload = {
                    business_main_details: true,
                    business_id: this.sellpoint.business_id,
                    business_name: this.sellpoint.business_name,
                    business_tagline: this.sellpoint.business_tagline || '',
                    business_profile: this.sellpoint.business_profile || '',
                    business_emails: this.sellpoint.business_emails || '',
                    business_address: this.sellpoint.business_address || '',
                    business_phones: this.sellpoint.business_phones || ''
                };
            }

            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(payload).length > 0) {
                service.editBusinessDetails(this, payload).then(function (data) {
                    if (data.body.status == 200 || data.body.status == 400) {
                        this.getSellpointDetails(this.sellpoint.business_username);
                        this.data_processing_message = "Updated";
                    } else {
                        this.data_processing_message = "Could not edit details, something went wrong, please try again";
                        this.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this28.data_processing_message = "Could not update details, something went wrong, please try again";
                    _this28.deactivate_processing();
                });
            }
        },
        setOtherOptions: function setOtherOptions(v, o) {
            if (v != undefined) {
                if (v == "other") {
                    this.other_delivery_option = true;
                    if (o == "edit") {
                        this.edit_other_delivery_option = true;
                    }
                }
                if (v == "all") {
                    this.delivery_option.business_delivery_other_option = "nill";
                    if (o == "edit") {
                        this.edit_other_delivery_option = false;
                    }
                    this.other_delivery_option = false;
                }
            }
            if (this.business_details.delivery_add_by_dco) {
                this.deliveryAddByDcoKey++;
            }
        },
        setDeliveryOptionParams: function setDeliveryOptionParams(option, attr) {
            this.delivery_option = option;
            if (attr == 'add-new-from') {
                this.delivery_option.addNewDeliveryFromPoint = true;
            }
        },
        setFreeDelivery: function setFreeDelivery(n) {
            if (n == 1) {
                if (this.delivery_option.delivery_option_free) {
                    this.delivery_option.delivery_option_free = 1;
                    this.delivery_option.delivery_option_price = 0;
                } else {
                    this.delivery_option.delivery_option_free = 0;
                }
            } else if (n == 2) {
                if (this.delivery_option.business_delivery_option_free) {
                    this.delivery_option.delivery_option_free = 1;
                    this.delivery_option.business_delivery_option_price = 0;
                } else {
                    this.delivery_option.business_delivery_option_free = 0;
                }
            }
            this.componentDeliveryKey++;
        },
        addDeliveryOption: function addDeliveryOption() {
            var _this29 = this;

            this.activate_processing();

            var business_delivery_option_from_points = [];
            if (this.business_details.delivery_add_by_dco) {
                if (this.dvco_cities.length > 0) {
                    var _iteratorNormalCompletion7 = true;
                    var _didIteratorError7 = false;
                    var _iteratorError7 = undefined;

                    try {
                        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.dvco_cities), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                            var dvc = _step7.value;

                            if (dvc.delivery_option_price > 0) {
                                var prepload = {
                                    business_delivery_option_from_state: dvc.city_state,
                                    business_delivery_option_from_location: dvc.city_id || 0,
                                    business_delivery_option_from_other_delivery_location: "nill",
                                    business_delivery_option_from_is_custom: 0,
                                    business_delivery_option_from_custom_option: "nill",
                                    business_delivery_option_from_price: dvc.delivery_option_price || 0
                                };

                                business_delivery_option_from_points.push(prepload);
                            }
                        }
                    } catch (err) {
                        _didIteratorError7 = true;
                        _iteratorError7 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                _iterator7.return();
                            }
                        } finally {
                            if (_didIteratorError7) {
                                throw _iteratorError7;
                            }
                        }
                    }
                }

                if (this.delivery_custom_options.length > 0) {
                    var _iteratorNormalCompletion8 = true;
                    var _didIteratorError8 = false;
                    var _iteratorError8 = undefined;

                    try {
                        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.delivery_custom_options), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                            var _dvc = _step8.value;

                            var is_custom_option = 0;
                            if (_dvc.delivery_custom_option != '') {
                                is_custom_option = 1;
                            }

                            if (_dvc.delivery_option_price > 0) {
                                var prepload = {
                                    business_delivery_option_from_state: 0,
                                    business_delivery_option_from_location: 0,
                                    business_delivery_option_from_other_delivery_location: _dvc.other_delivery_location || "nill",
                                    business_delivery_option_from_is_custom: is_custom_option,
                                    business_delivery_option_from_custom_option: _dvc.delivery_custom_option || "nill",
                                    business_delivery_option_from_price: _dvc.delivery_option_price || 0
                                };

                                business_delivery_option_from_points.push(prepload);
                            }
                        }
                    } catch (err) {
                        _didIteratorError8 = true;
                        _iteratorError8 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion8 && _iterator8.return) {
                                _iterator8.return();
                            }
                        } finally {
                            if (_didIteratorError8) {
                                throw _iteratorError8;
                            }
                        }
                    }
                }

                if (this.delivery_option.delivery_option_price == 0 || this.delivery_option.delivery_option_price == undefined) {
                    this.delivery_option.delivery_option_price = business_delivery_option_from_points[0]["business_delivery_option_from_price"];
                }
            }

            if (this.delivery_option.addNewDeliveryFromPoint) {
                this.delivery_option.state = this.delivery_option.business_delivery_state_id;
                this.delivery_option.city = this.delivery_option.business_delivery_city;
                this.delivery_option.option = this.delivery_option.business_delivery_option_id;
            }

            if (this.delivery_option.city && this.delivery_option.city != undefined) {
                if (!(this.delivery_option.city > 0)) {
                    this.delivery_option.city = this.delivery_option.city.city_id;
                }
            }
            var payload = {
                business_delivery_state: this.delivery_option.state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.delivery_other_option || "nill",
                business_delivery_custom_option: this.delivery_option.delivery_custom_option || "nill",
                business_delivery_option_price: this.delivery_option.delivery_option_price || 0,
                business_delivery_option_free: this.delivery_option.delivery_option_free || 0,
                business_delivery_option_from_points: business_delivery_option_from_points || [],
                business_delivery_option_set_option: this.delivery_option.option || 0,
                business_id: this.sellpoint.business_id
            };
            if (payload.business_delivery_option_price == 0 && payload.business_delivery_option_free == 0) {
                this.data_processing_message = "Delivery Charge not Added";
                this.deactivate_processing();
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.addDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 201 || data.body.status == 200) {
                            this.sellpoint.business_delivery_options = data.body.data;

                            this.sellpoint.business_delivery_locations = data.body.data;
                            this.business_delivery_locations = data.body.data;

                            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.sellpoint.business_delivery_options).length > 0) {
                                localforage.setItem(service.bbdlsdb_name, this.sellpoint.business_delivery_options).then(function (value) {}).catch(function (err) {});
                            }

                            this.sellpoint.business_delivery_options_nodes = data.body.data_delivery_options_nodes;
                            this.business_delivery_options_nodes = this.sellpoint.business_delivery_options_nodes;
                            this.custom_delivery_option = false;
                            this.delivery_option = {};
                            this.dvco_cities = {};
                            this.delivery_custom_options = {};
                            this.business_details = {};
                            this.deactivate_processing();

                            this.setAddDeliveryLocation = false;
                        }
                    }).catch(function (err) {
                        _this29.delivery_option = {};
                        _this29.dvco_cities = {};
                        _this29.delivery_custom_options = {};
                        _this29.deactivate_processing();
                    });
                } else {
                    this.data_processing_message = "Select a delivery option";
                    this.deactivate_processing();
                }
            }
        },
        editDeliveryOption: function editDeliveryOption() {
            var _this30 = this;

            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id,

                business_delivery_state: this.delivery_option.business_delivery_state_id,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.business_delivery_other_option || "nill",
                business_delivery_custom_option: this.delivery_option.business_delivery_custom_option || "nill",
                business_delivery_option_price: this.delivery_option.business_delivery_option_price || 0,
                business_delivery_option_free: this.delivery_option.delivery_option_free || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };

            if (payload.business_delivery_option_price == 0 && payload.business_delivery_option_free == 0) {
                this.data_processing_message = "Delivery Charge not Added";
                this.deactivate_processing();
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.editDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200) {
                            this.sellpoint.business_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.business_details = {};

                            this.sellpoint.business_delivery_locations = data.body.data;
                            this.business_delivery_locations = data.body.data;

                            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.sellpoint.business_delivery_options).length > 0) {
                                localforage.setItem(service.bbdlsdb_name, this.sellpoint.business_delivery_options).then(function (value) {}).catch(function (err) {});
                            }

                            this.deactivate_processing();
                            this.toggleSingleComponent(this.set_single_component_view);
                        }
                    }).catch(function (err) {
                        _this30.delivery_option.edit_set = false;
                        _this30.deactivate_processing();
                    });
                } else {
                    this.data_processing_message = "Select a delivery option";
                    this.deactivate_processing();
                }
            }
        },
        deleteDeliveryOption: function deleteDeliveryOption(id) {
            var _this31 = this;

            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id
            };
            service.deleteDeliveryOption(this, id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.sellpoint.business_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                    this.business_details = {};

                    this.sellpoint.business_delivery_locations = data.body.data;
                    this.business_delivery_locations = data.body.data;

                    if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.sellpoint.business_delivery_options).length > 0) {
                        localforage.setItem(service.bbdlsdb_name, this.sellpoint.business_delivery_options).then(function (value) {}).catch(function (err) {});
                    }

                    this.deactivate_processing();
                    this.toggleSingleComponent(this.set_single_component_view);
                }
            }).catch(function (err) {
                _this31.delivery_option = {};
                _this31.deactivate_processing();
            });
        },
        updateDeliveryFromOption: function updateDeliveryFromOption(action, option) {
            var _this32 = this;

            this.activate_processing();
            if (action == "edit-delivery-from") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_delivery_set_from_options: 1,
                    business_delivery_from_price: option.business_delivery_from_price || 0,
                    business_delivery_from_id: option.business_delivery_from_id
                };

                if (payload.business_delivery_from_price == 0) {
                    this.data_processing_message = "Delivery Charge not set";
                    this.deactivate_processing();
                } else {
                    if (payload.business_delivery_from_id != 0) {
                        service.editDeliveryOption(this, payload).then(function (data) {
                            if (data.body.status == 200) {
                                this.sellpoint.business_delivery_options = data.body.data;
                                this.delivery_option.edit_set = false;
                                this.business_details = {};
                                this.deactivate_processing();
                            }
                        }).catch(function (err) {
                            _this32.delivery_option.edit_set = false;
                            _this32.deactivate_processing();
                        });
                    } else {
                        this.data_processing_message = "Select a delivery option";
                        this.deactivate_processing();
                    }
                }
            }

            if (action == "delete-delivery-from") {
                var payload = {
                    business_id: this.sellpoint.business_id
                };
                service.deleteDeliveryOption(this, option.business_delivery_from_id, payload).then(function (data) {
                    if (data.body.status == 200) {
                        this.sellpoint.business_delivery_options = data.body.data;
                        this.delivery_option.edit_set = false;
                        this.delivery_option = {};
                        this.business_details = {};
                        this.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this32.delivery_option = {};
                    _this32.deactivate_processing();
                });
            }
        },
        setAddProcessingFees: function setAddProcessingFees() {
            this.data_error = {};
            if (!this.user.user_email || this.user.user_email && this.user.user_email == '') {
                this.data_error.email = true;
            }
            this.setMenuTabInnerView('addProcessingFees');
        },
        addtoProcessingFee: function addtoProcessingFee() {
            this.data_processing_message = "";
            this.data_error_message = "";
            this.activate_processing();

            var payload = {
                order_type: 1,
                order_user: this.user.user_id,
                order_business: this.sellpoint.business_id,
                order_amount: this.processing_fee.amount,
                order_service: "Add to Processing Fee Balance"
            };

            service.postBusinessGeneralOrders(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    this.app_orders = data.body.data;
                    this.data_processing_message = "Processing Request";
                    this.processPayment();
                }
            }).catch(function (err) {});
        },
        postBusinessProcessingFeeTransaction: function postBusinessProcessingFeeTransaction(payment_ref) {
            this.data_processing_message = "Adding Processing Fee";

            var payload = {
                processing_fee_transaction_type: 1,
                processing_fee_transaction_amount: this.processing_fee.amount,
                pay_ref: payment_ref,
                business: this.sellpoint.business_id
            };

            service.postBusinessProcessingFeeTransactions(this, payload).then(function (data) {
                if (data.body.status == 200 || data.body.status == 201) {
                    this.processing_fee_transactions = data.body.data;
                    this.sellpoint.business_processing_fee_balance = data.body.data_processing_fee_balance;
                    this.sellpoint.business_processing_fee_debt = data.body.data_processing_fee_debt;
                    this.service_charge_balance = this.sellpoint.business_processing_fee_balance;
                    this.app_orders = {};
                    this.data_processing_message = "Processed";
                    this.setMenuTabInnerView('setProcessingFees');
                    this.deactivate_processing();
                    this.processing_fee = {};
                }
            }).catch(function (err) {});
        },
        getBusinessProcessingFeesTransactions: function getBusinessProcessingFeesTransactions() {
            var _this33 = this;

            service.getBusinessProcessingFeesTransactions(this, this.sellpoint.business_id, 0, 250).then(function (response) {
                if (response.body.status == 200) {
                    console.log(98766);
                    _this33.processing_fee_transactions = response.body.data;
                    _this33.sellpoint.business_processing_fee_balance = response.body.data_processing_fee_balance;
                    _this33.sellpoint.business_processing_fee_debt = response.body.data_processing_fee_debt;
                    _this33.service_charge_balance = _this33.sellpoint.business_processing_fee_balance;
                }
            }).catch(function (err) {});
        },
        setBankDetails: function setBankDetails() {
            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.business_bank_details).length > 0) {
                this.sellpoint.business_bank_details = this.business_bank_details;
            }
            this.activate_processing();
            var payload = {
                business_bank_name: this.sellpoint.business_bank_details.bank_name,
                business_bank_account_name: this.sellpoint.business_bank_details.bank_account_name,
                business_bank_account_number: this.sellpoint.business_bank_details.bank_account_number,
                business_id: this.sellpoint.business_id,

                business_bank_rvpay_sync: this.sellpoint.business_bank_details.bank_rvpay_sync || 0,
                business_bank_rvpay_subaccount_id: this.sellpoint.business_bank_details.bank_rvpay_subaccount_id || 0,
                business_bank_rvpay_id: this.sellpoint.business_bank_details.bank_rvpay_id || 0,
                business_bank_rvpay_date_created: this.sellpoint.business_bank_details.bank_rvpay_date_created || 0,

                business_contact_email: this.sellpoint.business_contact_email || '',
                business_contact_phone: this.sellpoint.business_contact_phone || ''
            };

            service.setBusinessBankDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.data_processing_message = "Bank Details Set";

                    localforage.setItem(service.bbnksdb_name, this.sellpoint.business_bank_details).then(function (value) {}).catch(function (err) {});

                    this.deactivate_processing();
                    this.setEditBankDetails = false;
                }
            }).catch(function (err) {});
        },
        setBankDetailsRavePay: function setBankDetailsRavePay() {
            var _this34 = this;

            this.activate_processing();
            this.data_processing_message = "Verifying your bank details...";
            var payload = {
                "account_bank": this.ravepay_sba.account_bank,
                "account_number": this.ravepay_sba.account_number,
                "business_name": this.sellpoint.business_name,
                "business_email": this.sellpoint.business_contact_email,
                "business_contact": this.sellpoint.business_name,
                "business_contact_mobile": this.sellpoint.business_contact_phone,
                "business_mobile": this.sellpoint.business_contact_phone,
                "country": "NG",
                "meta": [{ "metaname": "AFPID", "metavalue": "" }],
                "seckey": service.ravepay_secret_test
            };
            service.createRavepaySubaccount(payload).then(function (response) {
                if (response.status == 200) {
                    _this34.data_processing_message = "Bank Details Set";

                    _this34.sellpoint.business_bank_details.bank_rvpay_sync = 1;
                    _this34.sellpoint.business_bank_details.bank_rvpay_subaccount_id = response.data.data.subaccount_id;
                    _this34.sellpoint.business_bank_details.bank_rvpay_id = response.data.data.account_bank;
                    _this34.sellpoint.business_bank_details.bank_rvpay_date_created = response.data.data.date_created;
                    _this34.sellpoint.business_bank_details.bank_name = response.data.data.bank_name;
                    _this34.sellpoint.business_bank_details.bank_account_name = response.data.data.fullname;
                    _this34.sellpoint.business_bank_details.bank_account_number = response.data.data.account_number;

                    _this34.setBankDetails();
                    _this34.deactivate_processing();
                } else {
                    _this34.data_processing_message = "Could not verify your details, please confirm your details and try again";
                    _this34.deactivate_processing();
                }
            }).catch(function (err) {
                _this34.data_processing_message = "Could not verify your details, please confirm your details and try again";
                _this34.deactivate_processing();
            });
        },
        setBusinessAgentCommissions: function setBusinessAgentCommissions() {
            this.activate_processing();
            if (!(this.sellpoint.business_agent_commission <= 100)) {
                this.data_processing_message = "value inappropriate";
            } else {
                var payload = {
                    business_agent_commission: this.sellpoint.business_agent_commission || 0,
                    business: this.sellpoint.business_id
                };

                service.setBusinessAgentCommissions(this, payload).then(function (data) {
                    this.data_processing_message = "Processed";
                    this.deactivate_processing();
                    this.setMenuTabInnerView('');
                }).catch(function (err) {});
            }
        },
        switchProcessingFee: function switchProcessingFee(to) {
            this.activate_processing();
            var payload = {
                business_process_fee_pay: to,
                business_id: this.sellpoint.business_id
            };

            service.switchProcessingFeePay(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.data_processing_message = "Processing Fee Set";
                    this.sellpoint.business_processing_fee_pay_status = to;
                    this.deactivate_processing();
                }
            }).catch(function (err) {});
        },
        setShippingFeeStatus: function setShippingFeeStatus(status_value) {
            this.activate_processing();
            this.business_set_shipping_fee_status = status_value;
            var payload = {
                business_set_shipping_fee_status: this.business_set_shipping_fee_status,
                business_id: this.sellpoint.business_id
            };

            service.setShippingFeeStatus(this, payload).then(function (data) {
                this.sellpoint.business_set_shipping_fee_status = this.business_set_shipping_fee_status;
                this.deactivate_processing();
            }).catch(function (err) {});
        },
        getBusinessDiscountsAndCoupons: function getBusinessDiscountsAndCoupons() {
            var _this35 = this;

            service.getBusinessDiscountsCoupons(this, this.sellpoint.business_id).then(function (response) {
                var payload = {};
                if (response.body.status == 200) {
                    _this35.sellpoint.business_discounts_coupons = response.body.data;
                    payload = _this35.sellpoint.business_discounts_coupons;
                }

                _this35.$store.dispatch('account/setBusinessDiscounts', payload);
            }).catch(function (err) {});
        },
        setDiscountsAndCouponsXXXX: function setDiscountsAndCouponsXXXX() {
            var _this36 = this;

            this.activate_processing();
            this.data_processing_message = "";

            if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                this.discount_coupon.discount_category = 1;
            }

            var entry_arr = [["Discount or Coupon", this.discount_coupon.is_discount_coupon, "str"], ["Coupon Percentage", this.discount_coupon.discount_percentage, "num"], ["Discount Category", this.discount_coupon.discount_category, "num"], ["Start Date", this.discount_coupon.discount_start_date, "date"], ["End Date", this.discount_coupon.discount_end_date, "date"]];
            var validated_arr = validator.validate_array(entry_arr, "Please fill in ");
            if (validated_arr.length == 0) {
                var start_date = new Date(this.discount_coupon.discount_start_date);
                var end_date = new Date(this.discount_coupon.discount_end_date);
                if (end_date <= start_date) {
                    this.data_processing_message = "Please reset Dates, End Date should be greater than Start Date";
                    this.deactivate_processing();
                } else {
                    var discount_category = 0;
                    if (this.business_details.setDiscount) {
                        discount_category = this.discount_coupon.discount_category;
                    }

                    var product_id = 0;
                    var product_item_id = 0;

                    if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                        product_id = this.product.product_id;
                    }
                    if (this.product_details.setProductItemDiscount) {
                        product_item_id = this.product_item.product_item_id;
                    }

                    var coupon_style_type = 0;
                    if (this.discount_coupon_is_gift_card) {
                        coupon_style_type = 36;
                    }
                    var payload = {
                        business_id: this.sellpoint.business_id,
                        business_market: service.apiToken,
                        product_id: product_id,
                        product_item_id: product_item_id,
                        is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'C',
                        coupon_business_category: discount_category,
                        coupon_style_type: coupon_style_type,
                        coupon_module_ref: discount_module_ref || '',
                        coupon_description: this.discount_coupon.discount_description || "NIL",
                        coupon_percentage: this.discount_coupon.discount_percentage,
                        coupon_min_amount: this.discount_coupon.discount_min_amount || 0,
                        coupon_min_quantity: this.discount_coupon.discount_min_quantity,
                        coupon_start_date: this.discount_coupon.discount_start_date,
                        coupon_end_date: this.discount_coupon.discount_end_date
                    };
                    service.setDiscountsAndCoupons(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            this.business_details.setDiscount = false;
                            this.business_details.viewDiscounts = true;
                            this.discount_coupon_is_gift_card = false;
                            if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                                var res = data.body.data;
                                var _iteratorNormalCompletion9 = true;
                                var _didIteratorError9 = false;
                                var _iteratorError9 = undefined;

                                try {
                                    for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.product.product_items), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                                        var item = _step9.value;
                                        var _iteratorNormalCompletion10 = true;
                                        var _didIteratorError10 = false;
                                        var _iteratorError10 = undefined;

                                        try {
                                            for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                                                var row = _step10.value;

                                                if (row.product_item_id == item.product_item_id) {
                                                    item.product_item_discounts = row.product_item_discounts;
                                                }
                                            }
                                        } catch (err) {
                                            _didIteratorError10 = true;
                                            _iteratorError10 = err;
                                        } finally {
                                            try {
                                                if (!_iteratorNormalCompletion10 && _iterator10.return) {
                                                    _iterator10.return();
                                                }
                                            } finally {
                                                if (_didIteratorError10) {
                                                    throw _iteratorError10;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError9 = true;
                                    _iteratorError9 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion9 && _iterator9.return) {
                                            _iterator9.return();
                                        }
                                    } finally {
                                        if (_didIteratorError9) {
                                            throw _iteratorError9;
                                        }
                                    }
                                }

                                if (this.product_details.setProductDiscount) {
                                    this.product.product_only_coupon_discount_count++;
                                }
                                if (this.product_details.setProductItemDiscount) {
                                    this.product_item.product_item_only_coupon_discount_count++;
                                }
                            } else {
                                this.sellpoint.business_discounts_coupons = data.body.data;
                            }
                            this.deactivate_processing();
                            this.product_details = {};
                        }
                    }).catch(function (err) {
                        _this36.deactivate_processing();
                    });
                }
            } else {
                validated_arr.forEach(function (error) {
                    this.data_processing_message = this.data_processing_message + " . " + error;
                }, this);
                this.deactivate_processing();
            }
        },
        editDiscountsAndCoupons: function editDiscountsAndCoupons() {
            var _this37 = this;

            this.data_processing_message = "";

            var entry_arr = [["Coupon Percentage", this.discount_coupon.discount_percentage, "num"], ["Discount Category", this.discount_coupon.discount_category, "num"], ["Start Date", this.discount_coupon.discount_start_date, "date"], ["End Date", this.discount_coupon.discount_end_date, "date"]];
            var validated_arr = validator.validate_array(entry_arr, "Please fill in ");
            if (validated_arr.length == 0) {
                var start_date = new Date(this.discount_coupon.discount_start_date);
                var end_date = new Date(this.discount_coupon.discount_end_date);
                if (end_date <= start_date) {
                    this.data_processing_message = "Please reset Dates, End Date should be pass Start Date";
                    this.deactivate_processing();
                } else {
                    this.activate_processing();
                    this.discount_coupon.business_id = this.sellpoint.business_id;
                    this.discount_coupon.business_market = service.apiToken;
                    service.editDiscountsAndCoupons(this, this.discount_coupon).then(function (data) {
                        if (data.body.status == 200) {
                            this.discount_coupon = {};
                            this.business_details.viewDiscounts = true;
                            if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                                var res = data.body.data;
                                var _iteratorNormalCompletion11 = true;
                                var _didIteratorError11 = false;
                                var _iteratorError11 = undefined;

                                try {
                                    for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.product.product_items), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                                        var item = _step11.value;
                                        var _iteratorNormalCompletion12 = true;
                                        var _didIteratorError12 = false;
                                        var _iteratorError12 = undefined;

                                        try {
                                            for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                                                var row = _step12.value;

                                                if (row.product_item_id == item.product_item_id) {
                                                    item.product_item_discounts = row.product_item_discounts;
                                                }
                                            }
                                        } catch (err) {
                                            _didIteratorError12 = true;
                                            _iteratorError12 = err;
                                        } finally {
                                            try {
                                                if (!_iteratorNormalCompletion12 && _iterator12.return) {
                                                    _iterator12.return();
                                                }
                                            } finally {
                                                if (_didIteratorError12) {
                                                    throw _iteratorError12;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError11 = true;
                                    _iteratorError11 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion11 && _iterator11.return) {
                                            _iterator11.return();
                                        }
                                    } finally {
                                        if (_didIteratorError11) {
                                            throw _iteratorError11;
                                        }
                                    }
                                }
                            } else {
                                this.sellpoint.business_discounts_coupons = data.body.data;
                            }
                            this.deactivate_processing();
                            this.product_details = {};
                        }
                    }).catch(function (err) {
                        _this37.deactivate_processing();
                    });
                }
            } else {
                validated_arr.forEach(function (error) {
                    this.data_processing_message = this.data_processing_message + " . " + error;
                }, this);
                this.deactivate_processing();
            }
        },
        deactivateDiscountsAndCoupons: function deactivateDiscountsAndCoupons(payload) {
            var _this38 = this;

            this.activate_processing();
            payload.business_id = this.sellpoint.business_id;
            payload.business_market = service.apiToken;
            service.deactivateDiscountsAndCoupons(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.business_details.viewDiscounts = true;
                    if (this.product.product_id) {
                        var res = data.body.data;
                        var _iteratorNormalCompletion13 = true;
                        var _didIteratorError13 = false;
                        var _iteratorError13 = undefined;

                        try {
                            for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.product.product_items), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                                var item = _step13.value;
                                var _iteratorNormalCompletion14 = true;
                                var _didIteratorError14 = false;
                                var _iteratorError14 = undefined;

                                try {
                                    for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                                        var row = _step14.value;

                                        if (row.product_item_id == item.product_item_id) {
                                            item.product_item_discounts = row.product_item_discounts;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError14 = true;
                                    _iteratorError14 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion14 && _iterator14.return) {
                                            _iterator14.return();
                                        }
                                    } finally {
                                        if (_didIteratorError14) {
                                            throw _iteratorError14;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError13 = true;
                            _iteratorError13 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion13 && _iterator13.return) {
                                    _iterator13.return();
                                }
                            } finally {
                                if (_didIteratorError13) {
                                    throw _iteratorError13;
                                }
                            }
                        }
                    } else {
                        this.sellpoint.business_discounts_coupons = data.body.data;
                    }
                    this.deactivate_processing();
                    this.product_details = {};
                }
            }).catch(function (err) {
                _this38.deactivate_processing();
            });
        },
        getBusinessRewardSettings: function getBusinessRewardSettings() {
            var _this39 = this;

            service.getBusinessRewardSettings(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this39.sellpoint.reward_settings = response.body.data;
                    _this39.setRewardCommission();
                }
                _this39.componentKey++;
                _this39.loading = false;
            }).catch(function (err) {});
        },
        postBusinessRewardSettings: function postBusinessRewardSettings(reward_type) {
            var _this40 = this;

            this.activate_processing();
            var payload = {
                reward_type_business: this.sellpoint.business_id,
                reward_type_type: reward_type.reward_type_id,
                reward_type_amount_type: this.set_reward_type_amount_type || C,
                reward_type_amount: this.business_details.set_reward_type_amount || 5,
                reward_type_duration: this.business_details.set_reward_type_duration || 0
            };
            if (payload.reward_type_amount == 0) {
                this.data_processing_message = "Amount should be more than 0";
                this.deactivate_processing();
            } else {
                service.postBusinessRewardSettings(this, payload).then(function (data) {
                    if (data.body.status == 201 || data.body.status == 200) {
                        this.sellpoint.reward_settings = data.body.data;
                        this.data_processing_message = "Set";
                        this.business_details = {};
                        this.deactivate_processing();
                        this.setMenuTabInnerView('');
                    }
                    this.setRewardCommission();
                }).catch(function (err) {
                    _this40.business_details = {};
                    _this40.deactivate_processing();
                });
            }
        },
        updateBusinessRewardSettings: function updateBusinessRewardSettings(reward_type_setting) {
            var _this41 = this;

            this.activate_processing();
            var payload = {
                reward_set: reward_type_setting.reward_set,
                reward_set_amount_type: reward_type_setting.reward_set_amount_type || C,
                reward_set_amount: reward_type_setting.reward_set_amount || 5,
                reward_set_duration: reward_type_setting.reward_set_duration || 0
            };

            if (payload.reward_set_amount) {
                service.updateBusinessRewardSettings(this, payload).then(function (data) {
                    if (data.body.status == 201 || data.body.status == 200) {
                        this.sellpoint.reward_settings = data.body.data;
                        this.data_processing_message = "Updated";
                        this.business_details = {};
                        this.deactivate_processing();
                        this.setMenuTabInnerView('');
                    }
                    this.setRewardCommission();
                }).catch(function (err) {
                    _this41.business_details = {};
                    _this41.deactivate_processing();
                });
            }
        },
        setRewardCommission: function setRewardCommission() {
            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.sellpoint.reward_settings).length > 0) {
                var _iteratorNormalCompletion15 = true;
                var _didIteratorError15 = false;
                var _iteratorError15 = undefined;

                try {
                    for (var _iterator15 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.sellpoint.reward_settings), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                        var rw = _step15.value;

                        if (rw.reward_type_id == 2) {
                            if (rw.reward_type_setting.reward_set_amount && rw.reward_type_setting.reward_set_amount > 0) {
                                this.set_reward_commission = rw.reward_type_setting.reward_set_amount;console.log(this.set_reward_commission);
                                this.componentKey++;
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError15 = true;
                    _iteratorError15 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion15 && _iterator15.return) {
                            _iterator15.return();
                        }
                    } finally {
                        if (_didIteratorError15) {
                            throw _iteratorError15;
                        }
                    }
                }
            }
        },
        updateBusinessGeneralSettings: function updateBusinessGeneralSettings(update_no, data) {
            var _this42 = this;

            this.activate_processing();
            var payload = {};
            if (update_no == 1) {
                this.business_details.business_open_agents = 0;
                if (this.sellpoint.business_is_agents_open && this.sellpoint.business_is_agents_open == 0) {
                    this.sellpoint.business_is_agents_open = 1;
                } else {
                    this.sellpoint.business_is_agents_open = 0;
                }
                payload = {
                    business_update_no: 1,
                    business_open_agents: this.sellpoint.business_is_agents_open
                };
            }

            if (update_no == 2) {
                if (data.business_agent_type == 20) {
                    data.business_agent_type_name = "Advanced";
                }

                if (data.business_agent_type == 19) {
                    data.business_agent_type_name = "Basic";
                }

                payload = {
                    business_agent_id: data.business_agent_id,
                    business_agent_type: data.business_agent_type
                };
                if (this.sellpoint.business_agent == 1) {
                    payload.business_update_no = 2;
                } else {
                    payload.business_update_no = 3;
                }
            }

            payload.business = this.sellpoint.business_id;
            if (payload.length != 0) {
                service.updateBusinessGeneralSettings(this, payload).then(function (data) {
                    if (data.body.status == 201 || data.body.status == 200) {
                        this.data_processing_message = "Updated";
                        this.business_details = {};
                        this.getSellpointDetails();
                        this.deactivate_processing();
                        this.setMenuTabInnerView('');
                    }
                }).catch(function (err) {
                    _this42.business_details = {};
                    _this42.deactivate_processing();
                });
            }
        },
        getBusinessesOpenToAgents: function getBusinessesOpenToAgents() {
            var _this43 = this;

            var payload = {
                business_category: 0
            };
            service.getBusinessesOpenToAgents(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this43.business_open_to_agents = response.body.data;
                }
            }).catch(function (err) {});
        },
        onFileChangeBannerImage: function onFileChangeBannerImage(e, type) {
            var _this44 = this;

            this.activate_processing();
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', this.sellpoint.business_id);
                formData.append('data_type', type);
                service.uploadBusinessDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "business_banner_image") {
                            _this44.sellpoint.business_banner_image = data.body.data;
                            _this44.set_gallery_banner_image = _this44.sellpoint.business_banner_image;
                        }
                        if (type == "business_brand_image") {
                            _this44.sellpoint.business_brand_image = data.body.data;
                        }

                        var _self2 = _this44;
                        setTimeout(function () {
                            _self2.deactivate_processing();

                            _self2.loading = true;
                            setTimeout(function () {
                                _self2.loading = false;
                                _self2.setCurrentBusiness();
                            }, 1200);
                        }, 1000);
                    } else {
                        _this44.data_error_message = "Could not update, something went wrong. Please try again";
                        _this44.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this44.data_error_message = "Could not update, something went wrong. Please try again";
                    _this44.deactivate_processing();
                });
            }
        },
        addToServiceOffers: function addToServiceOffers(offer) {
            if (offer.offer_set != undefined || offer.offer_new_offer != undefined) {
                if (offer.offer_set != undefined && offer.offer_limit != undefined) {
                    offer.offer = offer.offer_set.business_service_offer_id;
                    offer.offer_name = offer.offer_set.business_service_offer;
                    offer.offer_type_name = offer.offer_set.business_service_offer_type_name;
                    offer.offer_limit = offer.offer_limit;
                    offer.offer_set_actions = {};
                    offer.offer_set_actions.data_action_name = offer.offer_set.business_service_offer_action_name;
                    this.service_offers.push(offer);
                }
                if (offer.offer_new_offer != undefined) {
                    offer.offer_type = offer.offer_type_set.data_service_id;
                    offer.offer_type_name = offer.offer_type_set.data_service_name;
                    if (offer.offer_type != undefined && offer.offer_limit != undefined && offer.offer_set_actions != undefined) {
                        offer.offer_action = offer.offer_set_actions.data_action_id;
                        this.service_offers.push(offer);
                    }
                }
                this.service_offer = {};
            }
        },
        setAddProductMedia: function setAddProductMedia(product) {
            var _this45 = this;

            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(product).length > 0) {
                this.imageForm.append("data_id", product.product_id);
                this.imageForm.append("data_type", "products");
                service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                    if (data.body.status == 200) {} else {
                        _this45.data_processing_message = service.upload_media_error_msg;
                    }
                }).catch(function (err) {
                    if (err) {}
                    _this45.data_error_message = service.upload_media_error_msg;
                });
            }
        },
        prepSetAddProductsInList: function prepSetAddProductsInList() {
            var _this46 = this;

            var _loop = function _loop(item) {
                var self = _this46;
                setTimeout(function () {
                    console.log(4533);console.log(item);
                    self.product = item;
                    self.add_general_products = 1;
                    self.addProduct();
                }, 300);
            };

            var _iteratorNormalCompletion16 = true;
            var _didIteratorError16 = false;
            var _iteratorError16 = undefined;

            try {
                for (var _iterator16 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.set_items_list), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
                    var item = _step16.value;

                    _loop(item);
                }
            } catch (err) {
                _didIteratorError16 = true;
                _iteratorError16 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion16 && _iterator16.return) {
                        _iterator16.return();
                    }
                } finally {
                    if (_didIteratorError16) {
                        throw _iteratorError16;
                    }
                }
            }
        },
        addProduct: function addProduct() {
            var _this48 = this;

            this.resetMessages();
            this.activate_processing();
            var can_submit = true;

            if (this.service_offers.length == 0 && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.service_offer).length > 0) {
                this.addToServiceOffers(this.service_offer);
            }
            if (this.product.product_is_subscribed_to) {
                this.product.product_is_subscribed_to = 1;
            } else {
                this.product.product_is_subscribed_to = 0;
            }

            if (this.product_is_wholesale) {
                if (this.product.product_item_set_moq > 0 || this.product.product_item_set_moq_price > 0) {
                    can_submit = true;
                } else {
                    can_submit = false;
                }
                if (this.product.product_item_price <= 0 || this.product.product_item_price == '' || this.product.product_item_price == undefined) {
                    this.product.product_item_price = this.product.product_item_set_moq_price;
                }
            }

            if (this.add_general_products == 0) {
                var credentials = {
                    product_name: this.product.product_name,
                    product_is_product_or_service: this.is_product_service,
                    product_category_is_set: this.category.business_category_id || 0,
                    product_business: this.sellpoint.business_id || 0,
                    product_description: this.product.product_description || "nill",

                    product_item_price: this.product.product_item_price,
                    product_item_weight: this.product.product_item_weight || 1,
                    product_item_quantity: this.product.product_item_quantity || 100,
                    product_is_subscribed_to: this.product.product_is_subscribed_to,
                    product_service_offers: this.service_offers
                };
            } else if (this.add_general_products == 1) {
                var credentials = {
                    product_custom_app: 1,
                    product_custom_app_data_id: this.product.product_id,
                    product_custom_app_set_category: this.general_goods_category,
                    product_name: this.product.product_name,
                    product_category_is_set: 0,
                    product_business: this.sellpoint.business_id,
                    product_description: "nill",
                    product_item_price: this.product.product_items[0].product_item_price,
                    product_item_weight: this.product.product_item_weight || 1,
                    product_item_quantity: this.product.product_item_quantity || 100,
                    product_is_subscribed_to: this.product.product_is_subscribed_to,
                    product_service_offers: this.service_offers
                };
            }

            var navi = this.$router;
            if (can_submit && credentials.product_name != undefined && credentials.product_item_price > 0) {
                service.addProduct(this, credentials).then(function (data) {
                    var _this47 = this;

                    if (data.body.status == 201) {
                        this.data_success_message = "Processing, please wait ...";

                        var product = data.body.data;

                        if (this.product_set_details.length > 0) {
                            this.addProductDetails(product);
                        }

                        this.imageForm.append("data_id", product.product_id);

                        this.imageForm.append("data_type", "products");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                _this47.deactivate_processing();
                                _this47.resetFormData();
                            } else {
                                _this47.data_processing_message = service.upload_media_error_msg;

                                setTimeout(function () {
                                    _self3.deactivate_processing();
                                    _self3.resetFormData();
                                }, service.timeout_msg_wait_period);
                            }
                        }).catch(function (err) {
                            if (err) {}
                            _this47.data_error_message = service.upload_media_error_msg;

                            _this47.back();
                        });

                        var _self3 = this;
                        setTimeout(function () {
                            _self3.deactivate_processing();
                            _self3.resetFormData();
                        }, service.upload_wait_period);
                        this.service_offers = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        console.log(err);
                        _this48.data_error_message = "Something went wrong, preparing report ...";

                        _this48.deactivate_processing();
                        _this48.resetFormData();
                    }
                });
            } else {
                this.data_error_message = "Kindly fill all fields ...";
                this.deactivate_processing();
            }
        },
        addNewAgentProduct: function addNewAgentProduct(product, add_to_agent_category_type) {
            var _this49 = this;

            this.product = product;
            this.activate_processing();

            product.product_agent_business = this.sellpoint.business_id;
            product.product_agent_category_type = add_to_agent_category_type;
            product.product_agent_category = this.category.business_category_id;
            product.product_agent_category_name = this.category.business_category_name;

            var navi = this.$router;

            service.addAgentProduct(this, product).then(function (data) {
                if (data.body.status == 201) {
                    this.sellpoint.business_categories = data.body.data_business_categories;

                    this.$store.dispatch('account/setSellpointCategories', this.sellpoint.business_categories);

                    this.setBusinessComponent('viewBusinessCategory', this.sellpoint, data.body.data_active_business_category);
                    this.data_success_message = "Processing, please wait ...";
                    this.deactivate_processing();
                }
                this.setBusinessComponent('viewBusinessCategory', this.sellpoint, this.category);
            }).catch(function (err) {
                _this49.setBusinessComponent('viewBusinessCategory', _this49.sellpoint, _this49.category);
            });
        },
        setProductItemsMOQ: function setProductItemsMOQ(action, moq) {
            var _this50 = this;

            this.resetMessages();
            this.activate_processing();
            var can_submit = false;
            var product_item_moq = {};

            if (action == 'delete_moq') {
                can_submit = true;
                product_item_moq = moq;
            }
            if (action == 'edit_moq') {
                if (moq.product_item_moq > 0 || moq.product_item_moq_price > 0) {
                    can_submit = true;
                    product_item_moq = moq;
                }
            }
            if (action == 'add_moq') {
                if (this.product_item.product_item_set_moq > 0 || this.product_item.product_item_set_moq_price > 0) {
                    can_submit = true;
                    product_item_moq.product_item_moq_product_item = this.product_item.product_item_id, product_item_moq.product_item_moq = this.product_item.product_item_set_moq;
                    product_item_moq.product_item_moq_price = this.product_item.product_item_set_moq_price;
                }
            }

            var credentials = {
                data_action: action,
                data_moq: product_item_moq
            };

            var navi = this.$router;
            if (can_submit) {
                service.setProductITemMOQs(this, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        this.product_item.product_item_moqs = data.body.data;
                        this.data_success_message = "Processing, please wait ...";
                        this.deactivate_processing();
                        this.setMenuTabInnerView('');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this50.data_error_message = "Something went wrong, preparing report ...";
                        _this50.deactivate_processing();
                    }
                });
            } else {
                this.data_error_message = "Kindly fill all fields ...";
                this.deactivate_processing();
            }
        },
        setAddToProductAddons: function setAddToProductAddons(add_product) {
            if (!this.product.set_product_addons) {
                this.product.set_product_addons = [];
                this.product.set_product_addons.push(add_product.product_id);
            } else {
                if (!this.product.set_product_addons.includes(add_product.product_id)) {
                    this.product.set_product_addons.push(add_product.product_id);
                }
            }
        },
        addToProductAddons: function addToProductAddons() {
            var _this51 = this;

            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.product.set_product_addons).length > 0) {
                var payload = {
                    product: this.product.product_id,
                    product_addons: this.product.set_product_addons
                };

                service.addToProductAddons(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        this.product.product_addons = data.body.data;
                        this.data_success_message = "Processing, please wait ...";
                        this.componentKey++;
                        this.deactivate_processing();

                        if (document.getElementById('setAddProductAddons')) {
                            this.toggleSingleComponent('setAddProductAddons');
                        }
                    }
                }).catch(function (err) {
                    if (err) {
                        console.log();console.log(err);
                        _this51.data_error_message = "Something went wrong, preparing report ...";
                        _this51.deactivate_processing();
                    }
                });
            }
        },
        removeProductAddons: function removeProductAddons() {
            var _this52 = this;

            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.product.set_product_addons).length > 0) {
                var payload = {
                    product: this.product.product_id,
                    product_addons: this.product.set_product_addons
                };

                service.removeProductAddons(this, payload).then(function (data) {
                    if (data.body.status == 200) {
                        this.product.product_addons = data.body.data;
                        this.data_success_message = "Processing, please wait ...";
                        this.componentKey++;
                        this.deactivate_processing();
                    }
                }).catch(function (err) {
                    if (err) {
                        console.log();console.log(err);
                        _this52.data_error_message = "Something went wrong, preparing report ...";
                        _this52.deactivate_processing();
                    }
                });
            }
        },
        getProductAddons: function getProductAddons(product) {
            var set_addons = [];
            var product_id = product.product_id;

            var product_addons = [];
            if (product.product_addons && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(product.product_addons).length > 0) {
                product_addons = product.product_addons;
            }

            var _iteratorNormalCompletion17 = true;
            var _didIteratorError17 = false;
            var _iteratorError17 = undefined;

            try {
                for (var _iterator17 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.products), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
                    var prd = _step17.value;

                    if (product_id != prd.product_id) {
                        var _iteratorNormalCompletion18 = true;
                        var _didIteratorError18 = false;
                        var _iteratorError18 = undefined;

                        try {
                            for (var _iterator18 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(product_addons), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
                                var addon = _step18.value;

                                if (addon.product_id != prd.product_id) {
                                    set_addons.push(prd);
                                }
                            }
                        } catch (err) {
                            _didIteratorError18 = true;
                            _iteratorError18 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion18 && _iterator18.return) {
                                    _iterator18.return();
                                }
                            } finally {
                                if (_didIteratorError18) {
                                    throw _iteratorError18;
                                }
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError17 = true;
                _iteratorError17 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion17 && _iterator17.return) {
                        _iterator17.return();
                    }
                } finally {
                    if (_didIteratorError17) {
                        throw _iteratorError17;
                    }
                }
            }

            this.set_product_addons = set_addons;
        },
        addProductDetails: function addProductDetails(product) {
            var _this53 = this;

            if (this.product_set_details.length > 0) {
                var _iteratorNormalCompletion19 = true;
                var _didIteratorError19 = false;
                var _iteratorError19 = undefined;

                try {
                    for (var _iterator19 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.product_set_details), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
                        var pd = _step19.value;

                        var payload = {
                            product_id: product.product_id,
                            product_info_type: pd.type,
                            product_info_title: pd.title,
                            product_info_detail: pd.detail,
                            product_info_set_name: pd.set_name || '',
                            product_info_set_cost: pd.set_cost || 0
                        };

                        service.addProductInformation(this, payload).then(function (data) {
                            if (data.body.status == 201) {
                                this.product.product_addons = data.body.data;
                                this.data_success_message = "Processing, please wait ...";
                            }
                        }).catch(function (err) {
                            if (err) {
                                _this53.data_error_message = "Something went wrong, preparing report ...";
                                _this53.deactivate_processing();
                            }
                        });
                    }
                } catch (err) {
                    _didIteratorError19 = true;
                    _iteratorError19 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion19 && _iterator19.return) {
                            _iterator19.return();
                        }
                    } finally {
                        if (_didIteratorError19) {
                            throw _iteratorError19;
                        }
                    }
                }
            }
        },
        getProductImages: function getProductImages() {
            var _this54 = this;

            service.getProductImages(this, this.product.product_id).then(function (response) {
                if (response.body.status == 200) {
                    _this54.product.product_images = response.body.data;
                    _this54.product_display_image = _this54.product.product_images[0];

                    _this54.data_media_error_message = "";
                    _this54.deactivate_processing();
                }
            }).catch(function (err) {});
        },
        deleteProductImage: function deleteProductImage(image) {
            var _this55 = this;

            this.activate_processing();
            service.deleteProductImage(this, image).then(function (data) {
                if (data.body.status == 200) {
                    this.getProductImages();
                }
                this.deactivate_processing();
            }).catch(function (err) {
                _this55.deactivate_processing();
            });
        },
        editProduct: function editProduct() {
            var _this56 = this;

            this.activate_processing();

            var set_product_category = this.product.product_category_id;
            if (this.product.product_sub_category != undefined || this.product.product_listed_category != undefined) {
                set_product_category = 0;
            } else {
                if (this.product.product_category != undefined) {
                    set_product_category = this.product.product_category;
                } else {
                    set_product_category = this.product.product_category_id;
                }
            }
            var credentials = {
                product_id: this.product.product_id,
                product_name: this.product.product_name,

                product_category: set_product_category,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",


                product_url_name: this.product.product_url_name,
                product_description: this.product.product_description || "nill",
                product_business: this.product.product_business_id };

            var navi = this.$router;
            if (credentials.product_name != undefined) {
                service.editProduct(this, this.product.product_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this56.product = response.body.data;
                        _this56.product_details = {};
                    } else {
                        _this56.product_details = {};
                        _this56.deactivate_processing();
                    }

                    _this56.product_item.product_item_price = _this56.product.product_price;
                    _this56.editProductItem();

                    _this56.getSellpointProducts();
                }).catch(function (err) {
                    if (err) {
                        _this56.data_processing_message = "Something went wrong";
                        _this56.product_details = {};
                        _this56.deactivate_processing();
                    }
                });
            } else {
                this.data_processing_message = "Kindly fill all fields";
                this.disable_btn = false;
            }
        },
        editProductSingleProductItem: function editProductSingleProductItem() {
            var _this57 = this;

            this.activate_processing();

            var set_product_item = 0;
            var current_set_product_item_actual_price = this.product.product_items[0].product_item_actual_price;
            if (this.product.product_items[0].product_item_actual_price != 0) {
                set_product_item = this.product.product_items[0].product_item_actual_price;
            } else {
                set_product_item = this.product.product_items[0].product_item_price;
            }
            var credentials = {
                product_item_id: this.product.product_items[0].product_item_id,

                product_item_price: set_product_item,
                product_item_weight: this.product.product_items[0].product_item_weight || 1,
                product_item_quantity: this.product.product_items[0].product_item_quantity || 100
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.editProductItemSingle(this, this.product.product_items[0].product_item_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this57.product.product_items[0] = response.body.data;
                        _this57.product.product_items[0].product_item_actual_price = current_set_product_item_actual_price;
                        _this57.deactivate_processing();
                        _this57.product_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this57.data_processing_message = "Update failed, Something went wrong";
                        _this57.deactivate_processing();
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        editProductSettings: function editProductSettings() {
            var _this58 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_groups_set_name: this.product.product_groups_set_name || 'Group/Types',
                product_groups_items_set_name: this.product.product_groups_items_set_name || 'Select Item'
            };

            var navi = this.$router;
            service.editProductSettings(this, this.product.product_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this58.product = response.body.data;
                    _this58.product_details = {};
                } else {
                    _this58.product_details = {};
                    _this58.deactivate_processing();
                }
            }).catch(function (err) {
                if (err) {
                    _this58.data_processing_message = "Something went wrong";
                    _this58.product_details = {};
                    _this58.deactivate_processing();
                }
            });
        },
        addProductItem: function addProductItem() {
            var _this59 = this;

            this.activate_processing();
            if (this.product_details.addProductItemToGroup) {
                var credentials = {
                    product_item_group: this.product_item_group.product_item_group_id || 1,

                    product_id: this.product.product_id,
                    product_item_price: this.product.product_item_price,
                    product_item_weight: this.product.product_item_weight || 1,
                    product_item_quantity: this.product.product_item_quantity || 100,
                    product_item_size: this.product.product_item_size || "Nill",
                    product_item_service_tag: this.product.product_item_service_tag || "Nill",
                    product_item_service_duration: this.product.product_item_service_duration + this.service_duration || '1 year'
                };
            } else {
                var new_product_item_group = false;
                var product_item_group_is_color_image = 'IMG';
                if (this.product.product_item_group == undefined) {
                    new_product_item_group = true;
                }
                if (this.product.product_item_group_color == undefined) {
                    product_item_group_is_color_image = 'IMG';
                } else {
                    product_item_group_is_color_image = 'COL';
                }
                var credentials = {
                    product_new_product_item_group: new_product_item_group,
                    product_item_group_product: this.product.product_id,
                    product_item_group_name: this.product.product_item_group_name || "Group/Type",
                    product_item_group_is_color_image: product_item_group_is_color_image,
                    product_item_group_color: this.product.product_item_group_color || "Nill",
                    product_item_group_image: this.product.product_item_group_image || 0,


                    product_item_group: this.product.product_item_group || 1,

                    product_id: this.product.product_id,
                    product_item_price: this.product.product_item_price,
                    product_item_weight: this.product.product_item_weight || 1,
                    product_item_quantity: this.product.product_item_quantity || 100,
                    product_item_size: this.product.product_item_size || "Nill",
                    product_item_service_tag: this.product.product_item_service_tag || "Nill",
                    product_item_service_duration: this.product.product_item_service_duration + this.service_duration || '1 year'
                };
            }
            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.addProductItem(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_success_message = "Product Item Added Successfully";
                        this.product = data.body.data_product;

                        this.product_details.addProductItemPanel = false;
                        this.product_details = {};
                        this.setMenuTabView('product', 'setBusinessCategoryProductItems', this.sellpoint, '');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this59.data_error_message = "Something went wrong";

                        console.log(err);

                        _this59.deactivate_processing();
                    }
                });
            } else {
                this.data_error_message = "Kindly fill all fields";

                this.deactivate_processing();
            }
        },
        editProductItem: function editProductItem() {
            var _this60 = this;

            this.activate_processing();

            var set_product_item_price = 0;
            if (this.product_item.product_item_actual_price != undefined) {
                if (this.product_item.product_item_actual_price > 0) {
                    set_product_item_price = this.product_item.product_item_actual_price;
                } else {
                    set_product_item_price = this.product_item.product_item_price;
                }
            } else {
                set_product_item_price = this.product_item.product_item_price;
            }
            var credentials = {
                product_item_id: this.product_item.product_item_id,

                product_item_price: set_product_item_price,
                product_item_weight: this.product_item.product_item_weight || 1,
                product_item_size: this.product_item.product_item_size || "Nill",
                product_item_service_tag: this.product_item.product_item_service_tag || "Nill",
                product_item_quantity: this.product_item.product_item_quantity || 100
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.editProductItem(this, this.product_item.product_item_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this60.product_item = response.body.data;

                        if (_this60.product.product_item[0].product_item_id == _this60.product_item.product_item_id) {
                            _this60.product.product_price = _this60.product_item.product_item_price;
                        }
                        _this60.deactivate_processing();
                        _this60.product_details = {};
                        if (_this60.$route.params.ref && _this60.$route.params.ref != '') {
                            navi.push('/manage/order/' + _this60.product.product_url_name);
                        }
                    }
                }).catch(function (err) {
                    if (err) {
                        _this60.data_processing_message = "Update failed, Something went wrong";
                        _this60.deactivate_processing();
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        editProductItemGroup: function editProductItemGroup() {
            var _this61 = this;

            this.activate_processing();
            var product_item_group_is_color_image = 'IMG';
            if (this.product_item_group.product_item_group_color == undefined) {
                product_item_group_is_color_image = 'IMG';
            } else {
                product_item_group_is_color_image = 'COL';
            }

            if (this.product_item_group.product_item_group_color_new != undefined) {
                product_item_group_is_color_image = 'COL';
                this.product_item_group.product_item_group_color = this.product_item_group.product_item_group_color_new;
                this.product_item_group.product_item_group_image = 0;
            } else {
                product_item_group_is_color_image = 'IMG';
                this.product_item_group.product_item_group_color = "Nill";
            }
            var credentials = {
                product_item_group_product: this.product.product_id,
                product_item_group_name: this.product_item_group.product_item_group_name || "Type",
                product_item_group_is_color_image: product_item_group_is_color_image,
                product_item_group_color: this.product_item_group.product_item_group_color || "Nill",
                product_item_group_image: this.product_item_group.product_item_group_image || 0
            };

            var navi = this.$router;
            if (credentials.product_item_group_name != undefined) {
                service.editProductItemGroup(this, this.product_item_group.product_item_group_id, credentials).then(function (response) {
                    if (response.body.status == 200) {

                        _this61.product.product_item_groups = response.body.data;

                        _this61.deactivate_processing();
                        _this61.product_details = {};
                    } else {
                        _this61.deactivate_processing();
                        _this61.product_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this61.data_processing_message = 'Update failed, Something went wrong';
                        _this61.deactivate_processing();
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        restockProductItem: function restockProductItem() {
            var _this62 = this;

            this.activate_processing();

            var set_product_item = 0;
            if (this.product_item.product_item_actual_price != 0) {
                set_product_item = this.product_item.product_item_actual_price;
            } else {
                set_product_item = this.product_item.product_item_price;
            }
            var credentials = {
                product_item: this.product_item,
                product_item_id: this.product_item.product_item_id,
                product_item_quantity_restock: this.product_item.product_item_quantity_restock || 100
            };

            var navi = this.$router;
            if (credentials.product_item_quantity_restock != undefined) {
                service.restockProductItem(this, this.product_item.product_item_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this62.product_item = response.body.data;
                        _this62.deactivate_processing();
                        _this62.product_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this62.data_processing_message = "Update failed, Something went wrong";
                        _this62.deactivate_processing();
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        removeProduct: function removeProduct() {
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id
            };
            var navi = this.$router;
            service.removeProduct(this, this.product.product_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    location.reload(true);
                }
            }).catch(function (err) {
                if (err) {
                    location.reload(true);
                }
            });
        },
        removeProductItem: function removeProductItem() {
            var _this63 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_id: this.product_item.product_item_id
            };
            var navi = this.$router;
            service.removeProductItem(this, this.product_item.product_item_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    if (response.body.no_product) {
                        _this63.redir(_this63.$route.params.id);
                    }
                    _this63.product.product_item_groups = response.body.data;

                    _this63.deactivate_processing();
                    _this63.removeItemPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this63.deactivate_processing();
                }
            });
        },
        removeProductItemGroup: function removeProductItemGroup() {
            var _this64 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_group_id: this.product_item_group.product_item_group_id
            };
            var navi = this.$router;
            service.removeProductItemGroup(this, this.product_item_group.product_item_group_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    if (response.body.no_product) {
                        _this64.redir(_this64.$route.params.id);
                    }
                    _this64.product.product_item_groups = response.body.data;
                    _this64.deactivate_processing();
                    _this64.removeItemGroupPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this64.deactivate_processing();
                }
            });
        },
        setProductDelivery: function setProductDelivery() {
            var _this65 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_delivery_details: this.product.product_delivery_returns
            };
            service.setProductDelivery(this, 1, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product_details = {};
                }
                this.deactivate_processing();
            }).catch(function (err) {
                _this65.product_details = {};
                _this65.deactivate_processing();
            });
        },
        setProductShippingFeeStatus: function setProductShippingFeeStatus() {
            this.set_shipping_fee_status_track = true;
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_set_shipping_fee_status: this.product_set_shipping_fee_status
            };
            service.setProductShippingFeeStatus(this, payload).then(function (data) {
                this.product.product_set_shipping_fee_status = this.product_set_shipping_fee_status;
                this.set_shipping_fee_status_track = false;
                this.deactivate_processing();
            }).catch(function (err) {});
        },
        setProductDeliveryOption: function setProductDeliveryOption() {
            var _this66 = this;

            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id,
                business_product_id: this.product.product_id,
                business_product_delivery_fee: this.delivery_option.product_delivery_fee || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };
            if (payload.business_product_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_product_delivery_option != 0) {
                    service.setProductDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200 || data.body.status == 201) {
                            this.product.product_business_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.product_details = {};

                            this.deactivate_processing();
                        } else {
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        _this66.delivery_option.edit_set = false;
                        _this66.product_details = {};
                        _this66.deactivate_processing();
                    });
                } else {
                    this.deactivate_processing();
                }
            }
        },
        setProductSettings: function setProductSettings(payload) {
            var _this67 = this;

            this.activate_processing();
            service.editProductSettings(this, payload.product_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this67.products = response.body.data;
                }
                _this67.deactivate_processing();
            }).catch(function (err) {
                if (err) {
                    _this67.data_processing_message = "Something went wrong";
                    _this67.deactivate_processing();
                }
            });
        },
        setAddToAddonProducts: function setAddToAddonProducts(product) {
            if (!this.set_products_as_addons.includes(product.product_id)) {
                this.set_products_as_addons.push(product.product_id);
            } else {
                var index = this.set_products_as_addons.indexOf(product.product_id);
                if (index > -1) {
                    this.set_products_as_addons.splice(index, 1);
                }
            }
        },
        setProductsAddon: function setProductsAddon() {
            var _iteratorNormalCompletion20 = true;
            var _didIteratorError20 = false;
            var _iteratorError20 = undefined;

            try {
                for (var _iterator20 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.set_products_as_addons), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
                    var product = _step20.value;

                    var payload = {
                        business: this.sellpoint.business_id,
                        product_id: product,
                        product_is_addon: 1 };
                    this.setProductSettings(payload);
                }
            } catch (err) {
                _didIteratorError20 = true;
                _iteratorError20 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion20 && _iterator20.return) {
                        _iterator20.return();
                    }
                } finally {
                    if (_didIteratorError20) {
                        throw _iteratorError20;
                    }
                }
            }

            this.set_products_as_addons = [];
        },
        setAddToAvailableProducts: function setAddToAvailableProducts(product) {
            if (!this.set_products_as_available.includes(product.product_id)) {
                this.set_products_as_available.push(product.product_id);
            } else {
                var index = this.set_products_as_available.indexOf(product.product_id);
                if (index > -1) {
                    this.set_products_as_available.splice(index, 1);
                }
            }
        },
        setProductsAvailability: function setProductsAvailability() {
            var _iteratorNormalCompletion21 = true;
            var _didIteratorError21 = false;
            var _iteratorError21 = undefined;

            try {
                for (var _iterator21 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.set_products_as_available), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
                    var product = _step21.value;

                    var payload = {
                        business: this.sellpoint.business_id,
                        product_id: product,
                        product_is_available: 1 };
                    this.setProductSettings(payload);
                }
            } catch (err) {
                _didIteratorError21 = true;
                _iteratorError21 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion21 && _iterator21.return) {
                        _iterator21.return();
                    }
                } finally {
                    if (_didIteratorError21) {
                        throw _iteratorError21;
                    }
                }
            }

            this.set_products_as_available = [];
        },
        getGeneralGoods: function getGeneralGoods() {
            var _this68 = this;

            service.getGeneralGoods(this).then(function (response) {
                if (response.body.status == 200) {
                    _this68.general_goods = response.body.data;
                }
            }).catch(function (err) {});
        },
        getGeneralGoodsCategoryProducts: function getGeneralGoodsCategoryProducts() {
            var _this69 = this;

            service.getGeneralGoodsCategoryProducts(this, this.general_goods_category.category_id).then(function (response) {
                _this69.general_goods_category_products = response.body.data;
            }).catch(function (err) {});
        },
        setAddItemsToList: function setAddItemsToList(item, item_index) {
            this.product = item;
            var set_item = {};
            if (this.set_items_list && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.set_items_list).length > 0) {
                set_item = this.set_items_list.find(function (set_item) {
                    return set_item.product_id === item.product_id;
                });

                if (set_item == undefined) {
                    item.item_index = item_index;

                    this.set_items_list.push(item);
                } else {
                    var index = this.set_items_list.findIndex(function (i) {
                        return set_item.product_id === i.product_id;
                    });
                    this.set_items_list.splice(index, 1);
                }
            } else {
                this.set_items_list.push(item);
            }
        },
        checkItemInList: function checkItemInList(item) {
            var count = 0;
            var data_item = this.set_items_list.find(function (data_item) {
                return data_item.product_id === item.product_id;
            });
            if (data_item) {
                count++;
            }

            if (count > 0) {
                return true;
            } else {
                return false;
            }
        },
        getOrderDetails: function getOrderDetails(attr) {
            var payload = {
                order_ref: attr.ref,
                order_module: attr.module,
                order_module_id: attr.module_id
            };
            if (payload.order_ref != '') {
                service.getOrderDetails(this, payload).then(function (data) {
                    if (data.body.status == 200) {
                        this.order = data.body.data[0];
                        this.getOrderChart();
                        this.getOrderAdditionals();
                    }
                    this.action_loading = false;
                }).catch(function (err) {});
            }
        },
        getOrderChart: function getOrderChart() {
            var _this70 = this;

            service.getMapOrderChart(this, this.order.order_id).then(function (response) {
                if (response.body.status == 200) {
                    _this70.order_chart = response.body.data_chart;
                }
            }).catch(function (err) {});
        },
        checkOrderChart: function checkOrderChart(param, value) {
            var found = false;
            if (param == 'status') {
                var _iteratorNormalCompletion22 = true;
                var _didIteratorError22 = false;
                var _iteratorError22 = undefined;

                try {
                    for (var _iterator22 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.order_chart), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
                        var item = _step22.value;

                        if (item.order_status_id == value) {
                            found = true;
                        }
                    }
                } catch (err) {
                    _didIteratorError22 = true;
                    _iteratorError22 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion22 && _iterator22.return) {
                            _iterator22.return();
                        }
                    } finally {
                        if (_didIteratorError22) {
                            throw _iteratorError22;
                        }
                    }
                }
            }
            return found;
        },
        getOrderAdditionals: function getOrderAdditionals() {
            var _this71 = this;

            var payload = {
                data_order: this.order.order_id
            };
            service.getOrderAdditionals(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this71.order_additionals = response.body.data;
                }
            }).catch(function (err) {});
        },
        getAppBusinessOrders: function getAppBusinessOrders() {
            var _this72 = this;

            service.getAppBusinessOrders(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this72.sellpoint_orders = response.body.data;
                    _this72.sellpoint.orders = response.body.data;

                    _this72.setOrderedItems(_this72.sellpoint_orders);
                }
                _this72.componentKey++;
                _this72.loading = false;
            }).catch(function (err) {});
        },
        setOrderedItems: function setOrderedItems(orders) {
            var _this73 = this;

            var _iteratorNormalCompletion23 = true;
            var _didIteratorError23 = false;
            var _iteratorError23 = undefined;

            try {
                for (var _iterator23 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(orders), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
                    var order = _step23.value;

                    var _loop2 = function _loop2(order_item) {
                        var item = _this73.set_ordered_items.find(function (item) {
                            return item.product_item_id === order_item.product_item_id;
                        });
                        if (!item) {
                            order_item.set_order_quantity = Number(order_item.order_item_quantity);

                            _this73.set_ordered_items.push(order_item);

                            if (order.order_status_id == 2 && order.order_is_today == 1) {
                                console.log(822);
                                console.log(order);

                                _this73.total_sales_today += Number(order_item.order_item_total);
                            }
                        } else {
                            var index = _this73.set_ordered_items.findIndex(function (item) {
                                return item.product_item_id === order_item.product_item_id;
                            });
                            if (index > 0) {
                                _this73.set_ordered_items[index].set_order_quantity += Number(item.order_item_quantity);

                                if (order.order_status_id == 2 && order.order_is_today == 1) {
                                    console.log(822);
                                    console.log(order);

                                    _this73.total_sales_today += Number(order_item.order_item_total);
                                }
                            }
                        }
                    };

                    var _iteratorNormalCompletion24 = true;
                    var _didIteratorError24 = false;
                    var _iteratorError24 = undefined;

                    try {
                        for (var _iterator24 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(order.order_items), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
                            var order_item = _step24.value;

                            _loop2(order_item);
                        }
                    } catch (err) {
                        _didIteratorError24 = true;
                        _iteratorError24 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion24 && _iterator24.return) {
                                _iterator24.return();
                            }
                        } finally {
                            if (_didIteratorError24) {
                                throw _iteratorError24;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError23 = true;
                _iteratorError23 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion23 && _iterator23.return) {
                        _iterator23.return();
                    }
                } finally {
                    if (_didIteratorError23) {
                        throw _iteratorError23;
                    }
                }
            }
        },
        getAppBusinessOrdersPendingPayments: function getAppBusinessOrdersPendingPayments() {
            var _this74 = this;

            service.getAppBusinessOrdersPendingPayments(this, 3, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this74.sellpoint_pending_orders = response.body.data;
                }
                _this74.componentKey++;
                _this74.loading = false;
            }).catch(function (err) {});
        },
        setPendingOrdersPayment: function setPendingOrdersPayment(payment, order_index) {
            this.set_order_pending_payment_data = "ord" + order_index;

            var payment_orders_data = payment.data;
            var payment_amount_to_pay = payment.payment_data.payment_pending_amount_to_pay;
            var payment_ref = payment.payment_data.payment_ref;
            var payment_details = payment.payment_data.payment_service;
            var payment_service_module = payment.payment_service_module;
            var payment_service_module_id = payment.payment_service_module_id;
            var payment_pending_amount_to_pay_by = payment.payment_data.payment_pending_amount_to_pay_by;

            var set_subaccounts = [];
            var _iteratorNormalCompletion25 = true;
            var _didIteratorError25 = false;
            var _iteratorError25 = undefined;

            try {
                for (var _iterator25 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(payment.data), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
                    var order = _step25.value;
                    var _iteratorNormalCompletion26 = true;
                    var _didIteratorError26 = false;
                    var _iteratorError26 = undefined;

                    try {
                        for (var _iterator26 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(payment.payment_data.pay_settlements), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
                            var pay_stl = _step26.value;

                            if (payment_pending_amount_to_pay_by == 1) {
                                if (pay_stl.payment_stl_type == 22) {
                                    var sub_account_0 = {
                                        id: order.business_agent_bank_ravepay_subaccount_id,
                                        transaction_charge: pay_stl.payment_stl_amount,
                                        transaction_charge_type: "flat_subaccount"
                                    };
                                    set_subaccounts.push(sub_account_0);
                                }
                            }

                            if (pay_stl.payment_stl_type == 23) {
                                var sub_account_01 = {
                                    id: service.spcomms_subaccount_id,
                                    transaction_charge: pay_stl.payment_stl_amount,
                                    transaction_charge_type: "flat_subaccount"
                                };
                                set_subaccounts.push(sub_account_01);
                            }

                            if (payment_pending_amount_to_pay_by == 2) {
                                if (pay_stl.payment_stl_type == 25) {
                                    var sub_account_02 = {
                                        id: service.spcomms_subaccount_id,
                                        transaction_charge: pay_stl.payment_stl_amount,
                                        transaction_charge_type: "flat_subaccount"
                                    };
                                    set_subaccounts.push(sub_account_02);
                                }
                            }

                            if (pay_stl.payment_stl_type == 26) {
                                var sub_account_03 = {
                                    id: service.spcomms_subaccount_id,
                                    transaction_charge: pay_stl.payment_stl_amount,
                                    transaction_charge_type: "flat_subaccount"
                                };
                                set_subaccounts.push(sub_account_03);
                            }
                        }
                    } catch (err) {
                        _didIteratorError26 = true;
                        _iteratorError26 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion26 && _iterator26.return) {
                                _iterator26.return();
                            }
                        } finally {
                            if (_didIteratorError26) {
                                throw _iteratorError26;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError25 = true;
                _iteratorError25 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion25 && _iterator25.return) {
                        _iterator25.return();
                    }
                } finally {
                    if (_didIteratorError25) {
                        throw _iteratorError25;
                    }
                }
            }

            var payment_data = {};
            if (this.user.user_email == undefined || this.user.user_phone == undefined || this.user.user_email == "" || this.user.user_phone == "") {
                this.show_empty_fields = true;
            } else {
                payment_data = {
                    payer_name: this.user.user_name,
                    payer_email: this.user.user_email,
                    payer_phone: this.user.user_phone,
                    payment_total_amount: payment_amount_to_pay,
                    payment_currency: "NGN",
                    payment_ref: payment_ref,
                    payment_details: payment_details,
                    payment_processing_fee_status: 4,
                    payment_processing_fee: 0,
                    payment_processing_fee_transaction_type: 0,
                    payment_transaction_type: 3,
                    payment_service_module: payment_service_module,
                    payment_service_module_id: payment_service_module_id,
                    payment_data_index: 0,
                    payment_data_route: "account",
                    payment_service_business: 0,
                    payment_service_type: "single",
                    payment_service_payment_data: payment.payment_data,
                    payment_sub_accounts: set_subaccounts,
                    payment_fees_account_balance: this.sellpoint.business_processing_fee_balance,
                    payment_meta: [],
                    payment_modes_accepted: [1, 5] };

                payment_data.payment_service_payment_data.payment_services = payment_orders_data;
                this.show_empty_fields = false;
            }
            this.set_pending_payment_data = payment_data;
        },
        setOrderCustomOrderDetailsUpdate: function setOrderCustomOrderDetailsUpdate(order) {
            var payload = {
                order: order,
                order_status: "custom_set_track",
                order_set_track_status: 35,
                order_set_product_price: this.order.order_set_product_price || 0,
                order_set_shipping_cost: this.order.order_set_shipping_cost || 0,
                order_set_total_cost: this.order.order_set_total_cost || 0,
                order_set_delivery_info: this.order.order_set_delivery_info || '',
                order_set_bank_id: this.sellpoint.business_bank_details.bank_id || 0,
                order_set_bank_name: this.sellpoint.business_bank_details.bank_name || '',
                order_set_bank_account_name: this.sellpoint.business_bank_details.bank_account_name || '',
                order_set_bank_account_no: this.sellpoint.business_bank_details.bank_account_number || 0,

                order_track_module: 8,
                order_track_module_id: order.order_id,
                order_track_module_status: 35,
                order_track_action_by_module: 3,
                order_track_action_by_module_id: this.sellpoint.business_id,
                order_current_user: this.user.user_id || 0 };

            this.updateOrderSet(payload);
        },
        setOrderCustomConfirmPaymentUpdate: function setOrderCustomConfirmPaymentUpdate(order) {
            var payload = {
                order: order,
                order_status: "custom_set_track_confirm_payment",
                order_payment_seller_confirmation: 1,

                order_track_module: 8,
                order_track_module_id: order.order_id,
                order_track_module_status: 2,
                order_track_action_by_module: 3,
                order_track_action_by_module_id: this.sellpoint.business_id,
                order_current_user: this.user.user_id || 0 };

            this.updateOrderSet(payload);
        },
        setOrderCustomUpdates: function setOrderCustomUpdates(order, status, action_by_module) {
            var payload = {
                order: order,
                order_status: status,

                order_track_module: 8,
                order_track_module_id: order.order_id,
                order_track_module_status: 0,
                order_track_action_by_module: 0,
                order_track_action_by_module_id: 0,
                order_current_user: this.user.user_id || 0 };

            if (action_by_module == 1) {
                payload.order_track_action_by_module = 1;
                payload.order_track_action_by_module_id = this.user.user_id;
            } else if (action_by_module == 3) {
                payload.order_track_action_by_module = 3;
                payload.order_track_action_by_module_id = this.sellpoint.business_id;
            }

            if (status == "delivered") {
                payload.order_track_module_status = 18;
            }

            if (status == "closed") {
                payload.order_track_module_status = 33;
            }
            if (status == "custom_set_track_make_payment") {
                payload.order_track_module_status = 20;
            }
            if (status == "custom_set_track_confirm_payment") {
                payload.order_payment_seller_confirmation = 1;
                payload.order_track_module_status = 2;
            }

            if (payload.order_track_action_by_module > 0 && payload.order_track_module_status > 0) {
                this.updateOrderSet(payload);
            }
        },
        updateOrderPaymentXX: function updateOrderPaymentXX(order) {
            var _this75 = this;

            var payload = {
                payment_orders: order,
                payment_update_type: "manualUpdateConfirmation",
                payment_service_mode: 4,
                payment_service_user_id: 0

            };
            var navi = this.$router;
            service.updatePayment(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    _this75.data_processing_message = "Order Confirmed";
                    _this75.order = data.body.data;
                } else {
                    _this75.data_processing_message = "Sorry, could not update payment";
                }
            }).catch(function (err) {
                if (err) {
                    _this75.data_processing_message = "Sorry, could not process information";
                }
            });
        },
        updatePendingOrdersPayment: function updatePendingOrdersPayment(payment) {
            var _this76 = this;

            var payment_service_payment_data = payment.payment_data;
            payment_service_payment_data.payment_details = payment.payment_data.payment_service;
            payment_service_payment_data.payment_services = payment.data;

            var payload = {
                payment_update_type: "manualUpdateConfirmation",
                payment_service_mode: 4,
                payment_received_from: payment.payment_data.payment_set_to_receive_from,
                payment_service_payment_data: payment_service_payment_data,
                payment_service_type: "multiple",
                payment_service_user_id: 0

            };
            var navi = this.$router;
            service.updatePayment(this, payload).then(function (data) {
                if (data.body.data_pending_pay_status == 200) {
                    _this76.data_processing_message = "Payments Confirmed";
                    _this76.sellpoint_pending_orders = data.body.data_pending_pay_data.data;
                    _this76.getAppBusinessTransactions();
                } else {
                    _this76.data_processing_message = "Sorry, could not update payment";
                }
            }).catch(function (err) {
                if (err) {
                    _this76.data_processing_message = "Sorry, could not process information";
                }
            });
        },
        updateOrders: function updateOrders(order, status) {
            var _this77 = this;

            var payload = {
                order: order,
                order_status: status
            };
            var navi = this.$router;
            service.updateOrders(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    _this77.data_processing_message = "Order Updated";

                    _this77.order = data.body.data;
                } else {
                    _this77.data_processing_message = "Sorry, could not update payment";
                }
            }).catch(function (err) {
                if (err) {
                    _this77.data_processing_message = "Sorry, could not process information";
                }
            });
        },
        updateOrderSet: function updateOrderSet(payload) {
            var _this78 = this;

            this.activate_processing();
            var navi = this.$router;
            service.updateOrders(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    _this78.data_processing_message = "Order Updated";
                    _this78.order = data.body.data;

                    _this78.getOrderChart();
                } else {
                    _this78.data_processing_message = "Sorry, could not update payment";
                }
                _this78.deactivate_processing();
            }).catch(function (err) {
                if (err) {
                    _this78.data_processing_message = "Sorry, could not process information";
                }
            });
        },
        uploadFlexiPaymentReceipt: function uploadFlexiPaymentReceipt(data, data_ref, status) {
            var _this79 = this;

            if (status == 'transferred') {
                this.imageForm.append("data_id", data_ref);
                this.imageForm.append("data_type", "third_party_payment_receipt");
                service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                    if (data.body.status == 200) {
                        _this79.flexi_active_payment_status = 1;
                        _this79.getOrderChart();
                        _this79.resetImageUpload();
                    } else {
                        _this79.data_processing_message = service.upload_media_error_msg;
                    }
                });
            }
        },
        onFileChangeNewPhoto: function onFileChangeNewPhoto(e, data_type) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
                this.file_data_type = data_type;
            }

            document.getElementById('prImagePreview').src = window.URL.createObjectURL(files[0]);
        },
        resetImageUpload: function resetImageUpload() {
            this.file_info = [];document.getElementById('prImagePreview').src = '';
        },
        setAddDeliveryOptions: function setAddDeliveryOptions(option) {
            var store_locations = [];
            var set_item = {
                state: option.state,
                city: option.city || 0,
                delivery_option_price: option.delivery_option_price || 0
            };

            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.business_delivery_locations).length == 0) {
                store_locations.push(set_item);
                this.business_delivery_locations = store_locations;
            } else {
                var locations = this.business_delivery_locations;
                var _store_locations = [];
                var _iteratorNormalCompletion27 = true;
                var _didIteratorError27 = false;
                var _iteratorError27 = undefined;

                try {
                    for (var _iterator27 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(locations), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
                        var _location = _step27.value;
                        console.log(262);console.log(_location.state);
                        var set_location = {
                            state: _location.state,
                            city: _location.city || 0,
                            delivery_option_price: _location.delivery_option_price || 0
                        };
                        _store_locations.push(set_location);

                        if (option.state != _location.state) {
                            _store_locations.push(set_item);
                        } else {
                            if (option.city != _location.city) {
                                _store_locations.push(set_item);
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError27 = true;
                    _iteratorError27 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion27 && _iterator27.return) {
                            _iterator27.return();
                        }
                    } finally {
                        if (_didIteratorError27) {
                            throw _iteratorError27;
                        }
                    }
                }

                this.business_delivery_locations = _store_locations;

                this.componentDeliveryKey++;
            }
        },
        setAddProductAsAddon: function setAddProductAsAddon(product) {
            this.activate_processing();

            var credentials = {
                product_name: product.product_name,
                product_is_product_or_service: this.is_product_service || 'P',
                product_category_is_set: this.category.business_category_id || 0,
                product_business: this.sellpoint.business_id || 0,
                product_description: product.product_description || "nill",
                product_item_price: product.product_item_price || product.product_price,
                product_item_weight: product.product_item_weight || 1,
                product_item_quantity: product.product_item_quantity || 100,
                product_is_subscribed_to: product.product_is_subscribed_to || 0,
                product_service_offers: this.service_offers
            };

            var navi = this.$router;
            var can_submit = true;
            if (can_submit && credentials.product_name != undefined && credentials.product_item_price > 0) {
                service.addProduct(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        product = data.body.data;
                        this.data_success_message = "Processing, please wait ...";

                        this.setAddProductMedia(product);

                        this.setAddToProductAddons(product);
                        this.addToProductAddons();

                        var _self4 = this;
                        setTimeout(function () {
                            _self4.deactivate_processing();
                        }, 1800);
                    }
                });
            }
        },
        setAddProductOrderOptions: function setAddProductOrderOptions(detail) {
            detail.set_id = this.product_set_details.length + 1;

            detail.type = 69;
            detail.title = "";
            detail.detail = "Contains - " + detail.set_name;
            this.product_set_details.push(detail);

            this.set_detail = {};
        },
        removeProductOrderOptions: function removeProductOrderOptions(detail) {
            var index = this.product_set_details.findIndex(function (p) {
                return detail.set_id === p.set_id;
            });
            this.product_set_details.splice(index, 1);
        },
        setAddOrderProductItemsOptions: function setAddOrderProductItemsOptions(option) {
            option.set_id = this.product_set_items.length + 1;

            this.product_set_items.push(option);

            this.product_item = {};
        },
        removeOrderProductItemsOptions: function removeOrderProductItemsOptions(option) {
            var index = this.product_set_items.findIndex(function (p) {
                return option.set_id === p.set_id;
            });
            this.product_set_items.splice(index, 1);
        },
        setAddProductItems: function setAddProductItems() {
            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.sellpoint).length > 0 && this.product_set_items.length > 0) {
                var _iteratorNormalCompletion28 = true;
                var _didIteratorError28 = false;
                var _iteratorError28 = undefined;

                try {
                    for (var _iterator28 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.product_set_items), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
                        var _item = _step28.value;

                        this.product.product_item_price = _item.amount;
                        this.product.product_item_service_tag = _item.name;

                        this.addProductItem();
                    }
                } catch (err) {
                    _didIteratorError28 = true;
                    _iteratorError28 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion28 && _iterator28.return) {
                            _iterator28.return();
                        }
                    } finally {
                        if (_didIteratorError28) {
                            throw _iteratorError28;
                        }
                    }
                }
            }
        },
        createOrder: function createOrder() {
            var _this80 = this;

            this.activate_processing();

            var order_addons = [];

            var order_business_user_details = {
                user_id: this.user.user_id || 0,
                user_name: this.user.user_name || '',
                user_email: this.user.user_email || '',
                user_phone: this.user.user_phone || ''
            };

            var order_business_details = {
                business_id: this.sellpoint.business_id || 0,
                business_name: this.sellpoint.business_name || '',
                business_phone: this.sellpoint.business_phone || '',
                business_email: this.sellpoint.business_email || '',
                business_market_category: this.sellpoint.business_market_category || 0,
                business_category_id: this.sellpoint.business_category_id || 1
            };

            var order_item = {
                product_name: this.product.product_name || '',
                product_category: this.product.product_category || 0,
                product_price: this.product.product_price || 0,
                product_description: this.product.product_description || ''

            };

            if (this.product.set_product_addons && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.product.set_product_addons).length > 0) {
                order_addons = this.product.set_product_addons;
                console.log(1644);console.log(order_addons);
            }

            var payload = {
                order_business_user_details: order_business_user_details,
                order_business_details: order_business_details,
                order_item: order_item
            };

            service.createOrder(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    _this80.data_processing_message = "Order Created";

                    var data_set = data.body.data[0];

                    _this80.product = data_set.data_product_details;

                    _this80.product.set_product_addons = order_addons;
                    console.log(_this80.product.set_product_addons);

                    _this80.user = data_set.data_user_details;
                    localforage.setItem(service.udb_name, _this80.user).then(function (value) {}).catch(function (err) {
                        console.log(err);
                    });

                    _this80.sellpoint = data_set.data_business_details;
                    localforage.setItem(service.bdb_name, _this80.sellpoint).then(function (value) {}).catch(function (err) {
                        console.log(err);
                    });

                    _this80.setAddProductMedia(_this80.product);

                    if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this80.sellpoint).length > 0 && _this80.product_set_items.length > 0) {
                        var _iteratorNormalCompletion29 = true;
                        var _didIteratorError29 = false;
                        var _iteratorError29 = undefined;

                        try {
                            for (var _iterator29 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this80.product_set_items), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
                                var _item2 = _step29.value;

                                _this80.product_details.addProductItemToGroup = true;
                                _this80.product.product_item_price = _item2.amount;
                                _this80.product.product_item_service_tag = _item2.name;

                                _this80.addProductItem();
                            }
                        } catch (err) {
                            _didIteratorError29 = true;
                            _iteratorError29 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion29 && _iterator29.return) {
                                    _iterator29.return();
                                }
                            } finally {
                                if (_didIteratorError29) {
                                    throw _iteratorError29;
                                }
                            }
                        }
                    }

                    if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this80.sellpoint).length > 0 && _this80.product_set_details.length > 0) {
                        _this80.addProductDetails(_this80.product);
                    }

                    if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this80.product).length > 0 && _this80.product.product_ref != '') {
                        var _self5 = _this80;
                        setTimeout(function () {
                            _self5.$router.push('/set/order/' + this.product.product_ref);
                        }, 1800);
                    }
                }
            }).catch(function (err) {});
        },
        setOrderQuantity: function setOrderQuantity(type, data_set, action, product_index, product_item, product_item_index) {
            if (type == 0) {
                if (action == 'add') {
                    this.product_item.product_item_order_quantity++;
                } else if (action == 'sub') {
                    this.product_item.product_item_order_quantity--;
                }
                product_item = this.product_item;
            } else if (type == 1) {
                if (action == 'add') {
                    if (data_set == 1) {
                        this.products[product_index].product_items[product_item_index].product_item_order_quantity++;
                    } else if (data_set == 2) {
                        this.set_order_list[product_item_index].product_item_order_quantity++;
                    } else if (data_set == 3) {
                        this.set_order_addons[product_index].product_items[product_item_index].product_item_order_quantity++;
                    }
                } else if (action == 'sub') {
                    if (data_set == 1) {
                        this.products[product_index].product_items[product_item_index].product_item_order_quantity--;
                    } else if (data_set == 2) {
                        this.set_order_list[product_item_index].product_item_order_quantity--;
                    } else if (data_set == 3) {
                        this.set_order_addons[product_index].product_items[product_item_index].product_item_order_quantity--;
                    }
                }

                var _item3 = this.set_order_data.order_items.find(function (item) {
                    return item.product_item_id === product_item.product_item_id;
                });
                if (!_item3) {
                    if (data_set == 1) {
                        this.setAddOrderItems(data_set, this.products[product_index].product_items[product_item_index], product_index, product_item_index);
                    } else if (data_set == 2) {
                        this.setAddOrderItems(data_set, this.set_order_list[product_item_index], product_index, product_item_index);
                    } else if (data_set == 3) {
                        this.setAddOrderItems(data_set, this.set_order_addons[product_index].product_items[product_item_index], product_index, product_item_index);
                    }
                }

                if (data_set == 1) {
                    product_item = this.products[product_index].product_items[product_item_index];
                } else if (data_set == 2) {
                    product_item = this.set_order_list[product_item_index];
                } else if (data_set == 3) {
                    product_item = this.set_order_addons[product_index].product_items[product_item_index];
                }
            }

            if (product_item.product_item_order_quantity <= 0) {
                product_item.product_item_order_quantity = 1;
            }

            if (product_item.product_item_order_quantity > 0) {
                this.setOrderCost();
            }
        },
        setOrderDeliveryLocation: function setOrderDeliveryLocation(location) {
            if (this.set_order_data.order_delivery_option && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.set_order_data.order_delivery_option).length > 0) {
                var option = this.set_order_data.order_delivery_option;
                this.set_order_data.order_total_amount -= Number(option.business_delivery_option_price);
                this.set_order_data.order_delivery_option = {};
                this.set_order_data.order_delivery_option = location;
                if (location.business_delivery_option_price && location.business_delivery_option_price > 0) {
                    this.set_order_data.order_total_amount += Number(location.business_delivery_option_price);
                }
            } else {
                this.set_order_data.order_delivery_option = location;
                if (location.business_delivery_option_price && location.business_delivery_option_price > 0) {
                    this.set_order_data.order_total_amount += Number(location.business_delivery_option_price);
                }
            }

            this.set_order_total_amount = this.set_order_data.order_total_amount;
        },
        checkOrderProductAddons: function checkOrderProductAddons(add_product) {
            var in_arr = false;
            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.set_order_product_addons).length > 0) {
                var product = this.set_order_product_addons.find(function (product) {
                    return product.product_id === add_product.product_id;
                });
                if (product) {
                    in_arr = true;
                }
            }
            return in_arr;
        },
        checkOrderItems: function checkOrderItems(item) {
            var in_arr = false;
            if (this.set_order_data.order_items && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.set_order_data.order_items).length > 0) {
                var product_item = this.set_order_data.order_items.find(function (product_item) {
                    return product_item.product_item_id === item.product_item_id;
                });
                if (product_item) {
                    in_arr = true;
                }
            }
            return in_arr;
        },
        checkProductOrderItems: function checkProductOrderItems(product) {
            var _this81 = this;

            var count = 0;

            var _loop3 = function _loop3(set_item) {
                product_item = _this81.set_order_data.order_items.find(function (product_item) {
                    return product_item.product_item_id === set_item.product_item_id;
                });

                if (product_item) {
                    count++;
                }
            };

            var _iteratorNormalCompletion30 = true;
            var _didIteratorError30 = false;
            var _iteratorError30 = undefined;

            try {
                for (var _iterator30 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(product.product_items), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
                    var set_item = _step30.value;
                    var product_item;

                    _loop3(set_item);
                }
            } catch (err) {
                _didIteratorError30 = true;
                _iteratorError30 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion30 && _iterator30.return) {
                        _iterator30.return();
                    }
                } finally {
                    if (_didIteratorError30) {
                        throw _iteratorError30;
                    }
                }
            }

            if (count > 0) {
                return true;
            } else {
                return false;
            }
        },
        setOrderProductAddons: function setOrderProductAddons(add_product) {
            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.set_order_product_addons).length == 0) {
                this.set_order_product_addons.push(add_product);
                this.set_order_data.order_total_amount += Number(add_product.product_items[0].product_item_price);
                console.log(this.set_order_product_addons);
                console.log(this.set_order_data.order_total_amount);
            } else {
                var product = this.set_order_product_addons.find(function (product) {
                    return product.product_id === add_product.product_id;
                });
                if (!product) {
                    this.set_order_product_addons.push(add_product);
                    this.set_order_data.order_total_amount += Number(add_product.product_items[0].product_item_price);
                } else {
                    var index = this.set_order_product_addons.findIndex(function (p) {
                        return product.product_id === p.product_id;
                    });
                    this.set_order_product_addons.splice(index, 1);
                    this.set_order_data.order_total_amount -= Number(product.product_items[0].product_item_price);
                }
            }
            this.set_order_total_amount = this.set_order_data.order_total_amount;
        },
        setOrderProductItem: function setOrderProductItem(data_set, new_product_item, product_index, product_item_index) {
            this.set_order_list = this.set_order_data.order_items;

            this.setAddOrderItems(data_set, new_product_item, product_index, product_item_index);

            this.componentKey++;
        },
        setRemoveOrderProductItems: function setRemoveOrderProductItems(product_index) {
            var _this82 = this;

            var item_index = 0;

            var _loop4 = function _loop4(set_item) {
                product_item = _this82.set_order_data.order_items.find(function (product_item) {
                    return product_item.product_item_id === set_item.product_item_id;
                });

                if (product_item) {
                    var index = _this82.set_order_data.order_items.findIndex(function (p) {
                        return product_item.product_item_id === p.product_item_id;
                    });
                    _this82.set_order_data.order_items.splice(index, 1);
                    _this82.set_order_data.order_total_amount -= Number(product_item.product_item_price) * product_item.product_item_order_quantity;
                    _this82.products[product_index].product_items[item_index].product_item_order_quantity = 1;
                }
                item_index++;
            };

            var _iteratorNormalCompletion31 = true;
            var _didIteratorError31 = false;
            var _iteratorError31 = undefined;

            try {
                for (var _iterator31 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.products[product_index].product_items), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
                    var set_item = _step31.value;
                    var product_item;

                    _loop4(set_item);
                }
            } catch (err) {
                _didIteratorError31 = true;
                _iteratorError31 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion31 && _iterator31.return) {
                        _iterator31.return();
                    }
                } finally {
                    if (_didIteratorError31) {
                        throw _iteratorError31;
                    }
                }
            }

            this.set_order_total_amount = this.set_order_data.order_total_amount;
            this.set_order_list = this.set_order_data.order_items;
        },
        setAddOrderItems: function setAddOrderItems(data_set, item, product_index, product_item_index) {
            this.product_item = item;
            var product_item = {};
            if (this.set_order_data.order_items && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.set_order_data.order_items).length > 0) {
                product_item = this.set_order_data.order_items.find(function (product_item) {
                    return product_item.product_item_id === item.product_item_id;
                });

                if (product_item == undefined) {
                    item.product_index = product_index;

                    this.set_order_data.order_items.push(item);
                    this.set_order_data.order_total_amount += Number(item.product_item_price) * item.product_item_order_quantity;
                } else {
                    var index = this.set_order_data.order_items.findIndex(function (p) {
                        return product_item.product_item_id === p.product_item_id;
                    });
                    this.set_order_data.order_items.splice(index, 1);
                    this.set_order_data.order_total_amount -= Number(product_item.product_item_price) * product_item.product_item_order_quantity;

                    if (data_set == 1) {
                        this.products[product_index].product_items[product_item_index].product_item_order_quantity = 1;
                    } else if (data_set == 2) {} else if (data_set == 3) {
                        this.set_order_addons[product_index].product_items[product_item_index].product_item_order_quantity = 1;
                    }
                }
            } else {
                this.set_order_data.order_items.push(item);
                this.set_order_data.order_total_amount = Number(item.product_item_price) * item.product_item_order_quantity;
            }

            this.set_order_total_amount = this.set_order_data.order_total_amount;
            this.set_order_list = this.set_order_data.order_items;

            if (this.set_order_list.length == 0) {
                this.setMenuTabInnerView('');
            }
        },
        setItemProductOrderOptions: function setItemProductOrderOptions(option, option_index, item, item_index) {
            var option_status = this.set_order_list[item_index].product_order_options[option_index].set_status;
            if (option_status == 1) {
                this.set_order_list[item_index].product_order_options[option_index].set_status = 0;

                this.set_order_list[item_index].product_order_options[option_index].set_details = "Don't add " + option.product_info_set_name;
            } else if (option_status == 0) {
                this.set_order_list[item_index].product_order_options[option_index].set_status = 1;
                this.set_order_list[item_index].product_order_options[option_index].set_details = "";
            }
            this.componentKey++;
        },
        processMakeOrderXX: function processMakeOrderXX() {
            var order_items = [];
            this.product_item.product_name = this.product.product_name;
            this.product_item.product_item_order_quantity = 1;
            order_items.push(this.product_item);

            for (var product_index in this.product.product_addons) {
                this.product.product_addons[product_index].product_items[0].product_item_order_quantity = 1;
            }

            this.set_order_data.order_items = order_items;
        },
        setOrderCost: function setOrderCost() {
            var order_total_amount = 0;

            for (var product_index in this.set_order_data.order_items) {
                var _item4 = this.set_order_data.order_items[product_index];

                var item_order_cost = Number(_item4.product_item_price) * _item4.product_item_order_quantity;
                order_total_amount += item_order_cost;
            }

            if (this.set_order_data.order_delivery_option && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.set_order_data.order_delivery_option).length > 0) {
                var _location2 = this.set_order_data.order_delivery_option;
                if (_location2.business_delivery_option_price && _location2.business_delivery_option_price > 0) {
                    order_total_amount += Number(_location2.business_delivery_option_price);
                }
            }

            this.set_order_data.order_total_amount = order_total_amount;
            this.set_order_total_amount = this.set_order_data.order_total_amount;
        },
        setMakeOrder: function setMakeOrder(mode) {
            this.data_processing_messages = {};
            var process_order = false;
            if (mode > 0) {
                if (this.user.user_id && this.user.user_id > 0) {
                    process_order = true;
                } else {
                    this.set_order_data.order_user_details = {};
                    var payload = {
                        data_user_name: this.user.user_name || '',
                        data_user_email: this.user.user_email || '',
                        data_user_phone: this.user.user_phone || '',
                        data_user_password: this.user.user_name + this.user.user_email + this.user.user_phone
                    };
                    this.set_order_data.order_user_details = payload;
                    process_order = true;

                    if (payload.data_user_name == '') {
                        this.data_processing_messages.mode_err = "Name is empty, please provide.";
                        process_order = false;
                    }
                    if (payload.data_user_email == '' && payload.data_user_phone == '') {
                        this.data_processing_messages.mode_err = "Please provide email address or phone number.";
                        process_order = false;
                    }
                    if (mode == 1) {
                        if (payload.data_user_email == '') {
                            this.data_processing_messages.mode_err = "Please provide email address for payment processing";
                            process_order = false;
                        }
                    }
                }

                if (mode == 1) {
                    if (this.user.user_email == '') {
                        this.data_processing_messages.mode_err = "Please provide email address for payment processing";
                        process_order = false;
                    }
                }

                if (process_order) {
                    this.makeOrder(mode);
                }
            } else {
                this.data_processing_messages.mode_err = "Please select how you would like to pay";
            }
        },
        makeOrder: function makeOrder(mode) {
            var _this83 = this;

            var set_order_mode = 1;
            this.set_order_data.order_details = "";
            var set_order_user_details = this.set_order_data.order_user_details;
            var order_items = this.set_order_data.order_items;
            var set_order_delivery_option = 0;
            if (this.set_order_data.order_delivery_option && this.set_order_data.business_delivery_option_id > 0) {
                set_order_delivery_option = this.set_order_data.order_delivery_option.business_delivery_option_id;
            }

            var set_order_agent_service = 0;
            if (this.agent_is_active == 1) {
                set_order_agent_service = 1;
            }

            var payload = {
                order_business: this.sellpoint.business_id,
                order_mode: set_order_mode,
                order_user_id: this.user.user_id,
                order_agent_service: set_order_agent_service,
                order_agent_service_data: this.agent_service_order_data,
                order_items: order_items,
                order_delivery_option: set_order_delivery_option || 0,
                order_details: "",
                order_user_details: set_order_user_details
            };

            service.makeCustomOrder(this, payload).then(function (response) {
                if (response.body.status == 201) {
                    var data_id = response.body.data_id;
                    var order_data = response.body.data_order_data;
                    var order = order_data.data[0];
                    _this83.order = order;

                    if (_this83.agent_is_active == 1) {
                        _this83.user = _this83.agent_service_user_data;

                        _this83.$router.push('/agentservices');
                    } else {
                        if (response.body.data_user_details && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(response.body.data_user_details).length > 0) {
                            _this83.user = response.body.data_user_details;
                            localforage.setItem(service.udb_name, _this83.user).then(function (value) {}).catch(function (err) {
                                console.log(err);
                            });
                        }

                        _this83.$router.push('/placed/order/' + _this83.order.order_no);
                    }
                }
            }).catch(function (err) {});
        },
        makeOrderPayment: function makeOrderPayment(order_id, mode) {
            var _this84 = this;

            var payer_id = this.user.user_id;

            var payload = {
                payment_user: payer_id,
                payment_business: this.sellpoint.business_id,
                payment_by_module: 1,
                payment_by_module_id: payer_id,
                payment_to_module: 3,
                payment_to_module_id: this.sellpoint.business_id,
                payment_amount: this.set_order_data.order_total_amount,
                payment_mode: mode,
                payment_type: 0,
                payment_details: this.set_order_data.order_details,
                payment_service_type: 0,
                payment_service_module: 8,
                payment_service_module_id: order_id
            };

            if (payload.payment_amount > 0) {
                service.makeDirectPayment(this, payload).then(function (response) {
                    if (response.body.status == 201) {
                        _this84.setMenuTabInnerView('showOrderPaymentConfirmation');
                    } else {}
                }).catch(function (err) {});
            }
        },
        processPaymentRavepay: function processPaymentRavepay(data, order, mode) {
            console.log(data);
            var self = this;

            var set_subaccounts = [];

            var x = getpaidSetup({
                PBFPubKey: service.ravepay_public_test,
                customer_email: "keneinfostream@gmail.com",
                amount: 3000,
                customer_phone: data.payment_payer_phone,
                currency: "NGN",
                payment_method: "both",
                txref: data.payment_ref,
                subaccounts: set_subaccounts,
                meta: [{
                    metaname: "AFPAY",
                    metavalue: data.payment_payer_name
                }],
                onclose: function onclose() {},
                callback: function callback(response) {
                    var txref = response.tx.txRef;
                    var tx_amount = response.tx.amount;
                    if (response.tx.chargeResponseCode == "00" || response.tx.chargeResponseCode == "0") {
                        self.makeOrderPayment(order.order_id, mode);
                    } else {
                        self.payment_message = "Payment unsuccessfull. please try again or contact us";
                    }
                }
            });
        },
        getOrders: function getOrders(payload) {
            var _this85 = this;

            if (payload.user_id && payload.user_id > 0) {
                payload = payload.user_id;
            }
            service.getOrders(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this85.orders = response.body.data;
                    _this85.loading = false;
                }
            }).catch(function (err) {});
        },
        prepSetCustomAgentBusiness: function prepSetCustomAgentBusiness() {
            this.sellpoint.business_name = this.user.user_name + " " + service.app_name + " Agent Services";
            this.sellpoint.business_category_id = 52;
            this.sellpoint.business_custom_type = 10;
            this.customSetBusiness(0);
        },
        customSetBusiness: function customSetBusiness(custom_set_track) {
            var _this86 = this;

            this.activate_processing();
            var payload = {
                data_set_business: 1,
                data_set_user_data: this.user.user_id,
                business_name: this.sellpoint.business_name || this.user.user_name || '',
                business_phone: this.sellpoint.business_phone || '',
                business_email: this.sellpoint.business_email || '',
                business_market_category: this.sellpoint.business_market_category || 0,
                business_category_id: this.sellpoint.business_category_id || 1,
                business_custom_type: this.sellpoint.business_custom_type || 0
            };

            if (payload.business_name != '') {
                service.createCustomData(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        _this86.data_processing_message = "Saved Account Details";

                        _this86.sellpoint = data.body.data_business_details;
                        if (custom_set_track == 0) {
                            location.reload();
                        } else if (custom_set_track == 1) {
                            if (_this86.set_create_product == 1) {
                                _this86.customSetProduct();
                            }

                            _this86.getSellpointDetails();
                            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this86.business_bank_details).length > 0) {
                                _this86.setBankDetails();
                            }
                        }
                    }
                }).catch(function (err) {});
            } else {
                this.data_processing_message = "Business Details not set";
            }
        },
        customSetAgentServices: function customSetAgentServices(type, service_plan) {
            var _this87 = this;

            this.activate_processing();

            var set_service_plan = service_plan;

            var payload = {
                data_service: type,
                data_from_module: 3,
                data_from_module_id: this.agent_service_business_data.business_id,
                data_by_module: 1,
                data_by_module_id: this.agent_service_user_data.user_id,
                data_service_plan: set_service_plan

            };

            if (type == 1) {
                var set_user_data = 1;
                var set_user = 0;

                var set_name = this.custom_data.user_name;
                var set_email = this.custom_data.user_email;
                var set_phone = this.custom_data.user_phone;

                var business_bank_details = {
                    bank_name: this.custom_data.bank_name || '',
                    bank_account_name: this.custom_data.bank_account_name || '',
                    bank_account_number: this.custom_data.bank_account_number || ''
                };

                payload.data_set_user = set_user_data;
                payload.data_user = set_user;
                payload.user_name = set_name;
                payload.user_email = set_email;
                payload.user_phone = set_phone;
                payload.data_auto_set_business = 1;
                payload.business_name = this.custom_data.business_name || '';
                payload.business_phone = this.custom_data.business_phone || '';
                payload.business_email = this.custom_data.business_email || '';
                payload.business_market_category = this.custom_data.business_market_category || 0;
                payload.business_category_id = this.custom_data.business_category_id || 1;
                payload.business_custom_type = this.custom_data.business_custom_type || 0;
                payload.business_bank_details = business_bank_details;
                payload.business_added_by_module = 3, payload.business_added_by_module_id = this.sellpoint.business_id;
            }

            if (type == 2) {}

            if (type == 3) {}

            if (type == 4) {}

            if (type == 5) {}

            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(payload).length > 0) {
                service.customSetAgentServices(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        _this87.data_processing_message = "Successful";
                        if (type == 1) {}

                        if (type == 5) {
                            if (data.body.data_payment_details.status == 201) {
                                _this87.agent_service_order_data = data.body.data_payment_details.data;
                                _this87.setMakeOrder(1);
                            }
                        }
                    }
                }).catch(function (err) {});
            } else {
                this.data_processing_message = "";
            }
        },
        customGetAgentServices: function customGetAgentServices(type) {
            var _this88 = this;

            var payload = {
                data_module: 3,
                data_module_id: this.sellpoint.business_id,
                data_service_module: type
            };
            service.customGetAgentServices(this, payload).then(function (response) {
                _this88.agent_services_data = response.body.data;
            }).catch(function (err) {});
        },
        customGetAgentServiceActivities: function customGetAgentServiceActivities() {
            var _this89 = this;

            var payload = {
                data_module: 3,
                data_module_id: this.sellpoint.business_id
            };
            service.customGetAgentServiceActivities(this, payload).then(function (response) {
                _this89.agent_services_numbers = response.body.data_numbers;
            }).catch(function (err) {});
        },
        getCollections: function getCollections(payload) {
            var _this90 = this;

            service.getAccountCollections(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this90.earnings_balance = response.body.data_total_balance;
                }
            }).catch(function (err) {});
        },
        getAppBusinessTransactions: function getAppBusinessTransactions() {
            var _this91 = this;

            service.getAppBusinessTransactions(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this91.sellpoint_transactions.transactions = response.body.data;
                    _this91.sellpoint_transactions.transactions_total = response.body.data_total;
                    _this91.sellpoint_transactions.transactions_total_amount = response.body.data_total_amount;
                    _this91.sellpoint_transactions.transactions_total_today = response.body.data_total_today;
                    _this91.sellpoint_transactions.transactions_total_today_amount = response.body.data_total_today_amount;
                }
                _this91.componentKey++;
                _this91.loading = false;
            }).catch(function (err) {});
        },
        getAppBusinessCustomers: function getAppBusinessCustomers() {
            var _this92 = this;

            service.getAppBusinessCustomers(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this92.customers = response.body.data;
                }
            }).catch(function (err) {});
        },
        getAppMarketCircle: function getAppMarketCircle() {
            var _this93 = this;

            service.getAppMarketCircle(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this93.market_circle = response.body.data;
                }
            }).catch(function (err) {});
        },
        getAppGroup: function getAppGroup(ref) {
            this.activity.activity_module_action_type = 9;
            var data_payload = {
                data_group_ref: ref,
                data_user_id: this.user.user_id
            };
            this.activity.activity_module_data = data_payload;

            this.getActivity();

            var self = this;
            setTimeout(function () {
                localforage.getItem("activity_data_store", function (err, value) {
                    if (value != undefined) {
                        self.group = value;
                        self.componentKey++;
                        self.loading = false;
                    } else {}
                });
            }, 1000);
        },
        getAppGroups: function getAppGroups() {
            this.activity.activity_module_action_type = 8;
            var data_payload = {
                data_id: this.user.user_id
            };
            this.activity.activity_module_data = data_payload;

            this.getActivity();

            var self = this;
            setTimeout(function () {
                localforage.getItem("activity_data_store", function (err, value) {
                    if (value != undefined) {
                        self.groups = value;
                        self.componentKey++;
                        self.loading = false;
                    } else {}
                });
            }, 2000);
        },
        setTribe: function setTribe() {
            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.groups).length == 1) {
                this.group = this.groups[0];
                this.view_group_members = true;
            }
        },
        searchMember: function searchMember() {
            this.activity.activity_module_action_type = 10;
            var data_payload = {
                data_username: this.search_member.username
            };
            this.activity.activity_module_data = data_payload;

            this.getActivity();

            var self = this;
            setTimeout(function () {
                localforage.getItem("activity_data_store", function (err, value) {
                    if (value != undefined) {
                        self.display_members = value;
                        self.setMenuComponent('showDisplayMembers');
                        self.loading = false;
                    } else {}
                });
            }, 2000);
        },
        setAddMemberToGroup: function setAddMemberToGroup(member) {
            this.group_member.group = this.group.group_id, this.group_member.member_type = member.data_type, this.group_member.member_module = member.data_module, this.group_member.member_id = member.data_id, this.addMembersToGroup();
        },
        getAppSubscribers: function getAppSubscribers() {
            var _this94 = this;

            var payload = {
                sub_type: 1,
                subscribe_to_module: 3,
                subscribe_to_module_id: this.sellpoint.business_id
            };
            service.getAppSubscriptions(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this94.subscribers = response.body.data;
                    if (_this94.subscribers.length > 0) {
                        _this94.set_sub_view = "subscribers";
                    }
                }
            }).catch(function (err) {});
        },
        getAppSubscriptions: function getAppSubscriptions() {
            var _this95 = this;

            var payload = {
                sub_type: 2,
                subscriber_module: 1,
                subscriber_module_id: this.user.user_id
            };
            service.getAppSubscriptions(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this95.subscriptions = response.body.data;
                }
            }).catch(function (err) {});
        },
        updateSubscription: function updateSubscription(sub_account, sub) {
            this.activate_processing();

            localStorage.setItem("product_sub", sub.subscription_ref);
            this.$router.push(sub_account.subscribe_to_username);
        },
        getAppBusinessSubscription: function getAppBusinessSubscription() {
            var _this96 = this;

            var payload = {
                sub_type: 2,
                subscriber_module: 3,
                subscriber_module_id: this.sellpoint.business_id
            };
            service.getAppSubscriptions(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this96.business_app_subscription = response.body.data[0];

                    _this96.getAppBusinessSubscriptionOffers();
                }
            }).catch(function (err) {});
        },
        getAppBusinessSubscriptionOffers: function getAppBusinessSubscriptionOffers() {
            var _this97 = this;

            var item_id = 0;var app_id = 0;

            app_id = this.business_app_subscription.subscription_module_id;
            item_id = this.business_app_subscription.subscription_active_subscription.subscription_product_service;
            if (item_id && item_id > 0) {
                var payload = {
                    subscriber_module: 3,
                    subscriber_module_id: this.sellpoint.business_id,
                    subscribed_to_business: app_id,
                    subscribed_to_product_service: item_id,
                    subscribed_to_service_offers: [5, 6] };
                service.getAppSubscriptionOffers(this, payload).then(function (response) {
                    if (response.body.status == 200) {
                        var rdata = response.body.data;
                        _this97.$store.dispatch('account/setSellpointAppSubscriptionOffers', rdata);
                        var _self6 = _this97;

                        _this97.business_app_subscription_offers = response.body.data;
                    } else {}
                }).catch(function (err) {});
            }
        },
        setNewPost: function setNewPost(post_type, post_type_name) {
            this.post = {};
            this.post.post_products = [];
            this.post.selected_post_products = [];
            this.post.post_temp_id = Math.random();
            this.post.post_type = post_type;
            this.post.post_type_name = post_type_name;
            this.setMenuComponent('newBusinessPosts', this.sellpoint, '');
        },
        getAppBusinessPosts: function getAppBusinessPosts() {
            var _this98 = this;

            service.getXPosts(this, 2, this.sellpoint.business_id, 0, 50).then(function (response) {
                if (response.body.status == 200) {
                    _this98.posts = response.body.data;
                }
            }).catch(function (err) {});
        },
        setAttachProductToPost: function setAttachProductToPost(category) {
            this.category = category;
            this.getBusinessCategoryProducts();
            this.setMenuTabInnerView('viewProducts');
            this.attachProductsComponentKey++;
        },
        attachProductToPost: function attachProductToPost(product) {
            if (product.is_attached_to_post == this.post.post_temp_id) {
                product.is_attached_to_post = 0;
                var indexa = this.post.post_products.findIndex(function (p) {
                    return p === product.product_id;
                });
                this.post.post_products.splice(indexa, 1);
                var indexm = this.post.selected_post_products.findIndex(function (p) {
                    return p.product_id === product.product_id;
                });
                this.post.selected_post_products.splice(indexm, 1);
            } else {
                product.is_attached_to_post = this.post.post_temp_id;
                this.post.post_products.push(product.product_id);
                this.post.selected_post_products.push(product);
            }

            this.attachProductsComponentKey++;
        },
        setAddGroupPost: function setAddGroupPost() {
            if (this.group.group_posting_as_module == 3) {
                this.post.post_point_type = 2;
            } else if (this.group.group_posting_as_module == 1) {
                this.post.post_point_type = 3;
            }
            this.post.post_point_type = this.group.group_posting_as_module;
            this.post.post_point = this.group.group_posting_as_module_id;
            this.post.post_group = this.group.group_id || 0;

            this.post.post_type = 2;
            this.post.post_products = [];

            this.addNewPost();
        },
        addNewPostXX: function addNewPostXX() {
            var _this100 = this;

            this.activate_processing();

            if (this.post.post_products.length > 0) {
                this.post_has_products = 1;
            } else {
                this.post_has_products = 0;
            }
            var payload = {
                post_point_type: 2,
                post_point: this.sellpoint.business_id,
                post_type: this.post.post_type,
                post_parent: 0,
                post_title: this.post.post_title || "nil",
                post_post: this.post.post_details || "nil",
                post_start_date: this.post.post_start_date || "",
                post_end_date: this.post.post_end_date || "",
                post_product: this.post.post_product || 0,
                post_has_products: this.post_has_products || 0,
                post_products: this.post.post_products || []
            };

            var navi = this.$router;
            if (payload.gallery_post_details != undefined || payload.gallery_post_details || 'nil') {
                service.addXPosts(this, payload).then(function (data) {
                    var _this99 = this;

                    if (data.body.status == 201) {
                        (function () {
                            _this99.data_processing_message = "Post Created";

                            _this99.posts = data.body.data_posts;

                            var uploads_count = 0;
                            if (_this99.imagesFormArray.length > 0) {
                                var _iteratorNormalCompletion32 = true;
                                var _didIteratorError32 = false;
                                var _iteratorError32 = undefined;

                                try {
                                    for (var _iterator32 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this99.imagesFormArray), _step32; !(_iteratorNormalCompletion32 = (_step32 = _iterator32.next()).done); _iteratorNormalCompletion32 = true) {
                                        var imageForm = _step32.value;

                                        imageForm.append("data_id", _this99.post.post_id);
                                        imageForm.append("data_type", "post_media");
                                        service.uploadDataPhoto(_this99, imageForm).then(function (data) {
                                            if (data.body.status == 200) {
                                                uploads_count++;
                                                if (uploads_count == _this99.imagesFormArray.length) {
                                                    _this99.setMenuTabView('business', 'setBusinessPosts', _this99.sellpoint, '');
                                                    _this99.setMenuComponent('', _this99.sellpoint, '');
                                                    _this99.deactivate_processing();
                                                }
                                            }
                                        }).catch(function (err) {
                                            _this99.data_processing_message = "Media upload may have a problem";
                                            _this99.deactivate_processing();
                                        });
                                    }
                                } catch (err) {
                                    _didIteratorError32 = true;
                                    _iteratorError32 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion32 && _iterator32.return) {
                                            _iterator32.return();
                                        }
                                    } finally {
                                        if (_didIteratorError32) {
                                            throw _iteratorError32;
                                        }
                                    }
                                }
                            } else {
                                _this99.setMenuTabView('business', 'setBusinessPosts', _this99.sellpoint, '');
                                _this99.setMenuComponent('', _this99.sellpoint, '');
                                _this99.deactivate_processing();
                            }
                        })();
                    }
                }).catch(function (err) {
                    _this100.data_processing_message = "Something went wrong";
                    _this100.deactivate_processing();
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        addNewPostNotification: function addNewPostNotification() {
            var _this101 = this;

            this.activate_processing();

            var notification_has_image = 0;
            var notification_image_module = 0;
            var notification_image_module_id = 0;
            var notification_image_col = "";
            if (this.post.post_media && this.post.post_media.length > 0) {
                notification_has_image = 1;
                notification_image_module = 18;
                notification_image_module_id = this.post.post_media[0].post_media_id;
                notification_image_col = "psm_media";
            } else if (this.post.post_products && this.post.post_products.length > 0) {
                notification_has_image = 1;
                notification_image_module = 17;
                notification_image_module_id = this.post.post_products[0].product_images[0].product_image_id;
                notification_image_col = "pim_image";
            }

            var payload = {
                notification_custom_header: this.post.post_title,
                notification_custom_message: this.post.post_notification,
                notification_custom_url: "posts/" + this.post.post_url_name,
                notification_cta: 4,
                notification_has_image: notification_has_image,
                notification_image_module: notification_image_module,
                notification_image_module_id: notification_image_module_id,
                notification_image_col: notification_image_col,
                notification_type: 3,
                notification_module: 6,
                notification_module_id: this.post.post_id,
                market_business: service.apiToken,
                notify_user_id: 0,
                notify_following: 1,
                business_id: this.sellpoint.business_id
            };

            var navi = this.$router;
            if (payload.post_notification != undefined || payload.post_notification != '') {
                service.addNotifications(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_processing_message = "Notification Added";

                        this.deactivate_processing();
                        this.setMenuTabInnerView('');
                    }
                }).catch(function (err) {
                    _this101.data_processing_message = "Something went wrong";
                    _this101.deactivate_processing();
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        createGroup: function createGroup() {
            var _this102 = this;

            this.activate_processing();
            var payload = {
                group_module: 0,
                group_module_id: 0,
                group_name: this.group.group_name,
                group_description: this.group.group_description,
                group_type: this.group.group_type,
                group_created_by: this.user.user_id
            };

            var navi = this.$router;
            if (payload.group_name != undefined || payload.group_name != '' && payload.group_created_by != undefined || payload.group_created_by != 0) {
                service.createNewGroup(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_processing_message = "Group Created";

                        this.getAppGroups();
                        this.deactivate_processing();
                        this.setMenuComponent('');
                    }
                }).catch(function (err) {
                    _this102.data_processing_message = "Something went wrong";
                    _this102.deactivate_processing();
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        addMembersToGroup: function addMembersToGroup() {
            var payload_arr = [];
            var payload = {
                member_group: this.group_member.group || 0,
                member_group_module: this.group_member.group_module || 0,
                member_group_module_id: this.group_member.group_module_id || 0,
                member_type: this.group_member.member_type || 0,
                member_module: this.group_member.member_module || 1,
                member_id: this.group_member.member_id || 0
            };
            payload_arr.push(payload);
            this.addNewGroupMembers(payload_arr);
        },
        addPostToGallery: function addPostToGallery() {
            var _this104 = this;

            this.disable_btn = true;

            var credentials = {
                gallery_new_group: false,
                gallery_post_group: this.gallery.gallery_posts_group_id,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    var _this103 = this;

                    if (data.body.status == 201) {
                        toastr.success("Post Created", 'Success!');

                        this.post = data.body.data;

                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type", "gallery_media");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                _this103.setGallery();
                                _this103.gallery = data.body.data_gallery;
                                _this103.addNewPost = false;
                                _this103.edit_mode = false;
                            }
                        }).catch(function (err) {
                            if (err) {}
                            toastr.warning("Something went wrong.", 'Warning!');
                        });
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');

                        _this104.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        editLookbook: function editLookbook() {
            var _this105 = this;

            this.activate_processing();

            var credentials = {
                gallery_group_name: this.lookbook.gallery_posts_group_name,
                gallery_group_description: this.lookbook.gallery_posts_group_text,
                gallery_group_point: this.sellpoint.business_id
            };

            var navi = this.$router;
            if (credentials.gallery_group_name != undefined) {
                service.editGallery(this, this.lookbook.gallery_posts_group_id, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        this.data_processing_message = "Lookbook Edited";

                        this.deactivate_processing();
                        this.lookbook_details = {};
                    } else {
                        this.deactivate_processing();
                        this.editGalleryPanel = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this105.data_processing_message = "Something went wrong";

                        _this105.deactivate_processing();
                        _this105.lookbook_details = {};
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.disable_btn = false;
            }
        },
        deleteLookbook: function deleteLookbook() {
            var _this106 = this;

            this.activate_processing();
            var navi = this.$router;
            service.deleteGallery(this, this.lookbook.gallery_posts_group_id).then(function (data) {
                if (data.body.status == 200) {} else {
                    this.data_processing_message = "Something went wrong";
                    this.deactivate_processing();
                    this.lookbook_details = {};
                }
            }).catch(function (err) {
                if (err) {
                    _this106.deactivate_processing();
                    _this106.lookbook_details = {};
                    _this106.data_processing_message = "Something went wrong";
                }
            });
        },
        editLookbookPost: function editLookbookPost() {
            var _this107 = this;

            this.activate_processing();

            var credentials = {
                gallery_post_caption: this.lookbook_post.gallery_post_caption,
                gallery_post_details: this.lookbook_post.gallery_post_details,
                gallery_post_group: this.lookbook.gallery_posts_group_id
            };

            var navi = this.$router;
            if (credentials.gallery_post_caption != undefined) {
                service.editGalleryPost(this, this.lookbook_post.gallery_post_id, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        this.data_processing_message = "Lookbook Post Edited";

                        this.deactivate_processing();
                        this.lookbook_details = {};
                        this.lookbook = data.body.data;
                    } else {
                        this.deactivate_processing();
                        this.lookbook_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this107.data_processing_message = "Something went wrong";

                        _this107.deactivate_processing();
                        _this107.lookbook_details = {};
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        deleteLookbookPost: function deleteLookbookPost() {
            var _this108 = this;

            this.activate_processing();
            var navi = this.$router;
            service.deleteGalleryPost(this, this.lookbook_post.gallery_post_id).then(function (data) {
                if (data.body.status == 200) {
                    this.lookbook = data.body.data;
                    this.resetComponentData("lookbook");
                    this.deactivate_processing();
                    this.lookbook_details = {};
                } else {
                    this.data_processing_message = "Something went wrong";
                    this.deactivate_processing();
                    this.lookbook_details = {};
                }
            }).catch(function (err) {
                if (err) {
                    _this108.deactivate_processing();
                    _this108.data_processing_message = "Something went wrong";
                    _this108.lookbook_details = {};
                }
            });
        },
        deletePostImage: function deletePostImage(image) {
            this.activate_processing();
            var payload = {
                data_type: "gallery_media"
            };
            service.deleteImages(this, image, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.deactivate_processing();
                }
            }).catch(function (err) {});
        },
        isItemInList: function isItemInList(item) {
            var _iteratorNormalCompletion33 = true;
            var _didIteratorError33 = false;
            var _iteratorError33 = undefined;

            try {
                for (var _iterator33 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.invoice_added_items), _step33; !(_iteratorNormalCompletion33 = (_step33 = _iterator33.next()).done); _iteratorNormalCompletion33 = true) {
                    var it = _step33.value;

                    if (it.product_item_id == item.product_item_id) {
                        return true;
                    }
                }
            } catch (err) {
                _didIteratorError33 = true;
                _iteratorError33 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion33 && _iterator33.return) {
                        _iterator33.return();
                    }
                } finally {
                    if (_didIteratorError33) {
                        throw _iteratorError33;
                    }
                }
            }
        },
        addItemsToInvoice: function addItemsToInvoice(item, product_data) {
            var set_data = {
                product_id: product_data.product_id,
                product_name: product_data.product_name,
                product_images: product_data.product_images
            };
            item.product_data = set_data;
            item.order_item_order_quantity = 1;
            if (this.invoice_added_items.length == 0) {
                this.invoice_added_items.push(item);
            } else {
                var in_arr = false;
                var _iteratorNormalCompletion34 = true;
                var _didIteratorError34 = false;
                var _iteratorError34 = undefined;

                try {
                    for (var _iterator34 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.invoice_added_items), _step34; !(_iteratorNormalCompletion34 = (_step34 = _iterator34.next()).done); _iteratorNormalCompletion34 = true) {
                        var it = _step34.value;

                        if (it.product_item_id == item.product_item_id) {
                            in_arr = true;
                        }
                    }
                } catch (err) {
                    _didIteratorError34 = true;
                    _iteratorError34 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion34 && _iterator34.return) {
                            _iterator34.return();
                        }
                    } finally {
                        if (_didIteratorError34) {
                            throw _iteratorError34;
                        }
                    }
                }

                if (!in_arr) {
                    this.invoice_added_items.push(item);
                }
            }
        },
        removeItemsFromInvoice: function removeItemsFromInvoice(item) {
            var count = 0;
            var _iteratorNormalCompletion35 = true;
            var _didIteratorError35 = false;
            var _iteratorError35 = undefined;

            try {
                for (var _iterator35 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.invoice_added_items), _step35; !(_iteratorNormalCompletion35 = (_step35 = _iterator35.next()).done); _iteratorNormalCompletion35 = true) {
                    var it = _step35.value;

                    if (it.product_item_id == item.product_item_id) {
                        this.invoice_added_items.splice(count, 1);
                    }
                    count++;
                }
            } catch (err) {
                _didIteratorError35 = true;
                _iteratorError35 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion35 && _iterator35.return) {
                        _iterator35.return();
                    }
                } finally {
                    if (_didIteratorError35) {
                        throw _iteratorError35;
                    }
                }
            }
        },
        generatePaymentOrders: function generatePaymentOrders() {
            var order_items = [];
            var order_amount = 0;

            var _iteratorNormalCompletion36 = true;
            var _didIteratorError36 = false;
            var _iteratorError36 = undefined;

            try {
                for (var _iterator36 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.invoice_added_items), _step36; !(_iteratorNormalCompletion36 = (_step36 = _iterator36.next()).done); _iteratorNormalCompletion36 = true) {
                    var _item5 = _step36.value;

                    var set_item = {
                        order_item_module: 8,
                        order_item_module_id: _item5.product_item_id,
                        order_item_amount: _item5.product_item_price,
                        order_item_order_quantity: _item5.order_item_order_quantity,
                        order_module: 4,
                        order_module_id: _item5.product_data.product_id
                    };
                    order_amount = order_amount + Number(_item5.product_item_price);

                    order_items.push(set_item);
                }
            } catch (err) {
                _didIteratorError36 = true;
                _iteratorError36 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion36 && _iterator36.return) {
                        _iterator36.return();
                    }
                } finally {
                    if (_didIteratorError36) {
                        throw _iteratorError36;
                    }
                }
            }

            if (this.sellpoint.business_id > 0 && order_items.length > 0) {
                var payload = {
                    order_business: this.sellpoint.business_id,
                    order_module: 3,
                    order_module_id: this.sellpoint.business_id,
                    order_amount: order_amount,
                    order_items: order_items
                };
                service.generatePaymentOrder(this, payload).then(function (response) {
                    if (response.body.status == 201) {
                        console.log('song-gg');
                        console.log(response.body);
                    }
                }).catch(function (err) {});
            }
        },
        onFileChangePrep: function onFileChangePrep(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        },
        onFileChangeMultiplePrep: function onFileChangeMultiplePrep(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length > 0) {
                this.files_info = files;
                var _iteratorNormalCompletion37 = true;
                var _didIteratorError37 = false;
                var _iteratorError37 = undefined;

                try {
                    for (var _iterator37 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(files), _step37; !(_iteratorNormalCompletion37 = (_step37 = _iterator37.next()).done); _iteratorNormalCompletion37 = true) {
                        var file = _step37.value;

                        var formData = new FormData();
                        formData.append('photo', file);
                        this.imagesFormArray.push(formData);
                    }
                } catch (err) {
                    _didIteratorError37 = true;
                    _iteratorError37 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion37 && _iterator37.return) {
                            _iterator37.return();
                        }
                    } finally {
                        if (_didIteratorError37) {
                            throw _iteratorError37;
                        }
                    }
                }
            }
        },
        onFileChange: function onFileChange(e, type, data_id) {
            var _this109 = this;

            this.resetMessages();
            this.product_details = {};
            this.product_details.uploading_image = true;
            this.activate_processing();
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);


                this.imageForm = formData;

                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "business_category") {
                            _this109.category.business_category_image = data.body.data;
                        }

                        if (type == "products") {
                            _this109.getProductImages();
                            if (_this109.product_details.editProductItemGroup) {
                                _this109.product_item_group.product_item_group_image = data.body.data_id;
                            }
                        }

                        if (type == "product_information") {
                            _this109.getProductInformation();
                        }

                        _this109.deactivate_processing();
                    } else {
                        _this109.data_processing_message = service.upload_media_error_msg;
                        _this109.deactivate_processing();
                    }
                    _this109.product_details.uploading_image = false;
                }).catch(function (err) {
                    _this109.data_processing_message = service.upload_media_error_msg;
                    _this109.deactivate_processing();
                    _this109.product_details.uploading_image = false;
                });
            }
        },
        onFileChangeNewProduct: function onFileChangeNewProduct(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }

            document.getElementById('prImagePreview').src = window.URL.createObjectURL(files[0]);
        },
        onFileChangeProductItems: function onFileChangeProductItems(e, type, data_id) {
            var _this110 = this;

            this.activate_processing();
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);
                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "products") {
                            _this110.product.product_item_group_image = data.body.data_id;

                            _this110.getProductImages();
                        }
                    }
                }).catch(function (err) {
                    if (err) {}
                });

                this.data_media_error_message = service.media_upload_timeout_msg;
                var _self7 = this;
                setTimeout(function () {
                    _self7.data_media_error_message;
                }, 65000);
                setTimeout(function () {
                    _self7.data_media_error_message = "";
                }, 95000);
            }
        },
        processPayment: function processPayment() {
            this.data_error = {};
            this.data_processing_message = "Preparing Payment Information";

            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.app_orders.payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.app_orders.payer_phone).toLowerCase());

            if (email_test == false || this.app_orders.payer_name == " ") {
                data_test = false;
                this.data_error.email = true;
                this.data_error_message = "Please add an email to your account profile";
                this.deactivate_processing();
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                var obj = this;

                var handler = PaystackPop.setup({
                    key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.app_orders.payer_name,

                    email: this.app_orders.payer_email,
                    amount: Math.round(this.app_orders.pay_amount * 100),
                    ref: this.app_orders.pay_ref,
                    metadata: {
                        custom_fields: [{
                            display_name: "Service",
                            variable_name: "service_type",
                            value: this.app_orders.pay_service_details
                        }]
                    },

                    callback: function callback(response) {
                        obj.updatePayment(response.trxref);
                    },
                    onClose: function onClose() {
                        alert('window closed');
                    }
                });
                handler.openIframe();
            }
        },
        updatePayment: function updatePayment(payment_ref) {
            this.postBusinessProcessingFeeTransaction(payment_ref);
        },
        getRavepayBanks: function getRavepayBanks() {
            var _this111 = this;

            service.getRavepayBanks(this).then(function (response) {
                _this111.ravepay_bank_list = response.data.data.Banks;
            });
        },
        getIntegratedServices: function getIntegratedServices() {},
        getRecommendedProducts: function getRecommendedProducts() {
            var _this112 = this;

            service.getRecommendedProducts(this, this.user.user_id).then(function (response) {
                _this112.reco_products = response.body.data;;
            });
        },
        sendInboundMessages: function sendInboundMessages(type) {
            var payload = {
                contact_type: type,
                contact_from_module: 1,
                contact_from_module_id: this.user.user_id
            };

            var navi = this.$router;
            var set_payload = {};
            if (payload.contact_from_module_id != 0) {
                set_payload = payload;
            }

            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(set_payload).length > 0) {
                this.activity.activity_module_action_type = 6;

                var data_payload = {
                    data_id: this.group.ref_code
                };
                this.activity.activity_module_data = data_payload;

                this.getActivity();
            }
        },
        getProductsCard: function getProductsCard() {
            return '<div class="card col-xs-6 card-col-2" v-for="(product,index) in products" style="margin-bottom: 0.8em;"> \n              <a @click="postChatObject(product)" style="text-decoration: none; color:inherit; cursor: pointer;">\n                <!-- <span class="card-thumb-up-left"><i class="fa fa-shopping-bag"></i></span> -->\n                <div class="card-col-img" style="margin-bottom: 0.8em; border-left: #f5f5f5 solid 0.35em; border-radius: 4px;">\n                  <img v-if="product.product_images[0]" :src="product.product_images[0].product_image" class="img-responsive">\n                  <img v-else src="/static/assets/images/dummy-image.png">\n                </div>\n                <div class="card-col-details" style="display:block;">\n                  <p style="font-size:13px; text-align: center;">{{product.product_name}}<br>\n                    <span v-if="product.product_items[0]" class="sp-app-default-color">\u20A6{{product.product_items[0].product_item_price_f}}</span>\n                  </p>\n                </div>\n              </a>\n            </div>';
        },
        getProductCard: function getProductCard() {
            if (this.product.product_images[0] != undefined && this.product.product_items[0] != undefined) {
                return '<div class=\'card card-01 timeline-user-card\'> \n                        <div class="card-left">\n                            <div class="card-avatar-square">\n                            <img v-if="' + this.product.product_images[0] + '" src="' + this.product.product_images[0].product_image + '">\n                            <img v-else src="/static/assets/images/dummy-image.png">\n                            </div>\n                        </div>\n                        <div class="card-right">\n                            <div class="card-arm-line">\n                            <p>' + this.product.product_name + '<br>\n                            <span v-if="' + this.product.product_items[0] + '">\u20A6' + this.product.product_items[0].product_item_price_f + ' - ' + '\u20A6' + this.product.product_items[0].product_item_price_f + '</span>\n                            </p>\n\n                            </div>\n                    </div>';
            } else {
                return '<div class=\'card card-label\'> \n                        <div class="card-label-left">\n                            <div class="card-avatar-square">\n                            <img src="/static/assets/images/dummy-image.png">\n                            </div>\n                          </div>\n                          <div class="card-label-right">\n                            <div class="card-arm-line">\n                              <p>' + this.product.product_name + '</p>\n                         </div>\n                    </div>';
            }
        },
        setPageHeaders: function setPageHeaders() {
            window.onscroll = function () {
                var stick_header = document.getElementById("pageStickyHeader");
                if (stick_header != this.undefined || stick_header != null) {
                    var main_stick_header = document.getElementById("mainStickyHeader");
                    var head_arrow_back = document.getElementById("headTagBack");

                    var sticky = stick_header.offsetTop;

                    if (window.pageYOffset > sticky) {
                        main_stick_header.classList.add("header-main-unfix");
                        stick_header.classList.add("header-sticky-after-2");

                        stick_header.style.marginTop = "1em";
                        head_arrow_back.style.display = "block";
                        head_arrow_back.style.marginLeft = "-1em";
                        head_arrow_back.style.marginTop = "0.6em";
                    } else {
                        stick_header.classList.remove("header-sticky-after-2");
                        main_stick_header.classList.add("header-main-refix");

                        head_arrow_back.style.display = "none";
                    }
                }
            };
        },
        unsetPageHeaders: function unsetPageHeaders() {
            window.onscroll = function () {
                var stick_header = document.getElementById("pageStickyHeader");
                var main_stick_header = document.getElementById("mainStickyHeader");
                var head_arrow_back = document.getElementById("headTagBack");

                main_stick_header.classList.add("header-main-refix");
                main_stick_header.classList.add("header-sticky");
            };
        },
        getUtilities: function getUtilities() {
            var _this113 = this;

            service.getUtilities(this).then(function (response) {
                _this113.data_call_to_actions = response.body.data_call_to_actions;
                _this113.data_components_services = response.body.data_components_services;
            }).catch(function (err) {
                if (err) {}
            });
        },
        setSom: function setSom() {
            this.menu_link = {};
        },
        getUserAppData: function getUserAppData() {
            var _this114 = this;

            service.getFolders(this, 1, this.user.user_id).then(function (response) {
                var folders = response.body.data;
                var self = _this114;
                var _iteratorNormalCompletion38 = true;
                var _didIteratorError38 = false;
                var _iteratorError38 = undefined;

                try {
                    for (var _iterator38 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(folders), _step38; !(_iteratorNormalCompletion38 = (_step38 = _iterator38.next()).done); _iteratorNormalCompletion38 = true) {
                        var folder = _step38.value;

                        if (folder.folder_type == 9) {
                            var _iteratorNormalCompletion39 = true;
                            var _didIteratorError39 = false;
                            var _iteratorError39 = undefined;

                            try {
                                for (var _iterator39 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(folder.folder_items), _step39; !(_iteratorNormalCompletion39 = (_step39 = _iterator39.next()).done); _iteratorNormalCompletion39 = true) {
                                    var _item6 = _step39.value;

                                    self.saved_shops.push(_item6.folder_item_module_data);
                                }
                            } catch (err) {
                                _didIteratorError39 = true;
                                _iteratorError39 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion39 && _iterator39.return) {
                                        _iterator39.return();
                                    }
                                } finally {
                                    if (_didIteratorError39) {
                                        throw _iteratorError39;
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError38 = true;
                    _iteratorError38 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion38 && _iterator38.return) {
                            _iterator38.return();
                        }
                    } finally {
                        if (_didIteratorError38) {
                            throw _iteratorError38;
                        }
                    }
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getUsersDetails: function getUsersDetails(attr, set_data, request_type) {

            var payload = {
                search_name: attr
            };

            if (payload.search_name != '') {
                service.searchForUser(this, payload).then(function (data) {
                    if (data.body.status == 200) {
                        var user_data = data.body.data;

                        this.data_user.name = 'Okey Uwah';
                        this.data_user.email = 'okeyuwah2000@yahoo.com';
                        this.data_user.phone = '09023445677';

                        if (request_type == "get_customer_details_for_invoice_request") {
                            this.setMenuTabView('', 'selectItemsForInvoice');
                        }
                    } else if (data.body.status == 404) {
                        this.data_error_message = "Could not find any matching Customer , please check the data you entered and try again";
                    }
                }).catch(function (err) {});
            }
        },
        setAppBusinessSubscriptionOffersXX: function setAppBusinessSubscriptionOffersXX(service_offer) {
            var offer_set = this.$store.getters['account/getSellpointAppSubscriptionOffers'];
            this.business_app_subscription_offers = offer_set;
            var _iteratorNormalCompletion40 = true;
            var _didIteratorError40 = false;
            var _iteratorError40 = undefined;

            try {
                for (var _iterator40 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.business_app_subscription_offers), _step40; !(_iteratorNormalCompletion40 = (_step40 = _iterator40.next()).done); _iteratorNormalCompletion40 = true) {
                    var offer = _step40.value;

                    if (offer.service_offer == service_offer) {
                        return offer;
                    }
                }
            } catch (err) {
                _didIteratorError40 = true;
                _iteratorError40 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion40 && _iterator40.return) {
                        _iterator40.return();
                    }
                } finally {
                    if (_didIteratorError40) {
                        throw _iteratorError40;
                    }
                }
            }
        },
        setSiteUser: function setSiteUser() {
            this.getSellpoints(this.user.user_id);
        },
        resetUser: function resetUser(payload) {
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;

                    if (payload.data_user_is_agent && payload.data_user_is_agent == 1) {
                        self.user.user_is_agent = 1;
                    }

                    if (payload.data_user_agent_business_data && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(payload.data_user_agent_business_data).length > 0) {
                        self.user.user_agent_business_data = payload.data_user_agent_business_data;
                    }
                    if (payload.data_user_agent_user_data && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(payload.data_user_agent_user_data).length > 0) {
                        self.user.user_agent_user_data = payload.data_user_agent_user_data;
                    }

                    localforage.setItem(service.udb_name, self.user).then(function (value) {}).catch(function (err) {
                        console.log(err);
                    });
                }
            });
        },
        setGetAppBusiness: function setGetAppBusiness(business_username, set_redir) {
            var _this115 = this;

            console.log('song-0010');
            service.getAppBusinessByUserName(this, business_username).then(function (response) {
                if (response.body.status == 200) {
                    console.log('song-0011');
                    var payload = response.body.data;
                    _this115.$store.dispatch('account/setBusiness', payload);
                    _this115.componentKey++;

                    if (set_redir == 1) {
                        var _self8 = _this115;
                        localforage.getItem(_self8.getService.adr_db_name, function (err, value) {
                            if (value != undefined && value.link != "/account") {
                                console.log(5988 + value.link);
                                _self8.$router.push(value.link);
                            } else {
                                console.log(6988);
                                _self8.$router.push("/account/business");
                            }
                        });
                    } else {
                        location.reload(true);
                    }
                }
            }).catch(function (err) {});
        },
        storeSetBusiness: function storeSetBusiness(business_username, set_type) {
            var load = false;
            var set_business_username = business_username;

            if (set_type == 1) {
                console.log('song-006');

                load = true;
                this.setGetAppBusiness(set_business_username, 1);
            } else {
                console.log('song--008');

                var _self9 = this;
                localforage.getItem('xvue', function (err, value) {
                    if (value != undefined) {
                        console.log('song-009');
                        var current_sellpoint = value.account.store_sellpoint.store_sellpointData;
                        if (!current_sellpoint || current_sellpoint == undefined) {
                            var sellpoints = _self9.$store.getters['account/getUserBusinesses'];
                            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(sellpoints).length > 0) {
                                set_business_username = sellpoints[0].business_username;
                            }

                            load = true;
                            _self9.setGetAppBusiness(set_business_username, 2);
                        } else {}
                    } else {
                        _self9.$router.push("/account");
                    }
                });
            }
        },
        loadUser: function loadUser() {
            var self = this;
            localforage.getItem('xvue', function (err, value) {
                if (value != undefined) {
                    self.user = value.account.store_sellpoint.store_user;
                } else {}
            });
        },
        loadBusiness: function loadBusiness() {
            var self = this;
            localforage.getItem('xvue', function (err, value) {
                if (value != undefined) {
                    self.sellpoint = value.account.store_sellpoint.store_sellpointData;
                } else {}
            });
        },
        loadCategories: function loadCategories() {
            var self = this;
            localforage.getItem('xvue', function (err, value) {
                if (value != undefined) {
                    self.categories = value.account.store_sellpoint.store_sellpointData.business_categories;

                    self.sellpoint.business_categories = value.account.store_sellpoint.store_categories;
                } else {}
                self.loading = false;
            });
        },
        loadCategory: function loadCategory() {
            var self = this;
            localforage.getItem('xvue', function (err, value) {
                if (value != undefined) {
                    self.category = value.account.store_sellpoint.store_category;
                } else {}
            });
        },
        loadProducts: function loadProducts() {
            var self = this;
            self.loading = true;
            localforage.getItem('xvue', function (err, value) {
                if (value != undefined) {
                    self.products = value.account.store_sellpoint.store_products;
                } else {}
                self.loading = false;
            });
        },
        loadAccountBase: function loadAccountBase() {
            this.loading = true;
            var self = this;
            this.user = this.$store.getters['account/getUser'];

            if (this.user == undefined || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.user).length == 0) {
                localforage.getItem(service.udb_name, function (err, value) {
                    if (value != undefined) {
                        self.user = value;

                        self.loadSetUser(self.user.user_id);

                        self.loading = false;localforage.setItem(service.udb_name, this.user).then(function (value) {}).catch(function (err) {
                            console.log(err);
                        });
                    } else {
                        var request_data = {};
                        localforage.getItem(service.adr_db_name, function (err, value) {
                            if (value != undefined) {
                                request_data = value;
                            } else {
                                var request_data = {
                                    "name": "Account",
                                    "link": "/account",
                                    "dir": "/account",
                                    "src": "/account",
                                    "msg": "Login to manage your account",
                                    "track": 1 };
                            }

                            localforage.setItem(service.adr_db_name, request_data).then(function (value) {}).catch(function (err) {});

                            self.$router.push('/login');
                        });
                    }
                });
            } else {
                if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.user).length > 0) {
                    this.loading = false;
                    this.loadSetUserDetails();
                } else {
                    this.$router.push('/login');
                }
            }
        },
        loadSetUser: function loadSetUser(user_id) {
            this.$store.dispatch('account/setUserData', user_id);

            var self = this;console.log('song-00');
            setTimeout(function () {
                if (self.user.user_id > 0) {
                    console.log('song--01');
                    self.loadSetUserBusinesses();
                }
            }, 3000);
        },
        loadGetUserXX: function loadGetUserXX() {
            if (this.loadSetUser) {
                if (this.user.user_id > 0) {
                    this.loadSetUserBusinesses();
                } else {}
            }
        },
        loadSetUserDetails: function loadSetUserDetails() {
            this.loadSetUserBusinesses();
        },
        loadSetUserBusinesses: function loadSetUserBusinesses() {
            if (this.user.user_id > 0) {
                this.$store.dispatch('account/userAccountBusinesses', this.user.user_id);
                var _self10 = this;console.log('song-003');
                setTimeout(function () {
                    _self10.loadGetUserBusinesses();
                }, 3000);
            }
        },
        loadGetUserBusinesses: function loadGetUserBusinesses() {
            console.log('song-004');

            var self = this;
            localforage.getItem('xvue', function (err, value) {
                if (value != undefined) {
                    console.log('song-004-a');
                    self.sellpoints = value.account.store_sellpoints;
                    if (self.sellpoints != null && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(self.sellpoints).length > 0) {
                        console.log('song--005');
                        self.storeSetBusiness('', 0);
                        self.loading = false;
                    }
                } else {
                    console.log('song-004-b');
                    location.reload(true);
                }
            });
        }
    },

    created: function created() {
        this.getStates();
        this.getUtilities();
        this.getCategories();

        this.is_product_service = "product";
    }

});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(413)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(624),
  /* scopeId */
  "data-v-bd93932e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(532),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(577),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(390)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(600),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_USER_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ALL_SELLPOINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ALL_SELLPOINTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USER_SELLPOINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return USER_SELLPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return USER_SELLPOINT_APP_SUB_OFFERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return USER_SELLPOINT_SHIPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return USER_SELLPOINT_DISCOUNTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_SELLPOINT_CATEGORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RESET_SELLPOINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return USER_SELLPOINT_CATEGORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return USER_SELLPOINT_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return USER_SELLPOINT_CATEGORY_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return USER_SELLPOINT_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return USER_SELLPOINT_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ALL_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ALL_PRODUCTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return PRODUCT_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return PRODUCT_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return VIEW_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ADD_TO_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return REMOVE_FROM_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ERROR_MSG; });
/* unused harmony export SUCCESS_MSG */
var SET_USER_DATA = 'SET_USER_DATA';

var ALL_SELLPOINTS = 'ALL_SELLPOINTS';
var ALL_SELLPOINTS_SUCCESS = 'ALL_SELLPOINTS_SUCCESS';
var USER_SELLPOINTS = 'USER_SELLPOINTS';
var USER_SELLPOINT = 'USER_SELLPOINT';
var USER_SELLPOINT_APP_SUB_OFFERS = 'USER_SELLPOINT_APP_SUB_OFFERS';
var USER_SELLPOINT_SHIPPING = 'USER_SELLPOINT_SHIPPING';
var USER_SELLPOINT_DISCOUNTS = 'USER_SELLPOINT_DISCOUNTS';
var SET_SELLPOINT_CATEGORIES = 'SET_SELLPOINT_CATEGORIES';
var RESET_SELLPOINTS = 'RESET_SELLPOINTS';

var USER_SELLPOINT_CATEGORIES = 'USER_SELLPOINT_CATEGORIES';
var USER_SELLPOINT_CATEGORY = 'USER_SELLPOINT_CATEGORY';

var USER_SELLPOINT_CATEGORY_PRODUCTS = 'USER_SELLPOINT_CATEGORY_PRODUCTS';
var USER_SELLPOINT_PRODUCTS = 'USER_SELLPOINT_PRODUCTS';
var USER_SELLPOINT_PRODUCT = 'USER_SELLPOINT_PRODUCT';
var ALL_PRODUCTS = 'ALL_PRODUCTS';
var ALL_PRODUCTS_SUCCESS = 'ALL_PRODUCTS_SUCCESS';

var PRODUCT_BY_ID = 'PRODUCT_BY_ID';
var PRODUCT_BY_ID_SUCCESS = 'PRODUCT_BY_ID_SUCCESS';

var VIEW_CART = 'VIEW_CART';
var ADD_TO_CART = 'ADD_TO_CART';
var REMOVE_FROM_CART = 'REMOVE_FROM_CART';

var ERROR_MSG = 'ERROR_MSG';
var SUCCESS_MSG = 'SUCCESS_MSG';

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: "validate_array",
        value: function validate_array(str_array, error_msg) {
            var process_errors = [];

            var reg_num = /^[0-9]+$/;
            var reg_name = /^[\w\-\s]+$/;
            var reg_email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var reg_phone = /^\d{4}\d{3}\d{4}$/;

            for (var i = 0; i < str_array.length; i++) {
                var arr_in_str_array = str_array[i];
                if (arr_in_str_array[1] == undefined || arr_in_str_array[1] == "") {
                    process_errors.push(error_msg + arr_in_str_array[0]);

                    if (arr_in_str_array[2] == "alpha") {
                        if (!reg_name.test(arr_in_str_array[1])) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }

                    if (arr_in_str_array[2] == "num") {
                        if (!reg_num.test(arr_in_str_array[1])) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }

                    if (arr_in_str_array[2] == "email") {
                        if (!reg_email.test(String(arr_in_str_array[1]).toLowerCase())) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }

                    if (arr_in_str_array[2] == "phone") {
                        if (!reg_phone.test(arr_in_str_array[1])) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }
                }
            }

            return process_errors;
        }
    }, {
        key: "validateEmail",
        value: function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
    }, {
        key: "validateName",
        value: function validateName(name) {
            var re = /^[\w\-\s]+$/;
            return re.test(name);
        }
    }, {
        key: "validatePhoneNumber",
        value: function validatePhoneNumber(phone) {
            var re = /^\d{4}\d{3}\d{4}$/;
            return re.test(phone);
        }
    }, {
        key: "validateString",
        value: function validateString(str) {
            var re = /^\s*$/;
            var result = false;
            if (!re.test(str)) {
                result = true;
            }
            return result;
        }
    }, {
        key: "validateWebsite",
        value: function validateWebsite(url) {
            var re = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
            return re.test(url);
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_validation__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__activity__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__setts__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__capacitor_core__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__capacitor_push_notifications__ = __webpack_require__(105);










var service = new __WEBPACK_IMPORTED_MODULE_2__services_service__["a" /* default */]();
var validator = new __WEBPACK_IMPORTED_MODULE_3__services_validation__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Settings',
    mixins: [__WEBPACK_IMPORTED_MODULE_4__activity__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__setts__["a" /* default */]],
    data: function data() {
        return {
            app_name: service.app_name,

            users: {},
            user: {},
            states: {},
            cities: {},

            discount_coupon: {},
            discount_coupon_is_gift_card: false,
            discount_coupon_is_direct: false,
            discount_coupon_is_private: false,

            action_procs: {},
            action_verified: {},
            action_checking: {},

            error_messages: {},

            data_validated: false,
            formComponentKey: 0
        };
    },


    methods: {
        getStates: function getStates() {
            service.getStates(this).then(function (data) {
                this.states = data.body;
            });
        },
        getCities: function getCities(state) {
            service.getCities(this, state).then(function (data) {
                this.cities = data.body;
            });
        },
        validateEmail: function validateEmail(data_attr_value) {
            if (data_attr_value != '' && data_attr_value != undefined) {
                this.error_messages.email = "";
                if (validator.validateEmail(data_attr_value)) {
                    this.validateData("user", "email", data_attr_value);
                } else {
                    this.error_messages.email = "Email is not valid";
                }

                this.formComponentKey++;
            }
        },
        validatePhone: function validatePhone(data_attr_value) {
            if (data_attr_value != '' && data_attr_value != undefined) {
                this.error_messages.phone = "";
                if (validator.validatePhoneNumber(data_attr_value)) {
                    this.validateData("user", "phone", data_attr_value);
                } else {
                    this.error_messages.phone = "Phone Number is not valid";
                    this.user.phone = "";
                }
                this.formComponentKey++;
            }
        },
        validateUsername: function validateUsername(data_attr_value) {
            if (data_attr_value != '' && data_attr_value != undefined) {
                this.error_messages.username = "";
                if (validator.validateString(data_attr_value)) {
                    this.validateData("user", "username", data_attr_value);
                } else {
                    this.error_messages.username = "Username is not valid";
                }
                this.form2ComponentKey++;
            }
        },
        validateData: function validateData(data_type, data_attr, data_attr_value) {
            this.disable_btn = true;
            this.action_checking[data_attr] = true;
            var credentials = {
                data_type: data_type,
                data_attr: data_attr,
                data_attr_value: data_attr_value
            };
            service.validateDataExist(this, credentials).then(function (data) {
                if (data.body.status == 200) {
                    this.action_checking[data_attr] = false;
                    this.action_verified[data_attr] = true;
                    this.data_validated = true;
                } else {
                    this.action_checking[data_attr] = '';
                    this.action_verified[data_attr] = false;
                    this.error_messages[data_attr] = data.body.message;
                }
                this.disable_btn = false;
                this.formComponentKey++;
            });
            this.formComponentKey++;
        },
        validateDataXXX: function validateDataXXX(data_type, data_attr) {
            this.disable_btn = true;
            var data_attr_value = '';
            if (data_attr == 'email') {
                data_attr_value = this.user.email;
                this.action_checking.email = true;
            } else if (data_attr == 'phone') {
                data_attr_value = this.user.phone;
            } else if (data_attr == 'username') {
                data_attr_value = this.user.username;
            }
            this.action_checking[data_attr] = true;
            var credentials = {
                data_type: data_type,
                data_attr: data_attr,
                data_attr_value: data_attr_value
            };
            service.validateDataExist(this, credentials).then(function (data) {
                if (data.body.status == 200) {
                    this.action_checking[data_attr] = false;
                    this.action_verified[data_attr] = true;
                    this.data_validated = true;
                } else {
                    this.action_checking[data_attr] = false;
                    this.error_messages[data_attr] = data.body.message;
                }
                this.formComponentKey++;
                this.disable_btn = false;
            });
            this.formComponentKey++;
        },
        setDiscountsAndCoupons: function setDiscountsAndCoupons() {
            var _this = this;

            this.activate_processing();
            this.data_processing_message = "";

            if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                this.discount_coupon.discount_category = 1;
            }

            var entry_arr = [["Discount or Coupon", this.discount_coupon.is_discount_coupon, "str"], ["Coupon Percentage", this.discount_coupon.discount_percentage, "num"], ["Discount Category", this.discount_coupon.discount_category, "num"], ["Start Date", this.discount_coupon.discount_start_date, "date"], ["End Date", this.discount_coupon.discount_end_date, "date"]];
            var validated_arr = validator.validate_array(entry_arr, "Please fill in ");
            if (validated_arr.length == 0) {
                var start_date = new Date(this.discount_coupon.discount_start_date);
                var end_date = new Date(this.discount_coupon.discount_end_date);
                if (end_date <= start_date) {
                    this.data_processing_message = "Please reset Dates, End Date should be greater than Start Date";
                    this.deactivate_processing();
                } else {
                    var discount_category = 0;
                    if (this.business_details.setDiscount) {
                        discount_category = this.discount_coupon.discount_category;
                    }

                    var product_id = 0;
                    var product_item_id = 0;

                    if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                        product_id = this.product.product_id;
                    }
                    if (this.product_details.setProductItemDiscount) {
                        product_item_id = this.product_item.product_item_id;
                    }

                    var coupon_style_type = 0;
                    if (this.discount_coupon_is_gift_card) {
                        coupon_style_type = 36;
                    }

                    var coupon_is_specific_use = 0;
                    if (this.discount_coupon_is_direct) {
                        coupon_is_specific_use = 1;
                    }

                    var coupon_is_private = 0;
                    if (this.discount_coupon_is_private) {
                        coupon_is_private = 1;
                    }

                    var payload = {
                        business_id: this.sellpoint.business_id,
                        business_market: service.apiToken,
                        product_id: product_id,
                        product_item_id: product_item_id,
                        is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'C',
                        coupon_business_category: discount_category,
                        coupon_style_type: coupon_style_type,
                        coupon_is_private: coupon_is_private,
                        coupon_is_specific_use: coupon_is_specific_use,
                        coupon_for_account: this.discount_coupon.discount_username,
                        coupon_description: this.discount_coupon.discount_description || "NIL",
                        coupon_percentage: this.discount_coupon.discount_percentage,
                        coupon_min_amount: this.discount_coupon.discount_min_amount || 0,
                        coupon_min_quantity: this.discount_coupon.discount_min_quantity,
                        coupon_start_date: this.discount_coupon.discount_start_date,
                        coupon_end_date: this.discount_coupon.discount_end_date
                    };
                    service.setDiscountsAndCoupons(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            this.business_details.setDiscount = false;
                            this.business_details.viewDiscounts = true;
                            this.discount_coupon_is_gift_card = false;
                            if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                                var res = data.body.data;
                                var _iteratorNormalCompletion = true;
                                var _didIteratorError = false;
                                var _iteratorError = undefined;

                                try {
                                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.product.product_items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                        var item = _step.value;
                                        var _iteratorNormalCompletion2 = true;
                                        var _didIteratorError2 = false;
                                        var _iteratorError2 = undefined;

                                        try {
                                            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(res), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                                var row = _step2.value;

                                                if (row.product_item_id == item.product_item_id) {
                                                    item.product_item_discounts = row.product_item_discounts;
                                                }
                                            }
                                        } catch (err) {
                                            _didIteratorError2 = true;
                                            _iteratorError2 = err;
                                        } finally {
                                            try {
                                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                                    _iterator2.return();
                                                }
                                            } finally {
                                                if (_didIteratorError2) {
                                                    throw _iteratorError2;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return) {
                                            _iterator.return();
                                        }
                                    } finally {
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }

                                if (this.product_details.setProductDiscount) {
                                    this.product.product_only_coupon_discount_count++;
                                }
                                if (this.product_details.setProductItemDiscount) {
                                    this.product_item.product_item_only_coupon_discount_count++;
                                }
                            } else {
                                this.sellpoint.business_discounts_coupons = data.body.data_business;

                                this.$store.dispatch('account/setBusinessDiscounts', this.sellpoint.business_discounts_coupons);
                            }
                            this.deactivate_processing();
                            this.product_details = {};
                        }
                    }).catch(function (err) {
                        _this.deactivate_processing();
                    });
                }
            } else {
                validated_arr.forEach(function (error) {
                    this.data_processing_message = this.data_processing_message + " . " + error;
                }, this);
                this.deactivate_processing();
            }
        },
        routeNotification: function routeNotification(notification) {
            console.log('solidd==889', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(notification));
            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(notification.data));
            var redir = notification.data.action;
            if (redir != undefined && redir != '') {
                this.$router.push(redir);
            } else {
                this.$router.push('/register');
            }
        },
        sendAppToken: function sendAppToken(token) {
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                }
                console.log('u7888');

                var payload = {
                    token: token,
                    user: self.user.user_id || 0,
                    app: service.market_app_name,
                    app_temp_co_share: service.market_app_temp_co_share
                };
                if (payload.token != undefined && payload.app_token != '') {
                    service.sendAppToken(self, payload).then(function (data) {
                        console.log(payload.user);
                        if (data.body.status == 201) {
                            console.log("App Token Sent To Server");
                        } else {
                            console.log("App Token NOT Sent To Server");
                        }
                    }).catch(function (err) {
                        console.log("App Token Server ERROR: " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err));
                    });
                }
            });
        },
        setPushNotification: function setPushNotification() {
            var _this2 = this;

            var isPushNotificationsAvailable = __WEBPACK_IMPORTED_MODULE_6__capacitor_core__["a" /* Capacitor */].isPluginAvailable('PushNotifications');

            if (isPushNotificationsAvailable) {
                var promises = [];
                for (var i = 0; i < 7; ++i) {
                    if (i == 1) {
                        console.log('wwkkk-0999');
                        __WEBPACK_IMPORTED_MODULE_7__capacitor_push_notifications__["PushNotifications"].register();
                        __WEBPACK_IMPORTED_MODULE_7__capacitor_push_notifications__["PushNotifications"].addListener('registration', function (token) {
                            console.info('Registration token: ', token.value);

                            _this2.sendAppToken(token.value);
                        });
                    }
                    if (i == 2) {
                        __WEBPACK_IMPORTED_MODULE_7__capacitor_push_notifications__["PushNotifications"].addListener('registrationError', function (err) {
                            console.error('Registration error: ', err.error);
                        });
                    }
                    if (i == 3) {
                        __WEBPACK_IMPORTED_MODULE_7__capacitor_push_notifications__["PushNotifications"].addListener('pushNotificationReceived', function (notification) {
                            console.log('Push notification received: ', notification);
                            console.log('kkkk-1010Push notification received', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(notification));
                            console.dir(notification);
                        });
                    }
                    if (i == 4) {
                        __WEBPACK_IMPORTED_MODULE_7__capacitor_push_notifications__["PushNotifications"].addListener('pushNotificationActionPerformed', function (notification) {
                            console.log('Push notification action performed', notification.actionId, notification.inputValue);

                            console.log('kkkk-1010Push notification performed', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(notification.notification));
                            _this2.routeNotification(notification.notification);
                        });
                    }
                    if (i == 5) {
                        var permStatus = __WEBPACK_IMPORTED_MODULE_7__capacitor_push_notifications__["PushNotifications"].checkPermissions();

                        if (permStatus.receive === 'prompt') {
                            permStatus = __WEBPACK_IMPORTED_MODULE_7__capacitor_push_notifications__["PushNotifications"].requestPermissions();
                        }

                        if (permStatus.receive !== 'granted') {
                            throw new Error('User denied permissions!');
                        }
                    }
                    if (i == 6) {
                        console.log('77-kkk-0999');
                    }
                }
            }
        }
    },
    created: function created() {}
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Settings',
    data: function data() {
        return {
            disable_btn: false,
            action_loading: false,
            copied: false,

            site_view: 1 };
    },


    methods: {
        back: function back() {
            window.history.back();
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        formatCurrency: function formatCurrency(currency) {
            currency = Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(currency);
            currency = currency.replace("₦", "");
            currency = currency.replace("NGN", "");
            return currency;
        },
        formatCurrency_2: function formatCurrency_2(currency) {
            currency = Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(currency);
            currency = currency.replace("₦", "");
            currency = currency.replace("NGN", "");
            currency = currency.replace(".00", "");
            currency = currency.replace(" ", "");
            return currency;
        },
        copyLink: function copyLink(link, id) {
            this.$clipboard(link);
            this.copied = true;
            document.getElementById(id).style.display = "block";
        },
        toggleSingleComponent: function toggleSingleComponent(component) {
            var toggle = document.getElementById(component).style.display;
            if (toggle == "block") {
                document.getElementById(component).style.display = "none";
            } else {
                document.getElementById(component).style.display = "block";
            }
        },
        screenFunction: function screenFunction(x) {
            if (x.matches) {
                this.site_view = 1;
            } else {
                this.site_view = 2;
            }
        }
    },
    created: function created() {}
});

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_validation__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__resources_commons_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_templates_account_menu_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_templates_account_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_templates_account_menu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonfunctions__ = __webpack_require__(3);










var service = new __WEBPACK_IMPORTED_MODULE_2__services_service__["a" /* default */]();
var validator = new __WEBPACK_IMPORTED_MODULE_3__services_validation__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Account',
    mixins: [__WEBPACK_IMPORTED_MODULE_4__resources_commons_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__commonfunctions__["a" /* default */]],
    data: function data() {
        var _ref;

        return _ref = {
            kip: 0,
            user: {},
            sellpoints: {},
            sellpoint: {},
            business: {},
            products: {},
            product: {},
            product_item_group: {},
            product_item: {},
            categories: {},
            category: {},
            main_category: {},
            sub_categories: [],
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            sellpoint_gallery: {},
            galleria: {},
            lookbooks: {},
            lookbook: {},
            lookbook_post: {},
            menu_view: {},
            menu_tab_view: {},
            menu_tab_inner_view: {},
            is_view: "",
            is_viewing: "Account",
            is_viewed: "Account",
            is_view_type: "Account",
            img_url: service.imageURL,
            server_query_done: false,
            setPanel: false,
            loading: true,
            action_loading: false,
            disable_btn: false,
            data_processing_message: "",
            data_error_message: "",
            data_success_message: "",
            data_media_error_message: "",
            max_media_info: service.max_upload_image_info,
            max_plan_lookbooks: 0,
            max_plan_lookbook_posts: 0,
            total_lookbooks_added: 0,
            can_add_more_lookbook: false,
            can_add_product_lookbook: false,
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            setSettings: false,
            setting_details: {},

            states: {},
            cities: {},
            dvco_cities: {},
            delivery_partners: {},
            delivery_option: {},
            other_delivery_option: false,
            edit_other_delivery_option: false,
            custom_delivery_option: false,
            set_dvco_delivery_option: false,
            delivery_custom_options: {},
            component_view: { viewProducts: true, viewProduct: false, viewLookbooks: true, viewLookbook: false, viewLookbookPost: false },
            business_details: { delivery_edit: false, delivery_add: false, delivery_option_edit: false, viewDiscounts: true, setDiscount: false },
            product_details: {},
            lookbook_details: {},
            manageList: ["manageBusinesses", "manageProducts", "manageServices", "manageLookbooks"],
            manage: ["manageBusinesses", "manageProducts", "manageServices", "manageLookbooks"],
            discount_coupon: {},
            discount_coupon_is_gift_card: false,
            discount_coupon_is_direct: false,
            managePanel: false,
            manageBusinesses: true,
            manageProducts: false,
            manageServices: false,
            manageLookbooks: false,
            managePosts: false,
            manageOrders: false,
            manageBusinessDetails: false,
            businessComponents: ["BusinessEditing", "BusinessDeliveryShipping", "BusinessCoupons", "BusinessPaymentGateway"],
            business_set_shipping_fee_status: 9,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            product_set_shipping_fee_status: 12,
            set_shipping_fee_status_track: false,

            business_agent: 0,
            business_open_agents_products: {},
            business_product_categories: [],
            business_service_categories: [],
            business_category_type: 0,
            validate_user_name_error: false,
            validate_user_name_message: "",

            product_display_image: {}
        }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'product_item', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'file_info', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'files_info', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'imageForm', ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'imagesFormArray', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'is_product_service', "product"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'max_upload', service.max_media_upload), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'show_product_setting_box', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'showProductItemGroups', ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'tap_01', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'viewing_lookbook', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'viewing_lookbook_post', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'is_viewing_lookbook', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'post', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'posts', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'viewPost', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'group', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'groups', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'view_group_members', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'share_group', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'current_sellpoint_id', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'market_groups', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'app_orders', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'order', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'viewOrder', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'viewPendingPayOrder', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'viewPendingPayOrders', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'sellpoint_orders', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'sellpoint_pending_orders', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'sellpoint_transactions', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'processing_fee', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'payment_gateways', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'ravepay_bank_list', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'ravepay_sba', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'set_reward_type_amount_type', "C"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'product_is_wholesale', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'prdItemPriceKey', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'prdItemWholesaleKey', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'businessComponentKey', 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'orderComponentKey', 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'productVariationComponentKey', 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'productOrdersComponentKey', 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'attachProductsComponentKey', 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'deliveryAddByDcoKey', 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'user_settings', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'broker_deal', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'broker_request', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'broker_deals', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'broker_requests', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'market_circle', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'subscriptions', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'subscribers', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'set_sub_view', 'subscriptions'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'set_order_pending_payment_data', ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'set_pending_payment_data', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'service_duration', ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'service_offers', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'service_offer', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'data_call_to_actions', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'data_components_services', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'component_loading', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'set_menu', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'menu_link', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'back_link_view', 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'prev_menu_link', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'current_menu_link', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'prev_menu_tab_view', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'current_menu_tab_view', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'customers', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'reco_products', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'has_sellpoints', true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'productAddView02ComponentKey', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'active_group', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'saved_shops', []), _ref;
    },


    components: {
        'component-footer': __WEBPACK_IMPORTED_MODULE_6__MainFooter_index_vue___default.a,
        'component-account-menu': __WEBPACK_IMPORTED_MODULE_7__components_templates_account_menu_vue___default.a
    },

    methods: {
        toggleMenu: function toggleMenu() {
            if (this.set_menu == false) {
                this.set_menu = true;
            } else if (this.set_menu == true) {
                this.set_menu = false;
            }
        },
        presetDEPRAC: function presetDEPRAC() {
            this.loading = true;
            var self = this;
            this.user = this.$store.getters['account/getUser'];

            if (this.user == undefined || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user).length == 0) {
                localforage.getItem(service.udb_name, function (err, value) {
                    if (value != undefined) {
                        self.user = value;

                        self.setUser(self.user.user_id);

                        self.loading = false;
                    } else {
                        localforage.getItem(service.adr_db_name, function (err, value) {
                            if (value != undefined) {
                                self.redir = value.link;
                            } else {
                                var request_data = {
                                    "name": "Account",
                                    "link": "/account",
                                    "dir": "/account",
                                    "src": "/account",
                                    "msg": "Login to manage your account",
                                    "track": 1 };
                                localforage.setItem(service.adr_db_name, request_data).then(function (value) {}).catch(function (err) {});
                            }

                            self.$router.push('/login');
                        });
                    }
                });
            } else {
                if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user).length > 0) {
                    this.loading = false;
                    this.setUserDetails();
                } else {
                    this.$router.push('/login');
                }
            }
        },
        setUserDEPRAC: function setUserDEPRAC(user_id) {
            this.$store.dispatch('account/setUserData', user_id);

            var self = this;
            setTimeout(function () {
                self.getUser();
            }, 3000);
        },
        getUserDEPRAC: function getUserDEPRAC() {
            if (this.loadUser) {
                if (this.user.user_id > 0) {
                    this.setUserBusinesses();
                } else {}
            }
        },
        setUserDetailsDEPRAC: function setUserDetailsDEPRAC() {
            this.setUserBusinesses();
        },
        setUserBusinessesDEPRAC: function setUserBusinessesDEPRAC() {
            if (this.user.user_id > 0) {
                this.$store.dispatch('account/userAccountBusinesses', this.user.user_id);
                var self = this;
                setTimeout(function () {
                    self.getUserBusinesses();
                }, 1000);
            }
        },
        getUserBusinessesDEPRAC: function getUserBusinessesDEPRAC() {
            this.sellpoints = this.$store.getters['account/getUserBusinesses'];

            if (this.sellpoints != null && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.sellpoints).length > 0) {
                this.storeSetBusiness('', 0);
                this.loading = false;
            }
        }
    },

    mounted: function mounted() {},

    created: function created() {
        this.loadAccountBase();
    }
});

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(363)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(569),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(384)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(593),
  /* scopeId */
  "data-v-67ef5f3c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);


var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Activity Resource',
    props: {
        currentActivity: Object
    },
    data: function data() {
        return {
            store_loading: false,
            activities: {},
            activity: {},

            wishlist_store: {},
            saved_items_store: {},
            data_store0: {
                wishlist: {},
                saved_items: {}
            },
            data_store: [{ db_id: 1, db_name: "wishlistdbase", db_tag: "wishlist", data: {} }, { db_id: 2, db_name: "saveditemsdbase", db_tag: "saveditems", data: {} }]
        };
    },


    methods: {
        getStoredActivities: function getStoredActivities() {
            var _this = this;

            this.store_loading = true;

            var count = 0;

            var _loop = function _loop(store) {
                var self = _this;
                localforage.getItem(store.db_name, function (err, value) {
                    if (value != undefined) {
                        self.data_store[count].data = value;
                    }
                    count++;
                    if (count == self.data_store.length) {
                        self.store_loading = false;
                    }
                });
            };

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.data_store), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var store = _step.value;

                    _loop(store);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        getStoredActivity: function getStoredActivity(store_name, store_id) {
            if (store_name == '') {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(service.store_db), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var store = _step2.value;

                        if (store_id == store.db_id) {
                            store_name = store.db_name;
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
            var self = this;
            localforage.getItem(store_name, function (err, value) {
                if (value != undefined) {
                    if (store_id == 9) {
                        self.wishlist_store = value;
                    } else if (store_id == 10) {
                        self.saved_items_store = value;
                    }
                }
            });
        },
        storeActivity: function storeActivity(store_name, store_id, store_data) {
            if (store_name == '') {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(service.store_db), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var store = _step3.value;

                        if (store_id == store.db_id) {
                            store_name = store.db_name;
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }

            if (store_name != '') {
                localforage.setItem(store_name, store_data).then(function (value) {}).catch(function (err) {});
            }
        },
        getActivity: function getActivity() {
            var _this2 = this;

            localforage.removeItem("activity_data_store");

            var payload = {
                activity: this.activity.activity_id || 0,

                activity_module_action_type: this.activity.activity_module_action_type || 0,
                activity_module_data: this.activity.activity_module_data || 0
            };
            service.regActivity(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    var set_data = response.body.data;

                    _this2.storeActivity('activity_data_store', 0, set_data);

                    var data_store_id = _this2.activity.activity_data_store_id;
                    if (data_store_id > 0) {
                        _this2.storeActivity('', data_store_id, set_data);
                    }
                }
            }).catch(function (err) {});
        },
        setActivity: function setActivity() {
            var _this3 = this;

            if (this.activity.activity_module > 0 && this.activity.activity_module_id > 0 && this.activity.activity_user_module > 0 && this.activity.activity_user_module_id > 0) {
                var payload = {
                    activity_record_activity: this.activity.activity_record_activity || 0,
                    activity_user_module: this.activity.activity_user_module,
                    activity_user_module_id: this.activity.activity_user_module_id,
                    activity_activity: this.activity.activity_id || 0,
                    activity_action_type: this.activity.activity_action_type || 0,
                    activity_module: this.activity.activity_module,
                    activity_module_id: this.activity.activity_module_id,
                    activity_caption: this.activity.activity_caption || '',

                    activity_module_action_type: this.activity.activity_module_action_type || 0,
                    activity_module_data: this.activity.activity_module_data || 0
                };
                service.regActivity(this, payload).then(function (response) {
                    if (response.body.status == 201) {
                        var set_data = response.body.data;
                        var data_store_id = _this3.activity.activity_data_store_id;
                        _this3.storeActivity('', data_store_id, set_data);
                    }
                }).catch(function (err) {});
            }
        }
    },
    created: function created() {
        this.getStoredActivities();
    }
});

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(364)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(570),
  /* scopeId */
  "data-v-3a3fa036",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(625),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__posts_newgallery_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__posts_newgallery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__posts_newgallery_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__posts_newproductgallery_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__posts_newproductgallery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__posts_newproductgallery_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__templates_chat_index_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__templates_chat_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__templates_chat_index_vue__);







var service = new __WEBPACK_IMPORTED_MODULE_2__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'PostsCo',
    props: {},
    mixins: [__WEBPACK_IMPORTED_MODULE_5__templates_chat_index_vue___default.a],
    data: function data() {
        return {
            user: {},
            market: {},
            sellpoint: {},
            categories: {},
            galleria: {},
            gallery: {},
            gallery_post: {},
            gallery_post_set_image: {},
            products: {},
            product: {},
            productMain: {},
            productItem: {},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            edit_mode: false,
            loading: true,
            online: false,
            place_order: false,
            ordered_product: {},
            ordered_product_item: {},
            swipe_index: 0,

            data_error_message: "",
            data_success_message: "",
            data_processing_message: "",
            payment_successful: false,
            payment_successful_message: "",
            payment_payer_name: "",
            payment_payer_email: "",
            payment_payer_phone: "",
            payment_service: "",

            addPanel: false,
            business_load_error_msg: "",
            newLookbookForm: false,
            newProductLookbookForm: false,
            max_plan_lookbooks: 0,
            max_plan_lookbook_posts: 0,
            total_lookbooks_added: 0,
            can_add_more_lookbook: false,
            can_add_product_lookbook: false,
            refresh_button: false,
            disable_btn: false,
            action_loading: false,
            default_banner_image: "https://res.cloudinary.com/diprbfy7s/image/upload/v1550754799/businesses_files/sp-default-banner.jpg",
            set_sellpoint_banner_image: '',

            gallery_view: false,

            swiperOption: {
                pagination: {
                    el: '.swiper-pagination'
                }
            },
            menu_view: {},
            menu_tab_view: {},

            business_posts: {},

            com: {},
            comlogs: {},
            com_member: {},
            group: {},
            groups: {},
            post: {},
            posts: {},
            post_as: {},
            file_info: {},
            files_info: [],
            imageForm: "",
            imagesFormArray: [],
            selected_group_members: []
        };
    },


    components: {
        'add-lookbook': __WEBPACK_IMPORTED_MODULE_3__posts_newgallery_vue___default.a,
        'add-product-lookbook': __WEBPACK_IMPORTED_MODULE_4__posts_newproductgallery_vue___default.a
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        setMenuComponent: function setMenuComponent(view) {
            this.menu_view = {};
            this.menu_view[view] = true;

            var tabs = document.getElementsByClassName('tab-menu-link');
            for (var i = 0; i < tabs.length; i++) {
                tabs[i].style = "color:#000000;";
            }
            document.getElementById(view).style.color = service.app_default_color;
        },
        setMenuTabView: function setMenuTabView(view) {
            this.menu_tab_view = {};
            this.menu_tab_view[view] = true;
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        checkIfVideo: function checkIfVideo(url) {
            if (url != undefined) {
                var ext = url.split('.').pop();
                if (service.video_exts.includes(ext)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        addComponent: function addComponent(attr1, attr2) {

            this.addPanel = true;

            if (attr1 == "add-new-lookbook") {
                this.newLookbookForm = true;
            }
            if (attr1 == "add-new-product-lookbook") {
                this.newProductLookbookForm = true;
            }
            if (attr1 == "add-new-product-post") {
                this.$router.push("/" + this.$route.params.id + "/" + this.gallery.gallery_posts_group_url_name);

                this.newProductLookbookForm = true;
            }
            if (attr1 == "add-new-post") {
                this.addNewPost = true;

                this.gallery = attr2;
            }

            if (this.gallery_view) {
                this.gallery_view = false;

                var self = this;
                setTimeout(function () {
                    self.mobileSideNavToggle("open");
                }, 150);
            }

            var top = document.getElementById("addPanelView").offsetTop;
            window.scrollTo(0, top);
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == "refresh-store") {
                this.getGalleryPosts();
            }
            if (attr1 == "close-gallery-view") {
                this.gallery_view = false;
            }
        },
        reset: function reset() {
            this.addPanel = false, this.addNewPost = false;
            this.newLookbookForm = false;
            this.newProductLookbookForm = false;
            this.data_error_message = "";
            this.data_success_message = "";
        },
        preset: function preset() {
            this.loading = true;
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                    self.user.user_name = value.user_name;

                    self.getChatLogs();
                    self.getChatLog();
                    self.loadComLogs();

                    self.com_member.com_member_id = self.user.user_id;
                    self.com_member.com_member_name = self.user.user_name;
                    self.com_member.com_member_type = 2;
                    self.post_as = self.com_member;


                    self.loading = false;
                } else {}
            });
        },
        is_editing: function is_editing() {
            var _this = this;

            if (this.user.user_id != "") {
                var payload = {
                    validate_user: this.user.user_id,
                    validate_business: this.sellpoint.business_id
                };
                service.can_edit(this, payload).then(function (response) {
                    if (response.body.status == 200) {
                        _this.edit_mode = true;
                    } else {
                        _this.edit_mode = false;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        loadComLogs: function loadComLogs() {
            var _this2 = this;

            this.activate_processing();
            service.getComLogs(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.comlogs = response.body.data;
                    _this2.deactivate_processing();
                }
            }).catch(function (err) {});
        },
        loadComPosts: function loadComPosts() {
            var _this3 = this;

            this.activate_processing();
            if (this.com.com_type == 4) {
                service.getXPostsGroups(this, this.com.com_type_id, 0, 50).then(function (response) {
                    if (response.body.status == 200) {
                        _this3.posts = response.body.data;
                        _this3.deactivate_processing();
                    } else {
                        _this3.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this3.deactivate_processing();
                });
            } else {
                service.getXPosts(this, this.com.com_type, this.com.com_type_id, 0, 50).then(function (response) {
                    if (response.body.status == 200) {
                        _this3.posts = response.body.data;
                        _this3.deactivate_processing();
                    } else {
                        _this3.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this3.deactivate_processing();
                });
            }
        },
        setComView: function setComView(com) {
            this.com = com;
            this.setMenuTabView('comView');
            this.loadComPosts();
        },
        setComPost: function setComPost(post) {
            this.post = post;
            this.setMenuTabView('comPostView');
        },
        createNewGroup: function createNewGroup() {
            var _this4 = this;

            this.activate_processing();
            var payload = {
                group_name: this.group.group_name,
                group_description: this.group.group_description,
                group_module: this.group.group_module || 0,
                group_module_id: this.group.group_module_id || 0,
                group_created_by: this.user.user_id
            };
            var navi = this.$router;
            if (payload.group_name != undefined || payload.group_name != '') {
                service.createNewGroup(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_processing_message = "Created";
                        this.loadComLogs();
                        this.deactivate_processing();
                        this.setMenuTabView('viewLogs');
                        this.setMenuComponent('welcomeView');
                    }
                }).catch(function (err) {
                    _this4.data_processing_message = "Something went wrong";
                    _this4.deactivate_processing();
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        selectGroupMembers: function selectGroupMembers(com) {
            var indexa = this.selected_group_members.findIndex(function (cm) {
                return cm.com_ref === com.com_ref;
            });
            if (indexa >= 0) {
                this.selected_group_members.splice(indexa, 1);
            } else {
                this.selected_group_members.push(com);
                this.selected_group_members[0].com_group = 0;
            }
        },
        addNewGroupMembers: function addNewGroupMembers(members_set) {
            var payload_arr = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(members_set), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var m = _step.value;


                    var payload = {
                        group_member_group: m.member_group || 0,
                        group_member_group_module: m.member_group_module || 0,
                        group_member_group_module_id: m.member_group_module_id || 0,
                        group_member_type: m.member_type || 0,
                        group_member_module: m.member_module || 1,
                        group_member: m.member_id || 0
                    };
                    payload_arr.push(payload);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var navi = this.$router;
            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(payload_arr).length > 0) {
                service.addMembersToGroups(this, payload_arr).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_processing_message = "Members addded";
                        this.deactivate_processing();
                    }
                }).catch(function (err) {});
            } else {
                this.data_processing_message = 'Something may have went wrong';
                this.deactivate_processing();
            }
        },
        addMembersToGroup: function addMembersToGroup() {
            this.activate_processing();
            var payload_arr = [];
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selected_group_members), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var m = _step2.value;

                    var com_module = 1;
                    if (m.com_type == 2) {
                        com_module = 3;
                    } else if (m.com_type == 3) {
                        com_module = 1;
                    }
                    var payload = {
                        group_member_group: this.com.com_type_id,
                        group_member_type: m.com_type,
                        group_member_module: com_module,
                        group_member: m.com_type_id || 0
                    };

                    payload_arr.push(payload);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            var navi = this.$router;
            if (this.selected_group_members.length > 0) {
                service.addMembersToGroups(this, payload_arr).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_processing_message = "Members addded";
                        this.setMenuTabView('comView');
                        this.selected_group_members = [];
                        this.deactivate_processing();
                    }
                }).catch(function (err) {});
            } else {
                this.data_processing_message = 'Something may have went wrong';
                this.deactivate_processing();
            }
        },
        addNewPost: function addNewPost() {
            var _this6 = this;

            this.activate_processing();

            if (this.post.post_products.length > 0) {
                this.post_has_products = 1;
            } else {
                this.post_has_products = 0;
            }

            var post_group = 0;
            if (this.com.com_type == 4) {
                post_group = this.com.com_type_id;
            }
            var payload = {
                post_point_type: this.com_member.com_member_type || this.post.post_point_type,
                post_point: this.com_member.com_member_id || this.post.post_point,
                post_group: post_group || this.post.post_group,
                post_user: this.user.user_id,
                post_type: this.post.post_type,
                post_parent: 0,
                post_title: this.post.post_title || "nil",
                post_post: this.post.post_details || "nil",
                post_start_date: this.post.post_start_date || "",
                post_end_date: this.post.post_end_date || "",
                post_product: this.post.post_product || 0,
                post_has_products: this.post_has_products || 0,
                post_products: this.post.post_products || []
            };

            var navi = this.$router;
            if (payload.post_post != undefined || payload.post_post || 'nil') {
                service.addXPosts(this, payload).then(function (data) {
                    var _this5 = this;

                    if (data.body.status == 201) {
                        (function () {
                            _this5.data_processing_message = "Post Created";

                            var response_post = data.body.data;
                            _this5.posts = data.body.data_posts;

                            var uploads_count = 0;
                            if (_this5.imagesFormArray.length > 0) {
                                var _iteratorNormalCompletion3 = true;
                                var _didIteratorError3 = false;
                                var _iteratorError3 = undefined;

                                try {
                                    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this5.imagesFormArray), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                        var imageForm = _step3.value;

                                        imageForm.append("data_id", response_post.post_id);
                                        imageForm.append("data_type", "post_media");
                                        service.uploadDataPhoto(_this5, imageForm).then(function (data) {
                                            if (data.body.status == 200) {
                                                uploads_count++;
                                                if (uploads_count == _this5.imagesFormArray.length) {
                                                    _this5.setMenuTabView('comView');
                                                    _this5.setMenuComponent('welcomeView');
                                                    _this5.deactivate_processing();
                                                }
                                            }
                                        }).catch(function (err) {
                                            _this5.data_processing_message = "Media upload may have a problem";
                                            _this5.deactivate_processing();
                                        });
                                    }
                                } catch (err) {
                                    _didIteratorError3 = true;
                                    _iteratorError3 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                            _iterator3.return();
                                        }
                                    } finally {
                                        if (_didIteratorError3) {
                                            throw _iteratorError3;
                                        }
                                    }
                                }
                            } else {
                                _this5.setMenuTabView('comView');
                                _this5.setMenuComponent('welcomeView');
                                _this5.deactivate_processing();
                            }
                        })();
                    }
                }).catch(function (err) {
                    _this6.data_processing_message = "Something went wrong";
                    _this6.deactivate_processing();
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        onFileChangeMultiplePrep: function onFileChangeMultiplePrep(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length > 0) {
                this.files_info = files;
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(files), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var file = _step4.value;

                        var formData = new FormData();
                        formData.append('photo', file);
                        this.imagesFormArray.push(formData);
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }
            }
        },
        setGallery: function setGallery() {
            var _this7 = this;

            this.loading = true;
            service.getGallerySearch(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this7.gallery = response.body.data;

                    _this7.loading = false;
                }
            }).catch(function (err) {});
        },
        setMarket: function setMarket() {
            var _this8 = this;

            this.loading = true;
            service.getMarketActivityProducts(this, service.market_app_name, 0, 50).then(function (response) {
                if (response.body.status == 200) {
                    _this8.products = response.body.data;
                    _this8.preset();
                }
            }).catch(function (err) {
                _this8.loading = false;
            });
        },
        setSellpoint: function setSellpoint() {
            var _this9 = this;

            this.loading = true;
            service.getAppBusinessByUserName(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this9.sellpoint = response.body.data;
                    _this9.preset();
                    document.title = _this9.sellpoint.business_name + " | " + service.app_name;

                    _this9.getSellpointProducts();
                    _this9.getSellpointPosts();
                    if (_this9.sellpoint.business_banner_image == _this9.default_banner_image || _this9.sellpoint.business_banner_image == 'error') {
                        _this9.set_sellpoint_banner_image = service.general_banner_image;
                    } else {
                        _this9.set_sellpoint_banner_image = _this9.sellpoint.business_banner_image;
                    }
                } else {
                    _this9.business_load_error_msg = "Sorry, this Business Information could not be found.";
                }
            }).catch(function (err) {
                _this9.loading = false;
            });
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this10 = this;

            this.loading = true;
            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this10.products = response.body.data;
                    _this10.loading = false;
                }
            }).catch(function (err) {});
        },
        getSellpointPosts: function getSellpointPosts() {
            var _this11 = this;

            this.loading = true;
            service.getXPosts(this, 2, this.sellpoint.business_id, 0, 50).then(function (response) {
                if (response.body.status == 200) {
                    _this11.business_posts = response.body.data;
                    _this11.loading = false;
                }
            }).catch(function (err) {});
        },
        getProductsInBusinessCategories: function getProductsInBusinessCategories() {
            var _this12 = this;

            this.loading = true;
            service.getProductsInBusinessCategories(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this12.categories = response.body.data;
                }
                _this12.loading = false;
            }).catch(function (err) {
                _this12.loading = false;
            });
        },
        followSellpoint: function followSellpoint() {
            var _this13 = this;

            this.activate_processing();
            var payload = {
                following_user: this.user.user_id,
                following_type: 1,
                following_module: 3,
                following_module_id: this.sellpoint.business_id
            };

            var navi = this.$router;
            if (payload.following_module != undefined) {
                service.addFollowing(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_processing_message = "Followed";
                        this.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this13.data_processing_message = "Something went wrong";
                    _this13.deactivate_processing();
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        followPost: function followPost(post) {
            var _this14 = this;

            this.activate_processing();
            var payload = {
                following_user: this.user.user_id,
                following_type: 3,
                following_module: 6,
                following_module_id: post.post_id
            };

            var navi = this.$router;
            if (payload.following_module != undefined) {
                service.addFollowing(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_processing_message = "Followed";
                        this.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this14.data_processing_message = "Something went wrong";
                    _this14.deactivate_processing();
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        setNewPost: function setNewPost(post_type, post_type_name) {
            this.post = {};
            this.post.post_products = [];
            this.post.selected_post_products = [];
            this.post.post_temp_id = Math.random();
            this.post.post_type = post_type;
            this.post.post_type_name = post_type_name;
            this.setMenuComponent("newPosts");
        },
        postComment: function postComment() {},
        getGalleryPosts: function getGalleryPosts() {
            var _this15 = this;

            this.loading = true;
            service.getPointGalleryPosts(this, this.sellpoint.business_id, 0, this.max_plan_lookbooks, 0, this.max_plan_lookbook_posts).then(function (response) {
                _this15.galleria = response.body.data;

                _this15.total_lookbooks_added = response.body.total_data;

                if (_this15.total_lookbooks_added < _this15.max_plan_lookbooks) {
                    _this15.can_add_more_lookbook = true;
                }

                _this15.loading = false;
            }).catch(function (err) {
                _this15.loading = false;
            });
        },
        getPostsInGallery: function getPostsInGallery(gallery) {
            this.gallery = gallery;
            this.gallery_post = gallery.gallery_posts_group_posts[0];


            if (this.gallery_post.gallery_post_media[0]) {
                this.gallery_post_set_image = this.gallery_post.gallery_post_media[0];
            } else {
                this.gallery_post_set_image = {};
            }


            this.gallery_view = true;
        },
        getCategoryProducts: function getCategoryProducts(category) {
            this.loading = true;
            this.product = category.business_category_products[0];
            this.products = category.business_category_products;
            $('#quickviewModal').modal('show');
            this.loading = false;
        },
        getCategoryProductsXX: function getCategoryProductsXX(category) {
            var _this16 = this;

            this.loading = true;
            var self = this;
            service.getCategoryProducts(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this16.products = response.body.data;

                    var count = 0;
                    _this16.products.forEach(function (element) {
                        count++;
                        if (count == 1) {
                            _this16.product = element;
                            $('#quickviewModal').modal('show');
                        }
                    });
                    _this16.loading = false;
                }
            }).catch(function (err) {
                _this16.loading = false;
            });
        },
        showPost: function showPost(post) {
            this.gallery_post = post;

            if (this.gallery_post.gallery_post_media[0]) {
                this.gallery_post_set_image = this.gallery_post.gallery_post_media[0];
            } else {
                this.gallery_post_set_image = {};
            }
        },
        showPostImage: function showPostImage(post_image) {
            this.gallery_post_set_image = post_image;
        },
        showProduct: function showProduct(product) {
            this.product = product;
        },
        addPostToGallery: function addPostToGallery() {
            var _this18 = this;

            this.activate_processing();

            var credentials = {
                gallery_new_group: false,
                gallery_post_group: this.gallery.gallery_posts_group_id,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    var _this17 = this;

                    if (data.body.status == 201) {
                        this.data_success_message = "Post Created";

                        this.post = data.body.data;

                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type", "gallery_media");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                location.reload(true);
                                _this17.gallery = data.body.data_gallery;
                                _this17.addNewPost = false;
                            }
                            _this17.deactivate_processing();
                        }).catch(function (err) {
                            if (err) {}

                            _this17.data_error_message = "Something went wrong";
                            _this17.deactivate_processing();
                        });

                        var self = this;
                        setTimeout(function () {
                            location.reload(true);
                        }, 2000);
                    }
                }).catch(function (err) {
                    if (err) {
                        _this18.data_error_message = "Something went wrong";

                        _this18.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        },
        onFileChangeBannerImage: function onFileChangeBannerImage(e, type) {
            var _this19 = this;

            this.activate_processing();
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', this.sellpoint.business_id);
                formData.append('data_type', type);
                service.uploadBusinessDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "business_banner_image") {
                            _this19.sellpoint.business_banner_image = data.body.data;
                            _this19.set_sellpoint_banner_image = _this19.sellpoint.business_banner_image;
                        }
                        if (type == "business_brand_image") {
                            _this19.sellpoint.business_brand_image = data.body.data;
                        }

                        var self = _this19;
                        setTimeout(function () {
                            self.deactivate_processing();
                            self.mobileSideNavToggle('close');

                            self.loading = true;
                            setTimeout(function () {
                                self.loading = false;
                            }, 1200);
                        }, 1000);
                    } else {
                        _this19.data_error_message = "Could not update, something went wrong. Please try again";
                        _this19.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this19.data_error_message = "Could not update, something went wrong. Please try again";
                    _this19.deactivate_processing();
                });
            }
        },
        manageLookbook: function manageLookbook() {
            var _this20 = this;

            this.disable_btn = true;

            var credentials = {
                session_key: localStorage.getItem("sp_token"),
                request_url: service.app_url,
                request_from: service.app_name,
                request_status: "REQUESTING...",
                request: this.sellpoint.business_username + '/g/' + this.gallery.gallery_posts_group_url_name
            };
            if (credentials.session_key != null) {
                service.sessionSync(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var ref = response.body.data;
                        window.location.href = service.sp_url + '/manage/' + ref;
                    } else {
                        _this20.disable_btn = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this20.disable_btn = false;
                    }
                });
            }
        },
        placeOrder: function placeOrder(product, product_item) {
            this.ordered_product = product;
            this.ordered_product_item = product_item;
            this.place_order = true;
        },
        resetOptions: function resetOptions() {
            this.ordered_product = {};
            this.ordered_product_item = {};
            this.total_price = 0;
            this.place_order = false;
        },
        handleResize: function handleResize() {
            this.$refs.swipe.reset();
        },
        postsco_callCreateNewGroup: function postsco_callCreateNewGroup(group) {
            this.group = group;
            this.createNewGroup();
        },
        postsco_callAddNewGroupMembers: function postsco_callAddNewGroupMembers(data) {
            this.addNewGroupMembers(data);
        }
    },

    created: function created() {
        this.menu_view["welcomeView"] = true;
        this.menu_tab_view["viewLogs"] = true;
        this.preset();
    }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Resources_commonfunctions__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'AccountSellpoint',
    mixins: [__WEBPACK_IMPORTED_MODULE_1__Resources_commonfunctions__["a" /* default */]],
    data: function data() {
        return {
            has_sellpoints: {},
            sellpoint: {},
            categories: {},
            products: {}
        };
    },


    computed: {},

    components: {},

    methods: {
        setSellpointPage: function setSellpointPage() {
            this.action_loading = true;
            var self = this;console.log(7988);
            localforage.getItem('xvue', function (err, value) {
                if (value != undefined) {
                    console.log(value);
                    self.sellpoint = value.account.store_sellpoint.store_sellpointData;
                    console.log(988);console.log(self.sellpoint);
                    if (self.sellpoint == undefined) {
                        self.loadAccountBase();
                    } else {
                        self.setSellpoint();
                    }
                } else {
                    console.log(8099);
                    self.loadAccountBase();
                }
            });
        },
        setSellpintDetails: function setSellpintDetails() {
            this.$store.dispatch('account/setBusinessCategories');
            this.$store.dispatch('account/setBusinessProducts');

            var self = this;
            setTimeout(function () {
                self.categories = self.$store.getters['account/getBusinessCategories'];
                self.products = self.$store.getters['account/getBusinessProducts'];
            }, 1000);
        },
        setCategory: function setCategory(data) {
            this.$store.dispatch('account/setCategory', data);
            this.$router.push('/account/business/category');
        },
        setProduct: function setProduct(data) {
            this.$store.dispatch('account/setProduct', data);
            this.$router.push('/account/business/product');
        },
        setSellpointMoreDetails: function setSellpointMoreDetails() {
            this.getAppBusinessSubscription();
            this.getBusinessDeliveryOptions();
            this.getBusinessDiscountsAndCoupons();
        },
        setHeaderName: function setHeaderName() {
            if (this.$route.path == '/account/business/product') {
                this.header_name = 'Product';
            } else {
                this.header_name = this.getService.app_name;
            }
        }
    },

    created: function created() {
        this.setHeaderName();
        this.setSellpointPage();
        var self = this;
    }
});

/***/ }),
/* 59 */
/***/ (function(module, exports) {



/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Home_index_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Home_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Home_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Account_Resources_commonfunctions_js__ = __webpack_require__(3);










var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Home',
    mixins: [__WEBPACK_IMPORTED_MODULE_7__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            user: {},
            categories: {},
            market: {},
            market_groups: {},
            market_trending: {},
            products: {},
            product: {},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            menu_view: {},
            show_login: false,
            show_landing: true,
            header_data: {},
            has_shops: true,

            set_view_box: '',
            businesses: {},
            set_cateogries: {}
        };
    },


    components: {
        'component-landing': __WEBPACK_IMPORTED_MODULE_2__Home_index_vue___default.a,
        'component-header': __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue___default.a,
        'component-sticky-header': __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue___default.a,
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue___default.a,
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue___default.a
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        preset: function preset() {
            this.loading = true;
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;
                    self.loading = false;
                } else {}
            });
        },
        setMarketRemote: function setMarketRemote() {
            var _this = this;

            service.getBusinessByUserName(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this.market = response.body.data;
                    _this.businesses = _this.market.business_markets;
                    _this.loading = false;
                }
            }).catch(function (err) {});
        },
        setMarketActivities: function setMarketActivities() {
            var _this2 = this;

            service.getMarketActivityProducts(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this2.market_trending = response.body.data;
                    _this2.products = response.body.data;
                }
            }).catch(function (err) {});
        },
        setMarketGroups: function setMarketGroups() {
            var _this3 = this;

            service.getMarketGroupsProducts(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this3.market_groups = response.body.data;
                }
            }).catch(function (err) {});
        },
        setMenuComponent: function setMenuComponent(view, view_type, attr1, attr2) {
            var top = document.getElementById("topPanel").offsetTop;
            window.scrollTo(0, top);

            this.menu_view = {};
            this.menu_view[view] = true;
        },
        getBusinessCategories: function getBusinessCategories() {
            service.getCategories(this).then(function (data) {
                this.categories = data.body.data;
            });
        },
        getSellpoint: function getSellpoint() {
            var _this4 = this;

            this.loading = true;
            service.getBusinessByUserName(this, 'Kedi1674857669').then(function (response) {
                if (response.body.status == 200) {
                    _this4.sellpoint = response.body.data;
                    _this4.setBusinessDetails();
                    _this4.getSellpointProducts();
                }
            }).catch(function (err) {});
        },
        setBusinessDetails: function setBusinessDetails() {
            var _this5 = this;

            service.getBusinessByUserName(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this5.sellpoint = response.body.data;

                    _this5.business_delivery_locations = _this5.sellpoint.business_delivery_options;

                    _this5.business_bank_details = _this5.sellpoint.business_bank_details;
                }
            }).catch(function (err) {});
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this6 = this;

            this.loading = true;
            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this6.products = response.body.data;
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this6.products), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var product = _step.value;
                            var _iteratorNormalCompletion2 = true;
                            var _didIteratorError2 = false;
                            var _iteratorError2 = undefined;

                            try {
                                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(product.product_items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    var item = _step2.value;

                                    item.product_name = product.product_name;
                                    item.product_item_order_quantity = 1;
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                        _iterator2.return();
                                    }
                                } finally {
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }

                            _this6.set_order_addons.push(product);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this6.set_order_data.order_items = [];

                    _this6.loading = false;
                }
            }).catch(function (err) {});
        },
        setFeaturedCategories: function setFeaturedCategories() {
            this.set_categories = [{ category_name: 'Swallow',
                category_color: '#ff0979' }, { category_name: 'Drinks',
                category_color: '#ff9979' }, { category_name: 'Swallow', category_color: '#ff3189' }, { category_name: 'Drinks',
                category_color: '#ff1939' }];
        },
        setViewBox: function setViewBox(view) {
            if (this.set_view_box == '') {
                this.setMenuTabInnerView('');
                this.toggleSingleComponent('shareBox');
            } else {
                this.setMenuTabInnerView('setOptions');

                this.set_view_box = view;
            }
        }
    },
    created: function created() {
        var x = window.matchMedia("(max-width: 700px)");
        this.screenFunction(x);

        if (localStorage.getItem('appOn')) {
            this.show_landing = false;
        } else {
            localStorage.setItem('appOn', 1);
        }
        this.menu_view["timeline"] = true;
        this.preset();
        this.setMarketRemote();
        this.setFeaturedCategories();

        this.getSellpoint();
    }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__ = __webpack_require__(3);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'ManageOrders',
    mixins: [__WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints: {},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error: false,
            group_isset: false,
            add_sellpoint: false,
            add_business: false,
            get_flag: false,
            loading: false,
            action_loading: false,

            validate_user_name_message: "",
            payment_successful_message: "",
            data_error_message: "",
            data_boarding_message: "",

            headerdata: {
                'name': ''
            },

            reset_order: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue___default.a },
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        preset: function preset() {
            this.loading = true;

            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;

                    localforage.getItem(service.bdb_name, function (err, value) {
                        if (value != undefined) {
                            self.sellpoint = value;
                            self.headerdata.name = self.sellpoint.business_name;

                            self.setBusinessDetails();

                            self.getSellpointProducts();

                            self.getAppBusinessOrders();
                        } else {
                            self.getSellpoints(self.user.user_id);
                            self.loading = false;
                        }
                    });
                } else {
                    self.loading = false;
                    self.$router.push('/login');
                }
            });
        },
        setBusinessDetails: function setBusinessDetails() {
            var self = this;
            localforage.getItem(service.bbnksdb_name, function (err, value) {
                if (value != undefined) {
                    console.log(7654999);
                    self.sellpoint.business_bank_details = value;
                    self.business_bank_details = value;
                }
                self.loading = false;
            });

            localforage.getItem(service.bbdlsdb_name, function (err, value) {
                if (value != undefined) {
                    self.sellpoint.business_delivery_options = value;
                    self.business_delivery_locations = value;
                }
                self.loading = false;
            });

            this.getSellpointDetails(this.sellpoint.business_username);
        }
    },
    created: function created() {
        this.preset();

        this.getRavepayBanks();
    }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);

var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Preset',
    data: function data() {
        return {
            active_logged_in: false,
            user: {}
        };
    },


    methods: {
        preset: function preset() {
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.active_logged_in = true;
                    self.user.user_id = value.user_id;
                    self.user.user_name = value.user_name;
                } else {}
            });
        },
        sessionStoreGlobal: function sessionStoreGlobal() {}
    },
    created: function created() {
        this.preset();
    }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__activity_js__ = __webpack_require__(40);




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Utility Resource',
    props: {},
    mixins: [__WEBPACK_IMPORTED_MODULE_1__activity_js__["a" /* default */]],
    data: function data() {
        return {
            wishlist_folder: {},
            wishlist_product: {},

            savedshop_folder: {},
            save_shop: {}
        };
    },


    methods: {
        addToWishlist: function addToWishlist() {
            this.activity.activity_record_activity = 0;
            this.activity.activity_user_module = 1;
            this.activity.activity_user_module_id = this.user.user_id;
            this.activity.activity_id = 0;
            this.activity.activity_action_type = 48, this.activity.activity_module = 16;
            this.activity.activity_module_id = this.wishlist_product.product_item_id;
            this.activity.activity_caption = '';

            this.activity.activity_module_action_type = 2;
            var folder_payload = {
                folder_item_module: 16,
                folder_item_module_id: this.wishlist_product.product_item_id
            };

            this.activity.activity_data_store_id = 9;
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.wishlist_folder).length == 0) {
                folder_payload.folder_item_folder_name = "General";
                folder_payload.folder_item_folder_descr = "General Wishlist";
                folder_payload.folder_item_folder_type = 7;
                folder_payload.folder_item_folder_owner_module = 1;
                folder_payload.folder_item_folder_owner_module_id = this.user.user_id;
                folder_payload.folder_item_folder_created_by = this.user.user_id;
            } else {
                folder_payload.folder_item_folder = this.wishlist_folder.folder_id;
            }

            this.activity.activity_module_data = folder_payload, this.setActivity();
        },
        addToMyShops: function addToMyShops() {
            this.activity.activity_record_activity = 0;
            this.activity.activity_user_module = 1;
            this.activity.activity_user_module_id = this.user.user_id;
            this.activity.activity_id = 0;
            this.activity.activity_action_type = 48, this.activity.activity_module = 3;
            this.activity.activity_module_id = this.save_shop.business_id;
            this.activity.activity_caption = '';

            this.activity.activity_module_action_type = 2;
            var folder_payload = {
                folder_item_module: 3,
                folder_item_module_id: this.save_shop.business_id
            };

            this.activity.activity_data_store_id = 11;
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.savedshop_folder).length == 0) {
                folder_payload.folder_item_folder_name = "My Shops";
                folder_payload.folder_item_folder_descr = "My Saved Shops List";
                folder_payload.folder_item_folder_type = 9;
                folder_payload.folder_item_folder_owner_module = 1;
                folder_payload.folder_item_folder_owner_module_id = this.user.user_id;
                folder_payload.folder_item_folder_created_by = this.user.user_id;
            } else {
                folder_payload.folder_item_folder = this.savedshop_folder.folder_id;
            }

            this.activity.activity_module_data = folder_payload, this.setActivity();
        }
    },
    created: function created() {}
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Orderpoint_Template__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Orderpoint_Template___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Orderpoint_Template__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Orderpoint_Cart__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Orderpoint_Cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_Orderpoint_Cart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Orderpoint_Checkout__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Orderpoint_Checkout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Orderpoint_Checkout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Orderpoint_Orders__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Orderpoint_Orders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Orderpoint_Orders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Orderpoint_Order__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Orderpoint_Order___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Orderpoint_Order__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Orderpoint_OrderRequest__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Orderpoint_OrderRequest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_Orderpoint_OrderRequest__);







/* harmony default export */ __webpack_exports__["a"] = ({
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Orderpoint_Template___default.a,
    children: [{
        path: '/cart',
        name: 'Cart',
        component: __WEBPACK_IMPORTED_MODULE_1__pages_Orderpoint_Cart___default.a
    }, {
        path: '/checkout',
        name: 'Checkout',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Orderpoint_Checkout___default.a
    }, {
        path: '/checkout/:ref',
        name: 'CheckoutOrderRef',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Orderpoint_Checkout___default.a
    },, {
        path: '/checkout/:ckid',
        name: 'CheckoutOrderURL',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Orderpoint_Checkout___default.a
    }, {
        path: '/checkout/re/:rmkoref',
        name: 'CheckoutOrderRemake',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Orderpoint_Checkout___default.a
    }, {
        path: '/orders',
        name: 'Orders',
        component: __WEBPACK_IMPORTED_MODULE_3__pages_Orderpoint_Orders___default.a
    }, {
        path: '/order',
        name: 'Order',
        component: __WEBPACK_IMPORTED_MODULE_4__pages_Orderpoint_Order___default.a
    }, {
        path: '/order/request/:ref',
        name: 'OrderRequest',
        component: __WEBPACK_IMPORTED_MODULE_5__pages_Orderpoint_OrderRequest___default.a
    }]
});

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(339)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(545),
  /* scopeId */
  "data-v-16ad58f9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(336)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(542),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(391)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(601),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(408)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(619),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(573),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(374)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(583),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(594),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(406)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(617),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(395)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(606),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(425)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(637),
  /* scopeId */
  "data-v-f2d28d02",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(330)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(536),
  /* scopeId */
  "data-v-0f21c2f8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(398)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(609),
  /* scopeId */
  "data-v-7fb5ad06",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(354)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(561),
  /* scopeId */
  "data-v-2863d15c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(359)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(565),
  /* scopeId */
  "data-v-31884a04",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(416)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(628),
  /* scopeId */
  "data-v-c663ed78",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__updates__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buzz__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__notifications__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__feeds__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__search__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__register__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__login__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__onboarding__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__manage__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dashboard__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__account__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__createaccount__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__createorder__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__setorder__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__makeorder__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__prepareorder__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__placedorders__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__placedorder__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__placeorder__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__shoppinglists__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__settings__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__create__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sellpoint__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__collections__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__purchase__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__demos__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__buypoint__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__boxpoint__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__orderpoint__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__chats__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__myshops__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__transfer__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__agentservices__ = __webpack_require__(238);









































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [__WEBPACK_IMPORTED_MODULE_2__home__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__updates__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__buzz__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__notifications__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__feeds__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__search__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__register__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__login__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__onboarding__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__manage__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__purchase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__demos__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__dashboard__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__account__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__create__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__createaccount__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__createorder__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__setorder__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__makeorder__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__prepareorder__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__placedorders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__placedorder__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__placeorder__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__shoppinglists__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__settings__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__collections__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__buypoint__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__boxpoint__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__orderpoint__["a" /* default */], __WEBPACK_IMPORTED_MODULE_32__chats__["a" /* default */], __WEBPACK_IMPORTED_MODULE_33__myshops__["a" /* default */], __WEBPACK_IMPORTED_MODULE_34__transfer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_35__agentservices__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sellpoint__["a" /* default */]]
}));

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_persist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_account__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutations__ = __webpack_require__(277);










__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
var vuexLocalStorage = new __WEBPACK_IMPORTED_MODULE_3_vuex_persist___default.a({
    key: 'xvue',
    storage: localforage,
    asyncStorage: true,
    reducer: function reducer(state) {
        return {
            cart: state.cart,
            account: state.account };
    }
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
    strict: true,
    plugins: [vuexLocalStorage.plugin],
    state: {
        store_user: {},

        cart: [],

        store_showLoader: false
    },
    getters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_5__getters__["a" /* cartGetters */]),
    actions: {},
    mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_6__mutations__["a" /* cartMutations */]),
    modules: {
        account: __WEBPACK_IMPORTED_MODULE_4__modules_account__["a" /* account */]
    }
}));

/***/ }),
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductForm',
    data: function data() {
        return {
            user: {},
            sellpoint: {},
            sellpoint_categories: {},
            sub_categories: {},
            products: {},
            post: {},
            gallery: {},
            product_item: {},
            disable_btn: false,
            loading: true,
            action_loading: false,
            imageForm: "",
            product_info: false,
            product_url: "",
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            file_info: {},
            data_success_message: "",
            data_error_message: ""
        };
    },

    components: {},
    methods: {
        setComponent: function setComponent(attr1, attr2) {},
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        trackevent: function trackevent(e) {
            if (e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined) {
                this.category_type_2 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined) {
                this.category_type_1 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined) {
                this.category_type_1 = true;
                this.category_type_2 = true;
            } else {
                this.category_type_1 = false;
                this.category_type_2 = false;
                this.category_type_3 = false;
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);

                        _this.getSellpointCategories();
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this2 = this;

            service.getBusinessByUserName(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.sellpoint = response.body.data;
                    _this2.loading = false;
                }
            }).catch(function (err) {
                _this2.getSellpointCategories();
            });
        },
        getSubCategories: function getSubCategories(category) {
            var _this3 = this;

            service.getBusinessSubCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this3.sub_categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this4 = this;

            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this4.products = response.body.data;
                }
            }).catch(function (err) {});
        },
        addGallery: function addGallery() {
            var _this6 = this;

            this.activate_processing();
            var credentials = {
                gallery_new_group: true,
                gallery_group_type: 1,
                gallery_group_point: this.sellpoint.business_id,
                gallery_group_name: this.gallery.gallery_name,
                gallery_group_description: this.gallery.gallery_description,
                gallery_post_group: 0,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details || "nill",
                gallery_post_products: []
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    var _this5 = this;

                    if (data.body.status == 201) {
                        this.data_success_message = "processing, please wait.. ..";

                        this.post = data.body.data;

                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type", "gallery_media");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                location.reload(true);
                            }
                        }).catch(function (err) {
                            if (err) {}

                            _this5.data_error_message = "Something went wrong..";
                        });

                        var self = this;
                        setTimeout(function () {
                            location.reload(true);
                        }, 2000);
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');

                        _this6.deactivate_processing();
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        }
    },
    created: function created() {
        this.preset();
    }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductForm',
    data: function data() {
        return {
            open_request: true,
            user: {},
            sellpoint: {},
            sellpoint_categories: {},
            categories: {},
            main_category: {},
            sub_categories: [],
            products: {},
            product: {},
            post: {},
            gallery: {},
            selected_produts: [],
            product_item: {},
            disable_btn: false,
            imageForm: "",
            product_info: false,
            product_url: "",
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            file_info: {},
            addProductPost: false,
            showGalleryForm: true,
            showProductForm: false,
            canAddGallery: false,
            is_product_service: "product",
            data_success_message: "",
            data_error_message: "",
            loading: true,
            action_loading: false,
            executed_kipper: false,
            pinched_products: []
        };
    },

    components: {},
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == "add-to-gallery-product") {
                var if_index = this.selected_produts.indexOf(attr2.product_id);
                if (if_index != -1) {
                    attr2.product_checked = false;

                    this.selected_produts.splice(if_index, 1);
                    document.getElementById(attr2.product_id + "PRD").style.border = "none";
                } else {
                    this.selected_produts.push(attr2.product_id);
                    attr2.product_checked = true;
                    document.getElementById(attr2.product_id + "PRD").style.border = "1px solid #0000CC";
                }
            }
            if (attr1 == "show-add-product-form") {
                this.showProductForm = true;
                this.canAddGallery = false;
            }
        },
        close_request: function close_request() {
            this.open_request = false;
        },
        reset: function reset() {
            this.showProductForm = false;
            this.canAddGallery = true;
        },
        trackevent: function trackevent(e) {
            if (e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined) {
                this.category_type_2 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined) {
                this.category_type_1 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined) {
                this.category_type_1 = true;
                this.category_type_2 = true;
            } else {
                this.category_type_1 = false;
                this.category_type_2 = false;
                this.category_type_3 = false;
            }
        },
        preset: function preset() {
            var _this = this;

            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);

                        _this.getSellpointCategories();
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this2 = this;

            service.getBusinessByUserName(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.sellpoint = response.body.data;

                    service.getBusinessCategories(_this2, _this2.sellpoint.business_id).then(function (response) {
                        if (response.body.status == 200) {
                            _this2.sellpoint_categories = response.body.data;
                        }
                    }).catch(function (err) {});

                    _this2.getCategories(_this2.sellpoint.business_category_id);
                    _this2.getSellpointProducts();
                }
            }).catch(function (err) {});
        },
        getCategories: function getCategories(category) {
            var _this3 = this;

            service.getMainCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this3.categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSubCategories: function getSubCategories(category) {
            if (category != undefined) {
                this.sub_categories = category.sub_categories;
            } else {
                this.sub_categories = [];
            }
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this4 = this;

            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this4.products = response.body.data;
                    _this4.loading = false;

                    if (_this4.products.length > 0) {
                        _this4.canAddGallery = true;
                    }
                } else {
                    _this4.loading = false;
                }
            }).catch(function (err) {
                _this4.loading = false;
            });
        },
        addGallery: function addGallery() {
            var _this5 = this;

            this.activate_processing();
            this.loading = true;

            var credentials = {
                gallery_new_group: true,
                gallery_group_type: 2,
                gallery_group_point: this.sellpoint.business_id,
                gallery_group_name: this.gallery.gallery_name,
                gallery_group_description: this.gallery.gallery_description,
                gallery_post_group: 0,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details || "nill",
                gallery_post_products: this.selected_produts || []
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_success_message = "Processing, please wait ...";

                        this.gallery = data.body.data;

                        location.reload("/" + this.$route.params.id);

                        this.open_request = false;

                        this.deactivate_processing();
                    }
                }).catch(function (err) {
                    if (err) {
                        _this5.data_error_message = "Something went wrong, preparing report ...";

                        _this5.deactivate_processing();
                    }
                });
            } else {
                this.data_error_message = "Kindly fill all fields ..";
                this.deactivate_processing();
            }
        },
        addProduct: function addProduct() {
            var _this7 = this;

            this.activate_processing();

            var credentials = {
                product_name: this.product.product_name,
                product_is_product_or_service: this.is_product_service,
                product_category: this.product.product_category || 0,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",
                product_business: this.sellpoint.business_id,
                product_description: this.product.product_description || "nill",
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 1
            };

            var navi = this.$router;
            if (credentials.product_name != undefined) {
                service.addProduct(this, credentials).then(function (data) {
                    var _this6 = this;

                    if (data.body.status == 201) {
                        this.data_success_message = "Processing, please wait ...";

                        this.product = data.body.data;

                        this.imageForm.append("data_id", this.product.product_id);

                        this.imageForm.append("data_type", "products");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                if (!_this6.executed_kipper) {
                                    _this6.addProductKipper();
                                }
                            }
                        }).catch(function (err) {
                            if (err) {}

                            _this6.data_error_message = "Something went wrong, preparing report ...";

                            _this6.deactivate_processing();
                        });

                        var self = this;
                        setTimeout(function () {
                            self.addProductKipper();
                        }, 2000);
                    }
                }).catch(function (err) {
                    if (err) {
                        _this7.data_error_message = "Something went wrong, preparing report ...";

                        _this7.deactivate_processing();
                    }
                });
            } else {
                this.data_error_message = "Kindly fill all fields ...";

                this.deactivate_processing();
            }
        },
        addProductKipper: function addProductKipper() {
            this.executed_kipper = true;

            this.selected_produts.push(this.product.product_id);

            if (this.addProductPost) {
                this.addProductPostGallery();
            } else {
                this.addGallery();
            }
        },
        addProductPostGallery: function addProductPostGallery() {
            var _this8 = this;

            this.disable_btn = true;
            this.loading = true;

            var set_gallery = 0;
            if (this.$route.params.id1 != undefined) {
                set_gallery = this.gallery.gallery_posts_group_id;
            }

            var credentials = {
                gallery_new_group: false,
                gallery_post_group: set_gallery,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details || "nill",
                gallery_post_products: this.selected_produts || []
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_success_message = "Processing, please wait ...";

                        this.gallery = data.body.data;
                        location.reload("/" + this.$route.params.id);


                        this.open_request = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this8.data_error_message = "Something went wrong, preparing report ...";

                        _this8.disable_btn = false;
                        _this8.loading = false;
                    }
                });
            } else {
                this.data_error_message = "Kindly fill all fields ..";
                this.disable_btn = false;
                this.loading = false;
            }
        },
        setGallery: function setGallery() {
            var _this9 = this;

            service.getGallerySearch(this, this.$route.params.id1).then(function (response) {
                if (response.body.status == 200) {
                    _this9.gallery = response.body.data;
                }
            }).catch(function (err) {});
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        }
    },
    created: function created() {
        if (this.$route.params.id1 != undefined) {
            this.setGallery();

            this.showGalleryForm = false;
            this.addProductPost = true;
        }
        this.preset();
    }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(14);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['ctaType', 'productMain', 'productItemGroup', 'productItem', 'productMainView'],
  data: function data() {
    return {
      set_ctaType: 0,
      set_productMain: {},
      set_productItemGroup: {},
      set_productItem: {},
      set_productMainView: {},
      cart: this.$store.state.cart
    };
  },

  computed: {
    canAdd: function canAdd() {
      var _this = this;

      var index = this.cart.findIndex(function (p) {
        return p.product_item_id === _this.set_productItem.product_item_id;
      });
      if (index < 0) {
        return true;
      }
    }
  },
  methods: {
    addToCart: function addToCart() {
      if (this.set_ctaType == 2) {
        this.set_productItem.active_order = true;
        this.set_productItem.product_buy_now_ref = 'qx-r';
      }

      this.set_productItem._id = this.set_productItem.product_item_id;

      if (this.set_productItem.product_item_order_quantity == undefined) {
        this.set_productItem.product_item_order_quantity = 1;
      }
      this.set_productItem.product_main_id = this.set_productMain.product_id;
      this.set_productItem.product_business_name = this.set_productMain.product_business_name;
      this.set_productItem.product_business = this.set_productMain.product_business_ownername;
      this.set_productItem.product_name = this.set_productMain.product_name;
      this.set_productItem.product_url = this.set_productMain.product_business_ownername + "/" + this.set_productMain.product_url_name;
      this.set_productItem.product_item_quantity = this.set_productItem.product_item_quantity;
      this.set_productItem.product_item_need_shipping = this.set_productMain.product_need_shipping;

      if (this.set_productItemGroup.product_item_group_is_color_image == 'IMG' && this.set_productItemGroup.product_item_group_image != 'error') {
        this.set_productItem.product_item_image = this.set_productItemGroup.product_item_group_image;
      } else {
        this.set_productItem.product_item_image = '';
      }

      this.set_productItem.product_shipping_calculation_method = this.set_productMain.product_set_shipping_fee_status;

      this.set_productItem.can_remove = true;
      this.set_productItem.product_business_sort = this.set_productMain.product_business_ownername;

      this.set_productItem.product_referral_bash = "";
      this.set_productItem.product_has_referral_bash = 0;
      var product_ref = "REF-" + this.set_productMain.product_url_name;
      var ref_check = localStorage.getItem(product_ref);
      if (ref_check && (ref_check != null || ref_check != '')) {
        this.set_productItem.product_has_referral_bash = 1;
        this.set_productItem.product_referral_bash = ref_check;
      }

      if (this.set_productMain.product_agent_ship && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.set_productMain.product_agent_ship).length > 0) {
        if (this.set_productMain.product_agent_ship.product_business_is_agent && this.set_productMain.product_agent_ship.product_business_is_agent == 1) {
          this.set_productItem.product_is_from_agent = this.set_productMain.product_agent_ship.product_business_is_agent;
          this.set_productItem.product_business_agent_name = this.set_productMain.product_agent_ship.product_business_agent_name;
          this.set_productItem.product_business_agent_username = this.set_productMain.product_agent_ship.product_business_agent_username;
          this.set_productItem.product_business_sort = this.set_productMain.product_agent_ship.product_business_agent_username;
        }
      }

      if (localStorage.getItem("product_sub")) {
        var sub_check = localStorage.getItem("product_sub");
        if (sub_check && (sub_check != null || sub_check != undefined || sub_check != '')) {
          this.set_productItem.product_is_updated_subscription = 1;
          this.set_productItem.product_current_subscription = sub_check;
        }
      }

      if (this.set_ctaType == 3) {
        this.set_productItem.product_order_part_payments_request = 1;
      }

      if (this.set_productMain.selected_product_addons && this.set_productMain.selected_product_addons.length > 0) {
        this.set_productItem.product_item_order_has_addon_orders = 1;
        this.set_productItem.product_order_addons = this.set_productMain.selected_product_addons;
      }

      if (this.set_productMain.product_order_addon_to && this.set_productMain.product_order_addon_to > 0) {
        this.set_productItem.product_item_order_is_add_on_to = this.set_productMain.product_order_addon_to;
      }

      if (this.set_ctaType == 2) {
        this.set_productItem.product_buy_now_ref = 'qx-r' + this.set_productItem.product_item_id;
      }

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["v" /* ADD_TO_CART */], this.set_productItem);
      this.cart = this.$store.state.cart;
      if (this.set_productMain.selected_product_addons && this.set_productMain.selected_product_addons.length > 0) {
        this.addProductAddonsToCart(this.set_productMain.selected_product_addons);
      }


      if (this.set_ctaType == 2) {
        localStorage.removeItem('bnrf');
        localStorage.setItem('bnrf', this.set_productItem.product_buy_now_ref);

        this.redir('order');
      }
    },
    removeFromCart: function removeFromCart(payload) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["w" /* REMOVE_FROM_CART */], payload);
    },
    redir: function redir(rlink) {
      location.replace("/" + rlink);
    },
    addProductAddonsToCart: function addProductAddonsToCart(selected_product_addons) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(selected_product_addons), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var product_addon = _step.value;

          this.set_ctaType = 1;
          this.set_productMain = product_addon.productMain;
          this.set_productItemGroup = product_addon.productItemGroup;
          this.set_productItem = product_addon.productItem;
          this.set_productMainView = '';

          this.addToCart();
          this.set_ctaType = this.ctaType;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  },
  created: function created() {
    this.set_ctaType = this.ctaType;
    this.set_productMain = this.productMain;
    this.set_productItemGroup = this.productItemGroup;
    this.set_productItem = this.productItem;
    this.set_productMainView = this.productMainView;

    if (this.set_ctaType == 2) {
      if (this.set_productMain.product_cta_name && this.set_productMain.product_cta_name == 'error') {
        this.set_productMain.product_cta_name = "Buy Now";
      }
    }

    var self = this;
    localforage.getItem('xvue', function (err, value) {
      if (value != undefined) {
        self.cart = value.cart;
      } else {}
    });
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductForm',
    data: function data() {
        return {
            user: {},
            sellpoint: {},
            sellpoint_categories: {},
            sub_categories: {},
            product: {},
            product_item: {},
            disable_btn: false,
            imageForm: "",
            product_info: false,
            product_url: "",
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            file_info: {}
        };
    },

    components: {},
    methods: {
        setComponent: function setComponent(attr1, attr2) {
            this.setPanel = true;
            if (attr1 == 'create-sellpoint') {
                this.createSellpointPanel = true;
                this.addProductPanel = false;
                this.addProductItemPanel = false;
            }
            if (attr1 == 'add-product') {
                this.addProductPanel = true;
                this.addProductItemPanel = false;
                this.createSellpointPanel = false;
            }
            if (attr1 == 'add-product-item') {
                this.addProductItemPanel = true;
                this.addProductPanel = false;
                this.createSellpointPanel = false;
            }
        },
        trackevent: function trackevent(e) {
            if (e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined) {
                this.category_type_2 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined) {
                this.category_type_1 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined) {
                this.category_type_1 = true;
                this.category_type_2 = true;
            } else {
                this.category_type_1 = false;
                this.category_type_2 = false;
                this.category_type_3 = false;
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);

                        _this.getSellpointCategories();
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this2 = this;

            service.getBusinessByUserName(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.sellpoint = response.body.data;

                    service.getBusinessCategories(_this2, _this2.sellpoint.business_id).then(function (response) {
                        if (response.body.status == 200) {
                            _this2.sellpoint_categories = response.body.data;
                        }
                    }).catch(function (err) {});
                    _this2.getSubCategories(_this2.sellpoint.business_category_id);
                }
            }).catch(function (err) {
                console.log(err);
            });
        },
        getSubCategories: function getSubCategories(category) {
            var _this3 = this;

            service.getBusinessSubCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this3.sub_categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        addProduct: function addProduct() {
            var _this5 = this;

            this.disable_btn = true;

            var credentials = {
                product_name: this.product.product_name,
                product_category: this.product.product_category || 0,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",
                product_business: this.sellpoint.business_id,
                product_description: this.product.product_description || "nill",
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 1
            };

            var navi = this.$router;
            if (credentials.product_name != undefined) {
                service.addProduct(this, credentials).then(function (data) {
                    var _this4 = this;

                    if (data.body.status == 201) {
                        toastr.success("Product Added Successfully", 'Success!');

                        this.product = data.body.data;

                        this.imageForm.append("data_id", this.product.product_item_id);
                        this.imageForm.append("data_type", "product_items");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                _this4.product_info = true;
                                _this4.product_url = "/" + _this4.$route.params.id + "/" + _this4.product.product_url_name;
                            }
                        }).catch(function (err) {
                            if (err) {}
                            toastr.warning("Something went wrong.", 'Warning!');
                        });
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');

                        _this5.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        }
    },
    created: function created() {
        this.preset();
    }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductItemForm',
    data: function data() {
        return {
            user: {},
            sellpoint: {},
            product: {},
            product_items: {},
            disable_btn: false,
            imageForm: "",
            addProductItemPanel: false
        };
    },

    components: {},
    methods: {
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == 'add-product-item') {
                this.addProductItemPanel = true;
            }
            if (attr1 == 'reset-edit') {}
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);

                        _this.setProduct();
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        setProduct: function setProduct() {
            var _this2 = this;

            service.getProductSearch(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.product = response.body.data;
                }
            }).catch(function (err) {
                _this2.$router.push("/");
            });
        },
        addProductItem: function addProductItem() {
            var _this3 = this;

            this.disable_btn = true;

            var credentials = {
                product_id: this.product.product_id,
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 1
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.addProductItem(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        var result = data.body.data;
                        this.imageForm.append("data_id", result.product_item_id);
                        this.imageForm.append("data_type", "product_items");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                location.reload(true);
                            }
                        }).catch(function (err) {
                            if (err) {}
                        });
                    }
                }).catch(function (err) {
                    if (err) {
                        console.log(err);
                        _this3.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);


                this.imageForm = formData;
            }
        }
    },
    created: function created() {
        this.imageForm = new FormData();
        this.setProduct();
    }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'product-list',
  created: function created() {
    if (this.products.length === 0) {
      this.$store.dispatch('allProducts');
    }
  },

  computed: {
    products: function products() {
      return this.$store.getters.allProducts;
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Account',
    data: function data() {
        return {
            user: {},
            loggedIn: false,
            notifications_alert: 0
        };
    },

    methods: {
        dropMenu: function dropMenu() {

            var w = document.getElementById("menu-nav").style.width;

            if (w == "100vw") {
                document.getElementById("menu-nav").style.width = "0px";
            } else {
                document.getElementById("menu-nav").style.width = "100vw";
            }
        },
        hideMenu: function hideMenu() {
            document.getElementById("menu-nav").style.display = "none";
        },
        preset: function preset() {
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.loggedIn = true;
                    self.user = value;
                }
            });
        }
    },
    created: function created() {
        this.preset();
    }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LeftSidebar',
  data: function data() {
    return {
      user: {},
      loggedIn: false
    };
  },


  methods: {
    checkLoggedIn: function checkLoggedIn() {
      if (localStorage.getItem("sp_token") != null) {
        this.loggedIn = true;
        this.user.user_name = localStorage.getItem("sp_user");
      }
    }
  },
  created: function created() {
    this.checkLoggedIn();
  }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MenuBottom',
    data: function data() {
        return {
            user: {},
            notifications: {},
            notifications_alert: 0,
            active_shop_together_alert: 0
        };
    },


    methods: {
        preset: function preset() {
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                    self.getNotifications();
                } else {}
            });
        },
        getNotifications: function getNotifications() {
            var _this = this;

            service.getNotifications(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this.notifications_alert = response.body.data_alert_total;
                }
            }).catch(function (err) {});
        }
    },

    mounted: function mounted() {
        var path = this.$route.path;
        if (path == "/") {
            document.getElementById("m_trending").style.color = "#ffffff";
        }
        if (path == "/orders") {
            document.getElementById("m_orders").style.color = "#ffffff";
        }
        if (path == "/notifications") {
            document.getElementById("m_notifications").style.color = "#ffffff";
        }
        if (path == "/account") {
            document.getElementById("m_account").style.color = "#ffffff";
        }
    },
    created: function created() {
        if (localStorage.getItem("active_shop_together_alert") == 1) {
            this.active_shop_together_alert = 1;
        }

        this.preset();
    }
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MenuBottom',
    data: function data() {
        return {
            user: {},
            notifications: {},
            notifications_alert: 0,
            active_shop_together_alert: 0
        };
    },


    methods: {
        preset: function preset() {
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                    self.getNotifications();
                } else {}
            });
        },
        getNotifications: function getNotifications() {
            var _this = this;

            service.getNotifications(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this.notifications_alert = response.body.data_alert_total;
                }
            }).catch(function (err) {});
        }
    },

    mounted: function mounted() {
        var path = this.$route.path;
        if (path == "/") {
            document.getElementById("m_trending").style.color = "#ffffff";
        }
        if (path == "/orders") {
            document.getElementById("m_orders").style.color = "#ffffff";
        }
        if (path == "/notifications") {
            document.getElementById("m_notifications").style.color = "#ffffff";
        }
        if (path == "/account") {
            document.getElementById("m_account").style.color = "#ffffff";
        }
    },
    created: function created() {
        if (localStorage.getItem("active_shop_together_alert") == 1) {
            this.active_shop_together_alert = 1;
        }

        this.preset();
    }
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RightSidebar',
  data: function data() {
    return {
      user: {},
      loggedIn: false
    };
  },


  methods: {
    checkLoggedIn: function checkLoggedIn() {
      if (localStorage.getItem("sp_token") != null) {
        this.loggedIn = true;
        this.user.user_name = localStorage.getItem("sp_user");
      }
    }
  },
  created: function created() {
    this.checkLoggedIn();
  }
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SearchBox',
    data: function data() {
        return {
            search_words: "",
            search_type: "business"
        };
    },


    methods: {
        search: function search() {
            location.replace("search?search=" + this.search_type + "&k=" + this.search_words);
        }
    }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Settings',
    data: function data() {
        return {};
    },


    methods: {
        mountid: function mountid() {
            'use strict';
        }
    },

    created: function created() {
        window.addEventListener('load', this.mountid);
    },
    destroyed: function destroyed() {
        window.removeEventListener('load', this.mountid);
    }
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SearchBox',
    data: function data() {
        return {
            products: {}
        };
    },


    methods: {
        getMarketActivityProducts: function getMarketActivityProducts() {
            var _this = this;

            var offset = 0;var limit = 20;
            service.getMarketActivityProducts(this, service.market_app_name, offset, limit).then(function (response) {
                if (response.body.status == 200) {
                    _this.products = response.body.data;
                    _this.loading = false;
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.getMarketActivityProducts();
    }
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_postsco_index_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_postsco_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__mixins_postsco_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources_preset_js__ = __webpack_require__(62);





var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ShopTogetherWidget',
    props: {
        currentActivity: Object
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_2__resources_preset_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_postsco_index_vue___default.a],
    data: function data() {
        return {
            shop_together_activities: {},

            shopTogetherAlertKey: 0
        };
    },


    methods: {
        openModal: function openModal(id) {
            document.getElementById(id).style.display = "block";
        },
        closeModal: function closeModal(id) {
            document.getElementById(id).style.display = "none";
        },
        getShopTogetherActivities: function getShopTogetherActivities() {
            var self = this;
            localforage.getItem(service.s2gdb_name, function (err, value) {
                if (value != undefined) {
                    self.shop_together_activities = value;
                }
            });
        },
        showShareOnShopTogether: function showShareOnShopTogether(id) {
            document.getElementById(id).style.display = "block";
        },
        shareOnShopTogether: function shareOnShopTogether(activity, index) {
            this.setShopTogetherActivities(activity, index);
        },
        setShopTogetherActivities: function setShopTogetherActivities(activity, index) {
            var _this = this;

            if (this.currentActivity.data_module && this.currentActivity.data_module > 0 && this.currentActivity.data_module_id && this.currentActivity.data_module_id > 0) {
                var payload = {
                    activity_user: this.user.user_id,
                    activity_activity: activity.activity_id,
                    activity_action_type: 48,
                    activity_module: this.currentActivity.data_module,
                    activity_module_id: this.currentActivity.data_module_id,
                    activity_caption: activity.data_caption || ''
                };
                service.setActivity(this, payload).then(function (response) {
                    if (response.body.status == 201) {
                        _this.shop_together_activities[index].data_shared = 'Shared';
                        _this.shopTogetherAlertKey++;

                        var chatter_set = {
                            chatter_chat_from_module: 1,
                            chatter_chat_from: _this.user.user_id,
                            chatter_chat_to_module: 20,
                            chatter_chat_to: 16,
                            chatter_chat_group: 16
                        };
                        var chat_set = {
                            chat_set_message: activity.data_caption,
                            chat_message_type: 8,
                            chat_message_object: _this.currentActivity.data_module_id,
                            chat_message_object_name: _this.currentActivity.data_module_name,
                            chat_message_object_price: _this.currentActivity.data_module_price,
                            chat_message_object_url: _this.currentActivity.data_module_url,
                            chat_message_object_media: _this.currentActivity.data_module_media
                        };

                        _this.chat_callPostChat(chatter_set, chat_set);
                    }
                }).catch(function (err) {});
            }
        }
    },
    created: function created() {
        this.getShopTogetherActivities();
    }
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__["a" /* default */]],
    data: function data() {
        return {
            ko: 'ghg'
        };
    },


    methods: {
        setPage: function setPage() {
            this.loading = false;
            if (this.$route.name == 'AddNewBusinessByAgent') {
                this.ko = 'tt66';
                this.getBusinessesOpenToAgents();
                console.log('as333');
            }
        }
    },

    components: {},

    created: function created() {
        this.setPage();
        this.getCategories();
    }

});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__["a" /* default */]],
    data: function data() {
        return {
            user: this.$store.getters['account/getUser'],
            business: this.$store.getters['account/getUserBusiness']
        };
    },


    methods: {
        setPage: function setPage() {
            this.loading = false;
            this.getMainCategories(this.sellpoint.business_category_id);
        }
    },

    components: {},

    created: function created() {
        var self = this;
        localforage.getItem('xvue', function (err, value) {
            if (value != undefined) {
                self.sellpoint = value.account.store_sellpoint.store_sellpointData;
                self.setPage();
            } else {}
        });
    }

});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Resources_script_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Purchase__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Purchase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Purchase__);





/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2__Resources_script_js__["a" /* default */]],
    data: function data() {
        return {
            loadx: true,
            set_user: this.$store.getters['account/getUser'],
            set_business: this.$store.getters['account/getUserBusiness'],
            set_sub_offers: this.$store.getters['account/getSellpointAppSubscriptionOffers']
        };
    },


    methods: {
        setPage: function setPage() {
            this.sellpoint = this.set_business;

            var self = this;
            localforage.getItem('xvue', function (err, value) {
                if (value != undefined) {
                    self.sellpoint = value.account.store_sellpoint.store_sellpointData;

                    var offer_set = value.account.store_sellpoint.store_sellpointAppSubscriptionOffers;
                    console.log(offer_set);
                    self.loadx = false;
                    if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(offer_set).length > 0) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(offer_set), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var offer = _step.value;

                                if (offer.service_offer == 5) {
                                    self.subscription_offer.products = offer;
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } else {}
            });
        }
    },

    components: {
        'purchase': __WEBPACK_IMPORTED_MODULE_3__Purchase___default.a
    },

    created: function created() {
        this.setPage();
        this.loadCategory();
    }

});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Resources_commonfunctions__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__Resources_commonfunctions__["a" /* default */]],
    data: function data() {
        return {
            set_select_mode: false
        };
    },

    methods: {
        setPage: function setPage() {
            this.action_loading = true;
            var self = this;
            localforage.getItem('xvue', function (err, value) {
                if (value != undefined) {
                    self.sellpoint = value.account.store_sellpoint.store_sellpointData;

                    if (self.sellpoint == null || self.sellpoint == undefined) {
                        self.loadAccountBase();
                    } else {
                        self.products = value.account.store_sellpoint.store_products;
                        if (self.products == undefined || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(self.products).length == 0) {
                            self.getSellpointProducts();
                        } else {
                            self.action_loading = false;
                        }

                        self.setDynamicRequests();
                    }
                } else {}
            });
        },
        setDynamicRequests: function setDynamicRequests() {
            var self = this;
            localforage.removeItem(self.getService.adr_db_name).then(function (value) {}).catch(function (err) {});
        }
    },

    created: function created() {
        this.setPage();
    }

});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__["a" /* default */]],
    props: ['order_data'],
    data: function data() {
        return {
            order_add_info: {},
            setAddOrderAdditionalView: false
        };
    },

    components: {},

    methods: {
        setPage: function setPage() {
            this.loading = true;

            var set_business = this.$route.params.business;
            var set_order_ref = this.$route.params.ref;
            if (set_business != undefined && set_business != '') {
                if (set_order_ref != undefined && set_order_ref != '') {
                    var payload = {
                        ref: set_order_ref
                    };
                    this.getOrderDetails(payload);
                }
            }
        }
    },

    created: function created() {
        var self = this;
        localforage.getItem('xvue', function (err, value) {
            if (value != undefined) {
                self.sellpoint = value.account.store_sellpoint.store_sellpointData;

                self.setPage();
            } else {}
        });
    }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__["a" /* default */]],
    data: function data() {
        return {
            no_data: true
        };
    },


    methods: {
        setPage: function setPage() {
            var self = this;
            localforage.getItem('xvue', function (err, value) {
                if (value != undefined) {
                    self.sellpoint = value.account.store_sellpoint.store_sellpointData;
                    self.product = value.account.store_sellpoint.store_product;
                } else {}
            });
        }
    },

    components: {},

    created: function created() {
        this.setPage();
    }
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__["a" /* default */]],
    data: function data() {
        return {
            no_data: true
        };
    },


    methods: {
        setPage: function setPage() {
            var self = this;
            localforage.getItem('xvue', function (err, value) {
                if (value != undefined) {
                    self.sellpoint = value.account.store_sellpoint.store_sellpointData;
                    self.product = value.account.store_sellpoint.store_product;
                } else {}
            });
        }
    },

    components: {},

    created: function created() {
        this.setPage();
    }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__["a" /* default */]],
    data: function data() {
        return {
            no_data: true
        };
    },


    methods: {
        setPage: function setPage() {
            var self = this;
            localforage.getItem('xvue', function (err, value) {
                if (value != undefined) {
                    self.sellpoint = value.account.store_sellpoint.store_sellpointData;
                    self.product = value.account.store_sellpoint.store_product;
                } else {}
            });
        }
    },

    components: {},

    created: function created() {
        this.setPage();
    }
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__["a" /* default */]],
    data: function data() {
        return {
            no_data: true
        };
    },


    methods: {
        setPage: function setPage() {
            var self = this;
            localforage.getItem('xvue', function (err, value) {
                if (value != undefined) {
                    self.sellpoint = value.account.store_sellpoint.store_sellpointData;
                    self.product = value.account.store_sellpoint.store_product;
                } else {}
            });
        }
    },

    components: {},

    created: function created() {
        this.setPage();
    }
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__["a" /* default */]],
    data: function data() {
        return {
            no_data: true
        };
    },


    methods: {
        setPage: function setPage() {
            var self = this;
            localforage.getItem('xvue', function (err, value) {
                if (value != undefined) {
                    self.sellpoint = value.account.store_sellpoint.store_sellpointData;
                    self.product = value.account.store_sellpoint.store_product;
                } else {}
            });
        }
    },

    components: {},

    created: function created() {
        this.setPage();
    }
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__["a" /* default */]],
    data: function data() {
        return {
            no_data: true
        };
    },


    methods: {
        setPage: function setPage() {
            var self = this;
            localforage.getItem('xvue', function (err, value) {
                if (value != undefined) {
                    self.sellpoint = value.account.store_sellpoint.store_sellpointData;
                    self.product = value.account.store_sellpoint.store_product;
                } else {}
            });
        }
    },

    components: {},

    created: function created() {
        this.setPage();
    }
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__["a" /* default */]],
    data: function data() {
        return {
            no_data: true
        };
    },


    methods: {
        setPage: function setPage() {
            var self = this;
            localforage.getItem('xvue', function (err, value) {
                if (value != undefined) {
                    self.sellpoint = value.account.store_sellpoint.store_sellpointData;
                    self.product = value.account.store_sellpoint.store_product;
                } else {}
            });
        }
    },

    components: {},

    created: function created() {
        this.setPage();
    }

});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Resources_commonfunctions__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__Resources_commonfunctions__["a" /* default */]],
  data: function data() {
    return {
      no_data: true
    };
  },


  methods: {
    setPage: function setPage() {
      this.loading = false;

      if (this.sellpoint.store_sellpointDiscounts && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.sellpoint.store_sellpointDiscounts).length > 0) {
        this.no_data = false;
        this.sellpoint.business_discounts_coupons = this.sellpoint.store_sellpointDiscounts;
      }
    }
  },

  components: {},

  created: function created() {
    var self = this;
    localforage.getItem('xvue', function (err, value) {
      if (value != undefined) {
        self.sellpoint = value.account.store_sellpoint.store_sellpointData;
        console.log(87766);
        console.log(self.sellpoint);
        self.setPage();
      } else {}
    });
  }

});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__["a" /* default */]],
    data: function data() {
        return {};
    },


    methods: {
        setPage: function setPage() {
            this.loading = false;

            this.getRavepayBanks();
        }
    },

    components: {},

    created: function created() {
        var self = this;
        localforage.getItem('xvue', function (err, value) {
            if (value != undefined) {
                self.user = value.account.store_user;
                self.sellpoint = value.account.store_sellpoint.store_sellpointData;
                self.setPage();
            } else {}
        });
    }

});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__["a" /* default */]],
    data: function data() {
        return {};
    },


    methods: {
        setPage: function setPage() {
            this.loading = true;

            this.getBusinessRewardSettings();
        }
    },

    components: {},

    created: function created() {
        var self = this;
        localforage.getItem('xvue', function (err, value) {
            if (value != undefined) {
                self.sellpoint = value.account.store_sellpoint.store_sellpointData;
                self.setPage();
            } else {}
        });
    }

});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__["a" /* default */]],
    data: function data() {
        return {};
    },


    methods: {
        setPage: function setPage() {
            this.loading = true;

            this.getBusinessDeliveryOptions();
        }
    },

    components: {},

    created: function created() {
        var self = this;
        localforage.getItem('xvue', function (err, value) {
            if (value != undefined) {
                self.sellpoint = value.account.store_sellpoint.store_sellpointData;
                self.setPage();
            } else {}
        });
    }

});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__["a" /* default */]],
    data: function data() {
        return {};
    },


    methods: {
        setPage: function setPage() {
            this.loading = true;

            this.getAppBusinessTransactions();
        }
    },

    components: {},

    created: function created() {
        var self = this;
        localforage.getItem('xvue', function (err, value) {
            if (value != undefined) {
                self.sellpoint = value.account.store_sellpoint.store_sellpointData;
                self.setPage();
            } else {}
        });
    }

});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Account_Resources_commonfunctions_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: "AddToCategories",
    mixins: [__WEBPACK_IMPORTED_MODULE_1__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            headerdata: {
                'name': 'Add To Categories'
            }
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a
    },

    methods: {},

    mounted: function mounted() {},

    created: function created() {
        if (this.$route.params.item && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$route.params.item).length > 0) {
            this.product = this.$route.params.item;
        } else {
            this.$router.push('/manage/items');
        }
    }
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Account_Resources_commonfunctions_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: "ResetCategory",
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            headerdata: {
                'name': 'Reset Category'
            }
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },

    methods: {},

    mounted: function mounted() {},

    created: function created() {}
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Account_Resources_commonfunctions_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: "ItemSettings",
    mixins: [__WEBPACK_IMPORTED_MODULE_1__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            headerdata: {
                'name': 'Settings'
            }
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a
    },

    methods: {
        setItemSettings: function setItemSettings(set_path) {
            this.$router.push({
                path: set_path,
                params: {
                    item: this.product
                }
            });
        }
    },

    mounted: function mounted() {},

    created: function created() {
        if (this.$route.params.item && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$route.params.item).length > 0) {
            this.product = this.$route.params.item;
        } else {
            this.$router.push('/manage/items');
        }
    }
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Account_Resources_commonfunctions__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__Account_Resources_commonfunctions__["a" /* default */]],
  props: ['order_data'],
  data: function data() {
    return {
      order_add_info: {},
      setAddOrderAdditionalView: false
    };
  },

  components: {},

  methods: {
    setPage: function setPage() {
      this.loading = true;

      var set_business = this.$route.params.business;
      var set_order_ref = this.$route.params.ref;
      if (set_business != undefined && set_business != '') {
        if (set_order_ref != undefined && set_order_ref != '') {
          var payload = {
            ref: set_order_ref
          };
          this.getOrderDetails(payload);
        }
      }
    }
  },

  created: function created() {
    var self = this;
    localforage.getItem(this.getService.bdb_name, function (err, value) {
      if (value != undefined) {
        self.sellpoint = value;console.log(self.sellpoint);
      }
    });
  }
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service__ = __webpack_require__(1);




var service = new __WEBPACK_IMPORTED_MODULE_2__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    props: {
        chatter: Object
    },
    watch: {
        chatter: function chatter(newVal, oldVal) {
            this.set_chat_view = false;
            this.chat_log = [];
            this.getChatLogs();
        }
    },
    data: function data() {
        return {
            user: {},
            chat: {},

            chatter_set: {},
            chat_logs: {},
            chat_log: {},
            active_chat: {},
            disable_btn: false,
            loggedIn: false,
            loading: true,
            action_loading: {},
            menu_tab_view: {},
            set_chat_view: false,
            style1: {
                margin: '0.6em 0',
                borderRadius: '1em',
                border: '#e6e3e3 solid',
                padding: '0.5em',
                width: '85%',
                textAlign: 'left',
                float: 'right'
            },
            style2: {
                margin: '0.6em 0',
                borderRadius: '1em',
                border: '#e6e3e3 solid',
                padding: '0.5em',
                width: '85%',
                textAlign: 'left',
                float: 'left'
            }
        };
    },


    components: {},
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        setChatStyle: function setChatStyle(chat) {
            if (this.chatter_set.chatter_chat_from == chat.chat_from) {
                return this.style1;
            } else {
                return this.style2;
            }
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == "reset-edit") {}
        },
        setMenuTabView: function setMenuTabView(view, attr1, attr2) {
            if (this.menu_tab_view[view] == true) {
                this.menu_tab_view = {};
                this.setComponent('reset-edit', '');
            } else {
                this.setComponent('reset-edit', '');
                this.menu_tab_view = {};
                this.menu_tab_view[view] = true;
            }
        },
        preset_xtra: function preset_xtra() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        preset: function preset() {
            this.loading = true;
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                    self.user.user_name = value.user_name;
                    self.getChatLogs();
                    setTimeout(function () {
                        self.loadChatLogs();
                    }, 30000);


                    self.loading = false;
                } else {
                    self.$router.push('login');
                }
            });
        },
        loadChatLogs: function loadChatLogs() {
            var self = this;
            setInterval(function () {
                self.getChatLogs();
            }, 30000);
        },
        loadCurrentChatLog: function loadCurrentChatLog(ini) {
            var self = this;
            setInterval(function () {
                self.getChatLog(ini);
            }, 10000);
        },
        setChatLog: function setChatLog(chatlog) {
            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(chatlog).length != 0) {
                if (chatlog.chatlog_from_to_module == 20) {
                    this.chatter_set.chatter_chat_group = chatlog.chatlog_from_to;
                    this.chatter_set.chatter_chat_to = chatlog.chatlog_from_to;
                    this.chatter_set.chatter_chat_to_module = 20;
                } else {
                    this.chatter_set.chatter_chat_group = 0;
                    this.chatter_set.chatter_chat_to = chatlog.chatlog_from_to;
                    this.chatter_set.chatter_chat_to_module = chatlog.chatlog_from_to_module;
                }
            }

            this.chat_log = chatlog;
            this.set_chat_view = true;
            this.loadCurrentChatLog(chatlog.chat_ref);
        },
        getChatLogs: function getChatLogs() {
            var _this2 = this;

            if (this.chatter_set && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.chatter_set).length > 0) {
                service.getChatLogs(this, this.chatter_set.chatter_chat_from_module, this.chatter_set.chatter_chat_from).then(function (response) {
                    if (response.body.status == 200) {
                        _this2.chat_logs = response.body.data;

                        if (_this2.chatter_set.chatter_set_active_chat != 0) {
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;

                            try {
                                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this2.chat_logs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    var chat_log = _step.value;

                                    if (_this2.chatter_set.chatter_set_active_chat == chat_log.chatlog_ref) {
                                        _this2.chat_log = chat_log;
                                        _this2.set_chat_view = true;
                                        _this2.setChatLog(_this2.chat_log);
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return) {
                                        _iterator.return();
                                    }
                                } finally {
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }

                            _this2.set_chat_view = true;

                            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this2.chat_log).length === 0) {
                                _this2.chat_log = [];
                                _this2.setChatLog(_this2.chat_log);
                            }
                        }
                    }
                }).catch(function (err) {});
            }
        },
        getChatLog: function getChatLog(ini) {
            if (this.chat_log && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.chat_log).length > 0) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.chat_logs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var chat_log = _step2.value;

                        if (this.chat_log.chatlog_ref == chat_log.chatlog_ref) {
                            this.set_chat_view = true;
                            this.chat_log = chat_log;
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
        },
        postChatObject: function postChatObject(product) {
            this.chat.chat_message_type = 8;
            this.chat.chat_message_object = product.product_id;
            this.chat.chat_message_object_name = product.product_name;
            this.chat.chat_message_object_price = product.product_items[0].product_item_price;
            this.chat.chat_message_object_url = product.product_url_name;
            this.chat.chat_message_object_media = product.product_images[0].product_image;
            this.postChat();
        },
        postChat: function postChat() {
            var _this3 = this;

            this.chat.chat_message = this.chat.chat_set_message;
            this.chat.chat_set_message = "";
            this.activate_processing();

            var payload = {
                chat_module: this.chatter_set.chatter_chat_from_module,
                chat_module_id: this.chatter_set.chatter_chat_from,
                chat_ini: this.chatter_set.chatter_chat_from,
                chat_type: 0,
                chat_from: this.chatter_set.chatter_chat_from,
                chat_from_point_module: this.chatter_set.chatter_chat_from_module,
                chat_to: this.chatter_set.chatter_chat_to,
                chat_to_point_module: this.chatter_set.chatter_chat_to_module,
                chat_group: this.chatter_set.chatter_chat_group || 0,
                chat_message: this.chat.chat_message || "",
                chat_message_type: this.chat.chat_message_type || 0,
                chat_message_object: this.chat.chat_message_object || 0,
                chat_message_object_name: this.chat.chat_message_object_name || "",
                chat_message_object_price: this.chat.chat_message_object_price || 0,
                chat_message_object_url: this.chat.chat_message_object_url || "",
                chat_message_object_media: this.chat.chat_message_object_media || ""
            };

            if (payload.chat_message == "" && payload.chat_message_object == 0) {
                this.data_processing_message = "Nothing Sent";
                this.deactivate_processing();
            } else {
                service.postChat(this, payload).then(function (data) {
                    if (data.body.status == 201 || data.body.status == 200) {
                        this.chatter_set.chatter_set_active_chat = this.chatter_set.chatter_chat_from.concat(this.chatter_set.chatter_chat_from_module).concat(this.chatter_set.chatter_chat_to).concat(this.chatter_set.chatter_chat_to_module);
                        this.chat = {};
                        this.getChatLogs();
                        this.setMenuTabView("");
                        this.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this3.delivery_option = {};
                    _this3.deactivate_processing();
                });
            }
        },
        chat_callPostChat: function chat_callPostChat(chatter_set, chat_set) {
            this.chatter_set = chatter_set;
            this.chat = chat_set;
            this.postChat();
        }
    },
    created: function created() {
        this.chatter_set = this.chatter;

        if (this.chatter != undefined) {
            if (this.chatter.chatter_style == undefined || this.chatter.chatter_style == '') {
                this.chatter.chatter_style = 0;
                this.chatter_set.chatter_style = 0;
            }
        }
        this.preset();
    }
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vee_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_clipboard__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_v_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_swiper_dist_css_swiper_css__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(98);














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vee_validate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_v_clipboard___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  template: '\n    <div id="app">\n      <router-view></router-view>\n    </div>\n    '
}).$mount('#app');

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'AccountDashboard',
    data: function data() {
        return {
            sps: {}
        };
    },


    components: {},

    methods: {
        back: function back() {
            window.history.back();
        },
        setSP: function setSP(sp) {
            this.$store.dispatch('account/userAccountBusiness', sp);
            this.$router.push('/dashboard/business');
        }
    },

    created: function created() {
        var self = this;
    }
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resources_script_js__ = __webpack_require__(23);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Settings',
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Resources_script_js__["a" /* default */]],
    data: function data() {
        return {};
    },


    components: {},

    methods: {
        backTo: function backTo() {
            window.history.back();
        }
    },

    created: function created() {
        this.loading = true;
        var self = this;
        setTimeout(function () {
            self.getAppGroup(self.$route.params.ref);
        }, 2000);
    }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resources_script_js__ = __webpack_require__(23);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Settings',
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Resources_script_js__["a" /* default */]],
    data: function data() {
        return {};
    },


    components: {},

    methods: {
        backTo: function backTo() {
            window.history.back();
        }
    },

    created: function created() {
        this.loading = true;
        var self = this;
        setTimeout(function () {
            self.getAppGroups();
        }, 1000);
    }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Account',
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__["a" /* default */]],
    data: function data() {
        return {};
    },


    components: {},

    methods: {
        setPage: function setPage() {
            this.loadCategories();
        },
        setMoreDetails: function setMoreDetails() {},
        setCategory: function setCategory(data) {
            this.$store.dispatch('account/setCategory', data);
            this.$router.push('/account/business/category');
        },
        setProduct: function setProduct(data) {
            this.$store.dispatch('account/setProduct', data);
            this.$router.push('/account/business/product');
        }
    },

    created: function created() {
        this.setPage();
    }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Account',
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__["a" /* default */]],
    data: function data() {
        return {};
    },


    components: {},

    methods: {
        setPage: function setPage() {},
        setProduct: function setProduct(data) {
            this.$store.dispatch('account/setProduct', data);
            this.$router.push('/account/business/product');
        },
        prepAddProduct: function prepAddProduct() {
            this.$router.push('/account/business/newproduct');
        }
    },

    created: function created() {
        var self = this;
        localforage.getItem('xvue', function (err, value) {
            if (value != undefined) {
                self.category = value.account.store_sellpoint.store_category;

                self.getBusinessCategoryProducts();
            } else {}
        });

        this.setMenuTabInnerView('viewBusinessCategory', '', '');
    }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrderDetailsRequest_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrderDetailsRequest_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__OrderDetailsRequest_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Resources_commonfunctions__["a" /* default */]],
    data: function data() {
        return {};
    },

    components: {
        'order-request': __WEBPACK_IMPORTED_MODULE_1__OrderDetailsRequest_vue___default.a
    },

    methods: {
        setPage: function setPage() {
            this.loading = true;

            this.getAppBusinessOrders();

            this.getAppBusinessOrdersPendingPayments();
        }
    },

    created: function created() {
        var self = this;
        localforage.getItem('xvue', function (err, value) {
            if (value != undefined) {
                self.sellpoint = value.account.store_sellpoint.store_sellpointData;
                self.setPage();
            } else {}
        });
    }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Resources_commonfunctions__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'AccountProduct',
    mixins: [__WEBPACK_IMPORTED_MODULE_1__Resources_commonfunctions__["a" /* default */]],
    data: function data() {
        return {
            product: {}
        };
    },


    components: {},

    methods: {
        setPage: function setPage() {
            var self = this;
            localforage.getItem('xvue', function (err, value) {
                if (value != undefined) {
                    self.product = value.account.store_sellpoint.store_product;
                    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(self.product).length > 0) {
                        self.loading = false;

                        self.getSetProduct(self.product);
                    }
                } else {}
            });
        }
    },

    created: function created() {
        console.log('h777ggg' + this.header_name);
        this.header_name = "mmmmm";console.log('h4444777ggg' + this.header_name);
        this.setMenuTabView('product', 'viewBusinessCategoryProduct', '', '');
        this.setPage();
    }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Resources_commonfunctions__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'AccountProduct',
    mixins: [__WEBPACK_IMPORTED_MODULE_1__Resources_commonfunctions__["a" /* default */]],
    data: function data() {
        return {};
    },


    components: {},

    methods: {
        setPage: function setPage() {
            this.action_loading = true;
            var self = this;
            localforage.getItem('xvue', function (err, value) {
                if (value != undefined) {
                    self.sellpoint = value.account.store_sellpoint.store_sellpointData;
                    self.products = value.account.store_sellpoint.store_products;
                    if (self.products == undefined || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(self.products).length == 0) {
                        self.getSellpointProducts();
                    } else {
                        self.action_loading = false;
                    }
                } else {}
            });
        },
        setProduct: function setProduct(data) {
            this.$store.dispatch('account/setProduct', data);
            this.$router.push('/account/business/product');
        }
    },

    created: function created() {
        this.setPage();
        this.loadCategories();
    }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Resources_commonfunctions__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ShopSettings',
    mixins: [__WEBPACK_IMPORTED_MODULE_1__Resources_commonfunctions__["a" /* default */]],
    data: function data() {
        return {
            product: {}
        };
    },


    components: {},

    methods: {
        setPage: function setPage() {
            this.product = this.$store.getters['account/getProduct'];
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.product).length > 0) {}
        }
    },

    created: function created() {
        this.setMenuTabView('business', 'manageBusiness', '', '');
    }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resources_script_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sellpoint_Components_AddBusiness__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sellpoint_Components_AddBusiness___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Sellpoint_Components_AddBusiness__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Refer',
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Resources_script_js__["a" /* default */]],
    data: function data() {
        return {
            sellpoints_max: 10,
            set_view: 'business',
            action_loading: 1000000000
        };
    },


    components: {
        'component-createsellpoint': __WEBPACK_IMPORTED_MODULE_1__Sellpoint_Components_AddBusiness___default.a
    },

    methods: {
        setViewBusiness: function setViewBusiness(business_username, index) {
            this.action_loading = index;
            this.storeSetBusiness(business_username, 1);
        }
    },

    created: function created() {
        this.loading = true;

        var self = this;
        setTimeout(function () {
            if (self.loadUser) {
                self.getSellpoints(self.user.user_id);
            }
        }, 3000);
    }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sellpoint_Template_script_js__ = __webpack_require__(58);


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Settings',
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Sellpoint_Template_script_js__["default"]],
    data: function data() {
        return {};
    },


    components: {},

    methods: {
        backTo: function backTo() {
            window.history.back();
        }
    },

    created: function created() {
        this.loading = true;
        var self = this;
        setTimeout(function () {
            self.setSellpoint();
        }, 3000);
    }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resources_script_js__ = __webpack_require__(23);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Account',
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Resources_script_js__["a" /* default */]],
    data: function data() {
        return {
            sps: {},
            can_multiple_shops: true,
            can_show_footer: true
        };
    },


    components: {},

    methods: {
        back: function back() {
            window.history.back();
        },
        setSP: function setSP(sp) {
            this.$store.dispatch('account/userAccountBusiness', sp);
            this.$router.push('/dashboard/business');
        },
        routeToPage: function routeToPage(page) {
            this.$router.push(page);
            this.set_menu = false;
        },
        canShowFooter: function canShowFooter() {
            console.log('lo....' + this.$route.name);
            if (this.$route.name == 'Sellpoint') {
                this.can_show_footer = false;
            }
        }
    },

    mounted: function mounted() {
        this.canShowFooter();
    },

    created: function created() {
        var self = this;
    }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Account_Resources_commonfunctions_js__ = __webpack_require__(3);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    mixins: [__WEBPACK_IMPORTED_MODULE_3__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            header_data: {}
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    computed: {},
    methods: {
        preset: function preset() {
            this.loading = true;
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;
                    self.loggedIn = true;
                    self.setSiteUser();
                    self.loading = false;
                } else {
                    self.$router.push('login');
                }
            });
        },
        setPageCalls: function setPageCalls() {
            this.customGetAgentServiceActivities();
        }
    },
    created: function created() {
        this.preset();

        this.header_data.name = this.$route.name;
    }
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Account_Resources_commonfunctions_js__ = __webpack_require__(3);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    mixins: [__WEBPACK_IMPORTED_MODULE_3__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            header_data: {}
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    computed: {},
    methods: {
        preset: function preset() {
            this.loading = true;
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;
                    self.loggedIn = true;
                    self.setSiteUser();
                    self.loading = false;
                } else {
                    self.$router.push('login');
                }
            });
        },
        setPageCalls: function setPageCalls() {
            this.getBusinessProcessingFeesTransactions();
        }
    },
    created: function created() {
        this.preset();
        this.header_data.name = "Service Charges";
    }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Account_Resources_commonfunctions_js__ = __webpack_require__(3);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    mixins: [__WEBPACK_IMPORTED_MODULE_3__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            header_data: {}
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    computed: {},
    methods: {
        preset: function preset() {
            this.loading = true;
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;
                    self.loggedIn = true;
                    self.setSiteUser();
                    self.loading = false;
                } else {
                    self.$router.push('login');
                }
            });
        },
        setPageCalls: function setPageCalls() {
            this.getBusinessProcessingFeesTransactions();
        },
        getBusinessCategories: function getBusinessCategories() {
            service.getCategories(this).then(function (data) {
                this.categories = data.body.data;
            });
        }
    },
    created: function created() {
        this.header_data.name = "Setup Shop";
        this.preset();
        this.getRavepayBanks();
        this.getBusinessCategories();
    }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Account_Resources_commonfunctions_js__ = __webpack_require__(3);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    mixins: [__WEBPACK_IMPORTED_MODULE_3__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            header_data: {}
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    computed: {},
    methods: {
        preset: function preset() {
            this.loading = true;
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;
                    self.loggedIn = true;
                    self.setSiteUser();
                    self.loading = false;
                } else {
                    self.$router.push('login');
                }
            });
        },
        setPageCalls: function setPageCalls() {
            this.customGetAgentServices(3);
        }
    },
    created: function created() {
        this.preset();

        this.header_data.name = this.$route.name;
    }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Account_Resources_commonfunctions_js__ = __webpack_require__(3);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    mixins: [__WEBPACK_IMPORTED_MODULE_3__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            header_data: {},
            user: {},
            loggedIn: false,
            loading: true,
            tab_view: {},
            menu_tab_view: {},
            set_view: false,
            img_product_url: service.imageProductsURL
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == "reset-edit") {}
        },
        setTabComponent: function setTabComponent(view) {
            this.tab_view = {};
            this.tab_view[view] = true;
        },
        setMenuTabView: function setMenuTabView(view, attr1, attr2) {
            if (this.menu_tab_view[view] == true) {
                this.menu_tab_view = {};
            } else {
                this.menu_tab_view = {};
                this.menu_tab_view[view] = true;
            }

            if (view == "viewTransfer") {
                this.transfer = attr1;
            }
        },
        preset: function preset() {
            this.loading = true;
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;
                    self.loggedIn = true;
                    self.setSiteUser();
                    self.loading = false;
                } else {
                    self.$router.push('login');
                }
            });
        },
        setPageCalls: function setPageCalls() {
            this.getBusinessProcessingFeesTransactions();

            var payload = {
                data_module: 3,
                data_module_id: this.sellpoint.business_id
            };
            this.getCollections(payload);
        }
    },
    created: function created() {
        if (this.$route.path == '/agentservices') {
            this.preset();
            this.header_data.name = "Agent Services";
        }
    }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Buypoint',
    data: function data() {
        return {
            child_route_view: false,
            loading: false,
            loggedIn: false,
            user: {},
            sellpoint: {},
            set_gallery_banner_image: ""
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        setSellpoint: function setSellpoint() {
            var _this = this;

            this.loading = true;
            service.getAppBusinessByUserName(this, service.business_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this.sellpoint = response.body.data;
                    document.title = _this.sellpoint.business_name + " | SP";

                    if (_this.sellpoint.business_banner_image == _this.default_banner_image || _this.sellpoint.business_banner_image == 'error') {
                        _this.set_gallery_banner_image = service.general_banner_image;
                    } else {
                        _this.set_gallery_banner_image = _this.sellpoint.business_banner_image;
                    }

                    if (_this.sellpoint.business_market_subscription_name == 'Bird Plan') {
                        _this.max_plan_lookbooks = 2;
                        _this.max_plan_lookbook_posts = 5;
                    }
                    if (_this.sellpoint.business_market_subscription_name == 'Mid Bird Plan') {
                        _this.max_plan_lookbooks = 10;
                        _this.max_plan_lookbook_posts = 50;
                    }
                    if (_this.sellpoint.business_market_subscription_name == 'Max Bird Plan') {
                        _this.max_plan_lookbooks = 50;
                        _this.max_plan_lookbook_posts = 50;
                        _this.can_add_product_lookbook = true;
                    }

                    _this.preset();
                    _this.loading = false;
                } else {
                    _this.business_load_error_msg = "Sorry, this Business Information could not be found.";
                }
            }).catch(function (err) {
                _this.loading = false;
            });
        }
    },

    created: function created() {
        this.setSellpoint();
    }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources_activity_js__ = __webpack_require__(40);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Wishlist',
    mixins: [__WEBPACK_IMPORTED_MODULE_2__resources_activity_js__["a" /* default */]],
    data: function data() {
        return {
            loading: false,
            wishlist: {}
        };
    },


    methods: {},
    mounted: function mounted() {},
    created: function created() {}
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_chat_index_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_chat_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_templates_chat_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_postsco_index_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_postsco_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_mixins_postsco_index_vue__);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Buypoint',
    mixins: [__WEBPACK_IMPORTED_MODULE_4__components_mixins_postsco_index_vue___default.a],
    data: function data() {
        return {
            child_route_view: false,
            loading: false,
            loggedIn: false,
            user: {},
            data_ref_link: "",
            ref_bash_details: {},
            set_shop_together: false,
            shop_together_data: {},
            shop_together_join: false,
            active_shop_together: {},
            menu_view: {},
            menu_tab_view: {},
            menu_tab_inner_view: {},
            group: {}
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'component-chatroom': __WEBPACK_IMPORTED_MODULE_3__components_templates_chat_index_vue___default.a
    },
    methods: {
        setMenuTabView: function setMenuTabView(view, attr1, attr2) {
            this.menu_tab_inner_view = {};
            this.menu_tab_view = {};
            this.menu_tab_view[view] = true;
        },
        preset: function preset() {
            this.loading = true;
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                    self.user.user_name = value.user_name;
                    self.loggedIn = true;
                    self.loading = false;
                    self.getShopTogetherActivities();
                } else {
                    self.$router.push('login');
                }
            });
        },
        setReferralBash: function setReferralBash() {
            var _this = this;

            var set_ref_for = this.user.user_id;

            var payload = {
                ref_user: this.user.user_id,
                ref_of_type: 45,
                ref_of: 0,
                ref_for: 0
            };
            service.setReferralBash(this, payload).then(function (response) {
                var data_ref_bash = response.body.data_ref_bash;
                if (data_ref_bash && data_ref_bash != "") {
                    _this.data_ref_link = service.app_url + "/shoptogether" + "/" + data_ref_bash;

                    _this.setShopTogetherActivity(response.body.data_ref_bash_no);
                }
            }).catch(function (err) {});
        },
        getReferralBashDetails: function getReferralBashDetails() {
            var _this2 = this;

            service.getReferralBashDetails(this, this.$route.params.ref).then(function (response) {
                if (response.body.status == 200) {
                    _this2.ref_bash_details = response.body.data;
                    _this2.shop_together_join = true;
                }
            }).catch(function (err) {});
        },
        getShopTogetherActivities: function getShopTogetherActivities() {
            var _this3 = this;

            var payload = {
                activity_user: this.user.user_id,
                activity_type: 45 };
            service.getActivities(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this3.shop_together_data = response.body.data;
                    _this3.setActiveShopTogetherActivities();
                }
            }).catch(function (err) {});
        },
        setActiveShopTogetherActivities: function setActiveShopTogetherActivities() {
            if (this.shop_together_data.length > 0) {
                localStorage.setItem("active_shop_together_alert", 1);
            } else {
                localStorage.removeItem("active_shop_together_alert");
            }

            var self = this;
            localforage.setItem(service.s2gdb_name, self.shop_together_data).then(function (value) {}).catch(function (err) {});
        },
        setShopTogetherActivity: function setShopTogetherActivity(data_id) {
            var _this4 = this;

            if (data_id > 0 || data_id != undefined) {
                var payload = {
                    activity_user: this.user.user_id,
                    activity_type: 45,
                    activity_action_type: 46,
                    activity_module: 34,
                    activity_module_id: data_id
                };
                service.setActivity(this, payload).then(function (response) {
                    if (response.body.status == 201 || response.body.status == 409) {
                        _this4.set_shop_together = true;

                        var group = {
                            group_name: "Shop together with " + _this4.user.user_name,
                            group_description: "Activity Shop together with " + _this4.user.user_name,
                            group_module: 35,
                            group_module_id: response.body.data_activity
                        };
                        _this4.postsco_callCreateNewGroup(group);
                    }
                }).catch(function (err) {});
            }
        },
        setShopTogetherJoinIn: function setShopTogetherJoinIn() {
            var _this5 = this;

            var data_ref_bash = this.$route.params.ref;
            if (data_ref_bash != '' || data_ref_bash != undefined) {
                var payload = {
                    activity_user: this.user.user_id,
                    activity_type: 45,
                    activity_action_type: 47,
                    activity_module: 34,
                    activity_ref_bash: data_ref_bash };
                service.setActivity(this, payload).then(function (response) {
                    if (response.body.status == 200 || response.body.status == 201 || response.body.status == 409) {
                        _this5.set_shop_together = true;

                        var members_arr = [];
                        var member = {
                            member_group: 0,
                            member_group_module: 35,
                            member_group_module_id: response.body.data_activity || 0,
                            member_type: 3,
                            member_module: 1,
                            member_id: _this5.user.user_id
                        };
                        members_arr.push(member);
                        _this5.postsco_callAddNewGroupMembers(members_arr);
                    }
                }).catch(function (err) {});
            }
        },
        setActiveShopTogetherStatus: function setActiveShopTogetherStatus(activity, status) {
            var payload = {
                activity: activity,
                activity_type: status
            };
            service.updateActivity(this, payload).then(function (response) {
                if (response.body.status == 200) {}
            }).catch(function (err) {});
        }
    },

    created: function created() {
        this.preset();
        if (this.$route.params.ref) {
            this.getReferralBashDetails();
        }
    }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Home_index_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Home_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Home_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_rightsidebar_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_rightsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_templates_rightsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_leftsidebar_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_leftsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_templates_leftsidebar_vue__);







var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    data: function data() {
        return {
            user: {},
            market: {},
            market_groups: {},
            market_trending: {},
            products: {},
            product: {},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            menu_view: {}
        };
    },


    components: {
        'component-landing': __WEBPACK_IMPORTED_MODULE_1__Home_index_vue___default.a,
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a,
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_4__components_templates_rightsidebar_vue___default.a,
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_5__components_templates_leftsidebar_vue___default.a
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        preset_xtra: function preset_xtra() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        preset: function preset() {
            this.loading = true;
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;
                    self.loading = false;
                } else {
                    self.$router.push('login');
                }
            });
        },
        setMarketRemote: function setMarketRemote() {
            var _this2 = this;

            service.getBusinessByUserName(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this2.market = response.body.data;
                    _this2.loading = false;
                }
            }).catch(function (err) {});
        },
        setMarketActivities: function setMarketActivities() {
            var _this3 = this;

            service.getMarketActivityProducts(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this3.market_trending = response.body.data;
                }
            }).catch(function (err) {});
        },
        setMarketGroups: function setMarketGroups() {
            var _this4 = this;

            service.getMarketGroupsProducts(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this4.market_groups = response.body.data;
                }
            }).catch(function (err) {});
        },
        setMenuComponent: function setMenuComponent(view, view_type, attr1, attr2) {
            var top = document.getElementById("topPanel").offsetTop;
            window.scrollTo(0, top);

            this.menu_view = {};
            this.menu_view[view] = true;
        }
    },
    created: function created() {
        this.menu_view["timeline"] = true;
        this.preset();
        this.setMarketRemote();
        this.setMarketGroups();
        this.setMarketActivities();
    }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_preset_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_chat_index_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_chat_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_templates_chat_index_vue__);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Chat',
    mixins: [__WEBPACK_IMPORTED_MODULE_1__resources_preset_js__["a" /* default */]],
    data: function data() {
        return {
            menu_view: {},
            menu_tab_view: {},
            menu_tab_inner_view: {}
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a,
        'component-chatroom': __WEBPACK_IMPORTED_MODULE_4__components_templates_chat_index_vue___default.a
    },
    methods: {
        setMenuTabView: function setMenuTabView(view, attr1, attr2) {
            this.menu_tab_inner_view = {};
            this.menu_tab_view = {};
            this.menu_tab_view[view] = true;
        }
    },

    created: function created() {}
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    data: function data() {
        return {
            header_data: {},
            user: {},
            collections: {},
            gigs: {},
            total_collection_balance: 0,
            total_gigs_balance: 0,
            app_collection_balance: 0,
            loggedIn: false,
            loading: true,
            set_cashout_gig: false,
            tab_view: {},
            menu_tab_view: {},
            gigs_amount_to_cashout: 0,
            gigs_cash_out_proc_fee: service.app_gigs_cash_out_proc_fee
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue___default.a,
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue___default.a
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == "reset-edit") {}
        },
        setTabComponent: function setTabComponent(view) {
            this.tab_view = {};
            this.tab_view[view] = true;
        },
        setMenuTabView: function setMenuTabView(view, attr1, attr2) {
            if (this.menu_tab_view[view] == true) {
                this.menu_tab_view = {};
                this.setComponent('reset-edit', '');
            } else {
                this.setComponent('reset-edit', '');
                this.menu_tab_view = {};
                this.menu_tab_view[view] = true;
            }
        },
        checkCashOutGigs: function checkCashOutGigs() {
            this.gigs_amount_to_cashout = Number(this.gigs_amount_to_cashout);
            if (this.gigs_amount_to_cashout > this.gigs_collection_balance) {
                this.gigs_amount_to_cashout = this.gigs_collection_balance;
            }
        },
        preset_xtra: function preset_xtra() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        preset: function preset() {
            this.loading = true;
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;

                    self.getMonies();
                    self.loading = false;
                } else {
                    self.$router.push('login');
                }
            });
        },
        getCollections: function getCollections() {
            var _this2 = this;

            service.getUserCollections(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.collections = response.body.data;
                    _this2.collections_businesses = response.body.data_collections_businesses;
                    _this2.total_collection_balance = response.body.data_total_balance;

                    _this2.loading = false;
                }
            }).catch(function (err) {});
        },
        getMonies: function getMonies() {
            var _this3 = this;

            service.getUserMonies(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this3.total_collection_balance = response.body.data_collection_total_balance;
                    _this3.collections = response.body.data_collection_data;

                    _this3.total_gigs_balance = response.body.data_gigs_total_balance;
                    _this3.gigs = response.body.data_gigs_data;

                    _this3.loading = false;
                }
            }).catch(function (err) {});
        },
        cashOutGigs: function cashOutGigs() {
            var _this4 = this;

            var payload = {
                data_business: 0,
                data_type: 29,
                data_user: this.user.user_id,
                data_amount_paid: this.gigs_amount_to_cashout,
                data_action_type: 7,
                data_module: 0,
                data_module_id: 0,
                data_module_order_service_payment_ref: "" };
            if (payload.data_amount_paid == 0) {
                this.data_processing_message = "Amount should be more than 0";
            } else {
                service.postCollectionsServices(this, payload).then(function (response) {
                    if (response.body.status == 201 || response.body.status == 200) {
                        this.getCollections();

                        this.gigs_amount_to_cashout = 0;
                    }
                }).catch(function (err) {
                    _this4.gigs_amount_to_cashout = 0;
                });
            }
        }
    },
    created: function created() {
        this.preset();
        this.setTabComponent('tab02');
        this.header_data.name = "Collections";
    }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Account_Resources_commonfunctions_js__ = __webpack_require__(3);





var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CreateAccount',
    mixins: [__WEBPACK_IMPORTED_MODULE_3__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints: {},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error: false,
            group_isset: false,
            add_sellpoint: false,
            add_business: false,
            get_flag: false,
            loading: false,
            action_loading: false,

            validate_user_name_message: "",
            payment_successful_message: "",
            data_error_message: "",
            data_boarding_message: "",

            headerdata: {
                'name': 'Create Your Order'
            }
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        preset: function preset() {
            this.loading = true;

            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;
                    localforage.getItem(service.bdb_name, function (err, value) {
                        if (value != undefined) {
                            self.sellpoint = value;

                            self.setBusinessDetails();

                            self.getSellpointProducts();
                        } else {
                            self.loading = false;
                        }
                    });
                } else {
                    self.loading = false;
                }
            });
        },
        setBusinessDetails: function setBusinessDetails() {
            var self = this;
            localforage.getItem(service.bbnksdb_name, function (err, value) {
                if (value != undefined) {
                    console.log(7654999);
                    self.sellpoint.business_bank_details = value;
                    self.business_bank_details = value;
                }
                self.loading = false;
            });

            localforage.getItem(service.bbdlsdb_name, function (err, value) {
                if (value != undefined) {
                    self.sellpoint.business_delivery_options = value;
                    self.business_delivery_locations = value;
                }
                self.loading = false;
            });
        },
        set_checked: function set_checked(set) {
            var done = true;

            return done;
        }
    },
    created: function created() {
        this.preset();

        this.getRavepayBanks();
    }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Account_Resources_commonfunctions_js__ = __webpack_require__(3);





var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CreateSellpoint',
    mixins: [__WEBPACK_IMPORTED_MODULE_3__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints: {},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error: false,
            group_isset: false,
            add_sellpoint: false,
            add_business: false,
            get_flag: false,
            loading: false,
            action_loading: false,

            validate_user_name_message: "",
            payment_successful_message: "",
            data_error_message: "",
            data_boarding_message: "",

            headerdata: {
                'name': 'Create Your Order'
            }
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        preset: function preset() {
            this.loading = true;

            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;
                    localforage.getItem(service.bdb_name, function (err, value) {
                        if (value != undefined) {
                            self.sellpoint = value;

                            self.setBusinessDetails();

                            self.getSellpointProducts();
                        } else {
                            self.$router.push('/create/account/business');
                        }
                    });
                } else {
                    self.$router.push('/login');
                }
            });
        },
        setBusinessDetails: function setBusinessDetails() {
            var self = this;
            localforage.getItem(service.bbnksdb_name, function (err, value) {
                if (value != undefined) {
                    console.log(7654999);
                    self.sellpoint.business_bank_details = value;
                    self.business_bank_details = value;
                }
                self.loading = false;
            });

            localforage.getItem(service.bbdlsdb_name, function (err, value) {
                if (value != undefined) {
                    self.sellpoint.business_delivery_options = value;
                    self.business_delivery_locations = value;
                }
                self.loading = false;
            });
        },
        set_checked: function set_checked(set) {
            var done = true;

            return done;
        }
    },
    created: function created() {
        this.preset();

        this.getRavepayBanks();
    }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CreateSellpoint',
    data: function data() {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints: {},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error: false,
            group_isset: false,
            add_sellpoint: false,
            add_business: false,
            get_flag: false,
            loading: false,
            action_loading: false,

            validate_user_name_message: "",
            payment_successful_message: "",
            data_error_message: "",
            data_boarding_message: ""
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        validateUserName: function validateUserName() {
            var _this = this;

            service.validateBusinessUserName(this, this.business).then(function (response) {
                if (response.body.status == 200) {
                    _this.validate_user_name_error = false;
                    _this.validate_user_name_message = "This sellpoint does not exist";
                } else {
                    _this.validate_user_name_error = true;
                    _this.validate_user_name_message = "This username already exist";
                }
            }).catch(function (err) {
                _this.validate_user_name_error = true;
                _this.validate_user_name_message = "This username already exist";
            });
        },
        preset: function preset() {
            this.loading = true;
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;

                    self.getBusinessCategories();
                    self.getMarketCategories();
                } else {}
            });
        },
        getStates: function getStates() {
            service.getStates(this).then(function (data) {
                this.states = data.body;
            });
        },
        getCities: function getCities(state) {
            service.getCities(this, state).then(function (data) {
                this.cities = data.body;
            });
        },
        getBusinessCategories: function getBusinessCategories() {
            service.getCategories(this).then(function (data) {
                this.categories = data.body.data;
            });
        },
        getMarketCategories: function getMarketCategories() {
            service.getMarketCategories(this).then(function (data) {
                this.market_categories = data.body.data;
            });
        },
        getBusinessMarketGroups: function getBusinessMarketGroups() {
            service.getBusinessMarketGroups(this).then(function (data) {
                this.market_groups = data.body.data;
            });
        },
        getSellpoints: function getSellpoints(user) {
            var _this2 = this;

            service.getBusinesses(this, user).then(function (data) {
                if (data.body.status == 200) {
                    var result = data.body.data;
                    var arr = [];
                    result.forEach(function (element) {
                        if (element.business_type == 1) {
                            arr.push(element);
                        }
                    });
                    _this2.sellpoints = arr;
                }
            }).catch(function (err) {
                if (err) {
                    console.log(err);
                }
            });
        },
        setUpNewAccountBusiness: function setUpNewAccountBusiness() {
            var _this3 = this;

            this.resetMessages();
            this.activate_processing();
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: service.market_app_name,
                business_layout: 3,
                business_subscription: this.selected_plan_product_service_item.product_item_id
            };
            var navi = this.$router;
            if (this.validate_user_name_error) {
                this.data_error_message = "This Username already exists..";
                this.deactivate_processing();
            } else {
                if (credentials.business_name != undefined && credentials.business_category != undefined) {
                    service.addNewBusiness(this, credentials).then(function (data) {
                        if (data.body.status == 201) {
                            this.business.business_user_name = data.body.data_business_username;
                            this.data_boarding_message = "Sellpoint Creation Successful.";

                            navi.push('/account');
                        } else {
                            this.data_error_message = "This Username already exists";
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        if (err) {
                            _this3.data_error_message = "Something went wrong";
                            _this3.deactivate_processing();
                        }
                    });
                } else {
                    this.data_error_message = "Kindly fill all fields";
                    this.deactivate_processing();
                }
            }
        },
        setUpExistingAccount: function setUpExistingAccount() {
            var _this4 = this;

            this.activate_processing();
            var credentials = {
                business_user_name: this.user.user_business,
                business_group: service.market_app_name,
                business_subscription: this.selected_plan_product_service_item.product_item_id
            };

            var navi = this.$router;
            service.addExistingBusiness(this, credentials).then(function (data) {
                if (data.body.status == 201 || data.body.status == 200) {
                    this.data_boarding_message = "Sellpoint Setup Successful...";

                    navi.push('/account');
                }
            }).catch(function (err) {
                if (err) {
                    _this4.deactivate_processing();
                }
            });
        },
        createSellpoint: function createSellpoint() {
            var _this5 = this;

            this.disable_btn = true;
            this.business.agree = true;
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_market_category: this.business.market_category || 0,
                business_owner: this.user.user_id
            };
            var navi = this.$router;
            if (this.validate_user_name_error) {
                toastr.error('This Username already exists', 'Warning!');
            } else {
                if (credentials.business_name != undefined && credentials.business_category != undefined) {
                    if (this.business.agree) {
                        service.addBusiness(this, credentials).then(function (data) {
                            if (data.body.status == 201) {
                                toastr.success("Sellpoint Creation Successfull", 'Success!');

                                this.business = data.body.data;
                                navi.push('/' + this.business.business_user_name);
                            }
                        }).catch(function (err) {
                            if (err) {
                                toastr.warning("Something went wrong", 'Warning!');
                                _this5.disable_btn = false;
                            }
                        });
                    } else {
                        toastr.error('Please agree to Terms', 'Warning!');
                        this.disable_btn = false;
                    }
                } else {
                    toastr.error('Kindly fill all fields', 'Warning!');
                    this.disable_btn = false;
                }
            }
        },
        addSelectedExistingSellpoint: function addSelectedExistingSellpoint() {
            var _this6 = this;

            this.disable_btn = true;
            this.business.agree = true;
            var credentials = {
                business_user_name: this.business.business_user_name,
                business_group: localStorage.getItem("sp_#_sellpoint") || "nill"
            };
            var navi = this.$router;
            if (credentials.business_user_name != undefined) {
                service.addExistingBusiness(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Sellpoint Added Successfull", 'Success!');

                        navi.push('/' + localStorage.getItem("sp_#_sellpoint"));
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');
                        _this6.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        addExistingSellpoint: function addExistingSellpoint() {
            var _this7 = this;

            this.disable_btn = true;
            this.business.agree = true;
            var credentials = {
                business_user_name: this.business.business_user_name,
                business_group: localStorage.getItem("sp_#_sellpoint") || "nill"
            };
            var navi = this.$router;
            if (!this.validate_user_name_error) {
                toastr.error('This Sellpoint does not exist', 'Warning!');
            } else {
                if (credentials.business_user_name != undefined) {
                    service.addExistingBusiness(this, credentials).then(function (data) {
                        if (data.body.status == 201) {
                            toastr.success("Sellpoint Added Successfull", 'Success!');

                            navi.push('/' + localStorage.getItem("sp_#_sellpoint"));
                        }
                    }).catch(function (err) {
                        if (err) {
                            toastr.warning("Something went wrong", 'Warning!');
                            _this7.disable_btn = false;
                        }
                    });
                } else {
                    toastr.error('Kindly fill all fields', 'Warning!');
                    this.disable_btn = false;
                }
            }
        },
        addNewSellpoint: function addNewSellpoint() {
            var _this8 = this;

            this.disable_btn = true;
            this.business.agree = true;
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: localStorage.getItem("sp_#_sellpoint") || "nill"
            };
            var navi = this.$router;
            if (this.validate_user_name_error) {
                toastr.error('This Username already exists', 'Warning!');
            } else {
                if (credentials.business_name != undefined && credentials.business_category != undefined) {
                    if (this.business.agree) {
                        service.addNewBusiness(this, credentials).then(function (data) {
                            if (data.body.status == 201) {
                                toastr.success("Sellpoint Creation Successfull", 'Success!');

                                navi.push('/' + localStorage.getItem("sp_#_sellpoint"));
                            }
                        }).catch(function (err) {
                            if (err) {
                                toastr.warning("Something went wrong", 'Warning!');
                                _this8.disable_btn = false;
                            }
                        });
                    } else {
                        toastr.error('Please agree to Terms', 'Warning!');
                        this.disable_btn = false;
                    }
                } else {
                    toastr.error('Kindly fill all fields', 'Warning!');
                    this.disable_btn = false;
                }
            }
        }
    },
    created: function created() {
        this.preset();
        if (this.$route.query.create == "new") {
            this.add_sellpoint = true;
        }
        if (this.$route.query.create == "add") {
            this.add_sellpoint = true;
            this.add_business = true;
        }

        this.getBusinessMarketGroups();
    }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_posts_newgallery_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_posts_newgallery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_posts_newgallery_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_posts_newproductgallery_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_posts_newproductgallery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_posts_newproductgallery_vue__);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Sellpoint',
    data: function data() {
        return {
            user: {},
            market: {},
            sellpoint: {},
            categories: {},
            galleria: {},
            gallery: {},
            gallery_post: {},
            gallery_post_set_image: {},
            post: {},
            products: {},
            product: {},
            productMain: {},
            productItem: {},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            edit_mode: false,
            loading: true,
            online: false,
            place_order: false,
            ordered_product: {},
            ordered_product_item: {},
            swipe_index: 0,

            data_error_message: "",
            data_success_message: "",
            payment_successful: false,
            payment_successful_message: "",
            payment_payer_name: "",
            payment_payer_email: "",
            payment_payer_phone: "",
            payment_service: "",

            addPanel: false,
            business_load_error_msg: "",
            newLookbookForm: false,
            newProductLookbookForm: false,
            max_plan_lookbooks: 0,
            max_plan_lookbook_posts: 0,
            total_lookbooks_added: 0,
            can_add_more_lookbook: false,
            can_add_product_lookbook: false,
            addNewPost: false,
            file_info: {},
            refresh_button: false,
            disable_btn: false,
            action_loading: false,
            default_banner_image: "https://res.cloudinary.com/diprbfy7s/image/upload/v1550754799/businesses_files/sp-default-banner.jpg"

        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'add-lookbook': __WEBPACK_IMPORTED_MODULE_3__components_posts_newgallery_vue___default.a,
        'add-product-lookbook': __WEBPACK_IMPORTED_MODULE_4__components_posts_newproductgallery_vue___default.a
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        mobileSideNavToggle: function mobileSideNavToggle(action) {
            if (action == "open") {
                var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

                if (isMobile) {
                    document.getElementById("mobileSideNav").style.width = "100%";
                } else {
                    document.getElementById("mobileSideNav").style.width = "50%";
                }
            }
            if (action == "close") {
                document.getElementById("mobileSideNav").style.width = "0";
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        checkIfVideo: function checkIfVideo(url) {
            if (url != undefined) {
                var ext = url.split('.').pop();
                if (service.video_exts.includes(ext)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        addComponent: function addComponent(attr1, attr2) {
            this.addPanel = true;

            if (attr1 == "add-new-lookbook") {
                this.newLookbookForm = true;
            }
            if (attr1 == "add-new-product-lookbook") {
                this.newProductLookbookForm = true;
            }
            if (attr1 == "add-new-product-post") {
                this.$router.push("/" + this.$route.params.id + "/" + this.gallery.gallery_posts_group_url_name);
                $('#quickviewModal').modal('hide');

                this.newProductLookbookForm = true;
            }
            if (attr1 == "add-new-post") {
                this.addNewPost = true;
                $('#quickviewModal').modal('hide');
                this.gallery = attr2;
            }

            var top = document.getElementById("addPanelView").offsetTop;
            window.scrollTo(0, top);
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == "refresh-store") {
                this.getGalleryPosts();
            }
        },
        reset: function reset() {
            this.addPanel = false, this.addNewPost = false;
            this.newLookbookForm = false;
            this.newProductLookbookForm = false;
            this.data_error_message = "";
            this.data_success_message = "";
        },
        preset: function preset() {
            var _this = this;

            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                            this.is_editing();
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        is_editing: function is_editing() {
            var _this2 = this;

            if (this.user.user_id != "") {
                var payload = {
                    validate_user: this.user.user_id,
                    validate_business: this.sellpoint.business_id
                };
                service.can_edit(this, payload).then(function (response) {
                    if (response.body.status == 200) {
                        _this2.edit_mode = true;
                    } else {
                        _this2.edit_mode = false;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        setGallery: function setGallery() {
            var _this3 = this;

            this.loading = true;
            service.getGallerySearch(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this3.gallery = response.body.data;

                    _this3.loading = false;
                }
            }).catch(function (err) {
                console.log(err);
            });
        },
        setSellpoint: function setSellpoint() {
            var _this4 = this;

            this.loading = true;
            service.getAppBusinessByUserName(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this4.sellpoint = response.body.data;

                    if (_this4.sellpoint.business_market_subscription_name == 'Bird Plan') {
                        _this4.max_plan_lookbooks = 2;
                        _this4.max_plan_lookbook_posts = 5;
                    }
                    if (_this4.sellpoint.business_market_subscription_name == 'Mid Bird Plan') {
                        _this4.max_plan_lookbooks = 10;
                        _this4.max_plan_lookbook_posts = 50;
                    }
                    if (_this4.sellpoint.business_market_subscription_name == 'Max Bird Plan') {
                        _this4.max_plan_lookbooks = 50;
                        _this4.max_plan_lookbook_posts = 50;
                        _this4.can_add_product_lookbook = true;
                    }

                    var self = _this4;
                    setTimeout(function () {
                        self.getGalleryPosts();
                    }, 3000);
                    _this4.preset();
                    _this4.loading = false;
                } else {
                    _this4.business_load_error_msg = "Sorry, we could not load this Business Information";
                }
            }).catch(function (err) {
                _this4.loading = false;
            });
        },
        getProductsInBusinessCategories: function getProductsInBusinessCategories() {
            var _this5 = this;

            this.loading = true;
            service.getProductsInBusinessCategories(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this5.categories = response.body.data;
                }
                _this5.loading = false;
            }).catch(function (err) {
                _this5.loading = false;
            });
        },
        getGalleryPosts: function getGalleryPosts() {
            var _this6 = this;

            this.loading = true;
            service.getPointGalleryPosts(this, this.sellpoint.business_id, 0, this.max_plan_lookbooks, 0, this.max_plan_lookbook_posts).then(function (response) {
                _this6.galleria = response.body.data;

                _this6.total_lookbooks_added = response.body.total_data;

                if (_this6.total_lookbooks_added < _this6.max_plan_lookbooks) {
                    _this6.can_add_more_lookbook = true;
                }

                _this6.loading = false;
            }).catch(function (err) {
                _this6.loading = false;
            });
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this7 = this;

            this.loading = true;
            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {

                    _this7.products = response.body.data;
                    _this7.loading = false;
                }
            }).catch(function (err) {});
        },
        getPostsInGallery: function getPostsInGallery(gallery) {
            this.gallery = gallery;
            this.gallery_post = gallery.gallery_posts_group_posts[0];

            this.gallery_post_set_image = this.gallery_post.gallery_post_media[0];
            $('#quickviewModal').modal('show');
        },
        getCategoryProducts: function getCategoryProducts(category) {
            this.loading = true;
            this.product = category.business_category_products[0];
            this.products = category.business_category_products;
            $('#quickviewModal').modal('show');
            this.loading = false;
        },
        getCategoryProductsXX: function getCategoryProductsXX(category) {
            var _this8 = this;

            this.loading = true;
            var self = this;
            service.getCategoryProducts(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this8.products = response.body.data;

                    var count = 0;
                    _this8.products.forEach(function (element) {
                        count++;
                        if (count == 1) {
                            _this8.product = element;
                            $('#quickviewModal').modal('show');
                        }
                    });
                    _this8.loading = false;
                }
            }).catch(function (err) {
                _this8.loading = false;
            });
        },
        showPost: function showPost(post) {
            this.gallery_post = post;

            this.gallery_post_set_image = post.gallery_post_media[0];
        },
        showPostImage: function showPostImage(post_image) {
            this.gallery_post_set_image = post_image;
        },
        showProduct: function showProduct(product) {
            this.product = product;
        },
        addPostToGallery: function addPostToGallery() {
            var _this10 = this;

            this.disable_btn = true;

            var credentials = {
                gallery_new_group: false,
                gallery_post_group: this.gallery.gallery_posts_group_id,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    var _this9 = this;

                    if (data.body.status == 201) {
                        this.data_success_message = "Post Created";

                        this.post = data.body.data;

                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type", "gallery_media");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                location.reload(true);

                                _this9.gallery = data.body.data_gallery;
                                _this9.addNewPost = false;
                            }
                        }).catch(function (err) {
                            if (err) {}

                            _this9.data_error_message = "Something went wrong";
                        });
                    }
                }).catch(function (err) {
                    if (err) {
                        _this10.data_error_message = "Something went wrong";

                        _this10.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        },
        manageLookbook: function manageLookbook() {
            var _this11 = this;

            this.disable_btn = true;

            var credentials = {
                session_key: localStorage.getItem("sp_token"),
                request_url: service.app_url,
                request_from: service.app_name,
                request_status: "REQUESTING...",
                request: this.sellpoint.business_username + '/g/' + this.gallery.gallery_posts_group_url_name
            };
            if (credentials.session_key != null) {
                service.sessionSync(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var ref = response.body.data;
                        window.location.href = service.sp_url + '/manage/' + ref;
                    } else {
                        _this11.disable_btn = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        console.log(err);
                        _this11.disable_btn = false;
                    }
                });
            }
        },
        addToCart: function addToCart(productMain, productItem) {
            this.productItem = {};
            var cart_index = this.cart.findIndex(function (c) {
                return c.product_item_id === productItem.product_item_id;
            });
            if (cart_index < 0) {
                this.productMain = productMain;
                this.productItem = productItem;
                this.productItem._id = this.productItem.product_item_id;
                this.productItem.is_product_in_cart = true;

                if (this.productItem.product_item_order_quantity == undefined) {
                    this.productItem.product_item_order_quantity = 1;
                }
                this.productItem.product_main_id = this.productMain.product_id;
                this.productItem.product_business = this.productMain.product_business_ownername;
                this.productItem.product_name = this.productMain.product_name;
                this.productItem.product_url_name = this.productMain.product_url_name;
                this.productItem.product_url = this.productMain.product_business_ownername + "/" + this.productMain.product_url_name;
                this.$store.commit(ADD_TO_CART, this.productItem);
            } else {}
        },
        removeFromCart: function removeFromCart(payload) {
            this.$store.commit(REMOVE_FROM_CART, payload);
        },
        placeOrder: function placeOrder(product, product_item) {
            this.ordered_product = product;
            this.ordered_product_item = product_item;
            this.place_order = true;
        },
        resetOptions: function resetOptions() {
            this.ordered_product = {};
            this.ordered_product_item = {};
            this.total_price = 0;
            this.place_order = false;
        },
        processPayment: function processPayment() {
            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                this.payment_service = "HungrillvilleKitchen Order - " + this.ordered_product.product_name + "(" + this.ordered_product_item.product_item_price + ")";
                var obj = this;

                var handler = PaystackPop.setup({
                    key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.payment_payer_name,

                    email: this.payment_payer_email,
                    amount: Math.round(this.ordered_product_item.product_item_price * 100),
                    ref: "HUNGLOG" + Math.random(),
                    metadata: {
                        custom_fields: [{
                            display_name: "HungrillvilleKitchen Order",
                            variable_name: "",
                            value: this.payment_payer_name + " - " + this.payment_payer_phone + " - ORDER - " + this.ordered_product.product_name
                        }, {
                            display_name: "Service",
                            variable_name: "service_type",
                            value: this.ordered_product.product_name
                        }]
                    },

                    callback: function callback(response) {
                        obj.updatePayment(response.trxref);
                    },
                    onClose: function onClose() {
                        alert('window closed');
                    }
                });
                handler.openIframe();
            }
        },
        updatePayment: function updatePayment(payment_ref) {
            var navi = this.$router;

            var payer_name = this.payment_payer_name;
            this.data = {};

            this.payment_successful = true;
            this.payment_successful_message = "Hi " + payer_name + ", Your Payment was successful, we would proceed to prepare your order. Thank You.";
        }
    },
    mounted: function mounted() {
        this.preset();
    },

    created: function created() {
        if (this.$route.params.idg) {
            this.$router.push('/' + this.$route.params.id);
        }
        if (this.addPanel) {
            this.refresh_button = true;
        }
        this.reset();
        this.setSellpoint();
    }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Home_index_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Home_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Home_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_rightsidebar_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_rightsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_templates_rightsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_leftsidebar_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_leftsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_templates_leftsidebar_vue__);







var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    data: function data() {
        return {
            user: {},
            feeds: {},
            componentMenuBottomkey: 0,
            market: {},
            market_groups: {},
            market_trending: {},
            products: {},
            product: {},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            menu_view: {},
            show_login: false
        };
    },


    components: {
        'component-landing': __WEBPACK_IMPORTED_MODULE_1__Home_index_vue___default.a,
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-sticky-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a,
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_4__components_templates_rightsidebar_vue___default.a,
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_5__components_templates_leftsidebar_vue___default.a
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        preset: function preset() {
            this.loading = true;
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;

                    self.getFeeds();
                } else {
                    self.show_login = true;
                }
            });
        },
        getFeeds: function getFeeds() {
            var _this = this;

            var navi = this.$router;
            service.getFollowings(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this.feeds = response.body.data;
                    _this.loading = false;
                }
            }).catch(function (err) {});
        },
        clickNotifications: function clickNotifications(noti_id, noti_url) {
            var navi = this.$router;
            service.clickNotifications(this, noti_id).then(function (response) {
                navi.push('/' + noti_url);
            }).catch(function (err) {
                navi.push('/' + noti_url);
            });
        },
        setMarketRemote: function setMarketRemote() {
            var _this2 = this;

            service.getBusinessByUserName(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this2.market = response.body.data;
                    _this2.loading = false;
                }
            }).catch(function (err) {});
        },
        setMarketActivities: function setMarketActivities() {
            var _this3 = this;

            service.getMarketActivityProducts(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this3.market_trending = response.body.data;
                }
            }).catch(function (err) {});
        },
        setMarketGroups: function setMarketGroups() {
            var _this4 = this;

            service.getMarketGroupsProducts(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this4.market_groups = response.body.data;
                }
            }).catch(function (err) {});
        },
        setMenuComponent: function setMenuComponent(view, view_type, attr1, attr2) {
            var top = document.getElementById("topPanel").offsetTop;
            window.scrollTo(0, top);

            this.menu_view = {};
            this.menu_view[view] = true;
        }
    },
    created: function created() {
        this.menu_view["timeline"] = true;
        this.preset();
        this.setMarketRemote();
        this.setMarketGroups();
        this.setMarketActivities();
    }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_menubottom_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_menubottom_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_templates_menubottom_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tools_settings_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tools_settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_tools_settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__resources_commons_js__ = __webpack_require__(18);








var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    mixins: [__WEBPACK_IMPORTED_MODULE_6__resources_commons_js__["a" /* default */]],
    data: function data() {
        return {
            user: {},
            market: {},
            business: {},
            categories: {},
            subscriptions: {},
            plan1: {},
            plan2: {},
            plan3: {},
            selected_plan: {},
            place_order: false,

            data_boarding_message: "",
            set_up_with_existing_account: false,
            set_up_with_new_account: false,
            set_up_business: false,
            validate_user_name_error: false,
            data_error_message: "",
            payment_successful: false,
            payment_successful_message: "",
            payment_payer_name: "",
            payment_payer_email: "",
            payment_payer_phone: "",
            payment_service: "",
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            disable_btn: false
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a,
        'component-menu-bottom': __WEBPACK_IMPORTED_MODULE_4__components_templates_menubottom_vue___default.a,
        'c-settings': __WEBPACK_IMPORTED_MODULE_5__components_tools_settings_vue___default.a
    },
    computed: {},
    methods: {
        preset: function preset() {
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.loggedIn = true;

                    self.user.user_id = value.user_id;
                }
            });
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == 'setup-existing') {
                this.set_up_with_existing_account = true;
            }
        },
        toggleFAQComponent: function toggleFAQComponent(action, show, hide, head, body) {
            if (action == 'show') {
                document.getElementById(show).style.display = "none";
                document.getElementById(hide).style.display = "block";
                document.getElementById(head).style.color = "#ff0000";
                document.getElementById(body).style.display = "block";
            }
            if (action == 'hide') {
                document.getElementById(show).style.display = "block";
                document.getElementById(hide).style.display = "==none";
                document.getElementById(head).style.color = "#777b92";
                document.getElementById(body).style.display = "none";
            }
        },
        getSellpointMarket: function getSellpointMarket() {
            var _this = this;

            service.getBusinessByUserName(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this.market = response.body.data;

                    _this.getMarketMainProductsAsSubscriptions();

                    _this.loading = false;
                }
            }).catch(function (err) {});
        },
        getMarketMainProductsAsSubscriptions: function getMarketMainProductsAsSubscriptions() {
            var _this2 = this;

            service.getBusinessProducts(this, this.market.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.subscriptions = response.body.data;
                    _this2.plan1 = _this2.subscriptions[2];
                    _this2.plan2 = _this2.subscriptions[1];
                    _this2.plan3 = _this2.subscriptions[0];
                }
            }).catch(function (err) {});
        },
        purchase_plan: function purchase_plan(plan, plan_product_service_item_index) {
            this.loading = true;
            this.selected_plan = plan;
            this.place_order = true;

            this.$router.push('/purchase/?purchase=' + plan.product_url_name + '&item=' + plan_product_service_item_index);
        },
        resetOptions: function resetOptions() {
            this.selected_plan = {};
            this.total_price = 0;
            this.place_order = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        proceedNewAccount: function proceedNewAccount() {
            this.resetMessages();
            this.set_up_with_new_account = true;

            if (this.selected_plan.product_items[0].product_item_price == 0) {
                this.updatePayment("gw-free-account");
            } else {
                this.processPayment();
            }
        },
        proceedWithAccount: function proceedWithAccount() {
            this.resetMessages();
            var payload = {
                user_email: this.user.user_email,
                user_password: this.user.user_password,
                user_business: this.user.user_business
            };
            service.checkUserDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    if (data.body.status_2 != 200) {
                        this.data_error_message = "Sorry, Sellpoint does not exist on this account";
                    } else {
                        this.payment_payer_name = data.body.data.user_name;
                        this.payment_payer_email = data.body.data.user_email;
                        this.payment_payer_phone = data.body.data.user_phone;

                        if (this.selected_plan.product_items[0].product_item_price == 0) {
                            this.updatePayment("gw-free-account");
                        } else {
                            this.processPayment();
                        }
                    }
                } else {
                    this.data_error_message = "Sorry, Account does not exist";
                }
            }).catch(function (err) {});
        },
        processPayment: function processPayment() {
            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                this.payment_service = "Gallery Website Order - " + this.selected_plan.product_name + "(" + this.selected_plan.product_items[0].product_item_price + ")";
                var obj = this;

                var handler = PaystackPop.setup({
                    key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.payment_payer_name,

                    email: this.payment_payer_email,
                    amount: Math.round(this.selected_plan.product_items[0].product_item_price * 100),
                    ref: "GWLOG" + Math.random(),
                    metadata: {
                        custom_fields: [{
                            display_name: "GalleryWebsite Order",
                            variable_name: "",
                            value: this.payment_payer_name + " - " + this.payment_payer_phone + " - ORDER - " + this.selected_plan.product_name
                        }, {
                            display_name: "Service",
                            variable_name: "service_type",
                            value: this.selected_plan.product_name
                        }]
                    },

                    callback: function callback(response) {
                        obj.updatePayment(response.trxref);
                    },
                    onClose: function onClose() {
                        alert('window closed');
                    }
                });
                handler.openIframe();
            }
        },
        updatePayment: function updatePayment(payment_ref) {

            var navi = this.$router;
            this.payment_successful = true;
            this.payment_successful_message = "Payment Successful...";

            if (this.set_up_with_existing_account) {
                this.setUpExistingAccount();
            }
            if (this.set_up_with_new_account) {
                this.setUpNewAccount();
            }
        },
        setUpExistingAccount: function setUpExistingAccount() {
            var _this4 = this;

            this.disable_btn = true;
            var credentials = {
                business_user_name: this.user.user_business,
                business_group: service.market_app_name,
                business_subscription: this.selected_plan.product_id
            };

            var navi = this.$router;
            service.addExistingBusiness(this, credentials).then(function (data) {
                var _this3 = this;

                if (data.body.status == 201) {
                    this.boarding_messages.push("Sellpoint Setup Successful...");

                    var credentials = {
                        user_email: this.user.user_email,
                        user_password: this.user.user_password
                    };
                    service.loginUser(this, credentials).then(function (response) {
                        if (response.body.status == 200) {
                            var _data = response.body.data;
                            localStorage.setItem("sp_user", _data.user_name);
                            localStorage.setItem("sp_token", _data.user_session_key);
                            localStorage.setItem("sp_token_key", _data.user_token_key);

                            $('#purchaseModal').modal('hide');
                            navi.push('/' + _this3.user.user_business);
                        }
                    }).catch(function (err) {
                        if (err.status == 404) {
                            toastr.warning("invalid login credentials", 'Warning!');
                            _this3.disable_btn = false;
                        }
                    });
                }
            }).catch(function (err) {
                if (err) {
                    toastr.warning("Something went wrong", 'Warning!');
                    _this4.disable_btn = false;
                }
            });
        },
        setUpNewAccount: function setUpNewAccount() {
            this.disable_btn = true;
            this.loading = true;
            var credentials = {
                user_name: this.payment_payer_name,
                user_phone: this.payment_payer_phone,
                user_email: this.payment_payer_email,
                user_address: '',
                user_state: '',
                user_city: '',
                user_password: this.user.user_password
            };

            var navi = this.$router;

            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                if (credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null && credentials.user_email != null && credentials.user_password != null) {
                    service.regUser(this, credentials).then(function (data) {
                        var _this5 = this;

                        if (data.body.status == 201) {
                            this.data_boarding_message = "Registration Successful...";

                            var credentials = {
                                user_email: data.body.data.user_email,
                                user_password: data.body.data.user_password
                            };
                            service.loginUser(this, credentials).then(function (response) {
                                if (response.body.status == 200) {
                                    var _data2 = response.body.data;
                                    localStorage.setItem("sp_user", _data2.user_name);
                                    localStorage.setItem("sp_token", _data2.user_session_key);
                                    localStorage.setItem("sp_token_key", _data2.user_token_key);

                                    _this5.preset();

                                    setTimeout(function () {
                                        this.set_up_business = true;
                                        $('#purchaseModal').modal('hide');
                                        $('#newBusinessModal').modal('show');
                                    }, 3000);
                                }
                            }).catch(function (err) {
                                if (err.status == 404) {
                                    _this5.data_error_message = "invalid login credentials..";
                                    _this5.disable_btn = false;
                                }
                            });
                        } else if (data.body.status == 409) {
                            this.data_error_message = "This User is already registered..";
                            this.disable_btn = false;
                        }
                    });
                } else {
                    this.data_error_message = "Kindly fill all fields...";
                    this.disable_btn = false;
                }
            }
        },
        validateUserName: function validateUserName() {
            var _this6 = this;

            service.validateBusinessUserName(this, this.business).then(function (response) {
                if (response.body.status != 200) {
                    _this6.validate_user_name_error = true;
                    _this6.validate_user_name_message = "This username already exist";
                }
            }).catch(function (err) {
                _this6.validate_user_name_error = true;
                _this6.validate_user_name_message = "This username already exist";
            });
        },
        setUpNewAccountBusiness: function setUpNewAccountBusiness() {
            var _this7 = this;

            this.resetMessages();
            this.disable_btn = true;
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: service.market_app_name,
                business_layout: this.business.business_view_layout || 3,
                business_subscription: this.selected_plan.product_id
            };
            var navi = this.$router;
            if (this.validate_user_name_error) {
                this.data_error_message = "This Username already exists..";
            } else {
                if (credentials.business_name != undefined && credentials.business_category != undefined) {
                    service.addNewBusiness(this, credentials).then(function (data) {
                        if (data.body.status == 201) {
                            this.data_boarding_message = "Sellpoint Creation Successful.";

                            $('#newBusinessModal').modal('hide');
                            navi.push('/' + this.business.business_user_name);
                        } else {
                            this.data_error_message = "This Username already exists";
                        }
                    }).catch(function (err) {
                        if (err) {
                            _this7.data_error_message = "Something went wrong";
                            _this7.disable_btn = false;
                        }
                    });
                } else {
                    this.data_error_message = "Kindly fill all fields";
                    this.disable_btn = false;
                }
            }
        },
        getBusinessCategories: function getBusinessCategories() {
            service.getCategories(this).then(function (data) {
                this.categories = data.body.data;
            });
        },
        creation_thread: function creation_thread() {
            var promises = [];
            for (var i = 0; i < 9; ++i) {
                if (i == 1) {
                    promises.push(this.preset());
                }
                if (i == 2) {
                    promises.push(this.getSellpointMarket());
                }
            }

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
                var result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
                promises.forEach(function (promise) {
                    result.then(function () {});
                });
            }).catch(function (e) {});
        }
    },

    mounted: function mounted() {
        this.setPushNotification();
    },

    created: function created() {
        var self = this;
        setTimeout(function () {
            location.replace('/');
        }, 10500);
    }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__resources_commons_js__ = __webpack_require__(18);






var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Login',
    mixins: [__WEBPACK_IMPORTED_MODULE_4__resources_commons_js__["a" /* default */]],
    data: function data() {
        var _ref;

        return _ref = {
            users: {},
            user: {},
            states: {},
            cities: {},
            disable_btn: false,
            data_error_message: ""
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'disable_btn', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'action_loading', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'redir', ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'redir_data', {}), _ref;
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a
    },
    methods: {
        reset: function reset() {
            localStorage.removeItem("sp_user");
            localStorage.removeItem("sp_token");
            localStorage.removeItem("sp_token_key");
            localStorage.removeItem("sp_#_sellpoint");

            localforage.removeItem(service.udb_name).then(function (value) {}).catch(function (err) {});

            localforage.clear();
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        login: function login() {
            var _this = this;

            this.activate_processing();
            this.data_error_message = "";
            var credentials = {
                user_email: this.user.email,
                user_password: this.user.password
            };

            var navi = this.$router;
            if (credentials.user_email != null && credentials.user_password != null) {
                service.loginUser(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        localStorage.setItem("sp_user", data.user_name);

                        var user_data = {
                            "user_name": data.user_name,
                            "sp_token": data.user_session_key,
                            "sp_token_key": data.user_token_key,
                            "sps": data.user_sps
                        };
                        var credentials = {
                            session_key: data.user_session_key
                        };

                        service.sessionGuard(_this, credentials).then(function (response) {
                            if (response.body.status == 200) {
                                var _data = response.body.data;
                                _data.forEach(function (element) {
                                    user_data.user_id = element.user_id;
                                }, _this);

                                var self = _this;
                                localforage.setItem(service.udb_name, user_data).then(function (value) {
                                    if (user_data.sps && user_data.sps > 0) {
                                        navi.push('/dashboard');
                                    } else {
                                        navi.push(self.redir);
                                    }

                                    self.setPushNotification();
                                }).catch(function (err) {});
                            } else {}
                            _this.loading = false;
                        }).catch(function (err) {
                            if (err) {}
                        });
                    } else {
                        _this.data_error_message = "invalid login credentials";

                        _this.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this.data_error_message = "Sorry, could not process request";

                    _this.deactivate_processing();
                });
            } else {
                this.data_error_message = "Kindly fill all fields";
                this.disable_btn = false;
            }
        },
        doDynamicRedirectsDirects: function doDynamicRedirectsDirects() {
            var self = this;

            localforage.getItem(service.adr_db_name, function (err, value) {
                if (value != undefined) {
                    self.redir = value.link;
                    self.redir_data = value;
                } else {
                    self.redir = "/";
                }
                self.reset();
            });
        }
    },
    created: function created() {
        this.doDynamicRedirectsDirects();
    }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_templates_menubottom_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_templates_menubottom_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_templates_menubottom_vue__);


var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "MainFooter",
    data: function data() {
        return {
            user: {},
            user_slug: {}
        };
    },

    components: {
        'component-menu-bottom': __WEBPACK_IMPORTED_MODULE_1__components_templates_menubottom_vue___default.a
    }

});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tools_settings_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tools_settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_tools_settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_templates_logo_pad_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_templates_logo_pad_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_templates_logo_pad_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_account_menu_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_account_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_templates_account_menu_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "MainHeader",
    props: { headerdata: Object },
    data: function data() {
        return {
            app_name: service.app_name,
            path: this.$route.path.replace('/', ''),
            user: {},
            user_slug: {},
            market: {},
            products: {},
            product: {},
            items: [],
            checked_out_items: [],
            img_url: service.imageURL,
            loggedIn: false,
            server_query_done: false,
            show_back: true,
            cart: this.$store.state.cart,
            can_show_back_nav: true,
            can_show_side_nav: true,
            mall_set: false,
            notifications: {},
            notifications_alert: 0
        };
    },


    components: {
        'c-settings': __WEBPACK_IMPORTED_MODULE_1__components_tools_settings_vue___default.a,
        'logo-pad': __WEBPACK_IMPORTED_MODULE_2__components_templates_logo_pad_vue___default.a,
        'component-account-menu': __WEBPACK_IMPORTED_MODULE_3__components_templates_account_menu_vue___default.a
    },
    methods: {
        back: function back() {
            window.history.back();
        },
        display_menu: function display_menu() {
            var status = document.getElementById("main-nav-bar").style.display;
            if (status == "none") {
                document.getElementById("main-nav-bar").style.display = "block";
            } else {
                document.getElementById("main-nav-bar").style.display = "none";
            }
        },
        checkLoggedIn: function checkLoggedIn() {
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.loggedIn = true;
                    self.user = value;
                }
            });
        },
        setMarketRemote: function setMarketRemote() {
            var _this = this;

            service.getBusinessByUserName(this, "").then(function (response) {
                if (response.body.status == 200) {
                    _this.market = response.body.data;
                }
            }).catch(function (err) {});
        },
        setMarketLocal: function setMarketLocal() {},
        setPageHeaders: function setPageHeaders() {
            window.onscroll = function () {
                var stick_header = document.getElementById("pageStickyHeader");

                var sticky = stick_header.offsetTop;

                if (window.pageYOffset > sticky) {
                    stick_header.classList.add("header-sticky");
                } else {
                    stick_header.classList.remove("header-sticky");
                }
            };
        },
        setStickyHeader: function setStickyHeader() {
            var stick_header = document.getElementById("pageStickyHeader");

            var sticky = stick_header.offsetTop;

            if (window.pageYOffset > sticky) {
                stick_header.classList.add("header-sticky");
            } else {
                stick_header.classList.remove("header-sticky");
            }
        },
        checkCanShowBackNav: function checkCanShowBackNav() {
            if (this.path == '' || this.path == 'timeline' || this.$route.name == 'Onboarding' || this.$route.name == 'RefGroup') {
                this.can_show_back_nav = false;
            }
        },
        checkCanShowSideNav: function checkCanShowSideNav() {
            if (this.path == 'register' || this.path == 'login') {
                this.can_show_side_nav = false;
            }
        },
        getNotifications: function getNotifications() {
            var _this2 = this;

            service.getNotifications(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.notifications_alert = response.body.data_alert_total;
                }
            }).catch(function (err) {});
        },
        setAppName: function setAppName() {}
    },

    mounted: function mounted() {
        this.setAppName();
    },

    created: function created() {
        if (this.path == 'buzz') {
            this.setPageHeaders();
        }
        if (this.path == 'register') {
            this.show_back = false;
        }
        this.checkLoggedIn();
        this.checkCanShowSideNav();
        this.checkCanShowBackNav();
        this.getNotifications();

        var self = this;
        localforage.getItem('xvue', function (err, value) {
            if (value != undefined) {
                self.cart = value.cart;
            } else {}
        });
    }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__ = __webpack_require__(3);






var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MakeOrder',
    mixins: [__WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints: {},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error: false,
            group_isset: false,
            add_sellpoint: false,
            add_business: false,
            get_flag: false,
            loading: false,
            action_loading: false,

            validate_user_name_message: "",
            payment_successful_message: "",
            data_error_message: "",
            data_boarding_message: "",

            headerdata: {
                'name': 'Set Order'
            },

            order_data: {},
            select_delivery_location: 0,
            set_delivery_location: {},
            reset_order: false,

            set_view_box: ''
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a
    },
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        preset: function preset() {
            this.loading = true;

            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;
                } else {
                    self.loading = false;
                }
            });
        },
        setProduct: function setProduct() {
            var _this = this;

            this.loading = true;
            this.set_order_data.order_total_amount = 0;
            service.getProductSearch(this, this.$route.params.ref).then(function (response) {
                if (response.body.status == 200) {
                    _this.product = response.body.data;

                    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.product.product_images).length > 0) {
                        _this.product_display_image = _this.product.product_images[0];
                    } else {
                        _this.product_display_image.product_image = "";
                    }
                    _this.product_item = _this.product.product_items[0];
                    _this.product.product_price = _this.product_item.product_item_price;
                    _this.set_order_data.order_total_amount = Number(_this.product.product_price);
                    _this.set_order_total_amount = _this.set_order_data.order_total_amount;

                    _this.processMakeOrder();
                    if (_this.product.product_item_groups.length != 0) {
                        _this.product_item_group = _this.product.product_item_groups[0];
                    } else {
                        _this.product_item_group = [];
                    }

                    _this.sellpoint.business_id = _this.product.product_business_id;
                    _this.sellpoint.business_username = _this.product.product_business_ownername;
                    _this.setBusinessDetails();

                    _this.product.selected_product_addons = [];
                }
            }).catch(function (err) {});
        },
        setBusinessDetails: function setBusinessDetails() {
            var _this2 = this;

            service.getBusinessByUserName(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this2.sellpoint = response.body.data;

                    _this2.business_delivery_locations = _this2.sellpoint.business_delivery_options;

                    _this2.business_bank_details = _this2.sellpoint.business_bank_details;
                }
            }).catch(function (err) {});
        },
        setViewBox: function setViewBox(view) {
            this.setMenuTabInnerView('setOptions');

            this.set_view_box = view;
        }
    },
    created: function created() {
        this.setProduct();
        this.preset();

        this.getRavepayBanks();
    }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Account_Resources_commonfunctions_js__ = __webpack_require__(3);





var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'PlacedOrder',
    mixins: [__WEBPACK_IMPORTED_MODULE_3__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            headerdata: {
                'name': 'Placed Order'
            },

            set_view_box: '',
            order_item: {}
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        preset: function preset() {
            this.loading = true;

            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;

                    localforage.getItem(service.bdb_name, function (err, value) {
                        if (value != undefined) {
                            self.sellpoint = value;

                            if (self.$route.params.ref && self.$route.params.ref != '') {
                                var payload = {
                                    module: 3,
                                    module_id: self.sellpoint.business_id,
                                    ref: self.$route.params.ref
                                };
                                self.getOrderDetails(payload);
                            }
                        } else {
                            self.loading = false;
                        }
                    });
                } else {
                    self.loading = false;
                    self.$router.push('/login');
                }
            });
        },
        setViewBox: function setViewBox(view) {
            this.setMenuTabInnerView('setOptions');

            this.set_view_box = view;
        },
        setRate: function setRate(item, rate) {
            this.order_item = item;
            this.order_item.product_item_rate = rate;

            for (var i = 1; i <= 5; i++) {
                if (i <= rate) {
                    document.getElementById('rate-' + i).style.display = 'none';
                    document.getElementById('rated-' + i).style.display = 'block';
                } else {
                    document.getElementById('rate-' + i).style.display = 'block';
                    document.getElementById('rated-' + i).style.display = 'none';
                }
            }
        },
        submitReview: function submitReview() {
            var _this = this;

            this.order_item.data_processing_message = "Please review and rate";
            if (this.order_item.product_item_rate < 0) {
                this.data_processing_message = "Please rate";
            } else {
                this.activate_processing();
                var payload = {
                    'product_reviewed_by': this.user.user_id,
                    'product_id': this.order_item.product_id,
                    'product_item_id': this.order_item.product_item_id,
                    'product_item_order_cost': this.order_item.order_item_total,
                    'product_review': this.order_item.product_item_review || '',
                    'product_rate': this.order_item.product_item_rate
                };
                service.addProductReview(this, payload).then(function (response) {
                    if (response.body.status == 201) {
                        _this.deactivate_processing();
                    }
                }).catch(function (err) {});
            }
            this.componentOrderItemReviewKey++;
        }
    },
    created: function created() {
        this.preset();
    }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Account_Resources_commonfunctions_js__ = __webpack_require__(3);





var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'PlacedOrder',
    mixins: [__WEBPACK_IMPORTED_MODULE_3__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            headerdata: {
                'name': 'Placed Order'
            },

            set_view_box: '',
            order_item: {}
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        preset: function preset() {
            this.loading = true;

            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;

                    localforage.getItem(service.bdb_name, function (err, value) {
                        if (value != undefined) {
                            self.sellpoint = value;

                            if (self.$route.params.ref && self.$route.params.ref != '') {
                                var payload = {
                                    module: 3,
                                    module_id: self.sellpoint.business_id,
                                    ref: self.$route.params.ref
                                };
                                self.getOrderDetails(payload);
                            }
                        } else {
                            self.loading = false;
                        }
                    });
                } else {
                    self.loading = false;
                    self.$router.push('/login');
                }
            });
        },
        setViewBox: function setViewBox(view) {
            this.setMenuTabInnerView('setOptions');

            this.set_view_box = view;
        },
        setRate: function setRate(item, rate) {
            this.order_item = item;
            this.order_item.product_item_rate = rate;

            for (var i = 1; i <= 5; i++) {
                if (i <= rate) {
                    document.getElementById('rate-' + i).style.display = 'none';
                    document.getElementById('rated-' + i).style.display = 'block';
                } else {
                    document.getElementById('rate-' + i).style.display = 'block';
                    document.getElementById('rated-' + i).style.display = 'none';
                }
            }
        },
        submitReview: function submitReview() {
            var _this = this;

            this.order_item.data_processing_message = "Please review and rate";
            if (this.order_item.product_item_rate < 0) {
                this.data_processing_message = "Please rate";
            } else {
                this.activate_processing();
                var payload = {
                    'product_reviewed_by': this.user.user_id,
                    'product_id': this.order_item.product_id,
                    'product_item_id': this.order_item.product_item_id,
                    'product_item_order_cost': this.order_item.order_item_total,
                    'product_review': this.order_item.product_item_review || '',
                    'product_rate': this.order_item.product_item_rate
                };
                service.addProductReview(this, payload).then(function (response) {
                    if (response.body.status == 201) {
                        _this.deactivate_processing();
                    }
                }).catch(function (err) {});
            }
            this.componentOrderItemReviewKey++;
        }
    },
    created: function created() {
        this.preset();
    }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__ = __webpack_require__(3);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ManageItems',
    mixins: [__WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints: {},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error: false,
            group_isset: false,
            add_sellpoint: false,
            add_business: false,
            get_flag: false,
            loading: false,
            action_loading: false,

            validate_user_name_message: "",
            payment_successful_message: "",
            data_error_message: "",
            data_boarding_message: "",

            headerdata: {
                'name': 'New Category'
            },

            reset_order: false,
            business_type: 2,
            set_view: 'view_general' };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue___default.a },
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        preset: function preset() {
            this.loading = true;

            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;

                    localforage.getItem(service.bdb_name, function (err, value) {
                        if (value != undefined) {
                            self.sellpoint = value;

                            if (self.$route.params.ref && self.$route.params.ref != '') {
                                self.getSetProduct({}, self.$route.params.ref);
                            }

                            self.loading = false;
                        }
                    });
                } else {
                    self.loading = false;
                    self.$router.push('/login');
                }
            });
        },
        setGeneralGoodsCategoryProducts: function setGeneralGoodsCategoryProducts(category) {
            this.general_goods_category = category;

            this.getGeneralGoodsCategoryProducts();

            this.setMenuTabInnerView('general_goods_category_products');
        }
    },
    created: function created() {
        this.preset();

        this.getGeneralGoods();
    }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__ = __webpack_require__(3);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ManageItems',
    mixins: [__WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints: {},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error: false,
            group_isset: false,
            add_sellpoint: false,
            add_business: false,
            get_flag: false,
            loading: false,
            action_loading: false,

            validate_user_name_message: "",
            payment_successful_message: "",
            data_error_message: "",
            data_boarding_message: "",

            headerdata: {
                'name': ''
            },

            reset_order: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue___default.a },
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        preset: function preset() {
            this.loading = true;

            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;

                    localforage.getItem(service.bdb_name, function (err, value) {
                        if (value != undefined) {
                            self.sellpoint = value;
                            self.headerdata.name = self.sellpoint.business_name;

                            if (self.$route.params.ref && self.$route.params.ref != '') {
                                self.getSetProduct({}, self.$route.params.ref);
                            }

                            self.loading = false;
                        }
                    });
                } else {
                    self.loading = false;
                    self.$router.push('/login');
                }
            });
        },
        setGeneralGoodsCategoryProducts: function setGeneralGoodsCategoryProducts(category) {
            this.general_goods_category = category;

            this.getGeneralGoodsCategoryProducts();

            this.setMenuTabInnerView('general_goods_category_products');
        }
    },
    created: function created() {
        this.preset();

        this.getGeneralGoods();
    }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__ = __webpack_require__(3);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ManageItems',
    mixins: [__WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints: {},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error: false,
            group_isset: false,
            add_sellpoint: false,
            add_business: false,
            get_flag: false,
            loading: false,
            action_loading: false,

            validate_user_name_message: "",
            payment_successful_message: "",
            data_error_message: "",
            data_boarding_message: "",

            headerdata: {
                'name': ''
            },

            reset_order: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue___default.a },
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        preset: function preset() {
            this.loading = true;

            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;

                    localforage.getItem(service.bdb_name, function (err, value) {
                        if (value != undefined) {
                            self.sellpoint = value;
                            self.headerdata.name = 'Customers - ' + self.sellpoint.business_name;

                            self.getAppBusinessCustomers();
                        } else {
                            self.getSellpoints(self.user.user_id);
                            self.loading = false;
                        }
                    });
                } else {
                    self.loading = false;
                    self.$router.push('/login');
                }
            });
        },
        setBusinessDetails: function setBusinessDetails() {
            var self = this;
            localforage.getItem(service.bbnksdb_name, function (err, value) {
                if (value != undefined) {
                    console.log(7654999);
                    self.sellpoint.business_bank_details = value;
                    self.business_bank_details = value;
                }
                self.loading = false;
            });

            localforage.getItem(service.bbdlsdb_name, function (err, value) {
                if (value != undefined) {
                    self.sellpoint.business_delivery_options = value;
                    self.business_delivery_locations = value;
                }
                self.loading = false;
            });

            this.getSellpointDetails(this.sellpoint.business_username);
        }
    },
    created: function created() {
        this.preset();

        this.getRavepayBanks();
    }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__ = __webpack_require__(3);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ManageItems',
    mixins: [__WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints: {},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error: false,
            group_isset: false,
            add_sellpoint: false,
            add_business: false,
            get_flag: false,
            loading: false,
            action_loading: false,

            validate_user_name_message: "",
            payment_successful_message: "",
            data_error_message: "",
            data_boarding_message: "",

            headerdata: {
                'name': ''
            },

            reset_order: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue___default.a },
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        preset: function preset() {
            this.loading = true;

            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;

                    localforage.getItem(service.bdb_name, function (err, value) {
                        if (value != undefined) {
                            self.sellpoint = value;
                            self.headerdata.name = self.sellpoint.business_name;

                            if (self.$route.params.ref && self.$route.params.ref != '') {
                                self.getSetProduct({}, self.$route.params.ref);
                            }

                            self.loading = false;
                        }
                    });
                } else {
                    self.loading = false;
                    self.$router.push('/login');
                }
            });
        },
        setItemSettings: function setItemSettings() {
            this.$router.push({
                name: 'ItemSettings',

                params: {
                    item: this.product
                }
            });
        },
        setBusinessDetails: function setBusinessDetails() {
            var self = this;
            localforage.getItem(service.bbnksdb_name, function (err, value) {
                if (value != undefined) {
                    console.log(7654999);
                    self.sellpoint.business_bank_details = value;
                    self.business_bank_details = value;
                }
                self.loading = false;
            });

            localforage.getItem(service.bbdlsdb_name, function (err, value) {
                if (value != undefined) {
                    self.sellpoint.business_delivery_options = value;
                    self.business_delivery_locations = value;
                }
                self.loading = false;
            });

            this.getSellpointDetails(this.sellpoint.business_username);
        }
    },
    created: function created() {
        this.preset();

        this.getRavepayBanks();
    }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_manage_menubottom_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_manage_menubottom_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_templates_manage_menubottom_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Account_Resources_commonfunctions_js__ = __webpack_require__(3);







var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ManageItems',
    mixins: [__WEBPACK_IMPORTED_MODULE_5__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints: {},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error: false,
            group_isset: false,
            add_sellpoint: false,
            add_business: false,
            get_flag: false,
            loading: false,
            action_loading: false,

            validate_user_name_message: "",
            payment_successful_message: "",
            data_error_message: "",
            data_boarding_message: "",

            headerdata: {
                'name': ''
            },

            reset_order: false,
            set_view: 'setViewItems'
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_4__components_templates_manage_menubottom_vue___default.a },
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        preset: function preset() {
            this.loading = true;

            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;

                    localforage.getItem(service.bdb_name, function (err, value) {
                        if (value != undefined) {
                            self.sellpoint = value;
                            self.headerdata.name = self.sellpoint.business_name;

                            self.setBusinessDetails();

                            self.getSellpointProducts();

                            self.getAppBusinessOrders();
                        } else {
                            self.getSellpoints(self.user.user_id);
                            self.loading = false;
                        }
                    });
                } else {
                    self.loading = false;
                    self.$router.push('/login');
                }
            });
        },
        setBusinessDetails: function setBusinessDetails() {
            var self = this;
            localforage.getItem(service.bbnksdb_name, function (err, value) {
                if (value != undefined) {
                    console.log(7654999);
                    self.sellpoint.business_bank_details = value;
                    self.business_bank_details = value;
                }
                self.loading = false;
            });

            localforage.getItem(service.bbdlsdb_name, function (err, value) {
                if (value != undefined) {
                    self.sellpoint.business_delivery_options = value;
                    self.business_delivery_locations = value;
                }
                self.loading = false;
            });

            this.getSellpointDetails(this.sellpoint.business_username);
        },
        setAllProducts: function setAllProducts() {
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.products).length == 0) {
                this.getSellpointProducts();
            }
        },
        setCategoryProducts: function setCategoryProducts(category) {
            var _this = this;

            this.category = category;
            this.loading = true;
            service.getCategoryProducts(this, this.category.business_category_id).then(function (response) {
                if (response.body.status == 200) {
                    _this.products = response.body.data;
                    _this.loading = false;
                }
                _this.set_view = "setViewItems";
                _this.loading = false;
            }).catch(function (err) {
                _this.loading = false;
            });
        }
    },
    created: function created() {
        this.preset();

        this.getRavepayBanks();
    }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__ = __webpack_require__(3);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ManageItems',
    mixins: [__WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints: {},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error: false,
            group_isset: false,
            add_sellpoint: false,
            add_business: false,
            get_flag: false,
            loading: false,
            action_loading: false,

            validate_user_name_message: "",
            payment_successful_message: "",
            data_error_message: "",
            data_boarding_message: "",

            headerdata: {
                'name': ''
            },

            reset_order: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue___default.a },
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        preset: function preset() {
            this.loading = true;

            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;

                    localforage.getItem(service.bdb_name, function (err, value) {
                        if (value != undefined) {
                            self.sellpoint = value;
                            self.headerdata.name = 'Lists - ' + self.sellpoint.business_name;

                            self.getAppBusinessOrders();
                        }
                    });
                } else {
                    self.loading = false;
                    self.$router.push('/login');
                }
            });
        },
        setBusinessDetails: function setBusinessDetails() {
            var self = this;
            localforage.getItem(service.bbnksdb_name, function (err, value) {
                if (value != undefined) {
                    console.log(7654999);
                    self.sellpoint.business_bank_details = value;
                    self.business_bank_details = value;
                }
                self.loading = false;
            });

            localforage.getItem(service.bbdlsdb_name, function (err, value) {
                if (value != undefined) {
                    self.sellpoint.business_delivery_options = value;
                    self.business_delivery_locations = value;
                }
                self.loading = false;
            });

            this.getSellpointDetails(this.sellpoint.business_username);
        }
    },
    created: function created() {
        this.preset();

        this.getRavepayBanks();
    }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_validation__ = __webpack_require__(16);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
var validator = new __WEBPACK_IMPORTED_MODULE_1__services_validation__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
   name: 'ManageTemplate',
   data: function data() {
      return {};
   },

   components: {},
   methods: {},
   created: function created() {}
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__ = __webpack_require__(3);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ManageItems',
    mixins: [__WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints: {},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error: false,
            group_isset: false,
            add_sellpoint: false,
            add_business: false,
            get_flag: false,
            loading: false,
            action_loading: false,

            validate_user_name_message: "",
            payment_successful_message: "",
            data_error_message: "",
            data_boarding_message: "",

            headerdata: {
                'name': ''
            },

            reset_order: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue___default.a },
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        preset: function preset() {
            this.loading = true;

            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;

                    localforage.getItem(service.bdb_name, function (err, value) {
                        if (value != undefined) {
                            self.sellpoint = value;
                            self.headerdata.name = self.sellpoint.business_name;

                            if (self.$route.params.ref && self.$route.params.ref != '') {
                                var payload = {
                                    module: 3,
                                    module_id: self.sellpoint.business_id,
                                    ref: self.$route.params.ref
                                };
                                self.getOrderDetails(payload);
                            }
                        }
                    });
                } else {
                    self.loading = false;
                    self.$router.push('/login');
                }
            });
        },
        setBusinessDetails: function setBusinessDetails() {
            var self = this;
            localforage.getItem(service.bbnksdb_name, function (err, value) {
                if (value != undefined) {
                    console.log(7654999);
                    self.sellpoint.business_bank_details = value;
                    self.business_bank_details = value;
                }
                self.loading = false;
            });

            localforage.getItem(service.bbdlsdb_name, function (err, value) {
                if (value != undefined) {
                    self.sellpoint.business_delivery_options = value;
                    self.business_delivery_locations = value;
                }
                self.loading = false;
            });

            this.getSellpointDetails(this.sellpoint.business_username);
        }
    },
    created: function created() {
        this.preset();

        this.getRavepayBanks();
    }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OrderDetailsRequest_vue__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OrderDetailsRequest_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__OrderDetailsRequest_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Template_script_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Template_script_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Template_script_js__);



/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__Template_script_js___default.a],
    data: function data() {
        return {};
    },

    components: {
        'order-request': __WEBPACK_IMPORTED_MODULE_0__OrderDetailsRequest_vue___default.a
    },

    methods: {},
    created: function created() {}
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__ = __webpack_require__(3);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ManageItems',
    mixins: [__WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints: {},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error: false,
            group_isset: false,
            add_sellpoint: false,
            add_business: false,
            get_flag: false,
            loading: false,
            action_loading: false,

            validate_user_name_message: "",
            payment_successful_message: "",
            data_error_message: "",
            data_boarding_message: "",

            headerdata: {
                'name': ''
            },

            reset_order: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__components_templates_manage_menubottom_vue___default.a },
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        preset: function preset() {
            this.loading = true;

            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;

                    localforage.getItem(service.bdb_name, function (err, value) {
                        if (value != undefined) {
                            self.sellpoint = value;
                            self.headerdata.name = self.sellpoint.business_name;

                            if (self.$route.params.ref && self.$route.params.ref != '') {
                                var payload = {
                                    module: 3,
                                    module_id: self.sellpoint.business_id,
                                    ref: self.$route.params.ref
                                };
                                self.getOrderDetails(payload);
                            }
                        }
                    });
                } else {
                    self.loading = false;
                    self.$router.push('/login');
                }
            });
        },
        setBusinessDetails: function setBusinessDetails() {
            var self = this;
            localforage.getItem(service.bbnksdb_name, function (err, value) {
                if (value != undefined) {
                    console.log(7654999);
                    self.sellpoint.business_bank_details = value;
                    self.business_bank_details = value;
                }
                self.loading = false;
            });

            localforage.getItem(service.bbdlsdb_name, function (err, value) {
                if (value != undefined) {
                    self.sellpoint.business_delivery_options = value;
                    self.business_delivery_locations = value;
                }
                self.loading = false;
            });

            this.getSellpointDetails(this.sellpoint.business_username);
        }
    },
    created: function created() {
        this.preset();

        this.getRavepayBanks();
    }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    data: function data() {
        return {
            header_data: {},
            user: {},
            myshops: {},
            loggedIn: false,
            loading: true,
            tab_view: {},
            menu_tab_view: {}
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue___default.a,
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue___default.a
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == "reset-edit") {}
        },
        setTabComponent: function setTabComponent(view) {
            this.tab_view = {};
            this.tab_view[view] = true;
        },
        setMenuTabView: function setMenuTabView(view, attr1, attr2) {
            if (this.menu_tab_view[view] == true) {
                this.menu_tab_view = {};
                this.setComponent('reset-edit', '');
            } else {
                this.setComponent('reset-edit', '');
                this.menu_tab_view = {};
                this.menu_tab_view[view] = true;
            }
        },
        preset: function preset() {
            this.loading = true;
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;
                    self.getMyShops();
                    self.loading = false;
                } else {
                    self.$router.push('login');
                }
            });
        },
        getMyShops: function getMyShops() {
            var _this = this;

            var payload = {
                folder_for: 1,
                folder_for_id: this.user.user_id,
                folder_type: 9 };
            service.getSetFolders(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this.myshops = response.body.data[0].folder_items;
                    _this.loading = false;
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.preset();
        this.header_data.name = "My Shops";
    }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Home_index_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Home_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Home_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue__);








var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    data: function data() {
        return {
            user: {},
            notifications: {},
            notifications_alert: {},
            componentMenuBottomkey: 0,
            market: {},
            market_groups: {},
            market_trending: {},
            products: {},
            product: {},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            menu_view: {},
            show_login: false,

            show_feeds: [],
            show_feed_slide: 'Status',
            slide_feed_width: '30%',
            count_2: 0
        };
    },


    components: {
        'component-landing': __WEBPACK_IMPORTED_MODULE_2__Home_index_vue___default.a,
        'component-header': __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue___default.a,
        'component-sticky-header': __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue___default.a,
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue___default.a,
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue___default.a
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        preset: function preset() {
            this.loading = true;
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;

                    self.getNotifications();
                } else {
                    self.show_login = true;
                }
            });
        },
        getNotifications: function getNotifications() {
            var _this = this;

            var navi = this.$router;
            service.getNotifications(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this.notifications = response.body.data;
                    _this.notifications_alert = response.body.data_alert_total;
                    _this.loading = false;

                    if (_this.notifications_alert > 0) {
                        var payload = {
                            notification_type: "user",
                            notification_user: _this.user.user_id,
                            notification_user_null_ref: _this.user.user_id,
                            notification_business: 0
                        };
                        service.readNotifications(_this, payload).then(function (response) {
                            if (response.body.status == 200) {}
                        }).catch(function (err) {});
                    }
                }
            }).catch(function (err) {});
        },
        clickNotifications: function clickNotifications(noti_id, noti_url) {
            var navi = this.$router;
            service.clickNotifications(this, noti_id).then(function (response) {
                navi.push(noti_url);
            }).catch(function (err) {
                navi.push(noti_url);
            });
        },
        setMarketRemote: function setMarketRemote() {
            var _this2 = this;

            service.getBusinessByUserName(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this2.market = response.body.data;
                    _this2.loading = false;
                }
            }).catch(function (err) {});
        },
        setMarketActivities: function setMarketActivities() {
            var _this3 = this;

            service.getMarketActivityProducts(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this3.market_trending = response.body.data;
                }
            }).catch(function (err) {});
        },
        setMarketGroups: function setMarketGroups() {
            var _this4 = this;

            service.getMarketGroupsProducts(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this4.market_groups = response.body.data;
                }
            }).catch(function (err) {});
        },
        setMenuComponent: function setMenuComponent(view, view_type, attr1, attr2) {
            var top = document.getElementById("topPanel").offsetTop;
            window.scrollTo(0, top);

            this.menu_view = {};
            this.menu_view[view] = true;
        },
        showFeeder: function showFeeder() {
            this.show_feeds = ["Yeah", "You", "Got", "Me", "Yeah", "You", "Got", "Me", "You", "Got", "You", "Got"];
            var f = this.show_feeds.length;
            this.slide_feed_width = 80 / f + '%';
            var self = this;
            var count = 0;

            var sub = 0;

            var _loop = function _loop(x) {
                sub = f - (f - count);
                if (count == sub) {
                    setTimeout(function () {
                        self.show_feed_slide = x;
                        document.getElementById("StatusCode-" + self.count_2).style.borderBottomColor = "#ff0000";
                        self.count_2++;
                    }, 5000 + count * 3000);
                }
                count++;
            };

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.show_feeds), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var x = _step.value;

                    _loop(x);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        showFeed: function showFeed(index, feed) {
            this.show_feed_slide = feed;
            var feed_color = document.getElementById("StatusCode-" + index).style.borderBottomColor;
            if (feed_color == "#3a3939") {
                feed_color = "#ff0000";
            } else {
                feed_color = "#3a3939";
            }
        }
    },
    created: function created() {
        this.menu_view["timeline"] = true;
        this.preset();
        this.setMarketRemote();
        this.setMarketGroups();
        this.setMarketActivities();

        var self = this;
        setTimeout(function () {
            self.showFeeder();
        }, 3000);
    }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_validation__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources_commons_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MainFooter_index_vue__);







var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();
var validator = new __WEBPACK_IMPORTED_MODULE_2__services_validation__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Onboarding',
    mixins: [__WEBPACK_IMPORTED_MODULE_3__resources_commons_js__["a" /* default */]],
    data: function data() {
        return {
            user: {},
            group: {},
            group_details: {},
            group_shared_link: false,
            set_headers: {},
            loading: true
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_4__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_5__MainFooter_index_vue___default.a
    },
    methods: {
        getGroup: function getGroup() {
            this.activity.activity_module_action_type = 6;

            var data_payload = {
                data_id: this.group.ref_code
            };
            this.activity.activity_module_data = data_payload;

            this.getActivity();

            var self = this;
            setTimeout(function () {
                localforage.getItem("activity_data_store", function (err, value) {
                    if (value != undefined) {
                        self.group_details = value;
                        self.loading = false;
                        self.setGroup();
                    } else {}
                });
            }, 2000);
        },
        setGroup: function setGroup() {
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.group_details).length > 0) {
                localStorage.setItem('group', this.group_details.group_data.group_name);

                if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.group_details.group_data).length > 0) {
                    localforage.setItem('active_group_data', this.group_details.group_data).then(function (value) {}).catch(function (err) {});
                }
            }
        }
    },
    created: function created() {
        if (this.$route.params.gref != undefined && this.$route.params.gref != '') {
            this.group_shared_link = true;
            this.group.ref_code = this.$route.params.gref;
            this.group.name = this.$route.params.grname;
            this.set_headers.name = this.$route.params.grname;

            if (this.$route.params.ref != undefined && this.$route.params.ref != '') {
                localStorage.setItem('refcode', this.$route.params.ref);
            }
            localStorage.setItem('grefcode', this.$route.params.gref);

            this.getGroup();
        }
    }

});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__resources_setts__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__ = __webpack_require__(14);






var _methods;



var service = new __WEBPACK_IMPORTED_MODULE_5__services_service__["a" /* default */]();




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Cart',
    props: ['userprop'],
    mixins: [__WEBPACK_IMPORTED_MODULE_6__resources_setts__["a" /* default */]],
    data: function data() {
        var _ref;

        return _ref = {
            loading: false,
            user: {},
            group_products: {},
            item_product: {},
            checked_out: [],
            processed_checkout_orders: [],
            sorted_cart: [],
            orders: [],
            cart: this.$store.state.cart,
            img_product_url: service.imageProductsURL,
            coupon_code: [],
            product_delivery_fee: "",
            sellpoint_delivery_fee: "",
            payment_option: "",
            total_order_amt: 0.0,
            total_delivery_fee: 0.0,
            processed_groups: 0,
            process_count: 0,
            loggedIn: false
        }, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'loading', true), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'buy_now_order', false), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'share_cart_option', false), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'part_payments_request_option', false), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'has_part_payments_request', 0), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'data_processing_message', ""), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'action_loading', false), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'shipping_fee_key', 0), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'total_orders_key', 0), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'shipping_fee_key_options', 0), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'order_delivery_main_location', {}), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'states', []), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'cities', []), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'componentDeliveryLocationsKey', 0), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'componentProductDeliveryLocationsKey', 0), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'disable_btn_01', false), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'coupon_entry', ''), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'coupon_entry_error', ''), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'couponsComponentKey', 0), _ref;
    },

    components: {},
    computed: {},
    methods: (_methods = {
        setComponent: function setComponent(attr1, attr2) {},
        showDropdown: function showDropdown(id) {
            document.getElementById(id).style = "display:block";
            var stl = document.getElementById(id).style;
            if (stl == "display:block") {
                document.getElementById(id).style = "display:none";
            } else {
                document.getElementById(id).style = "display:block";
            }
        },
        numFormat: function numFormat(str) {
            return str.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        },
        forceRerender: function forceRerender() {
            this.shipping_fee_key += 1;
            this.total_orders_key += 1;
            this.shipping_fee_key_options += 1;
        },
        toggleSingleDisplay: function toggleSingleDisplay(attr, id) {
            if (attr == true) {
                document.getElementById(id).style = "display:block";
            } else {
                document.getElementById(id).style = "display:none";
            }
        },
        toggleDoubleMultiDisplay: function toggleDoubleMultiDisplay(show_arr, hide_arr) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(show_arr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var show = _step.value;

                    document.getElementById(show).style = "display:block";
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(hide_arr), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var hide = _step2.value;

                    document.getElementById(hide).style = "display:none";
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        },
        toggleProductDelivery: function toggleProductDelivery(attr1, i, product_index) {
            if (attr1 == 'item-delivery-options') {
                this.sorted_cart[i][1][product_index].display_delivery_details = true;
            }
            if (attr1 == 'hide-item-delivery-options') {
                this.sorted_cart[i][1][product_index].display_delivery_details = false;
            }
        },
        toggleSellpointDelivery: function toggleSellpointDelivery(attr1, i) {
            if (attr1 == 'group-delivery-options') {
                this.sorted_cart[i].display_delivery_details++;
            }
            if (attr1 == 'hide-group-delivery-options') {
                this.sorted_cart[i].display_delivery_details = false;
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        checkOrderQuantity: function checkOrderQuantity(group_index, item_index, item_qty, qty) {
            if (Number(qty) > item_qty) {
                this.sorted_cart[group_index][1][item_index].quantity_check_pass = false;
                document.getElementById("qty_c" + item_index).innerHTML = "The quantity you entered is above Item Quantity";
                document.getElementById("qty_t" + item_index).style = "display:none";
                return false;
            } else {
                this.sorted_cart[group_index][1][item_index].quantity_check_pass = true;
                document.getElementById("qty_c" + item_index).innerHTML = "";

                document.getElementById("qty_t" + item_index).style = "display:block";
                return true;
            }
        },
        checkDiscountsByQuantity: function checkDiscountsByQuantity(group_index, item_index, item_qty, qty) {
            this.sorted_cart[group_index][1][item_index].product_item_total_discount = 0;
            if (this.sorted_cart[group_index][1][item_index].product_item_actual_price != 0) {
                this.sorted_cart[group_index][1][item_index].product_item_price = this.sorted_cart[group_index][1][item_index].product_item_actual_price;
            }

            var total_discount = 0;var calc_discount = 0;var product_item_discount_price = 0;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.sorted_cart[group_index][1][item_index].product_item_discounts), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var dc = _step3.value;

                    if (dc['discount_status_id'] == 5) {
                        if (dc['discount_coupon'] == 'D') {
                            if (Number(Number(qty) >= dc['discount_min_quantity'])) {
                                total_discount += Number(Number(dc['discount_percentage']));
                            }
                        }
                        if (dc['discount_coupon'] == 'C') {
                            if (Number(Number(qty) <= dc['discount_min_quantity'])) {
                                if (dc['added']) {
                                    this.set_coupons(group_index, item_index, dc, dc['discount_percentage']);
                                }
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            if (total_discount != 0) {
                this.sorted_cart[group_index][1][item_index].product_item_actual_price = this.sorted_cart[group_index][1][item_index].product_item_price;
                calc_discount = total_discount / 100 * this.sorted_cart[group_index][1][item_index].product_item_actual_price;
                product_item_discount_price = this.sorted_cart[group_index][1][item_index].product_item_price - calc_discount;
                this.sorted_cart[group_index][1][item_index].product_item_total_discount = total_discount;
                this.sorted_cart[group_index][1][item_index].product_item_price = product_item_discount_price;
            }
        },
        removeFromCart: function removeFromCart(item_id, group_index, item) {
            this.removeFromSortedCart(group_index, item);
            this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["w" /* REMOVE_FROM_CART */], item_id);

            this.prepCart();
        },
        removeFromSortedCart: function removeFromSortedCart(group_index, item) {
            var index = this.sorted_cart[group_index][1].findIndex(function (p) {
                return p._id === item._id;
            });
            this.sorted_cart[group_index][1].splice(index, 1);
        },
        prepCart: function prepCart() {
            this.activate_processing();
            this.cart = this.$store.state.cart;
            var sorted_cart = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.cart.reduce(function (result, obj) {
                (result[obj.product_business_sort] || (result[obj.product_business_sort] = [])).push(obj);
                return result;
            }, {}));


            var count = 0;var buy_now_count = 0;
            var sorted_cart_array = [];
            var pre_sort_index = 0;
            sorted_cart.forEach(function (element) {
                var _this = this;

                var pre_sort = [];

                pre_sort.can_show = true;
                pre_sort.products_with_delivery_details_count = 0;
                pre_sort.products_without_delivery_details_count = 0;
                pre_sort.products_with_delivery_details_checked = [];
                pre_sort.products_without_delivery_details_checked = [];

                element.forEach(function (item) {
                    item.can_show = true;
                    item.can_remove = true;
                    item.display_delivery_details = false;
                    item.actual_product_item_price = item.product_item_price;
                    item.item_order_coupons_discounts = [];
                    item.total_item_order_coupons_amount = 0;

                    item.has_delivery = false;
                    if (item.product_checked) {
                        item.product_checked = false;
                    }

                    service.getProductDeliveryOptions(this, item.product_main_id).then(function (response) {
                        if (response.body.status == 200) {
                            item.has_delivery = true;
                            item.delivery_option = 0;
                            pre_sort.products_with_delivery_details_count += 1;
                        } else {
                            pre_sort.products_without_delivery_details_count += 1;
                        }
                    }).catch(function (err) {
                        pre_sort.products_without_delivery_details_count += 1;
                    });

                    if (item.product_order_part_payments_request == 1) {
                        this.has_part_payments_request++;
                    }

                    if (this.part_payments_request_option && item.product_order_part_payments_request == 0) {
                        item.can_show = false;
                    }
                }, this);
                pre_sort.display_delivery_details = 0;
                pre_sort.business_name = element[0].product_business_name;
                pre_sort[0] = element[0].product_business;
                pre_sort.is_from_agent = 0;
                if (element[0].product_is_from_agent && element[0].product_is_from_agent == 1) {
                    pre_sort.is_from_agent = element[0].product_is_from_agent;
                    pre_sort.business_agent_username = element[0].product_business_agent_username;
                    pre_sort.business_agent_name = element[0].product_business_agent_name;
                }

                pre_sort.part_payments_request = 0;
                if (element[0].product_order_part_payments_request && element[0].product_order_part_payments_request == 1) {
                    pre_sort.part_payments_request = element[0].product_order_part_payments_request;
                }

                if (this.part_payments_request_option && pre_sort.part_payments_request == 0) {
                    pre_sort.can_show = false;
                }

                pre_sort[1] = element;
                pre_sort.items_in_checkout = 0;
                pre_sort.total_order_amt = 0.0;
                pre_sort.show_delivery_option = 0;
                pre_sort.delivery_option_fee = 0.0;
                pre_sort.total_delivery_charge = 0.0;
                pre_sort.delivery_states = [];
                pre_sort.selected_delivery_state_locations = [];
                pre_sort.total_order_coupons_amount = 0.0;
                pre_sort.order_coupons_discounts = [];
                pre_sort[4] = [];
                var promises = [];
                for (var i = 0; i < 5; ++i) {
                    if (i == 1) {
                        promises.push(service.getBusinessDiscountsAndCoupons(this, element[0].product_business).then(function (response) {
                            if (response.body.status == 200) {
                                pre_sort[4] = response.body.data;
                            }
                        }).catch(function (err) {}));
                    }

                    if (i == 2) {
                        promises.push(service.getBusinessDeliveryOptions(this, element[0].product_business).then(function (response) {
                            if (response.body.status == 200) {
                                var delivery_options = response.body.data;
                                pre_sort.delivery_states = response.body.data_states;

                                var last_or_only_item_in_array = element[element.length - 1];
                                if (last_or_only_item_in_array) {
                                    delivery_options.forEach(function (item) {
                                        var fees = item.business_products_delivery_fees;

                                        if (fees.length != 0) {
                                            fees.forEach(function (fee) {
                                                if (last_or_only_item_in_array.product_main_id == fee.product_delivery_product) {
                                                    item.has_product_delivery_fee = true;
                                                    item.business_product_delivery_fee = fee.product_delivery_fee;
                                                }
                                            }, this);
                                        } else {
                                            pre_sort[2] = delivery_options;
                                            this.deactivate_processing();
                                        }
                                    }, _this);
                                } else {
                                    _this.deactivate_processing();
                                }

                                pre_sort[2] = delivery_options;
                                if (pre_sort.delivery_states.length == 1) {
                                    pre_sort.selected_delivery_state_locations = delivery_options;
                                }

                                pre_sort.business_shipping_calculation_method = response.body.data_business_set_shipping_fee_status;
                                _this.deactivate_processing();
                            } else {
                                pre_sort.delivery_option = "Free Delivery";
                                pre_sort.delivery_general_set_option = {};
                                _this.deactivate_processing();
                            }

                            pre_sort.business_min_delivery_fee = response.body.data_min_delivery_fee;
                            pre_sort.business_max_delivery_fee = response.body.data_max_delivery_fee;
                        }).catch(function (err) {}));
                    }

                    if (i == 3) {
                        promises.push(service.checkBusinessPayOnDelivery(this, element[0].product_business).then(function (response) {
                            if (response.body.status == 200) {
                                pre_sort[3] = response.body.data;
                            }
                        }).catch(function (err) {}));
                    }
                }

                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
                    if (_this.buy_now_order && buy_now_count == 0) {
                        var buy_now_ref = localStorage.getItem('bnrf');
                        var itm_count = 0;

                        element.forEach(function (item) {
                            if (item.active_order) {
                                if (item.product_buy_now_ref && item.product_buy_now_ref == buy_now_ref) {
                                    pre_sort[1][itm_count].can_show = true;

                                    buy_now_count++;
                                } else {
                                    pre_sort[1][itm_count].can_show = false;
                                }
                            } else {
                                pre_sort[1][itm_count].can_show = false;
                            }
                            itm_count++;
                        }, _this);

                        if (buy_now_count == 1) {
                            sorted_cart_array.push(pre_sort);
                        }
                    } else {
                            sorted_cart_array.push(pre_sort);
                        }
                }).catch(function (e) {});

                pre_sort_index++;
            }, this);

            this.sorted_cart = sorted_cart_array;

            this.loading = false;

            return this.sorted_cart;
        },
        preset: function preset() {
            this.loading = true;
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;
                    self.loading = false;
                } else {}

                self.prepCart();
            });
        },
        verifyCouponEntry: function verifyCouponEntry(group_index) {
            this.coupon_entry_error = "";
            var coupon_index = 0;
            var coupon_match = 0;
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.sorted_cart[group_index][4]), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var coupon = _step4.value;

                    if (coupon.discount_is_private == 1) {
                        if (coupon.discount_coupon_code == this.coupon_entry) {
                            this.sorted_cart[group_index][4][coupon_index].discount_validated = 1;
                            this.couponsComponentKey++;
                            coupon_match++;
                        }
                    }
                    coupon_index++;
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            if (coupon_match == 0) {
                this.coupon_entry_error = "sorry, not verified";
            }
            this.coupon_entry = '';
        },
        canUseCoupon: function canUseCoupon(coupon) {
            if (coupon.discount_type == 4 || coupon.discount_type == 5) {
                if (coupon.discount_type == 4) {
                    var sorted = this.checked_out.filter(function (item) {
                        return item.product_main_id == coupon.discount_product;
                    });
                    if (sorted.length != 0) {
                        return true;
                    }
                }
                if (coupon.discount_type == 5) {
                    var _sorted = this.checked_out.filter(function (item) {
                        return item.product_item_id == coupon.discount_product_item;
                    });
                    if (_sorted.length != 0) {
                        return true;
                    }
                }
            } else {
                return true;
            }
        },
        set_coupons: function set_coupons(i, i2, coupon, coupon_percentage) {
            var calc = 0;
            var calc_by_qty = 0;
            if (this.sorted_cart[i].total_order_amt != 0) {
                if (!coupon.added) {
                    if (coupon.discount_type == 4 || coupon.discount_type == 5) {
                        if (Number(this.sorted_cart[i][1][i2].product_item_order_quantity) >= coupon['discount_min_quantity']) {
                            calc = coupon_percentage / 100 * this.sorted_cart[i][1][i2].actual_product_item_price;
                            calc_by_qty = calc * this.sorted_cart[i][1][i2].product_item_order_quantity;
                            this.sorted_cart[i][1][i2].item_order_coupons_discounts.push(coupon);
                            this.sorted_cart[i][1][i2].total_item_order_coupons_amount += calc;
                            this.sorted_cart[i][1][i2].product_item_price -= calc;

                            this.sorted_cart[i].total_order_amt -= calc_by_qty;

                            this.total_order_amt -= calc_by_qty;
                            coupon.value = calc;
                        }
                    } else {
                        if (Number(this.sorted_cart[i].items_in_checkout) >= coupon['discount_min_quantity']) {
                            calc = coupon_percentage / 100 * this.sorted_cart[i].total_order_amt;

                            this.sorted_cart[i].order_coupons_discounts.push(coupon);
                            this.sorted_cart[i].total_order_coupons_amount += calc;
                            this.sorted_cart[i].total_order_amt -= calc;

                            this.total_order_amt -= calc;
                            coupon.value = calc;
                        }
                    }

                    coupon.added = true;
                } else {
                    calc = coupon.value;

                    if (coupon.discount_type == 4 || coupon.discount_type == 5) {
                        calc_by_qty = calc * this.sorted_cart[i][1][i2].product_item_order_quantity;
                        if (Number(this.sorted_cart[i][1][i2].product_item_order_quantity) >= coupon['discount_min_quantity']) {
                            var index = this.sorted_cart[i][1][i2].item_order_coupons_discounts.findIndex(function (c) {
                                return c.discount_id === coupon.discount_id;
                            });
                            this.sorted_cart[i][1][i2].item_order_coupons_discounts.splice(index, 1);
                            this.sorted_cart[i][1][i2].total_item_order_coupons_amount -= calc;
                            this.sorted_cart[i][1][i2].product_item_price += calc;

                            this.sorted_cart[i].total_order_amt += calc_by_qty;

                            this.total_order_amt += calc_by_qty;
                        }
                    } else {
                        if (Number(this.sorted_cart[i].items_in_checkout) >= coupon['discount_min_quantity']) {
                            var _index = this.sorted_cart[i].order_coupons_discounts.findIndex(function (c) {
                                return c.discount_id === coupon.discount_id;
                            });
                            this.sorted_cart[i].order_coupons_discounts.splice(_index, 1);
                            this.sorted_cart[i].total_order_coupons_amount -= calc;
                            this.sorted_cart[i].total_order_amt += calc;

                            this.total_order_amt += calc;
                        }
                    }

                    coupon.added = false;
                    coupon.value = 0;
                }
            } else {
                this.coupon_code.checked = false;
            }
            this.forceRerender();
        },
        getDeliveryLocations: function getDeliveryLocations(i, delivery_selected_state) {
            this.activate_processing();
            if (delivery_selected_state != undefined) {
                var sorted_options = [];
                this.sorted_cart[i].selected_business_delivery_option = false;var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.sorted_cart[i][2]), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var option = _step5.value;

                        if (option.business_delivery_state_id == delivery_selected_state.state_id) {
                            sorted_options.push(option);
                        }
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }

                this.sorted_cart[i].selected_delivery_state_locations = sorted_options;
                document.getElementById(i + "BDLS").style = "display:block;";
                this.componentDeliveryLocationsKey++;
            }
        },
        getStates: function getStates() {
            var _this2 = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this2.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state) {
            var _this3 = this;

            this.activate_processing();
            if (state != undefined) {
                service.getCities(this, state.state_id).then(function (response) {
                    if (response.body.status == 200) {
                        _this3.cities = response.body.data;
                        _this3.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this3.deactivate_processing();
                });
            }
        },
        setOrderLocations: function setOrderLocations(location) {
            if (location.city != undefined) {
                var i = 0;
                var _iteratorNormalCompletion6 = true;
                var _didIteratorError6 = false;
                var _iteratorError6 = undefined;

                try {
                    for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.sorted_cart), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                        var group = _step6.value;

                        if (group[2] && group[2].length != 0) {
                            var _iteratorNormalCompletion7 = true;
                            var _didIteratorError7 = false;
                            var _iteratorError7 = undefined;

                            try {
                                for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(group[2]), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                                    var option = _step7.value;

                                    if (option.business_delivery_state_id == location.state.state_id) {
                                        if (option.business_delivery_city == location.city.city_id || option.business_delivery_other_option == location.city.city_name || option.business_delivery_city == 0 && option.business_delivery_other_option == 'nill') {
                                            this.calc_sellpoint_delivery_fee(i, option);
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError7 = true;
                                _iteratorError7 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                        _iterator7.return();
                                    }
                                } finally {
                                    if (_didIteratorError7) {
                                        throw _iteratorError7;
                                    }
                                }
                            }
                        } else {
                            this.sorted_cart[i].delivery_general_set_option = location;

                            this.sorted_cart[i].delivery_selected_state = location.state;
                            this.sorted_cart[i].selected_business_delivery_option = location.city;
                            this.sorted_cart[i].delivery_selected_state.state_name = location.state.name;
                            this.sorted_cart[i].selected_business_delivery_option.business_delivery_option = location.city.city_name;
                            this.shipping_fee_key_options++;
                        }
                        i++;
                    }
                } catch (err) {
                    _didIteratorError6 = true;
                    _iteratorError6 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion6 && _iterator6.return) {
                            _iterator6.return();
                        }
                    } finally {
                        if (_didIteratorError6) {
                            throw _iteratorError6;
                        }
                    }
                }
            }
        },
        calc_product_delivery_fee: function calc_product_delivery_fee(i, option, product_index) {
            if (this.sorted_cart[i][1][product_index].delivery_option_fee != undefined) {
                if (this.sorted_cart[i][1][product_index].delivery_option_fee != 0.0) {
                    this.total_delivery_fee -= this.sorted_cart[i][1][product_index].delivery_option_fee;
                    this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i][1][product_index].delivery_option_fee;
                }
            }

            this.sorted_cart[i][1][product_index].selected_product_delivery_option = option;

            this.sorted_cart[i][1][product_index].delivery_option = option.business_delivery_option_id;
            this.sorted_cart[i][1][product_index].delivery_option_fee = Number(option.business_delivery_option_price);

            this.sorted_cart[i].total_delivery_charge += Number(option.business_delivery_option_price);
            this.total_delivery_fee += Number(option.business_delivery_option_price);
        },
        calc_sellpoint_delivery_fee_XXX: function calc_sellpoint_delivery_fee_XXX(i, option) {
            if (this.sorted_cart[i].delivery_option_fee != 0.0) {
                this.total_delivery_fee -= this.sorted_cart[i].delivery_option_fee;
                this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i].delivery_option_fee;
            }

            this.sorted_cart[i].selected_business_delivery_option = option;

            this.sorted_cart[i].delivery_option = option.business_delivery_option_id;
            this.sorted_cart[i].delivery_option_fee = Number(option.business_delivery_option_price);

            this.sorted_cart[i].total_delivery_charge += Number(option.business_delivery_option_price);

            this.total_delivery_fee += Number(option.business_delivery_option_price);
        },
        calc_sellpoint_delivery_fee: function calc_sellpoint_delivery_fee(i, option) {
            if (this.sorted_cart[i].delivery_option_fee != 0.0) {
                this.total_delivery_fee -= this.sorted_cart[i].delivery_option_fee;
                this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i].delivery_option_fee;
            }

            this.sorted_cart[i].selected_business_delivery_option = option;
            this.sorted_cart[i].delivery_option = option.business_delivery_option_id;

            this.sorted_cart[i].delivery_option_total_delivery_fee = 0;

            var fees = option.business_products_delivery_fees;
            if (fees.length == 0) {
                if (this.sorted_cart[i].business_shipping_calculation_method == 9) {
                    this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price);
                } else {
                    var items_to_checkout = this.sorted_cart[i][1].filter(function (item) {
                        return item.product_checked == true;
                    });
                    var _iteratorNormalCompletion8 = true;
                    var _didIteratorError8 = false;
                    var _iteratorError8 = undefined;

                    try {
                        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(items_to_checkout), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                            var item = _step8.value;

                            if (this.sorted_cart[i].business_shipping_calculation_method == 10) {
                                this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price);
                            }
                            if (this.sorted_cart[i].business_shipping_calculation_method == 11) {
                                this.sorted_cart[i].delivery_option_total_delivery_fee += Number(item.product_item_order_quantity * option.business_delivery_option_price);
                            }
                        }
                    } catch (err) {
                        _didIteratorError8 = true;
                        _iteratorError8 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion8 && _iterator8.return) {
                                _iterator8.return();
                            }
                        } finally {
                            if (_didIteratorError8) {
                                throw _iteratorError8;
                            }
                        }
                    }
                }
            } else {
                var _items_to_checkout = this.sorted_cart[i][1].filter(function (item) {
                    return item.product_checked == true;
                });

                var _iteratorNormalCompletion9 = true;
                var _didIteratorError9 = false;
                var _iteratorError9 = undefined;

                try {
                    for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_items_to_checkout), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                        var _item = _step9.value;

                        if (_item.has_calculated_product_delivery_fee == true) {
                            _item.product_delivery_fee = 0;
                            _item.has_calculated_product_delivery_fee = false;
                            _item.calculated_product_delivery_fee = 0;
                        };
                        var _iteratorNormalCompletion11 = true;
                        var _didIteratorError11 = false;
                        var _iteratorError11 = undefined;

                        try {
                            for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(fees), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                                var fee = _step11.value;

                                _item.product_delivery_fee = Number(fee.product_delivery_fee);
                                if (_item.product_main_id == fee.product_delivery_product) {
                                    if (_item.product_shipping_calculation_method == 13) {
                                        this.sorted_cart[i].delivery_option_total_delivery_fee += Number(_item.product_item_order_quantity * fee.product_delivery_fee);
                                        _item.calculated_product_delivery_fee = Number(_item.product_item_order_quantity * fee.product_delivery_fee);
                                    }
                                    if (_item.product_shipping_calculation_method == 12) {
                                        this.sorted_cart[i].delivery_option_total_delivery_fee += Number(fee.product_delivery_fee);
                                        _item.calculated_product_delivery_fee = Number(fee.product_delivery_fee);
                                    }

                                    _item.has_calculated_product_delivery_fee = true;
                                }
                            }
                        } catch (err) {
                            _didIteratorError11 = true;
                            _iteratorError11 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion11 && _iterator11.return) {
                                    _iterator11.return();
                                }
                            } finally {
                                if (_didIteratorError11) {
                                    throw _iteratorError11;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError9 = true;
                    _iteratorError9 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion9 && _iterator9.return) {
                            _iterator9.return();
                        }
                    } finally {
                        if (_didIteratorError9) {
                            throw _iteratorError9;
                        }
                    }
                }

                var sorted_fees = _items_to_checkout.filter(function (item) {
                    return item.has_calculated_product_delivery_fee == true;
                });

                if (sorted_fees.length < _items_to_checkout.length) {
                    if (this.sorted_cart[i].business_shipping_calculation_method == 9) {
                        this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price);
                    } else {
                        var _iteratorNormalCompletion10 = true;
                        var _didIteratorError10 = false;
                        var _iteratorError10 = undefined;

                        try {
                            for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_items_to_checkout), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                                var _item2 = _step10.value;

                                if (!_item2.has_calculated_product_delivery_fee) {
                                    if (this.sorted_cart[i].business_shipping_calculation_method == 10) {
                                        this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price);
                                    }
                                    if (this.sorted_cart[i].business_shipping_calculation_method == 11) {
                                        this.sorted_cart[i].delivery_option_total_delivery_fee += Number(_item2.product_item_order_quantity * option.business_delivery_option_price);
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError10 = true;
                            _iteratorError10 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion10 && _iterator10.return) {
                                    _iterator10.return();
                                }
                            } finally {
                                if (_didIteratorError10) {
                                    throw _iteratorError10;
                                }
                            }
                        }
                    }
                }
            }

            this.sorted_cart[i].delivery_option_fee = Number(this.sorted_cart[i].delivery_option_total_delivery_fee);

            this.sorted_cart[i].total_delivery_charge += Number(this.sorted_cart[i].delivery_option_total_delivery_fee);

            this.total_delivery_fee += Number(this.sorted_cart[i].delivery_option_total_delivery_fee);

            this.forceRerender();
        },
        setPaymentOption: function setPaymentOption(i, option) {
            this.sorted_cart[i].payment_mode = option;
        },
        pre_checkout: function pre_checkout() {
            this.preset();
        },
        addRefreshCheckout: function addRefreshCheckout(it, group_index, item_index) {
            it.product_item_order_quantity++;
            this.refreshCheckout(it, group_index, item_index);
        },
        removeRefreshCheckout: function removeRefreshCheckout(it, group_index, item_index) {
            if (it.product_item_order_quantity > 1) {
                it.product_item_order_quantity--;
                this.refreshCheckout(it, group_index, item_index);
            }
        },
        refreshCheckout: function refreshCheckout(it, group_index, item_index) {
            this.checkWholesalePrices(it, group_index, item_index);

            this.checkDiscountsByQuantity(group_index, item_index, it.product_item_quantity, it.product_item_order_quantity);

            if (it.product_item_order_quantity >= 1) {
                if (this.checkOrderQuantity(group_index, item_index, it.product_item_quantity, it.product_item_order_quantity)) {
                    this.sorted_cart[group_index].total_order_amt = 0.0;
                    this.total_order_amt = 0.0;
                    this.checked_out.forEach(function (item) {
                        this.sorted_cart[group_index].total_order_amt += item.product_item_order_quantity * item.product_item_price;

                        this.total_order_amt += item.product_item_order_quantity * item.product_item_price;
                    }, this);

                    if (this.sorted_cart[group_index][1][item_index].item_order_coupons_discounts.length > 0) {
                        this.sorted_cart[group_index][1][item_index].item_order_coupons_discounts.forEach(function (coupon) {
                            coupon.added = false;
                            var index = this.sorted_cart[group_index][1][item_index].item_order_coupons_discounts.findIndex(function (c) {
                                return c.discount_id === coupon.discount_id;
                            });
                            this.sorted_cart[group_index][1][item_index].item_order_coupons_discounts.splice(index, 1);

                            this.set_coupons(group_index, item_index, coupon, coupon.discount_percentage);
                        }, this);
                    }

                    if (this.sorted_cart[group_index].order_coupons_discounts.length > 0) {
                        this.sorted_cart[group_index].order_coupons_discounts.forEach(function (coupon) {
                            coupon.added = false;
                            var index = this.sorted_cart[group_index].order_coupons_discounts.findIndex(function (c) {
                                return c.discount_id === coupon.discount_id;
                            });
                            this.sorted_cart[group_index].order_coupons_discounts.splice(index, 1);
                            this.sorted_cart[group_index].total_order_coupons_amount -= coupon.value;
                            this.set_coupons(group_index, item_index, coupon, coupon.discount_percentage);
                        }, this);
                    }

                    if (this.sorted_cart[group_index].selected_business_delivery_option) {
                        this.calc_sellpoint_delivery_fee(group_index, this.sorted_cart[group_index].selected_business_delivery_option);
                    }
                }

                this.forceRerender();
            }
        },
        addToCheckout: function addToCheckout(item, group_index, item_index) {
            if (item.product_item_order_quantity == 0) {
                item.product_item_order_quantity = 1;
            }

            this.sorted_cart[group_index][1][item_index].can_remove = false;
            this.sorted_cart[group_index].products_in_checkout = true;
            if (this.sorted_cart[group_index][1][item_index].has_delivery) {
                this.sorted_cart[group_index].products_with_delivery_details_checked.push(item);
            } else {
                this.sorted_cart[group_index].products_without_delivery_details_checked.push(item);
            }

            if (this.sorted_cart[group_index].show_delivery_option == 0) {
                if (item.product_item_need_shipping == 0) {
                    this.sorted_cart[group_index].show_delivery_option = 0;
                    this.sorted_cart[group_index].delivery_option = "Free Delivery";
                } else {
                    this.sorted_cart[group_index].show_delivery_option = 1;
                }
            }

            this.checked_out.push(item);
            this.sorted_cart[group_index][1][item_index].product_checked = true;
            this.sorted_cart[group_index].total_order_amt += item.product_item_order_quantity * item.product_item_price;

            this.total_order_amt += item.product_item_order_quantity * item.product_item_price;
            this.sorted_cart[group_index].items_in_checkout++;

            if (this.sorted_cart[group_index][1][item_index].has_delivery) {
                this.sorted_cart[group_index][1][item_index].display_delivery_details = true;
            }

            if (this.sorted_cart[group_index].selected_business_delivery_option) {
                this.calc_sellpoint_delivery_fee(group_index, this.sorted_cart[group_index].selected_business_delivery_option);
            }

            if (this.buy_now_order) {
                document.getElementById(item.item_index + "PRT_CART").style = "display:block;";
            }
        },
        removeFromCheckout: function removeFromCheckout(item, group_index, item_index) {
            var index = this.checked_out.findIndex(function (p) {
                return p._id === item._id;
            });
            this.checked_out.splice(index, 1);
            this.sorted_cart[group_index][1][item_index].product_checked = false;

            if (this.sorted_cart[group_index][1][item_index].item_order_coupons_discounts && this.sorted_cart[group_index][1][item_index].item_order_coupons_discounts.length > 0) {
                this.sorted_cart[group_index][1][item_index].item_order_coupons_discounts.forEach(function (coupon) {
                    var index = this.sorted_cart[group_index][1][item_index].item_order_coupons_discounts.findIndex(function (c) {
                        return c.discount_id === coupon.discount_id;
                    });
                    this.sorted_cart[group_index][1][item_index].item_order_coupons_discounts.splice(index, 1);
                    this.sorted_cart[group_index][1][item_index].total_item_order_coupons_amount -= coupon.value;
                    coupon.added = false;
                    this.sorted_cart[group_index][1][item_index].product_item_price += coupon.value;

                    this.sorted_cart[group_index].total_order_amt += coupon.value;
                }, this);
            }

            if (this.sorted_cart[group_index][1][item_index].has_delivery) {
                var _index2 = this.sorted_cart[group_index].products_with_delivery_details_checked.findIndex(function (p) {
                    return p._id === item._id;
                });
                this.sorted_cart[group_index].products_with_delivery_details_checked.splice(_index2, 1);;
            } else {
                var _index3 = this.sorted_cart[group_index].products_without_delivery_details_checked.findIndex(function (p) {
                    return p._id === item._id;
                });
                this.sorted_cart[group_index].products_without_delivery_details_checked.splice(_index3, 1);;
            }

            this.sorted_cart[group_index].total_order_amt -= item.product_item_order_quantity * item.product_item_price;

            this.total_order_amt -= item.product_item_order_quantity * item.product_item_price;
            this.sorted_cart[group_index].items_in_checkout--;

            this.sorted_cart[group_index][1][item_index].can_remove = true;
            if (this.sorted_cart[group_index].items_in_checkout == 0 && this.sorted_cart[group_index].delivery_option != "Free Delivery") {
                this.total_delivery_fee -= this.sorted_cart[group_index].delivery_option_fee;
                this.sorted_cart[group_index].delivery_option_fee = 0;
                this.sorted_cart[group_index].delivery_option = 0;
                this.sorted_cart[group_index].total_delivery_charge = 0;
            }

            if (this.sorted_cart[group_index].selected_business_delivery_option) {
                this.calc_sellpoint_delivery_fee(group_index, this.sorted_cart[group_index].selected_business_delivery_option);
            }
        },
        checkWholesalePrices: function checkWholesalePrices(item, group_index, item_index) {
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item.product_item_moqs).length !== 0) {
                if (item.product_item_actual_mapped_price != 0) {
                    this.sorted_cart[group_index][1][item_index].product_item_price = item.product_item_actual_mapped_price;
                }

                var checked_moqs = [];var _iteratorNormalCompletion12 = true;
                var _didIteratorError12 = false;
                var _iteratorError12 = undefined;

                try {
                    for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(item.product_item_moqs), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                        var moq = _step12.value;

                        if (!checked_moqs.includes(moq.product_item_moq_id)) {
                            if (Number(Number(this.sorted_cart[group_index][1][item_index].product_item_order_quantity) >= moq.product_item_moq)) {
                                this.sorted_cart[group_index][1][item_index].product_item_price = moq.product_item_moq_price;
                                this.sorted_cart[group_index][1][item_index].product_item_price_f = this.numFormat(this.sorted_cart[group_index][1][item_index].product_item_price);
                            }
                        }
                        checked_moqs.push(moq.product_item_moq_id);
                    }
                } catch (err) {
                    _didIteratorError12 = true;
                    _iteratorError12 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion12 && _iterator12.return) {
                            _iterator12.return();
                        }
                    } finally {
                        if (_didIteratorError12) {
                            throw _iteratorError12;
                        }
                    }
                }
            }
        },
        process_checkout: function process_checkout(group) {
            if (this.checked_out.length > 0) {
                var processed_checkout = {};

                processed_checkout.order_user_id = this.user.user_id || 0;

                processed_checkout.order_business = group[0];

                if (group.is_from_agent == 1) {
                    processed_checkout.order_is_from_agent = group.is_from_agent;
                    processed_checkout.order_business_agent = group.business_agent_username;
                }

                if (this.part_payments_request_option || group.part_payments_request == 1) {
                    processed_checkout.order_part_payments_request = 1;
                }

                var order_url = group[0] + new Date().getTime();
                processed_checkout.order_url = order_url, processed_checkout.order_total_amount = group.total_order_amt;
                processed_checkout.order_delivery_option = group.delivery_option;
                processed_checkout.order_total_delivery_charge = group.total_delivery_charge;
                processed_checkout.order_payment_mode = group.payment_mode || 1;
                processed_checkout.order_coupons_discounts = group.order_coupons_discounts;
                processed_checkout.total_order_coupons_amount = group.total_order_coupons_amount;
                processed_checkout.order_share_cart = 0;

                if (processed_checkout.order_delivery_option == "Free Delivery" && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(group.delivery_general_set_option).length > 0) {
                    processed_checkout.order_delivery_set_state = group.delivery_general_set_option.state.state_id;
                    processed_checkout.order_delivery_set_location = group.delivery_general_set_option.city.city_id;
                }
                if (this.share_cart_option) {
                    processed_checkout.order_share_cart = 1;
                }
                processed_checkout.order_items = [];
                this.checked_out.forEach(function (element) {
                    if (element.product_business == group[0]) {
                        processed_checkout.order_items.push(element);
                    }
                    processed_checkout.status = "processed";
                }, this);
                if (processed_checkout.status == "processed") {
                    if (this.loggedIn) {
                        processed_checkout.order_mode = 1;
                        service.checkout(this, processed_checkout).then(function (data) {
                            if (data.body.status == 201) {
                                this.process_count++;

                                processed_checkout.order_items.forEach(function (item) {
                                    this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["w" /* REMOVE_FROM_CART */], item._id);
                                    var index = this.checked_out.findIndex(function (p) {
                                        return p._id === item._id;
                                    });
                                    this.checked_out.splice(index, 1);
                                }, this);
                            }

                            if (this.process_count == this.processed_groups) {
                                this.total_delivery_fee = 0;
                                this.total_order_amt = 0;

                                this.data_processing_message = 'Processing......';

                                location.replace("/checkout/");
                            }
                        }).catch(function (err) {
                            if (err) {}
                        });
                    } else {
                        processed_checkout.order_mode = 0;
                        this.process_count++;

                        processed_checkout.order_items.forEach(function (item) {
                            this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["w" /* REMOVE_FROM_CART */], item._id);
                            var index = this.checked_out.findIndex(function (p) {
                                return p._id === item._id;
                            });
                            this.checked_out.splice(index, 1);
                        }, this);

                        if (this.process_count == this.processed_groups) {
                            this.total_delivery_fee = 0;
                            this.total_order_amt = 0;
                        }

                        return processed_checkout;
                    }
                }
            }
        },
        share_cart: function share_cart() {
            this.share_cart_option = true;
            if (this.share_cart_option) {
                this.process_orders();
            }
        },
        process_orders: function process_orders() {
            this.data_processing_message = '';
            this.disable_btn_01 = true;
            if (this.checked_out.length == 0) {
                this.data_processing_message = 'Select Items to process';
            } else {

                var processed = [];
                var process_errors = 0;
                var process_error_list = [];

                this.checked_out.forEach(function (item) {
                    if (Number(item.product_item_order_quantity) > item.product_item_quantity) {
                        var err = "The quantity you entered for " + item.product_name + " is above Item Quantity";
                        process_errors++;
                        process_error_list.push(err);
                    }
                }, this);

                this.sorted_cart.forEach(function (group) {
                    if (group.items_in_checkout) {
                        if (group[2] && group[2].length > 0) {
                            if (group.delivery_option != 0 && group.delivery_option != undefined) {
                                processed.push(group);
                            } else {
                                var err = "";
                                if (this.buy_now_order) {
                                    err = "Please select a delivery option";
                                } else {
                                    err = "Please select a delivery option for " + group.business_name;
                                }
                                process_errors++;
                                process_error_list.push(err);
                            }
                        } else {
                            group.delivery_option = "Free Delivery";
                            processed.push(group);
                        }
                    }
                }, this);

                if (process_errors > 0) {
                    process_error_list.forEach(function (error) {
                        this.data_processing_message = this.data_processing_message + " . " + error;
                        this.disable_btn_01 = false;
                    }, this);
                } else {
                    if (this.loggedIn) {
                        if (processed.length != 0 && process_errors == 0) {
                            this.processed_groups = processed.length;
                            processed.forEach(function (group) {
                                this.process_checkout(group);
                            }, this);
                        }
                    } else {
                        var processed_to_store_in_forage = [];
                        if (processed.length != 0 && process_errors == 0) {
                            this.processed_groups = processed.length;
                            processed.forEach(function (group) {
                                processed_to_store_in_forage.push(this.process_checkout(group));
                            }, this);
                            localforage.setItem('not_loggedin_processed_orders', processed_to_store_in_forage).then(function (value) {}).catch(function (err) {});
                        }

                        this.data_processing_message = 'Processing Orders......';
                        this.$router.push("checkout");
                    }
                }
            }
        }
    }, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_methods, 'getStates', function getStates() {
        var _this4 = this;

        service.getStates(this).then(function (response) {
            if (response.body.status == 200) {
                _this4.states = response.body.data;
            }
        }).catch(function (err) {});
    }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_methods, 'getCities', function getCities(state) {
        var _this5 = this;

        this.activate_processing();
        if (state != undefined) {
            service.getCities(this, state.state_id).then(function (response) {
                if (response.body.status == 200) {
                    _this5.cities = response.body.data;
                    _this5.deactivate_processing();
                }
            }).catch(function (err) {
                _this5.deactivate_processing();
            });
        }
    }), _methods),
    created: function created() {
        if (this.$route.path == '/order') {
            this.buy_now_order = true;
        }
        document.title = "Cart" + " | " + service.app_name;


        this.getStates();

        var self = this;
        localforage.getItem('xvue', function (err, value) {
            if (value != undefined) {
                self.cart = value.cart;
                console.log(126677);console.log(self.cart);
            } else {}
            self.preset();
        });
    }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CartWidget_index_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CartWidget_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CartWidget_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__ = __webpack_require__(14);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Cart',
  data: function data() {
    return {
      loading: false,
      user: {},
      cart: this.$store.state.cart,
      img_product_url: service.imageProductsURL,
      loggedIn: false
    };
  },

  components: {
    'cart-widget': __WEBPACK_IMPORTED_MODULE_2__CartWidget_index_vue___default.a,
    'component-footer': __WEBPACK_IMPORTED_MODULE_1__MainFooter_index_vue___default.a
  },
  computed: {},
  methods: {},
  created: function created() {
    document.title = "Cart" + "";

    var self = this;
    localforage.getItem('xvue', function (err, value) {
      if (value != undefined) {
        console.log(694);console.log(value);
        self.cart = value.cart;
      } else {}
    });
  }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resources_setts_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__ = __webpack_require__(14);







var service = new __WEBPACK_IMPORTED_MODULE_3__services_service__["a" /* default */]();



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Checkout',
    props: {
        paymentdata: Object
    },
    watch: {
        paymentdata: function paymentdata(newVal, oldVal) {}
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_5__resources_setts_js__["a" /* default */]],
    data: function data() {
        return {
            flexi_pay: false,
            user: {},
            selected_order: [],
            checkout_orders: {},
            delivery_details: [],
            share_cart_details: {},
            payment_details: {},
            payment_mode: "",
            request_page: "orders",
            checked_out: [],
            processed_checkout_orders: [],
            sorted_cart: [],
            orders: [],
            cart: this.$store.state.cart,
            img_product_url: service.imageProductsURL,
            item_delivery_fee: "",
            delivery_fee: "",
            payment_option: "",
            total_order_items_total: 0.0,
            total_orders_amount: 0.0,
            total_order_coupon_amount: 0.0,
            total_shipping_fee: 0.0,
            total_processing_fee: 0.0,
            states: {},
            cities: [],
            set_cities: [],
            loggedIn: false,
            new_account: true,
            process_count: 0,
            checkout_processed: false,
            data_error_message: "",
            data_success_message: "",
            is_logged_in_order_mode: 0,
            disable_btn: false,
            loading: true,
            action_loading: false,
            user_delivery_address: "",
            order_delivery_state: "",
            order_delivery_city: "",

            shipping_locations: {},
            order_delivery_main_location: {},
            order_delivery_sorted_locations: {},
            group_set_order_delivery_key: 0,
            data_processing_message: "",
            componentOrderSummaryKey: 0,
            componentOrderMainLocation: 0,
            processed_single_order_count: 0,
            payment_active_resolve_ref: "",
            process_orders_update: [],

            set_gift_card: {},
            order_gift_card: {},

            app_url: service.app_url,
            menu_tab_inner_view: {},
            copied: false,
            set_order_user_delivery_address: '',
            transfer_verification_mode: 0,
            file_info: {},
            file_data_type: "",
            imageForm: "",
            flexi_active_payment_status: 0
        };
    },

    components: {
        'component-footer': __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue___default.a
    },
    computed: {},
    methods: {
        copyLink: function copyLink(link, id) {
            this.$clipboard(link);
            this.copied = true;
            document.getElementById(id).style.display = "block";
        },
        setMenuTabInnerView: function setMenuTabInnerView(view, attr1, attr2) {
            this.setComponent('reset-edit', '');
            this.menu_tab_inner_view = {};
            this.menu_tab_inner_view[view] = true;
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == 'login') {
                this.new_account = false;
            }
            if (attr1 == 'new-account') {
                this.new_account = true;
            }
            if (attr1 == 'change-delivery-option') {
                this.checkout_orders[attr2].change_delivery_option = true;
                document.getElementById("cdl" + attr2).style = "display:block;";
                document.getElementById("cdlb" + attr2).style = "display:none;";
            }
            if (attr1 == 'cancel-change-delivery-option') {
                this.checkout_orders[attr2].change_delivery_option = false;
                document.getElementById("cdl" + attr2).style = "display:none;";
                document.getElementById("cdlb" + attr2).style = "display:block;";
            }
            if (attr1 == 'close-enter-delivery-address') {
                this.checkout_orders[attr2].order_user_delivery_address = this.set_order_user_delivery_address;
                this.checkout_orders[attr2].data_processing_message = "";
                this.checkout_orders[attr2].show_address_input = false;
                this.componentOrderSummaryKey++;
            }
        },
        toggleViews: function toggleViews(view) {
            if (document.getElementById(view).style.display == "block") {
                document.getElementById(view).style = "display:none;";
            } else {
                document.getElementById(view).style = "display:block;";
            }
        },
        closeViews: function closeViews(view) {
            document.getElementById(view).style = "display:none;";
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        removeFromCheckout: function removeFromCheckout(group_index, order, item) {
            var index = this.checkout_orders[group_index].order_items.findIndex(function (ord) {
                return ord.order_item_no === item.order_item_no;
            });
            this.checkout_orders[group_index].order_items.splice(index, 1);
            if (this.checkout_orders[group_index].order_items.length == 0) {
                var index2 = this.checkout_orders.findIndex(function (o) {
                    return o.order_id === order.order_id;
                });
                this.checkout_orders.splice(index2, 1);
            }
        },
        getStates: function getStates() {
            var _this = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state) {
            var _this2 = this;

            this.activate_processing();
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this2.cities = response.body.data;
                    _this2.deactivate_processing();
                }
            }).catch(function (err) {
                _this2.deactivate_processing();
            });
        },
        setCities: function setCities(state) {
            var _this3 = this;

            if (state != undefined) {
                this.activate_processing();
                service.getCities(this, state.state_id).then(function (response) {
                    if (response.body.status == 200) {
                        _this3.set_cities = response.body.data;
                        _this3.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this3.deactivate_processing();
                });
            }
        },
        setOrderLocations: function setOrderLocations(location) {
            if (location.city != undefined) {
                this.order_delivery_main_location.address = '';
                var i = 0;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.checkout_orders), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var group = _step.value;

                        if (group.order_business_delivery_options && group.order_business_delivery_options.length == 0) {
                            this.checkout_orders[i].order_delivery_city = location.city.city_name;
                            this.checkout_orders[i].order_delivery_city_id = location.city.city_id;
                            this.checkout_orders[i].order_delivery_state_id = location.state.state_id;
                            this.checkout_orders[i].order_delivery_state = location.state.name;

                            this.checkout_orders[i].order_user_delivery_address = "";
                            if (this.checkout_orders[i].order_user_city_delivery == 'error' || this.checkout_orders[i].order_user_city_delivery == undefined) {
                                this.checkout_orders[i].order_user_city_delivery = location.city.city_id;
                                var _iteratorNormalCompletion2 = true;
                                var _didIteratorError2 = false;
                                var _iteratorError2 = undefined;

                                try {
                                    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.delivery_details), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                        var loc = _step2.value;

                                        if (location.city.city_id == loc.user_delivery_city_id) {
                                            var address_array = [];
                                            address_array["address_id"] = loc["user_delivery_id"];
                                            address_array["address_city"] = loc["user_delivery_city_id"];
                                            address_array["address_address"] = loc["user_delivery_address"];
                                            this.checkout_orders[i].order_user_city_delivery_addresses.push(address_array);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                            _iterator2.return();
                                        }
                                    } finally {
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                            }
                            this.checkout_orders[i].show_address_input = true;
                            this.group_set_order_delivery_key++;
                        }
                        i++;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                this.order_delivery_main_location.show_address_input = true;
                this.componentOrderMainLocation++;
            }
        },
        setOrderLocationAddress: function setOrderLocationAddress(location) {
            if (location.city != undefined) {
                var i = 0;
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.checkout_orders), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var group = _step3.value;

                        if (group.order_business_delivery_options && group.order_business_delivery_options.length == 0) {
                            this.checkout_orders[i].order_user_delivery_address = location.address;

                            group.data_processing_message = "";
                            this.group_set_order_delivery_key++;
                        }
                        i++;
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
        },
        setSortedOrderLocationAddress: function setSortedOrderLocationAddress(location) {
            if (location != undefined) {
                var i = 0;
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.checkout_orders), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var group = _step4.value;

                        if (group.order_business_delivery_options && group.order_business_delivery_options.length != 0) {
                            if (group.order_delivery_city_id == location.city_id) {
                                this.checkout_orders[i].order_user_delivery_address = location.address;
                                this.group_set_order_delivery_key++;
                            }
                        }
                        i++;
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }
            }
        },
        resetDeliveryLocation: function resetDeliveryLocation(i, location) {
            if (location != undefined) {
                this.checkout_orders[i].order_delivery_city = location.city_name;
                this.checkout_orders[i].order_delivery_city_id = location.city_id;
                this.checkout_orders[i].order_delivery_state_id = this.checkout_orders[i].order_delivery_selected_state.state_id;
                this.checkout_orders[i].order_delivery_state = this.checkout_orders[i].order_delivery_selected_state.name;

                this.checkout_orders[i].order_user_delivery_address = "";
            }
        },
        resetDeliveryLocationAddress: function resetDeliveryLocationAddress(index, location) {
            if (location != undefined) {
                this.checkout_orders[index].order_user_delivery_address = location.address;
                this.group_set_order_delivery_key++;
            }
        },
        getOrderLocations: function getOrderLocations(index, state) {
            this.activate_processing();

            var order_array = this.checkout_orders[index].order_business_delivery_options;
            this.checkout_orders[index].sorted_order_business_delivery_options = order_array.filter(function (item) {
                return item.business_delivery_state_id == state.state_id;
            });

            this.deactivate_processing();
        },
        loginAndProcess: function loginAndProcess() {
            var _this4 = this;

            this.activate_processing();
            service.loginUser(this, this.user).then(function (response) {
                if (response.body.status == 200) {
                    var data = response.body.data;
                    _this4.user = data;
                    var user_data = {
                        "user_name": data.user_name,
                        "user_id": data.user_id,
                        "sp_token": data.user_session_key,
                        "sp_token_key": data.user_token_key
                    };
                    localforage.setItem(service.udb_name, user_data).then(function (value) {}).catch(function (err) {});

                    _this4.is_logged_in_order_mode = 1;
                    _this4.process_checkout();
                    _this4.deactivate_processing();
                } else {
                    _this4.data_error_message = "Sorry, these login details are invalid.";
                    _this4.deactivate_processing();
                }
            }).catch(function (err) {
                _this4.deactivate_processing();
            });
        },
        preset_xtra: function preset_xtra() {
            var _this5 = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;

                            this.loggedIn = true;

                            if (this.$route.params.ckid != null) {
                                this.order_url = this.$route.params.ckid;
                                this.getCheckoutOrdersByURL();
                            } else {
                                this.getCheckoutOrders();
                            }
                            this.checkout_processed = true;
                            this.loading = false;

                            this.getUserDeliveryDetails();
                        }, _this5);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        preset: function preset() {
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;
                    self.new_account = false;

                    if (self.paymentdata && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(self.paymentdata).length > 0 && self.paymentdata.order_ref != undefined && self.paymentdata.order_ref != null) {
                        self.set_order_request_ref = self.paymentdata.order_ref;
                        self.flexi_pay = true;
                        self.getCheckoutOrderSetDetails();
                    } else if (self.$route.params.ref != null) {
                        self.getCheckoutOrderSetDetails();
                    } else if (self.$route.params.ckid != null) {
                        self.order_url = self.$route.params.ckid;
                    } else if (self.$route.params.rmkoref != null) {
                        self.getCheckoutOrdersByReMake(self.$route.params.rmkoref);
                    } else {
                        self.getCheckoutOrders();
                    }
                    self.checkout_processed = true;
                    self.loading = false;
                    self.getUserDeliveryDetails();
                } else {
                    self.getCheckoutLocalOrder();
                }
            });
        },
        getCheckoutLocalOrder: function getCheckoutLocalOrder() {
            this.loading = true;

            var self = this;

            setTimeout(function () {
                localforage.getItem('not_loggedin_processed_orders').then(function (value) {
                    if (value != null) {
                        self.checkout_orders = value;
                    }
                    self.loading = false;
                }).catch(function (err) {
                    this.loading = false;
                    location.replace("/orders/");
                });
            }, 500);
        },
        getCheckoutOrders: function getCheckoutOrders() {
            var _this6 = this;

            this.activate_processing();
            service.getCheckoutOrders(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this6.setCheckoutOrders(response);
                } else {
                    _this6.$router.push("/orders/");
                }
            }).catch(function (err) {
                _this6.deactivate_processing();
            });
        },
        getCheckoutOrderSetDetails: function getCheckoutOrderSetDetails() {
            var _this7 = this;

            this.activate_processing();
            var payload = {
                order_ref: this.set_order_request_ref
            };
            service.getOrderDetails(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    var data = response.body.data;
                    if (data[0]["order_payment_status_id"] && data[0]["order_payment_status_id"] != 2) {
                        _this7.setCheckoutOrders(response);
                    } else {
                        location.replace("/orders/");
                    }
                } else {
                    _this7.deactivate_processing();
                    location.replace("/orders/");
                }
            }).catch(function (err) {
                _this7.deactivate_processing();
                location.replace("/orders/");
            });
        },
        getCheckoutOrdersByURL: function getCheckoutOrdersByURL() {
            var _this8 = this;

            this.activate_processing();
            service.getCheckoutOrder(this, this.order_url).then(function (response) {
                if (response.body.status == 200) {
                    var data = response.body.data;
                    if (data[0]["order_payment_status_id"] && data[0]["order_payment_status_id"] != 2) {
                        _this8.setCheckoutOrders(response);
                    } else {
                        location.replace("/orders/");
                    }
                } else {
                    _this8.deactivate_processing();
                    location.replace("/orders/");
                }
            }).catch(function (err) {
                _this8.deactivate_processing();
                location.replace("/orders/");
            });
        },
        getCheckoutOrdersByReMake: function getCheckoutOrdersByReMake(order_ref) {
            var _this9 = this;

            this.activate_processing();
            service.getCheckoutOrderReMake(this, order_ref).then(function (response) {
                if (response.body.status == 200) {
                    var data = response.body.data;
                    if (data[0]["order_payment_status_id"] && data[0]["order_payment_status_id"] != 2) {
                        _this9.setCheckoutOrders(response);
                    } else {
                        location.replace("/orders/");
                    }
                } else {
                    _this9.deactivate_processing();
                    location.replace("/orders/");
                }
            }).catch(function (err) {
                _this9.deactivate_processing();
                location.replace("/orders/");
            });
        },
        setCheckoutOrders: function setCheckoutOrders(response) {
            var _this10 = this;

            this.checkout_orders = response.body.data;

            var remove_orders = [];
            this.checkout_orders.forEach(function (order) {
                order.change_shipping = false;
                order.display_delivery = false;
                order.cities = {};
                order.data_processing_message = "";

                if (order.order_items.length == 0) {
                    remove_orders.push(order);
                }
            }, this);

            var _loop = function _loop(order) {
                var order_index = _this10.checkout_orders.findIndex(function (o) {
                    return o.order_id === order.order_id;
                });
                _this10.checkout_orders.splice(order_index, 1);
            };

            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(remove_orders), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var order = _step5.value;

                    _loop(order);
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            this.total_order_items_total = response.body.data_calculated_orders_amount;

            this.total_orders_amount = response.body.data_total_amount;
            this.total_order_coupon_amount = response.body.data_calculated_coupons;
            this.total_shipping_fee = response.body.data_calculated_shipping_fee;
            this.total_processing_fee = response.body.data_total_orders_processing_fee;
            this.delivery_details = response.body.data_user_delivery_details;
            this.share_cart_details = response.body.data_share_cart_details;
            this.payment_details = response.body.payment_data;

            this.sortOrderLocations();

            this.checkout_processed = true;
            if (this.new_account) {
                this.loginAndProcess();
            }
            this.deactivate_processing();
        },
        sortOrderLocations: function sortOrderLocations() {
            var i = 0;
            var locations = [];
            this.order_delivery_sorted_locations.cities = [];
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.checkout_orders), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var group = _step6.value;

                    if (group.order_business_delivery_options && group.order_business_delivery_options.length != 0) {
                        var delivery_arr = { city_id: group.order_delivery_city_id, city_name: group.order_delivery_city };

                        locations.push(delivery_arr);
                    }

                    i++;
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }

            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
                for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(locations), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var _location = _step7.value;

                    if (this.order_delivery_sorted_locations.cities.indexOf(_location) == -1) {
                        this.order_delivery_sorted_locations.cities.push(_location);
                    }
                }
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                        _iterator7.return();
                    }
                } finally {
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }
        },
        getUserDeliveryDetails: function getUserDeliveryDetails() {
            var _this11 = this;

            service.getUserDeliveryDetails(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this11.delivery_details = response.body.data;
                }
            }).catch(function (err) {});
        },
        prep_process_checkout: function prep_process_checkout() {
            var _this12 = this;

            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.user.user_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;

            var phone_test = true;
            if (email_test == false || this.user.user_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                this.user.user_has_shipping_details = false;
                this.user.user_password = this.user.user_name;
                this.user.new_set_account = true;

                service.regUser(this, this.user).then(function (data) {
                    if (data.body.status == 201) {
                        this.loginAndProcess();
                    }
                }).catch(function (err) {
                    _this12.data_error_message = "Something went wrong while account was being processed";
                });
            }
        },
        process_checkout: function process_checkout() {
            this.activate_processing();

            var promises = [];
            var promise_thread_count = 0;

            if (this.process_count != this.checkout_orders.length) {
                this.checkout_orders.forEach(function (processed_checkout) {
                    this.order_url = this.checkout_orders[0].order_business + new Date().getTime();
                    processed_checkout.order_mode = this.is_logged_in_order_mode;
                    processed_checkout.order_url = this.order_url;
                    if (!this.new_account) {
                        processed_checkout.order_user_id = this.user.user_id;
                    } else {
                        processed_checkout.order_user_details = this.user;
                    }

                    processed_checkout.order_user_id = this.user.user_id;
                    processed_checkout.order_mode = 1;
                    promise_thread_count++;
                    promises.push(this.processCheckoutThread(processed_checkout));
                }, this);
            }

            if (promise_thread_count == this.checkout_orders.length) {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {}).catch(function (e) {});
            }
        },
        processCheckoutThread: function processCheckoutThread(processed_checkout) {
            service.checkout(this, processed_checkout).then(function (data) {
                if (data.body.status == 201) {
                    this.process_count++;
                }

                if (this.process_count == this.checkout_orders.length) {
                    this.checkout_orders = [];
                    this.preset();
                }
                this.deactivate_processing();
            }).catch(function (err) {});
        },
        pre_checkout: function pre_checkout() {
            this.preset();
        },
        displayDeliveryOptions: function displayDeliveryOptions(order) {
            this.selected_order = [];
            this.selected_order = order;
            if (this.selected_order.display_delivery) {
                this.selected_order.display_delivery = false;
            } else {
                this.selected_order.display_delivery = true;
            }
        },
        calc_delivery_fee: function calc_delivery_fee(i, option) {
            if (option != undefined) {
                this.total_orders_amount -= Number(this.checkout_orders[i].order_delivery_fee);
                this.checkout_orders[i].order_total -= Number(this.checkout_orders[i].order_delivery_fee);
                this.total_shipping_fee -= Number(this.checkout_orders[i].order_delivery_fee);
                this.checkout_orders[i].order_delivery_fee = 0;
                this.checkout_orders[i].order_user_delivery_address = "";

                var _iteratorNormalCompletion8 = true;
                var _didIteratorError8 = false;
                var _iteratorError8 = undefined;

                try {
                    for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.checkout_orders[i].order_items), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                        var item = _step8.value;

                        item.order_item_delivery_fee = 0;
                    }
                } catch (err) {
                    _didIteratorError8 = true;
                    _iteratorError8 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion8 && _iterator8.return) {
                            _iterator8.return();
                        }
                    } finally {
                        if (_didIteratorError8) {
                            throw _iteratorError8;
                        }
                    }
                }

                this.checkout_orders[i].order_delivery_id = option.business_delivery_option_id;
                this.checkout_orders[i].order_delivery_city = option.business_delivery_option;
                this.checkout_orders[i].order_delivery_city_id = option.business_delivery_city;
                this.checkout_orders[i].order_delivery_state_id = option.business_delivery_state_id;
                this.checkout_orders[i].order_delivery_state = option.business_delivery_state;

                var fees = option.business_products_delivery_fees;
                if (fees.length == 0) {
                    if (this.checkout_orders[i].business_shipping_calculation_method == 9) {
                        this.checkout_orders[i].order_delivery_fee += Number(option.business_delivery_option_price);
                    } else {
                        var _iteratorNormalCompletion9 = true;
                        var _didIteratorError9 = false;
                        var _iteratorError9 = undefined;

                        try {
                            for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.checkout_orders[i].order_items), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                                var _item = _step9.value;

                                if (this.checkout_orders[i].business_shipping_calculation_method == 10) {
                                    this.checkout_orders[i].order_delivery_fee += Number(option.business_delivery_option_price);
                                }
                                if (this.checkout_orders[i].business_shipping_calculation_method == 11) {
                                    this.checkout_orders[i].order_delivery_fee += Number(_item.product_item_order_quantity * option.business_delivery_option_price);
                                }
                            }
                        } catch (err) {
                            _didIteratorError9 = true;
                            _iteratorError9 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion9 && _iterator9.return) {
                                    _iterator9.return();
                                }
                            } finally {
                                if (_didIteratorError9) {
                                    throw _iteratorError9;
                                }
                            }
                        }
                    }
                } else {
                    var ordered_items = this.checkout_orders[i].order_items;
                    var _iteratorNormalCompletion10 = true;
                    var _didIteratorError10 = false;
                    var _iteratorError10 = undefined;

                    try {
                        for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(ordered_items), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                            var _item2 = _step10.value;
                            var _iteratorNormalCompletion12 = true;
                            var _didIteratorError12 = false;
                            var _iteratorError12 = undefined;

                            try {
                                for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(fees), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                                    var fee = _step12.value;

                                    if (_item2.product_id == fee.product_delivery_product) {
                                        if (_item2.product_shipping_calculation_method == 13) {
                                            this.checkout_orders[i].order_delivery_fee += Number(_item2.order_item_quantity * fee.product_delivery_fee);
                                        }
                                        if (_item2.product_shipping_calculation_method == 12) {
                                            this.checkout_orders[i].order_delivery_fee += Number(fee.product_delivery_fee);
                                        }

                                        _item2.has_calculated_product_delivery_fee = true;
                                        _item2.calculated_product_delivery_fee = Number(fee.product_delivery_fee);
                                        _item2.order_item_delivery_fee = Number(fee.product_delivery_fee);
                                    }
                                }
                            } catch (err) {
                                _didIteratorError12 = true;
                                _iteratorError12 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion12 && _iterator12.return) {
                                        _iterator12.return();
                                    }
                                } finally {
                                    if (_didIteratorError12) {
                                        throw _iteratorError12;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError10 = true;
                        _iteratorError10 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion10 && _iterator10.return) {
                                _iterator10.return();
                            }
                        } finally {
                            if (_didIteratorError10) {
                                throw _iteratorError10;
                            }
                        }
                    }

                    var sorted_fees = ordered_items.filter(function (item) {
                        return item.has_calculated_product_delivery_fee == true;
                    });

                    if (sorted_fees.length < ordered_items.length) {
                        if (this.checkout_orders[i].business_shipping_calculation_method == 9) {
                            this.checkout_orders[i].order_delivery_fee += Number(option.business_delivery_option_price);
                        } else {
                            var _iteratorNormalCompletion11 = true;
                            var _didIteratorError11 = false;
                            var _iteratorError11 = undefined;

                            try {
                                for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(ordered_items), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                                    var _item3 = _step11.value;

                                    if (this.checkout_orders[i].business_shipping_calculation_method == 10) {
                                        this.checkout_orders[i].order_delivery_fee += Number(option.business_delivery_option_price);
                                    }
                                    if (this.checkout_orders[i].business_shipping_calculation_method == 11) {
                                        this.checkout_orders[i].order_delivery_fee += Number(_item3.product_item_order_quantity * option.business_delivery_option_price);
                                    }
                                }
                            } catch (err) {
                                _didIteratorError11 = true;
                                _iteratorError11 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion11 && _iterator11.return) {
                                        _iterator11.return();
                                    }
                                } finally {
                                    if (_didIteratorError11) {
                                        throw _iteratorError11;
                                    }
                                }
                            }
                        }
                    }
                }

                this.total_orders_amount += Number(this.checkout_orders[i].order_delivery_fee);
                this.checkout_orders[i].order_total += Number(this.checkout_orders[i].order_delivery_fee);
                this.total_shipping_fee += Number(this.checkout_orders[i].order_delivery_fee);
                if (this.delivery_details.length != 0) {
                    var _iteratorNormalCompletion13 = true;
                    var _didIteratorError13 = false;
                    var _iteratorError13 = undefined;

                    try {
                        for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.delivery_details), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                            var detail = _step13.value;

                            if (detail.user_delivery_city == option.business_delivery_option) {
                                this.checkout_orders[i].order_user_city_delivery_addresses = [];

                                this.checkout_orders[i].order_user_city_delivery_addresses.push(detail);
                            }
                        }
                    } catch (err) {
                        _didIteratorError13 = true;
                        _iteratorError13 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion13 && _iterator13.return) {
                                _iterator13.return();
                            }
                        } finally {
                            if (_didIteratorError13) {
                                throw _iteratorError13;
                            }
                        }
                    }
                }
            }
        },
        setOrderUserCityDeliveryAddress: function setOrderUserCityDeliveryAddress(i, address) {
            if (address != undefined) {
                this.checkout_orders[i].order_user_delivery_detail = address.address_id;
            }
        },
        setUserDeliveryAddress: function setUserDeliveryAddress(i, city) {
            this.delivery_details.forEach(function (detail) {
                if (detail.user_delivery_city == city) {
                    this.checkout_orders[i].order_user_delivery_address = detail.user_delivery_address;
                }
            }, this);
        },
        setPaymentOption: function setPaymentOption(option) {
            this.payment_mode = option;
        },
        setProcessPaymentSingle: function setProcessPaymentSingle(order, index, toggle_view) {
            var process_errors = [];
            if (order.order_need_shipping == 1) {
                if (order.order_delivery_city == undefined || order.order_delivery_city == '') {
                    if (order.order_business_agent_type && order.order_business_agent_type == 20) {
                        process_errors.push("Please enter delivery location for " + order.order_business_agent_name);
                    } else {
                        process_errors.push("Please enter delivery location for " + order.order_business);
                    }
                } else {
                    if (order.order_user_delivery_address == undefined || order.order_user_delivery_address == '') {
                        if (order.order_business_agent_type && order.order_business_agent_type == 20) {
                            process_errors.push("Please enter delivery address for " + order.order_business_agent_name);
                        } else {
                            process_errors.push("Please enter delivery address for " + order.order_business);
                        }
                    }

                    order.order_items.forEach(function (item) {
                        if (item.order_delivery_city) {
                            if (item.order_user_delivery_address == undefined) {
                                process_errors.push("Please enter delivery address for " + item.product_name);
                            }
                        }
                    }, this);
                }
            }
            if (process_errors.length != 0) {
                process_errors.forEach(function (err) {
                    this.data_error_message = err;

                    this.checkout_orders[index].data_processing_message = err;
                    this.checkout_orders[index].show_address_input = true;

                    this.componentOrderSummaryKey++;
                }, this);
            } else {
                if (!order.order_user_delivery_detail) {
                    order.order_user_new_delivery_detail = true;
                }
                this.data_error_message = "";
                this.checkout_orders[index].data_processing_message = "";
                this.checkout_orders[index].show_address_input = true;
                this.toggleViews(toggle_view);
            }
        },
        setProcessGiftCardPayment: function setProcessGiftCardPayment(order, index, payment_mode, payment_status, payment_type) {
            var _this13 = this;

            var set_address_id = this.checkout_orders[index].order_user_delivery_detail;
            var set_address = this.checkout_orders[index].order_user_delivery_address;

            var payload = {
                gift_card_order: order.order_id,
                gift_card_user: this.user.user_id,
                gift_card_ref: this.set_gift_card.gift_card_ref,
                gift_card_order_data: order
            };

            service.getCheckoutGiftCardOrders(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    if (payment_type == 2) {
                        var new_order = data.body.data[0];
                        new_order.order_user_delivery_detail = set_address_id;
                        new_order.order_user_delivery_detail = set_address;
                        _this13.prepProcessPaymentSingle(new_order, index, payment_mode, payment_status);
                    } else {
                        _this13.order_gift_card = data.body.data;
                    }
                } else {}
            }).catch(function (err) {
                if (err) {
                    _this13.data_processing_message = "Sorry, could not process information";
                }
            });
        },
        prepProcessGiftCardPayment: function prepProcessGiftCardPayment(order, index, payment_mode, payment_status) {
            var _this14 = this;

            var set_address_id = this.checkout_orders[index].order_user_delivery_detail;
            var set_address = this.checkout_orders[index].order_user_delivery_address;
            var order_gift_card_data = {};var _iteratorNormalCompletion14 = true;
            var _didIteratorError14 = false;
            var _iteratorError14 = undefined;

            try {
                for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.order_gift_card), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                    var order_data = _step14.value;

                    if (order_data.order_id == this.checkout_orders[index].order_id) {
                        order_gift_card_data = order_data.order_gift_card_data;

                        this.checkout_orders[index] = order_data;
                        this.checkout_orders[index].order_user_delivery_detail = set_address_id;
                        this.checkout_orders[index].order_user_delivery_address = set_address;
                        this.checkout_orders[index].order_gift_card_data = order_gift_card_data;

                        order = this.checkout_orders[index];

                        service.makeOrderSpinoff(this, order).then(function (re) {
                            if (re.body.status == 200) {
                                var new_order = re.body.data[0];

                                _this14.setProcessGiftCardPayment(new_order, index, payment_mode, payment_status, 2);
                            }
                        }).catch(function (err) {});
                    }
                }
            } catch (err) {
                _didIteratorError14 = true;
                _iteratorError14 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion14 && _iterator14.return) {
                        _iterator14.return();
                    }
                } finally {
                    if (_didIteratorError14) {
                        throw _iteratorError14;
                    }
                }
            }
        },
        prepProcessPaymentSingle: function prepProcessPaymentSingle(order, index, payment_mode, payment_status) {
            var _this15 = this;

            var has_set_payment_ref = 0;
            var amount_to_pay = order.total_amount;

            order.total_amount_topay = order.total_amount;
            if (order.order_can_part_payment == 1 && payment_mode != 8) {
                var amount_rem = order.total_amount_topay - order.order_part_payment_total_amount_paid;
                if (order.order_part_payment_amount && order.order_part_payment_amount > 0) {
                    if (order.order_part_payment_amount > amount_rem) {
                        order.total_amount_topay = amount_rem;
                    } else {
                        order.total_amount_topay = order.order_part_payment_amount;
                    }
                } else {
                    order.total_amount_topay = amount_rem;
                }
            }

            if (order.total_amount_topay > 0) {
                console.log(884);
                var payload = {
                    service_load: this.payment_details.pay_set,
                    service_user: this.user.user_id,
                    service_payment_transaction_type: 1,
                    service_total_amount: order.total_amount_topay,
                    service_payment_mode: payment_mode,
                    service_is_part_payment: order.order_can_part_payment,
                    service_payment_status: payment_status,
                    service_active_payment_ref: this.payment_active_resolve_ref
                };
                service.preparePayments(this, payload).then(function (data) {
                    if (data.body.status == 200 || data.body.status == 404) {
                        has_set_payment_ref = 1;
                        _this15.payment_details.payment_ref = data.body.data.data_ref;
                    } else {
                        var paymode = data.body.data_active_payment_mode;
                        var paydata = data.body;
                        if (data.body.status == 409) {
                            if (data.body.data_active_gateway_payment_check == 1) {
                                _this15.verifyServerRavePayment(order, index, payment_mode, paydata);
                            } else if (data.body.status == 409 && data.body.data_paid_status == 200) {
                                _this15.resolveActivePayment(order, index, payment_mode, paydata);
                            }
                        } else {
                            _this15.data_processing_message = "Sorry, could not update payment";
                        }
                    }
                    if (has_set_payment_ref == 1 && _this15.payment_details.payment_ref != '') {
                        _this15.processPaymentSingle(order, index, payment_mode);
                    }

                    _this15.payment_active_resolve_ref = "";
                }).catch(function (err) {
                    if (err) {
                        _this15.data_processing_message = "Sorry, could not process information";
                    }

                    _this15.payment_active_resolve_ref = "";
                });

                service.updateOrderBasics(this, order).then(function (re) {
                    if (re.body.status == 200 || re.body.status == 404) {}
                }).catch(function (err) {});
            }
        },
        verifyServerRavePayment: function verifyServerRavePayment(order, index, payment_mode, paydata) {
            var _this16 = this;

            var payref = paydata.data_active_payment_service_ref;

            var payload = {
                call_url: "https://api.flutterwave.com/v3/transactions/" + payref + "/verify",
                call_method: "GET",
                call_header: ["Content-Type: application/json", "Authorization: FLWSECK-a235ea72184ac4d7c07ea2e356682cd7-X"]
            };
            service.verifyRavePayment(this, payload).then(function (response) {
                if (response.body.status === "success") {
                    if (response.body.data.amount === order.total_amount_topay) {
                        paydata.data_active_gateway_payment_check = "00";
                        paydata.data_active_gateway_payment_log_ref = payref;
                        _this16.resolveActivePayment(order, index, payment_mode, paydata);
                    }
                } else {
                    _this16.payment_active_resolve_ref = payref;

                    _this16.prepProcessPaymentSingle(order, index, payment_mode, 2);
                }
            }).catch(function (err) {
                if (err) {
                    _this16.data_processing_message = "Sorry, could not process information";
                }
            });
        },
        resolveActivePayment: function resolveActivePayment(order, index, payment_mode, payment_data) {
            this.payment_details.active_payment_data = payment_data;
            this.payment_details.active_payment_alert = 1;
            this.payment_details.active_payment_ref = payment_data.data_active_payment_service_ref;

            this.processPaymentSingle(order, index, payment_mode);
        },
        processPaymentSingle: function processPaymentSingle(order, index, payment_mode) {
            this.activate_processing();
            var active_payment_alert = 0;
            if (this.payment_details.active_payment_alert && this.payment_details.active_payment_alert == 1) {
                active_payment_alert = 1;
            }
            if (payment_mode == 1) {
                order.order_payment_mode = 1;
                this.checkout_orders[index].order_payment_mode = 1;
                var set_post_payment_payload = {
                    payment_gateway_id: 1,
                    payment_from_module: 1,
                    payment_from_module_id: this.user.user_id || 0,
                    payment_to_module: 0,
                    payment_to_module_id: 0,
                    payment_service_module: 8,
                    payment_service_module_id: order.order_id,
                    payment_amount_paid: order.total_amount_topay,
                    payment_gateway_transaction_ref: "test_ref" + new Date().getTime() };
                order.payment_mode_update_data = set_post_payment_payload;

                this.updatePaymentSingle("test_ref" + new Date().getTime(), order, index, "autoUpdate");
            }

            if (payment_mode == 2) {
                order.order_payment_mode = 2;
                this.checkout_orders[index].order_payment_mode = 2;
                if (active_payment_alert == 1) {
                    this.updatePaymentSingle(this.payment_details.active_payment_ref, order, index, "autoUpdateCollections");
                } else {
                    this.updatePaymentSingle(this.payment_details.payment_ref, order, index, "autoUpdateCollections");
                }
            }

            if (payment_mode == 3) {
                order.order_payment_mode = 3;
                this.checkout_orders[index].order_payment_mode = 3;
                if (active_payment_alert == 1) {
                    this.updatePaymentSingle(this.payment_details.active_payment_ref, order, index, "manualUpdate");
                } else {
                    this.updatePaymentSingle(this.payment_details.payment_ref, order, index, "manualUpdate");
                }
            }

            if (payment_mode == 5) {
                order.order_payment_mode = 5;
                this.checkout_orders[index].order_payment_mode = 3;
                if (active_payment_alert == 1) {
                    this.updatePaymentSingle(this.payment_details.active_payment_ref, order, index, "PaymentProcessingAccount");
                } else {
                    this.updatePaymentSingle(this.payment_details.payment_ref, order, index, "PaymentProcessingAccount");
                }
            }

            if (payment_mode == 6) {
                order.order_payment_mode = 6;
                this.checkout_orders[index].order_payment_mode = 6;
                if (active_payment_alert == 1) {
                    this.updatePaymentSingle(this.payment_details.active_payment_ref, order, index, "GigsPayment");
                } else {
                    this.updatePaymentSingle(this.payment_details.payment_ref, order, index, "GigsPayment");
                }
            }

            if (payment_mode == 7) {
                order.order_payment_mode = 7;
                this.checkout_orders[index].order_payment_mode = 7;
                if (active_payment_alert == 1) {
                    this.updatePaymentSingle(this.payment_details.active_payment_ref, order, index, "GiftCardPayment");
                } else {
                    this.updatePaymentSingle(this.payment_details.payment_ref, order, index, "GiftCardPayment");
                }
            }

            if (payment_mode == 8) {
                order.order_payment_mode = 8;
                this.checkout_orders[index].order_payment_mode = 8;
                if (active_payment_alert == 1) {
                    this.updatePaymentSingle(this.payment_details.active_payment_ref, order, index, "AppPayment");
                } else {
                    this.makeAppPayment(this.payment_details, order, index);
                }
            }
        },
        processPaymentRavepay: function processPaymentRavepay(data, order, index) {
            var self = this;

            var set_subaccounts = [];
            var set_subaccounts_settlements = true;
            if (order.order_can_part_payment) {
                set_subaccounts_settlements = false;
            }

            if (set_subaccounts_settlements) {
                if (order.order_agent_fee > 0) {
                    var sub_account_0 = {
                        id: order.business_agent_bank_ravepay_subaccount_id,
                        transaction_charge: order.order_agent_fee,
                        transaction_charge_type: "flat_subaccount"
                    };
                    set_subaccounts.push(sub_account_0);
                }

                if (order.order_total_commissions_fee > 0) {
                    var sub_account_01 = {
                        id: service.spcomms_subaccount_id,
                        transaction_charge: order.order_total_commissions_fee,
                        transaction_charge_type: "flat_subaccount"
                    };
                    set_subaccounts.push(sub_account_01);
                }

                var order_business = 0;
                var order_delivery_business = order.order_delivery_business.business_delivery_id;
                if (order_business == order_delivery_business) {
                    var sub_account_1 = {
                        id: order.business_bank_ravepay_subaccount_id,
                        transaction_charge: order.total_amount - (order.order_processing_fee + order.order_agent_fee + order.order_total_commissions_fee),
                        transaction_charge_type: "flat_subaccount"
                    };
                    set_subaccounts.push(sub_account_1);
                } else {
                    var sub_account_1 = {
                        id: order.business_bank_ravepay_subaccount_id,
                        transaction_charge: order.total_amount - (order.order_delivery_fee + order.order_processing_fee + order.order_agent_fee + order.order_total_commissions_fee),
                        transaction_charge_type: "flat_subaccount"
                    };
                    set_subaccounts.push(sub_account_1);
                    var sub_account_2 = {
                        id: order.order_delivery_business.business_bank_ravepay_subaccount_id,
                        transaction_charge: order.order_delivery_fee,
                        transaction_charge_type: "flat_subaccount"
                    };
                    set_subaccounts.push(sub_account_2);
                }
            }


            var x = getpaidSetup({
                PBFPubKey: service.ravepay_public_test,
                customer_email: "keneinfostream@gmail.com",
                amount: 3000,
                customer_phone: data.payment_payer_phone,
                currency: "NGN",
                payment_method: "both",
                txref: data.payment_ref,

                subaccounts: set_subaccounts,
                meta: [{
                    metaname: "AFPAY",
                    metavalue: data.payment_payer_name
                }],
                onclose: function onclose() {},
                callback: function callback(response) {
                    var txref = response.tx.txRef;
                    var tx_amount = response.tx.amount;
                    if (response.tx.chargeResponseCode == "00" || response.tx.chargeResponseCode == "0") {
                        var set_post_payment_payload = {
                            payment_gateway_id: 1,
                            payment_from_module: 1,
                            payment_from_module_id: self.user.user_id || 0,
                            payment_to_module: 0,
                            payment_to_module_id: 0,
                            payment_service_module: 8,
                            payment_service_module_id: order.order_id,
                            payment_amount_paid: tx_amount,
                            payment_gateway_transaction_ref: txref };
                        order.payment_mode_update_data = set_post_payment_payload;

                        self.updatePaymentSingle(txref, order, index, "autoUpdate");
                    } else {
                        self.payment_message = "Payment unsuccessfull. please try again or contact us";
                    }
                }
            });
        },
        makeAppPayment: function makeAppPayment(data, order, index) {
            var _this17 = this;

            var self = this;

            var set_accounts = [];
            var set_subaccounts_settlements = true;
            if (set_subaccounts_settlements) {
                if (order.order_agent_fee > 0) {
                    var set_account = {
                        "account_bank": order.business_agent_bank_details.bank_ravepay_id,
                        "account_number": order.business_agent_bank_details.bank_account_number,
                        "amount": order.order_agent_fee,
                        "narration": order.business_agent_bank_details.bank_account_name + " Transfer for order " + order.order_no,
                        "currency": "NGN",
                        "reference": data.payment_ref,
                        "callback_url": "#",
                        "debit_currency": "NGN"
                    };
                    set_accounts.push(set_account);
                }

                if (order.order_total_commissions_fee > 0) {
                    var set_account = {
                        "account_bank": service.spcomms_subaccount_bank_ravepay_id,
                        "account_number": service.spcomms_subaccount_bank_account_number,
                        "amount": order.order_total_commissions_fee,
                        "narration": service.spcomms_subaccount_bank_account_name + " Transfer for order " + order.order_no,
                        "currency": "NGN",
                        "reference": data.payment_ref,
                        "callback_url": "#",
                        "debit_currency": "NGN"
                    };
                    set_accounts.push(set_account);
                }

                var order_business = 0;
                var order_delivery_business = order.order_delivery_business.business_delivery_id;
                if (order_business == order_delivery_business) {
                    var set_account = {
                        "account_bank": order.business_bank_details.bank_ravepay_id,
                        "account_number": order.business_bank_details.bank_account_number,
                        "amount": order.total_amount - (order.order_processing_fee + order.order_agent_fee + order.order_total_commissions_fee),
                        "narration": order.business_bank_details.bank_account_name + " Transfer for order " + order.order_no,
                        "currency": "NGN",
                        "reference": data.payment_ref,
                        "callback_url": "#",
                        "debit_currency": "NGN"
                    };
                    set_accounts.push(set_account);
                } else {
                    var set_account_01 = {
                        "account_bank": order.business_bank_details.bank_ravepay_id,
                        "account_number": order.business_bank_details.bank_account_number,
                        "amount": order.total_amount - (order.order_processing_fee + order.order_agent_fee + order.order_total_commissions_fee),
                        "narration": order.business_bank_details.bank_account_name + " Transfer for order " + order.order_no,
                        "currency": "NGN",
                        "reference": data.payment_ref,
                        "callback_url": "#",
                        "debit_currency": "NGN"
                    };
                    set_accounts.push(set_account_01);

                    var set_account_02 = {
                        "account_bank": order.order_delivery_business.bank_ravepay_id,
                        "account_number": order.order_delivery_business.bank_account_number,
                        "amount": order.order_delivery_fee,
                        "narration": order.order_delivery_business.bank_account_name + " Transfer for order " + order.order_no,
                        "currency": "NGN",
                        "reference": data.payment_ref,
                        "callback_url": "#",
                        "debit_currency": "NGN"
                    };
                    set_accounts.push(set_account_02);
                }
            }

            var process_count = 0;
            var _iteratorNormalCompletion15 = true;
            var _didIteratorError15 = false;
            var _iteratorError15 = undefined;

            try {
                for (var _iterator15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(set_accounts), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                    var account = _step15.value;

                    process_count++;
                    var payload = {
                        "account_bank": account.account_bank,
                        "account_number": account.account_number,
                        "amount": account.amount,
                        "narration": account.narration,
                        "currency": account.currency,
                        "reference": account.reference,
                        "callback_url": account.callback_url,
                        "debit_currency": account.debit_currency
                    };

                    if (process_count == set_accounts.length) {
                        this.updatePaymentSingle(data.payment_ref, order, index, "autoUpdate");
                    } else {
                        service.transferPayoutRavepay(payload).then(function (data) {
                            if (data.body.status == 'success') {
                                console.log(data.body.data);
                                _this17.deactivate_processing();
                            }
                        }).catch(function (err) {
                            if (err) {
                                console.log(err);
                            }
                        });
                    }
                }
            } catch (err) {
                _didIteratorError15 = true;
                _iteratorError15 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion15 && _iterator15.return) {
                        _iterator15.return();
                    }
                } finally {
                    if (_didIteratorError15) {
                        throw _iteratorError15;
                    }
                }
            }

            var x = getpaidSetup({
                PBFPubKey: service.ravepay_public_test,
                customer_email: "keneinfostream@gmail.com",
                amount: order.total_amount_topay,
                customer_phone: data.payment_payer_phone,
                currency: "NGN",
                payment_method: "both",
                txref: data.payment_ref,

                subaccounts: set_subaccounts,
                meta: [{
                    metaname: "AFPAY",
                    metavalue: data.payment_payer_name
                }],
                onclose: function onclose() {},
                callback: function callback(response) {
                    var txref = response.tx.txRef;
                    var tx_amount = response.tx.amount;
                    if (response.tx.chargeResponseCode == "00" || response.tx.chargeResponseCode == "0") {
                        var set_post_payment_payload = {
                            payment_gateway_id: 1,
                            payment_from_module: 1,
                            payment_from_module_id: this.user.user_id || 0,
                            payment_to_module: 0,
                            payment_to_module_id: 0,
                            payment_service_module: 8,
                            payment_service_module_id: order.order_id,
                            payment_amount_paid: tx_amount,
                            payment_gateway_transaction_ref: txref };
                        order.payment_mode_update_data = set_post_payment_payload;

                        self.updatePaymentSingle(txref, order, index, "autoUpdate");
                    } else {
                        self.payment_message = "Payment unsuccessfull. please try again or contact us";
                    }
                }
            });
        },
        updatePaymentSingle: function updatePaymentSingle(payment_ref, order, index, update_type) {
            var _this18 = this;

            this.process_orders_update = [];
            var processing_fee_transaction_type = 0;
            if (order.order_processing_fee_status == 3) {
                processing_fee_transaction_type = 2;
                order.processing_fee_transaction_type = processing_fee_transaction_type;
                order.processing_fee_transaction_amount = order.order_processing_fee;
            }

            this.payment_details.payment_details = order.order_details;
            this.payment_details.payment_service_module = 8;
            this.payment_details.payment_service_module_id = order.order_id;
            this.payment_details.payment_service_amount_paid = order.total_amount_topay;

            var payment_service_payment_data = this.payment_details;

            this.process_orders_update.push(order);
            payment_service_payment_data.payment_services = this.process_orders_update;

            var set_payment_mode_update_data = [];
            if (order.order_payment_mode == 1) {
                set_payment_mode_update_data = order.payment_mode_update_data;
            }

            var set_payment_is_part_payment = order.order_can_part_payment;
            if (order.order_can_part_payment == 1) {
                if (order.total_amount_topay == order.order_part_payment_total_amount_paid) {
                    set_payment_is_part_payment = 0;
                }
            }

            if (order.order_payment_mode == 3) {
                if (order.order_receive_manual_payment_by == 2) {
                    payment_service_payment_data.payment_manual_payment_to_agent = 1;
                }
            }

            var order_gift_card_data = {};
            if (order.order_payment_mode == 7) {
                order_gift_card_data = order.order_gift_card_data;
            }

            var payload = {
                payment_order_type: "single",
                payment_order_ref: payment_ref,
                payment_order_amount_paid: order.total_amount_topay,
                payment_user_id: this.user.user_id,
                payment_orders: order,
                payment_details: order.order_details,

                processing_fee_transaction_type: processing_fee_transaction_type,
                processing_fee_transaction_amount: order.order_processing_fee,

                payment_service_payment_data: payment_service_payment_data,
                payment_service_mode: order.order_payment_mode,
                payment_service_type: "single",

                payment_service_user_id: this.user.user_id,
                payment_service_amount_paid: order.total_amount_topay,
                payment_service_processing_fee_transaction_type: processing_fee_transaction_type,
                payment_service_processing_fee_transaction_amount: order.order_processing_fee,

                payment_is_part_payment: set_payment_is_part_payment,

                payment_mode_update_data: set_payment_mode_update_data,

                payment_update_type: update_type,

                payment_order_gift_card_data: order_gift_card_data

            };
            var navi = this.$router;

            if (payment_ref != "") {
                service.updatePayment(this, payload).then(function (data) {
                    if (data.body.status == 200 || data.body.status == 400) {
                        if (data.body.data_part_payment_status && data.body.data_part_payment_status == 200) {
                            _this18.checkout_orders[index].order_status_id = 0;
                            _this18.checkout_orders[index].order_part_payment_status = 200;
                            _this18.data_processing_message = "Payment Processed!";
                            _this18.processed_single_order_count++;
                        } else {
                            _this18.data_processing_message = "Payment Processed!";
                            _this18.checkout_orders[index] = data.body.data;
                            _this18.processed_single_order_count++;
                        }

                        if (order.order_payment_third_party_ref && order.order_payment_third_party_ref != '') {
                            _this18.updateFlexPaymentDetails(order, payment_ref, "transferred");
                        }

                        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this18.file_info).length > 0 && _this18.file_data_type == 'transfer-receipt') {
                            _this18.uploadFlexiPaymentReceipt(order, payment_ref, "transferred");
                        }

                        _this18.deactivate_processing();
                    } else if (data.body.status == 204) {
                        if (data.body.data_make_app_payment_alert == 1) {
                            if (order.order_can_part_payment == 1) {
                                order.order_part_payment_total_amount_paid = order.total_amount;
                            }
                            _this18.prepProcessPaymentSingle(order, index, 8, 0);
                        }
                        _this18.data_processing_message = "Sorry, could not update payment";
                        _this18.deactivate_processing();
                    } else {
                        _this18.data_processing_message = "Sorry, could not update payment";
                        _this18.deactivate_processing();
                    }
                }).catch(function (err) {
                    if (err) {
                        _this18.data_processing_message = "Sorry, could not process information";
                        _this18.deactivate_processing();
                    }
                });
            } else {
                this.data_processing_message = "Something went wrong";
                this.deactivate_processing();
            }
        },
        updateOrders: function updateOrders(order, index, status) {
            var _this19 = this;

            this.activate_processing();
            var order_data = {};

            var payload = {
                order: order,
                order_status: status,
                order_data: order_data
            };
            var navi = this.$router;
            service.updateOrders(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    _this19.checkout_orders[index].order_status_id = 0;
                    _this19.data_processing_message = "Order Placed";
                    _this19.processed_single_order_count++;
                    _this19.checkout_orders[index] = data.body.data;
                } else {
                    _this19.data_processing_message = "Sorry, could not update payment";
                }
                _this19.deactivate_processing();
            }).catch(function (err) {
                if (err) {
                    _this19.data_processing_message = "Sorry, could not process information";
                }
                _this19.deactivate_processing();
            });
        },
        updateFlexPaymentDetails: function updateFlexPaymentDetails(data, ref, status) {
            var _this20 = this;

            var data_set = {};
            if (status == "transferred") {
                data_set = {
                    payment_request_ref: ref,
                    payment_transfer_ref: data.order_payment_third_party_ref
                };
            }

            var payload = {
                data_data: data,
                data_status: status,
                data_updates: data_set
            };
            var navi = this.$router;
            service.updatePaymentDetails(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this20.flexi_active_payment_status = 1;
                } else {}
            }).catch(function (err) {
                if (err) {}
            });
        },
        uploadFlexiPaymentReceipt: function uploadFlexiPaymentReceipt(data, ref, status) {
            var _this21 = this;

            if (status == 'transferred') {
                this.imageForm.append("data_id", ref);
                this.imageForm.append("data_type", "third_party_payment_receipt");
                service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                    if (data.body.status == 200) {
                        _this21.flexi_active_payment_status = 1;
                    } else {
                        _this21.data_processing_message = service.upload_media_error_msg;
                    }
                });
            }
        },
        onFileChangeNewPhoto: function onFileChangeNewPhoto(e, data_type) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
                this.file_data_type = data_type;
            }
        },
        _del_onFileChange: function _del_onFileChange(e, data_id, data_type) {
            if (data_type == "order_receipt") {}

            if (data_id > 0 && data_type != '') {
                var files = e.target.files || e.dataTransfer.files;
                if (files.length) {
                    this.file_info = files;
                    var formData = new FormData();
                    formData.append('photo', files[0]);
                    this.imageForm = formData;
                    formData.append('data_id', data_id);
                    formData.append('data_type', data_type);
                    service.uploadDataPhoto(this, formData).then(function (response) {
                        if (response.body.status == 200) {}
                    }).catch(function (err) {});
                }
            }
        }
    },
    created: function created() {
        document.title = "Checkout" + " | " + service.app_name;
        this.preset();
        this.loading = true;

        this.getStates();
    }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resources_setts_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Account_Resources_commonfunctions_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__ = __webpack_require__(14);








var service = new __WEBPACK_IMPORTED_MODULE_3__services_service__["a" /* default */]();



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Checkout',
    props: {
        paymentdata: Object
    },
    watch: {
        paymentdata: function paymentdata(newVal, oldVal) {}
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_5__resources_setts_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            flexi_pay: false,
            user: {},
            selected_order: [],
            checkout_orders: {},
            delivery_details: [],
            share_cart_details: {},
            payment_details: {},
            payment_mode: "",
            request_page: "orders",
            checked_out: [],
            processed_checkout_orders: [],
            sorted_cart: [],
            orders: [],
            cart: this.$store.state.cart,
            img_product_url: service.imageProductsURL,
            item_delivery_fee: "",
            delivery_fee: "",
            payment_option: "",
            total_order_items_total: 0.0,
            total_orders_amount: 0.0,
            total_order_coupon_amount: 0.0,
            total_shipping_fee: 0.0,
            total_processing_fee: 0.0,
            states: {},
            cities: [],
            set_cities: [],
            loggedIn: false,
            new_account: true,
            process_count: 0,
            checkout_processed: false,
            data_error_message: "",
            data_success_message: "",
            is_logged_in_order_mode: 0,
            disable_btn: false,
            loading: true,
            action_loading: false,
            user_delivery_address: "",
            order_delivery_state: "",
            order_delivery_city: "",

            shipping_locations: {},
            order_delivery_main_location: {},
            order_delivery_sorted_locations: {},
            group_set_order_delivery_key: 0,
            data_processing_message: "",
            componentOrderSummaryKey: 0,
            componentOrderMainLocation: 0,
            processed_single_order_count: 0,
            payment_active_resolve_ref: "",
            process_orders_update: [],

            set_gift_card: {},
            order_gift_card: {},

            app_url: service.app_url,
            menu_tab_inner_view: {},
            copied: false,
            set_order_user_delivery_address: '',
            transfer_verification_mode: 0,
            file_info: {},
            file_data_type: "",
            imageForm: "",
            flexi_active_payment_status: 0,

            componentKey: 0
        };
    },

    components: {
        'component-footer': __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue___default.a
    },
    computed: {},
    methods: {
        copyLink: function copyLink(link, id) {
            this.$clipboard(link);
            this.copied = true;
            document.getElementById(id).style.display = "block";
        },
        setMenuTabInnerView: function setMenuTabInnerView(view, attr1, attr2) {
            this.setComponent('reset-edit', '');
            this.menu_tab_inner_view = {};
            this.menu_tab_inner_view[view] = true;
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == 'login') {
                this.new_account = false;
            }
            if (attr1 == 'new-account') {
                this.new_account = true;
            }
            if (attr1 == 'change-delivery-option') {
                this.checkout_orders[attr2].change_delivery_option = true;
                document.getElementById("cdl" + attr2).style = "display:block;";
                document.getElementById("cdlb" + attr2).style = "display:none;";
            }
            if (attr1 == 'cancel-change-delivery-option') {
                this.checkout_orders[attr2].change_delivery_option = false;
                document.getElementById("cdl" + attr2).style = "display:none;";
                document.getElementById("cdlb" + attr2).style = "display:block;";
            }
            if (attr1 == 'close-enter-delivery-address') {
                this.checkout_orders[attr2].order_user_delivery_address = this.set_order_user_delivery_address;
                this.checkout_orders[attr2].data_processing_message = "";
                this.checkout_orders[attr2].show_address_input = false;
                this.componentOrderSummaryKey++;
            }
        },
        toggleViews: function toggleViews(view) {
            if (document.getElementById(view).style.display == "block") {
                document.getElementById(view).style = "display:none;";
            } else {
                document.getElementById(view).style = "display:block;";
            }
        },
        closeViews: function closeViews(view) {
            document.getElementById(view).style = "display:none;";
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        removeFromCheckout: function removeFromCheckout(group_index, order, item) {
            var index = this.checkout_orders[group_index].order_items.findIndex(function (ord) {
                return ord.order_item_no === item.order_item_no;
            });
            this.checkout_orders[group_index].order_items.splice(index, 1);
            if (this.checkout_orders[group_index].order_items.length == 0) {
                var index2 = this.checkout_orders.findIndex(function (o) {
                    return o.order_id === order.order_id;
                });
                this.checkout_orders.splice(index2, 1);
            }
        },
        getStates: function getStates() {
            var _this = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state) {
            var _this2 = this;

            this.activate_processing();
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this2.cities = response.body.data;
                    _this2.deactivate_processing();
                }
            }).catch(function (err) {
                _this2.deactivate_processing();
            });
        },
        setCities: function setCities(state) {
            var _this3 = this;

            if (state != undefined) {
                this.activate_processing();
                service.getCities(this, state.state_id).then(function (response) {
                    if (response.body.status == 200) {
                        _this3.set_cities = response.body.data;
                        _this3.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this3.deactivate_processing();
                });
            }
        },
        setOrderLocations: function setOrderLocations(location) {
            if (location.city != undefined) {
                this.order_delivery_main_location.address = '';
                var i = 0;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.checkout_orders), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var group = _step.value;

                        if (group.order_business_delivery_options && group.order_business_delivery_options.length == 0) {
                            this.checkout_orders[i].order_delivery_city = location.city.city_name;
                            this.checkout_orders[i].order_delivery_city_id = location.city.city_id;
                            this.checkout_orders[i].order_delivery_state_id = location.state.state_id;
                            this.checkout_orders[i].order_delivery_state = location.state.name;

                            this.checkout_orders[i].order_user_delivery_address = "";
                            if (this.checkout_orders[i].order_user_city_delivery == 'error' || this.checkout_orders[i].order_user_city_delivery == undefined) {
                                this.checkout_orders[i].order_user_city_delivery = location.city.city_id;
                                var _iteratorNormalCompletion2 = true;
                                var _didIteratorError2 = false;
                                var _iteratorError2 = undefined;

                                try {
                                    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.delivery_details), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                        var loc = _step2.value;

                                        if (location.city.city_id == loc.user_delivery_city_id) {
                                            var address_array = [];
                                            address_array["address_id"] = loc["user_delivery_id"];
                                            address_array["address_city"] = loc["user_delivery_city_id"];
                                            address_array["address_address"] = loc["user_delivery_address"];
                                            this.checkout_orders[i].order_user_city_delivery_addresses.push(address_array);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                            _iterator2.return();
                                        }
                                    } finally {
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                            }
                            this.checkout_orders[i].show_address_input = true;
                            this.group_set_order_delivery_key++;
                        }
                        i++;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                this.order_delivery_main_location.show_address_input = true;
                this.componentOrderMainLocation++;
            }
        },
        setOrderLocationAddress: function setOrderLocationAddress(location) {
            if (location.city != undefined) {
                var i = 0;
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.checkout_orders), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var group = _step3.value;

                        if (group.order_business_delivery_options && group.order_business_delivery_options.length == 0) {
                            this.checkout_orders[i].order_user_delivery_address = location.address;

                            group.data_processing_message = "";
                            this.group_set_order_delivery_key++;
                        }
                        i++;
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
        },
        setSortedOrderLocationAddress: function setSortedOrderLocationAddress(location) {
            if (location != undefined) {
                var i = 0;
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.checkout_orders), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var group = _step4.value;

                        if (group.order_business_delivery_options && group.order_business_delivery_options.length != 0) {
                            if (group.order_delivery_city_id == location.city_id) {
                                this.checkout_orders[i].order_user_delivery_address = location.address;
                                this.group_set_order_delivery_key++;
                            }
                        }
                        i++;
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }
            }
        },
        resetDeliveryLocation: function resetDeliveryLocation(i, location) {
            if (location != undefined) {
                this.checkout_orders[i].order_delivery_city = location.city_name;
                this.checkout_orders[i].order_delivery_city_id = location.city_id;
                this.checkout_orders[i].order_delivery_state_id = this.checkout_orders[i].order_delivery_selected_state.state_id;
                this.checkout_orders[i].order_delivery_state = this.checkout_orders[i].order_delivery_selected_state.name;

                this.checkout_orders[i].order_user_delivery_address = "";
            }
        },
        resetDeliveryLocationAddress: function resetDeliveryLocationAddress(index, location) {
            if (location != undefined) {
                this.checkout_orders[index].order_user_delivery_address = location.address;
                this.group_set_order_delivery_key++;
            }
        },
        getOrderLocations: function getOrderLocations(index, state) {
            this.activate_processing();

            var order_array = this.checkout_orders[index].order_business_delivery_options;
            this.checkout_orders[index].sorted_order_business_delivery_options = order_array.filter(function (item) {
                return item.business_delivery_state_id == state.state_id;
            });

            this.deactivate_processing();
        },
        loginAndProcess: function loginAndProcess() {
            var _this4 = this;

            this.activate_processing();
            service.loginUser(this, this.user).then(function (response) {
                if (response.body.status == 200) {
                    var data = response.body.data;
                    _this4.user = data;
                    var user_data = {
                        "user_name": data.user_name,
                        "user_id": data.user_id,
                        "sp_token": data.user_session_key,
                        "sp_token_key": data.user_token_key
                    };
                    localforage.setItem(service.udb_name, user_data).then(function (value) {}).catch(function (err) {});

                    _this4.is_logged_in_order_mode = 1;
                    _this4.process_checkout();
                    _this4.deactivate_processing();
                } else {
                    _this4.data_error_message = "Sorry, these login details are invalid.";
                    _this4.deactivate_processing();
                }
            }).catch(function (err) {
                _this4.deactivate_processing();
            });
        },
        preset_xtra: function preset_xtra() {
            var _this5 = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;

                            this.loggedIn = true;

                            if (this.$route.params.ckid != null) {
                                this.order_url = this.$route.params.ckid;
                                this.getCheckoutOrdersByURL();
                            } else {
                                this.getCheckoutOrders();
                            }
                            this.checkout_processed = true;
                            this.loading = false;

                            this.getUserDeliveryDetails();
                        }, _this5);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        preset: function preset() {
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;
                    self.new_account = false;

                    self.getCheckoutOrderSetDetails();

                    self.checkout_processed = true;
                    self.loading = false;
                    self.getUserDeliveryDetails();
                } else {
                    self.getCheckoutLocalOrder();
                }
            });
        },
        getCheckoutLocalOrder: function getCheckoutLocalOrder() {
            this.loading = true;

            var self = this;

            setTimeout(function () {
                localforage.getItem('not_loggedin_processed_orders').then(function (value) {
                    if (value != null) {
                        self.checkout_orders = value;
                    }
                    self.loading = false;
                }).catch(function (err) {
                    this.loading = false;
                    location.replace("/orders/");
                });
            }, 500);
        },
        getCheckoutOrders: function getCheckoutOrders() {
            var _this6 = this;

            this.activate_processing();
            service.getCheckoutOrders(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this6.setCheckoutOrders(response);
                } else {
                    _this6.$router.push("/orders/");
                }
            }).catch(function (err) {
                _this6.deactivate_processing();
            });
        },
        getCheckoutOrderSetDetails: function getCheckoutOrderSetDetails() {
            var _this7 = this;

            this.activate_processing();
            var payload = {
                order_ref: this.$route.params.ref
            };
            service.getOrderDetails(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    var data = response.body.data;
                    if (data[0]["order_payment_status_id"] && data[0]["order_payment_status_id"] != 2) {
                        _this7.setCheckoutOrders(response);
                    } else {
                        location.replace("/orders/");
                    }
                } else {
                    _this7.deactivate_processing();
                    location.replace("/orders/");
                }
            }).catch(function (err) {
                _this7.deactivate_processing();
                location.replace("/orders/");
            });
        },
        getCheckoutOrdersByURL: function getCheckoutOrdersByURL() {
            var _this8 = this;

            this.activate_processing();
            service.getCheckoutOrder(this, this.order_url).then(function (response) {
                if (response.body.status == 200) {
                    var data = response.body.data;
                    if (data[0]["order_payment_status_id"] && data[0]["order_payment_status_id"] != 2) {
                        _this8.setCheckoutOrders(response);
                    } else {
                        location.replace("/orders/");
                    }
                } else {
                    _this8.deactivate_processing();
                    location.replace("/orders/");
                }
            }).catch(function (err) {
                _this8.deactivate_processing();
                location.replace("/orders/");
            });
        },
        getCheckoutOrdersByReMake: function getCheckoutOrdersByReMake(order_ref) {
            var _this9 = this;

            this.activate_processing();
            service.getCheckoutOrderReMake(this, order_ref).then(function (response) {
                if (response.body.status == 200) {
                    var data = response.body.data;
                    if (data[0]["order_payment_status_id"] && data[0]["order_payment_status_id"] != 2) {
                        _this9.setCheckoutOrders(response);
                    } else {
                        location.replace("/orders/");
                    }
                } else {
                    _this9.deactivate_processing();
                    location.replace("/orders/");
                }
            }).catch(function (err) {
                _this9.deactivate_processing();
                location.replace("/orders/");
            });
        },
        setCheckoutOrders: function setCheckoutOrders(response) {
            var _this10 = this;

            this.checkout_orders = response.body.data;

            var remove_orders = [];
            var order_count = 0;
            this.checkout_orders.forEach(function (order) {
                order.change_shipping = false;
                order.display_delivery = false;
                order.cities = {};
                order.data_processing_message = "";

                if (order.order_items.length == 0) {
                    remove_orders.push(order);
                }

                this.getOrderChart(order, order_count);

                order_count++;
            }, this);

            var _loop = function _loop(order) {
                var order_index = _this10.checkout_orders.findIndex(function (o) {
                    return o.order_id === order.order_id;
                });
                _this10.checkout_orders.splice(order_index, 1);
            };

            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(remove_orders), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var order = _step5.value;

                    _loop(order);
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            this.total_order_items_total = response.body.data_calculated_orders_amount;

            this.total_orders_amount = response.body.data_total_amount;
            this.total_order_coupon_amount = response.body.data_calculated_coupons;
            this.total_shipping_fee = response.body.data_calculated_shipping_fee;
            this.total_processing_fee = response.body.data_total_orders_processing_fee;
            this.delivery_details = response.body.data_user_delivery_details;
            this.share_cart_details = response.body.data_share_cart_details;
            this.payment_details = response.body.payment_data;

            this.sortOrderLocations();

            this.checkout_processed = true;
            if (this.new_account) {
                this.loginAndProcess();
            }
            this.deactivate_processing();
        },
        sortOrderLocations: function sortOrderLocations() {
            var i = 0;
            var locations = [];
            this.order_delivery_sorted_locations.cities = [];
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.checkout_orders), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var group = _step6.value;

                    if (group.order_business_delivery_options && group.order_business_delivery_options.length != 0) {
                        var delivery_arr = { city_id: group.order_delivery_city_id, city_name: group.order_delivery_city };

                        locations.push(delivery_arr);
                    }

                    i++;
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }

            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
                for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(locations), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var _location = _step7.value;

                    if (this.order_delivery_sorted_locations.cities.indexOf(_location) == -1) {
                        this.order_delivery_sorted_locations.cities.push(_location);
                    }
                }
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                        _iterator7.return();
                    }
                } finally {
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }
        },
        getUserDeliveryDetails: function getUserDeliveryDetails() {
            var _this11 = this;

            service.getUserDeliveryDetails(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this11.delivery_details = response.body.data;
                }
            }).catch(function (err) {});
        },
        prep_process_checkout: function prep_process_checkout() {
            var _this12 = this;

            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.user.user_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;

            var phone_test = true;
            if (email_test == false || this.user.user_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                this.user.user_has_shipping_details = false;
                this.user.user_password = this.user.user_name;
                this.user.new_set_account = true;

                service.regUser(this, this.user).then(function (data) {
                    if (data.body.status == 201) {
                        this.loginAndProcess();
                    }
                }).catch(function (err) {
                    _this12.data_error_message = "Something went wrong while account was being processed";
                });
            }
        },
        process_checkout: function process_checkout() {
            this.activate_processing();

            var promises = [];
            var promise_thread_count = 0;

            if (this.process_count != this.checkout_orders.length) {
                this.checkout_orders.forEach(function (processed_checkout) {
                    this.order_url = this.checkout_orders[0].order_business + new Date().getTime();
                    processed_checkout.order_mode = this.is_logged_in_order_mode;
                    processed_checkout.order_url = this.order_url;
                    if (!this.new_account) {
                        processed_checkout.order_user_id = this.user.user_id;
                    } else {
                        processed_checkout.order_user_details = this.user;
                    }

                    processed_checkout.order_user_id = this.user.user_id;
                    processed_checkout.order_mode = 1;
                    promise_thread_count++;
                    promises.push(this.processCheckoutThread(processed_checkout));
                }, this);
            }

            if (promise_thread_count == this.checkout_orders.length) {
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises).then(function () {}).catch(function (e) {});
            }
        },
        processCheckoutThread: function processCheckoutThread(processed_checkout) {
            service.checkout(this, processed_checkout).then(function (data) {
                if (data.body.status == 201) {
                    this.process_count++;
                }

                if (this.process_count == this.checkout_orders.length) {
                    this.checkout_orders = [];
                    this.preset();
                }
                this.deactivate_processing();
            }).catch(function (err) {});
        },
        pre_checkout: function pre_checkout() {
            this.preset();
        },
        displayDeliveryOptions: function displayDeliveryOptions(order) {
            this.selected_order = [];
            this.selected_order = order;
            if (this.selected_order.display_delivery) {
                this.selected_order.display_delivery = false;
            } else {
                this.selected_order.display_delivery = true;
            }
        },
        calc_delivery_fee: function calc_delivery_fee(i, option) {
            if (option != undefined) {
                this.total_orders_amount -= Number(this.checkout_orders[i].order_delivery_fee);
                this.checkout_orders[i].order_total -= Number(this.checkout_orders[i].order_delivery_fee);
                this.total_shipping_fee -= Number(this.checkout_orders[i].order_delivery_fee);
                this.checkout_orders[i].order_delivery_fee = 0;
                this.checkout_orders[i].order_user_delivery_address = "";

                var _iteratorNormalCompletion8 = true;
                var _didIteratorError8 = false;
                var _iteratorError8 = undefined;

                try {
                    for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.checkout_orders[i].order_items), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                        var item = _step8.value;

                        item.order_item_delivery_fee = 0;
                    }
                } catch (err) {
                    _didIteratorError8 = true;
                    _iteratorError8 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion8 && _iterator8.return) {
                            _iterator8.return();
                        }
                    } finally {
                        if (_didIteratorError8) {
                            throw _iteratorError8;
                        }
                    }
                }

                this.checkout_orders[i].order_delivery_id = option.business_delivery_option_id;
                this.checkout_orders[i].order_delivery_city = option.business_delivery_option;
                this.checkout_orders[i].order_delivery_city_id = option.business_delivery_city;
                this.checkout_orders[i].order_delivery_state_id = option.business_delivery_state_id;
                this.checkout_orders[i].order_delivery_state = option.business_delivery_state;

                var fees = option.business_products_delivery_fees;
                if (fees.length == 0) {
                    if (this.checkout_orders[i].business_shipping_calculation_method == 9) {
                        this.checkout_orders[i].order_delivery_fee += Number(option.business_delivery_option_price);
                    } else {
                        var _iteratorNormalCompletion9 = true;
                        var _didIteratorError9 = false;
                        var _iteratorError9 = undefined;

                        try {
                            for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.checkout_orders[i].order_items), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                                var _item = _step9.value;

                                if (this.checkout_orders[i].business_shipping_calculation_method == 10) {
                                    this.checkout_orders[i].order_delivery_fee += Number(option.business_delivery_option_price);
                                }
                                if (this.checkout_orders[i].business_shipping_calculation_method == 11) {
                                    this.checkout_orders[i].order_delivery_fee += Number(_item.product_item_order_quantity * option.business_delivery_option_price);
                                }
                            }
                        } catch (err) {
                            _didIteratorError9 = true;
                            _iteratorError9 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion9 && _iterator9.return) {
                                    _iterator9.return();
                                }
                            } finally {
                                if (_didIteratorError9) {
                                    throw _iteratorError9;
                                }
                            }
                        }
                    }
                } else {
                    var ordered_items = this.checkout_orders[i].order_items;
                    var _iteratorNormalCompletion10 = true;
                    var _didIteratorError10 = false;
                    var _iteratorError10 = undefined;

                    try {
                        for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(ordered_items), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                            var _item2 = _step10.value;
                            var _iteratorNormalCompletion12 = true;
                            var _didIteratorError12 = false;
                            var _iteratorError12 = undefined;

                            try {
                                for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(fees), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                                    var fee = _step12.value;

                                    if (_item2.product_id == fee.product_delivery_product) {
                                        if (_item2.product_shipping_calculation_method == 13) {
                                            this.checkout_orders[i].order_delivery_fee += Number(_item2.order_item_quantity * fee.product_delivery_fee);
                                        }
                                        if (_item2.product_shipping_calculation_method == 12) {
                                            this.checkout_orders[i].order_delivery_fee += Number(fee.product_delivery_fee);
                                        }

                                        _item2.has_calculated_product_delivery_fee = true;
                                        _item2.calculated_product_delivery_fee = Number(fee.product_delivery_fee);
                                        _item2.order_item_delivery_fee = Number(fee.product_delivery_fee);
                                    }
                                }
                            } catch (err) {
                                _didIteratorError12 = true;
                                _iteratorError12 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion12 && _iterator12.return) {
                                        _iterator12.return();
                                    }
                                } finally {
                                    if (_didIteratorError12) {
                                        throw _iteratorError12;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError10 = true;
                        _iteratorError10 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion10 && _iterator10.return) {
                                _iterator10.return();
                            }
                        } finally {
                            if (_didIteratorError10) {
                                throw _iteratorError10;
                            }
                        }
                    }

                    var sorted_fees = ordered_items.filter(function (item) {
                        return item.has_calculated_product_delivery_fee == true;
                    });

                    if (sorted_fees.length < ordered_items.length) {
                        if (this.checkout_orders[i].business_shipping_calculation_method == 9) {
                            this.checkout_orders[i].order_delivery_fee += Number(option.business_delivery_option_price);
                        } else {
                            var _iteratorNormalCompletion11 = true;
                            var _didIteratorError11 = false;
                            var _iteratorError11 = undefined;

                            try {
                                for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(ordered_items), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                                    var _item3 = _step11.value;

                                    if (this.checkout_orders[i].business_shipping_calculation_method == 10) {
                                        this.checkout_orders[i].order_delivery_fee += Number(option.business_delivery_option_price);
                                    }
                                    if (this.checkout_orders[i].business_shipping_calculation_method == 11) {
                                        this.checkout_orders[i].order_delivery_fee += Number(_item3.product_item_order_quantity * option.business_delivery_option_price);
                                    }
                                }
                            } catch (err) {
                                _didIteratorError11 = true;
                                _iteratorError11 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion11 && _iterator11.return) {
                                        _iterator11.return();
                                    }
                                } finally {
                                    if (_didIteratorError11) {
                                        throw _iteratorError11;
                                    }
                                }
                            }
                        }
                    }
                }

                this.total_orders_amount += Number(this.checkout_orders[i].order_delivery_fee);
                this.checkout_orders[i].order_total += Number(this.checkout_orders[i].order_delivery_fee);
                this.total_shipping_fee += Number(this.checkout_orders[i].order_delivery_fee);
                if (this.delivery_details.length != 0) {
                    var _iteratorNormalCompletion13 = true;
                    var _didIteratorError13 = false;
                    var _iteratorError13 = undefined;

                    try {
                        for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.delivery_details), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                            var detail = _step13.value;

                            if (detail.user_delivery_city == option.business_delivery_option) {
                                this.checkout_orders[i].order_user_city_delivery_addresses = [];

                                this.checkout_orders[i].order_user_city_delivery_addresses.push(detail);
                            }
                        }
                    } catch (err) {
                        _didIteratorError13 = true;
                        _iteratorError13 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion13 && _iterator13.return) {
                                _iterator13.return();
                            }
                        } finally {
                            if (_didIteratorError13) {
                                throw _iteratorError13;
                            }
                        }
                    }
                }
            }
        },
        setOrderUserCityDeliveryAddress: function setOrderUserCityDeliveryAddress(i, address) {
            if (address != undefined) {
                this.checkout_orders[i].order_user_delivery_detail = address.address_id;
            }
        },
        setUserDeliveryAddress: function setUserDeliveryAddress(i, city) {
            this.delivery_details.forEach(function (detail) {
                if (detail.user_delivery_city == city) {
                    this.checkout_orders[i].order_user_delivery_address = detail.user_delivery_address;
                }
            }, this);
        },
        setPaymentOption: function setPaymentOption(option) {
            this.payment_mode = option;
        },
        setProcessPaymentSingle: function setProcessPaymentSingle(order, index, toggle_view) {
            var process_errors = [];
            if (order.order_need_shipping == 1) {
                if (order.order_delivery_city == undefined || order.order_delivery_city == '') {
                    if (order.order_business_agent_type && order.order_business_agent_type == 20) {
                        process_errors.push("Please enter delivery location for " + order.order_business_agent_name);
                    } else {
                        process_errors.push("Please enter delivery location for " + order.order_business);
                    }
                } else {
                    if (order.order_user_delivery_address == undefined || order.order_user_delivery_address == '') {
                        if (order.order_business_agent_type && order.order_business_agent_type == 20) {
                            process_errors.push("Please enter delivery address for " + order.order_business_agent_name);
                        } else {
                            process_errors.push("Please enter delivery address for " + order.order_business);
                        }
                    }

                    order.order_items.forEach(function (item) {
                        if (item.order_delivery_city) {
                            if (item.order_user_delivery_address == undefined) {
                                process_errors.push("Please enter delivery address for " + item.product_name);
                            }
                        }
                    }, this);
                }
            }
            if (process_errors.length != 0) {
                process_errors.forEach(function (err) {
                    this.data_error_message = err;

                    this.checkout_orders[index].data_processing_message = err;
                    this.checkout_orders[index].show_address_input = true;

                    this.componentOrderSummaryKey++;
                }, this);
            } else {
                if (!order.order_user_delivery_detail) {
                    order.order_user_new_delivery_detail = true;
                }
                this.data_error_message = "";
                this.checkout_orders[index].data_processing_message = "";
                this.checkout_orders[index].show_address_input = true;
                this.toggleViews(toggle_view);
            }
        },
        setProcessGiftCardPayment: function setProcessGiftCardPayment(order, index, payment_mode, payment_status, payment_type) {
            var _this13 = this;

            var set_address_id = this.checkout_orders[index].order_user_delivery_detail;
            var set_address = this.checkout_orders[index].order_user_delivery_address;

            var payload = {
                gift_card_order: order.order_id,
                gift_card_user: this.user.user_id,
                gift_card_ref: this.set_gift_card.gift_card_ref,
                gift_card_order_data: order
            };

            service.getCheckoutGiftCardOrders(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    if (payment_type == 2) {
                        var new_order = data.body.data[0];
                        new_order.order_user_delivery_detail = set_address_id;
                        new_order.order_user_delivery_detail = set_address;
                        _this13.prepProcessPaymentSingle(new_order, index, payment_mode, payment_status);
                    } else {
                        _this13.order_gift_card = data.body.data;
                    }
                } else {}
            }).catch(function (err) {
                if (err) {
                    _this13.data_processing_message = "Sorry, could not process information";
                }
            });
        },
        prepProcessGiftCardPayment: function prepProcessGiftCardPayment(order, index, payment_mode, payment_status) {
            var _this14 = this;

            var set_address_id = this.checkout_orders[index].order_user_delivery_detail;
            var set_address = this.checkout_orders[index].order_user_delivery_address;
            var order_gift_card_data = {};var _iteratorNormalCompletion14 = true;
            var _didIteratorError14 = false;
            var _iteratorError14 = undefined;

            try {
                for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.order_gift_card), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                    var order_data = _step14.value;

                    if (order_data.order_id == this.checkout_orders[index].order_id) {
                        order_gift_card_data = order_data.order_gift_card_data;

                        this.checkout_orders[index] = order_data;
                        this.checkout_orders[index].order_user_delivery_detail = set_address_id;
                        this.checkout_orders[index].order_user_delivery_address = set_address;
                        this.checkout_orders[index].order_gift_card_data = order_gift_card_data;

                        order = this.checkout_orders[index];

                        service.makeOrderSpinoff(this, order).then(function (re) {
                            if (re.body.status == 200) {
                                var new_order = re.body.data[0];

                                _this14.setProcessGiftCardPayment(new_order, index, payment_mode, payment_status, 2);
                            }
                        }).catch(function (err) {});
                    }
                }
            } catch (err) {
                _didIteratorError14 = true;
                _iteratorError14 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion14 && _iterator14.return) {
                        _iterator14.return();
                    }
                } finally {
                    if (_didIteratorError14) {
                        throw _iteratorError14;
                    }
                }
            }
        },
        prepProcessPaymentSingle: function prepProcessPaymentSingle(order, index, payment_mode, payment_status) {
            var _this15 = this;

            var has_set_payment_ref = 0;
            var amount_to_pay = order.total_amount;

            order.total_amount_topay = order.total_amount;
            if (order.order_can_part_payment == 1 && payment_mode != 8) {
                var amount_rem = order.total_amount_topay - order.order_part_payment_total_amount_paid;
                if (order.order_part_payment_amount && order.order_part_payment_amount > 0) {
                    if (order.order_part_payment_amount > amount_rem) {
                        order.total_amount_topay = amount_rem;
                    } else {
                        order.total_amount_topay = order.order_part_payment_amount;
                    }
                } else {
                    order.total_amount_topay = amount_rem;
                }
            }

            if (order.total_amount_topay > 0) {
                console.log(884);
                var payload = {
                    service_load: this.payment_details.pay_set,
                    service_user: this.user.user_id,
                    service_payment_transaction_type: 1,
                    service_total_amount: order.total_amount_topay,
                    service_payment_mode: payment_mode,
                    service_is_part_payment: order.order_can_part_payment,
                    service_payment_status: payment_status,
                    service_active_payment_ref: this.payment_active_resolve_ref
                };
                service.preparePayments(this, payload).then(function (data) {
                    if (data.body.status == 200 || data.body.status == 404) {
                        has_set_payment_ref = 1;
                        _this15.payment_details.payment_ref = data.body.data.data_ref;
                    } else {
                        var paymode = data.body.data_active_payment_mode;
                        var paydata = data.body;
                        if (data.body.status == 409) {
                            if (data.body.data_active_gateway_payment_check == 1) {
                                _this15.verifyServerRavePayment(order, index, payment_mode, paydata);
                            } else if (data.body.status == 409 && data.body.data_paid_status == 200) {
                                _this15.resolveActivePayment(order, index, payment_mode, paydata);
                            }
                        } else {
                            _this15.data_processing_message = "Sorry, could not update payment";
                        }
                    }
                    if (has_set_payment_ref == 1 && _this15.payment_details.payment_ref != '') {
                        _this15.processPaymentSingle(order, index, payment_mode);
                    }

                    _this15.payment_active_resolve_ref = "";
                }).catch(function (err) {
                    if (err) {
                        _this15.data_processing_message = "Sorry, could not process information";
                    }

                    _this15.payment_active_resolve_ref = "";
                });

                service.updateOrderBasics(this, order).then(function (re) {
                    if (re.body.status == 200 || re.body.status == 404) {}
                }).catch(function (err) {});
            }
        },
        verifyServerRavePayment: function verifyServerRavePayment(order, index, payment_mode, paydata) {
            var _this16 = this;

            var payref = paydata.data_active_payment_service_ref;

            var payload = {
                call_url: "https://api.flutterwave.com/v3/transactions/" + payref + "/verify",
                call_method: "GET",
                call_header: ["Content-Type: application/json", "Authorization: FLWSECK-a235ea72184ac4d7c07ea2e356682cd7-X"]
            };
            service.verifyRavePayment(this, payload).then(function (response) {
                if (response.body.status === "success") {
                    if (response.body.data.amount === order.total_amount_topay) {
                        paydata.data_active_gateway_payment_check = "00";
                        paydata.data_active_gateway_payment_log_ref = payref;
                        _this16.resolveActivePayment(order, index, payment_mode, paydata);
                    }
                } else {
                    _this16.payment_active_resolve_ref = payref;

                    _this16.prepProcessPaymentSingle(order, index, payment_mode, 2);
                }
            }).catch(function (err) {
                if (err) {
                    _this16.data_processing_message = "Sorry, could not process information";
                }
            });
        },
        resolveActivePayment: function resolveActivePayment(order, index, payment_mode, payment_data) {
            this.payment_details.active_payment_data = payment_data;
            this.payment_details.active_payment_alert = 1;
            this.payment_details.active_payment_ref = payment_data.data_active_payment_service_ref;

            this.processPaymentSingle(order, index, payment_mode);
        },
        processPaymentSingle: function processPaymentSingle(order, index, payment_mode) {
            this.activate_processing();
            var active_payment_alert = 0;
            if (this.payment_details.active_payment_alert && this.payment_details.active_payment_alert == 1) {
                active_payment_alert = 1;
            }
            if (payment_mode == 1) {
                order.order_payment_mode = 1;
                this.checkout_orders[index].order_payment_mode = 1;
                var set_post_payment_payload = {
                    payment_gateway_id: 1,
                    payment_from_module: 1,
                    payment_from_module_id: this.user.user_id || 0,
                    payment_to_module: 0,
                    payment_to_module_id: 0,
                    payment_service_module: 8,
                    payment_service_module_id: order.order_id,
                    payment_amount_paid: order.total_amount_topay,
                    payment_gateway_transaction_ref: "test_ref" + new Date().getTime() };
                order.payment_mode_update_data = set_post_payment_payload;

                this.updatePaymentSingle("test_ref" + new Date().getTime(), order, index, "autoUpdate");
            }

            if (payment_mode == 2) {
                order.order_payment_mode = 2;
                this.checkout_orders[index].order_payment_mode = 2;
                if (active_payment_alert == 1) {
                    this.updatePaymentSingle(this.payment_details.active_payment_ref, order, index, "autoUpdateCollections");
                } else {
                    this.updatePaymentSingle(this.payment_details.payment_ref, order, index, "autoUpdateCollections");
                }
            }

            if (payment_mode == 3) {
                order.order_payment_mode = 3;
                this.checkout_orders[index].order_payment_mode = 3;
                if (active_payment_alert == 1) {
                    this.updatePaymentSingle(this.payment_details.active_payment_ref, order, index, "manualUpdate");
                } else {
                    this.updatePaymentSingle(this.payment_details.payment_ref, order, index, "manualUpdate");
                }
            }

            if (payment_mode == 5) {
                order.order_payment_mode = 5;
                this.checkout_orders[index].order_payment_mode = 3;
                if (active_payment_alert == 1) {
                    this.updatePaymentSingle(this.payment_details.active_payment_ref, order, index, "PaymentProcessingAccount");
                } else {
                    this.updatePaymentSingle(this.payment_details.payment_ref, order, index, "PaymentProcessingAccount");
                }
            }

            if (payment_mode == 6) {
                order.order_payment_mode = 6;
                this.checkout_orders[index].order_payment_mode = 6;
                if (active_payment_alert == 1) {
                    this.updatePaymentSingle(this.payment_details.active_payment_ref, order, index, "GigsPayment");
                } else {
                    this.updatePaymentSingle(this.payment_details.payment_ref, order, index, "GigsPayment");
                }
            }

            if (payment_mode == 7) {
                order.order_payment_mode = 7;
                this.checkout_orders[index].order_payment_mode = 7;
                if (active_payment_alert == 1) {
                    this.updatePaymentSingle(this.payment_details.active_payment_ref, order, index, "GiftCardPayment");
                } else {
                    this.updatePaymentSingle(this.payment_details.payment_ref, order, index, "GiftCardPayment");
                }
            }

            if (payment_mode == 8) {
                order.order_payment_mode = 8;
                this.checkout_orders[index].order_payment_mode = 8;
                if (active_payment_alert == 1) {
                    this.updatePaymentSingle(this.payment_details.active_payment_ref, order, index, "AppPayment");
                } else {
                    this.makeAppPayment(this.payment_details, order, index);
                }
            }
        },
        processPaymentRavepay: function processPaymentRavepay(data, order, index) {
            var self = this;

            var set_subaccounts = [];
            var set_subaccounts_settlements = true;
            if (order.order_can_part_payment) {
                set_subaccounts_settlements = false;
            }

            if (set_subaccounts_settlements) {
                if (order.order_agent_fee > 0) {
                    var sub_account_0 = {
                        id: order.business_agent_bank_ravepay_subaccount_id,
                        transaction_charge: order.order_agent_fee,
                        transaction_charge_type: "flat_subaccount"
                    };
                    set_subaccounts.push(sub_account_0);
                }

                if (order.order_total_commissions_fee > 0) {
                    var sub_account_01 = {
                        id: service.spcomms_subaccount_id,
                        transaction_charge: order.order_total_commissions_fee,
                        transaction_charge_type: "flat_subaccount"
                    };
                    set_subaccounts.push(sub_account_01);
                }

                var order_business = 0;
                var order_delivery_business = order.order_delivery_business.business_delivery_id;
                if (order_business == order_delivery_business) {
                    var sub_account_1 = {
                        id: order.business_bank_ravepay_subaccount_id,
                        transaction_charge: order.total_amount - (order.order_processing_fee + order.order_agent_fee + order.order_total_commissions_fee),
                        transaction_charge_type: "flat_subaccount"
                    };
                    set_subaccounts.push(sub_account_1);
                } else {
                    var sub_account_1 = {
                        id: order.business_bank_ravepay_subaccount_id,
                        transaction_charge: order.total_amount - (order.order_delivery_fee + order.order_processing_fee + order.order_agent_fee + order.order_total_commissions_fee),
                        transaction_charge_type: "flat_subaccount"
                    };
                    set_subaccounts.push(sub_account_1);
                    var sub_account_2 = {
                        id: order.order_delivery_business.business_bank_ravepay_subaccount_id,
                        transaction_charge: order.order_delivery_fee,
                        transaction_charge_type: "flat_subaccount"
                    };
                    set_subaccounts.push(sub_account_2);
                }
            }


            var x = getpaidSetup({
                PBFPubKey: service.ravepay_public_test,
                customer_email: "keneinfostream@gmail.com",
                amount: 3000,
                customer_phone: data.payment_payer_phone,
                currency: "NGN",
                payment_method: "both",
                txref: data.payment_ref,

                subaccounts: set_subaccounts,
                meta: [{
                    metaname: "AFPAY",
                    metavalue: data.payment_payer_name
                }],
                onclose: function onclose() {},
                callback: function callback(response) {
                    var txref = response.tx.txRef;
                    var tx_amount = response.tx.amount;
                    if (response.tx.chargeResponseCode == "00" || response.tx.chargeResponseCode == "0") {
                        var set_post_payment_payload = {
                            payment_gateway_id: 1,
                            payment_from_module: 1,
                            payment_from_module_id: self.user.user_id || 0,
                            payment_to_module: 0,
                            payment_to_module_id: 0,
                            payment_service_module: 8,
                            payment_service_module_id: order.order_id,
                            payment_amount_paid: tx_amount,
                            payment_gateway_transaction_ref: txref };
                        order.payment_mode_update_data = set_post_payment_payload;

                        self.updatePaymentSingle(txref, order, index, "autoUpdate");
                    } else {
                        self.payment_message = "Payment unsuccessfull. please try again or contact us";
                    }
                }
            });
        },
        makeAppPayment: function makeAppPayment(data, order, index) {
            var _this17 = this;

            var self = this;

            var set_accounts = [];
            var set_subaccounts_settlements = true;
            if (set_subaccounts_settlements) {
                if (order.order_agent_fee > 0) {
                    var set_account = {
                        "account_bank": order.business_agent_bank_details.bank_ravepay_id,
                        "account_number": order.business_agent_bank_details.bank_account_number,
                        "amount": order.order_agent_fee,
                        "narration": order.business_agent_bank_details.bank_account_name + " Transfer for order " + order.order_no,
                        "currency": "NGN",
                        "reference": data.payment_ref,
                        "callback_url": "#",
                        "debit_currency": "NGN"
                    };
                    set_accounts.push(set_account);
                }

                if (order.order_total_commissions_fee > 0) {
                    var set_account = {
                        "account_bank": service.spcomms_subaccount_bank_ravepay_id,
                        "account_number": service.spcomms_subaccount_bank_account_number,
                        "amount": order.order_total_commissions_fee,
                        "narration": service.spcomms_subaccount_bank_account_name + " Transfer for order " + order.order_no,
                        "currency": "NGN",
                        "reference": data.payment_ref,
                        "callback_url": "#",
                        "debit_currency": "NGN"
                    };
                    set_accounts.push(set_account);
                }

                var order_business = 0;
                var order_delivery_business = order.order_delivery_business.business_delivery_id;
                if (order_business == order_delivery_business) {
                    var set_account = {
                        "account_bank": order.business_bank_details.bank_ravepay_id,
                        "account_number": order.business_bank_details.bank_account_number,
                        "amount": order.total_amount - (order.order_processing_fee + order.order_agent_fee + order.order_total_commissions_fee),
                        "narration": order.business_bank_details.bank_account_name + " Transfer for order " + order.order_no,
                        "currency": "NGN",
                        "reference": data.payment_ref,
                        "callback_url": "#",
                        "debit_currency": "NGN"
                    };
                    set_accounts.push(set_account);
                } else {
                    var set_account_01 = {
                        "account_bank": order.business_bank_details.bank_ravepay_id,
                        "account_number": order.business_bank_details.bank_account_number,
                        "amount": order.total_amount - (order.order_processing_fee + order.order_agent_fee + order.order_total_commissions_fee),
                        "narration": order.business_bank_details.bank_account_name + " Transfer for order " + order.order_no,
                        "currency": "NGN",
                        "reference": data.payment_ref,
                        "callback_url": "#",
                        "debit_currency": "NGN"
                    };
                    set_accounts.push(set_account_01);

                    var set_account_02 = {
                        "account_bank": order.order_delivery_business.bank_ravepay_id,
                        "account_number": order.order_delivery_business.bank_account_number,
                        "amount": order.order_delivery_fee,
                        "narration": order.order_delivery_business.bank_account_name + " Transfer for order " + order.order_no,
                        "currency": "NGN",
                        "reference": data.payment_ref,
                        "callback_url": "#",
                        "debit_currency": "NGN"
                    };
                    set_accounts.push(set_account_02);
                }
            }

            var process_count = 0;
            var _iteratorNormalCompletion15 = true;
            var _didIteratorError15 = false;
            var _iteratorError15 = undefined;

            try {
                for (var _iterator15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(set_accounts), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                    var account = _step15.value;

                    process_count++;
                    var payload = {
                        "account_bank": account.account_bank,
                        "account_number": account.account_number,
                        "amount": account.amount,
                        "narration": account.narration,
                        "currency": account.currency,
                        "reference": account.reference,
                        "callback_url": account.callback_url,
                        "debit_currency": account.debit_currency
                    };

                    if (process_count == set_accounts.length) {
                        this.updatePaymentSingle(data.payment_ref, order, index, "autoUpdate");
                    } else {
                        service.transferPayoutRavepay(payload).then(function (data) {
                            if (data.body.status == 'success') {
                                console.log(data.body.data);
                                _this17.deactivate_processing();
                            }
                        }).catch(function (err) {
                            if (err) {
                                console.log(err);
                            }
                        });
                    }
                }
            } catch (err) {
                _didIteratorError15 = true;
                _iteratorError15 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion15 && _iterator15.return) {
                        _iterator15.return();
                    }
                } finally {
                    if (_didIteratorError15) {
                        throw _iteratorError15;
                    }
                }
            }

            var x = getpaidSetup({
                PBFPubKey: service.ravepay_public_test,
                customer_email: "keneinfostream@gmail.com",
                amount: order.total_amount_topay,
                customer_phone: data.payment_payer_phone,
                currency: "NGN",
                payment_method: "both",
                txref: data.payment_ref,

                subaccounts: set_subaccounts,
                meta: [{
                    metaname: "AFPAY",
                    metavalue: data.payment_payer_name
                }],
                onclose: function onclose() {},
                callback: function callback(response) {
                    var txref = response.tx.txRef;
                    var tx_amount = response.tx.amount;
                    if (response.tx.chargeResponseCode == "00" || response.tx.chargeResponseCode == "0") {
                        var set_post_payment_payload = {
                            payment_gateway_id: 1,
                            payment_from_module: 1,
                            payment_from_module_id: this.user.user_id || 0,
                            payment_to_module: 0,
                            payment_to_module_id: 0,
                            payment_service_module: 8,
                            payment_service_module_id: order.order_id,
                            payment_amount_paid: tx_amount,
                            payment_gateway_transaction_ref: txref };
                        order.payment_mode_update_data = set_post_payment_payload;

                        self.updatePaymentSingle(txref, order, index, "autoUpdate");
                    } else {
                        self.payment_message = "Payment unsuccessfull. please try again or contact us";
                    }
                }
            });
        },
        updatePaymentSingle: function updatePaymentSingle(payment_ref, order, index, update_type) {
            var _this18 = this;

            this.process_orders_update = [];
            var processing_fee_transaction_type = 0;
            if (order.order_processing_fee_status == 3) {
                processing_fee_transaction_type = 2;
                order.processing_fee_transaction_type = processing_fee_transaction_type;
                order.processing_fee_transaction_amount = order.order_processing_fee;
            }

            this.payment_details.payment_details = order.order_details;
            this.payment_details.payment_service_module = 8;
            this.payment_details.payment_service_module_id = order.order_id;
            this.payment_details.payment_service_amount_paid = order.total_amount_topay;

            var payment_service_payment_data = this.payment_details;

            this.process_orders_update.push(order);
            payment_service_payment_data.payment_services = this.process_orders_update;

            var set_payment_mode_update_data = [];
            if (order.order_payment_mode == 1) {
                set_payment_mode_update_data = order.payment_mode_update_data;
            }

            var set_payment_is_part_payment = order.order_can_part_payment;
            if (order.order_can_part_payment == 1) {
                if (order.total_amount_topay == order.order_part_payment_total_amount_paid) {
                    set_payment_is_part_payment = 0;
                }
            }

            if (order.order_payment_mode == 3) {
                if (order.order_receive_manual_payment_by == 2) {
                    payment_service_payment_data.payment_manual_payment_to_agent = 1;
                }
            }

            var order_gift_card_data = {};
            if (order.order_payment_mode == 7) {
                order_gift_card_data = order.order_gift_card_data;
            }

            var payload = {
                payment_order_type: "single",
                payment_order_ref: payment_ref,
                payment_order_amount_paid: order.total_amount_topay,
                payment_user_id: this.user.user_id,
                payment_orders: order,
                payment_details: order.order_details,

                processing_fee_transaction_type: processing_fee_transaction_type,
                processing_fee_transaction_amount: order.order_processing_fee,

                payment_service_payment_data: payment_service_payment_data,
                payment_service_mode: order.order_payment_mode,
                payment_service_type: "single",

                payment_service_user_id: this.user.user_id,
                payment_service_amount_paid: order.total_amount_topay,
                payment_service_processing_fee_transaction_type: processing_fee_transaction_type,
                payment_service_processing_fee_transaction_amount: order.order_processing_fee,

                payment_is_part_payment: set_payment_is_part_payment,

                payment_mode_update_data: set_payment_mode_update_data,

                payment_update_type: update_type,

                payment_order_gift_card_data: order_gift_card_data

            };
            var navi = this.$router;

            if (payment_ref != "") {
                service.updatePayment(this, payload).then(function (data) {
                    if (data.body.status == 200 || data.body.status == 400) {
                        if (data.body.data_part_payment_status && data.body.data_part_payment_status == 200) {
                            _this18.checkout_orders[index].order_status_id = 0;
                            _this18.checkout_orders[index].order_part_payment_status = 200;
                            _this18.data_processing_message = "Payment Processed!";
                            _this18.processed_single_order_count++;
                        } else {
                            _this18.data_processing_message = "Payment Processed!";
                            _this18.checkout_orders[index] = data.body.data;
                            _this18.processed_single_order_count++;
                        }

                        if (order.order_payment_third_party_ref && order.order_payment_third_party_ref != '') {
                            _this18.updateFlexPaymentDetails(order, payment_ref, "transferred");
                        }

                        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this18.file_info).length > 0 && _this18.file_data_type == 'transfer-receipt') {
                            _this18.uploadFlexiPaymentReceipt(order, payment_ref, "transferred");
                        }

                        _this18.deactivate_processing();
                    } else if (data.body.status == 204) {
                        if (data.body.data_make_app_payment_alert == 1) {
                            if (order.order_can_part_payment == 1) {
                                order.order_part_payment_total_amount_paid = order.total_amount;
                            }
                            _this18.prepProcessPaymentSingle(order, index, 8, 0);
                        }
                        _this18.data_processing_message = "Sorry, could not update payment";
                        _this18.deactivate_processing();
                    } else {
                        _this18.data_processing_message = "Sorry, could not update payment";
                        _this18.deactivate_processing();
                    }
                }).catch(function (err) {
                    if (err) {
                        _this18.data_processing_message = "Sorry, could not process information";
                        _this18.deactivate_processing();
                    }
                });
            } else {
                this.data_processing_message = "Something went wrong";
                this.deactivate_processing();
            }
        },
        updateOrders: function updateOrders(order, index, status) {
            var _this19 = this;

            this.activate_processing();
            var order_data = {};

            var payload = {
                order: order,
                order_status: status,
                order_data: order_data
            };
            var navi = this.$router;
            service.updateOrders(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    _this19.checkout_orders[index].order_status_id = 0;
                    _this19.data_processing_message = "Order Placed";
                    _this19.processed_single_order_count++;
                    _this19.checkout_orders[index] = data.body.data;
                } else {
                    _this19.data_processing_message = "Sorry, could not update payment";
                }
                _this19.deactivate_processing();
            }).catch(function (err) {
                if (err) {
                    _this19.data_processing_message = "Sorry, could not process information";
                }
                _this19.deactivate_processing();
            });
        },
        updateFlexPaymentDetails: function updateFlexPaymentDetails(data, ref, status) {
            var _this20 = this;

            var data_set = {};
            if (status == "transferred") {
                data_set = {
                    payment_request_ref: ref,
                    payment_transfer_ref: data.order_payment_third_party_ref
                };
            }

            var payload = {
                data_data: data,
                data_status: status,
                data_updates: data_set
            };
            var navi = this.$router;
            service.updatePaymentDetails(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this20.flexi_active_payment_status = 1;
                } else {}
            }).catch(function (err) {
                if (err) {}
            });
        },
        uploadFlexiPaymentReceipt: function uploadFlexiPaymentReceipt(data, ref, status) {
            var _this21 = this;

            if (status == 'transferred') {
                this.imageForm.append("data_id", ref);
                this.imageForm.append("data_type", "third_party_payment_receipt");
                service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                    if (data.body.status == 200) {
                        _this21.flexi_active_payment_status = 1;
                    } else {
                        _this21.data_processing_message = service.upload_media_error_msg;
                    }
                });
            }
        },
        onFileChangeNewPhoto: function onFileChangeNewPhoto(e, data_type) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
                this.file_data_type = data_type;
            }

            document.getElementById('prImagePreview').src = window.URL.createObjectURL(files[0]);
        },
        _del_onFileChange: function _del_onFileChange(e, data_id, data_type) {
            if (data_type == "order_receipt") {}

            if (data_id > 0 && data_type != '') {
                var files = e.target.files || e.dataTransfer.files;
                if (files.length) {
                    this.file_info = files;
                    var formData = new FormData();
                    formData.append('photo', files[0]);
                    this.imageForm = formData;
                    formData.append('data_id', data_id);
                    formData.append('data_type', data_type);
                    service.uploadDataPhoto(this, formData).then(function (response) {
                        if (response.body.status == 200) {}
                    }).catch(function (err) {});
                }
            }
        },
        getOrderChart: function getOrderChart(order, index) {
            var _this22 = this;

            var payload = {
                track_module: 8,
                track_module_id: order.order_id
            };

            service.getMapOrderChart(this, order.order_id).then(function (response) {
                if (response.body.status == 200) {
                    _this22.checkout_orders[index].order_chart = response.body.data_chart;
                    _this22.componentKey++;
                }
            }).catch(function (err) {});
        },
        setOrderCustomMakePaymentUpdate: function setOrderCustomMakePaymentUpdate(order) {
            var payload = {
                order: order,
                order_status: "custom_set_track_make_payment",
                order_payment_buyer_confirmation: 1,

                order_track_module: 8,
                order_track_module_id: order.order_id,
                order_track_module_status: 20,
                order_track_action_by_module: 1,
                order_track_action_by_module_id: this.user.user_id,
                order_current_user: this.user.user_id || 0 };

            this.updateOrderSet(payload);
        },
        setOrderCustomUpdates: function setOrderCustomUpdates(order, status) {
            var payload = {
                order: order,
                order_status: status,
                order_payment_seller_confirmation: 1,

                order_track_module: 8,
                order_track_module_id: order.order_id,
                order_track_module_status: 0,
                order_track_action_by_module: 1,
                order_track_action_by_module_id: this.user.user_id,
                order_current_user: this.user.user_id || 0 };

            if (status == "received") {
                payload.order_track_module_status = 21;
            }
            if (status == "closed") {
                payload.order_track_module_status = 33;
            }

            if (payload.order_track_module_status > 0) {
                this.updateOrderSet(payload);
            }
        },
        setOrderCustomUploadReceipt: function setOrderCustomUploadReceipt(order) {
            var _this23 = this;

            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.file_info).length > 0 && this.file_data_type == 'transfer-receipt') {
                this.imageForm.append("data_id", order.order_id);
                this.imageForm.append("data_module", 8);
                this.imageForm.append("data_module_id", order.order_id);
                this.imageForm.append("data_type", "custom_set_upload");
                service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                    if (data.body.status == 200) {} else {
                        _this23.data_processing_message = service.upload_media_error_msg;
                    }
                });
            }
        }
    },
    created: function created() {
        document.title = "Checkout" + " | " + service.app_name;
        this.preset();
        this.loading = true;

        this.getStates();
    }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Order',
    data: function data() {
        return {
            loading: false,
            user: {},
            cart: this.$store.state.cart,
            img_product_url: service.imageProductsURL,
            loggedIn: false
        };
    },

    components: {
        'cart-widget': __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue___default.a
    },
    computed: {},
    methods: {},
    created: function created() {
        document.title = "Order" + " ";

        var self = this;
        localforage.getItem('xvue', function (err, value) {
            if (value != undefined) {
                self.cart = value.cart;
            } else {}
        });
    }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PaymentService_index_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PaymentService_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PaymentService_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources_setts_js__ = __webpack_require__(19);





var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Orders',
    mixins: [__WEBPACK_IMPORTED_MODULE_3__resources_setts_js__["a" /* default */]],
    data: function data() {
        return {
            user: {},
            orders: {},
            order: {},
            order_item: {},
            img_product_url: service.imageProductsURL,
            loading: true,
            show_all: true,
            show_single: false,
            is_new: false,
            show_products_for_review: false,
            data_processing_message: "",
            disable_btn: false,
            action_loading: false,
            star_rates: 5,
            componentOrderItemReviewKey: 0,
            brokers: {},
            broker_request: {},
            broker_request_payment_data: {},
            show_brokers: false,
            show_order_notifications: false,
            show_payment_service: false,
            show_empty_fields: false
        };
    },

    components: {
        'component-payment-service': __WEBPACK_IMPORTED_MODULE_2__PaymentService_index_vue___default.a
    },

    methods: {
        setOrder: function setOrder(order) {
            this.order = order;
            this.show_all = false;
            this.show_single = true;
            this.loading = false;
        },
        viewOrders: function viewOrders() {
            this.show_all = true;
            this.show_single = false;
            this.is_new = false;
            this.show_products_for_review = false;
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        preset_xtra: function preset_xtra() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.getOrders();
                            if (this.$route.params.ordid != null) {
                                this.setSingleOrder(this.$route.params.ckid);
                            }
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        preset: function preset() {
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != null) {
                    self.user.user_id = value.user_id;
                    self.user.user_name = value.user_name;
                    self.loggedIn = true;
                    self.getOrders();
                    if (self.$route.params.ordid != null) {
                        self.setSingleOrder(self.$route.params.ckid);
                    }
                } else {
                    self.$router.push('login');
                }
            });
        },
        getOrders: function getOrders() {
            var _this2 = this;

            service.getOrders(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.orders = response.body.data;
                    _this2.orders.set = true;
                    _this2.loading = false;
                }
            }).catch(function (err) {});
        },
        setSingleOrder: function setSingleOrder(order_no) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(orders), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var order = _step.value;

                    if (order.order_no == order_no) {
                        this.setOrder(order);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        prepareProductsForReview: function prepareProductsForReview() {
            this.order_item = this.order.order_items[0];
            this.order_item.data_processing_message = "";
            this.order_item.product_item_review = "";
            this.order_item.product_item_rate = 0;
            this.order_item.star_rates = 5;
            this.show_products_for_review = true;
        },
        setRating: function setRating(i, item_index) {
            var stars = document.getElementsByClassName('rate-stars');
            for (var n = 0; n < this.order_item.star_rates; n++) {
                stars[n].style = "color:none;";
            }

            for (var r = 0; r <= i; r++) {
                document.getElementById(r + "STR" + item_index).style.color = "yellow";
            }

            this.order_item.product_item_rate = i + 1;
        },
        submitReview: function submitReview() {
            var _this3 = this;

            this.order_item.data_processing_message = "";
            if (this.order_item.product_item_review == "" && this.order_item.product_item_rate == 0) {
                this.order_item.data_processing_message = "Please review and rate";
            } else {
                this.activate_processing();
                var payload = {
                    'product_reviewed_by': this.user.user_id,
                    'product_id': this.order_item.product_id,
                    'product_item_id': this.order_item.product_item_id,
                    'product_item_order_cost': this.order_item.order_item_total,
                    'product_review': this.order_item.product_item_review,
                    'product_rate': this.order_item.product_item_rate
                };
                service.addProductReview(this, payload).then(function (response) {
                    if (response.body.status == 201) {
                        _this3.deactivate_processing();
                    }
                }).catch(function (err) {});
            }
            this.componentOrderItemReviewKey++;
        },
        sendMessageToBroker: function sendMessageToBroker(broker) {
            var _this4 = this;

            this.activate_processing();
            this.data_processing_message = "";

            var payload = {
                request_agent_type: 12,
                request_module: 8,
                request_module_id: this.order.order_id,
                request_agent: broker.broker_ref,
                request_sender: this.user.user_id,
                request_message: this.user.user_name + " requested your Broker Services "
            };
            service.postAgentRequests(this, payload).then(function (response) {
                if (response.body.status == 201) {
                    var payload = {
                        message_module: 19,
                        message_module_id: 0,
                        message_recipient: broker.broker_ref_id,
                        message_sender: _this4.user.user_id,
                        message_message: _this4.user.user_name + " requested your Broker Services "
                    };
                    service.postMessages(_this4, payload).then(function (response) {
                        if (response.body.status == 201) {
                            _this4.data_processing_message = "Sent, Broker would reply";

                            _this4.deactivate_processing();
                        } else {
                            _this4.deactivate_processing();
                        }
                    }).catch(function (err) {
                        _this4.deactivate_processing();
                    });
                } else {
                    _this4.deactivate_processing();
                }
            }).catch(function (err) {
                _this4.deactivate_processing();
            });
        },
        getActiveBrokers: function getActiveBrokers() {
            var _this5 = this;

            service.getActiveBrokers(this).then(function (response) {
                if (response.body.status == 200) {
                    _this5.brokers = response.body.data;
                }
            }).catch(function (err) {});
        },
        setBrokerOrderPaymentData: function setBrokerOrderPaymentData() {
            this.show_empty_fields = false;
            var payment_data = {};
            if (this.user.user_email == undefined || this.user.user_phone == undefined || this.user.user_email == "" || this.user.user_phone == "") {
                this.show_empty_fields = true;
            } else {
                payment_data = {
                    payer_name: this.user.user_name,
                    payer_email: this.user.user_email,
                    payer_phone: this.user.user_phone,
                    payment_total_amount: this.broker_request.broker_request_fee,
                    payment_currency: "NGN",
                    payment_ref: this.broker_request.broker_request_ref,
                    payment_details: "Broker Agent Fee Payment For: " + this.broker_request.broker_request,
                    payment_processing_fee_status: 4,
                    payment_processing_fee: service.app_proc_fee_calc * this.broker_request.broker_request_fee,
                    payment_processing_fee_transaction_type: 4,
                    pay_transaction_type: 2,
                    payment_module: 22,
                    payment_module_id: this.broker_request_ref_no,
                    payment_data_index: 0,
                    payment_data_route: "orders",
                    payment_service_business: 0,
                    payment_sub_accounts: [],
                    payment_meta: []
                };
                this.show_empty_fields = false;
            }
            this.broker_request_payment_data = payment_data;
        }
    },
    created: function created() {
        document.title = "Orders" + " | " + service.app_name;

        localforage.removeItem("not_loggedin_processed_orders").then(function (value) {}).catch(function (err) {});
        if (this.$route.params.ordid != null) {
            this.show_all = false;
            this.show_single = true;
            this.is_new = true;
        }
        this.getActiveBrokers();
        this.preset();
    }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Buypoint',
    data: function data() {
        return {
            child_route_view: false,
            loading: false,
            loggedIn: false,
            user: {},
            sellpoint: {},
            set_gallery_banner_image: "",
            set_headers: {}
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        setSellpoint: function setSellpoint() {
            var _this = this;

            this.loading = true;
            service.getAppBusinessByUserName(this, service.business_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this.sellpoint = response.body.data;
                    document.title = _this.sellpoint.business_name + " | SP";

                    if (_this.sellpoint.business_banner_image == _this.default_banner_image || _this.sellpoint.business_banner_image == 'error') {
                        _this.set_gallery_banner_image = service.general_banner_image;
                    } else {
                        _this.set_gallery_banner_image = _this.sellpoint.business_banner_image;
                    }

                    if (_this.sellpoint.business_market_subscription_name == 'Bird Plan') {
                        _this.max_plan_lookbooks = 2;
                        _this.max_plan_lookbook_posts = 5;
                    }
                    if (_this.sellpoint.business_market_subscription_name == 'Mid Bird Plan') {
                        _this.max_plan_lookbooks = 10;
                        _this.max_plan_lookbook_posts = 50;
                    }
                    if (_this.sellpoint.business_market_subscription_name == 'Max Bird Plan') {
                        _this.max_plan_lookbooks = 50;
                        _this.max_plan_lookbook_posts = 50;
                        _this.can_add_product_lookbook = true;
                    }

                    _this.preset();
                    _this.loading = false;
                } else {
                    _this.business_load_error_msg = "Sorry, this Business Information could not be found.";
                }
            }).catch(function (err) {
                _this.loading = false;
            });
        }
    },

    created: function created() {
        if (this.$route.path == '/orders') {
            this.set_headers.name = 'Orders';
        }

        this.setSellpoint();
    }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Account_Template_index_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Account_Template_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Account_Template_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_rightsidebar_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_rightsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_templates_rightsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_leftsidebar_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_leftsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_templates_leftsidebar_vue__);







var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    props: {
        paymentdata: Object
    },
    watch: {
        paymentdata: function paymentdata(newVal, oldVal) {
            this.setPaymentDetails();
        }
    },

    data: function data() {
        return {
            user: {},
            payment_mode: 1,
            payment_message: "",
            payment_active_resolve_ref: "",
            payment_service_update_data_status: 0,
            payment_service_update_data: "",
            loading: false,
            action_loading: false,
            disable_btn: false
        };
    },


    components: {
        'component-account': __WEBPACK_IMPORTED_MODULE_3__Account_Template_index_vue___default.a,
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_4__components_templates_rightsidebar_vue___default.a,
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_5__components_templates_leftsidebar_vue___default.a
    },

    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },

    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == "reset-edit") {}
        },
        setMenuTabView: function setMenuTabView(view, attr1, attr2) {
            if (this.menu_tab_view[view] == true) {
                this.menu_tab_view = {};
                this.setComponent('reset-edit', '');
            } else {
                this.setComponent('reset-edit', '');
                this.menu_tab_view = {};
                this.menu_tab_view[view] = true;
            }
        },
        preset: function preset() {
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;
                    self.loading = false;
                } else {}
            });
        },
        setPaymentDetails: function setPaymentDetails() {},
        prepProcessPaymentSingle: function prepProcessPaymentSingle(payment_mode, payment_status) {
            var _this = this;

            this.activate_processing();
            var has_set_payment_ref = 0;
            var set_payment_mode = payment_mode;
            if (this.paymentdata.payment_transaction_type == 3) {
                set_payment_mode = 4;
            }
            var payload = {
                service_load: this.paymentdata.payment_service_payment_data.pay_set,
                service_user: this.user.user_id,
                service_payment_transaction_type: this.paymentdata.payment_transaction_type,
                service_total_amount: this.paymentdata.payment_total_amount,
                service_payment_mode: set_payment_mode,
                service_payment_by_payment_mode: payment_mode,
                service_is_part_payment: 0,
                service_payment_status: payment_status,
                service_active_payment_ref: this.payment_active_resolve_ref
            };

            service.preparePayments(this, payload).then(function (data) {
                if (data.body.status == 200 || data.body.status == 404) {
                    has_set_payment_ref = 1;
                    _this.paymentdata.payment_service_ref = data.body.data.data_ref;
                } else {
                    var paymode = data.body.data_active_payment_mode;
                    var paydata = data.body;
                    if (data.body.status == 409) {
                        if (data.body.data_active_gateway_payment_check == 1) {
                            _this.verifyServerRavePayment(payment_mode, paydata);
                        } else if (data.body.status == 409 && data.body.data_paid_status == 200) {
                            _this.resolveActivePayment(payment_mode, paydata);
                        }
                    } else {
                        _this.data_processing_message = "Sorry, could not update payment";
                    }
                }
                if (has_set_payment_ref == 1 && _this.paymentdata.payment_service_ref != '') {
                    _this.processPaymentSingle(payment_mode);
                }

                _this.payment_active_resolve_ref = "";
            }).catch(function (err) {
                if (err) {
                    _this.data_processing_message = "Sorry, could not process information";
                }

                _this.payment_active_resolve_ref = "";
            });
        },
        verifyServerRavePayment: function verifyServerRavePayment(payment_mode, paydata) {
            var _this2 = this;

            var payref = paydata.data_active_payment_service_ref;

            var payload = {
                call_url: "https://api.flutterwave.com/v3/transactions/" + payref + "/verify",
                call_method: "GET",
                call_header: ["Content-Type: application/json", "Authorization: FLWSECK-a235ea72184ac4d7c07ea2e356682cd7-X"]
            };
            service.verifyRavePayment(this, payload).then(function (response) {
                if (response.body.status === "success") {
                    if (response.body.data.amount === _this2.paymentdata.payment_total_amount) {
                        paydata.data_active_gateway_payment_check = "00";
                        paydata.data_active_gateway_payment_log_ref = payref;
                        _this2.resolveActivePayment(payment_mode, paydata);
                    }
                } else {
                    _this2.payment_active_resolve_ref = payref;

                    _this2.prepProcessPaymentSingle(payment_mode, 2);
                }
            }).catch(function (err) {
                if (err) {
                    _this2.data_processing_message = "Sorry, could not process information";
                }
            });
        },
        resolveActivePayment: function resolveActivePayment(payment_mode, payment_data) {
            this.paymentdata.payment_service_payment_data.active_payment_data = payment_data;
            this.paymentdata.payment_service_payment_data.active_payment_alert = 1;
            this.paymentdata.payment_service_payment_data.active_payment_ref = payment_data.data_active_payment_service_ref;

            this.processPaymentSingle(payment_mode);
        },
        processPaymentSingle: function processPaymentSingle(payment_mode) {
            this.activate_processing();
            var data = this.paymentdata;
            var paydata = {};

            paydata.payment_data = data;

            paydata.payer = {
                payerName: data.payer_name,
                payerEmail: data.payer_email,
                payerPhone: data.payer_phone
            };

            paydata.payment_total_amount = data.payment_total_amount;
            paydata.payment_currency = data.payment_currency;
            paydata.payment_ref = data.payment_service_ref;
            paydata.payment_details = data.payment_details;
            paydata.payment_transaction_type = data.payment_transaction_type;
            paydata.payment_transaction_module_id = data.payment_transaction_module_id;
            paydata.payment_data_index = data.payment_data_index;
            paydata.payment_data_route = data.payment_data_route;

            paydata.payment_subaccounts = data.payment_sub_accounts;

            paydata.payment_meta = data.payment_meta;

            var active_payment_alert = 0;
            this.paymentdata.payment_service_payment_by_payment_mode = 0;
            if (this.paymentdata.active_payment_alert && this.paymentdata.active_payment_alert == 1) {
                active_payment_alert = 1;
            }
            if (payment_mode == 1) {
                this.paymentdata.payment_service_payment_mode = 1;
                if (active_payment_alert == 1) {
                    this.updatePaymentSingle(this.paymentdata.active_payment_ref);
                } else {
                    this.updatePaymentSingle(paydata.payment_ref);
                }
            }

            if (payment_mode == 2) {
                this.paymentdata.payment_service_payment_mode = 2;
                if (active_payment_alert == 1) {
                    this.updatePaymentSingle(this.paymentdata.active_payment_ref);
                } else {
                    this.updatePaymentSingle(this.paymentdata.payment_service_ref);
                }
            }

            if (payment_mode == 3) {
                this.paymentdata.payment_service_payment_mode = 3;
                if (active_payment_alert == 1) {
                    this.updatePaymentSingle(this.paymentdata.active_payment_ref);
                } else {
                    this.updatePaymentSingle(this.paymentdata.payment_service_ref);
                }
            }

            if (payment_mode == 5) {
                this.paymentdata.payment_service_payment_mode = 5;
                if (active_payment_alert == 1) {
                    this.updatePaymentSingle(this.paymentdata.active_payment_ref);
                } else {
                    this.updatePaymentSingle(this.paymentdata.payment_service_ref);
                }
            }
        },
        processPaymentRavepay: function processPaymentRavepay(paydata) {
            var self = this;
            var x = getpaidSetup({
                PBFPubKey: service.ravepay_public_test,
                customer_email: paydata.payer.payerEmail,
                amount: paydata.payment_total_amount,
                customer_phone: paydata.payer.payerPhone,
                currency: paydata.payment_currency,
                payment_method: "both",
                txref: paydata.payment_ref,
                subaccounts: paydata.payment_subaccounts,
                meta: paydata.payment_meta,
                onclose: function onclose() {},
                callback: function callback(response) {
                    var txref = response.tx.txRef;
                    var tx_amount = response.tx.amount;
                    if (response.tx.chargeResponseCode == "00" || response.tx.chargeResponseCode == "0") {
                        self.updatePaymentSingle(txref);
                    } else {
                        self.payment_message = "Payment unsuccessfull. please try again or contact us";
                    }
                }
            });
        },
        updatePaymentSingle: function updatePaymentSingle(payment_service_ref) {
            var _this3 = this;

            var service_to_pay = {};
            var processing_fee_transaction_type = 0;

            service_to_pay = {};this.paymentdata.payment_service_payment_data.payment_services[0];
            if (Object(service_to_pay).length == 0) {
                service_to_pay = this.paymentdata.payment_service_payment_data.payment_services;
            }

            console.log(2312);console.log(this.paymentdata);
            if (this.paymentdata.payment_transaction_type == 3) {
                if (service_to_pay.order_processing_fee_status == 3) {
                    processing_fee_transaction_type = 2;
                    service_to_pay.processing_fee_transaction_type = processing_fee_transaction_type;
                    service_to_pay.processing_fee_transaction_amount = service_to_pay.order_processing_fee;
                }
                this.paymentdata.payment_service_payment_data.payment_manual_payment_to_agent = 0;
                if (service_to_pay.order_receive_manual_payment_by == 2) {
                    this.paymentdata.payment_service_payment_data.payment_manual_payment_to_agent = 1;
                }
            } else {
                if (service_to_pay.service_processing_fee_status == 3) {
                    processing_fee_transaction_type = 2;
                    service_to_pay.processing_fee_transaction_type = processing_fee_transaction_type;
                    service_to_pay.processing_fee_transaction_amount = service_to_pay.service_processing_fee;
                }
            }

            console.log(23114);console.log(this.paymentData);

            if (this.paymentdata.payment_transaction_type == 3) {
                this.paymentdata.payment_service_payment_by_payment_mode = this.paymentdata.payment_service_payment_mode;
                this.paymentdata.payment_service_payment_mode = 4;
            }

            console.log(23117);console.log(payment_service_ref);
            var payload = {
                payment_service_ref: payment_service_ref,
                payment_service_amount_paid: this.paymentdata.payment_total_amount,

                payment_service_payment_data: this.paymentdata.payment_service_payment_data,
                payment_service_mode: this.paymentdata.payment_service_payment_mode,
                payment_service_payment_by_payment_mode: this.paymentdata.payment_service_payment_by_payment_mode,
                payment_service_type: this.paymentdata.payment_sevice_type,

                payment_service_user_id: this.user.user_id,
                payment_service_processing_fee_transaction_type: processing_fee_transaction_type,
                payment_service_processing_fee_transaction_amount: service_to_pay.processing_fee_transaction_amount
            };
            var navi = this.$router;
            console.log(231112775522);console.log(payment_service_ref);
            if (payment_service_ref != "") {
                console.log(231113333);
                service.updatePayment(this, payload).then(function (data) {
                    if (data.body.status == 200 || data.body.status == 400) {
                        _this3.data_processing_message = "Payment Processed!";

                        if (_this3.paymentdata.payment_transaction_type == 3) {
                            if (data.body.data_pending_pay_status == 200) {
                                _this3.payment_service_update_data_status = 200;
                                _this3.payment_service_update_data = data.body.data_pending_pay_data;
                            }
                        }
                        _this3.deactivate_processing();
                    } else {
                        _this3.data_processing_message = "Sorry, could not update payment";
                        _this3.deactivate_processing();
                    }
                }).catch(function (err) {
                    if (err) {
                        _this3.data_processing_message = "Sorry, could not process information";
                        _this3.deactivate_processing();
                    }
                });
            } else {
                this.data_processing_message = "Something went wrong";
                this.deactivate_processing();
            }
        }
    },
    created: function created() {
        this.preset();
    }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__ = __webpack_require__(3);






var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CreateSellpoint',
    mixins: [__WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints: {},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error: false,
            group_isset: false,
            add_sellpoint: false,
            add_business: false,
            get_flag: false,
            loading: false,
            action_loading: false,

            validate_user_name_message: "",
            payment_successful_message: "",
            data_error_message: "",
            data_boarding_message: "",

            headerdata: {
                'name': 'Set Order'
            },

            reset_order: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a
    },
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        preset: function preset() {
            this.loading = true;

            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;

                    localforage.getItem(service.bdb_name, function (err, value) {
                        if (value != undefined) {
                            self.sellpoint = value;

                            self.setBusinessDetails();

                            self.getSellpointProducts();

                            self.setProduct();
                        } else {
                            self.loading = false;
                        }
                    });
                } else {
                    self.loading = false;
                    self.$router.push('/login');
                }
            });
        },
        setBusinessDetails: function setBusinessDetails() {
            var self = this;
            localforage.getItem(service.bbnksdb_name, function (err, value) {
                if (value != undefined) {
                    console.log(7654999);
                    self.sellpoint.business_bank_details = value;
                    self.business_bank_details = value;
                }
                self.loading = false;
            });

            localforage.getItem(service.bbdlsdb_name, function (err, value) {
                if (value != undefined) {
                    self.sellpoint.business_delivery_options = value;
                    self.business_delivery_locations = value;
                }
                self.loading = false;
            });

            this.getSellpointDetails(this.sellpoint.business_username);
        },
        setProduct: function setProduct() {
            var _this = this;

            this.loading = true;
            service.getProductSearch(this, this.$route.params.ref).then(function (response) {
                if (response.body.status == 200) {
                    _this.product = response.body.data;

                    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.product.product_images).length > 0) {
                        _this.product_display_image = _this.product.product_images[0];
                    } else {
                        _this.product_display_image.product_image = "";
                    }
                    _this.product_item = _this.product.product_items[0];
                    _this.product.product_price = _this.product_item.product_item_price;
                    if (_this.product.product_item_groups.length != 0) {
                        _this.product_item_group = _this.product.product_item_groups[0];
                    } else {
                        _this.product_item_group = [];
                    }

                    _this.getProductAddons(_this.product);

                    _this.product.selected_product_addons = [];
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.preset();

        this.getRavepayBanks();
    }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Account_Resources_commonfunctions_js__ = __webpack_require__(3);





var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'PlacedOrder',
    mixins: [__WEBPACK_IMPORTED_MODULE_3__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            headerdata: {
                'name': 'Placed Order'
            },

            set_view_box: '',
            order_item: {}
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        preset: function preset() {
            this.loading = true;

            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;

                    if (self.$route.params.ref && self.$route.params.ref != '') {
                        console.log(988 + '---' + self.$route.params.ref);
                        var payload = { ref: self.$route.params.ref };
                        self.getOrderDetails(payload);
                    }
                } else {
                    self.loading = false;
                    self.$router.push('/login');
                }
            });
        },
        setViewBox: function setViewBox(view) {
            this.setMenuTabInnerView('setOptions');

            this.set_view_box = view;
        },
        setRate: function setRate(item, rate) {
            this.order_item = item;
            this.order_item.product_item_rate = rate;

            for (var i = 1; i <= 5; i++) {
                if (i <= rate) {
                    document.getElementById('rate-' + i).style.display = 'none';
                    document.getElementById('rated-' + i).style.display = 'block';
                } else {
                    document.getElementById('rate-' + i).style.display = 'block';
                    document.getElementById('rated-' + i).style.display = 'none';
                }
            }
        },
        submitReview: function submitReview() {
            var _this = this;

            this.order_item.data_processing_message = "Please review and rate";
            if (this.order_item.product_item_rate < 0) {
                this.data_processing_message = "Please rate";
            } else {
                this.activate_processing();
                var payload = {
                    'product_reviewed_by': this.user.user_id,
                    'product_id': this.order_item.product_id,
                    'product_item_id': this.order_item.product_item_id,
                    'product_item_order_cost': this.order_item.order_item_total,
                    'product_review': this.order_item.product_item_review || '',
                    'product_rate': this.order_item.product_item_rate
                };
                service.addProductReview(this, payload).then(function (response) {
                    if (response.body.status == 201) {
                        _this.deactivate_processing();
                    }
                }).catch(function (err) {});
            }
            this.componentOrderItemReviewKey++;
        }
    },
    created: function created() {
        this.preset();
    }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Account_Resources_commonfunctions_js__ = __webpack_require__(3);





var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'PlacedOrders',
    mixins: [__WEBPACK_IMPORTED_MODULE_3__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            headerdata: {
                'name': 'Placed Order'
            }
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        preset: function preset() {
            this.loading = true;

            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;

                    self.getOrders(self.user.user_id);
                } else {
                    self.loading = false;
                    self.$router.push('/login');
                }
            });
        }
    },
    created: function created() {
        this.preset();
    }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__ = __webpack_require__(3);






var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CreateSellpoint',
    mixins: [__WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints: {},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error: false,
            group_isset: false,
            add_sellpoint: false,
            add_business: false,
            get_flag: false,
            loading: false,
            action_loading: false,

            validate_user_name_message: "",
            payment_successful_message: "",
            data_error_message: "",
            data_boarding_message: "",

            headerdata: {
                'name': 'Set Order'
            },

            reset_order: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a
    },
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        preset: function preset() {
            this.loading = true;

            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;

                    localforage.getItem(service.bdb_name, function (err, value) {
                        if (value != undefined) {
                            self.sellpoint = value;

                            self.setBusinessDetails();

                            self.getSellpointProducts();

                            self.setProduct();
                        } else {
                            self.loading = false;
                        }
                    });
                } else {
                    self.loading = false;
                    self.$router.push('/login');
                }
            });
        },
        setBusinessDetails: function setBusinessDetails() {
            var self = this;
            localforage.getItem(service.bbnksdb_name, function (err, value) {
                if (value != undefined) {
                    console.log(7654999);
                    self.sellpoint.business_bank_details = value;
                    self.business_bank_details = value;
                }
                self.loading = false;
            });

            localforage.getItem(service.bbdlsdb_name, function (err, value) {
                if (value != undefined) {
                    self.sellpoint.business_delivery_options = value;
                    self.business_delivery_locations = value;
                }
                self.loading = false;
            });

            this.getSellpointDetails(this.sellpoint.business_username);
        },
        setProduct: function setProduct() {
            var _this = this;

            this.loading = true;
            service.getProductSearch(this, this.$route.params.ref).then(function (response) {
                if (response.body.status == 200) {
                    _this.product = response.body.data;

                    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.product.product_images).length > 0) {
                        _this.product_display_image = _this.product.product_images[0];
                    } else {
                        _this.product_display_image.product_image = "";
                    }
                    _this.product_item = _this.product.product_items[0];
                    _this.product.product_price = _this.product_item.product_item_price;
                    if (_this.product.product_item_groups.length != 0) {
                        _this.product_item_group = _this.product.product_item_groups[0];
                    } else {
                        _this.product_item_group = [];
                    }

                    _this.getProductAddons(_this.product);

                    _this.product.selected_product_addons = [];
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.preset();

        this.getRavepayBanks();
    }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_commons__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_ProductList_vue__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_ProductList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_product_ProductList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_templates_rightsidebar_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_templates_rightsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_templates_rightsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_templates_leftsidebar_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_templates_leftsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_templates_leftsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_templates_searchbox_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_templates_searchbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_templates_searchbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_tools_settings_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_tools_settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_tools_settings_vue__);











var service = new __WEBPACK_IMPORTED_MODULE_2__services_service__["a" /* default */]();
var set = new __WEBPACK_IMPORTED_MODULE_3__services_commons__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            plan_user: {},
            plan_business: {},
            user: {},
            market: {},
            business: {},
            categories: {},
            subscriptions: {},
            business_service_categories: [],
            business_product_categories: [],
            business_category_type: 0,
            plan1: {},
            plan2: {},
            plan3: {},
            selected_plan: {},
            selected_plan_product_service_item: {},
            upgradable_plans: {},
            upgrade_business: "",
            upgrade_subscription: 0,
            current_subscription_product_service_item: 0,
            set_upgrade_plans: false,
            place_order: false,

            data_boarding_message: "",
            set_up_with_existing_account: false,
            set_up_with_new_account: false,
            set_up_business: false,
            validate_user_name_error: false,
            data_error_message: "",
            payment_successful: false,
            payment_successful_message: "",
            payment_payer_name: "",
            payment_payer_email: "",
            payment_payer_phone: "",
            payment_service: "",
            payment_ref: "",
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            action_loading: false,
            disable_btn: false,
            setup_error_message: "",
            newBusinessForm: false,
            product_service_items_select: "",
            set_upgrade_plan_process: false,

            header_data: {},
            set_purchase_process: false,
            picked_plan: {},
            user_businesses: {},
            selected_business: {},
            referral_code: '',
            order_details: '',
            order_coupon: '',
            order_amount: 0,
            order_amount_to_pay: 0,
            set_checkout: false
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_4__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_5__MainFooter_index_vue___default.a,
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_7__components_templates_rightsidebar_vue___default.a,
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_8__components_templates_leftsidebar_vue___default.a,
        'search-box': __WEBPACK_IMPORTED_MODULE_9__components_templates_searchbox_vue___default.a,
        'c-settings': __WEBPACK_IMPORTED_MODULE_10__components_tools_settings_vue___default.a
    },
    computed: {},
    methods: {
        setCurrency: function setCurrency(currency) {
            return set.formatCurrency(currency);
        },
        setComponent: function setComponent(attr1, attr2) {
            this.data_error_message = "";
            if (attr1 == 'setup-existing') {
                this.set_up_with_existing_account = true;
            }
            if (attr1 == 'not-setup-existing') {
                this.set_up_with_existing_account = false;
            }
            if (attr1 == 'show-new-business-form') {
                this.newBusinessForm = true;
            }
            if (attr1 == 'display-product_service_items') {
                var x = document.getElementById("productServiceItems");
                if (x.style.display === "none") {
                    x.style.display = "block";
                } else {
                    x.style.display = "none";
                }
            }
        },
        reset: function reset() {
            this.set_upgrade_plan_process = false;
            this.set_purchase_process = false;
            this.data_error_message = "";
        },
        toggleDisplayFeatures: function toggleDisplayFeatures() {
            var x = document.getElementById("seeFeatures");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        selectProductServiceItem: function selectProductServiceItem(item) {
            this.selected_plan_product_service_item = item;

            if (this.order_amount_to_pay > 0) {
                this.setProcessPurchase();
            }

            var x = document.getElementById("productServiceItems");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        preset: function preset() {
            this.loading = true;
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                    self.user.user_name = localStorage.getItem("sp_user");
                    self.loggedIn = true;
                    self.loading = false;

                    if (self.$route.query.upgrade) {
                        self.prepareUpgradePlans();
                    }
                } else {}
            });
        },
        getAppUserAndBusinessesDetails: function getAppUserAndBusinessesDetails() {
            if (this.user.user_id > 0) {
                var payload = {
                    user: this.user.user_id,
                    user_purchase_plan_product: this.selected_plan.product_id,
                    user_purchase_plan: this.selected_plan_product_service_item.product_item_id
                };
                this.checkUserDetailsForPurchase(payload, 0);
            }
        },
        setPurchase: function setPurchase() {
            this.set_purchase_process = true;

            var query_plan = this.$route.query.purchase;
            var query_plan_item = this.$route.query.item;
            var found = false;

            this.subscriptions.forEach(function (element) {
                if (element.product_url_name == query_plan) {
                    this.selected_plan = element;
                    if (query_plan_item != 'n') {
                        if (element.product_items[query_plan_item]) {
                            this.selected_plan_product_service_item = element.product_items[query_plan_item];
                        } else {
                            this.selected_plan_product_service_item = element.product_items[0];
                        }
                    } else {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(element.product_items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var pt = _step.value;

                                if (pt.product_item_service_tag == '1 year') {
                                    this.selected_plan_product_service_item = pt;
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }

                    found = true;

                    this.getAppUserAndBusinessesDetails();

                    this.loading = false;
                }
            }, this);

            if (!found) {
                this.setup_error_message = "Something went wrong with your selection, please pick another plan";
            }

            this.loading = false;
        },
        prepareUpgradePlans: function prepareUpgradePlans() {
            this.loading = true;
            if (this.plan_business.business_id > 0) {
                var navi = this.$router;
                var payload = {
                    subscriber_module: 3,
                    subscriber_module_id: this.plan_business.business_id,
                    subscription_module: 3,
                    subscription_module_id: 'APP'
                };
                service.setAppSubscriptionUpgradeDetails(this, payload).then(function (data) {
                    this.upgradable_plans = data.body.data;
                    this.upgrade_subscription = data.body.data_subscription;
                    this.current_subscription_product_service_item = data.body.data_subscription_current_subscription;
                    this.upgrade_business = this.$route.query.upgrade;

                    this.payment_payer_name = data.body.data_user_payment_details["user_name"];
                    this.payment_payer_email = data.body.data_user_payment_details["user_email"];
                    this.payment_payer_phone = data.body.data_user_payment_details["user_phone"];

                    this.set_upgrade_plans = true;
                    this.loading = false;
                });
            }
        },
        getSellpointMarket: function getSellpointMarket() {
            var _this = this;

            service.getBusinessByUserName(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this.market = response.body.data;

                    _this.getMarketMainProductsAsSubscriptions();

                    _this.loading = false;
                }
            }).catch(function (err) {
                _this.loading = true;
            });
        },
        getMarketMainProductsAsSubscriptions: function getMarketMainProductsAsSubscriptions() {
            var _this2 = this;

            service.getBusinessProducts(this, this.market.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.subscriptions = response.body.data;
                    _this2.plan1 = _this2.subscriptions[2];
                    _this2.plan2 = _this2.subscriptions[1];
                    _this2.plan3 = _this2.subscriptions[0];
                }

                if (_this2.$route.query.purchase) {
                    _this2.setPurchase();
                }
            }).catch(function (err) {});
        },
        purchase_plan_2: function purchase_plan_2(plan, plan_product_service_item_index) {
            this.loading = true;
            this.$router.push('/purchase/?purchase=' + plan.product_url_name + '&item=' + plan_product_service_item_index);
            this.setPurchase();

            var top = document.getElementById("topwrap").offsetTop;
            window.scrollTo(0, top);
        },
        purchase_plan: function purchase_plan(plan) {
            this.loading = true;
            this.selected_plan = plan;
            this.selected_plan_product_service_item = plan.product_items[0];
        },
        upgrade_plan: function upgrade_plan(plan) {
            this.loading = true;
            this.set_upgrade_plan_process = true;
            this.selected_plan = plan;
            this.selected_plan_product_service_item = plan.product_items[0];
            this.loading = false;
        },
        resetOptions: function resetOptions() {
            this.selected_plan = {};
            this.selected_plan_product_service_item = {}, this.total_price = 0;
            this.place_order = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        validateUserName: function validateUserName() {
            var _this3 = this;

            service.validateBusinessUserName(this, this.business).then(function (response) {
                if (response.body.status != 200) {
                    _this3.validate_user_name_error = true;
                    _this3.validate_user_name_message = "This username already exist";
                    _this3.deactivate_processing();
                }
            }).catch(function (err) {
                _this3.validate_user_name_error = true;
                _this3.validate_user_name_message = "This username already exist";
                _this3.deactivate_processing();
            });
        },
        getBusinessCategories: function getBusinessCategories() {
            service.getCategories(this).then(function (data) {
                this.categories = data.body.data;

                this.categories.forEach(function (element) {
                    if (element.category_type == 1) {
                        this.business_product_categories.push(element);
                    }
                    if (element.category_type == 2) {
                        this.business_service_categories.push(element);
                    }
                }, this);
            });
        },
        proceedUpgradePlan: function proceedUpgradePlan() {
            var found = false;
            this.selected_plan.product_items_upgrade_details.forEach(function (element) {
                if (this.selected_plan_product_service_item.product_item_id == element.subscription_new_product_item_id) {
                    this.selected_plan_product_service_item.product_item_price = element.subscription_new_product_total_amount_to_pay;
                    found = true;
                }
            }, this);

            if (found) {
                this.selected_business = this.plan_business;
                this.setProcessPayment();
            }
        },
        setUpWithAccount: function setUpWithAccount() {
            this.resetMessages();
            this.activate_processing();
            var payload = {
                user_email: this.user.user_email,
                user_password: this.user.user_password,
                user_purchase_plan: this.selected_plan_product_service_item.product_item_id
            };
            this.checkUserDetailsForPurchase(payload, 1);
        },
        checkUserDetailsForPurchase: function checkUserDetailsForPurchase(payload, shouldLogin) {
            payload.order_referral_code = this.referral_code;
            payload.order_coupon = this.order_coupon;

            service.checkUserDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    if (shouldLogin == 1) {
                        this.data_boarding_message = "Account verified...";
                        this.loginUser();
                    }

                    if (data.body.status_2 != 200) {
                        this.data_error_message = "Sorry, no business exist on this account";
                        this.deactivate_processing();
                    } else {
                        this.user_businesses = data.body.data.user_businesses;
                        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user_businesses).length == 1) {
                            this.selected_business = this.user_businesses[0];
                        }

                        this.order_amount = data.body.data_subscription_new_product_total_amount_to_pay;
                        this.order_amount_to_pay = this.order_amount;
                        this.selected_plan = data.body.data_subscription_selected_plan_details;

                        this.payment_payer_name = data.body.data.user_name;
                        this.payment_payer_email = data.body.data.user_email;
                        this.payment_payer_phone = data.body.data.user_phone;

                        this.deactivate_processing();
                    }
                } else {
                    this.data_error_message = "Sorry, Account does not exist";
                    this.deactivate_processing();
                }
            }).catch(function (err) {});
        },
        setProcessPurchase: function setProcessPurchase() {
            if (this.selected_plan.product_items_upgrade_details && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selected_plan.product_items_upgrade_details).length > 0) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.selected_plan.product_items_upgrade_details), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var details = _step2.value;

                        if (this.selected_plan_product_service_item.product_item_id == details.subscription_new_product_item_id) {
                            this.selected_plan_product_service_item.product_item_price = details.subscription_new_product_total_amount_to_pay;
                            this.order_amount = this.selected_plan_product_service_item.product_item_price;
                            this.order_amount_to_pay = this.order_amount;
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
        },
        setUpNewAccount: function setUpNewAccount() {
            this.activate_processing();
            var credentials = {
                user_name: this.payment_payer_name,
                user_phone: this.payment_payer_phone,
                user_email: this.payment_payer_email,
                user_address: '',
                user_state: '',
                user_city: '',
                user_password: this.user.user_password
            };

            var navi = this.$router;

            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var re_phone = /^\d{4}\d{3}\d{4}$/;

            var phone_test = false;
            var email_test = false;
            if (this.payment_payer_phone != '' || this.payment_payer_email != '') {
                if (this.payment_payer_phone != '') {
                    phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
                } else {
                    phone_test = true;
                }

                if (this.payment_payer_email != '') {
                    email_test = re.test(String(this.payment_payer_email).toLowerCase());
                } else {
                    email_test = true;
                }
            }


            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
                this.deactivate_processing();
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                if (credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null && credentials.user_email != null && credentials.user_password != null) {
                    service.regUser(this, credentials).then(function (data) {
                        if (data.body.status == 201) {
                            this.data_boarding_message = "Registration Successful...";

                            this.user.user_email = data.body.data.user_email;
                            this.user.user_password = data.body.data.user_password;
                            this.loginUser();

                            this.prepSetUpNewBusiness();
                        } else if (data.body.status == 409) {
                            this.data_error_message = "This User is already registered..";

                            this.deactivate_processing();
                        }
                    });
                } else {
                    this.data_error_message = "Kindly fill all fields...";

                    this.deactivate_processing();
                }
            }
        },
        setProcessPayment: function setProcessPayment() {
            var can_process = true;

            this.order_details = "eShop Subscription Order:  - " + this.selected_plan.product_name + "(₦" + this.order_amount + ")";
            if (this.set_up_with_existing_account) {
                if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user_businesses).length == 0) {
                    can_process = false;
                } else {
                    this.data_error_message = "No business selected !";
                    this.deactivate_processing();
                }
            }

            if (can_process) {
                if (this.selected_plan_product_service_item.product_item_price == 0) {
                    this.updatePayment("ref-free-account");
                } else {
                    var payload = {
                        order_user: this.user.user_id,
                        order_referral_code: this.referral_code,
                        order_product: this.selected_plan.product_id,
                        order_product_item: this.selected_plan_product_service_item.product_item_id,
                        order_amount: this.order_amount,
                        order_details: this.order_details,
                        order_coupon: this.order_coupon
                    };
                    service.makeAppSubscriptionOrder(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            this.payment_ref = data.body.data.data_payref;

                            this.order_amount_to_pay = data.body.data.data_order_amount_to_pay;

                            this.processPayment();
                        }
                    }).catch(function (err) {});
                }
            }
        },
        processPayment: function processPayment() {
            this.data_boarding_message = "Preparing Payment Information";

            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var re_phone = /^\d{4}\d{3}\d{4}$/;

            var phone_test = false;
            var email_test = false;

            if (this.payment_payer_phone != '') {
                phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            } else {
                phone_test = true;
            }

            if (this.payment_payer_email != '') {
                email_test = re.test(String(this.payment_payer_email).toLowerCase());
            } else {
                this.data_error_message = "Please enter your email address to make payment";
            }

            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                this.payment_service = this.order_details;
                var obj = this;

                var handler = PaystackPop.setup({
                    key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.payment_payer_name,

                    email: this.payment_payer_email,

                    amount: Math.round(this.order_amount_to_pay * 100),
                    ref: this.payment_ref,
                    metadata: {
                        custom_fields: [{
                            display_name: "eShop Subscription Order",
                            variable_name: "",
                            value: this.payment_payer_name + " - " + this.payment_payer_phone + " - ORDER - " + this.selected_plan.product_name
                        }, {
                            display_name: "Service",
                            variable_name: "service_type",
                            value: this.selected_plan.product_name
                        }]
                    },

                    callback: function callback(response) {
                        obj.updatePayment(response.trxref);
                    },
                    onClose: function onClose() {
                        alert('window closed');
                    }
                });
                handler.openIframe();
            }
        },
        updatePayment: function updatePayment(payment_ref) {
            var navi = this.$router;

            this.payment_successful = true;
            if (this.selected_plan_product_service_item.product_item_price != 0) {
                this.payment_successful_message = "Payment Successful...";
            }

            this.upgradePlan(payment_ref);
        },
        setUpNewAccountBusiness: function setUpNewAccountBusiness() {
            var _this4 = this;

            this.resetMessages();

            this.activate_processing();
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: service.market_app_name,
                business_layout: 1,
                business_subscription: service.market_app_default_plan };
            var navi = this.$router;
            if (this.validate_user_name_error) {
                this.data_error_message = "This Username already exists..";
                this.deactivate_processing();
            } else {
                if (credentials.business_name != undefined && credentials.business_category != undefined) {
                    service.addNewBusiness(this, credentials).then(function (data) {
                        if (data.body.status == 201) {
                            this.getAppUserAndBusinessesDetails();

                            this.data_boarding_message = "Sellpoint Creation Successful.";

                            this.newBusinessForm = false;
                        } else {
                            this.data_error_message = "This Username already exists";
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        if (err) {
                            _this4.data_error_message = "Something went wrong";

                            _this4.deactivate_processing();
                        }
                    });
                } else {
                    this.data_error_message = "Kindly fill all fields";

                    this.deactivate_processing();
                }
            }
        },
        prepSetUpNewBusiness: function prepSetUpNewBusiness() {
            var self = this;
            setTimeout(function () {
                self.set_up_business = true;
                self.data_boarding_message = " ";
                self.setComponent('show-new-business-form', '');
                self.deactivate_processing();

                var top = document.getElementById("banner").offsetTop;
                window.scrollTo(0, top);
            }, 3000);
        },
        setAsUpgradePlan: function setAsUpgradePlan() {
            if (this.selected_business.business_id > 0) {
                var navi = this.$router;
                var payload = {
                    subscriber_module: 3,
                    subscriber_module_id: this.selected_business.business_id,
                    subscription_module: 3,
                    subscription_module_id: 'APP',
                    subscription_selected_plan: this.selected_plan.product_id,

                    order_referral_code: this.referral_code,
                    order_coupon: this.order_coupon
                };
                service.setAppSubscriptionUpgradeDetails(this, payload).then(function (data) {
                    this.upgradable_plans = data.body.data;
                    this.upgrade_subscription = data.body.data_subscription;
                    this.current_subscription_product_service_item = data.body.data_subscription_current_subscription;
                    this.upgrade_business = this.selected_business.business_username;
                    this.selected_plan = data.body.data_subscription_selected_plan_details;

                    this.payment_payer_name = data.body.data_user_payment_details["user_name"];
                    this.payment_payer_email = data.body.data_user_payment_details["user_email"];
                    this.payment_payer_phone = data.body.data_user_payment_details["user_phone"];

                    this.set_checkout = true;
                });
            }
        },
        upgradePlan: function upgradePlan(payment_ref) {
            var _this5 = this;

            this.activate_processing();
            var credentials = {
                business_upgrade_subscription: this.upgrade_subscription,
                business_user_name: this.upgrade_business,
                business_group: service.market_app_name,
                business_group_token: service.apiToken,
                business_subscription: this.selected_plan_product_service_item.product_item_id,
                business_subscription_amount_paid: this.selected_plan_product_service_item.product_item_price,
                business_subscription_payment_ref: payment_ref,
                business_subscription_plan_upgrade_details: this.selected_plan.product_items_upgrade_details,
                business_current_subscription: this.current_subscription_product_service_item
            };

            var navi = this.$router;
            service.upgradeBusinessMarketSubscription(this, credentials).then(function (data) {
                if (data.body.status == 200) {
                    this.updateAppSubscriptionOrder();
                }
            }).catch(function (err) {
                if (err) {
                    _this5.data_error_message = "Something went wrong";
                    _this5.deactivate_processing();
                }
            });
        },
        updateAppSubscriptionOrder: function updateAppSubscriptionOrder() {
            var _this6 = this;

            var payload = {
                subscriber_module: 3,
                subscriber_module_id: this.selected_business.business_id,
                order_status: 15,
                order_payment_ref: this.payment_ref
            };
            var navi = this.$router;
            service.updateAppSubscriptionOrder(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    navi.push('/' + _this6.selected_business.business_username);
                }
            }).catch(function (err) {
                if (err.status == 404) {
                    toastr.warning("invalid login credentials", 'Warning!');

                    _this6.deactivate_processing();
                }
            });
        },
        loginUser: function loginUser() {
            var _this7 = this;

            var credentials = {
                user_email: this.user.user_email,
                user_password: this.user.user_password
            };
            service.loginUser(this, credentials).then(function (response) {
                if (response.body.status == 200) {
                    var data = response.body.data;
                    localStorage.setItem("sp_user", data.user_name);

                    var user_data = {
                        "user_name": data.user_name,
                        "sp_token": data.user_session_key,
                        "sp_token_key": data.user_token_key
                    };
                    var credentials = {
                        session_key: data.user_session_key
                    };

                    service.sessionGuard(_this7, credentials).then(function (response) {
                        if (response.body.status == 200) {
                            var _data = response.body.data;
                            _data.forEach(function (element) {
                                user_data.user_id = element.user_id;
                            }, _this7);
                            var self = _this7;
                            localforage.setItem(service.udb_name, user_data).then(function (value) {
                                self.preset();
                            }).catch(function (err) {});
                        } else {}
                        _this7.loading = false;
                    }).catch(function (err) {});
                }
            }).catch(function (err) {
                if (err.status == 404) {
                    toastr.warning("invalid login credentials", 'Warning!');

                    _this7.deactivate_processing();
                }
            });
        }
    },

    mounted: function mounted() {
        var top = document.getElementById("topwrap").offsetTop;
        window.scrollTo(0, top);
    },


    created: function created() {
        var refcode = localStorage.getItem('refcode');
        if (refcode != undefined && refcode != '') {
            this.referral_code = refcode;
        } else if (this.$route.params.ref && this.$route.params.ref != '') {
            this.referral_code = this.$route.params.ref;
            localStorage.setItem('refcode', this.referral_code);
        }

        var user_store = this.$store.getters['account/getUser'];
        var business_store = this.$store.getters['account/getUserBusiness'];
        if (user_store.user_id && user_store.user_id > 0 && business_store.business_id && business_store.business_id > 0) {
            this.plan_user = user_store;
            this.plan_business = business_store;
        }

        if (this.$route.query.upgrade) {
            this.set_upgrade_plans = true;
        }
        this.preset();
        this.getSellpointMarket();
        this.getBusinessCategories();
    }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_validation__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources_commons_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MainFooter_index_vue__);







var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();
var validator = new __WEBPACK_IMPORTED_MODULE_2__services_validation__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Register',
    mixins: [__WEBPACK_IMPORTED_MODULE_3__resources_commons_js__["a" /* default */]],
    data: function data() {
        return {
            users: {},
            user: {},
            states: {},
            cities: {},
            user_type: "bo",
            terms: false,
            disable_btn: false,
            loading: false,
            action_loading: false,
            data_processing_message: "",
            data_error_message: "",
            error_messages: {},
            know_terms: false,
            card_view: { 'card1': true },
            card_back_view: 0,
            action_checking: {},
            action_verified: {},
            formComponentKey: 0,
            form2ComponentKey: 0,

            set_headers: {},
            ref_code: "",
            group_ref_code: "",
            group_name: '',
            group_is_set: 0,
            redir: ''
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_4__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_5__MainFooter_index_vue___default.a
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        reset: function reset() {
            localStorage.removeItem("sp_user");
            localStorage.removeItem("sp_token");
            localStorage.removeItem("sp_token_key");
            localStorage.removeItem("sp_#_sellpoint");

            localforage.removeItem(service.udb_name).then(function (value) {}).catch(function (err) {});

            localforage.clear();
        },
        showTerms: function showTerms(action) {
            if (action) {
                this.know_terms = true;
            } else {
                this.know_terms = false;
            }
        },
        setCardGuide: function setCardGuide(card) {
            this.disable_btn = false;

            if (card == 'card1') {
                this.card_back_view = 'card1';
            } else if (card == 'card2') {
                this.card_back_view = 'card1';
            } else if (card == 'card3') {
                this.card_back_view = 'card2';
            }

            this.card_view = {};
            this.card_view[card] = true;
        },
        getStatesXX: function getStatesXX() {
            service.getStates(this).then(function (data) {
                this.states = data.body;
            });
        },
        getCitiesXX: function getCitiesXX(state) {
            service.getCities(this, state).then(function (data) {
                this.cities = data.body;
            });
        },
        validateEmailXX: function validateEmailXX() {
            this.error_messages.email = "";
            if (validator.validateEmail(this.user.email)) {
                this.validateData("user", "email");
            } else {
                this.error_messages.email = "Email is not validbbb";
            }

            this.formComponentKey++;
        },
        validatePhoneXX: function validatePhoneXX() {
            this.error_messages.phone = "";
            if (validator.validatePhoneNumber(this.user.phone)) {
                this.validateData("user", "phone");
            } else {
                this.error_messages.phone = "Phone Number is not valid";
                this.user.phone = "";
            }
            this.formComponentKey++;
        },
        validateUsernameXX: function validateUsernameXX() {
            this.error_messages.username = "";
            if (validator.validateString(this.user.username)) {
                this.validateData("user", "username");
            } else {
                this.error_messages.username = "Username is not valid";
            }
            this.form2ComponentKey++;
        },
        validateDataXX: function validateDataXX(data_type, data_attr) {
            this.disable_btn = true;
            var data_attr_value = '';
            if (data_attr == 'email') {
                data_attr_value = this.user.email;
                this.action_checking.email = true;
            } else if (data_attr == 'phone') {
                data_attr_value = this.user.phone;
            } else if (data_attr == 'username') {
                data_attr_value = this.user.username;
            }
            this.action_checking[data_attr] = true;
            var credentials = {
                data_type: data_type,
                data_attr: data_attr,
                data_attr_value: data_attr_value
            };
            service.validateDataExist(this, credentials).then(function (data) {
                if (data.body.status == 200) {
                    this.action_checking[data_attr] = false;
                    this.action_verified[data_attr] = true;
                    this.data_validated = true;
                } else {
                    this.action_checking[data_attr] = false;
                    this.error_messages[data_attr] = data.body.message;
                }
                this.formComponentKey++;
                this.disable_btn = false;
            });
            this.formComponentKey++;
        },
        reg_step_01: function reg_step_01() {
            this.disable_btn = true;
            this.user.agree = true;
            var credentials = {
                user_name: this.user.name,
                user_phone: this.user.phone,
                user_email: this.user.email
            };

            var navi = this.$router;
            var validated = false;
            this.validateEmail(this.user.email);
            this.validatePhone(this.user.phone);
            if (this.data_validated) {
                if (validator.validateString(this.user.name)) {
                    if (credentials.user_phone != undefined || credentials.user_email != undefined || credentials.user_phone != undefined && credentials.user_email != undefined) {
                        if (credentials.user_email != undefined && !validator.validateEmail(this.user.email)) {
                            this.error_messages.email = 'Email is not correct';
                        } else {
                            this.error_messages.email = '';
                            validated = true;
                        }

                        if (credentials.user_phone != undefined && !validator.validatePhoneNumber(this.user.phone)) {
                            this.error_messages.phone = 'Phone is not correct';
                        } else {
                            this.error_messages.phone = '';
                            validated = true;
                        }
                        if (validated) {
                            if (this.terms) {
                                this.setCardGuide('card2');
                                this.disable_btn = false;
                                this.data_validated = false;
                            } else {
                                this.error_messages.terms = 'Please agree to Terms';
                                this.disable_btn = false;
                            }
                        } else {
                            this.disable_btn = false;
                        }
                    } else {
                        this.error_messages.email = 'Please enter either email or phone number or both';
                        this.disable_btn = false;
                    }
                } else {
                    this.data_error_message = 'Kindly fill all fields';
                    this.disable_btn = false;
                }
            }
        },
        reg_step_02: function reg_step_02() {
            this.disable_btn = true;


            var navi = this.$router;
            if (this.data_validated) {
                if (validator.validateString(this.user.username) && validator.validateString(this.user.password)) {
                    this.regfinale();
                } else {
                    this.data_error_message = 'Kindly fill all fields';
                    this.disable_btn = false;
                }
            } else {
                this.error_messages.username = "Username is not valid";
                this.disable_btn = false;
            }
        },
        regfinale: function regfinale() {
            var _this2 = this;

            this.terms_error_message = "";
            this.disable_btn = true;

            var credentials = {
                user_name: this.user.name,
                user_username: this.user.username || '',
                user_phone: this.user.phone || '',
                user_email: this.user.email || '',
                user_address: this.user.address || '',
                user_state: this.user.state || '',
                user_city: this.user.city || '',
                user_password: this.user.password,
                user_ref_code: this.ref_code,
                user_group_ref_code: this.group_ref_code
            };

            var navi = this.$router;
            if (validator.validateString(this.user.username) && validator.validateString(this.user.password)) {
                this.loading = true;
                service.regUser(this, credentials).then(function (data) {
                    var _this = this;

                    if (data.body.status == 201) {
                        this.data_processing_message = "Account Created";

                        if (data.body.data.user_email != '') {
                            var credentials = {
                                user_email: data.body.data.user_email,
                                user_password: data.body.data.user_password
                            };
                        } else if (data.body.data.user_phone != '') {
                            var credentials = {
                                user_detail: data.body.data.user_phone,
                                user_password: data.body.data.user_password
                            };
                        } else {
                            this.data_error_message = "invalid login credentials";
                            this.disable_btn = false;
                            navi.push("login");
                        }

                        service.loginUser(this, credentials).then(function (response) {
                            if (response.body.status == 200) {
                                var _data = response.body.data;

                                var self = _this;
                                localStorage.setItem("sp_user", _data.user_name);
                                var user_data = {
                                    "user_name": _data.user_name,
                                    "user_id": _data.user_id,
                                    "sp_token": _data.user_session_key,
                                    "sp_token_key": _data.user_token_key
                                };
                                localforage.setItem(service.udb_name, user_data).then(function (value) {
                                    if (self.redir != '') {
                                        navi.push(redir);
                                    } else {
                                        self.setCardGuide("card3");
                                    }
                                }).catch(function (err) {});
                            }
                        }).catch(function (err) {
                            if (err.status == 404) {
                                _this.data_error_message = "invalid login credentials";
                                _this.disable_btn = false;
                            }
                        });
                    } else if (data.body.status == 409) {
                        this.data_error_message = "You already have a Sellpoint Account, please log in with this email or username";

                        setTimeout(function () {
                            navi.push("login?u=connect");
                        }, 3000);
                        this.disable_btn = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this2.data_error_message = "Something went wrong";
                        _this2.disable_btn = false;
                    }
                    _this2.disable_btn = false;
                });
            } else {
                this.data_error_message = 'Kindly fill all fields';
                this.disable_btn = false;
                this.form2ComponentKey++;
            }
        },
        doDynamicRedirectsDirects: function doDynamicRedirectsDirects() {
            var self = this;

            localforage.getItem(service.adr_db_name, function (err, value) {
                if (value != undefined) {
                    self.$router.push(value.link);
                } else {
                    self.setCardGuide("card3");
                }
            });
        }
    }, 'doDynamicRedirectsDirects', function doDynamicRedirectsDirects() {
        var self = this;

        localforage.getItem(service.adr_db_name, function (err, value) {
            if (value != undefined) {
                self.redir = value.link;
            } else {
                self.redir = "/";
            }
        });
    }),
    created: function created() {
        if (this.$route.params.ref != undefined && this.$route.params.ref != '') {
            this.ref_code = this.$route.params.ref;
        }

        var refcode = localStorage.getItem('refcode');
        var grefcode = localStorage.getItem('grefcode');

        if (refcode != undefined && refcode != '') {
            this.ref_code = refcode;
        }

        if (grefcode != undefined && grefcode != '') {
            this.group_ref_code = grefcode;
            this.group_is_set = true;
        }

        if (localStorage.getItem('group') != '' || localStorage.getItem('group') != undefined) {
            this.group_name = localStorage.getItem('group');
        }
    }

});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_searchbox_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_searchbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_templates_searchbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_activeproducts_vue__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_activeproducts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_activeproducts_vue__);








var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Search',
    data: function data() {
        return {
            user: {},
            products: {},
            product: {},
            search_data: "",
            loggedIn: false
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue___default.a,
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue___default.a,
        'search-box': __WEBPACK_IMPORTED_MODULE_5__components_templates_searchbox_vue___default.a,
        'active-products': __WEBPACK_IMPORTED_MODULE_6__components_widgets_activeproducts_vue___default.a
    },
    methods: {
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        getSearchProducts: function getSearchProducts() {
            var _this2 = this;

            service.searchProducts(this, this.$route.query.k).then(function (response) {
                if (response.body.status == 200) {
                    _this2.products = response.body.data;
                    _this2.search_data = _this2.$route.query.k;
                }
            }).catch(function (err) {});
        },
        getBusinessSearchProducts: function getBusinessSearchProducts() {
            var _this3 = this;

            service.searchBusinessProducts(this, this.$route.query.k).then(function (response) {
                if (response.body.status == 200) {
                    _this3.products = response.body.data;
                    _this3.search_data = _this3.$route.query.k;
                }
            }).catch(function (err) {});
        },
        getCategorySearchProducts: function getCategorySearchProducts() {
            var _this4 = this;

            service.searchCategoryProducts(this, this.$route.query.s, this.$route.query.k).then(function (response) {
                if (response.body.status == 200) {
                    _this4.products = response.body.data;
                    _this4.search_data = response.body.data_search;
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.preset();
        if (this.$route.query.search == "business") {
            this.getBusinessSearchProducts();
        } else if (this.$route.query.search == "product") {
            this.getSearchProducts();
        } else if (this.$route.query.s) {
            this.getCategorySearchProducts();
        }
    }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_ProductForm_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_ProductForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_product_ProductForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_product_ProductItemForm_vue__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_product_ProductItemForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_product_ProductItemForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_product_ProductCartActions_vue__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_product_ProductCartActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_product_ProductCartActions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_activeshoptogether_vue__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_activeshoptogether_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_widgets_activeshoptogether_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__resources_utility__ = __webpack_require__(63);




var _methods;












var service = new __WEBPACK_IMPORTED_MODULE_3__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Product',
    props: ['productItem'],
    mixins: [__WEBPACK_IMPORTED_MODULE_10__resources_utility__["a" /* default */]],
    data: function data() {
        var _ref;

        return _ref = {
            user: {},
            loggedIn: false,
            cart: this.$store.state.cart,
            sellpoint: {},
            categories: {},
            main_category: {},
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            sub_categories: [],
            product: {},
            details: {},
            reviews: {},
            information: {},
            states: {},
            cities: {},
            related_products: {},
            delivery_option: {},
            discount_coupon: {},
            product_item_group: {},
            product_item: {},
            sellpoint_categories: {},
            seller_mode: false,
            can_edit: false,
            edit_mode: false,
            disable_btn: false,
            setPanel: false,
            other_delivery_option: false,
            edit_other_delivery_option: false,
            edit_city: false,
            editProductPanel: false,
            addProductItemPanel: false,
            editProductItemPanel: false,
            removeItemPanel: false,
            editProductItemGroupPanel: false,
            removeItemGroupPanel: false,
            removeProductPanel: false,
            product_details_descr: true,
            product_details_reviews: false,
            product_details_information: false,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            setProductDeliveryInformation: false,
            setDiscount: false,
            editDiscount: false,
            img_product_url: service.imageProductsURL,
            img_user_url: service.imageUsersURL,
            siteUrl: "",
            is_product_in_cart: false,
            loading: false,
            copied: false,
            descr_active: 'active',
            user_type: "buyer",
            new_added: false,
            product_display_image: {},
            action_loading: false,
            product_is_ready_to_cart: false,
            product_item_selected: [],
            product_item_group_selected: [],
            data_cart_message: "",
            data_cart_group_message: "",
            data_cart_item_message: "",
            product_set_shipping_fee_status: 12,
            set_shipping_fee_status_track: false,
            check_order_quantity: "",

            product_addon: {},
            product_addon_item: {},
            product_addon_item_group: {},

            tab_view: {},
            menu_tab_view: {},
            menu_tab_inner_view: {},
            product_item_quantity_key: 0,
            share_url: "",
            share_text: ""
        }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'related_products', ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'product_ref_link', ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'order_data', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'setproductAddonKey', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'cta_add_to_cart', 1), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'cta_buy_now', 2), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'cta_donate_to_buy', 3), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'product_component', [1, "product", "set-product", "PR"]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'product_item_component', [2, "product_item", "product-item", "PRT"]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'product_item_group_component', [3, "product_item_group", "product-item-group", "PRTG"]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'product_addon_component', [4, "product_addon", "product-addon", "PRAD"]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'product_addon_item_component', [5, "product_addon_item", "product-addon-item", "PRADT"]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'product_addon_item_group_component', [6, "product_addon_Item_group", "product-addon-item-group", "PRADTG"]), _ref;
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_4__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_5__MainFooter_index_vue___default.a,
        'product-form': __WEBPACK_IMPORTED_MODULE_6__components_product_ProductForm_vue___default.a,
        "product-item-form": __WEBPACK_IMPORTED_MODULE_7__components_product_ProductItemForm_vue___default.a,
        'add-to-cart-button': __WEBPACK_IMPORTED_MODULE_8__components_product_ProductCartActions_vue___default.a,

        'share-shop-together': __WEBPACK_IMPORTED_MODULE_9__components_widgets_activeshoptogether_vue___default.a
    },
    computed: {},

    methods: (_methods = {
        back: function back() {
            this.$router.push("/" + this.product.product_business_ownername);
        },
        redir: function redir(rlink) {
            location.replace("/" + rlink);
        },
        copyLinkXX: function copyLinkXX() {
            this.$clipboard(this.siteUrl);
            this.copied = true;
        },
        copyLink: function copyLink(link, id) {
            this.$clipboard(link);
            this.copied = true;
            document.getElementById(id).style.display = "block";
        },
        numFormat: function numFormat(str) {

            return str.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        },
        mobileSideNavToggle: function mobileSideNavToggle(action) {
            if (action == "open") {
                document.getElementById("mobileSideNav").style.width = "300px";
            }
            if (action == "close") {
                document.getElementById("mobileSideNav").style.width = "0";
            }
        },
        setMenuTabView: function setMenuTabView(view) {
            this.menu_tab_view = {};
            this.menu_tab_view[view] = true;
        },
        setMenuTabInnerView: function setMenuTabInnerView(view, attr1, attr2) {
            this.setComponent('reset-edit', '');
            this.menu_tab_inner_view = {};
            this.menu_tab_inner_view[view] = true;
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        openModal: function openModal(id) {
            document.getElementById(id).style.display = "block";
        },
        closeModal: function closeModal(id) {
            document.getElementById(id).style.display = "none";
        },
        setAddToWishlist: function setAddToWishlist(item) {
            this.wishlist_product = item;
            this.addToWishlist();
        },
        addQuantity: function addQuantity(qty) {
            if (this.product_item.product_item_order_quantity == undefined) {
                this.product_item.product_item_order_quantity = 1;
            } else {
                this.product_item.product_item_order_quantity++;
            }
            this.product_item_quantity_key++;
            this.checkOrderQuantity(qty);
        },
        removeQuantity: function removeQuantity(qty) {
            if (this.product_item.product_item_order_quantity != 1) {
                this.product_item.product_item_order_quantity--;
                this.product_item_quantity_key++;
                this.checkOrderQuantity(qty);
            }
        },
        checkOrderQuantity: function checkOrderQuantity(qty) {
            if (this.product_item_selected.product_item_price > 0 && this.product_item.product_item_order_quantity != 0) {
                if (Number(qty) > this.product_item.product_item_quantity) {
                    this.check_order_quantity = "The quantity you entered is above Item Quantity";
                    this.product_is_ready_to_cart = false;
                    this.data_cart_message = "The quantity you entered is above Item Quantity";
                } else {
                    this.checkWholesalePrices();

                    this.check_order_quantity = "";
                    this.product_is_ready_to_cart = true;
                    this.data_cart_message = "";
                }
            } else {
                this.check_order_quantity = "";
            }
        },
        checkWholesalePrices: function checkWholesalePrices() {
            if (this.product.product_has_wholesale_options) {
                if (this.product_item.product_item_actual_mapped_price != 0) {
                    this.product_item.product_item_price = this.product_item.product_item_actual_mapped_price;
                }

                var checked_moqs = [];var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.product_item.product_item_moqs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var moq = _step.value;

                        if (!checked_moqs.includes(moq.product_item_moq_id)) {
                            if (Number(Number(this.product_item.product_item_order_quantity) >= moq.product_item_moq)) {
                                this.product_item.product_item_price = moq.product_item_moq_price;
                                this.product_item.product_item_price_f = this.numFormat(this.product_item.product_item_price);
                            }
                        }
                        checked_moqs.push(moq.product_item_moq_id);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                this.checkDiscountsByQuantity();
            }
        },
        checkDiscountsByQuantity: function checkDiscountsByQuantity() {
            this.product_item.product_item_total_discount = 0;
            if (this.product_item.product_item_actual_price != 0) {
                this.product_item.product_item_price = this.product_item.product_item_actual_price;
            }

            var total_discount = 0;var calc_discount = 0;var product_item_discount_price = 0;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.product_item.product_item_discounts), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var dc = _step2.value;

                    if (Number(Number(this.product_item.product_item_order_quantity) >= dc['discount_min_quantity'])) {
                        if (dc['discount_status_id'] == 5 && dc['discount_coupon'] == 'D') {
                            total_discount += Number(Number(dc['discount_percentage']));
                        }
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            if (total_discount != 0) {
                this.product_item.product_item_actual_price = this.product_item.product_item_price;
                calc_discount = total_discount / 100 * this.product_item.product_item_price;
                product_item_discount_price = this.product_item.product_item_price - calc_discount;
                this.product_item.product_item_total_discount = total_discount;
                this.product_item.product_item_price = product_item_discount_price;
                this.product_item.product_item_price_f = this.numFormat(product_item_discount_price);
            } else {
                this.product_item.product_item_price_f = this.numFormat(this.product_item.product_item_price);
            }
        },
        trackevent: function trackevent(e) {
            if (e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined) {
                this.category_type_2 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined) {
                this.category_type_1 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined) {
                this.category_type_1 = true;
                this.category_type_2 = true;
            } else {
                this.category_type_1 = false;
                this.category_type_2 = false;
                this.category_type_3 = true;
            }
        },
        setTabComponent: function setTabComponent(view) {
            this.tab_view = {};
            this.tab_view[view] = true;
        },
        setComponent: function setComponent(attr1, attr2, component_set) {
            this.setPanel = true;
            if (attr1 == 'edit-product') {
                this.editProductPanel = true;
            }
            if (attr1 == 'remove-product') {
                this.removeProductPanel = true;
            }
            if (attr1 == 'add-product-item') {
                this.addProductItemPanel = true;
            }
            if (attr1 == 'edit-product-item') {
                this.editProductItemPanel = true;
            }
            if (attr1 == 'set-edit-product-item') {
                this.product_item = attr2;
                this.editProductItemPanel = true;
            }
            if (attr1 == 'remove-product-item') {
                this.product_item = attr2;
                this.removeItemPanel = true;
            }
            if (attr1 == 'edit-product-item_group') {
                this.product_item_group = attr2;
                this.editProductItemGroupPanel = true;
            }
            if (attr1 == 'remove-product-item_group') {
                this.product_item_group = attr2;
                this.removeItemGroupPanel = true;
            }
            if (attr1 == 'set-product-item-group-image') {
                this.setProductItemGroupImage(attr1, attr2, component_set);
            }
            if (attr1 == 'edit-product-detail') {
                this.details.edit_product_detail = false;
                this.details = attr2;
                this.details.edit_product_detail = true;
            }
            if (attr1 == 'edit-product-delivery') {
                this.details.edit_product_delivery = false;
                this.details = {};
                this.details.edit_product_delivery = true;
            }
            if (attr1 == 'add-delivery-option') {
                this.addDeliveryInformation = true;
            }
            if (attr1 == 'set-product-delivery-option') {
                this.delivery_option.edit_set = false;
                this.setProductDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
            }
            if (attr1 == 'edit-delivery-option') {
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;

                this.getCities(this.delivery_option.business_delivery_state, 'edit');
            }
            if (attr1 == 'set-product-item') {
                this.check_order_quantity = "";
                this.data_cart_message = '';

                this.product_item = attr2;
                this.product_item_selected = attr2;

                var itms = document.getElementsByClassName('product-item');
                for (var i = 0; i < itms.length; i++) {
                    itms[i].style = "border:none;";
                }

                if (attr2.product_item_size != "Nill" && attr2.product_item_size != "") {
                    document.getElementById(attr2.product_item_id + "PRT").style = "border:1px solid #0000CC;";
                }

                this.data_cart_item_message = '';
                this.data_cart_message = '';
                this.prep_set_product_is_ready_to_cart();
            }
            if (attr1 == 'set-product-item-group') {
                this.check_order_quantity = "";
                this.data_cart_message = '';

                this.product_item_group = attr2;
                this.product_item_group_selected = attr2;

                this.product_display_image = [];
                this.product_display_image.product_image = attr2.product_item_group_image;

                this.product_is_ready_to_cart = false;
                this.product_item_selected = [];

                var itms = document.getElementsByClassName('product-item');
                for (var i = 0; i < itms.length; i++) {
                    itms[i].style = "border:none;";
                }

                var grps = document.getElementsByClassName('product-item-group');
                for (var i = 0; i < grps.length; i++) {
                    grps[i].style.border = "none";
                }

                document.getElementById(attr2.product_item_group_id + "PRTGR").style.border = "1px solid #0000CC";

                this.data_cart_group_message = '';

                if (attr2.product_items[0].product_item_size == "Nill" || attr2.product_items[0].product_item_size == "") {
                    this.setComponent('set-product-item', attr2.product_items[0]);
                } else {
                    if (this.product.product_service == 'P') {
                        this.data_cart_item_message = "please select";
                    } else {
                        this.data_cart_item_message = "please select";
                    }
                }
            }
            if (attr1 == 'set-product-display-image') {
                this.product_display_image = attr2;
            }
            if (attr1 == 'set-descr') {
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails', ''));

                this.product_details_descr = true;
                this.product_details_reviews = false;
                this.product_details_information = false;
                window.location.hash = "";
            }
            if (attr1 == 'set-reviews') {
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails', ''));
                this.descr_active = '';
                this.product_details_reviews = true;
                this.product_details_descr = false;
                this.product_details_information = false;
            }
            if (attr1 == 'set-information') {
                this.descr_active = '';
                this.product_details_information = true;
                this.product_details_reviews = false;
                this.product_details_descr = false;
            }
            if (attr1 == 'set-discount') {
                this.setDiscount = true;
                this.editDiscount = false;
            }
            if (attr1 == 'edit-discount') {
                this.editDiscount = true;
                this.setDiscount = false;
                this.discount_coupon = attr2;
            }
            if (attr1 == 'reset-edit') {
                this.addProductItemPanel = false;
                this.editProductPanel = false;
                this.editProductItemPanel = false;
                this.removeItemPanel = false;
                this.editProductItemGroupPanel = false;
                this.removeItemGroupPanel = false;
                this.removeProductPanel = false;
                this.addDeliveryInformation = false;
                this.editDeliveryInformation = false;
                this.delivery_option.edit_set = false;
                this.setDiscounts = false;
                this.editDiscount = false;
            }
            var self = this;

            setTimeout(function () {
                self.action_loading = false;
            }, 2000);
        },
        setComponentActions: function setComponentActions(attr1, attr2) {
            if (attr1 == 'reset-edit') {
                this.details = {};
            }
        },
        preset: function preset() {
            this.loading = true;
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                    self.user.user_name = value.user_name;
                    self.is_editing();
                    self.sellpoint.business_id = self.product.product_business_id;
                    self.loggedIn = true;
                    self.loading = false;
                } else {
                    self.loading = false;
                }
            });
        },
        is_editing: function is_editing() {
            var _this = this;

            var payload = {
                validate_user: this.user.user_id,
                validate_business: this.sellpoint.business_id
            };
            service.can_edit(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this.seller_mode = true;
                    _this.edit_mode = true;
                    _this.can_edit = true;
                } else {
                    _this.edit_mode = false;
                    _this.seller_mode = false;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        switchMode: function switchMode() {
            if (this.edit_mode == false) {
                this.is_editing();
            } else {
                this.edit_mode = false;
                this.can_edit = true;
            }
        },
        getStates: function getStates() {
            var _this2 = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this2.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state, option) {
            var _this3 = this;

            if (option == "edit") {
                this.edit_city = true;
            } else {
                this.edit_city = false;
            }
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this3.cities = response.body.data;
                }
            }).catch(function (err) {});
        },
        setOtherOptions: function setOtherOptions(v, o) {
            if (v != undefined) {
                if (v == "other") {
                    this.other_delivery_option = true;
                    if (o == "edit") {
                        this.edit_other_delivery_option = true;
                    }
                }
                if (v == "all") {
                    this.delivery_option.business_delivery_other_option = "nill";
                    if (o == "edit") {
                        this.edit_other_delivery_option = false;
                    }
                    this.other_delivery_option = false;
                }
            }
        },
        set_data_messages: function set_data_messages(data, action) {
            if (this.product.product_service == 'P') {
                if (action == 'set') {
                    if (data == 'product-item') {}
                }
                if (action == 'unset') {}
            } else {}
        },
        prep_set_product_is_ready_to_cart: function prep_set_product_is_ready_to_cart() {
            if (this.product_item_selected.length != 0) {
                this.product_is_ready_to_cart = true;
            } else {
                this.data_cart_message = "make a selection before you proceed";
                if (this.product_item_group_selected.length != 0) {
                    if (this.product.product_service == 'P') {
                        this.data_cart_item_message = "please select";
                    } else {
                        this.data_cart_item_message = "please select";
                    }
                } else {
                    if (this.product.product_service == 'P') {
                        this.data_cart_group_message = "please select";
                    } else {
                        this.data_cart_group_message = "please select";
                    }
                }
            }
        },
        isEmpty: function isEmpty(obj) {
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) return false;
            }
            return true;
        },
        set_product_is_ready_to_cart: function set_product_is_ready_to_cart() {
            if (this.product.product_set_groups <= 1 && this.product.product_set_items <= 1) {
                this.product_item_selected = this.product_item;
                this.product_item_group_selected = this.product_item_group;
                this.product_is_ready_to_cart = true;
            }
        },
        setProduct: function setProduct() {
            var _this4 = this;

            this.loading = true;
            service.getProductSearch(this, this.$route.params.id1).then(function (response) {
                if (response.body.status == 200) {
                    _this4.product = response.body.data;
                    _this4.setProductRelationships();
                    document.title = _this4.product.product_name + " | " + _this4.product.product_business_name + " | SP";

                    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this4.product.product_images).length > 0) {
                        _this4.product_display_image = _this4.product.product_images[0];
                    } else {
                        _this4.product_display_image.product_image = "";
                    }
                    _this4.product_item = _this4.product.product_items[0];
                    if (_this4.product.product_item_groups.length != 0) {
                        _this4.product_item_group = _this4.product.product_item_groups[0];
                    } else {
                        _this4.product_item_group = [];
                    }

                    _this4.product_set_shipping_fee_status = _this4.product.product_set_shipping_fee_status;

                    _this4.product.selected_product_addons = [];

                    _this4.set_product_is_ready_to_cart();

                    _this4.siteUrl = service.siteUrl + "?p=" + _this4.product.product_url_name + "&p1=" + _this4.product.product_business_ownername + "&p2=" + _this4.product.product_url_name + "&p3=" + encodeURI(_this4.product.product_name) + "&p4=" + encodeURI(_this4.product.product_description) + "&p5=" + _this4.product_item.product_item_image + " ";

                    _this4.product.product_share_url = "http://sellpoints.com.ng/" + _this4.product.product_business_ownername + "/" + _this4.product.product_url_name;
                    _this4.loading = false;

                    _this4.preset();

                    _this4.setRelatedProducts(_this4.product.product_business_id);

                    _this4.getCategories(_this4.product.product_business_category_id);

                    _this4.getSellpointCategories();

                    _this4.check_in_cart();
                }
            }).catch(function (err) {});
        },
        setProductAddOn: function setProductAddOn(product_addon) {
            this.product_addon = product_addon;
            this.product_addon.selected = false;
            this.product_addon_item = product_addon.product_items[0];
            this.product_addon_item_group = product_addon.product_item_groups[0];
        },
        setSelectedProductAddOns: function setSelectedProductAddOns() {
            var set_product_addon = [];

            var added = false;
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.product.selected_product_addons).length > 0) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.product.product_selected_product_addons), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var addon = _step3.value;

                        if (addon.product_id == this.product_addon.product_id) {
                            added = true;
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
            if (!added) {
                this.product_addon.selected = true;
                this.product_addon.product_order_addon_to = this.product.product_id;
                set_product_addon.productMain = this.product_addon;
                set_product_addon.productItemGroup = this.product_addon_item_group;
                set_product_addon.productItem = this.product_addon_item;

                this.product.selected_product_addons.push(set_product_addon);
            }
            this.setproductAddonKey++;
        },
        removeFromProductAddOns: function removeFromProductAddOns() {},
        setProductRelationships: function setProductRelationships() {
            var _this5 = this;

            localStorage.removeItem("REF-" + this.product.product_url_name);
            if (this.$route.params.ref0) {
                localStorage.setItem("REF-" + this.product.product_url_name, this.$route.params.ref0);
            }

            var payload = {
                product: this.product.product_id,
                business: this.product.product_business_id,
                business_agent_username: this.$route.params.id
            };
            service.setProductAgentShip(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this5.product.product_agent_ship = response.body.data_product_agent_ship;
                }
            }).catch(function (err) {});
        },
        setProductViewOptions: function setProductViewOptions(component_set, attr) {
            var type = component_set[0];
            if (type == 1) {
                this.product = attr;
            } else if (type == 1) {
                this.product = attr;
            }
        },
        setProductItemGroupImage: function setProductItemGroupImage(attr1, attr2, component_set) {
            attr1.product_item_group_image = attr2;
            var imgs = document.getElementsByClassName('product-item-group-image');
            for (var i = 0; i < imgs.length; i++) {
                imgs[i].style = "border:none;";
            }
            document.getElementById(attr2 + "PRTG").style.border = "1px solid #0000CC";

            this.setProductViewOptions(component_set, attr1);
        },
        getCategories: function getCategories(category) {
            var _this6 = this;

            service.getMainCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this6.categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSubCategories: function getSubCategories(category) {
            if (category != undefined) {
                this.sub_categories = category.sub_categories;
            } else {
                this.sub_categories = [];
            }
        },
        check_in_cart: function check_in_cart() {
            this.cart.forEach(function (element) {
                if (element.product_item_id == this.product_item.product_item_id) {
                    this.is_product_in_cart = true;
                }
            }, this);
        }
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'numFormat', function numFormat(str) {
        return str.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'setProductCustomPrice', function setProductCustomPrice() {
        if (this.product_item.product_item_order_custom_set_price > 0) {
            var total_discount = this.product_item.product_item_total_discount;
            if (total_discount > 0) {
                var calc_discount = 0;
                calc_discount = total_discount / 100 * this.product_item.product_item_order_custom_set_price;

                this.product_item.product_item_price = this.product_item.product_item_order_custom_set_price - calc_discount;
            } else {
                this.product_item.product_item_price = this.product_item.product_item_order_custom_set_price;
            }

            this.product_item.product_item_price_f = this.numFormat(this.product_item.product_item_price);

            this.product_item.product_item_order_custom_set_price_type = 36;
        }
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'setRelatedProducts', function setRelatedProducts() {
        var _this7 = this;

        var payload = {
            business: this.product.product_business_id,
            category: this.product.product_category_id,
            product: this.product.product_id,
            limit: 4,
            user_search: []
        };
        service.setRelatedProducts(this, payload).then(function (response) {
            if (response.body.status == 200) {
                _this7.related_products = response.body.data;
            }
        }).catch(function (err) {});
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'setReferralBash', function setReferralBash() {
        var _this8 = this;

        var set_ref_for = this.product.product_business_id;
        if (this.product.product_agent_ship.product_business_agent_id > 0) {
            if (this.product.product_agent_ship.product_business_agent_type == 20) {
                set_ref_for = this.product.product_agent_ship.product_business_agent_id;
            }
        }
        var payload = {
            ref_user: this.user.user_id,
            ref_of_type: 17,
            ref_of: this.product.product_id,
            ref_for: set_ref_for
        };
        service.setReferralBash(this, payload).then(function (response) {
            var product_ref_bash = response.body.data_ref_bash;
            if (product_ref_bash && product_ref_bash != "") {
                _this8.product_ref_link = service.app_url + _this8.$route.params.id + "/" + _this8.product.product_url_name + "/" + product_ref_bash;
            }
            console.log(_this8.product_ref_link);
        }).catch(function (err) {});
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'getProductImages', function getProductImages() {
        var _this9 = this;

        service.getProductImages(this, this.product.product_id).then(function (response) {
            if (response.body.status == 200) {
                _this9.product.product_images = response.body.data;
                _this9.product_display_image = _this9.product.product_images[0];
            }
        }).catch(function (err) {});
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'deleteProductImage', function deleteProductImage(image) {
        service.deleteProductImage(this, image).then(function (data) {
            if (data.body.status == 200) {
                this.getProductImages();
            }
        }).catch(function (err) {});
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'editProduct', function editProduct() {
        var _this10 = this;

        this.activate_processing();

        var set_product_category = this.product.product_category_id;
        if (this.product.product_sub_category != undefined || this.product.product_listed_category != undefined) {
            set_product_category = 0;
        } else {
            if (this.product.product_category != undefined) {
                set_product_category = this.product.product_category;
            } else {
                set_product_category = this.product.product_category_id;
            }
        }
        var credentials = {
            product_id: this.product.product_id,
            product_name: this.product.product_name,

            product_category: set_product_category,
            product_sub_category: this.product.product_sub_category || 0,
            product_listed_category: this.product.product_listed_category || "nill",


            product_url_name: this.product.product_url_name,
            product_description: this.product.product_description || "nill",
            product_business: this.product.product_business_id };

        var navi = this.$router;
        if (credentials.product_name != undefined) {
            service.editProduct(this, this.product.product_id, credentials).then(function (response) {
                if (response.body.status == 200) {
                    _this10.editProductPanel = false;
                    _this10.product = response.body.data;
                    navi.push("/" + _this10.product.product_business_ownername + "/" + _this10.product.product_url_name);
                } else {
                    _this10.editProductPanel = false;
                    _this10.deactivate_processing();
                }
            }).catch(function (err) {
                if (err) {
                    _this10.editProductPanel = false;
                    _this10.deactivate_processing();
                }
            });
        } else {
            this.disable_btn = false;
        }
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'editProductItem', function editProductItem() {
        var _this11 = this;

        this.activate_processing();
        var credentials = {
            product_item_id: this.product_item.product_item_id,
            product_item_price: this.product_item.product_item_price,
            product_item_weight: this.product_item.product_item_weight || 1,
            product_item_size: this.product_item.product_item_size || "Nill",
            product_item_service_tag: this.product_item.product_item_service_tag || "Nill",
            product_item_quantity: this.product_item.product_item_quantity || 1
        };

        var navi = this.$router;
        if (credentials.product_item_price != undefined) {
            service.editProductItem(this, this.product_item.product_item_id, credentials).then(function (response) {
                if (response.body.status == 200) {
                    _this11.product_item = response.body.data;
                    _this11.deactivate_processing();
                    _this11.editProductItemPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this11.deactivate_processing();
                }
            });
        } else {
            this.deactivate_processing();
        }
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'editProductItemGroup', function editProductItemGroup() {
        var _this12 = this;

        this.activate_processing();
        var product_item_group_is_color_image = 'IMG';
        if (this.product_item_group.product_item_group_color == undefined) {
            product_item_group_is_color_image = 'IMG';
        } else {
            product_item_group_is_color_image = 'COL';
        }

        if (this.product_item_group.product_item_group_color_new != undefined) {
            product_item_group_is_color_image = 'COL';
            this.product_item_group.product_item_group_color = this.product_item_group.product_item_group_color_new;
            this.product_item_group.product_item_group_image = 0;
        } else {
            product_item_group_is_color_image = 'IMG';
            this.product_item_group.product_item_group_color = "Nill";
        }
        var credentials = {
            product_item_group_product: this.product.product_id,
            product_item_group_name: this.product_item_group.product_item_group_name || "Type",
            product_item_group_is_color_image: product_item_group_is_color_image,
            product_item_group_color: this.product_item_group.product_item_group_color || "Nill",
            product_item_group_image: this.product_item_group.product_item_group_image || 0
        };

        var navi = this.$router;
        if (credentials.product_item_group_name != undefined) {
            service.editProductItemGroup(this, this.product_item_group.product_item_group_id, credentials).then(function (response) {
                if (response.body.status == 200) {

                    _this12.product.product_item_groups = response.body.data;

                    _this12.deactivate_processing();
                    _this12.editProductItemGroupPanel = false;
                } else {
                    _this12.deactivate_processing();
                    _this12.editProductItemGroupPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this12.deactivate_processing();
                }
            });
        } else {
            this.deactivate_processing();
        }
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'removeProduct', function removeProduct() {
        var _this13 = this;

        this.disable_btn = true;
        var payload = {
            product_id: this.product.product_id
        };
        var navi = this.$router;
        service.removeProduct(this, this.product.product_id, payload).then(function (response) {
            if (response.body.status == 200) {
                _this13.redir(_this13.$route.params.id1);

                _this13.removeProductPanel = false;
            }
        }).catch(function (err) {
            if (err) {
                _this13.disable_btn = false;
                _this13.redir(_this13.$route.params.id1);
            }
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'removeProductItem', function removeProductItem() {
        var _this14 = this;

        this.activate_processing();
        var payload = {
            product_id: this.product.product_id,
            product_item_id: this.product_item.product_item_id
        };
        var navi = this.$router;
        service.removeProductItem(this, this.product_item.product_item_id, payload).then(function (response) {
            if (response.body.status == 200) {
                if (response.body.no_product) {
                    _this14.redir(_this14.$route.params.id);
                }
                _this14.product.product_item_groups = response.body.data;

                _this14.deactivate_processing();
                _this14.removeItemPanel = false;
            }
        }).catch(function (err) {
            if (err) {
                _this14.deactivate_processing();
            }
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'removeProductItemGroup', function removeProductItemGroup() {
        var _this15 = this;

        this.activate_processing();
        var payload = {
            product_id: this.product.product_id,
            product_item_group_id: this.product_item_group.product_item_group_id
        };
        var navi = this.$router;
        service.removeProductItemGroup(this, this.product_item_group.product_item_group_id, payload).then(function (response) {
            if (response.body.status == 200) {
                if (response.body.no_product) {
                    _this15.redir(_this15.$route.params.id);
                }
                _this15.product.product_item_groups = response.body.data;
                _this15.deactivate_processing();
                _this15.removeItemGroupPanel = false;
            }
        }).catch(function (err) {
            if (err) {
                _this15.deactivate_processing();
            }
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'addProductDetail', function addProductDetail() {
        var _this16 = this;

        this.activate_processing();
        var payload = {
            product_detail: this.details.new_product_detail || "nill",
            product_id: this.product.product_id
        };
        service.addProductDetail(this, payload).then(function (data) {
            if (data.body.status == 201) {
                this.product.product_details = data.body.data;
                this.details = {};
                this.deactivate_processing();
            } else {
                this.deactivate_processing();
            }
        }).catch(function (err) {
            _this16.details = {};
            _this16.deactivate_processing();
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'editProductDetail', function editProductDetail() {
        var _this17 = this;

        this.details.product_id = this.product.product_id;
        service.editProductDetail(this, 1, this.details).then(function (data) {
            if (data.body.status == 200) {
                this.product.product_details = data.body.data;
            }
        }).catch(function (err) {
            _this17.service = {};
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'deleteProductDetail', function deleteProductDetail(details) {
        var _this18 = this;

        var payload = {
            product_detail_id: details.product_detail_id
        };
        service.deleteProductDetail(this, details.product_detail_id, payload).then(function (data) {
            if (data.body.status == 200) {
                this.product.product_details = data.body.data;
            }
        }).catch(function (err) {
            _this18.service = {};
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'setProductDelivery', function setProductDelivery() {
        var payload = {
            product_id: this.product.product_id,
            product_delivery_details: this.product.product_delivery_returns
        };
        service.setProductDelivery(this, 1, payload).then(function (data) {
            if (data.body.status == 200) {
                this.details = {};

                this.details.edit_product_delivery = false;
            }
        }).catch(function (err) {});
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'setProductShippingFeeStatus', function setProductShippingFeeStatus() {
        this.set_shipping_fee_status_track = true;
        this.activate_processing();
        var payload = {
            product_id: this.product.product_id,
            product_set_shipping_fee_status: this.product_set_shipping_fee_status
        };
        service.setProductShippingFeeStatus(this, payload).then(function (data) {
            if (data.body.status == 200) {
                this.product.product_set_shipping_fee_status = this.product_set_shipping_fee_status;
                this.set_shipping_fee_status_track = false;
                this.deactivate_processing();
            }
        }).catch(function (err) {});
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'addProductReview', function addProductReview() {
        var _this19 = this;

        var payload = {
            product_reviewed_by: this.user.user_id || 1,
            product_review: this.reviews.review || "nill",
            product_id: this.product.product_id
        };
        service.addProductReview(this, payload).then(function (data) {
            if (data.body.status == 201) {
                this.product.product_reviews = data.body.data;
                this.reviews = {};
            }
        }).catch(function (err) {
            _this19.reviews = {};
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'getProductInformation', function getProductInformation() {
        var _this20 = this;

        service.getProductInformation(this, this.product.product_id).then(function (response) {
            if (response.body.status == 200) {
                _this20.product.product_information = response.body.data;
            }
        }).catch(function (err) {});
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'addProductInformation', function addProductInformation() {
        var _this21 = this;

        var payload = {
            product_info_detail: this.information.product_info_detail || "nill",
            product_info_type: "text",
            product_id: this.product.product_id
        };
        if (payload.product_information != "nill") {
            service.addProductInformation(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    this.product.product_information = data.body.data;
                    this.information = {};
                }
            }).catch(function (err) {
                _this21.details = {};
            });
        }
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'editProductInformation', function editProductInformation() {
        var _this22 = this;

        this.details.product_id = this.product.product_id;
        service.editProductInformation(this, 1, this.details).then(function (data) {
            if (data.body.status == 200) {
                this.product.product_details = data.body.data;
            }
        }).catch(function (err) {
            _this22.service = {};
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'deleteProductInformation', function deleteProductInformation(details) {
        var _this23 = this;

        var payload = {
            product_detail_id: details.product_detail_id
        };
        service.deleteProductDetail(this, details.product_detail_id, payload).then(function (data) {
            if (data.body.status == 200) {
                this.product.product_details = data.body.data;
            }
        }).catch(function (err) {
            _this23.service = {};
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'setProductDeliveryOption', function setProductDeliveryOption() {
        var _this24 = this;

        this.activate_processing();
        var payload = {
            business_id: this.sellpoint.business_id,
            business_product_id: this.product.product_id,
            business_product_delivery_fee: this.delivery_option.product_delivery_fee || 0,
            business_delivery_option_id: this.delivery_option.business_delivery_option_id
        };
        if (payload.business_product_delivery_option_price == 0) {
            toastr.warning("Delivery Charge not Added", 'Warning!');
        } else {
            if (payload.business_product_delivery_option != 0) {
                service.setProductDeliveryOption(this, payload).then(function (data) {
                    if (data.body.status == 200 || data.body.status == 201) {
                        this.product.product_business_delivery_options = data.body.data;
                        this.delivery_option.edit_set = false;
                        this.setProductDeliveryInformation = false;

                        this.deactivate_processing();
                    } else {
                        this.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this24.delivery_option.edit_set = false;
                    _this24.setProductDeliveryInformation = false;
                    _this24.deactivate_processing();
                });
            } else {
                this.deactivate_processing();
            }
        }
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'deleteDeliveryFee', function deleteDeliveryFee(id) {
        var _this25 = this;

        var payload = {
            business_id: this.sellpoint.business_id,
            business_delivery_product: this.product.product_id
        };
        service.deleteDeliveryOption(this, id, payload).then(function (data) {
            if (data.body.status == 200) {
                this.product.product_delivery_options = data.body.data;
                this.delivery_option.edit_set = false;
                this.delivery_option = {};
            }
        }).catch(function (err) {
            _this25.delivery_option = {};
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'addDeliveryOption', function addDeliveryOption() {
        var _this26 = this;

        var payload = {
            business_delivery_state: this.delivery_option.state,
            business_delivery_city: this.delivery_option.city || 0,
            business_delivery_other_option: this.delivery_option.delivery_other_option || "nill",
            business_delivery_option_price: this.delivery_option.delivery_option_price || 0,
            business_delivery_product: this.product.product_id,
            business_id: this.sellpoint.business_id
        };
        if (payload.business_delivery_option_price == 0) {
            toastr.warning("Delivery Charge not Added", 'Warning!');
        } else {
            if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                service.addDeliveryOption(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        this.product.product_delivery_options = data.body.data;
                        this.delivery_option = {};
                        this.addDeliveryInformation = false;
                    }
                }).catch(function (err) {
                    _this26.delivery_option = {};
                });
            } else {
                toastr.warning("Select a delivery option", 'Warning!');
            }
        }
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'editDeliveryOption', function editDeliveryOption() {
        var _this27 = this;

        var payload = {
            business_id: this.sellpoint.business_id,
            business_delivery_product: this.product.product_id,
            business_delivery_state: this.delivery_option.business_delivery_state,
            business_delivery_city: this.delivery_option.city || 0,
            business_delivery_other_option: this.delivery_option.business_delivery_other_option || "nill",
            business_delivery_option_price: this.delivery_option.business_delivery_option_price || 0,
            business_delivery_option_id: this.delivery_option.business_delivery_option_id
        };

        if (payload.business_delivery_option_price == 0) {
            toastr.warning("Delivery Charge not Added", 'Warning!');
        } else {
            if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                service.editDeliveryOption(this, payload).then(function (data) {
                    if (data.body.status == 200) {
                        this.product.product_delivery_options = data.body.data;
                        this.delivery_option.edit_set = false;
                        this.editDeliveryInformation = false;
                    }
                }).catch(function (err) {
                    _this27.delivery_option.edit_set = false;
                    _this27.editDeliveryInformation = false;
                });
            } else {}
        }
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'deleteDeliveryOption', function deleteDeliveryOption(id) {
        var _this28 = this;

        var payload = {
            business_id: this.sellpoint.business_id,
            business_delivery_product: this.product.product_id
        };
        service.deleteDeliveryOption(this, id, payload).then(function (data) {
            if (data.body.status == 200) {
                this.product.product_delivery_options = data.body.data;
                this.delivery_option.edit_set = false;
                this.delivery_option = {};
            }
        }).catch(function (err) {
            _this28.delivery_option = {};
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'setDiscountsAndCoupons', function setDiscountsAndCoupons() {
        var payload = {
            business_id: this.sellpoint.business_id,
            product_item_id: this.product_item.product_item_id,
            is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'D',
            coupon_business_category: 0,
            coupon_percentage: this.discount_coupon.discount_percentage,
            coupon_start_date: this.discount_coupon.discount_start_date,
            coupon_end_date: this.discount_coupon.discount_end_date
        };
        service.setDiscountsAndCoupons(this, payload).then(function (data) {
            if (data.body.status == 201) {
                toastr.success("New Discount Set", 'Update!');
                this.sellpoint.business_discounts_coupons = data.body.data;
                this.setDiscount = false;
            }
        }).catch(function (err) {});
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'editDiscountsAndCoupons', function editDiscountsAndCoupons() {
        this.discount_coupon.business_id = this.sellpoint.business_id;
        service.editDiscountsAndCoupons(this, this.discount_coupon).then(function (data) {
            if (data.body.status == 200) {
                this.editDiscount = false;
            }
        }).catch(function (err) {});
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'deactivateDiscountsAndCoupons', function deactivateDiscountsAndCoupons(payload) {
        payload.business_id = this.sellpoint.business_id;
        service.deactivateDiscountsAndCoupons(this, payload).then(function (data) {
            if (data.body.status == 200) {
                payload.discount_status_id = 6;
            }
        }).catch(function (err) {});
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'onFileChange', function onFileChange(e, type, data_id) {
        var _this29 = this;

        var files = e.target.files || e.dataTransfer.files;
        if (files.length) {
            var formData = new FormData();
            formData.append('photo', files[0]);
            formData.append('data_id', data_id);
            formData.append('data_type', type);


            this.imageForm = formData;
            service.uploadDataPhoto(this, formData).then(function (data) {
                if (data.body.status == 200) {
                    if (type == "products") {
                        _this29.getProductImages();
                        if (_this29.editProductItemGroupPanel) {
                            _this29.product_item_group.product_item_group_image = data.body.data_id;
                        }
                    }

                    if (type == "product_information") {
                        _this29.getProductInformation();
                    }
                }
            }).catch(function (err) {
                if (err) {}
            });
        }
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'getSellpointCategories', function getSellpointCategories() {
        var _this30 = this;

        service.getBusinessByUserName(this, this.product.product_business_ownername).then(function (response) {
            if (response.body.status == 200) {
                var sellpoint = response.body.data;
                service.getBusinessCategories(_this30, sellpoint.business_id).then(function (response) {
                    if (response.body.status == 200) {
                        _this30.sellpoint_categories = response.body.data;
                    }
                }).catch(function (err) {});
            }
        }).catch(function (err) {});
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'handleScrollFix', function handleScrollFix(event) {
        var x = document.getElementById("menuHeader");

        var isMobile = false;
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
            isMobile = true;
        }
        if (isMobile) {
            if (document.documentElement.scrollTop >= 300) {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        }
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'toggleSumBrief', function toggleSumBrief() {
        var sumBrief1 = document.getElementById("sumBrief1");
        var sumBrief2 = document.getElementById("sumBrief2");
        if (sumBrief1.style.display == "none") {
            sumBrief2.style.display = "none";
            sumBrief1.style.display = "block";
        } else {
            sumBrief1.style.display = "none";
            sumBrief2.style.display = "block";
        }
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'toggleSection', function toggleSection(id) {
        var section = document.getElementById(id);
        if (section.style.display == "none") {
            section.style.display = "block";
        } else {
            section.style.display = "none";
        }
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'showCartOptions', function showCartOptions() {
        var sumBrief = document.getElementById("sumBrief");
        var cartOptions = document.getElementById("cartOptions");

        if (cartOptions.style.display == "none") {
            sumBrief.style.display = "none";
            cartOptions.style.display = "block";
        } else {
            sumBrief.style.display = "block";
            cartOptions.style.display = "none";
        }
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'addToPurchaseList', function addToPurchaseList(product_item) {
        if (product_item.product_item_order_quantity == undefined || product_item.product_item_order_quantity == 0) {
            product_item.product_item_order_quantity = 1;
        }

        product_item.product_business_id = this.product.product_business_id;
        product_item.product_name = this.product.product_name;
        product_item.product_id = this.product.product_id;

        var self = this;
        var purchase_items = [];var ids = [];
        localforage.getItem("purchase_list", function (err, value) {
            console.log(788557888);console.log(value);
            if (value != undefined) {
                console.log(113237888);console.log(purchase_items);
                purchase_items = value;


                if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(value).length == 0) {
                    console.log(666788557888);

                    purchase_items.push(item);
                } else {
                    console.log(211888);
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(value), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var _item = _step4.value;

                            ids.push(_item.product_item_id);
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }

                    if (!ids.includes(product_item.product_item_id)) {
                        console.log(88221888);

                        purchase_items.push(product_item);
                    }
                }

                localforage.setItem("purchase_list", purchase_items).then(function (value) {
                    console.log(99788);console.log(value);
                }).catch(function (err) {});
            } else {
                console.log(3237888);

                purchase_items.push(product_item);
                localforage.setItem("purchase_list", purchase_items).then(function (value) {}).catch(function (err) {});
            }
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'setMakePaymentOrder', function setMakePaymentOrder(mode) {
        this.order_data.order_business = this.product.product_business_id;
        this.order_data.order_items = [];
        this.order_data.order_user_details = {};
        this.order_data.order_details = [], this.order_data.order_details.push(this.product.product_name);
        if (!this.loggedIn) {
            this.order_user_details = {
                name: "kkl",
                email: "kk77@webnigeria.com.ng"
            };
        }

        if (mode == 1) {
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.product.product_items).length == 1) {
                if (this.product_item.product_item_order_quantity == undefined || this.product_item.product_item_order_quantity == 0) {
                    this.product_item.product_item_order_quantity = 1;
                }

                this.product_item.product_business_id = this.product.product_business_id;
                this.product_item.product_name = this.product.product_name;
                this.product_item.product_id = this.product.product_id;

                this.order_data.order_items.push(this.product_item);
            } else {
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.product.product_items), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var _item2 = _step5.value;

                        if (_item2.product_item_order_quantity > 0) {
                            this.order_data.order_items.push(_item2);
                        }
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }
            }

            this.makePaymentOrder();
        } else if (mode == 2) {
            var self = this;
            localforage.getItem("purchase_list", function (err, value) {
                if (value != undefined) {
                    var sort_product_items = [];
                    var sort_product_names = [];
                    var sort_product_businesses = [];
                    var sorted_order_businesses = [];
                    var sorted_items = [];

                    var _iteratorNormalCompletion6 = true;
                    var _didIteratorError6 = false;
                    var _iteratorError6 = undefined;

                    try {
                        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(value), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                            var _item3 = _step6.value;

                            if (_item3.product_item_order_quantity > 0) {
                                console.log(11);

                                sort_product_items.push(_item3);

                                if (!sorted_items.includes(_item3.product_item_id)) {
                                    console.log(1122);

                                    if (!sort_product_businesses.includes(_item3.product_business_id)) {
                                        console.log(1133);

                                        var b_load = {
                                            business_id: _item3.product_business_id,
                                            order_items: [],
                                            order_product_names: []
                                        };
                                        b_load.order_items.push(_item3);
                                        b_load.order_product_names.push(_item3.product_name);

                                        sorted_order_businesses.push(b_load);
                                        sort_product_businesses.push(_item3.product_business_id);
                                    } else {
                                        var b_count = 0;
                                        var _iteratorNormalCompletion8 = true;
                                        var _didIteratorError8 = false;
                                        var _iteratorError8 = undefined;

                                        try {
                                            for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(sorted_order_businesses), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                                                var business = _step8.value;

                                                if (business.business_id == _item3.product_business_id) {
                                                    if (sorted_order_businesses[b_count].order_items) {
                                                        sorted_order_businesses[b_count].order_items.push(_item3);
                                                    } else {
                                                        sorted_order_businesses[b_count].order_items = [];
                                                        sorted_order_businesses[b_count].order_items.push(_item3);
                                                    }

                                                    if (!sorted_order_businesses[b_count].order_product_names.includes(_item3.product_name)) {
                                                        sorted_order_businesses[b_count].order_product_names.push(_item3.product_name);
                                                    }
                                                }
                                                b_count++;
                                            }
                                        } catch (err) {
                                            _didIteratorError8 = true;
                                            _iteratorError8 = err;
                                        } finally {
                                            try {
                                                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                                                    _iterator8.return();
                                                }
                                            } finally {
                                                if (_didIteratorError8) {
                                                    throw _iteratorError8;
                                                }
                                            }
                                        }
                                    }

                                    sorted_items.push(_item3.product_item_id);
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError6 = true;
                        _iteratorError6 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                _iterator6.return();
                            }
                        } finally {
                            if (_didIteratorError6) {
                                throw _iteratorError6;
                            }
                        }
                    }

                    var _iteratorNormalCompletion7 = true;
                    var _didIteratorError7 = false;
                    var _iteratorError7 = undefined;

                    try {
                        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(sorted_order_businesses), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                            var sort = _step7.value;

                            self.order_data = {};
                            self.order_data.order_business = sort.business_id;
                            self.order_data.order_items = sort.order_items;
                            self.order_data.order_details = sort.order_product_names;

                            console.log(50098);
                            console.log(self.order_data);
                            self.makePaymentOrder();
                        }
                    } catch (err) {
                        _didIteratorError7 = true;
                        _iteratorError7 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                _iterator7.return();
                            }
                        } finally {
                            if (_didIteratorError7) {
                                throw _iteratorError7;
                            }
                        }
                    }

                    localforage.removeItem("purchase_list").then(function (value) {}).catch(function (err) {});
                } else {}
            });

            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.product.product_items).length == 1) {
                if (this.product_item.product_item_order_quantity == 0) {
                    this.product_item.product_item_order_quantity = 1;
                }
                this.order_data.order_items.push(this.product_item);
            } else {
                var _iteratorNormalCompletion9 = true;
                var _didIteratorError9 = false;
                var _iteratorError9 = undefined;

                try {
                    for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.product.product_items), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                        var _item4 = _step9.value;

                        if (_item4.product_item_order_quantity > 0) {
                            this.order_data.order_items.push(_item4);
                        }
                    }
                } catch (err) {
                    _didIteratorError9 = true;
                    _iteratorError9 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion9 && _iterator9.return) {
                            _iterator9.return();
                        }
                    } finally {
                        if (_didIteratorError9) {
                            throw _iteratorError9;
                        }
                    }
                }
            }
        }
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'makePaymentOrder', function makePaymentOrder() {
        var set_order_mode = 0;
        if (this.loggedIn) {
            set_order_mode = 1;
        }
        var payload = {
            order_business: this.order_data.order_business,
            order_mode: set_order_mode,
            order_user_id: this.user.user_id || 0,
            order_user_details: this.order_data.order_user_details,
            order_items: this.order_data.order_items,
            order_details: this.order_data.order_details,
            order_on_notify: 1
        };

        service.makeCustomOrder(this, payload).then(function (response) {
            if (response.body.status == 201) {}
        }).catch(function (err) {});
    }), _methods),
    mounted: function mounted() {},
    created: function created() {
        if (this.$route.query.setup == "yes") {
            this.new_added = true;
        }
        this.setProduct();
        this.getStates();
        this.tab_view['descr'] = true;
        window.onscroll = function (ev) {
            if (window.innerHeight + window.pageYOffset >= document.body.offsetHeight) {}
        };

        var self = this;
        localforage.getItem('xvue', function (err, value) {
            if (value != undefined) {
                self.cart = value.cart;
                console.log(7555126677);console.log(self.cart);
            } else {}
        });
    },
    destroyed: function destroyed() {}
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_validation__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_logo_pad_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_logo_pad_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_templates_logo_pad_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_account_menu_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_account_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_templates_account_menu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductForm_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_product_ProductForm_vue__);








var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
var validator = new __WEBPACK_IMPORTED_MODULE_1__services_validation__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SellpointTemplate',
    data: function data() {
        return {
            path: this.$route.path.replace('/', ''),
            path_name: this.$route.name,
            sellpoint_name: this.$route.path.split('/')[1],
            product_name: this.$route.path.split('/')[2]
        };
    },

    components: {
        'logo-pad': __WEBPACK_IMPORTED_MODULE_3__components_templates_logo_pad_vue___default.a,
        'component-account-menu': __WEBPACK_IMPORTED_MODULE_4__components_templates_account_menu_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'product-form': __WEBPACK_IMPORTED_MODULE_5__components_product_ProductForm_vue___default.a
    },
    methods: {
        back: function back() {
            if (this.path_name == 'Product' || this.path_name == 'RefProduct') {
                this.$router.push("/" + this.sellpoint_name);
            } else {
                this.$router.push("/");
            }
        },
        setPageHeaders: function setPageHeaders() {
            window.onscroll = function () {
                var stick_header = document.getElementById("pageStickyHeader");

                var sticky = stick_header.offsetTop;

                if (window.pageYOffset > sticky) {
                    stick_header.classList.add("header-sticky-after");
                } else {
                    stick_header.classList.remove("header-sticky-after");
                }
            };
        },
        setStickyHeader: function setStickyHeader() {
            var stick_header = document.getElementById("pageStickyHeader");

            var sticky = stick_header.offsetTop;

            if (window.pageYOffset > sticky) {
                stick_header.classList.add("header-sticky-after");
            } else {
                stick_header.classList.remove("header-sticky-after");
            }
        }
    },
    created: function created() {}
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_account_menu_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_account_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_templates_account_menu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__resources_utility__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Account_Resources_commonfunctions_js__ = __webpack_require__(3);










var service = new __WEBPACK_IMPORTED_MODULE_2__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Sellpoint',
    mixins: [__WEBPACK_IMPORTED_MODULE_7__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            user: {},
            categories: {},
            market: {},
            market_groups: {},
            market_trending: {},
            products: {},
            product: {},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            menu_view: {},
            show_login: false,
            show_landing: true,
            header_data: {},
            has_shops: true,

            set_view_box: '',
            set_view_box_2: '',
            set_order_options_item_index: 0,
            set_product_order_options: {},

            product_index: 0,
            product_item_index: 0,

            headerComponentKey: 0,
            shop_layout: 3 };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue___default.a,
        'component-sticky-header': __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue___default.a
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        preset: function preset() {
            this.loading = true;
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;
                    self.loggedIn = true;
                    self.loading = false;

                    if (self.user.user_is_agent && self.user.user_is_agent == 1) {
                        self.agent_is_active = 1;
                        if (self.user.user_agent_business_data && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(self.user.user_agent_business_data).length > 0) {
                            self.agent_service_user_data = self.user.user_agent_user_data;
                            self.agent_service_business_data = self.user.user_agent_business_data;

                            self.user = {};
                        }
                    }
                } else {}
            });
        },
        setMarketRemote: function setMarketRemote() {
            var _this = this;

            service.getBusinessByUserName(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this.market = response.body.data;
                    _this.businesses = _this.market.business_markets;
                    _this.loading = false;
                }
            }).catch(function (err) {});
        },
        setMarketActivities: function setMarketActivities() {
            var _this2 = this;

            service.getMarketActivityProducts(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this2.market_trending = response.body.data;
                    _this2.products = response.body.data;
                }
            }).catch(function (err) {});
        },
        setMarketGroups: function setMarketGroups() {
            var _this3 = this;

            service.getMarketGroupsProducts(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this3.market_groups = response.body.data;
                }
            }).catch(function (err) {});
        },
        setMenuComponent: function setMenuComponent(view, view_type, attr1, attr2) {
            var top = document.getElementById("topPanel").offsetTop;
            window.scrollTo(0, top);

            this.menu_view = {};
            this.menu_view[view] = true;
        },
        getBusinessCategories: function getBusinessCategories() {
            service.getCategories(this).then(function (data) {
                this.categories = data.body.data;
            });
        },
        getSellpoint: function getSellpoint() {
            var _this4 = this;

            this.loading = true;
            service.getBusinessByUserName(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this4.sellpoint = response.body.data;
                    _this4.header_data.name = _this4.sellpoint.business_name;

                    _this4.headerComponentKey++;
                    _this4.setBusinessDetails();
                    _this4.getSellpointProducts();

                    _this4.categories = [{ category_name: 'Swallow' }, { category_name: 'Drinks' }, { category_name: 'Swallow' }, { category_name: 'Drinks' }];
                    if (_this4.sellpoint.business_username == 'tmxmall') {
                        _this4.shop_layout = 3;
                    }
                    if (_this4.sellpoint.business_username == 'lucas1870509088') {
                        _this4.shop_layout = 2;
                    }
                    if (_this4.sellpoint.business_username == 'jarephones') {
                        _this4.shop_layout = 2;
                    }
                    if (_this4.sellpoint.business_username == 'kedi1674857669') {
                        _this4.shop_layout = 1;
                    }
                }
            }).catch(function (err) {});
        },
        setBusinessDetails: function setBusinessDetails() {
            var _this5 = this;

            service.getBusinessByUserName(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this5.sellpoint = response.body.data;

                    _this5.business_delivery_locations = _this5.sellpoint.business_delivery_options;

                    _this5.business_bank_details = _this5.sellpoint.business_bank_details;
                }
            }).catch(function (err) {});
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this6 = this;

            this.loading = true;
            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this6.products = response.body.data;
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this6.products), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var product = _step.value;
                            var _iteratorNormalCompletion2 = true;
                            var _didIteratorError2 = false;
                            var _iteratorError2 = undefined;

                            try {
                                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(product.product_items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    var item = _step2.value;

                                    item.product_name = product.product_name;
                                    item.product_item_order_quantity = 1;
                                    item.product_order_options = product.product_information;
                                    var _iteratorNormalCompletion3 = true;
                                    var _didIteratorError3 = false;
                                    var _iteratorError3 = undefined;

                                    try {
                                        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(item.product_order_options), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                            var option = _step3.value;

                                            option.set_status = 1;
                                            option.set_details = "";
                                        }
                                    } catch (err) {
                                        _didIteratorError3 = true;
                                        _iteratorError3 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                                _iterator3.return();
                                            }
                                        } finally {
                                            if (_didIteratorError3) {
                                                throw _iteratorError3;
                                            }
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                        _iterator2.return();
                                    }
                                } finally {
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }

                            _this6.set_order_addons.push(product);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this6.set_order_data.order_items = [];

                    _this6.loading = false;
                }
            }).catch(function (err) {});
        },
        setViewBox: function setViewBox(view) {
            if (this.set_view_box == '') {
                this.setMenuTabInnerView('');
                this.toggleSingleComponent('shareBox');
            } else {
                this.setMenuTabInnerView('setOptions');

                this.set_view_box = view;
            }
        },
        setProductView: function setProductView(product, product_index, product_item, product_item_index) {
            this.product = product;
            this.product_index = product_index;

            this.product_item = product_item;
            this.product_item_index = product_item_index;

            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(product).length > 0) {
                this.setMenuTabInnerView('addToList');

                var self = this;
                setTimeout(function () {
                    self.setbg();
                }, 50);
            }
        },
        setProductItem: function setProductItem(product_item, product_item_index) {
            this.product_item = product_item;
            this.product_item_index = product_item_index;

            this.setOrderProductItem(1, product_item, this.product_index, this.product_item_index);
        },
        setProductOrderOptions: function setProductOrderOptions(index, item, options) {
            this.product_item = item;
            this.set_order_options_item_index = index;

            this.set_view_box_2 = 'setProductOrderOptions';
            this.toggleSingleComponent('infoBox');
        },
        setbg: function setbg() {
            this.componentKey++;

            var el = document.getElementById('dbgg');
            var el_width = el.offsetWidth;
            var el_height = el.offsetHeight;
            var bg_width = 50;
            var bg_height = 50;
            var ibg = el_width - bg_width + 10 + "px " + (el_height - bg_height - 10) + "px";

            var xel = document.getElementById('xmg');
            var xel_width = xel.offsetWidth;
            var xel_height = xel.offsetHeight;

            console.log(xel);
            var rf = false;
            if (xel_height - xel_width > 40) {
                console.log('ovvff---' + (xel_height - xel_width));
                rf = true;
            }

            if (rf) {
                el.style.backgroundPosition = 'center';
                el.style.height = '50vh';
            } else {
                console.log('op00ttt');
                el.style.height = xel_height + 'px';
            }
            console.log('op2200--win' + window.innerWidth + '---el-width' + el_width);

            document.getElementById('xmg').style.display = 'none';
        }
    },
    created: function created() {
        if (localStorage.getItem('appOn')) {
            this.show_landing = false;
        } else {
            localStorage.setItem('appOn', 1);
        }
        this.menu_view["timeline"] = true;
        this.preset();
        this.getSellpoint();
    }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__ = __webpack_require__(3);






var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CreateSellpoint',
    mixins: [__WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints: {},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error: false,
            group_isset: false,
            add_sellpoint: false,
            add_business: false,
            get_flag: false,
            loading: false,
            action_loading: false,

            validate_user_name_message: "",
            payment_successful_message: "",
            data_error_message: "",
            data_boarding_message: "",

            headerdata: {
                'name': 'Set Order'
            },

            reset_order: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a
    },
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        preset: function preset() {
            this.loading = true;

            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;
                    self.setProduct();
                    localforage.getItem(service.bdb_name, function (err, value) {
                        if (value != undefined) {
                            self.sellpoint = value;

                            self.setBusinessDetails();

                            self.getSellpointProducts();
                        } else {
                            self.loading = false;
                        }
                    });
                } else {
                    self.loading = false;
                    self.$router.push('/login');
                }
            });
        },
        setBusinessDetails: function setBusinessDetails() {
            var self = this;
            localforage.getItem(service.bbnksdb_name, function (err, value) {
                if (value != undefined) {
                    console.log(7654999);
                    self.sellpoint.business_bank_details = value;
                    self.business_bank_details = value;
                }
                self.loading = false;
            });

            localforage.getItem(service.bbdlsdb_name, function (err, value) {
                if (value != undefined) {
                    self.sellpoint.business_delivery_options = value;
                    self.business_delivery_locations = value;
                }
                self.loading = false;
            });
        },
        setProduct: function setProduct() {
            var _this = this;

            this.loading = true;
            service.getProductSearch(this, this.$route.params.ref).then(function (response) {
                if (response.body.status == 200) {
                    _this.product = response.body.data;

                    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.product.product_images).length > 0) {
                        _this.product_display_image = _this.product.product_images[0];
                    } else {
                        _this.product_display_image.product_image = "";
                    }
                    _this.product_item = _this.product.product_items[0];
                    if (_this.product.product_item_groups.length != 0) {
                        _this.product_item_group = _this.product.product_item_groups[0];
                    } else {
                        _this.product_item_group = [];
                    }

                    _this.product.selected_product_addons = [];
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.preset();

        this.getRavepayBanks();
    }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__ = __webpack_require__(3);






var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CreateSellpoint',
    mixins: [__WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints: {},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error: false,
            group_isset: false,
            add_sellpoint: false,
            add_business: false,
            get_flag: false,
            loading: false,
            action_loading: false,

            validate_user_name_message: "",
            payment_successful_message: "",
            data_error_message: "",
            data_boarding_message: "",

            headerdata: {
                'name': 'Set Order'
            },

            reset_order: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a
    },
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        preset: function preset() {
            this.loading = true;

            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;
                    self.setProduct();
                    localforage.getItem(service.bdb_name, function (err, value) {
                        if (value != undefined) {
                            self.sellpoint = value;

                            self.setBusinessDetails();

                            self.getSellpointProducts();
                        } else {
                            self.loading = false;
                        }
                    });
                } else {
                    self.loading = false;
                    self.$route.push('/login');
                }
            });
        },
        setBusinessDetails: function setBusinessDetails() {
            var self = this;
            localforage.getItem(service.bbnksdb_name, function (err, value) {
                if (value != undefined) {
                    console.log(7654999);
                    self.sellpoint.business_bank_details = value;
                    self.business_bank_details = value;
                }
                self.loading = false;
            });

            localforage.getItem(service.bbdlsdb_name, function (err, value) {
                if (value != undefined) {
                    self.sellpoint.business_delivery_options = value;
                    self.business_delivery_locations = value;
                }
                self.loading = false;
            });
        },
        setProduct: function setProduct() {
            var _this = this;

            this.loading = true;
            service.getProductSearch(this, this.$route.params.ref).then(function (response) {
                if (response.body.status == 200) {
                    _this.product = response.body.data;

                    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.product.product_images).length > 0) {
                        _this.product_display_image = _this.product.product_images[0];
                    } else {
                        _this.product_display_image.product_image = "";
                    }
                    _this.product_item = _this.product.product_items[0];
                    if (_this.product.product_item_groups.length != 0) {
                        _this.product_item_group = _this.product.product_item_groups[0];
                    } else {
                        _this.product_item_group = [];
                    }

                    _this.product.selected_product_addons = [];
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.preset();

        this.getRavepayBanks();
    }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__ = __webpack_require__(3);






var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ShoppingList',
    mixins: [__WEBPACK_IMPORTED_MODULE_4__Account_Resources_commonfunctions_js__["a" /* default */]],
    data: function data() {
        return {
            headerdata: {
                'name': 'Shopping List'
            }
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a
    },
    methods: {
        preset: function preset() {
            this.loading = true;

            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user = value;

                    self.getOrders(self.user.user_id);
                } else {
                    self.loading = false;
                }
            });
        },
        setPresetCategories: function setPresetCategories() {
            var payload = {};
            this.getPresetCategories(payload);
        },
        setBusinessView: function setBusinessView(business) {
            this.sellpoint = business;

            this.setMenuTabInnerView('getCategoryProducts');
        },
        setProductView: function setProductView(product) {
            this.product = product;

            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.product.product_items).length > 1) {
                this.toggleSingleComponent('productItemsBox');
            } else {}
        },
        setMarketActivities: function setMarketActivities() {
            var _this = this;

            service.getMarketActivityProducts(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this.market_trending = response.body.data;
                    _this.products = response.body.data;
                }
            }).catch(function (err) {});
        },
        setMarketRemote: function setMarketRemote() {
            var _this2 = this;

            service.getBusinessByUserName(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this2.market = response.body.data;
                    _this2.businesses = _this2.market.business_markets;
                    _this2.loading = false;
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.setMarketRemote();
        this.setMarketActivities();
        this.setPresetCategories();
        this.preset();


        if (this.$route.path == '/shopping/lists/new') {
            this.setMenuTabInnerView("newShoppingList");
        }
    }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_js__ = __webpack_require__(60);

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'DHome',
    mixins: [__WEBPACK_IMPORTED_MODULE_0__main_js__["a" /* default */]],
    data: function data() {
        return {};
    },


    components: {},
    methods: {},
    created: function created() {}
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__desktop_index_vue__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__desktop_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__desktop_index_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MHome',
    mixins: [__WEBPACK_IMPORTED_MODULE_0__main_js__["a" /* default */]],
    data: function data() {
        return {};
    },


    components: {
        'component-desktop': __WEBPACK_IMPORTED_MODULE_1__desktop_index_vue___default.a
    },

    methods: {},
    created: function created() {}
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__resources_setts_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaymentService_index_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaymentService_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PaymentService_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Orderpoint_Checkout_index_vue__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Orderpoint_Checkout_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Orderpoint_Checkout_index_vue__);








var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    mixins: [__WEBPACK_IMPORTED_MODULE_4__resources_setts_js__["a" /* default */]],
    data: function data() {
        return {
            header_data: {},
            user: {},
            transfer: {},
            transfers: {},
            transfer_item: {},
            transfer_ref: '',
            loggedIn: false,
            loading: true,
            action_loading: false,
            tab_view: {},
            menu_tab_view: {},
            set_view: false,
            set_payment: false,
            payment_data: {},
            img_product_url: service.imageProductsURL,
            show_empty_fields: false,
            data_processing_message: '',
            show_login_view: false,
            data_view: ''
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a,
        'component-payment-service': __WEBPACK_IMPORTED_MODULE_5__PaymentService_index_vue___default.a,
        'component-checkout': __WEBPACK_IMPORTED_MODULE_6__Orderpoint_Checkout_index_vue___default.a
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == "reset-edit") {}
        },
        setTabComponent: function setTabComponent(view) {
            this.tab_view = {};
            this.tab_view[view] = true;
        },
        setMenuTabView: function setMenuTabView(view, attr1, attr2) {
            if (this.menu_tab_view[view] == true) {
                this.menu_tab_view = {};
            } else {
                this.menu_tab_view = {};
                this.menu_tab_view[view] = true;
            }

            if (view == "viewTransfer") {
                this.transfer = attr1;
            }
        },
        preset: function preset() {
            this.loading = true;
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;

                    self.getGeneratedTransferOrders();
                    self.loading = false;
                } else {
                    self.show_login_view = true;
                }
            });
        },
        addProductsToTransferOrder: function addProductsToTransferOrder() {},
        makeTransFerOrder: function makeTransFerOrder() {
            if (this.transfer.payment_order_id > 0 && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.transfer.payment_order_items).length > 0) {
                var payload = {
                    order_user: this.user.user_id,
                    order_payment_order: this.transfer.payment_order_id,
                    order_items: this.transfer.payment_order_items
                };
                service.acceptPaymentOrder(this, payload).then(function (response) {
                    if (response.body.status == 201) {
                        console.log(response.body);
                    }
                }).catch(function (err) {});
            }
        },
        setGenerateReceipt: function setGenerateReceipt() {
            var self = this;

            var request_data = {
                "name": "GenerateTransferPayment",
                "link": "/account/business/generatetransferpayment",
                "dir": "/account/business",
                "src": "/transfer",
                "msg": "Login to check your Transfers",
                "track": 1 };
            localforage.setItem(service.adr_db_name, request_data).then(function (value) {
                self.$router.push(request_data.link);
            }).catch(function (err) {});
        },
        setTabActiveDisplay: function setTabActiveDisplay(tab) {
            if (tab == "invoices") {
                document.getElementById("t_invoice").style.color = "#ff0000";
                document.getElementById("t_payment").style.color = "#000000";
            }

            if (tab == "payments") {
                document.getElementById("t_payment").style.color = "#ff0000";
                document.getElementById("t_invoice").style.color = "#000000";
            }
        },
        getGeneratedTransferOrders: function getGeneratedTransferOrders() {
            var _this = this;

            this.setTabActiveDisplay("invoices");
            this.data_view = "invoices";
            this.action_loading = true;
            this.transfers = {};
            var payload = {
                order_user: this.user.user_id,
                order_generated_request: 1
            };
            service.getPaymentOrders(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this.transfers = response.body.data;
                }
                _this.loading = false;
                _this.action_loading = false;
            }).catch(function (err) {});
        },
        getTransferOrders: function getTransferOrders() {
            var _this2 = this;

            this.setTabActiveDisplay("payments");
            this.data_view = "Payments";
            this.action_loading = true;
            this.transfers = {};
            var payload = {
                order_user: this.user.user_id
            };
            service.getPaymentOrders(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this2.transfers = response.body.data;
                }
                _this2.loading = false;
                _this2.action_loading = false;
            }).catch(function (err) {});
        },
        getTransferDetails: function getTransferDetails() {
            var _this3 = this;

            var payload = {
                order_ref: this.transfer_ref
            };
            service.getPaymentOrders(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    var set_data = response.body.data;
                    _this3.transfer = set_data[0];
                    _this3.setMenuTabView('viewTransfer', _this3.transfer);
                }
                _this3.loading = false;
            }).catch(function (err) {});
        },
        setUserData: function setUserData() {
            this.show_empty_fields = false;
            this.preparePaymentData();
        },
        preparePaymentData: function preparePaymentData() {
            if (this.transfer.payment_order_payment_status_id == 7) {
                this.setPaymentDataSlim();
            }
        },
        setPaymentDataSlim: function setPaymentDataSlim() {
            var set_payment_data = {};

            var order = this.transfer.payment_order_order_details;
            var order_data = this.transfer.payment_order_order_data;

            set_payment_data.order_ref = order.order_no;

            this.payment_data = set_payment_data;

            this.set_payment = true;
        },
        setPaymentData: function setPaymentData() {
            var order = this.transfer.payment_order_order_details;
            var order_data = this.transfer.payment_order_order_data;

            var payment_orders_data = order;
            var payment_amount_to_pay = order.total_amount;
            var payment_ref = order.order_ref;
            var payment_details = order_data.payment_service;
            var payment_service_module = order_data.payment_service_module;
            var payment_service_module_id = order_data.payment_service_module_id;

            var set_subaccounts = [];
            var set_subaccounts_settlements = true;
            if (set_subaccounts_settlements) {
                if (order.order_agent_fee > 0) {
                    var sub_account_0 = {
                        id: order.business_agent_bank_ravepay_subaccount_id,
                        transaction_charge: order.order_agent_fee,
                        transaction_charge_type: "flat_subaccount"
                    };
                    set_subaccounts.push(sub_account_0);
                }

                if (order.order_total_commissions_fee > 0) {
                    var sub_account_01 = {
                        id: service.spcomms_subaccount_id,
                        transaction_charge: order.order_total_commissions_fee,
                        transaction_charge_type: "flat_subaccount"
                    };
                    set_subaccounts.push(sub_account_01);
                }

                var order_business = 0;
                var order_delivery_business = order.order_delivery_business.business_delivery_id;
                if (order_business == order_delivery_business) {
                    var sub_account_1 = {
                        id: order.business_bank_ravepay_subaccount_id,
                        transaction_charge: order.total_amount - (order.order_processing_fee + order.order_agent_fee + order.order_total_commissions_fee),
                        transaction_charge_type: "flat_subaccount"
                    };
                    set_subaccounts.push(sub_account_1);
                } else {
                    var sub_account_1 = {
                        id: order.business_bank_ravepay_subaccount_id,
                        transaction_charge: order.total_amount - (order.order_delivery_fee + order.order_processing_fee + order.order_agent_fee + order.order_total_commissions_fee),
                        transaction_charge_type: "flat_subaccount"
                    };
                    set_subaccounts.push(sub_account_1);
                    var sub_account_2 = {
                        id: order.order_delivery_business.business_bank_ravepay_subaccount_id,
                        transaction_charge: order.order_delivery_fee,
                        transaction_charge_type: "flat_subaccount"
                    };
                    set_subaccounts.push(sub_account_2);
                }
            }

            if (this.user.user_email == undefined || this.user.user_phone == undefined || this.user.user_email == "" || this.user.user_phone == "") {
                this.user.user_name = order_data.payment_data.payment_payer_name;
                this.user.user_email = order_data.payment_data.payment_payer_email;
                this.user.user_phone = order_data.payment_data.payment_payer_phone;
            }

            var set_payment_data = {};
            if (this.user.user_email == undefined || this.user.user_phone == undefined || this.user.user_email == "" || this.user.user_phone == "") {
                this.show_empty_fields = true;
            } else {
                set_payment_data = {
                    payer_name: this.user.user_name,
                    payer_email: this.user.user_email,
                    payer_phone: this.user.user_phone,
                    payment_total_amount: payment_amount_to_pay,
                    payment_currency: "NGN",
                    payment_ref: payment_ref,
                    payment_details: payment_details,
                    payment_processing_fee_status: 4,
                    payment_processing_fee: 0,
                    payment_processing_fee_transaction_type: 0,
                    payment_transaction_type: 1,
                    payment_service_module: payment_service_module,
                    payment_service_module_id: payment_service_module_id,
                    payment_data_index: 0,
                    payment_data_route: "account",
                    payment_service_business: order.order_business,
                    payment_service_type: "single",
                    payment_service_payment_data: order_data.payment_data,
                    payment_sub_accounts: set_subaccounts,
                    payment_fees_account_balance: 0,
                    payment_meta: [],
                    payment_modes_accepted: [1, 5] };

                set_payment_data.payment_service_payment_data.payment_services = payment_orders_data;
                this.show_empty_fields = false;
            }

            this.payment_data = set_payment_data;

            this.set_payment = true;
        }
    },
    created: function created() {
        this.header_data.name = "Transfers";

        if (this.$route.params.ref != undefined && this.$route.params.ref != '') {
            this.transfer_ref = this.$route.params.ref;
            this.getTransferDetails();
        } else {
            this.preset();
        }
    }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    data: function data() {
        return {
            header_data: {},
            set_view: '',
            user: {},
            collections: {},
            gigs: {},
            total_collection_balance: 0,
            total_gigs_balance: 0,
            app_collection_balance: 0,
            loggedIn: false,
            loading: true,
            set_cashout_gig: false,
            tab_view: {},
            menu_tab_view: {},
            gigs_amount_to_cashout: 0,
            gigs_cash_out_proc_fee: service.app_gigs_cash_out_proc_fee
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue___default.a,
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue___default.a
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == "reset-edit") {}
        },
        setTabComponent: function setTabComponent(view) {
            this.tab_view = {};
            this.tab_view[view] = true;
        },
        setMenuTabView: function setMenuTabView(view, attr1, attr2) {
            if (this.menu_tab_view[view] == true) {
                this.menu_tab_view = {};
                this.setComponent('reset-edit', '');
            } else {
                this.setComponent('reset-edit', '');
                this.menu_tab_view = {};
                this.menu_tab_view[view] = true;
            }
        },
        checkCashOutGigs: function checkCashOutGigs() {
            this.gigs_amount_to_cashout = Number(this.gigs_amount_to_cashout);
            if (this.gigs_amount_to_cashout > this.gigs_collection_balance) {
                this.gigs_amount_to_cashout = this.gigs_collection_balance;
            }
        },
        preset_xtra: function preset_xtra() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        preset: function preset() {
            this.loading = true;
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;

                    self.getMonies();
                    self.loading = false;
                } else {
                    self.$router.push('login');
                }
            });
        },
        getCollections: function getCollections() {
            var _this2 = this;

            service.getUserCollections(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.collections = response.body.data;
                    _this2.collections_businesses = response.body.data_collections_businesses;
                    _this2.total_collection_balance = response.body.data_total_balance;

                    _this2.loading = false;
                }
            }).catch(function (err) {});
        },
        getMonies: function getMonies() {
            var _this3 = this;

            service.getUserMonies(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this3.total_collection_balance = response.body.data_collection_total_balance;
                    _this3.collections = response.body.data_collection_data;

                    _this3.total_gigs_balance = response.body.data_gigs_total_balance;
                    _this3.gigs = response.body.data_gigs_data;

                    _this3.loading = false;
                }
            }).catch(function (err) {});
        },
        cashOutGigs: function cashOutGigs() {
            var _this4 = this;

            var payload = {
                data_business: 0,
                data_type: 29,
                data_user: this.user.user_id,
                data_amount_paid: this.gigs_amount_to_cashout,
                data_action_type: 7,
                data_module: 0,
                data_module_id: 0,
                data_module_order_service_payment_ref: "" };
            if (payload.data_amount_paid == 0) {
                this.data_processing_message = "Amount should be more than 0";
            } else {
                service.postCollectionsServices(this, payload).then(function (response) {
                    if (response.body.status == 201 || response.body.status == 200) {
                        this.getCollections();

                        this.gigs_amount_to_cashout = 0;
                    }
                }).catch(function (err) {
                    _this4.gigs_amount_to_cashout = 0;
                });
            }
        }
    },
    created: function created() {
        this.preset();
        this.setTabComponent('tab02');

        if (this.$route.path == '/deluxe') {
            this.set_view = 'deluxe';
        }
    }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_js__ = __webpack_require__(61);

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'DHome',
    mixins: [__WEBPACK_IMPORTED_MODULE_0__main_js__["a" /* default */]],
    data: function data() {
        return {};
    },


    components: {},
    methods: {},
    created: function created() {}
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__desktop_index_vue__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__desktop_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__desktop_index_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MHome',
    mixins: [__WEBPACK_IMPORTED_MODULE_0__main_js__["a" /* default */]],
    data: function data() {
        return {};
    },


    components: {
        'component-desktop': __WEBPACK_IMPORTED_MODULE_1__desktop_index_vue___default.a
    },

    methods: {},
    created: function created() {}
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Account_Template__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Account_Template___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Account_Template__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Account_Dashboard__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Account_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_Account_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Account_Settings__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Account_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Account_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Account_Groups__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Account_Groups___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Account_Groups__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Account_Groups_Group__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Account_Groups_Group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Account_Groups_Group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Account_Sellpoints__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Account_Sellpoints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_Account_Sellpoints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Account_Sellpoint_Template__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Account_Sellpoint_Template___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_Account_Sellpoint_Template__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Account_Sellpoint_Categories__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Account_Sellpoint_Categories___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_Account_Sellpoint_Categories__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Account_Sellpoint_Category__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Account_Sellpoint_Category___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_Account_Sellpoint_Category__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Account_Sellpoint_Products__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Account_Sellpoint_Products___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_Account_Sellpoint_Products__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Account_Sellpoint_Product__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Account_Sellpoint_Product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_Account_Sellpoint_Product__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Account_Sellpoint_Orders__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Account_Sellpoint_Orders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_Account_Sellpoint_Orders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Account_Sellpoint_Settings__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Account_Sellpoint_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_Account_Sellpoint_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Account_Sellpoint_Components_AddBusiness__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Account_Sellpoint_Components_AddBusiness___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_Account_Sellpoint_Components_AddBusiness__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Account_Sellpoint_Components_AddCategory__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Account_Sellpoint_Components_AddCategory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_Account_Sellpoint_Components_AddCategory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Account_Sellpoint_Components_AddProduct__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Account_Sellpoint_Components_AddProduct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_Account_Sellpoint_Components_AddProduct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Account_Sellpoint_Components_GenerateTransferPayment__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Account_Sellpoint_Components_GenerateTransferPayment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__pages_Account_Sellpoint_Components_GenerateTransferPayment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Account_Sellpoint_Settings_SellpointTransactions__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Account_Sellpoint_Settings_SellpointTransactions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pages_Account_Sellpoint_Settings_SellpointTransactions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Account_Sellpoint_Settings_SellpointPayments__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Account_Sellpoint_Settings_SellpointPayments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__pages_Account_Sellpoint_Settings_SellpointPayments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Account_Sellpoint_Settings_SellpointShipping__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Account_Sellpoint_Settings_SellpointShipping___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__pages_Account_Sellpoint_Settings_SellpointShipping__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Account_Sellpoint_Settings_SellpointDiscounts__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Account_Sellpoint_Settings_SellpointDiscounts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__pages_Account_Sellpoint_Settings_SellpointDiscounts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Account_Sellpoint_Settings_SellpointRewards__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Account_Sellpoint_Settings_SellpointRewards___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__pages_Account_Sellpoint_Settings_SellpointRewards__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Account_Sellpoint_Product_ProductTypes__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Account_Sellpoint_Product_ProductTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__pages_Account_Sellpoint_Product_ProductTypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_Account_Sellpoint_Product_ProductOrders__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_Account_Sellpoint_Product_ProductOrders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__pages_Account_Sellpoint_Product_ProductOrders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_Account_Sellpoint_Product_ProductReviews__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_Account_Sellpoint_Product_ProductReviews___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__pages_Account_Sellpoint_Product_ProductReviews__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_Account_Sellpoint_Product_ProductSettings__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_Account_Sellpoint_Product_ProductSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__pages_Account_Sellpoint_Product_ProductSettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_Account_Sellpoint_Product_ProductAddons__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_Account_Sellpoint_Product_ProductAddons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__pages_Account_Sellpoint_Product_ProductAddons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_Account_Sellpoint_Product_ProductDiscounts__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_Account_Sellpoint_Product_ProductDiscounts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__pages_Account_Sellpoint_Product_ProductDiscounts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_Account_Sellpoint_Product_ProductShipping__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_Account_Sellpoint_Product_ProductShipping___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__pages_Account_Sellpoint_Product_ProductShipping__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_Account_Sellpoint_Orders_OrderDetailsRequest__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_Account_Sellpoint_Orders_OrderDetailsRequest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__pages_Account_Sellpoint_Orders_OrderDetailsRequest__);



































/* harmony default export */ __webpack_exports__["a"] = ({
  path: '',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Account_Template___default.a,
  children: [{
    path: '/account',
    name: 'Account',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Account_Template___default.a
  }, {
    path: '/account/businesses',
    name: 'Sellpoints',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_Account_Sellpoints___default.a
  }, {
    path: '/account/business',
    name: 'Sellpoint',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_Account_Sellpoint_Template___default.a,
    children: [{
      path: '',
      name: 'AccountSellpoint',
      component: __WEBPACK_IMPORTED_MODULE_6__pages_Account_Sellpoint_Template___default.a
    }, {
      path: '/account/business/categories',
      name: 'AccountSellpointCategories',
      component: __WEBPACK_IMPORTED_MODULE_7__pages_Account_Sellpoint_Categories___default.a
    }, {
      path: '/account/business/category',
      name: 'AccountSellpointCategory',
      component: __WEBPACK_IMPORTED_MODULE_8__pages_Account_Sellpoint_Category___default.a
    }, {
      path: '/account/business/products',
      name: 'AccountSellpointProducts',
      component: __WEBPACK_IMPORTED_MODULE_9__pages_Account_Sellpoint_Products___default.a
    }, {
      path: '/account/business/product',
      component: __WEBPACK_IMPORTED_MODULE_10__pages_Account_Sellpoint_Product___default.a,
      children: [{
        path: '',
        name: 'AccountSellpointProduct',
        component: __WEBPACK_IMPORTED_MODULE_10__pages_Account_Sellpoint_Product___default.a
      }, {
        path: '/account/business/product/types',
        name: 'ProductTypes',
        component: __WEBPACK_IMPORTED_MODULE_22__pages_Account_Sellpoint_Product_ProductTypes___default.a
      }, {
        path: '/account/business/product/orders',
        name: 'ProductOrders',
        component: __WEBPACK_IMPORTED_MODULE_23__pages_Account_Sellpoint_Product_ProductOrders___default.a
      }, {
        path: '/account/business/product/reviews',
        name: 'ProductReviews',
        component: __WEBPACK_IMPORTED_MODULE_24__pages_Account_Sellpoint_Product_ProductReviews___default.a
      }, {
        path: '/account/business/product/settings',
        name: 'ProductSettings',
        component: __WEBPACK_IMPORTED_MODULE_25__pages_Account_Sellpoint_Product_ProductSettings___default.a
      }, {
        path: '/account/business/product/addons',
        name: 'ProductAddons',
        component: __WEBPACK_IMPORTED_MODULE_26__pages_Account_Sellpoint_Product_ProductAddons___default.a
      }, {
        path: '/account/business/product/discounts',
        name: 'ProductDiscounts',
        component: __WEBPACK_IMPORTED_MODULE_27__pages_Account_Sellpoint_Product_ProductDiscounts___default.a
      }, {
        path: '/account/business/product/shipping',
        name: 'ProductShipping',
        component: __WEBPACK_IMPORTED_MODULE_28__pages_Account_Sellpoint_Product_ProductShipping___default.a
      }]
    }, {
      path: '/account/business/orders',
      name: 'AccountSellpointOrders',
      component: __WEBPACK_IMPORTED_MODULE_11__pages_Account_Sellpoint_Orders___default.a
    }, {
      path: '/account/business/orders/:business/:ref',
      name: 'AccountSellpointOrder',
      component: __WEBPACK_IMPORTED_MODULE_29__pages_Account_Sellpoint_Orders_OrderDetailsRequest___default.a
    }, {
      path: '/account/business/settings',
      name: 'AccountSellpointSettings',
      component: __WEBPACK_IMPORTED_MODULE_12__pages_Account_Sellpoint_Settings___default.a
    }, {
      path: '/account/business/newproduct',
      name: 'AddNewProduct',
      component: __WEBPACK_IMPORTED_MODULE_15__pages_Account_Sellpoint_Components_AddProduct___default.a
    }, {
      path: '/account/business/newcategory',
      name: 'AddNewCategory',
      component: __WEBPACK_IMPORTED_MODULE_14__pages_Account_Sellpoint_Components_AddCategory___default.a
    }, {
      path: '/account/business/transactions',
      name: 'BusinessTransactions',
      component: __WEBPACK_IMPORTED_MODULE_17__pages_Account_Sellpoint_Settings_SellpointTransactions___default.a
    }, {
      path: '/account/business/shipping',
      name: 'BusinessShipping',
      component: __WEBPACK_IMPORTED_MODULE_19__pages_Account_Sellpoint_Settings_SellpointShipping___default.a
    }, {
      path: '/account/business/payments',
      name: 'BusinessPayments',
      component: __WEBPACK_IMPORTED_MODULE_18__pages_Account_Sellpoint_Settings_SellpointPayments___default.a
    }, {
      path: '/account/business/discounts',
      name: 'BusinessDiscounts',
      component: __WEBPACK_IMPORTED_MODULE_20__pages_Account_Sellpoint_Settings_SellpointDiscounts___default.a
    }, {
      path: '/account/business/rewards',
      name: 'BusinessRewards',
      component: __WEBPACK_IMPORTED_MODULE_21__pages_Account_Sellpoint_Settings_SellpointRewards___default.a
    }, {
      path: '/account/business/generatetransferpayment',
      name: 'GenerateTransferPayment',
      component: __WEBPACK_IMPORTED_MODULE_16__pages_Account_Sellpoint_Components_GenerateTransferPayment___default.a
    }]
  }, {
    path: '/account/business/newbusiness',
    name: 'AddNewBusiness',
    component: __WEBPACK_IMPORTED_MODULE_13__pages_Account_Sellpoint_Components_AddBusiness___default.a
  }, {
    path: '/account/business/newbusiness/agent',
    name: 'AddNewBusinessByAgent',
    component: __WEBPACK_IMPORTED_MODULE_13__pages_Account_Sellpoint_Components_AddBusiness___default.a
  }, {
    path: '/account/groups',
    name: 'AccountGroups',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Account_Groups___default.a
  }, {
    path: '/account/group/:ref',
    name: 'AccountGroup',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Account_Groups_Group___default.a
  }, {
    path: '/account/settings',
    name: 'AccountSettings',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Account_Settings___default.a
  }]
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_AgentServices_Template__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_AgentServices_Template___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_AgentServices_Template__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_AgentServices_ServiceCharges__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_AgentServices_ServiceCharges___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_AgentServices_ServiceCharges__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_AgentServices_SetUpShop__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_AgentServices_SetUpShop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_AgentServices_SetUpShop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_AgentServices_AddedServices__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_AgentServices_AddedServices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_AgentServices_AddedServices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_AgentServices_ShopAccounts__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_AgentServices_ShopAccounts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_AgentServices_ShopAccounts__);






/* harmony default export */ __webpack_exports__["a"] = ({
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_AgentServices_Template___default.a,
    children: [{
        path: '/agentservices',
        name: 'AgentServices',
        component: __WEBPACK_IMPORTED_MODULE_0__pages_AgentServices_Template___default.a
    }, {
        path: '/agentservices/servicecharges',
        name: 'Service Charges',
        component: __WEBPACK_IMPORTED_MODULE_1__pages_AgentServices_ServiceCharges___default.a
    }, {
        path: '/agentservices/setupshop',
        name: 'Set Up Shop',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_AgentServices_SetUpShop___default.a
    }, {
        path: '/agentservices/addedservices',
        name: 'Added Services',
        component: __WEBPACK_IMPORTED_MODULE_3__pages_AgentServices_AddedServices___default.a
    }, {
        path: '/agentservices/shopaccounts',
        name: 'Shop Accounts',
        component: __WEBPACK_IMPORTED_MODULE_4__pages_AgentServices_ShopAccounts___default.a
    }]
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Boxpoint_Template__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Boxpoint_Template___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Boxpoint_Template__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Boxpoint_Wishlist__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Boxpoint_Wishlist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_Boxpoint_Wishlist__);


/* harmony default export */ __webpack_exports__["a"] = ({
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Boxpoint_Template___default.a,
    children: [{
        path: '/wishlist',
        name: 'Wishlist',
        component: __WEBPACK_IMPORTED_MODULE_1__pages_Boxpoint_Wishlist___default.a
    }]
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Buypoint__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Buypoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Buypoint__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/buypoint',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Buypoint___default.a,
  children: [{
    path: '',
    name: 'Buypoint',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Buypoint___default.a
  }, {
    path: '/shoptogether',
    name: 'ShopTogether',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Buypoint___default.a
  }, {
    path: '/shoptogether/:ref',
    name: 'ShopTogetherRefLink',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Buypoint___default.a
  }]
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Buzz__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Buzz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Buzz__);


/* harmony default export */ __webpack_exports__["a"] = ({
    path: '/buzz',
    name: 'Buzz',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Buzz___default.a
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Chats__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Chats___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Chats__);


/* harmony default export */ __webpack_exports__["a"] = ({
    path: '/chats',
    name: 'Chats',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Chats___default.a
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Collections__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Collections___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Collections__);


/* harmony default export */ __webpack_exports__["a"] = ({
    path: '/collections',
    name: 'Collections',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Collections___default.a
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_CreateSellpoint__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_CreateSellpoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_CreateSellpoint__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/create',
  name: 'CreateSellpoint',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_CreateSellpoint___default.a
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_CreateAccount__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_CreateAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_CreateAccount__);


/* harmony default export */ __webpack_exports__["a"] = ({
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_CreateAccount___default.a,
    children: [{
        path: '/create/account/:ref',
        name: 'Create Account',
        component: __WEBPACK_IMPORTED_MODULE_0__pages_CreateAccount___default.a
    }]
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_CreateOrder__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_CreateOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_CreateOrder__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/create/order',
  name: 'Create Order',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_CreateOrder___default.a
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_dashboard__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_dashboard__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/dashboard',
  name: 'Dashboard',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_dashboard___default.a
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Demos__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Demos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Demos__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/demos',
  name: 'demos',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Demos___default.a
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Feeds__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Feeds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Feeds__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/feeds',
  name: 'Feeds',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Feeds___default.a
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Timeline__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Timeline__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/',
  name: 'Home',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Timeline___default.a
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Login__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Login__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/login',
  name: 'login',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Login___default.a
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_MakeOrder__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_MakeOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_MakeOrder__);


/* harmony default export */ __webpack_exports__["a"] = ({
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_MakeOrder___default.a,
    children: [{
        path: '/make/order/:ref',
        name: 'Make Order',
        component: __WEBPACK_IMPORTED_MODULE_0__pages_MakeOrder___default.a
    }]
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Manage_Template__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Manage_Template___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Manage_Template__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Manage_ManageSet__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Manage_ManageSet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_Manage_ManageSet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_ManageShop__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_ManageShop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_ManageShop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Manage_Orders__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Manage_Orders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Manage_Orders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Manage_Items__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Manage_Items___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Manage_Items__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Manage_Item__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Manage_Item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_Manage_Item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_ManageOrder__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_ManageOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_ManageOrder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Manage_Customers__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Manage_Customers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_Manage_Customers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Manage_Lists__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Manage_Lists___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_Manage_Lists__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Manage_ShoppingList__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Manage_ShoppingList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_Manage_ShoppingList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Manage_MarketList__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Manage_MarketList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_Manage_MarketList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Manage_AddItems__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Manage_AddItems___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_Manage_AddItems__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Manage_AddCategories__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Manage_AddCategories___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_Manage_AddCategories__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Manage_ItemSettings_SettingsList__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Manage_ItemSettings_SettingsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_Manage_ItemSettings_SettingsList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Manage_ItemSettings_ResetCategory__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Manage_ItemSettings_ResetCategory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_Manage_ItemSettings_ResetCategory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Manage_ItemSettings_AddToCategories__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Manage_ItemSettings_AddToCategories___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_Manage_ItemSettings_AddToCategories__);



















/* harmony default export */ __webpack_exports__["a"] = ({
  path: '',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Manage_Template___default.a,
  children: [{
    path: 'shop/:ref',
    name: 'Manage Shop',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_ManageShop___default.a
  }, {
    path: '/manage/items',
    name: 'Manage Items',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Manage_Items___default.a
  }, {
    path: '/manage/items/:ref',
    name: 'Manage Item',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_Manage_Item___default.a
  }, {
    path: 'orders',
    name: 'Manage Orders',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Manage_Orders___default.a
  }, {
    path: 'order/:ref',
    name: 'Manage Order',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_ManageOrder___default.a
  }, {
    path: '/manage/customers',
    name: 'Manage Customers',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_Manage_Customers___default.a
  }, {
    path: '/manage/lists',
    name: 'Manage Lists',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_Manage_Lists___default.a
  }, {
    path: '/manage/lists/shopping/:ref',
    name: 'Shopping List',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_Manage_ShoppingList___default.a
  }, {
    path: '/manage/lists/market/:ref',
    name: 'Market List',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_Manage_MarketList___default.a
  }, {
    path: '/manage/add/items',
    name: 'Add Items to Shop',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_Manage_AddItems___default.a
  }, {
    path: '/manage/add/categories',
    name: 'Add Categories',
    component: __WEBPACK_IMPORTED_MODULE_12__pages_Manage_AddCategories___default.a
  }, {
    path: '/manage/items/settings/lists',
    name: 'ItemSettings',
    component: __WEBPACK_IMPORTED_MODULE_13__pages_Manage_ItemSettings_SettingsList___default.a
  }, {
    path: '/manage/items/settings/resetcategory',
    name: 'Reset Category',
    component: __WEBPACK_IMPORTED_MODULE_14__pages_Manage_ItemSettings_ResetCategory___default.a
  }, {
    path: '/manage/items/settings/addtocategories',
    name: 'Add to Categories',
    component: __WEBPACK_IMPORTED_MODULE_15__pages_Manage_ItemSettings_AddToCategories___default.a
  }]
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_MyShops__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_MyShops___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_MyShops__);


/* harmony default export */ __webpack_exports__["a"] = ({
    path: '/myshops',
    name: 'MyShops',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_MyShops___default.a
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Notifications__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Notifications__);


/* harmony default export */ __webpack_exports__["a"] = ({
    path: '/notifications',
    name: 'Notifications',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Notifications___default.a
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Onboarding__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Onboarding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Onboarding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Timeline__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_Timeline__);





/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/securedrss91',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Onboarding___default.a,
  children: [{
    path: '',
    name: 'Onboarding',
    component: __WEBPACK_IMPORTED_MODULE_1__pages_Timeline___default.a
  }, {
    path: 'gr/:grname/:gref/:ref',
    name: 'RefGroup',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Onboarding___default.a
  }]
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_PlacedOrder__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_PlacedOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_PlacedOrder__);


/* harmony default export */ __webpack_exports__["a"] = ({
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_PlacedOrder___default.a,
    children: [{
        path: '/placed/order/:ref',
        name: 'Placed Order',
        component: __WEBPACK_IMPORTED_MODULE_0__pages_PlacedOrder___default.a
    }]
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_PlacedOrders__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_PlacedOrders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_PlacedOrders__);

/* harmony default export */ __webpack_exports__["a"] = ({
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_PlacedOrders___default.a,
    children: [{
        path: '/placed/orders',
        name: 'Placed Orders',
        component: __WEBPACK_IMPORTED_MODULE_0__pages_PlacedOrders___default.a
    }]
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_PlaceOrder__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_PlaceOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_PlaceOrder__);


/* harmony default export */ __webpack_exports__["a"] = ({
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_PlaceOrder___default.a,
    children: [{
        path: '/place/order/:ref',
        name: 'Place Order',
        component: __WEBPACK_IMPORTED_MODULE_0__pages_PlaceOrder___default.a
    }]
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_PrepareOrder__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_PrepareOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_PrepareOrder__);


/* harmony default export */ __webpack_exports__["a"] = ({
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_PrepareOrder___default.a,
    children: [{
        path: '/prepare/order/:ref',
        name: 'Prepare Order',
        component: __WEBPACK_IMPORTED_MODULE_0__pages_PrepareOrder___default.a
    }]
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Purchase__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Purchase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Purchase__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/purchase',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Purchase___default.a,
  children: [{
    path: '',
    name: 'Purchase',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Purchase___default.a
  }, {
    path: ':ref',
    name: 'RefPurchase',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Purchase___default.a
  }]
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Register__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Register__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/register',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Register___default.a,
  children: [{
    path: '',
    name: 'register',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Register___default.a
  }, {
    path: ':ref',
    name: 'RefRegister',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Register___default.a
  }]
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Search__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Search__);


/* harmony default export */ __webpack_exports__["a"] = ({
    path: '/search',
    name: 'Search',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Search___default.a
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Sellpoint_Product__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Sellpoint_Product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Sellpoint_Product__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Sellpoint_SellpointTemplate__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Sellpoint_SellpointTemplate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Sellpoint_SellpointTemplate__);





/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/:id',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_Sellpoint_SellpointTemplate___default.a,
  children: [{
    path: '',
    name: 'Sellpoint',
    component: __WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint___default.a
  }, {
    path: ':id1',
    name: 'Product',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Sellpoint_Product___default.a
  }, {
    path: ':id1/:ref0',
    name: 'RefProduct',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Sellpoint_Product___default.a
  }, {
    path: 'g/:idg',
    name: 'Gallery',
    component: __WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint___default.a
  }]
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_SetOrder__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_SetOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_SetOrder__);


/* harmony default export */ __webpack_exports__["a"] = ({
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_SetOrder___default.a,
    children: [{
        path: '/set/order/:ref',
        name: 'Set Order',
        component: __WEBPACK_IMPORTED_MODULE_0__pages_SetOrder___default.a
    }]
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Settings__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Settings__);


/* harmony default export */ __webpack_exports__["a"] = ({
    path: '/settings',
    name: 'Settings',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Settings___default.a
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_ShoppingLists__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_ShoppingLists___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_ShoppingLists__);

/* harmony default export */ __webpack_exports__["a"] = ({
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_ShoppingLists___default.a,
    children: [{
        path: '/shopping/lists',
        name: 'Shopping Lists',
        component: __WEBPACK_IMPORTED_MODULE_0__pages_ShoppingLists___default.a
    }, {
        path: '/shopping/lists/new',
        name: 'New Shopping List',
        component: __WEBPACK_IMPORTED_MODULE_0__pages_ShoppingLists___default.a
    }]
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Transfer__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Transfer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Transfer__);


/* harmony default export */ __webpack_exports__["a"] = ({
    path: '/transfers',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Transfer___default.a,
    children: [{
        path: '',
        name: 'transfer',
        component: __WEBPACK_IMPORTED_MODULE_0__pages_Transfer___default.a
    }, {
        path: ':ref',
        name: 'RefTransfer',
        component: __WEBPACK_IMPORTED_MODULE_0__pages_Transfer___default.a
    }]
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Updates__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Updates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Updates__);

/* harmony default export */ __webpack_exports__["a"] = ({
  path: '',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Updates___default.a,
  children: [{
    path: '/rc',
    name: 'Updates',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Updates___default.a
  }, {
    path: '/deluxe',
    name: 'DeluxeUpdates',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Updates___default.a
  }]
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service__ = __webpack_require__(1);






var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

        var service = new __WEBPACK_IMPORTED_MODULE_3__service__["a" /* default */]();
        this.baseURL = service.baseURL;
        this.apiToken = service.apiToken;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: 'getUser',
        value: function getUser(id) {
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.baseURL + 'users/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getBusinesses',
        value: function getBusinesses(id) {
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.baseURL + 'businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getAppBusinessByUserName',
        value: function getAppBusinessByUserName(id) {
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.baseURL + 'app/businesses/usernames/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getAppBusinessProducts',
        value: function getAppBusinessProducts(id, limit) {
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.baseURL + 'products/app/businesses/' + id + '/' + limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getBusinessCategories',
        value: function getBusinessCategories(id) {
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.baseURL + 'businesses/categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: 'getCategoryProducts',
        value: function getCategoryProducts(id) {
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.baseURL + 'products/categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: 'formatCurrency',
        value: function formatCurrency(currency) {
            currency = Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(currency);
            currency = currency.replace("₦", "");
            currency = currency.replace("NGN", "");
            currency = currency.replace(".00", "");
            return currency.replace(/\s/g, '');
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cartGetters; });

var cartGetters = {
    cartProducts: function cartProducts(state) {
        return state.added.map(function (_ref) {
            var id = _ref.id,
                quantity = _ref.quantity;

            var product_item = state.all.find(function (p) {
                return p._id === id;
            });

            return {
                name: product.name,
                price: product.price,
                quantity: quantity
            };
        });
    }
};

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return accountUserActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return accountSellpointActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return accountCategoryActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return accountProductActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_axios_services__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(14);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_axios_services__["a" /* default */]();

var accountUserActions = {
    setUserData: function setUserData(_ref, id) {
        var commit = _ref.commit;

        var payload = {};
        service.getUser(id).then(function (response) {
            if (response.data.status == 200) {
                payload = response.data.data;
                payload.user_id = id;
                commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SET_USER_DATA */], payload);
            }
        }).catch(function (err) {});
    }
};

var accountSellpointActions = {
    userAccountBusinesses: function userAccountBusinesses(_ref2, id) {
        var commit = _ref2.commit;

        service.getBusinesses(id).then(function (response) {
            commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* USER_SELLPOINTS */], response.data.data);
        }).catch(function (err) {});
    },
    userAccountBusiness: function userAccountBusiness(_ref3, payload) {
        var commit = _ref3.commit;

        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* USER_SELLPOINT */], payload);
    },
    setBusiness: function setBusiness(_ref4, payload) {
        var commit = _ref4.commit;

        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* RESET_SELLPOINTS */]);

        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* USER_SELLPOINT */], payload);
    },
    setSellpointAppSubscriptionOffers: function setSellpointAppSubscriptionOffers(_ref5, payload) {
        var commit = _ref5.commit;

        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* USER_SELLPOINT_APP_SUB_OFFERS */], payload);
    },
    setBusinessShipping: function setBusinessShipping(_ref6, payload) {
        var commit = _ref6.commit;

        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* USER_SELLPOINT_SHIPPING */], payload);
    },
    setBusinessDiscounts: function setBusinessDiscounts(_ref7, payload) {
        var commit = _ref7.commit;

        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* USER_SELLPOINT_DISCOUNTS */], payload);
    }
};

var accountCategoryActions = {
    setBusinessCategories: function setBusinessCategories(_ref8) {
        var commit = _ref8.commit,
            getters = _ref8.getters;

        var business = getters['getUserBusiness'];
        var id = business.business_id;
        if (id > 0) {
            service.getBusinessCategories(id).then(function (response) {
                commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* USER_SELLPOINT_CATEGORIES */], response.data.data);
            }).catch(function (err) {});
        }
    },
    setSellpointCategories: function setSellpointCategories(_ref9, payload) {
        var commit = _ref9.commit;

        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* USER_SELLPOINT_CATEGORIES */], payload);

        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* SET_SELLPOINT_CATEGORIES */], payload);
    },
    setCategory: function setCategory(_ref10, payload) {
        var commit = _ref10.commit;

        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* USER_SELLPOINT_CATEGORY */], payload);
    }
};

var accountProductActions = {
    setBusinessProducts: function setBusinessProducts(_ref11, payload) {
        var commit = _ref11.commit;

        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* USER_SELLPOINT_PRODUCTS */], payload);
    },
    setBusinessProductsDEPRAC: function setBusinessProductsDEPRAC(_ref12) {
        var commit = _ref12.commit,
            getters = _ref12.getters;

        var xsellpoint = getters['getUserBusiness'];
        var sellpoint_id = xsellpoint.business_id;
        if (sellpoint_id > 0) {
            service.getAppBusinessProducts(sellpoint_id, 100).then(function (response) {
                commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* USER_SELLPOINT_PRODUCTS */], response.data.data);
            }).catch(function (err) {});
        }
    },
    setBusinessCategoryProducts: function setBusinessCategoryProducts(_ref13, payload) {
        var commit = _ref13.commit;

        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* USER_SELLPOINT_CATEGORY_PRODUCTS */], payload);
    },
    setCategoryProductsDEPRAC: function setCategoryProductsDEPRAC(_ref14) {
        var commit = _ref14.commit,
            getters = _ref14.getters;

        var category = getters['getCategory'];
        var id = category.business_category_id;
        if (id > 0) {
            service.getCategoryProducts(id).then(function (response) {
                commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* USER_SELLPOINT_PRODUCTS */], response.data.data);
            }).catch(function (err) {});
        }
    },
    setProduct: function setProduct(_ref15, payload) {
        var commit = _ref15.commit;

        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* USER_SELLPOINT_PRODUCT */], payload);
    }
};

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return accountUserGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return accountSellpointGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return accountCategoryGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return accountProductGetters; });

var accountUserGetters = {
  getUser: function getUser(state) {
    return state.store_user;
  } };

var accountSellpointGetters = {

  getUserBusinesses: function getUserBusinesses(state) {
    return state.store_sellpoints;
  },

  getUserBusiness: function getUserBusiness(state) {
    return state.store_sellpoint.store_sellpointData;
  },

  setSellpoint: function setSellpoint(state) {
    return state.store_sellpoint.store_sellpointData;
  },

  getSellpointAppSubscriptionOffers: function getSellpointAppSubscriptionOffers(state) {
    return state.store_sellpoint.store_sellpointAppSubscriptionOffers;
  },

  getSellpointShipping: function getSellpointShipping(state) {
    return state.store_sellpoint.store_sellpointShipping;
  },

  getSellpointDiscounts: function getSellpointDiscounts(state) {
    return state.store_sellpoint.store_sellpointDiscounts;
  },

  sellpointById: function sellpointById(state, getters) {
    return function (id) {
      if (getters.allSellpoints.length > 0) {
        return getters.allSellpoints.filter(function (p) {
          return p._id === id;
        })[0];
      } else {
        return state.store_sellpoint;
      }
    };
  }

};

var accountCategoryGetters = {
  getBusinessCategories: function getBusinessCategories(state) {
    return state.store_sellpoint.store_categories;
  },

  getCategory: function getCategory(state) {
    return state.store_sellpoint.store_category;
  } };

var accountProductGetters = {
  getBusinessProducts: function getBusinessProducts(state) {
    return state.store_sellpoint.store_products;
  },

  getProduct: function getProduct(state) {
    return state.store_sellpoint.store_product;
  },

  allProducts: function allProducts(state, getters) {
    return state.store_sellpoint.store_products;
  },

  productById: function productById(state, getters) {
    return function (id) {
      if (getters.allProducts.length > 0) {
        return getters.allProducts.filter(function (p) {
          return p._id === id;
        })[0];
      } else {
        return state.store_sellpoint.store_product;
      }
    };
  }

};

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return account; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(273);






var account = {
    namespaced: true,

    state: function state() {
        return {
            store_user: {},
            store_sellpoints: {},
            store_sellpoint: {},
            store_orders: {},
            store_stores: {},
            store_posts: {},
            store_post: {}
        };
    },

    getters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* accountUserGetters */], __WEBPACK_IMPORTED_MODULE_1__getters__["b" /* accountProductGetters */], __WEBPACK_IMPORTED_MODULE_1__getters__["c" /* accountCategoryGetters */], __WEBPACK_IMPORTED_MODULE_1__getters__["d" /* accountSellpointGetters */]),
    mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* accountUserMutations */], __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* accountProductMutations */], __WEBPACK_IMPORTED_MODULE_2__mutations__["c" /* accountCategoryMutations */], __WEBPACK_IMPORTED_MODULE_2__mutations__["d" /* accountSellpointMutations */]),
    actions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* accountUserActions */], __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* accountProductActions */], __WEBPACK_IMPORTED_MODULE_3__actions__["c" /* accountCategoryActions */], __WEBPACK_IMPORTED_MODULE_3__actions__["d" /* accountSellpointActions */])

};

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return accountUserMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return accountSellpointMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return accountCategoryMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return accountProductMutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(14);


var _accountUserMutations, _accountSellpointMuta, _accountCategoryMutat, _accountProductMutati;



var accountUserMutations = (_accountUserMutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_accountUserMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SET_USER_DATA */], function (state, payload) {
    state.store_user = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_accountUserMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["n" /* ERROR_MSG */], function (state, payload) {}), _accountUserMutations);

var accountSellpointMutations = (_accountSellpointMuta = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_accountSellpointMuta, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* USER_SELLPOINTS */], function (state, payload) {
    state.store_showLoader = false;
    state.store_sellpoints = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_accountSellpointMuta, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* USER_SELLPOINT */], function (state, payload) {
    state.store_showLoader = false;
    state.store_sellpoint.store_sellpointData = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_accountSellpointMuta, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* SET_SELLPOINT_CATEGORIES */], function (state, payload) {
    state.store_sellpoint.business_categories = payload;
    state.store_sellpoint.store_sellpointData.business_categories = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_accountSellpointMuta, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* USER_SELLPOINT_APP_SUB_OFFERS */], function (state, payload) {
    state.store_sellpoint.store_sellpointAppSubscriptionOffers = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_accountSellpointMuta, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* USER_SELLPOINT_SHIPPING */], function (state, payload) {
    state.store_sellpoint.store_sellpointShipping = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_accountSellpointMuta, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* USER_SELLPOINT_DISCOUNTS */], function (state, payload) {
    state.store_sellpoint.store_sellpointDiscounts = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_accountSellpointMuta, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* RESET_SELLPOINTS */], function (state) {
    state.store_sellpoint = {};
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_accountSellpointMuta, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["n" /* ERROR_MSG */], function (state, payload) {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_accountSellpointMuta, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["o" /* ALL_SELLPOINTS */], function (state) {
    state.store_showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_accountSellpointMuta, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["p" /* ALL_SELLPOINTS_SUCCESS */], function (state, payload) {
    state.store_showLoader = false;
    state.store_sellpoints = payload;
}), _accountSellpointMuta);

var accountCategoryMutations = (_accountCategoryMutat = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_accountCategoryMutat, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* USER_SELLPOINT_CATEGORIES */], function (state, payload) {
    state.store_sellpoint.store_categories = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_accountCategoryMutat, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* USER_SELLPOINT_CATEGORY */], function (state, payload) {
    state.store_sellpoint.store_category = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_accountCategoryMutat, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["n" /* ERROR_MSG */], function (state, payload) {}), _accountCategoryMutat);

var accountProductMutations = (_accountProductMutati = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_accountProductMutati, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* USER_SELLPOINT_PRODUCTS */], function (state, payload) {
    state.store_sellpoint.store_products = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_accountProductMutati, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* USER_SELLPOINT_CATEGORY_PRODUCTS */], function (state, payload) {
    state.store_sellpoint.store_category_products = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_accountProductMutati, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* USER_SELLPOINT_PRODUCT */], function (state, payload) {
    state.store_sellpoint.store_product = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_accountProductMutati, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["q" /* ALL_PRODUCTS */], function (state) {
    state.store_showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_accountProductMutati, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["r" /* ALL_PRODUCTS_SUCCESS */], function (state, payload) {
    state.store_showLoader = false;
    state.store_sellpoint.store_products = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_accountProductMutati, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["s" /* PRODUCT_BY_ID */], function (state) {
    state.store_showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_accountProductMutati, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["t" /* PRODUCT_BY_ID_SUCCESS */], function (state, payload) {
    state.store_showLoader = false;
    state.store_sellpoint.store_product = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_accountProductMutati, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["n" /* ERROR_MSG */], function (state, payload) {}), _accountProductMutati);

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cartMutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(14);


var _cartMutations;



var cartMutations = (_cartMutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cartMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["u" /* VIEW_CART */], function (state) {
  return state.cart;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cartMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["v" /* ADD_TO_CART */], function (state, payload) {
  state.cart;console.log(7879866856 + '---' + state.cart);
  state.cart.push(payload);console.log(78 + '---' + payload._id);
  state.cart = state.cart;console.log(state.cart);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cartMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["w" /* REMOVE_FROM_CART */], function (state, payload) {
  console.log(9123);console.log(state.cart);
  var index = state.cart.findIndex(function (p) {
    return p._id === payload;
  });
  state.cart.splice(index, 1);console.log(2323);
  console.log(state.cart);
}), _cartMutations);

/***/ }),
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(333)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(539),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(349)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(556),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(581),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(603),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(552),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(334)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(540),
  /* scopeId */
  "data-v-11649f85",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(381)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(590),
  /* scopeId */
  "data-v-6174c1e9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(427)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(639),
  /* scopeId */
  "data-v-faea1e4e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(419)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(631),
  /* scopeId */
  "data-v-d1258c9c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(350)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(557),
  /* scopeId */
  "data-v-215abe58",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(353)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(560),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(386)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(596),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(355)
__webpack_require__(356)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(562),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(325)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(530),
  /* scopeId */
  "data-v-076ba4bb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(344)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(550),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(357)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(563),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(379)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(588),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(394)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(605),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(331)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(537),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(397)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(608),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(400)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(611),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(351)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(558),
  /* scopeId */
  "data-v-22c73faf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(368)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(575),
  /* scopeId */
  "data-v-4251edba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(409)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(620),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(382)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(591),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(369)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(153),
  /* template */
  __webpack_require__(576),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(385)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(154),
  /* template */
  __webpack_require__(595),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(361)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(567),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(396)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(607),
  /* scopeId */
  "data-v-7ba4948e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(401)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(612),
  /* scopeId */
  "data-v-866af560",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(328)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(534),
  /* scopeId */
  "data-v-0db2d90c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(423)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(635),
  /* scopeId */
  "data-v-e80c2c30",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(428)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(640),
  /* scopeId */
  "data-v-fbcff176",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(346)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(553),
  /* scopeId */
  "data-v-1af827b9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(420)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(632),
  /* scopeId */
  "data-v-d4728e8c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(422)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(634),
  /* scopeId */
  "data-v-df2e892a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(393)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(604),
  /* scopeId */
  "data-v-77ba6769",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(324)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(529),
  /* scopeId */
  "data-v-06fb60b7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(362)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(568),
  /* scopeId */
  "data-v-37b56842",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(378)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(587),
  /* scopeId */
  "data-v-60c6588d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(405)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(616),
  /* scopeId */
  "data-v-9aa06554",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(342)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(548),
  /* scopeId */
  "data-v-181dbf4e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(372)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(580),
  /* scopeId */
  "data-v-458d3a48",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(338)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(544),
  /* scopeId */
  "data-v-16a16144",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(367)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(574),
  /* scopeId */
  "data-v-41ee0825",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(327)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(533),
  /* scopeId */
  "data-v-0c925f56",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(375)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(584),
  /* scopeId */
  "data-v-57e8403a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(399)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(610),
  /* scopeId */
  "data-v-81ef3570",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(388)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(598),
  /* scopeId */
  "data-v-7044e5c8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(429)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(641),
  /* scopeId */
  "data-v-fef2121a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(430)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(642),
  /* scopeId */
  "data-v-fef4e6c8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(360)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(566),
  /* scopeId */
  "data-v-332b5c7e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(365)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(571),
  /* scopeId */
  "data-v-3c4dccd6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(414)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(626),
  /* scopeId */
  "data-v-c131b648",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(389)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(599),
  /* scopeId */
  "data-v-72031c8e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(376)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(585),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(340)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(546),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(329)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(535),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(343)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(549),
  /* scopeId */
  "data-v-184be450",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(323)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(528),
  /* scopeId */
  "data-v-053c458e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(418)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(630),
  /* scopeId */
  "data-v-d11b5a64",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(377)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(586),
  /* scopeId */
  "data-v-5bffaef6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(322)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(527),
  /* scopeId */
  "data-v-03f7bdf7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(424)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(159),
  /* template */
  __webpack_require__(636),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(345)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(551),
  /* scopeId */
  "data-v-19d085bc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(380)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(589),
  /* scopeId */
  "data-v-61010da3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(387)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(597),
  /* scopeId */
  "data-v-6dd21ff7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(370)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(578),
  /* scopeId */
  "data-v-44c3a0b8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(341)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(547),
  /* scopeId */
  "data-v-17fd704a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(417)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(629),
  /* scopeId */
  "data-v-d0778ec4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(347)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(554),
  /* scopeId */
  "data-v-1d48ace0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(352)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(559),
  /* scopeId */
  "data-v-2537eee1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(402)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(613),
  /* scopeId */
  "data-v-8aec7238",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(412)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(623),
  /* scopeId */
  "data-v-ba3f65b6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(373)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(582),
  /* scopeId */
  "data-v-4db6bb3a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(383)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(592),
  /* scopeId */
  "data-v-66f7b60a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(358)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(564),
  /* scopeId */
  "data-v-2edbd6c4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(403)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(614),
  /* scopeId */
  "data-v-8e5f8d76",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(332)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(538),
  /* scopeId */
  "data-v-10574fec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(407)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(618),
  /* scopeId */
  "data-v-b3d55db4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(371)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(579),
  /* scopeId */
  "data-v-4562efeb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(410)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(621),
  /* scopeId */
  "data-v-b61ebe9e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(426)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(638),
  /* scopeId */
  "data-v-f3ae084c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(366)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(572),
  /* scopeId */
  "data-v-3d81b8c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(337)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(543),
  /* scopeId */
  "data-v-168f0962",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(335)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(541),
  /* scopeId */
  "data-v-13ee02b4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(392)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(602),
  /* scopeId */
  "data-v-770e2bc0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(326)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(531),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(404)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(615),
  /* scopeId */
  "data-v-96e63f24",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(421)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(633),
  /* scopeId */
  "data-v-d98a3986",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(348)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(555),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(415)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(627),
  /* scopeId */
  "data-v-c2f74ab2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin": "0.1em",
      "margin-top": "-0.2em"
    }
  }, [_c('div', {
    staticClass: "card card-box"
  }, [_c('p', [_vm._v("Search for items")]), _vm._v(_vm._s(_vm.order) + "\r\n        "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "border-radius": "8px"
    },
    attrs: {
      "type": "text"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-box"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h4', [_vm._v("Items in Shop\r\n            "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "13px"
    }
  }, [_vm._v("Total: " + _vm._s(_vm.products.length))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', [_c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.products), function(product, index) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s((index + 1)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "80%"
      }
    }, [_c('div', {
      staticClass: "col-xs-3"
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('p', [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v("8")]), _vm._v(" "), _vm._m(1, true)])
  })], 2)])])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('th', [_vm._v("-")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding-left": "1em",
      "padding-bottom": "1em",
      "font-size": "0"
    }
  }, [_vm._v("item")]), _vm._v(" "), _c('th', [_vm._v("Qty")]), _vm._v(" "), _c('th', [_vm._v("-")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "5%"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    staticStyle: {
      "color": "#5703a5"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-box"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h4')]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "block",
      "position": "fixed",
      "width": "100%",
      "bottom": "4.6em",
      "background": "#ffffff",
      "z-index": "10000"
    },
    attrs: {
      "id": "xInfo"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "background-color": "rgb(41, 122, 245)",
      "border-radius": "18px",
      "color": "#ffffff"
    }
  }, [_vm._v("\r\n        Add Items to Shop")])])])])
}]}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin": "0.1em",
      "margin-top": "-0.2em"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.set_view == 'setViewItems') ? _c('div', {
    staticClass: "card card-box",
    attrs: {
      "id": "setViewCategoryIntro"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h4', [_vm._v("Categories\r\n            "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "18px"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_view = 'setViewCategories'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.set_view == 'setViewCategories') ? _c('div', {
    staticClass: "card card-box",
    attrs: {
      "id": "setViewItemsIntro"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h4', [_vm._v("Items in shop\r\n            "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "18px"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_view = 'setViewItems';
        _vm.setAllProducts();
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.set_view == 'setViewCategories') ? _c('div', {
    staticClass: "card card-box",
    attrs: {
      "id": "setViewCategories"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h4', [_vm._v("Categories "), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("(" + _vm._s(Object.keys(_vm.sellpoint.business_categories).length) + ")")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [((Object.keys(_vm.sellpoint.business_categories).length > 0)) ? _c('div', {
    key: _vm.componentKey
  }, _vm._l((_vm.sellpoint.business_categories), function(category, index) {
    return _c('div', {
      staticClass: "card card-box-fl"
    }, [_c('h5', [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setCategoryProducts(category)
        }
      }
    }, [_vm._v("\r\n                    " + _vm._s(category.business_category_name) + "\r\n                    "), _vm._m(2, true)])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.set_view == 'setViewItems') ? _c('div', {
    staticClass: "card card-box",
    attrs: {
      "id": "setViewItems"
    }
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h4', [(Object.keys(_vm.category).length > 0) ? _c('span', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_view = 'setViewCategories';
        _vm.products = {};
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-left"
  })]), _vm._v(" Items in "), _c('b', [_vm._v(_vm._s(_vm.category.business_category_name))])]) : _c('span', [_vm._v("Items in Shop")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "13px"
    }
  }, [_vm._v("Total: " + _vm._s(_vm.products.length))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', [_c('table', [_vm._m(3), _vm._v(" "), _vm._l((_vm.products), function(product, index) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s((index + 1)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "80%"
      }
    }, [_c('div', {
      staticClass: "col-xs-3"
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('p', [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v("8")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_c('a', {
      staticClass: "card-link",
      attrs: {
        "href": '/manage/items/' + product.product_url_name
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-right",
      staticStyle: {
        "color": "#5703a5"
      }
    })])])])
  })], 2)])])]) : _vm._e(), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-box"
  }, [_c('p', [_vm._v("Search for items")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "border-radius": "8px"
    },
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "right",
      "margin-top": "-0.1em"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "font-size": "13px",
      "border-radius": "8px",
      "background": "#5703a5",
      "line-height": "0.8",
      "color": "#ffffff"
    },
    attrs: {
      "href": "/manage/add/categories"
    }
  }, [_vm._v("\r\n                  Add new Category "), _c('i', {
    staticClass: "fas fa-angle-right",
    staticStyle: {
      "color": "#ffffff"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('th', [_vm._v("-")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding-left": "1em",
      "padding-bottom": "1em",
      "font-size": "0"
    }
  }, [_vm._v("item")]), _vm._v(" "), _c('th', [_vm._v("Qty")]), _vm._v(" "), _c('th', [_vm._v("-")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-box"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h4')]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "block",
      "position": "fixed",
      "width": "100%",
      "bottom": "4.6em",
      "background": "#ffffff",
      "z-index": "10000"
    },
    attrs: {
      "id": "xInfo"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "background-color": "rgb(41, 122, 245)",
      "border-radius": "18px",
      "color": "#ffffff"
    },
    attrs: {
      "href": "/manage/add/items"
    }
  }, [_vm._v("\r\n        Add Items to Shop")])])])])
}]}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('router-view')], 1)])]), _vm._v(" "), ((!(this.$route.path == '/order') && !(this.$route.path == '/order/') && !(this.$route.path == '/cart') && !(this.$route.path == '/cart/') && !(this.$route.path == '/checkout') && !(this.$route.path == '/checkout/'))) ? _c('component-footer') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _c('div', {
    key: _vm.componentKey,
    staticClass: "detail-card"
  }, [_c('h6', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("Shop Orders")]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), ((Object.keys(_vm.sellpoint_pending_orders).length !== 0)) ? _c('div', {
    staticClass: "detail-card"
  }, [_vm._m(1), _vm._v(" "), (!_vm.viewPendingPayOrders) ? _c('div', {
    staticClass: "card card-flat-pad sp-app-default-background-color",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.viewPendingPayOrders = true;
      }
    }
  }, [_c('div', {
    staticStyle: {
      "width": "95%"
    }
  }, [_vm._m(2), _c('span', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v(" You have " + _vm._s((_vm.sellpoint_pending_orders).length) + " Pending Payments")])])])]) : _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('p', [_vm._v(_vm._s((_vm.sellpoint_pending_orders).length) + " Pending Payment(s)\r\n                "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "font-weight": "bolder",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.viewPendingPayOrders = false;
      }
    }
  }, [_vm._v("X")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {}, _vm._l((_vm.sellpoint_pending_orders), function(spo, spodex) {
    return _c('div', {
      staticClass: "card card-flat-pad"
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "90%"
      }
    }, [_c('div', [_c('span', {
      staticStyle: {
        "float": "left",
        "width": "55%"
      }
    }, [_c('b', [_vm._v(_vm._s(spo.payment_data.payment_payer_name))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "width": "35%"
      }
    }, [_vm._v("  ₦" + _vm._s(spo.payment_data.payment_amount))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', [_vm._v("\r\n                      __"), _c('br'), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "width": "35%",
        "font-size": "13px"
      }
    }, [_vm._v("  ₦" + _vm._s(spo.payment_data.payment_pending_amount_to_pay))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), (_vm.sellpoint.business_agent == 0) ? _c('div', [(((spo.payment_data.payment_set_to_receive_from == 1) && (spo.payment_data.payment_amount_to_pay !== 0))) ? _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [(((_vm.set_order_pending_payment_data == 'ord' + spodex) && (Object.keys(_vm.set_pending_payment_data).length !== 0))) ? _c('div', [_c('component-payment-service', {
      attrs: {
        "paymentdata": _vm.set_pending_payment_data
      }
    })], 1) : _c('div', [_c('a', {
      staticClass: "btn sp-button-02 sp-button-sm",
      on: {
        "click": function($event) {
          _vm.setPendingOrdersPayment(spo, spodex)
        }
      }
    }, [_vm._v("Make Payment")])])]) : _vm._e(), _vm._v(" "), (spo.payment_data.payment_set_to_receive_from == 2) ? _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [(spo.payment_data.payment_settled_by_agent != 1) ? _c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Payment is set to be received by Agent")]) : _c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Payment has been sent to you from Agent")]), _vm._v(" "), (spo.payment_data.payment_settled_by_agent == 1) ? _c('a', {
      staticClass: "btn sp-button-02 sp-button-sm",
      on: {
        "click": function($event) {
          _vm.updateOrdersGeneralDetails(spo)
        }
      }
    }, [_vm._v("Confirm Payment")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_agent == 1) ? _c('div', [(spo.payment_data.payment_set_to_receive_from == 1) ? _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Payment is set to be received by Seller")])]) : _vm._e(), _vm._v(" "), (spo.payment_data.payment_set_to_receive_from == 2) ? _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Payment is set to be received by you")]), _vm._v(" "), (((_vm.set_order_pending_payment_data == 'ord' + spodex) && (Object.keys(_vm.set_pending_payment_data).length !== 0))) ? _c('div', [_c('component-payment-service', {
      attrs: {
        "paymentdata": _vm.set_pending_payment_data
      }
    })], 1) : _c('div', [_c('a', {
      staticClass: "btn sp-button-02 sp-button-sm",
      on: {
        "click": function($event) {
          _vm.setPendingOrdersPayment(spo, spodex)
        }
      }
    }, [_vm._v("Make Payment")])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('div', [(_vm.menu_tab_inner_view['SPO' + spodex]) ? _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('')
        }
      }
    }, [_vm._m(4, true)]) : _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('SPO' + spodex)
        }
      }
    }, [_vm._m(5, true)])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (_vm.menu_tab_inner_view['SPO' + spodex]) ? _c('div', [_c('div', {
      staticClass: "orders-panel",
      staticStyle: {
        "margin-top": "1em"
      }
    }, [(_vm.viewPendingPayOrder) ? _c('div', [_c('div', {
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('hr'), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "font-size": "28px",
        "font-weight": "bolder",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("X")])]), _vm._v(" "), _c('div', {}, [_c('div', [_vm._v("Order number: " + _vm._s(_vm.order.order_no))]), _vm._v(" "), _c('div', [_vm._v("Date: " + _vm._s(_vm.order.order_date))]), _vm._v(" "), _c('div', [_vm._v("Payment method: Online Payment")]), _vm._v(" "), _c('div', [_vm._v("Status: "), _c('span', {
      style: ({
        color: _vm.order.order_status_color
      })
    }, [_vm._v(_vm._s(_vm.order.order_status))])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('div', [_vm._v("Order Amount: ₦" + _vm._s(_vm.order.order_items_total))]), _vm._v(" "), _c('div', [_vm._v("Shipping:  ₦" + _vm._s(_vm.order.order_shipping_total))]), _vm._v(" "), _c('div', [_vm._v("Total: ₦" + _vm._s(_vm.order.order_total))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('div', [_vm._v("Delivery Location: " + _vm._s(_vm.order.order_delivery_city))]), _vm._v(" "), _c('div', [_vm._v("Address: " + _vm._s(_vm.order.order_user_delivery_address))])]), _vm._v(" "), _c('div', {}, [_c('table', {
      staticClass: "table table-striped",
      staticStyle: {
        "width": "100%",
        "text-align": "left"
      }
    }, [_c('th', {
      staticClass: "tcol",
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("Order No")]), _vm._v(" "), _c('th', {
      staticClass: "tcol",
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v("Order")]), _vm._v(" "), _c('th', {
      staticClass: "tcol",
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v("Qty")]), _vm._v(" "), _c('th', {
      staticClass: "tcol",
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("Total")]), _vm._v(" "), _vm._l((_vm.order.order_items), function(item) {
      return _c('tr', [_c('td', {
        staticStyle: {
          "width": "20%",
          "font-size": "12px"
        }
      }, [_vm._v("\r\n                                      " + _vm._s(item.order_item_no) + "\r\n                                    ")]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "50%"
        }
      }, [_vm._v("\r\n                                      " + _vm._s(item.product_name) + "\r\n                                      "), _c('br'), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "inline"
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.img_product_url + item.product_item_group_image,
          "height": "50",
          "width": "50"
        }
      })])]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "10%"
        }
      }, [_vm._v(_vm._s(item.order_item_quantity))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "20%"
        }
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.order_item_total.toFixed(2)))])])
    })], 2)]), _vm._v(" "), _c('div', {}, [_vm._v("\r\n                                " + _vm._s(_vm.order_commissions_stl) + "\r\n                              ")])])]) : _c('div', [_c('div', {
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('p', {
      staticStyle: {
        "text-align": "center",
        "font-weight": "bolder",
        "font-size": "18px"
      }
    }, [_vm._v(" . . .")]), _vm._v(" "), _c('div', {
      staticClass: "card card-strip"
    }, [_vm._m(6, true), _vm._v(" "), _c('div', {
      staticClass: "card-right-50"
    }, [_c('p', [_vm._v(_vm._s(spo.payment_data.payment_service))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "card card-strip"
    }, [_vm._m(7, true), _vm._v(" "), _c('div', {
      staticClass: "card-right-50"
    }, [_c('p', [_vm._v(_vm._s(spo.payment_data.payment_ref))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "card card-strip"
    }, [_vm._m(8, true), _vm._v(" "), _c('div', {
      staticClass: "card-right-50"
    }, [_c('p', [_vm._v(_vm._s(spo.payment_data.payment_date))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])]), _vm._v(" "), _c('h6', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("Orders Made")]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Please confirm payment to view orders")])])])]) : _vm._e()])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "detail-card"
  }, [_vm._m(9), _vm._v(" "), (_vm.sellpoint_orders && (Object.keys(_vm.sellpoint_orders).length === 0)) ? _c('p', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("No orders yet")]) : _vm._e(), _vm._v(" "), (_vm.viewOrder) ? _c('div', [_c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "28px",
      "font-weight": "bolder",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('order-request', {
    attrs: {
      "order_data": _vm.order
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {}, [_c('div', [_vm._v("Order number: " + _vm._s(_vm.order.order_no))]), _vm._v(" "), _c('div', [_vm._v("Date: " + _vm._s(_vm.order.order_date))]), _vm._v(" "), _c('div', [_vm._v("Payment method: Online Payment")]), _vm._v(" "), _c('div', [_vm._v("Status: "), _c('span', {
    style: ({
      color: _vm.order.order_status_color
    })
  }, [_vm._v(_vm._s(_vm.order.order_status))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', [_vm._v("Order Amount: ₦" + _vm._s(_vm.order.order_items_total))]), _vm._v(" "), _c('div', [_vm._v("Shipping:  ₦" + _vm._s(_vm.order.order_shipping_total))]), _vm._v(" "), _c('div', [_vm._v("Total: ₦" + _vm._s(_vm.order.order_total))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', [_vm._v("Delivery Location: " + _vm._s(_vm.order.order_delivery_city))]), _vm._v(" "), _c('div', [_vm._v("Address: " + _vm._s(_vm.order.order_user_delivery_address))])]), _vm._v(" "), _c('div', {}, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Order No")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Order")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Qty")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _vm._l((_vm.order.order_items), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "20%",
        "font-size": "12px"
      }
    }, [_vm._v("\r\n                    " + _vm._s(item.order_item_no) + "\r\n                  ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v("\r\n                    " + _vm._s(item.product_name) + "\r\n                    "), _c('br'), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + item.product_item_group_image,
        "height": "50",
        "width": "50"
      }
    })])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.order_item_quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.order_item_total.toFixed(2)))])])
  })], 2)]), _vm._v(" "), _c('div', {}, [_vm._m(10), _vm._v(" "), _c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Earner")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Item")]), _vm._v(" "), _vm._l((_vm.order.order_commissions_stl), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "20%",
        "font-size": "11px"
      }
    }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.service_commission_amount.toFixed(2)) + "\r\n                  ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("\r\n                    " + _vm._s(item.service_commission_earner_name) + "\r\n                  ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v("\r\n                    " + _vm._s(item.service_commission_module_name) + "\r\n                    "), _c('br'), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + item.service_commission_module_image_url,
        "height": "50",
        "width": "50"
      }
    })])])])
  })], 2)])], 1), _vm._v(" "), (_vm.order.order_payment_status_id != 18) ? _c('div', {
    staticClass: "mobile-fix-nav-2"
  }, [_c('p', {
    staticStyle: {
      "padding": "0 5px"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.order.order_status_id == 2) ? _c('div', {
    staticStyle: {
      "background": "#e94b4b",
      "width": "100vw",
      "padding": "0.8em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.updateOrders(_vm.order, 'delivered')
      }
    }
  }, [_vm._v("Mark order as delivered")])]) : _vm._e()]) : _vm._e()]) : _c('div', _vm._l((_vm.sellpoint_orders), function(order, odex) {
    return _c('div', {
      key: _vm.orderComponentKey,
      staticClass: "card card-flat-pad card-striped"
    }, [(order.order_status_id != 20) ? _c('div', [(_vm.sellpoint.business_agent == 1) ? _c('a', {
      staticStyle: {
        "float": "right",
        "color": "inherit",
        "font-weight": "bolder",
        "text-decoration": "underline"
      },
      attrs: {
        "href": '/' + order.order_business_username
      }
    }, [_vm._v(_vm._s(order.order_business))]) : _vm._e(), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('orders', order)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(order.order_time_ago))]), _c('br'), _vm._v(_vm._s(order.order_user)), _c('br'), _c('b', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(order.order_total.toFixed(2)))]), _vm._v(" "), _c('br'), _vm._v(" "), (order.order_status_id == 20) ? _c('p', {
      staticStyle: {
        "color": "#e94b4b"
      }
    }, [_c('b', [_vm._v("Confirm order")])]) : _vm._e(), _vm._v(" "), (order.order_status_id == 2) ? _c('p', {
      staticStyle: {
        "color": "#e94b4b"
      }
    }, [_vm._v("Mark order as delivered")]) : _vm._e(), _vm._v(" "), (order.order_status_id == 18) ? _c('p', {
      staticStyle: {
        "color": "#337ab7"
      }
    }, [_vm._v("Delivered")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [(order.order_items && (order.order_items.length != 0)) ? _c('span', [_c('b', [_vm._v(_vm._s(order.order_items.length) + " item(s)")]), _c('br')]) : _vm._e(), _vm._v(" "), _vm._l((order.order_items), function(item, idex) {
      return (idex < 2) ? _c('div', {
        staticStyle: {
          "display": "inline"
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.img_product_url + item.product_item_group_image,
          "height": "35",
          "width": "35"
        }
      })]) : _vm._e()
    })], 2), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]) : _c('div', [_c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Pending Order Payment Confirmation\r\n                "), (_vm.sellpoint.business_agent == 0) ? _c('span', [_c('br'), _c('b', [_vm._v("Please clear payments")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(order.order_time_ago))]), _c('br'), _vm._v(_vm._s(order.order_user)), _c('br'), _c('b', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(order.order_total.toFixed(2)))]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [(order.order_items && (order.order_items.length != 0)) ? _c('span', [_c('b', [_vm._v(_vm._s(order.order_items.length) + " item(s)")]), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Pending Order-Payments Confirmation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-bell",
    staticStyle: {
      "color": "#ffffff"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "left",
      "width": "55%",
      "font-size": "13px"
    }
  }, [_c('b', [_vm._v("Amount to pay")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left-50"
  }, [_c('p', [_vm._v("Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left-50"
  }, [_c('p', [_vm._v("Payment Ref")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left-50"
  }, [_c('p', [_vm._v("Date")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Business Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Commissions earned in this Order")])])
}]}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "header-wrap-sticky"
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), (_vm.loading) ? _c('div') : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "3em",
      "padding": "2em"
    }
  }, [_c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "border": "#000000 solid 1px"
    }
  }, [_c('div', {
    staticClass: "containeraa"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "height": "13em",
      "border": "#eee solid 1px",
      "border-radius": "8px"
    }
  }, [_vm._v("\r\n                  hinnnnhhuhu88888\r\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "height": "50vh"
    }
  }, [_c('div', {
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin": "0em",
      "margin-top": "1em",
      "background": "#ffffff"
    }
  }, _vm._l((_vm.products), function(product, index) {
    return (product.product_images.length > 0) ? _c('div', {
      staticClass: "col-xs-3"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('a', {
      staticClass: "card-link",
      attrs: {
        "href": '/make/order/' + product.product_url_name
      }
    }, [_c('div', {}, [(product.product_images[0]) ? _c('img', {
      staticClass: "card-col-d-img",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('span', {
      staticStyle: {
        "display": "block"
      },
      attrs: {
        "id": 'prdQty' + index
      }
    }, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'sub', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(product.product_items[0].product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'add', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])])]), _vm._v(" "), (_vm.checkOrderItems(product.product_items[0])) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(1, product.product_items[0], index, 0);
          _vm.toggleSingleComponent('prdQty' + index)
        }
      }
    }, [_vm._m(0, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(1, product.product_items[0], index, 0);
          _vm.toggleSingleComponent('prdQty' + index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])])])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])])]), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "height": "80vh",
      "border": "#000000 solid 1px"
    }
  }, [_c('button', [_vm._v("Checkout")])])
}]}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loggedIn) ? _c('div', {
    staticClass: "hidden-sm hidden-xs"
  }, [_c('div', {
    staticClass: "profile-card"
  }, [_c('img', {
    staticClass: "profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _vm._v(" "), _c('h5', [_c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "timeline"
    }
  }, [_vm._v(_vm._s(_vm.user.user_name))])]), _vm._v(" "), _vm._m(0), _c('br'), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" 62 shops")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ion ion-android-person-add"
  }), _vm._v(" 1,500 friends")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav-news-feed"
  }, [_c('li', [_c('i', {
    staticClass: "icon ion-ios-paper"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Tradefair Newsfeed")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon fa fa-shopping-cart"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Shops Following")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-ios-people-outline"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Friends")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-chatboxes"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Discussions / Messages")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-images"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Orders")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon fa fa-bell"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("No6ifications")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs"
  }, [_c('div', {
    staticClass: "profile-card"
  }, [_c('p', [_vm._v("Do you dream of the day you will use naijabrandtradefair2019 and really make so much sales? Like the day you will stop struggling to pay bills because sales aren’t forth coming, Or maybe you want to be your own brand influencer but your visibility keeps diminishing day by day …")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sticky-feeds"
    }
  }, [_c('h4', {
    staticClass: "grey"
  }, [_vm._v("Ongoing Activities")]), _vm._v(" "), _c('div', {
    staticClass: "feed-item"
  }, [_c('div', {
    staticClass: "live-activity"
  }, [_c('p', [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _c('a', {
    staticClass: "profile-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Olu Jane Stores")]), _vm._v(" Commented on a product")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("5 mins ago")])])]), _vm._v(" "), _c('div', {
    staticClass: "feed-item"
  }, [_c('div', {
    staticClass: "live-activity"
  }, [_c('p', [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _c('a', {
    staticClass: "profile-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Lami Fashion Store")]), _vm._v(" Has posted a product")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("an hour ago")])])]), _vm._v(" "), _c('div', {
    staticClass: "feed-item"
  }, [_c('div', {
    staticClass: "live-activity"
  }, [_c('p', [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _c('a', {
    staticClass: "profile-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Trish Hairs")]), _vm._v(" Liked friend's product")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("4 hours ago")])])]), _vm._v(" "), _c('div', {
    staticClass: "feed-item"
  }, [_c('div', {
    staticClass: "live-activity"
  }, [_c('p', [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _c('a', {
    staticClass: "profile-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("LuluBeads Crafts")]), _vm._v(" has shared a product")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("a day ago")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Tradefair Talks")]), _vm._v(" "), _c('ul', {
    staticClass: "online-users list-inline"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Cynthia Belonwu"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Jubril Sani"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Sandra Oseni"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Titilo Bass"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Jayden Ajibade"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Nonso Obi"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Efiong Dun"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Chika Nnabi"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Bolaji Adewale"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])])])])])])
}]}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container card-box"
  }, [_c('div', {
    staticClass: "row card-box-o"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("start with")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "display": "none",
      "padding-top": "3em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-6 col-sm-offset-1"
  }, [_c('div', {
    staticClass: "sp1-reg",
    staticStyle: {
      "background": "#ffffff",
      "padding": "2em",
      "border-radius": "2px"
    }
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "register"
    }
  }, [_c('h3', [_vm._v("Create A Sellpoint")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Set up a Store for your Business!")]), _vm._v(" "), _c('form', {
    staticClass: "form-inline",
    attrs: {
      "name": "registration_form",
      "id": "registration_form"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "business_name"
    }
  }, [_vm._v("Business Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_name),
      expression: "business.business_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "business_name",
      "type": "text",
      "name": "business_name",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.business.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "business_user_name"
    }
  }, [_vm._v("Business Username"), (_vm.validate_user_name_error) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.validate_user_name_message))]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_user_name),
      expression: "business.business_user_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "business_user_name",
      "type": "text",
      "name": "business_name",
      "title": "Enter  name",
      "placeholder": "Your unique Business User Name"
    },
    domProps: {
      "value": (_vm.business.business_user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_user_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Business Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select a Category")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Do you sell in any of these markets?")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_market_group),
      expression: "business.business_market_group"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_market_group = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select a Market")]), _vm._v(" "), _vm._l((_vm.market_groups), function(business_market_group) {
    return _c('option', {
      domProps: {
        "value": business_market_group.business_market_group
      }
    }, [_vm._v(_vm._s(business_market_group.business_market_group_name))])
  })], 2)])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#43a1fa"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    on: {
      "click": _vm.createSellpoint
    }
  }, [_vm._v("Create")])])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-onboarding"
  }, [_c('div', {
    staticClass: "card card-row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('a', {
    attrs: {
      "href": "account?t=newsp"
    }
  }, [_vm._v("Register Businesses and create Sellpoints")])])])])
}]}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "background": "#ffffff"
    },
    attrs: {
      "id": "topPanel"
    }
  }, [_c('div', {}, [_c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0.3em",
      "margin-bottom": "3em"
    }
  }, [(_vm.set_view == 'newBusiness') ? _c('div', {
    staticClass: "row"
  }, [_c('component-createsellpoint'), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-sm sp-button-02",
    on: {
      "click": function($event) {
        _vm.set_view = 'business'
      }
    }
  }, [_vm._v("<< Back")])], 1) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "min-height": "80vh",
      "margin": "0.51em",
      "padding": "2em 3em",
      "border-radius": "5px",
      "box-shadow": "0 0 30px 4px rgba(0,0,0,0.03)"
    }
  }, [_vm._l((_vm.sellpoints), function(sellpoint, index) {
    return _c('div', {
      staticClass: "row",
      staticStyle: {
        "min-height": "65px",
        "padding": "1em",
        "background-color": "#ffffff",
        "border-radius": "5px",
        "box-shadow": "0 0 30px 4px rgba(0,0,0,0.03)"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.setViewBusiness(sellpoint.business_username, index)
        }
      }
    }, [_c('div', [_c('h3', {
      staticStyle: {
        "text-transform": "uppercase",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(sellpoint.business_name))]), _vm._v(" "), (_vm.action_loading == index) ? _c('span', [_c('i', {
      staticClass: "fas fa-circle-notch fa-spin fa-1x"
    }), _c('br')]) : _vm._e(), _vm._v(" "), _c('a', [_vm._v("Select")])])])])
  }), _vm._v(" "), ((Object.keys(_vm.sellpoints).length < _vm.sellpoints_max)) ? _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn sp-button-02",
    on: {
      "click": function($event) {
        _vm.set_view = 'newBusiness'
      }
    }
  }, [_vm._v("Add New Business")])]) : _vm._e()], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin": "0.1em",
      "margin-top": "-0.2em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card card-box-fl"
  }, [_c('h4', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setItemSettings('/manage/items/settings/resetcategory')
      }
    }
  }, [_vm._v("\n                            Move to new Category\n                            "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-box-fl"
  }, [_c('h4', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setItemSettings('manage/items/settings/addtocategories')
      }
    }
  }, [_vm._v("\n                            Add to new Categories\n                            "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])
}]}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100vw"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "col-md-6 col-md-offset-4 col-xs-12"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticClass: "row cart-widget",
    staticStyle: {
      "width": "100vw",
      "margin-top": "-0.2em"
    }
  }, [(((_vm.has_part_payments_request > 0) && (!_vm.buy_now_order))) ? _c('div', [_c('p', [_vm._v("you have some part payment orders")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.part_payments_request_option = true;
        _vm.prepCart();
        _vm.has_part_payments_request = 0;
      }
    }
  }, [_vm._v("Process Part Payment Orders")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.has_part_payments_request = 0
      }
    }
  }, [_vm._v("Process Orders")])]) : _c('div', {
    staticStyle: {
      "background": "#ffffff",
      "margin": "0 1em"
    }
  }, [_c('div', {
    staticClass: "cart-summ",
    staticStyle: {
      "text-align": "left",
      "width": "100%",
      "margin-bottom": "1em"
    }
  }, [(!_vm.buy_now_order) ? _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Select Items to checkout and click *Process Orders* to continue.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "15em"
    }
  }, _vm._l((_vm.sorted_cart), function(group, index) {
    return (group.can_show) ? _c('div', {
      staticClass: "group-row",
      staticStyle: {
        "margin-bottom": "2em",
        "height": "auto"
      }
    }, [(!_vm.buy_now_order) ? _c('div', [(group.is_from_agent && (group.is_from_agent == 1)) ? _c('p', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('a', {
      staticClass: "sp-app-default-color",
      attrs: {
        "href": group.business_agent_username
      }
    }, [_vm._v(_vm._s(group.business_agent_name))])]) : _c('p', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('a', {
      staticClass: "sp-app-default-color",
      attrs: {
        "href": group[0]
      }
    }, [_vm._v(_vm._s(group.business_name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none",
        "float": "right",
        "margin-right": "5px"
      }
    }, [_c('div', {
      staticStyle: {
        "height": "2em"
      }
    }, [(group.selected_business_delivery_option || group.delivery_general_set_option) ? _c('div', [(group.selected_business_delivery_option) ? _c('p', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_c('b', [_vm._v("Shipping: ")]), _vm._v(_vm._s(group.selected_business_delivery_option.business_delivery_option) + " - ₦" + _vm._s(group.selected_business_delivery_option.business_delivery_option_price))]) : _vm._e(), _vm._v(" "), (group.delivery_general_set_option && (group.delivery_general_set_option.city)) ? _c('p', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_c('b', [_vm._v("Shipping: ")]), _vm._v(_vm._s(group.delivery_general_set_option.city.city_name) + "-" + _vm._s(group.delivery_option))]) : _vm._e()]) : _c('div', [(group.business_min_delivery_fee != 0 && (group.business_max_delivery_fee.length != 0)) ? _c('div', [_c('p', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_c('b', [_vm._v("Shipping: ")]), _vm._v("₦" + _vm._s(group.business_min_delivery_fee) + " - ₦" + _vm._s(group.business_max_delivery_fee))])]) : _vm._e()])]), _vm._v(" "), (group.show_delivery_option > 0) ? _c('div', [(group[2] && (group[2].length == 0)) ? _c('div', [_c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Free Delivery")])]) : _c('div', {
      key: _vm.shipping_fee_key_options,
      staticStyle: {
        "margin-top": "-1em"
      }
    }, [(group.delivery_states.length == 1) ? _c('div') : _c('div', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.delivery_selected_state),
        expression: "group.delivery_selected_state"
      }],
      staticClass: "sp-form-select sp-select",
      staticStyle: {
        "height": "28px",
        "padding": "0",
        "margin-bottom": "3px",
        "font-size": "12px"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.delivery_selected_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getDeliveryLocations(index, group.delivery_selected_state)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((group.delivery_states), function(state) {
      return _c('option', {
        domProps: {
          "value": state
        }
      }, [_vm._v(_vm._s(state.state_name))])
    })], 2)]), _vm._v(" "), (((group.delivery_states.length == 1) || (group.delivery_selected_state))) ? _c('div', {
      attrs: {
        "id": index + 'BDLS'
      }
    }, [_c('div', {
      key: _vm.componentDeliveryLocationsKey
    }, [(group.selected_delivery_state_locations.length != 0) ? _c('div', [_c('div', {
      staticClass: "dropdown"
    }, [(group.delivery_states.length == 1) ? _c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(group.delivery_states[0].state_name) + ":")]) : _vm._e(), _vm._v(" "), (group.selected_business_delivery_option) ? _c('button', {
      staticClass: "dropbtn"
    }, [(group.selected_business_delivery_option.has_product_delivery_fee) ? _c('span', [_vm._v("\r\n                                    " + _vm._s(group.selected_business_delivery_option.business_delivery_option) + " -  ₦" + _vm._s(group.selected_business_delivery_option.business_product_delivery_fee) + "▼\r\n                                  ")]) : _c('span', [_vm._v("\r\n                                    " + _vm._s(group.selected_business_delivery_option.business_delivery_option) + " -  ₦" + _vm._s(group.selected_business_delivery_option.business_delivery_option_price) + "▼\r\n                                  ")])]) : _c('button', {
      staticClass: "dropbtn"
    }, [_vm._v("Select Delivery Location ▼")]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-content"
    }, _vm._l((group.selected_delivery_state_locations), function(option) {
      return _c('div', [(option.business_delivery_product == 0) ? _c('span', [_c('label', [_c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.sellpoint_delivery_fee),
          expression: "sellpoint_delivery_fee"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": option.business_delivery_option_id,
          "checked": _vm._q(_vm.sellpoint_delivery_fee, option.business_delivery_option_id)
        },
        on: {
          "click": function($event) {
            _vm.calc_sellpoint_delivery_fee(index, option)
          },
          "__c": function($event) {
            _vm.sellpoint_delivery_fee = option.business_delivery_option_id
          }
        }
      })]), _vm._v(" "), _c('span', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v("\r\n                                          " + _vm._s(option.business_delivery_option) + " -  ₦" + _vm._s(option.business_delivery_option_price) + "\r\n                                        ")])])]) : _vm._e()])
    }))])]) : _c('div', [_c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Free Delivery")])])])]) : _vm._e()])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _vm._l((group[1]), function(item, index2) {
      return (item.can_show) ? _c('div', {
        staticClass: "row cart-details cart-item-row",
        staticStyle: {
          "margin": "0 auto",
          "margin-bottom": "8px"
        }
      }, [_c('div', {
        staticClass: "col-xs-2 cart-item-row-left",
        staticStyle: {
          "margin": "0",
          "padding": "0",
          "padding-left": "5px"
        }
      }, [_c('div', {
        staticStyle: {
          "float": "right",
          "margin-left": "0px",
          "margin-bottom": "7px"
        }
      }, [_c('div', {
        staticStyle: {
          "width": "100%",
          "padding-top": "1em"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "href": item.product_url
        }
      }, [((item.product_item_image && (item.product_item_image != ''))) ? _c('img', {
        staticStyle: {
          "border-radius": "15px"
        },
        attrs: {
          "src": _vm.img_product_url + item.product_item_image,
          "width": "100%;"
        }
      }) : _c('img', {
        staticStyle: {
          "border-radius": "15px"
        },
        attrs: {
          "src": "/static/assets/images/dummy-image.png",
          "width": "100%"
        }
      })])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "padding-top": "-1.82em"
        }
      }, [(item.product_checked) ? _c('input', {
        staticClass: "check-select",
        attrs: {
          "type": "checkbox",
          "checked": ""
        },
        on: {
          "click": function($event) {
            _vm.removeFromCheckout(item, index, index2)
          }
        }
      }) : _c('input', {
        staticClass: "check-select",
        attrs: {
          "type": "checkbox"
        },
        on: {
          "click": function($event) {
            _vm.addToCheckout(item, index, index2)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticStyle: {
          "font-size": "14px",
          "color": "#311010",
          "margin-left": "-0.38em"
        }
      }, [_vm._v("Select")])])])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-10 cart-item-row-right",
        staticStyle: {
          "margin": "0",
          "padding": "0",
          "padding-top": "1em",
          "padding-left": "1em"
        }
      }, [_c('div', {
        staticClass: "w-flow",
        staticStyle: {
          "margin-top": "1px"
        }
      }, [_c('p', [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), (item.product_item_order_quantity > 1) ? _c('span', {
        staticClass: "price",
        attrs: {
          "id": 'qty_t' + index2
        }
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.formatCurrency_2(item.product_item_order_quantity * item.product_item_price)))]) : _c('span', {
        staticClass: "price",
        attrs: {
          "id": 'qty_t' + index2
        }
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.formatCurrency_2(item.product_item_price)))])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "float": "right",
          "margin-top": "-3em"
        }
      }, [_c('div', {
        staticClass: "col-xs-12",
        staticStyle: {
          "margin": "0",
          "padding": "0"
        }
      }, [_c('a', {
        staticClass: "col-xs-1",
        staticStyle: {
          "cursor": "pointer",
          "text-decoration": "none",
          "padding": "1px 3px",
          "width": "25px",
          "font-weight": "bolder",
          "font-size": "14px",
          "color": "#000000"
        },
        on: {
          "click": function($event) {
            _vm.removeRefreshCheckout(item, index, index2)
          }
        }
      }, [_vm._v("–")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.product_item_order_quantity),
          expression: "item.product_item_order_quantity"
        }],
        staticClass: "col-xs-2 qty-input qty-input-sm",
        staticStyle: {
          "width": "38px"
        },
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": (item.product_item_order_quantity)
        },
        on: {
          "change": function($event) {
            _vm.refreshCheckout(item, index, index2)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            item.product_item_order_quantity = $event.target.value
          }
        }
      }), _vm._v(" "), _c('a', {
        staticClass: "col-xs-1",
        staticStyle: {
          "cursor": "pointer",
          "text-decoration": "none",
          "padding": "1px 3px",
          "width": "25px",
          "font-weight": "bolder",
          "font-size": "14px",
          "color": "#ff0000"
        },
        on: {
          "click": function($event) {
            _vm.addRefreshCheckout(item, index, index2)
          }
        }
      }, [_vm._v(" +")])]), _vm._v(" "), _c('p', {
        staticStyle: {
          "color": "#f73676"
        },
        attrs: {
          "id": 'qty_c' + index2
        }
      }, [_vm._v(_vm._s(item.check_order_quantity))])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "float": "right",
          "margin-top": "3em",
          "display": "block"
        }
      }, [_c('a', {
        staticStyle: {
          "margin-right": "4px",
          "font-size": "12px",
          "color": "#ff0000",
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.removeFromCart(item._id, index, item)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-close"
      }), _vm._v(" REMOVE")])])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "cart-item-row-full"
      }, [_c('div', {
        staticStyle: {
          "float": "left"
        }
      }, [(group.selected_business_delivery_option && item.product_checked) ? _c('p', [(group.selected_business_delivery_option.has_product_delivery_fee) ? _c('span', _vm._l((group.selected_business_delivery_option.business_products_delivery_fees), function(pd_fee) {
        return _c('span', [(item.product_main_id == pd_fee.product_delivery_product) ? _c('span', [_vm._v("\r\n                              Shipping Fee: ₦" + _vm._s(pd_fee.product_delivery_fee) + "\r\n                              "), _vm._v(" "), _c('label', {
          staticStyle: {
            "display": "inline"
          }
        }, [_vm._v("Total: ₦" + _vm._s(item.calculated_product_delivery_fee))])]) : _vm._e()])
      })) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticStyle: {
          "float": "right",
          "display": "none"
        }
      }, [_c('span', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.chk),
          expression: "item.chk"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(item.chk) ? _vm._i(item.chk, null) > -1 : (item.chk)
        },
        on: {
          "click": function($event) {
            _vm.toggleSingleDisplay(item.chk, index + 's_itm_d' + index2)
          },
          "__c": function($event) {
            var $$a = item.chk,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (item.chk = $$a.concat($$v))
              } else {
                $$i > -1 && (item.chk = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              item.chk = $$c
            }
          }
        }
      }), _vm._v("Gift/Send this Product to a different location")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "none"
        },
        attrs: {
          "id": index + 's_itm_d' + index2
        }
      })]), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      }), _vm._v(" "), _c('div', {
        staticStyle: {
          "padding-left": "0.6em"
        }
      }, _vm._l((item.product_item_discounts), function(coupon) {
        return (coupon.discount_status_id != 8) ? _c('p', {
          staticStyle: {
            "line-height": "1.0",
            "font-size": "10px"
          }
        }, [((((coupon.discount_coupon == 'C') && (coupon.discount_product == item.product_main_id)) || ((coupon.discount_coupon == 'C') && (coupon.discount_product_item == item.product_item_id)))) ? _c('span', [(item.item_order_coupons_discounts.length == 0) ? _c('span', {
          staticStyle: {
            "color": "#4e504e",
            "font-size": "12px"
          }
        }, [_vm._v("\r\n                          Get " + _vm._s(coupon.discount_percentage) + "% Off"), ((coupon.discount_min_quantity > 0)) ? _c('span', [_vm._v(" on " + _vm._s(coupon.discount_min_quantity) + " and above order of this item")]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((item.product_item_order_quantity >= coupon.discount_min_quantity)) ? _c('span', [_c('br'), _vm._v(" "), (item.product_checked) ? _c('span', [_c('input', {
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "value": coupon.discount_id + item.product_item_id
          },
          on: {
            "click": function($event) {
              _vm.set_coupons(index, index2, coupon, coupon.discount_percentage)
            }
          }
        })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(coupon.discount_coupon_code) + " ( " + _vm._s(coupon.discount_percentage) + "% Off)\r\n                            "), _c('br'), _c('span', {
          staticStyle: {
            "color": "#ff0000",
            "font-size": "12px"
          }
        }, [(item.product_checked) ? _c('span', [_vm._v("select")]) : _vm._e(), _vm._v(" coupon")])])]) : _vm._e()]) : _vm._e()]) : _vm._e()
      })), _vm._v(" "), (_vm.buy_now_order) ? _c('div', {
        staticClass: "mobile-fix-nav"
      }, [_c('div', {
        staticStyle: {
          "background": "#ffa800",
          "width": "100vw",
          "padding": "0.8em",
          "text-align": "center"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer",
          "color": "#000000",
          "text-decoration": "none"
        },
        on: {
          "click": function($event) {
            _vm.addToCheckout(item, index, index2)
          }
        }
      }, [_vm._v("Process Order")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      })]) : _vm._e()
    }), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [(group.items_in_checkout > 0) ? _c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [(group.items_in_checkout > 0) ? _c('div', [((group[4] && (Object.keys(group[4]).length !== 0))) ? _c('div', {
      key: _vm.couponsComponentKey,
      staticClass: "coupons-sec"
    }, [_c('h4', {
      staticClass: "cart-hh"
    }, [_vm._v("Store Coupons")]), _vm._v(" "), _vm._l((group[4]), function(coupon, coupdex) {
      return _c('p', [(((coupon.discount_is_specific_use == 0) || ((coupon.discount_is_specific_use == 1) && (coupon.discount_module_id == _vm.user.user_id)))) ? _c('span', [(((coupon.discount_is_private == 0) || ((coupon.discount_is_private == 1) && (coupon.discount_validated == 1)))) ? _c('span', [(((coupon.discount_type == 2) || (coupon.discount_type == 3))) ? _c('span', [((group.items_in_checkout >= coupon.discount_min_quantity)) ? _c('span', [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": coupon.discount_id
        },
        on: {
          "click": function($event) {
            _vm.set_coupons(index, 0, coupon, coupon.discount_percentage)
          }
        }
      }), _vm._v(" " + _vm._s(coupon.discount_coupon_code) + " ( " + _vm._s(coupon.discount_percentage) + "% Off )")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), ((!coupon.added && (group.items_in_checkout <= coupon.discount_min_quantity))) ? _c('span', {
        staticStyle: {
          "color": "#4e504e",
          "font-size": "12px"
        }
      }, [_vm._v("Get " + _vm._s(coupon.discount_percentage) + "% Off"), ((coupon.discount_min_quantity > 0)) ? _c('span', [_vm._v(" from " + _vm._s(coupon.discount_min_quantity) + " and above items")]) : _vm._e()]) : _vm._e()]) : _vm._e()]) : _vm._e()]) : _vm._e()])
    }), _vm._v(" "), _c('div', {}, [_c('p', {
      staticClass: "sp-app-default-color",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("Enter a Coupon Code if you have any")]), _vm._v(" "), _c('div', {
      staticClass: "form-group",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.coupon_entry),
        expression: "coupon_entry"
      }],
      staticClass: "form-control",
      staticStyle: {
        "float": "left",
        "width": "80%"
      },
      attrs: {
        "type": "text",
        "placeholder": "Enter Coupon"
      },
      domProps: {
        "value": (_vm.coupon_entry)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.coupon_entry = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "sp-button-1 sp-button-sm btn",
      staticStyle: {
        "float": "right",
        "width": "20%",
        "padding": "0.65em",
        "background-color": "#f7efd7"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.verifyCouponEntry(index)
        }
      }
    }, [_vm._v("OK")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "12px",
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.coupon_entry_error))])])], 2) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [(((group.items_in_checkout > 0) || (_vm.buy_now_order))) ? _c('h4', {
      staticClass: "cart-hh"
    }, [_vm._v("Delivery Details")]) : _vm._e(), _vm._v(" "), (group.selected_delivery_state_locations && (group.selected_delivery_state_locations.length == 0)) ? _c('div', {
      staticStyle: {
        "clear": "both",
        "text-align": "left"
      }
    }, [(group.selected_business_delivery_option || group.delivery_general_set_option) ? _c('div', [(group.selected_business_delivery_option && (group.selected_business_delivery_option.business_delivery_option_price)) ? _c('p', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_c('b', [_vm._v("Shipping: ")]), _vm._v(_vm._s(group.selected_business_delivery_option.business_delivery_option) + " - ₦" + _vm._s(group.selected_business_delivery_option.business_delivery_option_price))]) : _vm._e(), _vm._v(" "), (group.delivery_general_set_option && (group.delivery_general_set_option.city)) ? _c('p', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_c('b', [_vm._v("Shipping: ")]), _vm._v(_vm._s(group.delivery_general_set_option.city.city_name) + "-" + _vm._s(group.delivery_option))]) : _vm._e()]) : _c('div', [(group.business_min_delivery_fee != 0 && (group.business_max_delivery_fee.length != 0)) ? _c('div', [_c('p', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_c('b', [_vm._v("Shipping: ")]), _vm._v("₦" + _vm._s(group.business_min_delivery_fee) + " - ₦" + _vm._s(group.business_max_delivery_fee))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (((group.items_in_checkout > 0) || (_vm.buy_now_order))) ? _c('div', [_vm._m(0, true), _vm._v(" "), _c('div', {
      key: _vm.shipping_fee_key_options,
      staticStyle: {
        "width": "80%",
        "float": "right",
        "padding": "3px"
      }
    }, [_c('p', [_c('span', [_c('b', [(group.delivery_selected_state && (Object.keys(group.delivery_selected_state).length > 0)) ? _c('span', [_vm._v("\r\n                              " + _vm._s(group.delivery_selected_state.state_name) + "\r\n                            ")]) : _c('span', [_vm._v("No Address set")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [(group.selected_business_delivery_option && (Object.keys(group.selected_business_delivery_option).length > 0)) ? _c('span', [_vm._v("\r\n                              " + _vm._s(group.selected_business_delivery_option.business_delivery_option) + "\r\n                            ")]) : _c('span', [_vm._v("Select Delivery location")])])])]), _vm._v(" "), (_vm.buy_now_order) ? _c('div', {
      staticStyle: {
        "width": "5%",
        "float": "right",
        "margin-left": "9em",
        "margin-top": "-4em",
        "padding": "1em",
        "text-align": "center"
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-right",
      staticStyle: {
        "font-weight": "bolder",
        "font-size": "18px"
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]) : _vm._e(), _vm._v(" "), (group.items_in_checkout > 0) ? _c('div', {
      staticClass: "delivery-sec",
      staticStyle: {
        "width": "100%"
      }
    }, [(group.show_delivery_option > 0) ? _c('div', [_c('div', {
      key: _vm.shipping_fee_key_options
    }, [(group[2]) ? _c('div', [_c('div', [(group[2].length != 0 && !group.delivery_option) ? _c('span', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Please select a delivery option"), _c('br')]) : _vm._e()]), _vm._v(" "), (group.delivery_states.length == 1) ? _c('div', [_vm._v("\r\n                              Shipping State:" + _vm._s(group.delivery_states[0].state_name) + "\r\n                            ")]) : _c('div', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.delivery_selected_state),
        expression: "group.delivery_selected_state"
      }],
      staticClass: "sp-form-select sp-select",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.delivery_selected_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getDeliveryLocations(index, group.delivery_selected_state)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((group.delivery_states), function(state) {
      return _c('option', {
        domProps: {
          "value": state
        }
      }, [_vm._v(_vm._s(state.state_name))])
    })], 2)])]) : _c('div', [_c('div', {}, [_c('label', [_vm._v("State: ")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.order_delivery_main_location.state),
        expression: "order_delivery_main_location.state"
      }],
      staticClass: "sp-form-select sp-select",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.order_delivery_main_location.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities(_vm.order_delivery_main_location.state)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2)]), _vm._v(" "), (_vm.cities.length != 0) ? _c('div', {}, [_c('label', [_vm._v("Location: ")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.order_delivery_main_location.city),
        expression: "order_delivery_main_location.city"
      }],
      staticClass: "sp-form-select sp-select",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.order_delivery_main_location.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.setOrderLocations(_vm.order_delivery_main_location)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city
        }
      }, [_vm._v(_vm._s(city.city_name))])
    })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
      attrs: {
        "id": index + 'BDLS'
      }
    }, [_c('div', {
      key: _vm.componentDeliveryLocationsKey
    }, [(group.selected_delivery_state_locations.length != 0) ? _c('div', [_c('div', {
      staticClass: "dropdown"
    }, [(group.selected_business_delivery_option) ? _c('button', {
      staticClass: "dropbtn"
    }, [(group.selected_business_delivery_option.has_product_delivery_fee) ? _c('span', [_vm._v("\r\n                                      " + _vm._s(group.selected_business_delivery_option.business_delivery_option) + " -  ₦" + _vm._s(group.selected_business_delivery_option.business_product_delivery_fee) + "▼\r\n                                    ")]) : _c('span', [_vm._v("\r\n                                      " + _vm._s(group.selected_business_delivery_option.business_delivery_option) + " -  ₦" + _vm._s(group.selected_business_delivery_option.business_delivery_option_price) + "▼\r\n                                    ")])]) : _c('button', {
      staticClass: "dropbtn",
      on: {
        "click": function($event) {
          _vm.showDropdown('deliveryLocation1')
        }
      }
    }, [_vm._v("Select Delivery Location ▼")]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-content",
      attrs: {
        "id": "deliveryLocation1"
      }
    }, _vm._l((group.selected_delivery_state_locations), function(option) {
      return _c('div', [(option.business_delivery_product == 0) ? _c('span', [_c('label', [((group.items_in_checkout > 0)) ? _c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.sellpoint_delivery_fee),
          expression: "sellpoint_delivery_fee"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": option.business_delivery_option_id,
          "checked": _vm._q(_vm.sellpoint_delivery_fee, option.business_delivery_option_id)
        },
        on: {
          "click": function($event) {
            _vm.calc_sellpoint_delivery_fee(index, option)
          },
          "__c": function($event) {
            _vm.sellpoint_delivery_fee = option.business_delivery_option_id
          }
        }
      })]) : _vm._e(), _vm._v(" "), _c('span', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [(option.business_is_delivery_business == 1) ? _c('span', {
        staticStyle: {
          "color": "#96c5f5"
        }
      }, [_vm._v(_vm._s(option.business_delivery_business_name)), _c('br')]) : _vm._e(), _vm._v(_vm._s(option.business_delivery_option) + " -  ₦" + _vm._s(option.business_delivery_option_price) + "\r\n                                          ")])])]) : _vm._e()])
    }))])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('p', {
      staticClass: "tiny-part",
      staticStyle: {
        "line-height": "0.4"
      }
    }, [_vm._v("Total Orders ₦" + _vm._s(parseFloat(group.total_order_amt).toFixed(2)))]), _vm._v(" "), (group[2]) ? _c('span', [_c('p', {
      key: _vm.shipping_fee_key,
      staticClass: "tiny-part",
      staticStyle: {
        "line-height": "0.4"
      }
    }, [_vm._v("Shipping Fee:  ₦" + _vm._s(group.total_delivery_charge))]), _vm._v(" "), _c('p', {
      key: _vm.total_orders_key,
      staticClass: "tiny-part",
      staticStyle: {
        "line-height": "0.4"
      }
    }, [_vm._v("Total: ₦" + _vm._s(parseFloat(group.total_order_amt + group.total_delivery_charge).toFixed(2)))])]) : _c('span', [_c('p', {
      staticClass: "tiny-part"
    }, [_c('b', [_vm._v("Shipping Details:")]), _vm._v(" " + _vm._s(group.delivery_option))])]), _vm._v(" "), (group[3]) ? _c('div', {
      staticClass: "row",
      staticStyle: {
        "display": "none"
      }
    }, [_vm._m(1, true), _vm._v(" "), (!group.payment_mode) ? _c('span', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Please select a payment option"), _c('br')]) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.payment_option),
        expression: "payment_option"
      }],
      attrs: {
        "type": "radio",
        "value": "pay_on_delivrey"
      },
      domProps: {
        "checked": _vm._q(_vm.payment_option, "pay_on_delivrey")
      },
      on: {
        "click": function($event) {
          _vm.setPaymentOption(index, 2)
        },
        "__c": function($event) {
          _vm.payment_option = "pay_on_delivrey"
        }
      }
    }), _c('label', [_vm._v("Pay On Delivery")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.payment_option),
        expression: "payment_option"
      }],
      attrs: {
        "type": "radio",
        "value": "pay_now"
      },
      domProps: {
        "checked": _vm._q(_vm.payment_option, "pay_now")
      },
      on: {
        "click": function($event) {
          _vm.setPaymentOption(index, 1)
        },
        "__c": function($event) {
          _vm.payment_option = "pay_now"
        }
      }
    }), _c('label', [_vm._v("Pay Now")])]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])], 2) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "mobile-fix-nav"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000",
      "margin-left": "15px"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.total_order_amt == 0 && (_vm.data_processing_message == '')) ? _c('span', {
    staticStyle: {
      "clear": "both",
      "color": "#ff0000",
      "margin-left": "15px"
    }
  }, [_vm._v("Select items to checkout")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card card-out-colord-pad",
    staticStyle: {
      "text-align": "left",
      "margin-top": "1em"
    }
  }, [(!_vm.buy_now_order) ? _c('div', {}, [_c('div', {
    staticClass: "size-h3 margin-bottom"
  }, [_vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "fl-right"
  }, [_vm._v("(" + _vm._s(_vm.cart.length) + " items)")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-cart__section in-cart-page"
  }, [_c('p', [_c('span', {
    staticClass: "fl-left"
  }, [_vm._v("Subtotal ")]), _vm._v(" "), _c('span', {
    staticClass: "fl-right"
  }, [_vm._v("₦" + _vm._s(_vm.formatCurrency_2(_vm.total_order_amt)))]), _vm._v(" "), _c('span', {
    staticClass: "clear"
  })]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "fl-left"
  }, [_vm._v("Shipping ")]), _vm._v(" "), _c('span', {
    staticClass: "fl-right"
  }, [_vm._v("₦" + _vm._s(_vm.formatCurrency_2(_vm.total_delivery_fee)))]), _vm._v(" "), _c('span', {
    staticClass: "clear"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('div', {}, [(_vm.buy_now_order) ? _c('span', [_c('b', [_vm._v("Order Total")]), _c('br'), _vm._v(" ₦" + _vm._s(_vm.formatCurrency_2(_vm.total_order_amt + _vm.total_delivery_fee)))]) : _c('span', [_c('h4', {
    staticClass: "cart-hh"
  }, [_vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "fl-right"
  }, [_vm._v("₦" + _vm._s(_vm.formatCurrency_2(_vm.total_order_amt + _vm.total_delivery_fee)))])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#ffa800",
      "width": "100vw",
      "padding": "0.8em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#000000",
      "background": "#ffa800",
      "text-decoration": "none"
    },
    attrs: {
      "disabled": _vm.disable_btn_01
    },
    on: {
      "click": function($event) {
        _vm.process_orders()
      }
    }
  }, [_vm._v("Process Orders")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-colord-pad card-colord-01",
    staticStyle: {
      "width": "15%",
      "float": "left",
      "padding": "1em",
      "border-radius": "5px",
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "18px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tiny-part"
  }, [_c('b', [_vm._v("Payment Mode")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "fl-left"
  }, [_c('h5', [_c('b', [_vm._v("Cart totals")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "fl-left"
  }, [_c('b', [_vm._v("Total ")])])
}]}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.sellpoint) ? _c('div', {
    staticStyle: {
      "text-align": "left",
      "padding": "1em",
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "menu-links-strip menu-links-strip-2"
  }, [_c('ul', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('product', 'setBusinessCategoryProductDetails', _vm.sellpoint, '/account/business/product')
      }
    }
  }, [_c('li', [_vm._v("\n            Product Details\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('product', 'setBusinessCategoryProductItems', _vm.sellpoint, '/account/business/product/types')
      }
    }
  }, [_c('li', [_vm._v("\n            Product Types / Variations\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('product', 'setBusinessCategoryProductReviews', _vm.sellpoint, '/account/business/product/reviews')
      }
    }
  }, [_c('li', [_vm._v("\n            Reviews\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('product', 'setBusinessCategoryProductOrders', _vm.sellpoint, '/account/business/product/orders')
      }
    }
  }, [_c('li', [_vm._v("\n            Orders\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('product', 'setBusinessCategoryProductAddOns', _vm.sellpoint, '/account/business/product/addons')
      }
    }
  }, [_c('li', [_vm._v("\n            Product Addons\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('product', 'setBusinessCategoryProductDiscountCoupons', _vm.sellpoint, '/account/business/product/discounts')
      }
    }
  }, [_c('li', [_vm._v("\n            Discounts and Coupons\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('product', 'setBusinessCategoryProductShippingInformation', _vm.sellpoint, '/account/business/product/shipping')
      }
    }
  }, [_c('li', [_vm._v("\n            Shipping and Delivery \n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat component-tabs"
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container card-box"
  }, [_c('div', {
    staticClass: "row card-box-o"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-6 col-sm-offset-1"
  }, [_c('div', {
    staticClass: "sp1-reg",
    staticStyle: {
      "background": "#ffffff",
      "padding": "2em",
      "padding-top": "0",
      "border-radius": "2px"
    }
  }, [(_vm.loading) ? _c('div', [_vm._m(0)]) : _c('div', {
    staticClass: "card"
  }, [_c('div', [_c('div', {
    staticClass: "card"
  }, [_c('form', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Price")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_price),
      expression: "product.product_price"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "number",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.product.product_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Details")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#43a1fa"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "color": "#000000",
      "background-color": "#e8fa43"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.editProduct()
      }
    }
  }, [_vm._v("Save Details")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Product Images")]), _vm._v(" "), _c('div', {
    staticClass: "category-slide"
  }, [_c('ul', _vm._l((_vm.product.product_images), function(img) {
    return _c('li', {
      staticStyle: {
        "width": "30%"
      }
    }, [(img.product_image && (img.product_image != '' && img.product_image != 'error')) ? _c('img', {
      staticClass: "pb_img",
      attrs: {
        "src": _vm.img_product_url + img.product_image,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "pb_img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs sp-button-02 sp-button-sm sp-button-style-1",
      staticStyle: {
        "font-size": "12px",
        "padding": "6px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteProductImage(img.product_image_id)
        }
      }
    }, [_vm._v("Remove")])])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.product.product_images && (_vm.product.product_images.length > 1)) ? _c('div', [_c('hr'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-transform": "uppercase"
    }
  }, [_vm._v(_vm._s(_vm.product.product_images.length) + " pictures, Swipe >>")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [(_vm.action_loading && _vm.product_details.uploading_image) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "upload-btn sp-button-02 sp-button-sm",
    staticStyle: {
      "line-height": "1.8",
      "font-size": "14px",
      "background-color": "#f7f7f7"
    }
  }, [_vm._v("Add new Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'products', _vm.product.product_id)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    key: _vm.componentKey,
    staticClass: "row"
  }, [_c('h3', [_vm._v("Order Addons")]), _vm._v(" "), _c('p', [_vm._v("Add Items that could be ordered together with this Order")]), _vm._v(" "), ((_vm.product.product_addons && (Object.keys(_vm.product.product_addons).length > 0))) ? _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.product.product_addons), function(product, index) {
    return _c('div', {
      staticClass: "card col-xs-4"
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + _vm.user.business_username
      }
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "card-avatar-square",
      staticStyle: {
        "width": "100px",
        "height": "95px"
      }
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block",
        "padding": "3px",
        "padding-left": "2em",
        "text-align": "center"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(product.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setAddToProductAddons(product)
        }
      }
    }), _vm._v("Remove\r\n                                    ")])])])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-sm",
    staticStyle: {
      "float": "right",
      "background": "#ff0066",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.removeProductAddons()
      }
    }
  }, [_vm._v("Done, remove Products to Add-ons")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "0.2em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('setProductAddons')
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), (_vm.menu_tab_inner_view['setProductAddons']) ? _c('div', [((Object.keys(_vm.set_product_addons).length > 0)) ? _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.set_product_addons), function(prd, index) {
    return (_vm.product.product_id != prd.product_id) ? _c('div', {
      staticClass: "card col-xs-4"
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "card-avatar-square",
      staticStyle: {
        "width": "100px",
        "height": "95px"
      }
    }, [(prd.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": prd.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block",
        "padding": "3px",
        "padding-left": "2em",
        "text-align": "center"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(prd.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(prd.product_items[0].product_item_price_f))])]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setAddToProductAddons(prd)
        }
      }
    })])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px",
      "display": "none"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-sm",
    staticStyle: {
      "float": "right",
      "background": "#ff0066",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.addToProductAddons()
      }
    }
  }, [_vm._v("Done, Add Products to Add-ons")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('form', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_product.product_name),
      expression: "set_product.product_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.set_product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.set_product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Price")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_product.product_price),
      expression: "set_product.product_price"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "number",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.set_product.product_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.set_product.product_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Details")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_product.product_description),
      expression: "set_product.product_description"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.set_product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.set_product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Product Photo ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "prImagePreview"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sp-form-descr"
  }, [_vm._v("Maximum Upload Size " + _vm._s(_vm.max_upload))]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Upload Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeNewProduct($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading && _vm.product_details.uploading_image) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "color": "#000000",
      "background-color": "#e8fa43"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddProductAsAddon(_vm.set_product)
      }
    }
  }, [_vm._v("Add")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Settings")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "0.2em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('contactDetails')
      }
    }
  }, [_vm._m(2)]), _vm._v(" "), (_vm.menu_tab_inner_view['contactDetails']) ? _c('div', [_c('div', [_c('h4', [_vm._v("Contact Details")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.sellpoint.business_phones))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.sellpoint.business_emails))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('editBusinessDetails');
      }
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "editBusinessDetails"
    }
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_name),
      expression: "sellpoint.business_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.sellpoint.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_phones),
      expression: "sellpoint.business_phones"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.sellpoint.business_phones)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_phones = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_emails),
      expression: "sellpoint.business_emails"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.sellpoint.business_emails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_emails = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('main')
      }
    }
  }, [_vm._v("Save Details")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('editBusinessDetails')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center",
      "padding-top": "0.2em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('bankDetails')
      }
    }
  }, [_vm._m(3)]), _vm._v(" "), (_vm.menu_tab_inner_view['bankDetails']) ? _c('div', {
    attrs: {
      "id": "bankDetails"
    }
  }, [_c('div', {
    staticClass: "card card-colord-01 card-colord-pad"
  }, [_vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Add your Bank Details to receive order payments")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [((!_vm.setEditBankDetails && (Object.keys(_vm.business_bank_details).length > 0))) ? _c('div', [_c('p', [_c('b', [_vm._v("Bank:")]), _vm._v(" " + _vm._s(_vm.business_bank_details.bank_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account Holder's Name:")]), _vm._v(" " + _vm._s(_vm.business_bank_details.bank_account_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account No:")]), _vm._v(" " + _vm._s(_vm.business_bank_details.bank_account_number))]), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("you can edit or change bank details")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setEditBankDetails = true;
      }
    }
  }, [_vm._v("Edit Bank Details")])]) : _vm._e(), _vm._v(" "), (((Object.keys(_vm.business_bank_details).length == 0) || _vm.setEditBankDetails)) ? _c('form', {
    staticClass: "sp-form",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(_vm.ravepay_bank_list && ((Object.keys(_vm.ravepay_bank_list).length == 0))) ? _c('div', [_vm._m(5)]) : _c('div', [_c('label', [_c('b', [_vm._v("Bank Name:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_bank_details.bank_name),
      expression: "business_bank_details.bank_name"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business_bank_details.bank_name = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select your bank")]), _vm._v(" "), _vm._l((_vm.ravepay_bank_list), function(bank) {
    return _c('option', {
      domProps: {
        "value": bank.Name
      }
    }, [_vm._v(_vm._s(bank.Name))])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_bank_details.bank_account_name),
      expression: "business_bank_details.bank_account_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.business_bank_details.bank_account_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business_bank_details.bank_account_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account No:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_bank_details.bank_account_number),
      expression: "business_bank_details.bank_account_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.business_bank_details.bank_account_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business_bank_details.bank_account_number = $event.target.value
      }
    }
  })]), _vm._v(" "), ((Object.keys(_vm.sellpoint).length > 0)) ? _c('div', [_c('p', {
    staticClass: "tiny-p"
  }), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.setBankDetails
    }
  }, [_vm._v("Save Bank Details")])]) : _vm._e()])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center",
      "padding-top": "0.2em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('deliveryLocations')
      }
    }
  }, [_vm._m(6)]), _vm._v(" "), (_vm.menu_tab_inner_view['deliveryLocations']) ? _c('div', {
    attrs: {
      "id": "deliveryLocations"
    }
  }, [((!_vm.setAddDeliveryLocation && (Object.keys(_vm.business_delivery_locations).length > 0))) ? _c('div', [_c('h3', [_vm._v("Delivery Locations")]), _vm._v(" "), _vm._l((_vm.business_delivery_locations), function(location, index) {
    return _c('div', [_c('p', [_vm._v(_vm._s(++index) + " - " + _vm._s(location.business_delivery_state) + " - " + _vm._s(location.business_delivery_option) + " - " + _vm._s(location.business_delivery_option_price) + "\r\n                                    "), _c('br'), _vm._v(" "), _c('span', [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('DL-CHANGE-PRICE-' + index)
        }
      }
    }, [_vm._v("Change Price")]), _vm._v("  | \r\n                                      "), _c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('DL-REMOVE-' + index)
        }
      }
    }, [_vm._v("Remove")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-box",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'DL-CHANGE-PRICE-' + index
      }
    }, [_c('p', [_c('b', [_vm._v("Current Price: ")]), _vm._v(_vm._s(location.business_delivery_option_price))]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Delivery Price")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (location.business_delivery_option_price),
        expression: "location.business_delivery_option_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (location.business_delivery_option_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          location.business_delivery_option_price = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.delivery_option = location;
          _vm.set_single_component_view = 'DL-CHANGE-PRICE-' + index;
          _vm.editDeliveryOption();
        }
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-box",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'DL-REMOVE-' + index
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Do you want to delete this location.")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.delivery_option = location;
          _vm.set_single_component_view = 'DL-REMOVE-' + index;
          _vm.deleteDeliveryOption(location.business_delivery_option_id);
        }
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('div'), _vm._v(" "), _c('hr')])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddDeliveryLocation = true;
      }
    }
  }, [_vm._v("Add Delivery Locations")])], 2) : _vm._e(), _vm._v(" "), (((Object.keys(_vm.business_delivery_locations).length == 0) || _vm.setAddDeliveryLocation)) ? _c('div', {
    key: _vm.componentDeliveryKey,
    staticClass: "card"
  }, [_c('h5', [_vm._v("Add a Delivery Location and Price")]), _vm._v(" "), (_vm.states && (Object.keys(_vm.states).length == 0)) ? _c('div', [_vm._m(7)]) : _c('div', [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.state),
      expression: "delivery_option.state"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.delivery_option.state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      key: state.state_id,
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.action_loading) ? _c('div', [_c('p', [_vm._v("...loading cities")])]) : _vm._e(), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.city),
      expression: "delivery_option.city"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOtherOptions(_vm.delivery_option.city, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      key: city.city_id,
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other Areas / Cities ")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.other_delivery_option) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_other_option),
      expression: "delivery_option.delivery_other_option"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "eg. Abuja"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_other_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_other_option = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Free Delivery?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_free),
      expression: "delivery_option.delivery_option_free"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.delivery_option.delivery_option_free) ? _vm._i(_vm.delivery_option.delivery_option_free, null) > -1 : (_vm.delivery_option.delivery_option_free)
    },
    on: {
      "click": function($event) {
        _vm.setFreeDelivery(1)
      },
      "__c": function($event) {
        var $$a = _vm.delivery_option.delivery_option_free,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.delivery_option.delivery_option_free = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.delivery_option.delivery_option_free = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.delivery_option.delivery_option_free = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.delivery_option.delivery_option_free != 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Delivery Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_price),
      expression: "delivery_option.delivery_option_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "eg. 1000"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_option_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_option_price = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (((Object.keys(_vm.sellpoint).length > 0) && (_vm.sellpoint.business_id > 0))) ? _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addDeliveryOption()
      }
    }
  }, [_vm._v("Add")]) : _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddDeliveryOptions(_vm.delivery_option)
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddDeliveryLocation = false;
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()]) : _vm._e()])])])])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "background": "#fff",
      "border-radius": "5px",
      "padding": "10px",
      "margin": "5px 5vw",
      "box-shadow": "0 7px 30px -10px rgba(150,170,180,0.5)"
    }
  }, [_vm._v("Add Addons "), _c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "font-size": "18px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "background": "#fff",
      "border-radius": "5px",
      "padding": "10px",
      "margin": "5px 35vw",
      "box-shadow": "0 7px 30px -10px rgba(150,170,180,0.5)"
    }
  }, [_vm._v("Contact Details "), _c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "font-size": "18px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "background": "#fff",
      "border-radius": "5px",
      "padding": "10px",
      "margin": "5px 35vw",
      "box-shadow": "0 7px 30px -10px rgba(150,170,180,0.5)"
    }
  }, [_vm._v("Manage "), _c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "font-size": "18px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Bank Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "background": "#fff",
      "border-radius": "5px",
      "padding": "10px",
      "margin": "5px 35vw",
      "box-shadow": "0 7px 30px -10px rgba(150,170,180,0.5)"
    }
  }, [_vm._v("Manage "), _c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "font-size": "18px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
}]}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [((_vm.set_ctaType == 1 || _vm.set_ctaType == 3)) ? _c('div', [(_vm.set_productMainView == 'cartactions') ? _c('span', [(_vm.canAdd) ? _c('div', [(_vm.set_ctaType == 1) ? _c('button', {
    staticClass: "cart-btn cart-btn-sm",
    staticStyle: {
      "width": "45vw"
    },
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v("Add to Cart")]) : _vm._e()]) : _c('div', [_c('div', {
    staticClass: "hidden-sm hidden-xs"
  }, [_c('div', {
    staticClass: "cart-cta-box"
  }, [_c('button', {
    staticClass: "cart-btn cart-btn-sm",
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View Cart")])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-md hidden-lg"
  }, [_c('button', {
    staticClass: "cart-btn cart-btn-sm",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View Cart")])])])]) : _c('div', {
    staticStyle: {
      "clear": "right"
    }
  }, [(_vm.canAdd) ? _c('div', [(_vm.set_ctaType == 1) ? _c('button', {
    staticClass: "cart-btn cart-btn-sm",
    staticStyle: {
      "width": "45vw"
    },
    on: {
      "click": _vm.addToCart
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    staticStyle: {
      "color": "#000000",
      "font-size": "16px"
    }
  }), _vm._v(" Add to Cart")]) : _vm._e()]) : _c('div', [_c('button', {
    staticClass: "cart-btn",
    staticStyle: {
      "width": "45vw",
      "font-size": "14px"
    },
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_vm._v("View Cart")])])])]) : _vm._e(), _vm._v(" "), (_vm.set_ctaType == 2) ? _c('div', [(_vm.canAdd) ? _c('div', [(_vm.set_productMainView == 'cartactions') ? _c('button', {
    staticClass: "cta-btn cta-btn-sm",
    staticStyle: {
      "width": "45vw"
    },
    on: {
      "click": _vm.addToCart
    }
  }, [_c('i', {
    staticClass: "fa fa-play",
    staticStyle: {
      "color": "#000000",
      "font-size": "16px"
    }
  }), _vm._v("  " + _vm._s(_vm.set_productMain.product_cta_name || ' Buy Now'))]) : _c('button', {
    staticClass: "cta-btn",
    staticStyle: {
      "width": "45vw"
    },
    on: {
      "click": _vm.addToCart
    }
  }, [_c('i', {
    staticClass: "fa fa-play",
    staticStyle: {
      "color": "#000000",
      "font-size": "16px"
    }
  }), _vm._v("  " + _vm._s(_vm.set_productMain.product_cta_name || ' Buy Now'))])]) : _c('div', [_c('button', {
    staticClass: "cta-btn",
    staticStyle: {
      "width": "45vw",
      "text-align": "left",
      "padding-left": "5px",
      "font-size": "14px"
    },
    on: {
      "click": function($event) {
        _vm.redir(_vm.set_productMain.product_business_ownername)
      }
    }
  }, [_vm._v(" Continue Shopping")])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "page-header",
    staticStyle: {
      "padding": "0 1em",
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn sp-button-02 sp-button-02-lt",
    on: {
      "click": function($event) {
        _vm.setMenuLink('profile', 'profile')
      }
    }
  }, [_vm._v("View Profile")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('profile', 'profile')
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "padding": "1em"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.user.user_name))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em",
      "clear": "both",
      "padding": "0 1em",
      "margin-bottom": "1em"
    }
  }, [_c('div', {
    staticClass: "card card-colord-01 card-colord-pad mt1"
  }, [_c('p', [_vm._v("Your Shop Statistics")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-02 sp-button-02-lt",
    on: {
      "click": function($event) {
        _vm.setMenuLink('business')
      }
    }
  }, [_vm._v("Go to Store")])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-out-colord-pad mt1 hgt-slab"
  }, [_c('h4', [_vm._v("Best Sellers")]), _vm._v(" "), _c('p', [_vm._v("Your most purchased products")]), _vm._v(" "), (_vm.sellpoint.business_categories && (_vm.sellpoint.business_categories.length > 1)) ? _c('div', {
    staticClass: "category-slide"
  }, [_c('ul', _vm._l((_vm.reco_products), function(product, index) {
    return _c('li', [_c('div', {
      staticClass: "card col-xs-6 card-col-2",
      staticStyle: {
        "margin-bottom": "0.8em"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + _vm.sellpoint.business_username + '/' + product.product_url_name
      }
    }, [_c('div', {
      staticClass: "card-col-img",
      staticStyle: {
        "margin-bottom": "0.8em",
        "border-left": "#f5f5f5 solid 0.35em",
        "border-radius": "4px"
      }
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e(), _vm._v(" "), ((product.product_items[0].product_item_min_wholesale_order && (product.product_items[0].product_item_min_wholesale_order > 0))) ? _c('span', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("min.order(>" + _vm._s(product.product_items[0].product_item_min_wholesale_order) + ")")]) : _vm._e()]), _vm._v(" "), _vm._m(2, true)])])])])
  }))]) : _vm._e()]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "src": "/static/assets/images/dummy-image.png",
      "width": "50",
      "height": "50"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('td', [_c('b', [_vm._v("Orders")])]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("45")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Products")])]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("95")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Categoriess")])]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("5")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Customers")])]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("85")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-arm-alt-bottom",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "card-analytics"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-tag"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-colord-01 card-colord-pad mt1 hgt-slab"
  }, [_c('div', {
    staticClass: "col-xs-3",
    staticStyle: {
      "text-align": "center",
      "padding": "1.2em 5px",
      "background-color": "#ffffff"
    }
  }, [_c('i', {
    staticClass: "wn-icon-lgflt fa fa-envelope",
    staticStyle: {
      "font-size": "42px",
      "color": "#ee4917"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9",
    staticStyle: {
      "background-color": "#f8f4f4",
      "padding": "1.2em 1.1em",
      "text-align": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "float": "right",
      "text-decoration": "underline"
    }
  }, [_c('b', [_vm._v("Inbox")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "clear": "right"
    }
  }, [_vm._v("You have (7) unread messages")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-out-colord-pad mt1 hgt-slab"
  }, [_c('h3', [_vm._v("Recent Orders")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ee4917"
    }
  }, [_vm._v("No orders yet")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', [_vm._v("view all")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table"
  }, [_c('th', [_vm._v("Order")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('tr', [_c('td')])])])])
}]}

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container card-box"
  }, [_c('div', {
    staticClass: "row card-box-o"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-6 col-sm-offset-1"
  }, [_c('div', {
    staticClass: "sp1-reg",
    staticStyle: {
      "background": "#ffffff",
      "padding": "2em",
      "padding-top": "0",
      "border-radius": "2px"
    }
  }, [(_vm.loading) ? _c('div', [_vm._m(0)]) : _c('div', {
    staticClass: "card"
  }, [_c('div', [(!_vm.reset_order) ? _c('div', {
    staticClass: "card"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Product Details")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', [_vm._v("₦" + _vm._s(_vm.product_item.product_item_price_f))]), _vm._v(" "), _c('div', {
    staticClass: "category-slide"
  }, [_c('ul', _vm._l((_vm.product.product_images), function(img) {
    return _c('li', {}, [(img.product_image && (img.product_image != '' && img.product_image != 'error')) ? _c('img', {
      staticClass: "pb_img",
      attrs: {
        "src": _vm.img_product_url + img.product_image,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "pb_img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.product.product_images && (_vm.product.product_images.length > 1)) ? _c('div', [_c('hr'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-transform": "uppercase"
    }
  }, [_vm._v("Swipe to see all pictures >>")])]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card-box-o"
  }, [_c('h3', [_vm._v("Details")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.product_description))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn sp-button-02",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reset_order = true;
      }
    }
  }, [_vm._v("Reset Order")])])]) : _vm._e(), _vm._v(" "), (_vm.reset_order) ? _c('div', {
    staticClass: "card"
  }, [_c('form', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Price")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_price),
      expression: "product.product_price"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "number",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.product.product_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Product Photo ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "prImagePreview"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sp-form-descr"
  }, [_vm._v("Maximum Upload Size " + _vm._s(_vm.max_upload))]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Upload Display "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.is_product_service))]), _vm._v(" Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeNewProduct($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Details")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), (Object.keys(_vm.sellpoint).length == 0) ? _c('div', [_c('h3', [_vm._v("Contact Details")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_name),
      expression: "sellpoint.business_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.sellpoint.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_phone),
      expression: "sellpoint.business_phone"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.sellpoint.business_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_email),
      expression: "sellpoint.business_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.sellpoint.business_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_email = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Order Addons")]), _vm._v(" "), _c('p', [_vm._v("Add Items that could be ordered together with this Order")]), _vm._v(" "), ((Object.keys(_vm.products).length > 0)) ? _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "card col-xs-4"
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + _vm.user.business_username
      }
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "card-avatar-square",
      staticStyle: {
        "width": "100px",
        "height": "95px"
      }
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block",
        "padding": "3px",
        "padding-left": "2em",
        "text-align": "center"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(product.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setAddToProductAddons(product)
        }
      }
    })])])])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px",
      "display": "none"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-sm",
    staticStyle: {
      "float": "right",
      "background": "#ff0066",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.addToProductAddons()
      }
    }
  }, [_vm._v("Done, Add Products to Add-ons")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Settings")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center",
      "padding-top": "0.2em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('bankDetails')
      }
    }
  }, [_vm._m(2)]), _vm._v(" "), (_vm.menu_tab_inner_view['bankDetails']) ? _c('div', {
    attrs: {
      "id": "bankDetails"
    }
  }, [_c('div', {
    staticClass: "card card-colord-01 card-colord-pad"
  }, [_vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Add your Bank Details to receive order payments")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [((!_vm.setEditBankDetails && (Object.keys(_vm.business_bank_details).length > 0))) ? _c('div', [_c('p', [_c('b', [_vm._v("Bank:")]), _vm._v(" " + _vm._s(_vm.business_bank_details.bank_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account Holder's Name:")]), _vm._v(" " + _vm._s(_vm.business_bank_details.bank_account_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account No:")]), _vm._v(" " + _vm._s(_vm.business_bank_details.bank_account_number))]), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("you can edit or change bank details")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setEditBankDetails = true;
      }
    }
  }, [_vm._v("Edit Bank Details")])]) : _vm._e(), _vm._v(" "), (((Object.keys(_vm.business_bank_details).length == 0) || _vm.setEditBankDetails)) ? _c('form', {
    staticClass: "sp-form",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(_vm.ravepay_bank_list && ((Object.keys(_vm.ravepay_bank_list).length == 0))) ? _c('div', [_vm._m(4)]) : _c('div', [_c('label', [_c('b', [_vm._v("Bank Name:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_bank_details.bank_name),
      expression: "business_bank_details.bank_name"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business_bank_details.bank_name = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select your bank")]), _vm._v(" "), _vm._l((_vm.ravepay_bank_list), function(bank) {
    return _c('option', {
      domProps: {
        "value": bank.Name
      }
    }, [_vm._v(_vm._s(bank.Name))])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_bank_details.bank_account_name),
      expression: "business_bank_details.bank_account_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.business_bank_details.bank_account_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business_bank_details.bank_account_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account No:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_bank_details.bank_account_number),
      expression: "business_bank_details.bank_account_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.business_bank_details.bank_account_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business_bank_details.bank_account_number = $event.target.value
      }
    }
  })]), _vm._v(" "), ((Object.keys(_vm.sellpoint).length > 0)) ? _c('div', [_c('p', {
    staticClass: "tiny-p"
  }), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.setBankDetails
    }
  }, [_vm._v("Save Bank Details")])]) : _vm._e()])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center",
      "padding-top": "0.2em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('deliveryLocations')
      }
    }
  }, [_vm._m(5)]), _vm._v(" "), (_vm.menu_tab_inner_view['deliveryLocations']) ? _c('div', {
    attrs: {
      "id": "deliveryLocations"
    }
  }, [((!_vm.setAddDeliveryLocation && (Object.keys(_vm.business_delivery_locations).length > 0))) ? _c('div', [_c('h3', [_vm._v("Delivery Locations")]), _vm._v(" "), _vm._l((_vm.business_delivery_locations), function(location, index) {
    return _c('div', [_c('p', [_vm._v(_vm._s(++index) + " - " + _vm._s(location.business_delivery_state) + " - " + _vm._s(location.business_delivery_option) + " - " + _vm._s(location.business_delivery_option_price) + "\r\n                                    "), _c('br'), _vm._v(" "), _c('span', [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('DL-CHANGE-PRICE-' + index)
        }
      }
    }, [_vm._v("Change Price")]), _vm._v("  | \r\n                                      "), _c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('DL-REMOVE-' + index)
        }
      }
    }, [_vm._v("Remove")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-box",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'DL-CHANGE-PRICE-' + index
      }
    }, [_c('p', [_c('b', [_vm._v("Current Price: ")]), _vm._v(_vm._s(location.business_delivery_option_price))]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Delivery Price")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (location.business_delivery_option_price),
        expression: "location.business_delivery_option_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (location.business_delivery_option_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          location.business_delivery_option_price = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.delivery_option = location;
          _vm.set_single_component_view = 'DL-CHANGE-PRICE-' + index;
          _vm.editDeliveryOption();
        }
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-box",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'DL-REMOVE-' + index
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Do you want to delete this location.")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.delivery_option = location;
          _vm.set_single_component_view = 'DL-REMOVE-' + index;
          _vm.deleteDeliveryOption(location.business_delivery_option_id);
        }
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('div'), _vm._v(" "), _c('hr')])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddDeliveryLocation = true;
      }
    }
  }, [_vm._v("Add Delivery Locations")])], 2) : _vm._e(), _vm._v(" "), (((Object.keys(_vm.business_delivery_locations).length == 0) || _vm.setAddDeliveryLocation)) ? _c('div', {
    key: _vm.componentDeliveryKey,
    staticClass: "card"
  }, [_c('h5', [_vm._v("Add a Delivery Location and Price")]), _vm._v(" "), (_vm.states && (Object.keys(_vm.states).length == 0)) ? _c('div', [_vm._m(6)]) : _c('div', [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.state),
      expression: "delivery_option.state"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.delivery_option.state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      key: state.state_id,
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.action_loading) ? _c('div', [_c('p', [_vm._v("...loading cities")])]) : _vm._e(), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.city),
      expression: "delivery_option.city"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOtherOptions(_vm.delivery_option.city, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      key: city.city_id,
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other Areas / Cities ")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.other_delivery_option) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_other_option),
      expression: "delivery_option.delivery_other_option"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "eg. Abuja"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_other_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_other_option = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Free Delivery?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_free),
      expression: "delivery_option.delivery_option_free"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.delivery_option.delivery_option_free) ? _vm._i(_vm.delivery_option.delivery_option_free, null) > -1 : (_vm.delivery_option.delivery_option_free)
    },
    on: {
      "click": function($event) {
        _vm.setFreeDelivery(1)
      },
      "__c": function($event) {
        var $$a = _vm.delivery_option.delivery_option_free,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.delivery_option.delivery_option_free = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.delivery_option.delivery_option_free = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.delivery_option.delivery_option_free = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.delivery_option.delivery_option_free != 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Delivery Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_price),
      expression: "delivery_option.delivery_option_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "eg. 1000"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_option_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_option_price = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (((Object.keys(_vm.sellpoint).length > 0) && (_vm.sellpoint.business_id > 0))) ? _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addDeliveryOption()
      }
    }
  }, [_vm._v("Add")]) : _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddDeliveryOptions(_vm.delivery_option)
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddDeliveryLocation = false;
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#43a1fa"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createOrder
    }
  }, [_vm._v("Create")])]) : _vm._e()])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(You can always add more images or video on this post)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "background": "#fff",
      "border-radius": "5px",
      "padding": "10px",
      "margin": "5px 35vw",
      "box-shadow": "0 7px 30px -10px rgba(150,170,180,0.5)"
    }
  }, [_vm._v("Manage "), _c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "font-size": "18px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Bank Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "background": "#fff",
      "border-radius": "5px",
      "padding": "10px",
      "margin": "5px 35vw",
      "box-shadow": "0 7px 30px -10px rgba(150,170,180,0.5)"
    }
  }, [_vm._v("Manage "), _c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "font-size": "18px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
}]}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h6', [_vm._v("Add a New Lookbook to your Gallery")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "loading-md"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px",
      "color": "#000000"
    }
  }, [_vm._v("Preparing and Checking your Sellpoint")])]) : _c('form', {
    staticClass: "gw-form"
  }, [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_name),
      expression: "gallery.gallery_name"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "What's the Name of your Lookbook"
    },
    domProps: {
      "value": (_vm.gallery.gallery_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_description),
      expression: "gallery.gallery_description"
    }],
    attrs: {
      "placeholder": "What's this Lookbook all about"
    },
    domProps: {
      "value": (_vm.gallery.gallery_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('h6', [_vm._v("Add a Post to "), _c('span', {
    staticStyle: {
      "color": "#ff0055"
    }
  }, [_vm._v(_vm._s(_vm.gallery.gallery_name))]), _vm._v(" Lookbook")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_caption),
      expression: "post.post_caption"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Caption/Title this Post"
    },
    domProps: {
      "value": (_vm.post.post_caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_caption = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_details),
      expression: "post.post_details"
    }],
    attrs: {
      "placeholder": "Full Post Details"
    },
    domProps: {
      "value": (_vm.post.post_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_details = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "upload-btn-wrapper"
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add Post's media (Image/Video)")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*,video/*",
      "capture": ""
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ee87a6"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addGallery
    }
  }, [_vm._v("All Done, Add Lookbook")])])]), _vm._v(" "), _c('hr')])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(your lookbook is a collection or group of posts you want to keep together)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Lookbook Name"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Description"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(This would be the first post added to this lookbook)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Caption"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Details"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(You can always add more images or video on this post)")])])
}]}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container card-box"
  }, [_c('div', {
    staticClass: "row card-box-o"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-6 col-sm-offset-1"
  }, [_c('div', {
    staticClass: "sp1-reg",
    staticStyle: {
      "background": "#ffffff",
      "padding": "2em",
      "padding-top": "0",
      "border-radius": "2px"
    }
  }, [(_vm.loading) ? _c('div', [_vm._m(0)]) : _c('div', {
    staticClass: "card"
  }, [_c('div', [_c('div', {
    staticClass: "card"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Product Details")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', [_vm._v("₦" + _vm._s(_vm.product_item.product_item_price_f))]), _vm._v(" "), _c('div', {
    staticClass: "category-slide"
  }, [_c('ul', _vm._l((_vm.product.product_images), function(img) {
    return _c('li', {}, [(img.product_image && (img.product_image != '' && img.product_image != 'error')) ? _c('img', {
      staticClass: "pb_img",
      attrs: {
        "src": _vm.img_product_url + img.product_image,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "pb_img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.product.product_images && (_vm.product.product_images.length > 1)) ? _c('div', [_c('hr'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-transform": "uppercase"
    }
  }, [_vm._v("Swipe to see all pictures >>")])]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card-box-o"
  }, [_c('h3', [_vm._v("Details")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.product_description))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn sp-button-02",
    attrs: {
      "href": '/manage/order/' + _vm.product.product_url_name
    }
  }, [_vm._v("Reset Order")])])])])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
}]}

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "0em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "sp1-reg",
    staticStyle: {
      "background": "#ffffff",
      "padding": "0.82em",
      "padding-top": "0",
      "border-radius": "2px"
    }
  }, [_c('div', [_c('a', {
    staticClass: "header-nav-back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "16px",
      "color": "#000000"
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('div', [_vm._m(0)]) : _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    key: _vm.formComponentKey,
    staticClass: "tab-pane active",
    attrs: {
      "id": "register"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("send, share and sell")]), _vm._v(" "), _c('form', {
    staticClass: "form-inline",
    attrs: {
      "name": "registration_form",
      "id": "registration_form"
    }
  }, [_c('div', [_c('h3', [_vm._v("Contact Details")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "id": "email",
      "type": "text",
      "title": "Enter Email",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "change": function($event) {
        _vm.validateEmail(_vm.user.email)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "-2.3em",
      "float": "right"
    }
  }, [(_vm.action_checking.email) ? _c('i', {}, [_c('div', {
    staticClass: "loading-xxs"
  })]) : _vm._e(), _vm._v(" "), ((_vm.user.email && _vm.action_verified.email) && (!_vm.error_messages.email)) ? _c('i', {
    staticClass: "fa fa-check"
  }) : _vm._e(), _vm._v(" "), (_vm.error_messages.email) ? _c('i', {
    staticClass: "fa fa-times",
    staticStyle: {
      "color": "#ff0000"
    }
  }) : _vm._e()])])]), _vm._v(" "), (_vm.error_messages.email) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.error_messages.email))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone),
      expression: "user.phone"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "id": "phone",
      "type": "number",
      "name": "Phone",
      "title": "Enter Phone Number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.phone)
    },
    on: {
      "change": function($event) {
        _vm.validatePhone(_vm.user.phone)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "-2.3em",
      "float": "right"
    }
  }, [(_vm.action_checking.phone) ? _c('i', {}, [_c('div', {
    staticClass: "loading-xxs"
  })]) : _vm._e(), _vm._v(" "), ((_vm.user.phone && _vm.action_verified.phone) && (!_vm.error_messages.phone)) ? _c('i', {
    staticClass: " fa fa-check"
  }) : _vm._e(), _vm._v(" "), (_vm.error_messages.phone) ? _c('i', {
    staticClass: " fa fa-times",
    staticStyle: {
      "color": "#ff0000"
    }
  }) : _vm._e()])])]), _vm._v(" "), (_vm.error_messages.phone) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.error_messages.phone))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Settings")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center",
      "padding-top": "0.2em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('bankDetails')
      }
    }
  }, [_vm._m(2)]), _vm._v(" "), (_vm.menu_tab_inner_view['bankDetails']) ? _c('div', {
    attrs: {
      "id": "bankDetails"
    }
  }, [_c('div', {
    staticClass: "card card-colord-01 card-colord-pad"
  }, [_vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Add your Bank Details to receive order payments")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [((!_vm.setEditBankDetails && (Object.keys(_vm.business_bank_details).length > 0))) ? _c('div', [_c('p', [_c('b', [_vm._v("Bank:")]), _vm._v(" " + _vm._s(_vm.business_bank_details.bank_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account Holder's Name:")]), _vm._v(" " + _vm._s(_vm.business_bank_details.bank_account_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account No:")]), _vm._v(" " + _vm._s(_vm.business_bank_details.bank_account_number))]), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("you can edit or change bank details")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setEditBankDetails = true;
      }
    }
  }, [_vm._v("Edit Bank Details")])]) : _vm._e(), _vm._v(" "), (((Object.keys(_vm.business_bank_details).length == 0) || _vm.setEditBankDetails)) ? _c('form', {
    staticClass: "sp-form",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(_vm.ravepay_bank_list && ((Object.keys(_vm.ravepay_bank_list).length == 0))) ? _c('div', [_vm._m(4)]) : _c('div', [_c('label', [_c('b', [_vm._v("Bank Name:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_bank_details.bank_name),
      expression: "business_bank_details.bank_name"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business_bank_details.bank_name = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select your bank")]), _vm._v(" "), _vm._l((_vm.ravepay_bank_list), function(bank) {
    return _c('option', {
      domProps: {
        "value": bank.Name
      }
    }, [_vm._v(_vm._s(bank.Name))])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_bank_details.bank_account_name),
      expression: "business_bank_details.bank_account_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.business_bank_details.bank_account_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business_bank_details.bank_account_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account No:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_bank_details.bank_account_number),
      expression: "business_bank_details.bank_account_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.business_bank_details.bank_account_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business_bank_details.bank_account_number = $event.target.value
      }
    }
  })]), _vm._v(" "), ((Object.keys(_vm.sellpoint).length > 0)) ? _c('div', [_c('p', {
    staticClass: "tiny-p"
  }), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.setBankDetails
    }
  }, [_vm._v("Save Bank Details")])]) : _vm._e()])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center",
      "padding-top": "0.2em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('deliveryLocations')
      }
    }
  }, [_vm._m(5)]), _vm._v(" "), (_vm.menu_tab_inner_view['deliveryLocations']) ? _c('div', {
    attrs: {
      "id": "deliveryLocations"
    }
  }, [((!_vm.setAddDeliveryLocation && (Object.keys(_vm.business_delivery_locations).length > 0))) ? _c('div', [_c('h3', [_vm._v("Delivery Locations")]), _vm._v(" "), _vm._l((_vm.business_delivery_locations), function(location, index) {
    return _c('div', [_c('p', [_vm._v(_vm._s(++index) + " - " + _vm._s(location.business_delivery_state) + " - " + _vm._s(location.business_delivery_option) + " - " + _vm._s(location.business_delivery_option_price) + "\r\n                                "), _c('br'), _vm._v(" "), _c('span', [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('DL-CHANGE-PRICE-' + index)
        }
      }
    }, [_vm._v("Change Price")]), _vm._v("  | \r\n                                  "), _c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('DL-REMOVE-' + index)
        }
      }
    }, [_vm._v("Remove")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-box",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'DL-CHANGE-PRICE-' + index
      }
    }, [_c('p', [_c('b', [_vm._v("Current Price: ")]), _vm._v(_vm._s(location.business_delivery_option_price))]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Delivery Price")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (location.business_delivery_option_price),
        expression: "location.business_delivery_option_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (location.business_delivery_option_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          location.business_delivery_option_price = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.delivery_option = location;
          _vm.set_single_component_view = 'DL-CHANGE-PRICE-' + index;
          _vm.editDeliveryOption();
        }
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-box",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'DL-REMOVE-' + index
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Do you want to delete this location.")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.delivery_option = location;
          _vm.set_single_component_view = 'DL-REMOVE-' + index;
          _vm.deleteDeliveryOption(location.business_delivery_option_id);
        }
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('div'), _vm._v(" "), _c('hr')])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddDeliveryLocation = true;
      }
    }
  }, [_vm._v("Add Delivery Locations")])], 2) : _vm._e(), _vm._v(" "), (((Object.keys(_vm.business_delivery_locations).length == 0) || _vm.setAddDeliveryLocation)) ? _c('div', {
    key: _vm.componentDeliveryKey,
    staticClass: "card"
  }, [_c('h5', [_vm._v("Add a Delivery Location and Price")]), _vm._v(" "), (_vm.states && (Object.keys(_vm.states).length == 0)) ? _c('div', [_vm._m(6)]) : _c('div', [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.state),
      expression: "delivery_option.state"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.delivery_option.state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      key: state.state_id,
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.action_loading) ? _c('div', [_c('p', [_vm._v("...loading cities")])]) : _vm._e(), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.city),
      expression: "delivery_option.city"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOtherOptions(_vm.delivery_option.city, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      key: city.city_id,
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other Areas / Cities ")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.other_delivery_option) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_other_option),
      expression: "delivery_option.delivery_other_option"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "eg. Abuja"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_other_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_other_option = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Free Delivery?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_free),
      expression: "delivery_option.delivery_option_free"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.delivery_option.delivery_option_free) ? _vm._i(_vm.delivery_option.delivery_option_free, null) > -1 : (_vm.delivery_option.delivery_option_free)
    },
    on: {
      "click": function($event) {
        _vm.setFreeDelivery(1)
      },
      "__c": function($event) {
        var $$a = _vm.delivery_option.delivery_option_free,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.delivery_option.delivery_option_free = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.delivery_option.delivery_option_free = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.delivery_option.delivery_option_free = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.delivery_option.delivery_option_free != 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Delivery Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_price),
      expression: "delivery_option.delivery_option_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "eg. 1000"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_option_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_option_price = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (((Object.keys(_vm.sellpoint).length > 0) && (_vm.sellpoint.business_id > 0))) ? _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addDeliveryOption()
      }
    }
  }, [_vm._v("Add")]) : _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddDeliveryOptions(_vm.delivery_option)
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddDeliveryLocation = false;
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v("kk" + _vm._s(_vm.error_messages) + "---set_user_loggedIn--" + _vm._s(_vm.set_user_loggedIn) + "\r\n                        "), _c('p', {
    staticStyle: {
      "color": "#43a1fa"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))]), _vm._v(" "), (((!_vm.error_messages.email) && (!_vm.error_messages.phone))) ? _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.prepProfile(2)
      }
    }
  }, [_vm._v("Create")]) : _vm._e()])])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("Create your acoount "), _c('br'), _vm._v(" to set up orders")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "background": "#fff",
      "border-radius": "5px",
      "padding": "10px",
      "margin": "5px 35vw",
      "box-shadow": "0 7px 30px -10px rgba(150,170,180,0.5)"
    }
  }, [_vm._v("Manage "), _c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "font-size": "18px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Bank Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "background": "#fff",
      "border-radius": "5px",
      "padding": "10px",
      "margin": "5px 35vw",
      "box-shadow": "0 7px 30px -10px rgba(150,170,180,0.5)"
    }
  }, [_vm._v("Manage "), _c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "font-size": "18px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
}]}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(!_vm.menu_tab_view.viewLogs) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('viewLogs')
      }
    }
  }, [_vm._v("Home")]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.createNew) ? _c('div', [_c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('viewLogs')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-top": "1em",
      "height": "auto"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('newGroup')
      }
    }
  }, [_vm._v("New Group")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView(1, 'Category')
      }
    }
  }, [_vm._v("Category / Product / Service")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad",
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setNewPost(7, 'Featured Products')
      }
    }
  }, [_vm._v("Featured Products")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setNewPost(2, 'Post')
      }
    }
  }, [_vm._v("Post")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setNewPost(5, 'Event')
      }
    }
  }, [_vm._v("Event")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setNewPost(4, 'News')
      }
    }
  }, [_vm._v("News")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setNewPost(6, 'Deals')
      }
    }
  }, [_vm._v("Deals")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.viewLogs) ? _c('div', {
    staticClass: "card-box-0"
  }, [_c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('createNew')
      }
    }
  }, [_vm._v("Create New")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._l((_vm.comlogs), function(com, index) {
    return _c('div', {
      staticClass: "card card-01 timeline-user-card"
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setComView(com)
        }
      }
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-circle"
    }, [(com.com_image && (com.com_image != '')) ? _c('img', {
      attrs: {
        "src": com.com_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right"
    }, [_c('div', {
      staticClass: "card-arm-line"
    }, [_c('p', [_vm._v(_vm._s(com.com_name)), _c('br'), _c('span', [_vm._v("@" + _vm._s(com.com_username))])])]), _vm._v(" "), _vm._m(2, true)])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.comView) ? _c('div', {
    staticClass: "card-box-0"
  }, [(_vm.com.com_type == 4) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('addMembersToGroup')
      }
    }
  }, [_vm._v("Add Members to Group")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('createNew')
      }
    }
  }, [_vm._v("Create New")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-card"
  }, [_c('h6', [_c('b', [_vm._v(_vm._s(_vm.com.com_name))])]), _vm._v(" "), (_vm.posts && (Object.keys(_vm.posts).length === 0)) ? _c('p', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("No post yet")]) : _vm._e(), _vm._v(" "), _c('div', _vm._l((_vm.posts), function(post, psdex) {
    return _c('div', {
      staticClass: "card card-strip"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.setComPost(post)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [(post.post_media && (post.post_media.length > 0)) ? _c('div', [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": post.post_media[0].post_media
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      staticClass: "col-xs-2",
      staticStyle: {
        "padding": "0"
      }
    }, [(post.post_owner_brand_image) ? _c('div', {
      staticClass: "card-avatar-circle card-avatar-circle-sm"
    }, [_c('img', {
      attrs: {
        "src": post.post_owner_brand_image
      }
    })]) : _vm._e()]), _c('p', [_vm._v("\r\n                      " + _vm._s(post.post_title)), _c('br'), _c('b', [_vm._v(_vm._s(post.post_time_ago))])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.comPostView) ? _c('div', {
    staticClass: "card-box-0"
  }, [_c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('comView')
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-card"
  }, [_c('h6', [_c('b', [_vm._v(_vm._s(_vm.post))])]), _vm._v(" "), _c('div', [_c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "28px",
      "font-weight": "bolder",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticClass: "text-align:left"
  }, [(_vm.post.post_media.length > 0) ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.post.post_media[0].post_media,
      "height": "35",
      "width": "35"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.post.post_title))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.post.post_time_ago))]), _c('br'), _vm._v(_vm._s(_vm.post.post_post))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {}, _vm._l((_vm.post.post_media), function(post_media) {
    return (_vm.post.post_media && (_vm.post.post_media.length > 0)) ? _c('div', [_c('img', {
      attrs: {
        "src": post_media.post_media,
        "height": "35",
        "width": "35"
      }
    })]) : _vm._e()
  })), _vm._v(" "), _c('div', {}, _vm._l((_vm.post.post_products), function(product, index) {
    return (_vm.post.post_products && (_vm.post.post_products.length > 0)) ? _c('div', [_c('div', {
      staticClass: "card card-01 timeline-user-card"
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setBusinessComponent('viewBusinessCategoryProduct', _vm.sellpoint, product)
        }
      }
    }, [_c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-square"
    }, [(product.product_images[0]) ? _c('img', {
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right"
    }, [_c('div', {
      staticClass: "card-arm-line"
    }, [_c('p', [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f) + " - ₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e()])])])])])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [(!_vm.menu_tab_inner_view.addBusinessPostNotification) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('addBusinessPostNotification')
      }
    }
  }, [_vm._v("Add a Notification")]) : _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), (_vm.menu_tab_inner_view.addBusinessPostNotification) ? _c('div', [_c('div', {
    staticClass: "form-card"
  }, [_c('form', {
    staticClass: "sp-form"
  }, [_c('h6', [_vm._v("Add notification to " + _vm._s(_vm.post.post_title))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_notification),
      expression: "post.post_notification"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.post.post_notification)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_notification = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#084c8b"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.addNewPostNotification
    }
  }, [_vm._v("Add")])])])])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.addMembersToGroup) ? _c('div', {
    staticClass: "card-box-0"
  }, [(_vm.selected_group_members.length > 0) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.addMembersToGroup
    }
  }, [_vm._v("Add " + _vm._s(_vm.selected_group_members.length) + " member(s)")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('comView')
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._l((_vm.comlogs), function(com, index) {
    return (com.com_type != 4) ? _c('div', {
      staticClass: "card card-01 timeline-user-card"
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      }
    }, [_c('span', {
      staticClass: "card-thumb-up-left"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.selectGroupMembers(com)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-circle"
    }, [(com.com_image && (com.com_image != '')) ? _c('img', {
      attrs: {
        "src": com.com_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right"
    }, [_c('div', {
      staticClass: "card-arm-line"
    }, [_c('p', [_vm._v(_vm._s(com.com_name)), _c('br'), _c('span', [_vm._v("@" + _vm._s(com.com_username))])])]), _vm._v(" "), _vm._m(4, true)])])]) : _vm._e()
  })], 2) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat"
  }, [_c('h5', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Add New")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "card-thumb-up-left"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-arm-alt-bottom"
  }, [_c('div', {
    staticClass: "card-analytics"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-tag"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-users"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-certificate"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', [_vm._v("Comments: 30")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-arm-alt-bottom"
  }, [_c('div', {
    staticClass: "card-analytics"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-tag"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-users"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-certificate"
  })])])])])
}]}

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin": "0.1em",
      "margin-top": "-0.2em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card card-box-fl"
  }, [_c('h4', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/manage/items/settings/resetcategory"
    }
  }, [_vm._v("\n                            Move to new Category\n                            "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-box-fl"
  }, [_c('h4', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/manage/items/settings/addtocategories"
    }
  }, [_vm._v("\n                            Add to new Categories\n                            "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])
}]}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.show_login) ? _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header')], 1), _vm._v(" "), _c('div', {
    staticClass: "pager pager-clear-sticky"
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "topPanel"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', {
    staticClass: "row"
  }, [_c('div', [_c('div', [_c('ul', {
    staticStyle: {
      "margin": "0 5px",
      "padding": "0",
      "white-space": "nowrap",
      "overflow": "hidden",
      "-ms-overflow-style": "none !important",
      "scrollbar-color": "#ffffff"
    }
  }, _vm._l((_vm.show_feeds), function(x, xndex) {
    return _c('li', {
      staticStyle: {
        "color": "#3a3939",
        "display": "inline-block",
        "margin": "4px",
        "border-bottom": "solid 1px #3a3939"
      },
      style: ({
        width: _vm.slide_feed_width
      }),
      attrs: {
        "id": 'StatusCode-' + xndex
      }
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.showFeed(xndex, x)
        }
      }
    }, [_c('span', {
      staticClass: "x-bar"
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "x-view",
    staticStyle: {
      "height": "70vh",
      "background": "#eeeded"
    }
  }, [_c('p', {
    staticStyle: {
      "padding": "8em 2em 3em 2em",
      "font-weight": "bolder",
      "font-size": "32px"
    }
  }, [_vm._v(_vm._s(_vm.show_feed_slide))])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-box-0"
  }, _vm._l((_vm.notifications), function(noti, index) {
    return _c('div', {
      staticClass: "card card-02",
      staticStyle: {
        "border-bottom": "#eeeded solid",
        "padding": "8px 0"
      }
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.clickNotifications(noti.notification_ref, noti.notification_url)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "80%"
      }
    }, [_c('div', {
      staticClass: "card-arm-line"
    }, [(noti.notification_click == 0) ? _c('span', [(noti.notification_header && (noti.notification_header != '')) ? _c('h6', [_vm._v(_vm._s(noti.notification_header))]) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-weight": "bolder"
      }
    }, [_vm._v(_vm._s(noti.notification_message))]), _vm._v(" "), (noti.notification_cta && (noti.notification_cta != 0)) ? _c('span', {
      staticStyle: {
        "float": "left",
        "font-size": "12px",
        "color": "#ff0066"
      }
    }, [_vm._v(_vm._s(noti.notification_cta_name))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "font-size": "12px",
        "color": "#ff0066"
      }
    }, [_vm._v(_vm._s(noti.notification_time_ago))])]) : _c('span', [(noti.notification_header && (noti.notification_header != '')) ? _c('h6', [_vm._v(_vm._s(noti.notification_header))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(noti.notification_message))]), _vm._v(" "), (noti.notification_cta && (noti.notification_cta != 0)) ? _c('span', {
      staticStyle: {
        "float": "left",
        "font-size": "12px",
        "color": "#ff0066"
      }
    }, [_vm._v(_vm._s(noti.notification_cta_name))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "font-size": "12px",
        "color": "#ff0066"
      }
    }, [_vm._v(_vm._s(noti.notification_time_ago))])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle"
    }, [_c('img', {
      attrs: {
        "src": noti.notification_image
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  }))])])]), _vm._v(" "), _c('component-footer', {
    key: _vm.componentMenuBottomkey
  })], 1) : _c('div', [_c('component-landing')], 1)])
},staticRenderFns: []}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "timeline-cover sp-page-banner"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-contents"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h4', [_vm._v("Group Chat")]), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('viewChatLog')
      }
    }
  }, [_vm._v("View Chat")]), _vm._v(" "), (_vm.menu_tab_view.viewChatLog) ? _c('div', [((Object.keys(_vm.user).length > 0)) ? _c('div', [_c('component-chatroom', {
    attrs: {
      "chatter": {
        chatter_chat_from: _vm.user.user_id,
        chatter_chat_from_module: 1,
        chatter_set_active_chat: '',
        chatter_chat_to: 0,
        chatter_chat_to_module: 0,
        chatter_chat_group: 0,
        chatter_style: 2,
        chat_components_products: []
      }
    }
  })], 1) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat"
  }, [_c('div', [_c('h3', [_vm._v("Chats")])])])
}]}

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin": "0.1em",
      "margin-top": "-0.2em"
    }
  }, [_c('div', {
    staticClass: "card card-box"
  }, [_c('a', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setItemSettings()
      }
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('h4', [_c('span', {
    staticStyle: {
      "float": "left",
      "font-size": "13px"
    }
  }, [_vm._v("Item Name ")]), _c('br'), _vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {}, [(_vm.product.product_images[0]) ? _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.product.product_images[0].product_image
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card card-box"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "p-row",
    attrs: {
      "id": "buyItem"
    }
  }, [_c('span', {
    staticClass: "p-row-01"
  }, [_vm._v("Buy Item ")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "p-row-02"
  }, [_vm._v("Add to items you want to purchase ")]), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "background-color": "rgb(41, 122, 245)",
      "border-radius": "18px",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('AddToMarketList', 'buyItem')
      }
    }
  }, [_vm._v("\r\n                Add to Market List")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "AddToMarketList"
    }
  }, [_c('h5', [_vm._v("Buy Item")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "float": "right",
      "background-color": "rgb(41, 122, 245)",
      "border-radius": "18px",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('AddToMarketList', 'buyItem')
      }
    }
  }, [_vm._v("\r\n                x close")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "background-color": "rgb(41, 122, 245)",
      "border-radius": "18px",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('AddToMarketList', 'buyItem')
      }
    }
  }, [_vm._v("\r\n              Buy from Distributors")])])])]), _vm._v(" "), _vm._m(10)])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-row"
  }, [_c('span', {
    staticClass: "p-row-01"
  }, [_vm._v("Available ")]), _c('br'), _c('span', {
    staticClass: "p-row-02"
  }, [_vm._v("0")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-row"
  }, [_c('span', {
    staticClass: "p-row-01"
  }, [_vm._v("Last Sold ")]), _c('br'), _c('span', {
    staticClass: "p-row-02"
  }, [_vm._v("000-00-00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-row"
  }, [_c('span', {
    staticClass: "p-row-01"
  }, [_vm._v("Expiry Date ")]), _c('br'), _c('span', {
    staticClass: "p-row-02"
  }, [_vm._v("000-00-00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h4', [_vm._v("Market Information\r\n            "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "13px"
    }
  }, [_c('i', {
    staticClass: "fas fa-shopping-bag"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-row"
  }, [_c('span', {
    staticClass: "p-row-01"
  }, [_vm._v("Last Purchase Amount ")]), _c('br'), _c('span', {
    staticClass: "p-row-02"
  }, [_vm._v("0")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-row"
  }, [_c('span', {
    staticClass: "p-row-01"
  }, [_vm._v("Last Purchase Date ")]), _c('br'), _c('span', {
    staticClass: "p-row-02"
  }, [_vm._v("000-00-00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-row"
  }, [_c('span', {
    staticClass: "p-row-01"
  }, [_vm._v("Purchased From ")]), _c('br'), _c('span', {
    staticClass: "p-row-02"
  }, [_vm._v("000-00-00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "btn  btn-default",
    staticStyle: {
      "padding": "0.41em",
      "border-radius": "50%"
    }
  }), _vm._v(" Add to general market list")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "btn btn-default",
    staticStyle: {
      "padding": "0.41em",
      "border-radius": "50%"
    }
  }), _vm._v(" Add to market list with "), _c('b')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-row"
  }, [_c('span', {
    staticClass: "p-row-01"
  }, [_vm._v("Direct Access ")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "p-row-02"
  }, [_vm._v("Send your list to distributors tat sell these products")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-box"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h4')]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div')])])
}]}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {}, [_c('h6', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Product Add-ons")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "clear": "both",
      "margin-top": "1em"
    },
    attrs: {
      "id": "setAddProductAddons"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-sm",
    staticStyle: {
      "float": "left",
      "background": "#5883a0",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('setAddProductAddons')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-sm",
    staticStyle: {
      "float": "right",
      "background": "#008cff",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.addToProductAddons()
      }
    }
  }, [_vm._v("Done, Add Products to Add-ons")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('h5', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Please select products")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat, casndex) {
    return _c('div', {
      key: casndex,
      staticClass: "card card-flat-pad",
      staticStyle: {
        "height": "auto"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('h5', [_vm._v(_vm._s(cat.business_category_name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('button', {
      staticClass: "btn sp-button-sm",
      staticStyle: {
        "background": "#5883a0",
        "color": "#ffffff"
      },
      on: {
        "click": function($event) {
          _vm.category = cat;
          _vm.getBusinessCategoryProducts('CATSET' + casndex);
          _vm.setMenuTabInnerView(_vm.menu_tab_inner_view['SHCPRDS' + casndex] ? ' ' : ('SHCPRDS' + casndex));
        }
      }
    }, [_vm._v("Select "), _c('i', {
      staticClass: "fa fa-angle-down"
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (_vm.menu_tab_inner_view['SHCPRDS' + casndex]) ? _c('div', {
      staticClass: "card"
    }, [(_vm.component_loading['CATSET' + casndex]) ? _c('div', {
      staticClass: "container"
    }, [_vm._m(0, true)]) : _c('div', [_vm._l((cat.category_products), function(prd, prddex) {
      return _c('div', {
        key: prddex,
        staticStyle: {
          "float": "left",
          "width": "30%",
          "clear": "right",
          "padding": "1em"
        }
      }, [(_vm.product.product_id != prd.product_id) ? _c('div', {
        staticClass: "card",
        staticStyle: {
          "padding-top": "1em",
          "width": "auto",
          "height": "auto"
        }
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        on: {
          "click": function($event) {
            _vm.setAddToProductAddons(prd)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "card-avatar-square card-label-avatar"
      }, [(prd.product_images && (prd.product_images.length != 0)) ? _c('img', {
        attrs: {
          "src": prd.product_images[0].product_image
        }
      }) : _c('img', {
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(prd.product_name))])])]) : _vm._e()])
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_c('button', {
      staticClass: "btn sp-button-sm",
      staticStyle: {
        "float": "right",
        "background": "#ff0066",
        "color": "#ffffff"
      },
      on: {
        "click": function($event) {
          _vm.addToProductAddons()
        }
      }
    }, [_vm._v("Done, Add Products to Add-ons")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])], 2), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]) : _vm._e()])
  })], 2), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-bottom": "5px"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('setAddProductAddons')
      }
    }
  }, [_vm._v("Add Products Add-ons")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.product.product_addons && (_vm.product.product_addons.length != 0)) ? _c('div', [_vm._l((_vm.product.product_addons), function(product, index) {
    return _c('div', {
      key: index,
      staticClass: "card col-xs-4 card-col-2",
      staticStyle: {
        "margin-bottom": "2.2em"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setProduct(product)
        }
      }
    }, [_c('div', {
      staticClass: "card-col-img"
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "max-height": "8em"
      },
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block",
        "padding": "3px"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticClass: "sp-app-default-color",
      staticStyle: {
        "font-weight": "bolder"
      }
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Stock: ")]), _vm._v(_vm._s(product.product_items[0].product_item_quantity))])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2) : _c('div', [_c('p', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("No product addons")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
}]}

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _c('div', {
    key: _vm.componentKey,
    staticClass: "detail-card"
  }, [_c('h6', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("Shop Orders")]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), ((Object.keys(_vm.sellpoint_pending_orders).length !== 0)) ? _c('div', {
    staticClass: "detail-card"
  }, [_vm._m(1), _vm._v(" "), (!_vm.viewPendingPayOrders) ? _c('div', {
    staticClass: "card card-flat-pad sp-app-default-background-color",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.viewPendingPayOrders = true;
      }
    }
  }, [_c('div', {
    staticStyle: {
      "width": "95%"
    }
  }, [_vm._m(2), _c('span', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v(" You have " + _vm._s((_vm.sellpoint_pending_orders).length) + " Pending Payments")])])])]) : _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('p', [_vm._v(_vm._s((_vm.sellpoint_pending_orders).length) + " Pending Payment(s)\r\n                "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "font-weight": "bolder",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.viewPendingPayOrders = false;
      }
    }
  }, [_vm._v("X")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {}, _vm._l((_vm.sellpoint_pending_orders), function(spo, spodex) {
    return _c('div', {
      staticClass: "card card-flat-pad"
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "90%"
      }
    }, [_c('div', [_c('span', {
      staticStyle: {
        "float": "left",
        "width": "55%"
      }
    }, [_c('b', [_vm._v(_vm._s(spo.payment_data.payment_payer_name))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "width": "35%"
      }
    }, [_vm._v("  ₦" + _vm._s(spo.payment_data.payment_amount))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', [_vm._v("\r\n                      __"), _c('br'), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "width": "35%",
        "font-size": "13px"
      }
    }, [_vm._v("  ₦" + _vm._s(spo.payment_data.payment_pending_amount_to_pay))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), (_vm.sellpoint.business_agent == 0) ? _c('div', [(((spo.payment_data.payment_set_to_receive_from == 1) && (spo.payment_data.payment_amount_to_pay !== 0))) ? _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [(((_vm.set_order_pending_payment_data == 'ord' + spodex) && (Object.keys(_vm.set_pending_payment_data).length !== 0))) ? _c('div', [_c('component-payment-service', {
      attrs: {
        "paymentdata": _vm.set_pending_payment_data
      }
    })], 1) : _c('div', [_c('a', {
      staticClass: "btn sp-button-02 sp-button-sm",
      on: {
        "click": function($event) {
          _vm.setPendingOrdersPayment(spo, spodex)
        }
      }
    }, [_vm._v("Make Payment")])])]) : _vm._e(), _vm._v(" "), (spo.payment_data.payment_set_to_receive_from == 2) ? _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [(spo.payment_data.payment_settled_by_agent != 1) ? _c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Payment is set to be received by Agent")]) : _c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Payment has been sent to you from Agent")]), _vm._v(" "), (spo.payment_data.payment_settled_by_agent == 1) ? _c('a', {
      staticClass: "btn sp-button-02 sp-button-sm",
      on: {
        "click": function($event) {
          _vm.updateOrdersGeneralDetails(spo)
        }
      }
    }, [_vm._v("Confirm Payment")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_agent == 1) ? _c('div', [(spo.payment_data.payment_set_to_receive_from == 1) ? _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Payment is set to be received by Seller")])]) : _vm._e(), _vm._v(" "), (spo.payment_data.payment_set_to_receive_from == 2) ? _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Payment is set to be received by you")]), _vm._v(" "), (((_vm.set_order_pending_payment_data == 'ord' + spodex) && (Object.keys(_vm.set_pending_payment_data).length !== 0))) ? _c('div', [_c('component-payment-service', {
      attrs: {
        "paymentdata": _vm.set_pending_payment_data
      }
    })], 1) : _c('div', [_c('a', {
      staticClass: "btn sp-button-02 sp-button-sm",
      on: {
        "click": function($event) {
          _vm.setPendingOrdersPayment(spo, spodex)
        }
      }
    }, [_vm._v("Make Payment")])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('div', [(_vm.menu_tab_inner_view['SPO' + spodex]) ? _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('')
        }
      }
    }, [_vm._m(4, true)]) : _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('SPO' + spodex)
        }
      }
    }, [_vm._m(5, true)])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (_vm.menu_tab_inner_view['SPO' + spodex]) ? _c('div', [_c('div', {
      staticClass: "orders-panel",
      staticStyle: {
        "margin-top": "1em"
      }
    }, [(_vm.viewPendingPayOrder) ? _c('div', [_c('div', {
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('hr'), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "font-size": "28px",
        "font-weight": "bolder",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("X")])]), _vm._v(" "), _c('div', {}, [_c('div', [_vm._v("Order number: " + _vm._s(_vm.order.order_no))]), _vm._v(" "), _c('div', [_vm._v("Date: " + _vm._s(_vm.order.order_date))]), _vm._v(" "), _c('div', [_vm._v("Payment method: Online Payment")]), _vm._v(" "), _c('div', [_vm._v("Status: "), _c('span', {
      style: ({
        color: _vm.order.order_status_color
      })
    }, [_vm._v(_vm._s(_vm.order.order_status))])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('div', [_vm._v("Order Amount: ₦" + _vm._s(_vm.order.order_items_total))]), _vm._v(" "), _c('div', [_vm._v("Shipping:  ₦" + _vm._s(_vm.order.order_shipping_total))]), _vm._v(" "), _c('div', [_vm._v("Total: ₦" + _vm._s(_vm.order.order_total))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('div', [_vm._v("Delivery Location: " + _vm._s(_vm.order.order_delivery_city))]), _vm._v(" "), _c('div', [_vm._v("Address: " + _vm._s(_vm.order.order_user_delivery_address))])]), _vm._v(" "), _c('div', {}, [_c('table', {
      staticClass: "table table-striped",
      staticStyle: {
        "width": "100%",
        "text-align": "left"
      }
    }, [_c('th', {
      staticClass: "tcol",
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("Order No")]), _vm._v(" "), _c('th', {
      staticClass: "tcol",
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v("Order")]), _vm._v(" "), _c('th', {
      staticClass: "tcol",
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v("Qty")]), _vm._v(" "), _c('th', {
      staticClass: "tcol",
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("Total")]), _vm._v(" "), _vm._l((_vm.order.order_items), function(item) {
      return _c('tr', [_c('td', {
        staticStyle: {
          "width": "20%",
          "font-size": "12px"
        }
      }, [_vm._v("\r\n                                      " + _vm._s(item.order_item_no) + "\r\n                                    ")]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "50%"
        }
      }, [_vm._v("\r\n                                      " + _vm._s(item.product_name) + "\r\n                                      "), _c('br'), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "inline"
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.img_product_url + item.product_item_group_image,
          "height": "50",
          "width": "50"
        }
      })])]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "10%"
        }
      }, [_vm._v(_vm._s(item.order_item_quantity))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "20%"
        }
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.order_item_total.toFixed(2)))])])
    })], 2)]), _vm._v(" "), _c('div', {}, [_vm._v("\r\n                                " + _vm._s(_vm.order_commissions_stl) + "\r\n                              ")])])]) : _c('div', [_c('div', {
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('p', {
      staticStyle: {
        "text-align": "center",
        "font-weight": "bolder",
        "font-size": "18px"
      }
    }, [_vm._v(" . . .")]), _vm._v(" "), _c('div', {
      staticClass: "card card-strip"
    }, [_vm._m(6, true), _vm._v(" "), _c('div', {
      staticClass: "card-right-50"
    }, [_c('p', [_vm._v(_vm._s(spo.payment_data.payment_service))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "card card-strip"
    }, [_vm._m(7, true), _vm._v(" "), _c('div', {
      staticClass: "card-right-50"
    }, [_c('p', [_vm._v(_vm._s(spo.payment_data.payment_ref))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "card card-strip"
    }, [_vm._m(8, true), _vm._v(" "), _c('div', {
      staticClass: "card-right-50"
    }, [_c('p', [_vm._v(_vm._s(spo.payment_data.payment_date))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])]), _vm._v(" "), _c('h6', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("Orders Made")]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Please confirm payment to view orders")])])])]) : _vm._e()])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "detail-card"
  }, [_vm._m(9), _vm._v(" "), (_vm.sellpoint_orders && (Object.keys(_vm.sellpoint_orders).length === 0)) ? _c('p', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("No orders yet")]) : _vm._e(), _vm._v(" "), (_vm.viewOrder) ? _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "28px",
      "font-weight": "bolder",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('order-request', {
    attrs: {
      "order_data": _vm.order
    }
  }), _vm._v(" "), _c('hr')], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "28px",
      "font-weight": "bolder",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {}, [_c('div', [_vm._v("Order number: " + _vm._s(_vm.order.order_no))]), _vm._v(" "), _c('div', [_vm._v("Date: " + _vm._s(_vm.order.order_date))]), _vm._v(" "), _c('div', [_vm._v("Payment method: Online Payment")]), _vm._v(" "), _c('div', [_vm._v("Status: "), _c('span', {
    style: ({
      color: _vm.order.order_status_color
    })
  }, [_vm._v(_vm._s(_vm.order.order_status))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', [_vm._v("Order Amount: ₦" + _vm._s(_vm.order.order_items_total))]), _vm._v(" "), _c('div', [_vm._v("Shipping:  ₦" + _vm._s(_vm.order.order_shipping_total))]), _vm._v(" "), _c('div', [_vm._v("Total: ₦" + _vm._s(_vm.order.order_total))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', [_vm._v("Delivery Location: " + _vm._s(_vm.order.order_delivery_city))]), _vm._v(" "), _c('div', [_vm._v("Address: " + _vm._s(_vm.order.order_user_delivery_address))])]), _vm._v(" "), _c('div', {}, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Order No")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Order")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Qty")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _vm._l((_vm.order.order_items), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "20%",
        "font-size": "12px"
      }
    }, [_vm._v("\r\n                      " + _vm._s(item.order_item_no) + "\r\n                    ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v("\r\n                      " + _vm._s(item.product_name) + "\r\n                      "), _c('br'), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + item.product_item_group_image,
        "height": "50",
        "width": "50"
      }
    })])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.order_item_quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.order_item_total.toFixed(2)))])])
  })], 2)]), _vm._v(" "), _c('div', {}, [_vm._m(10), _vm._v(" "), _c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Earner")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Item")]), _vm._v(" "), _vm._l((_vm.order.order_commissions_stl), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "20%",
        "font-size": "11px"
      }
    }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.service_commission_amount.toFixed(2)) + "\r\n                    ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("\r\n                      " + _vm._s(item.service_commission_earner_name) + "\r\n                    ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v("\r\n                      " + _vm._s(item.service_commission_module_name) + "\r\n                      "), _c('br'), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + item.service_commission_module_image_url,
        "height": "50",
        "width": "50"
      }
    })])])])
  })], 2)])]), _vm._v(" "), (_vm.order.order_payment_status_id != 18) ? _c('div', {
    staticClass: "mobile-fix-nav-2"
  }, [_c('p', {
    staticStyle: {
      "padding": "0 5px"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.order.order_status_id == 2) ? _c('div', {
    staticStyle: {
      "background": "#e94b4b",
      "width": "100vw",
      "padding": "0.8em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.updateOrders(_vm.order, 'delivered')
      }
    }
  }, [_vm._v("Mark order as delivered")])]) : _vm._e()]) : _vm._e()])]) : _c('div', _vm._l((_vm.sellpoint_orders), function(order, odex) {
    return _c('div', {
      key: _vm.orderComponentKey,
      staticClass: "card card-flat-pad card-striped"
    }, [(order.order_status_id != 20) ? _c('div', [(_vm.sellpoint.business_agent == 1) ? _c('a', {
      staticStyle: {
        "float": "right",
        "color": "inherit",
        "font-weight": "bolder",
        "text-decoration": "underline"
      },
      attrs: {
        "href": '/' + order.order_business_username
      }
    }, [_vm._v(_vm._s(order.order_business))]) : _vm._e(), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('orders', order)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(order.order_time_ago))]), _c('br'), _vm._v(_vm._s(order.order_user)), _c('br'), _c('b', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(order.order_total.toFixed(2)))]), _vm._v(" "), _c('br'), _vm._v(" "), (order.order_status_id == 20) ? _c('p', {
      staticStyle: {
        "color": "#e94b4b"
      }
    }, [_c('b', [_vm._v("Confirm order")])]) : _vm._e(), _vm._v(" "), (order.order_status_id == 2) ? _c('p', {
      staticStyle: {
        "color": "#e94b4b"
      }
    }, [_vm._v("Mark order as delivered")]) : _vm._e(), _vm._v(" "), (order.order_status_id == 18) ? _c('p', {
      staticStyle: {
        "color": "#337ab7"
      }
    }, [_vm._v("Delivered")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [(order.order_items && (order.order_items.length != 0)) ? _c('span', [_c('b', [_vm._v(_vm._s(order.order_items.length) + " item(s)")]), _c('br')]) : _vm._e(), _vm._v(" "), _vm._l((order.order_items), function(item, idex) {
      return (idex < 2) ? _c('div', {
        staticStyle: {
          "display": "inline"
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.img_product_url + item.product_item_group_image,
          "height": "35",
          "width": "35"
        }
      })]) : _vm._e()
    })], 2), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]) : _c('div', [_c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Pending Order Payment Confirmation\r\n                "), (_vm.sellpoint.business_agent == 0) ? _c('span', [_c('br'), _c('b', [_vm._v("Please clear payments")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(order.order_time_ago))]), _c('br'), _vm._v(_vm._s(order.order_user)), _c('br'), _c('b', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(order.order_total.toFixed(2)))]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [(order.order_items && (order.order_items.length != 0)) ? _c('span', [_c('b', [_vm._v(_vm._s(order.order_items.length) + " item(s)")]), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Pending Order-Payments Confirmation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-bell",
    staticStyle: {
      "color": "#ffffff"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "left",
      "width": "55%",
      "font-size": "13px"
    }
  }, [_c('b', [_vm._v("Amount to pay")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left-50"
  }, [_c('p', [_vm._v("Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left-50"
  }, [_c('p', [_vm._v("Payment Ref")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left-50"
  }, [_c('p', [_vm._v("Date")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Business Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Commissions earned in this Order")])])
}]}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('button', {
    staticClass: "sp-button-sm",
    attrs: {
      "id": "myBtn",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.openModal('setShopTogetherModal')
      }
    }
  }, [_vm._v("Share on Shop Together")])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    staticStyle: {
      "top": "5em",
      "padding": "1em",
      "width": "97%"
    },
    attrs: {
      "id": "setShopTogetherModal"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('setShopTogetherModal')
      }
    }
  }, [_c('span', {
    staticClass: "close"
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    key: _vm.shopTogetherAlertKey,
    staticClass: "card"
  }, [_c('h5', {
    staticStyle: {
      "color": "#ff5566",
      "padding-left": "0.7em"
    }
  }, [_vm._v("Share with")]), _vm._v(" "), _vm._l((_vm.shop_together_activities), function(shp, shpindex) {
    return _c('div', {
      key: shpindex,
      staticClass: "card card-flat-pad"
    }, [_c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [((shp.data_shared && (shp.data_shared != ''))) ? _c('p', {
      staticClass: "sp-app-default-color",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(shp.data_shared))]) : _c('button', {
      staticClass: "btn sp-button-sm",
      staticStyle: {
        "background": "#fc4112 !important",
        "color": "#ffffff !important"
      },
      attrs: {
        "id": "myBtn",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.showShareOnShopTogether('S2G' + shpindex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-share-alt"
    }), _vm._v(" Share")])]), _vm._v(" "), _c('ul', {
      staticStyle: {
        "clear": "both"
      }
    }, _vm._l((shp.activity_users), function(u, uindex) {
      return _c('li', {
        key: uindex,
        staticStyle: {
          "display": "inline-block",
          "margin-left": "1em",
          "text-align": "center"
        }
      }, [_vm._m(0, true), _vm._v(" "), _c('span', {
        staticClass: "sp-app-default-color",
        staticStyle: {
          "font-size": "12px"
        }
      }, [(_vm.user.user_id == u.activity_user) ? _c('span', [_vm._v("You")]) : _c('span', [_vm._v(_vm._s(u.activity_user_fullname))])])])
    })), _vm._v(" "), _c('ul', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'S2G' + shpindex
      }
    }, [_c('li', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shp.data_caption),
        expression: "shp.data_caption"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Say something about this"
      },
      domProps: {
        "value": (shp.data_caption)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          shp.data_caption = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('li', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_c('button', {
      staticClass: "btn sp-button-sm",
      staticStyle: {
        "background": "#fc4112 !important",
        "color": "#ffffff !important"
      },
      attrs: {
        "id": "myBtn",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.shareOnShopTogether(shp, shpindex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-share-alt"
    })])])])])
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "src": "/static/assets/images/dummy-image.png",
      "width": "30",
      "height": "30"
    }
  })])
}]}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap"
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "6em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_c('span', {
    staticStyle: {
      "float": "left",
      "font-size": "13px",
      "color": "#5703a5"
    }
  }, [_vm._v("Service Charge: ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "margin-top": "-0.41em"
    }
  }, [_c('span', {
    staticClass: "nra-fmt"
  }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(_vm.service_charge_balance)))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#242323"
    }
  }, [_vm._v("Add funds to your Service Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.processing_fee.amount),
      expression: "processing_fee.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Amount"
    },
    domProps: {
      "value": (_vm.processing_fee.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.processing_fee.amount = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.menu_tab_inner_view['addProcessingFees']) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    staticStyle: {
      "margin-top": "5px",
      "background-color": "#5703a5",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddProcessingFees()
      }
    }
  }, [_vm._v("Enter")])]) : _vm._e()]), _vm._v(" "), (_vm.menu_tab_inner_view['addProcessingFees']) ? _c('div', [(((_vm.data_error.email))) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v("Provide your email address to make an online payment")]), _vm._v(_vm._s(_vm.user) + "\r\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Email Address"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    staticStyle: {
      "margin-top": "5px",
      "background-color": "#5703a5",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editProfileDetails()
      }
    }
  }, [_vm._v("Save")])])]) : _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    staticStyle: {
      "margin-top": "5px",
      "background-color": "#5703a5",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.addtoProcessingFee()
      }
    }
  }, [_vm._v("Add Fund")])])])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-head"
  }, [_c('h4', [_vm._v("Service charge Transactions "), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("(" + _vm._s(Object.keys(_vm.processing_fee_transactions).length) + ")")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "1em"
    }
  }, _vm._l((_vm.processing_fee_transactions), function(txn, tdex) {
    return _c('div', {
      staticClass: "col-xs-12 mp0"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8",
      staticStyle: {
        "padding-left": "1.3em"
      }
    }, [_c('p', [(txn.data_transaction_action_type == 1) ? _c('span', [_vm._v("Account Credited")]) : _vm._e(), _vm._v(" "), (txn.data_transaction_action_type == 2) ? _c('span', [_vm._v("Account Debited")]) : _vm._e(), _c('br'), _vm._v("\r\n                  " + _vm._s(txn.data_transaction_time_ago) + "\r\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('p', {
      staticClass: "sp-app-default-color"
    }, [_c('span', {
      staticClass: "nra-fmt"
    }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(txn.data_transaction_amount)))])])])
  }))])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "right",
      "margin-top": "-0.1em"
    }
  }, [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "font-size": "18px",
      "border-radius": "8px",
      "line-height": "0.8",
      "color": "#000000"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down",
    staticStyle: {
      "color": "#5703a5"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-1"
  }, [_c('i', {
    staticClass: "fa fa-exchange",
    staticStyle: {
      "padding": "0.4em 0.4em",
      "border-radius": "50%",
      "background-color": "#eee",
      "color": "#242323"
    }
  })])
}]}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "on-dark",
    staticStyle: {
      "padding-left": "12px",
      "margin-top": "-0.3px",
      "font-size": "18px",
      "text-align": "left"
    }
  }, [_vm._v("Shopping Cart")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "chart-page"
  }, [_c('div', {
    staticClass: "container"
  }, [(!_vm.cart.length) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "1.4em"
    }
  }, [_vm._m(1), _vm._v(" "), _c('component-footer')], 1) : _c('div', {
    staticClass: "col-sm-12 chart-card"
  }, [_c('cart-widget')], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h5', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center"
    }
  }, [_vm._v("Your cart is empty,")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "padding": "0.5em",
      "background": "#ffa800",
      "color": "#000000"
    },
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Start Buying")])])
}]}

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "header-wrap-sticky"
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), (_vm.loading) ? _c('div') : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "3em",
      "padding": "2em"
    }
  }, [_c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "border": "#000000 solid 1px"
    }
  }, [_c('div', {
    staticClass: "containeraa"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "height": "13em",
      "border": "#eee solid 1px",
      "border-radius": "8px"
    }
  }, [_vm._v("\r\n                  hinnnn\r\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "height": "50vh"
    }
  }, [_c('div', {
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin": "0em",
      "margin-top": "1em",
      "background": "#ffffff"
    }
  }, _vm._l((_vm.products), function(product, index) {
    return (product.product_images.length > 0) ? _c('div', {
      staticClass: "col-xs-3"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('a', {
      staticClass: "card-link",
      attrs: {
        "href": '/make/order/' + product.product_url_name
      }
    }, [_c('div', {}, [(product.product_images[0]) ? _c('img', {
      staticClass: "card-col-d-img",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('span', {
      staticStyle: {
        "display": "block"
      },
      attrs: {
        "id": 'prdQty' + index
      }
    }, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'sub', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(product.product_items[0].product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'add', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])])]), _vm._v(" "), (_vm.checkOrderItems(product.product_items[0])) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(1, product.product_items[0], index, 0);
          _vm.toggleSingleComponent('prdQty' + index)
        }
      }
    }, [_vm._m(0, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(1, product.product_items[0], index, 0);
          _vm.toggleSingleComponent('prdQty' + index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])])])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])])]), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "height": "80vh",
      "border": "#000000 solid 1px"
    }
  }, [_c('button', [_vm._v("Checkout")])])
}]}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-8 contact_form add-prd-item"
  }, [_c('h6', [_vm._v("Add New Item ")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Price\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Weight\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Quantity\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" Product Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addProductItem
    }
  }, [_vm._v("Add")])])])])])
},staticRenderFns: []}

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "page-top-header sticky-tab",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "pageStickyHeaderXXX"
    }
  }, [_c('div', {
    staticClass: "head-tags"
  }, [_c('div', {
    staticClass: "card-label"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": _vm.back
    }
  }, [_c('div', {
    staticClass: "card card-label"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "0.6em",
      "margin-top": "-2em"
    }
  }, [_c('div', {
    staticClass: "card-arm-line"
  }, [_c('p', {
    staticStyle: {
      "padding-top": "9px"
    }
  }, [_c('b', [_vm._v("Category: ")]), _vm._v(_vm._s(_vm.category.business_category_name) + "\r\n                "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Products in " + _vm._s(_vm.category.business_category_name))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1",
    staticStyle: {
      "display": "none",
      "padding": "0",
      "margin": "0",
      "float": "right",
      "margin-right": "1.3em"
    }
  }, [_c('div', {
    staticClass: "leftbtn",
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabView('business', 'manageBusinessCategory', _vm.sellpoint, _vm.category)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-slide"
  }, [_c('ul', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "-0.2em"
    }
  }, [_c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "viewBusinessCategory"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('viewBusinessCategory', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Products")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "manageBusinessCategory"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('manageBusinessCategory', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Settings")])])])])]), _vm._v(" "), _c('div', {}, [_c('div', {}, [_c('p', {
    staticStyle: {
      "padding-top": "9px"
    }
  }, [_c('b', [_vm._v("Category: ")]), _vm._v(_vm._s(_vm.category.business_category_name))]), _vm._v(" "), _c('p', [(_vm.category.category_products) ? _c('span', [_vm._v("Total Products:" + _vm._s(_vm.category.category_products.length))]) : _vm._e()]), _vm._v(" "), _c('p', [_c('span', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('viewBusinessCategory', '', '')
      }
    }
  }, [_vm._v("Products | ")])]), _vm._v(" "), _c('span', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('manageBusinessCategory', '', '')
      }
    }
  }, [_vm._v("Settings | ")])]), _vm._v(" "), _c('span', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.prepAddProduct()
      }
    }
  }, [_vm._v("Add New Product")])])])])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.businessComponentKey,
    staticClass: "row-after-stick"
  }, [(_vm.menu_tab_inner_view.viewBusinessCategory) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "left",
      "padding": "0 0.1em",
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "card card-flat"
  }, [_vm._m(1), _vm._v(" "), (_vm.category.category_products && (_vm.category.category_products.length != 0)) ? _c('div', _vm._l((_vm.category.category_products), function(product, index) {
    return _c('div', {
      staticClass: "card card-01 timeline-user-card p-card-fit-00"
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setProduct(product)
        }
      }
    }, [_c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-square p-card-fit-01"
    }, [(product.product_images[0]) ? _c('img', {
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right p-card-fit-02 card-colord-01"
    }, [_c('div', {
      staticClass: "card-arm-line"
    }, [_c('p', [_vm._v(_vm._s(product.product_name))]), _vm._v(" "), (product.product_items[0]) ? _c('span', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e()])])])])
  })) : _c('div', [_c('p', [_vm._v("No products in this category")])]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.prepAddProduct()
      }
    }
  }, [_vm._v("Add New Product")])])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view.manageBusinessCategory) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "left",
      "padding": "1em",
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "card-row",
    staticStyle: {
      "margin-top": "1.5em"
    }
  }, [_c('p', [_c('b', [_vm._v("Category Name: ")]), _vm._v(_vm._s(_vm.category.business_category_name))]), _vm._v(" "), (_vm.category.can_edit == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You can not edit this category name, it has a default setting")]) : _vm._e(), _vm._v(" "), (_vm.category.can_edit == 1) ? _c('a', {
    staticClass: "btn sp-button-02 sp-button-02-soft sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('editBusinessCategory', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Rename "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.category.business_category))])]) : _vm._e(), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card card-out-colord-pad",
    staticStyle: {
      "display": "none",
      "margin-top": "1.5em"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "rounded",
    staticStyle: {
      "width": "100%",
      "height": "120px",
      "object-fit": "contain"
    },
    attrs: {
      "src": _vm.category.business_category_image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "banner-btn upload-btn-wrapper",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('button', {
    staticClass: "upload-btn sp-button-02 sp-button-02-soft sp-button-sm",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "12px",
      "line-height": "0.6"
    },
    attrs: {
      "disabled": _vm.disable_btn
    }
  }, [_vm._v("Change Category Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'business_category', _vm.category.business_category_id)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-row",
    staticStyle: {
      "padding-top": "0em"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-02 sp-button-02-soft sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('deleteBusinessCategory', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Delete Category")])])])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view.editBusinessCategory) ? _c('div', [_c('div', {
    staticClass: "form-card"
  }, [_c('h6', [_vm._v("Rename " + _vm._s(_vm.category.business_category))]), _vm._v(" "), _c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('p', {
    staticClass: "info info-processing"
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('label', {}, [_vm._v("Enter category name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.business_category),
      expression: "category.business_category"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.category.business_category)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.category.business_category = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editCategory
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-check"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '');
        _vm.setMenuTabInnerView('manageBusinessCategory', _vm.sellpoint, _vm.category);
      }
    }
  }, [_vm._v("Cancel "), _c('i', {
    staticClass: "fa fa-ban"
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view.deleteBusinessCategory) ? _c('div', [_c('div', {
    staticClass: "form-card"
  }, [_c('p', [_vm._v("Do you want to Delete this Category and all products within it")]), _vm._v(" "), _c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "info info-processing"
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteCategory
    }
  }, [_vm._v("Yes,Request Delete")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '');
        _vm.setMenuTabInnerView('manageBusinessCategory', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Cancel ")])])])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Category Image")])])
}]}

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _c('div', [_c('div', {
    staticClass: "page-top-header sticky-tab",
    attrs: {
      "id": "pageStickyHeaderXXXX"
    }
  }, [_c('div', {
    staticClass: "head-tags",
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    staticClass: "sp-app-default-color",
    staticStyle: {
      "float": "right",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('viewBusinessCategory', _vm.sellpoint, _vm.category)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  }), _vm._v(" Back to category")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 header-left",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "headTagBack"
    }
  }, [_c('a', {
    staticClass: "header-nav-back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 card-label"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": _vm.back
    }
  }, [_c('div', {
    staticClass: "card card-label"
  }, [_c('div', {
    staticClass: "card-label-left"
  }, [_c('div', {
    staticClass: "card-avatar-square card-label-avatar"
  }, [(_vm.product.product_images && (_vm.product.product_images.length != 0)) ? _c('img', {
    attrs: {
      "src": _vm.product.product_images[0].product_image
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-label-right"
  }, [_c('div', {
    staticClass: "card-arm-line"
  }, [_c('p', [_vm._v(_vm._s(_vm.product.product_name)), _c('br'), _vm._v(" "), (_vm.product.product_items && (_vm.product.product_items.length != 0)) ? _c('span', [_vm._v("₦" + _vm._s(_vm.product.product_items[0].product_item_price_f))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1",
    staticStyle: {
      "display": "none",
      "padding": "0",
      "margin": "0",
      "float": "right",
      "margin-right": "1.3em"
    }
  }, [_c('div', {
    staticClass: "leftbtn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabView('product', 'manageBusinessCategoryProduct', _vm.sellpoint, _vm.product)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-slide",
    staticStyle: {
      "display": "none",
      "margin-top": "0.6em"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('product', 'setBusinessCategoryProductDetails', _vm.sellpoint, '/account/business/product')
      }
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('product', 'setBusinessCategoryProductDetails', _vm.sellpoint, '/account/business/product/types')
      }
    }
  }, [_vm._v("Types")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('product', 'setBusinessCategoryProductDetails', _vm.sellpoint, '/account/business/product/orders')
      }
    }
  }, [_vm._v("Orders")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('product', 'setBusinessCategoryProductDetails', _vm.sellpoint, '/account/business/product/settings')
      }
    }
  }, [_vm._v("More")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row-after-stick"
  }, [(this.$route.path != '/account/business/product') ? _c('div', [_c('router-view')], 1) : _c('div', [_c('div', {
    staticClass: "card card-flat"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "1.5em"
    }
  }, [_c('div', {
    staticClass: "card-row"
  }, [_c('h5', {
    staticClass: "t-intro"
  }, [_vm._v("Product Name")]), _vm._v(" "), _c('p', {
    staticClass: "t-details"
  }, [_vm._v(_vm._s(_vm.product.product_name))]), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_c('h5', {
    staticClass: "t-intro"
  }, [_vm._v("Price")]), _vm._v(" "), _c('p', {
    staticClass: "t-details"
  }, [_vm._v("₦" + _vm._s(_vm.product_item.product_item_price_f))]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_c('h5', {
    staticClass: "t-intro"
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('p', {
    staticClass: "t-details"
  }, [_vm._v(_vm._s(_vm.product_item.product_item_quantity) + "  "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductItemQuantityRestock')
      }
    }
  }, [_vm._v("Restock")])]), _vm._v(" "), (_vm.product_details.setProductItemQuantityRestock) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_item.product_item_quantity_restock),
      expression: "product_item.product_item_quantity_restock"
    }],
    staticClass: "qty-input qty-input-sm",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product_item.product_item_quantity_restock)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_item.product_item_quantity_restock = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.restockProductItem
    }
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-xs"
  }) : _c('span', [_vm._v("Add")])]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.product_details = {};
      }
    }
  }, [_vm._v("\r\n                    Cancel")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "card-row",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('h5', {
    staticClass: "t-intro"
  }, [_vm._v("Product Photos")]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticStyle: {
      "max-height": "275px"
    }
  }, [(_vm.product_display_image && (_vm.product_display_image.product_image != '' && _vm.product_display_image.product_image != 'error')) ? _c('img', {
    staticClass: "sp-prd-img",
    attrs: {
      "src": _vm.img_product_url + _vm.product_display_image.product_image,
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "img-responsive sp-prd-img",
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })])]), _vm._v(" "), (_vm.product.product_images && (_vm.product.product_images.length > 1)) ? _c('div', {
    staticClass: "img-row",
    staticStyle: {
      "margin-bottom": "5px",
      "width": "100%",
      "height": "25%"
    }
  }, [_vm._l((_vm.product.product_images), function(pt) {
    return _c('li', {
      staticClass: "img-column",
      staticStyle: {
        "border": "none",
        "margin-bottom": "5px"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.product_display_image = pt
        }
      }
    }, [_c('img', {
      staticClass: "sp-prd-img",
      staticStyle: {
        "height": "50px",
        "width": "80px"
      },
      attrs: {
        "src": _vm.img_product_url + pt.product_image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs sp-button-02 sp-button-sm sp-button-style-1",
      staticStyle: {
        "font-size": "12px",
        "padding": "6px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteProductImage(pt.product_image_id)
        }
      }
    }, [_vm._v("Remove")])])
  }), _vm._v(" "), _c('li', {
    staticStyle: {
      "border": "none",
      "float": "right"
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [(_vm.action_loading && _vm.product_details.uploading_image) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "padding-bottom": "1em"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "upload-btn sp-button-02 sp-button-sm",
    staticStyle: {
      "line-height": "1.8",
      "font-size": "14px",
      "background-color": "#f7f7f7"
    }
  }, [_vm._v("Add new Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'products', _vm.product.product_id)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_c('h5', {
    staticClass: "t-intro"
  }, [_vm._v("Category")]), _vm._v(" "), _c('p', {
    staticClass: "t-details"
  }, [_vm._v(_vm._s(_vm.product.product_category_name))]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_c('h5', {
    staticClass: "t-intro"
  }, [_vm._v("Weight: " + _vm._s(_vm.product.product_items[0].product_item_weight) + "(kg)")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_c('h5', {
    staticClass: "t-intro"
  }, [_vm._v("Product Description")]), _vm._v(" "), _c('p', {
    staticClass: "t-details"
  }, [_vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_c('h5', {
    staticClass: "t-intro"
  }, [_vm._v("Product Details")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, _vm._l((_vm.product.product_information), function(detail, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (detail.product_info_title),
        expression: "detail.product_info_title"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (detail.product_info_title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          detail.product_info_title = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "75%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (detail.product_info_detail),
        expression: "detail.product_info_detail"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (detail.product_info_detail)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          detail.product_info_detail = $event.target.value
        }
      }
    })])])
  })), _vm._v(" "), _c('hr')]), _vm._v(" "), ((_vm.product_details.editProduct) && (_vm.product_details.setProductSingleProductItem)) ? _c('div', {
    staticClass: "card-row"
  }, [(_vm.product_details.editProduct) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('h6', [_vm._v("Edit Product")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" *Product Name ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("Category:- " + _vm._s(_vm.product.product_category_name) + " ")]), _vm._v(" "), (_vm.sellpoint_categories.length > 0) ? _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [_vm._v(" Select from My Shop Categories")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "category-type-1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-1')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_1
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('option', {
      key: category.business_category_id,
      attrs: {
        "disabled": _vm.category_type_1
      },
      domProps: {
        "value": category.business_category_id
      }
    }, [_vm._v(_vm._s(category.business_category))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [(_vm.sellpoint_categories.length > 0) ? _c('span', [_c('b', [_vm._v("Or ")])]) : _vm._e(), _vm._v(" Select from Related Categories")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main_category),
      expression: "main_category"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.main_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getSubCategories(_vm.main_category)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      key: category.category_id,
      domProps: {
        "value": category
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]), _vm._v(" "), (_vm.sub_categories.length != 0) ? _c('div', {
    staticClass: "form-group col-md-6"
  }, [(_vm.sub_categories.length != 0) ? _c('label', [_vm._v(" Select a Category")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_sub_category),
      expression: "product.product_sub_category"
    }],
    staticClass: "form-control category-type-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_sub_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-2')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_2
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(category) {
    return _c('option', {
      key: category.sub_category_id,
      attrs: {
        "disabled": _vm.category_type_2
      },
      domProps: {
        "value": category.sub_category_id
      }
    }, [_vm._v(_vm._s(category.sub_category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-8"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_listed_category),
      expression: "product.product_listed_category"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.category_type_3,
      "type": "text",
      "placeholder": "",
      "id": "category-type-3"
    },
    domProps: {
      "value": (_vm.product.product_listed_category)
    },
    on: {
      "change": function($event) {
        _vm.trackevent('category-type-3')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_listed_category = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', [_vm._v(" *Product Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    staticClass: "form-control txtarea",
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProduct
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])])])]) : _vm._e(), _vm._v(" "), (_vm.product_details.setProductSingleProductItem) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('h6', {
    staticStyle: {
      "font-size": "14px",
      "text-decoration": "underline"
    }
  }, [_vm._v("Reset Product Details")]), _vm._v(" "), _c('form', {
    key: _vm.prdItemPriceKey,
    staticClass: "sp-forms-one"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "inline"
    }
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v("\r\n                    Price\r\n                    "), (_vm.product.product_items[0].product_item_actual_price != 0) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_items[0].product_item_actual_price),
      expression: "product.product_items[0].product_item_actual_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_items[0].product_item_actual_price)
    },
    on: {
      "change": function($event) {
        _vm.numStrip01()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_items[0].product_item_actual_price = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_items[0].product_item_price),
      expression: "product.product_items[0].product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_items[0].product_item_price)
    },
    on: {
      "change": function($event) {
        _vm.numStrip01()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_items[0].product_item_price = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.product.product_has_wholesale_options) ? _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "width": "85%"
    }
  }, [_c('button', {
    attrs: {
      "id": "myBtn",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.openModal('setWholesalePricesModal')
      }
    }
  }, [_vm._v("Set Wholesale Prices")])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('label', [_vm._v(" Weight(kg)\r\n                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_items[0].product_item_weight),
      expression: "product.product_items[0].product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_items[0].product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_items[0].product_item_weight = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('label', [_vm._v(" Quantity\r\n                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_items[0].product_item_quantity),
      expression: "product.product_items[0].product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_items[0].product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_items[0].product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 col-md-2",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProductSingleProductItem
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 col-md-2",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])])])]) : _vm._e()]) : _c('div', {
    staticClass: "card-row"
  }, [_c('h5', {
    staticClass: "t-intro"
  }, [_vm._v("Product Settings")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('button', {
    staticClass: "btn btn-xs sp-button-02 sp-button-sm sp-button-style-1",
    on: {
      "click": function($event) {
        _vm.setProductComponent('editProduct', '')
      }
    }
  }, [_vm._v("Edit Product Details")])]), _vm._v(" "), ((_vm.product.product_set_items == 0 || (_vm.product.product_items.length == 1))) ? _c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('button', {
    staticClass: "btn btn-xs sp-button-02 sp-button-sm sp-button-style-1",
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductSingleProductItem', '')
      }
    }
  }, [_vm._v("Edit Price/Weight/Quantity")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_c('h5', {
    staticClass: "t-intro"
  }, [_vm._v("Product Types, Sizes, Colours")]), _vm._v(" "), (((_vm.product.product_set_items > 0))) ? _c('div', {}, [_vm._l((_vm.product.product_items), function(pt, ptdex) {
    return _c('div', {
      staticClass: "card col-xs-12"
    }, [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      staticClass: "col-xs-3",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "box-cube"
    }, [(pt.product_item_group_is_color_image == 'IMG') ? _c('div', {
      staticClass: "box-color-cube",
      staticStyle: {
        "z-index": "3"
      }
    }, [((pt.product_item_group_image && (pt.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": pt.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (pt.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pt.product_item_group_color
      })
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9 mp-flat",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [(_vm.product.product_service == 'P' && (pt.product_item_size)) ? _c('span', {
      staticStyle: {
        "font-weight": "bolder",
        "font-size": "10px"
      }
    }, [_vm._v(_vm._s(pt.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (pt.product_item_service_tag)) ? _c('span', {
      staticStyle: {
        "font-weight": "bolder",
        "font-size": "10px"
      }
    }, [_vm._v(_vm._s(pt.product_item_service_tag))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "11px"
      }
    }, [(_vm.product.product_service == 'P') ? _c('span', [_vm._m(2, true), _vm._v(_vm._s(pt.product_item_weight))]) : _vm._e(), _vm._v(" "), (pt.product_item_actual_price != 0) ? _c('span', [_vm._m(3, true), _vm._v(_vm._s(pt.product_item_actual_price))]) : _c('span', [_vm._m(4, true), _vm._v(_vm._s(pt.product_item_price))]), _vm._v(" "), _c('span', [_vm._m(5, true), _vm._v(_vm._s(pt.product_item_quantity))])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2) : _vm._e(), _vm._v(" "), (((_vm.product.product_set_groups > 0) && (_vm.product.product_set_items > 0))) ? _c('div', {}) : _c('div', [_c('p', {
    staticClass: "sp-app-default-color",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("No Groups/Types set")])]), _vm._v(" "), _c('div', {}, [_c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setMenuTabView('product', 'setBusinessCategoryProductItems', _vm.sellpoint, '')
      }
    }
  }, [_vm._v("Set Product Groups/Types")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(!_vm.product_details.removeProduct) ? _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "line-height": "2em",
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('removeProduct', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete this Product")]) : _vm._e(), _vm._v(" "), (_vm.product_details.removeProduct) ? _c('span', {}, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to remove this Product?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs sp-button-02 sp-button-sm",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.removeProduct
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs sp-button-02 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr')])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v("Or ")]), _vm._v(" Enter a specific Category")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Wt(kg):")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Price:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Price:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Qty:")])])
}]}

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: _vm.componentKey,
    staticClass: "pager",
    staticStyle: {
      "background": "#fcfcfc"
    }
  }, [_c('div', {
    staticClass: "section",
    staticStyle: {
      "margin-top": "0em",
      "text-align": "left"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', {}, [_vm._l((_vm.checkout_orders), function(order_data, index) {
    return _c('div', {
      staticClass: "group-row gp-row00 container",
      staticStyle: {
        "margin": "1em 2em",
        "box-shadow": "0 0 30px 4px rgba(0,0,0,0.03)"
      }
    }, [_c('div', [_vm._m(0, true), _vm._v(" "), _c('div', [_c('div', {}, [_c('div', [_vm._v("Order number: " + _vm._s(order_data.order_no))]), _vm._v(" "), _c('div', [_vm._v("Date: " + _vm._s(order_data.order_date))]), _vm._v(" "), _c('div', [_vm._v("Payment method: Online Payment")]), _vm._v(" "), _c('div', [_vm._v("Status: "), _c('span', {
      style: ({
        color: order_data.order_status_color
      })
    }, [_vm._v(_vm._s(order_data.order_status))])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('div', [_vm._v("Order Amount: ₦" + _vm._s(order_data.order_items_total))]), _vm._v(" "), _c('div', [_vm._v("Shipping:  ₦" + _vm._s(order_data.order_shipping_total))]), _vm._v(" "), _c('div', [_vm._v("Total: ₦" + _vm._s(order_data.order_total))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('div', [_vm._v("Delivery Location: " + _vm._s(order_data.order_delivery_city))]), _vm._v(" "), _c('div', [_vm._v("Address: " + _vm._s(order_data.order_user_delivery_address))])])]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', [_vm._v("jkj\r\n                        " + _vm._s(order_data.order_chart) + "\r\n                        "), _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.setOrderCustomMakePaymentUpdate(order_data)
        }
      }
    }, [_vm._v("pay")])]), _vm._v(" "), _c('label', [_vm._v("Order Payment Receipt")]), _vm._v(" "), _c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "id": "prImagePreview"
      }
    }), _vm._v(" "), ((Object.keys(_vm.file_info).length == 0)) ? _c('div', {
      staticClass: "upload-btn-wrapper",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('button', {
      staticClass: "upload-btn",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("Upload Receipt")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "input-file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          _vm.onFileChangeNewPhoto($event, 'transfer-receipt')
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.file_info[0]) ? _c('div', [_c('p', [(_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Uploading Receipt: " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default wnf-button",
      staticStyle: {
        "width": "30vw",
        "margin-left": "0vw",
        "padding": "5px 3px"
      },
      attrs: {
        "disabled": _vm.disable_btn
      },
      on: {
        "click": function($event) {
          _vm.setOrderCustomUploadReceipt(order_data)
        }
      }
    }, [_vm._v("Yes, Upload")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default wnf-button",
      staticStyle: {
        "width": "30vw",
        "margin-left": "0vw",
        "padding": "5px 3px",
        "background-color": "#f5f4e6",
        "color": "#000000"
      },
      on: {
        "click": function($event) {
          _vm.file_info = []
        }
      }
    }, [_vm._v("Cancel")])]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "sp-button sp-button-lt",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderCustomUpdates(order_data, 'received')
        }
      }
    }, [_vm._v("Mark as received")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
      staticClass: "sp-button sp-button-lt",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderCustomUpdates(order_data, 'closed')
        }
      }
    }, [_vm._v("Close Order")])])])
  }), _vm._v(" "), (_vm.checkout_orders.length != 0) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [(!_vm.checkout_processed) ? _c('div', [_c('div', {
    staticClass: "container",
    staticStyle: {
      "background": "#ffffff",
      "margin": "0 1em",
      "margin-top": "-1em"
    }
  }, [_c('h4', {
    staticClass: "ck-hh"
  }, [_vm._v("Billing details")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#000000",
      "font-size": "13px"
    }
  }, [_vm._v("Enter the details below to Checkout"), _c('br'), _vm._v(" "), (_vm.new_account) ? _c('span', [_vm._v("Do you have a "), _c('b', [_vm._v("Buypoint Account? ")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "sp-app-default-color",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('login', '')
      }
    }
  }, [_vm._v("You can use it to process your orders")])]) : _c('span', [_vm._v("Don't have a "), _c('b', [_vm._v("Buypoint Account? ")]), _vm._v(" "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('new-account', '')
      }
    }
  }, [_vm._v("Click Here")])])])]), _vm._v(" "), _c('div', {}, [(_vm.new_account) ? _c('form', [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "email",
      "placeholder": "Email",
      "id": "Last-name-2"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "number",
      "placeholder": "Phone No"
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [(_vm.data_success_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]) : _vm._e(), _vm._v(" "), (_vm.data_error_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn wnf-button",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.prep_process_checkout
    }
  }, [_vm._v("Process Checkout")])])])]) : _c('form', [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-groupw"
  }, [(_vm.data_success_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]) : _vm._e(), _vm._v(" "), (_vm.data_error_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn wnf-button",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.loginAndProcess()
      }
    }
  }, [_vm._v("Process Checkout")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('h4', {
    staticClass: "ck-hh"
  }, [_vm._v("Items to Checkout")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1em",
      "margin-top": "-1em"
    }
  }, _vm._l((_vm.checkout_orders), function(group, index) {
    return _c('div', {
      staticClass: "group-row",
      staticStyle: {
        "height": "auto"
      }
    }, [_c('div', {
      staticStyle: {
        "margin": "1em"
      }
    }, [_vm._l((group.order_items), function(item) {
      return _c('div', {
        staticStyle: {
          "width": "100%",
          "padding-top": "1em"
        }
      }, [_c('div', [_c('div', {
        staticStyle: {
          "width": "30%",
          "float": "left"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "href": item.product_url
        }
      }, [((item.product_item_image && (item.product_item_image != ''))) ? _c('img', {
        staticClass: "sp-prd-img",
        staticStyle: {
          "height": "80px"
        },
        attrs: {
          "src": _vm.img_product_url + item.product_item_image
        }
      }) : _c('img', {
        staticClass: "sp-prd-img",
        staticStyle: {
          "height": "80px"
        },
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "width": "60%",
          "float": "right"
        }
      }, [_c('h5', [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), _c('p', {
        staticClass: "sp-app-default-color",
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v(" Qty: " + _vm._s(item.product_item_order_quantity))]), _c('br'), _vm._v(" "), _c('p', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v("  ₦" + _vm._s(_vm.formatCurrency_2(item.product_item_price * item.product_item_order_quantity)))]), _c('br'), _vm._v(" "), (group.order_items.length > 1) ? _c('div', {
        staticClass: "col-xs-9 pull-right"
      }, [(item.calculated_product_delivery_fee > 0) ? _c('p', [_vm._v("This item's Shipping Fee: " + _vm._s(item.calculated_product_delivery_fee))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      })])])
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none",
        "clear": "both",
        "width": "100%",
        "border-top": "#f3f0f0 solid 1px",
        "padding-top": "1em",
        "padding-bottom": "1em"
      }
    }, [(group.total_order_coupons_amount != 0) ? _c('div', [_vm._m(2, true), _vm._v(" "), _c('label', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("₦" + _vm._s((group.total_order_coupons_amount).toFixed(2)))])]) : _vm._e(), _vm._v(" "), _c('div', [_vm._m(3, true), _vm._v(" "), _c('label', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("₦" + _vm._s((group.order_total_amount).toFixed(2)))])]), _vm._v(" "), (group.order_total_delivery_charge > 0) ? _c('div', [_vm._m(4, true), _vm._v(" "), _c('label', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("₦" + _vm._s(group.order_total_delivery_charge))])]) : _vm._e()])], 2)])
  }))])]) : _c('div', {
    staticClass: "container"
  }, [(!_vm.flexi_pay) ? _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1em",
      "margin-top": "0.5em"
    }
  }, [(Object.keys(_vm.share_cart_details).length > 0) ? _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "card card-flat-pad",
    staticStyle: {
      "text-align": "center",
      "background": "#ff0066",
      "color": "#ffffff",
      "height": "auto",
      "padding": "2em",
      "border-radius": "5px"
    }
  }, [_c('h3', [_vm._v("Share Cart Order")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._m(5), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.app_url) + "sharecart/" + _vm._s(_vm.share_cart_details.order_share_cart_ref_link))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF-CODE: ")]), _vm._v(_vm._s(_vm.share_cart_details.order_share_cart_ref_code))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.copyLink(_vm.app_url + 'sharecart/' + _vm.share_cart_details.order_share_cart_ref_link, 'MAINSHCRCOPY')
      }
    }
  }, [_vm._v("Copy Link")]), _vm._v(" "), (_vm.copied) ? _c('span', {
    staticStyle: {
      "background": "rgb(240, 227, 157)"
    },
    attrs: {
      "id": "MAINSHCRCOPY"
    }
  }, [_vm._v("Copied")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "ck-hh"
  }, [_vm._v("Checkout")]), _vm._v(" "), _c('div', {
    staticClass: "row cktop ck-card-row card",
    staticStyle: {
      "background": "#ffffff",
      "margin-left": "-1em"
    }
  }, [_c('div', {
    staticClass: "mobi-on"
  }, [_c('p', [_c('b', [_c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("\r\n                                            Total")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("₦" + _vm._s(_vm.formatCurrency_2(_vm.total_orders_amount)))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {}, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.payment_details.payment_payer_name))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.payment_details.payment_payer_phone))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.payment_details.payment_payer_email))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1.5em 2.5em"
    }
  }, [_vm._l((_vm.checkout_orders), function(group, index) {
    return _c('div', {
      staticClass: "group-row gp-row00",
      staticStyle: {
        "box-shadow": "0 0 30px 4px rgba(0,0,0,0.03)"
      }
    }, [_c('div', {
      staticStyle: {
        "background": "#000000",
        "color": "#ffffff",
        "margin": "-8px",
        "padding": "0 8px",
        "padding-top": "6px",
        "border-radius": "15px 15px 0px 0px"
      }
    }, [_c('span', {
      staticClass: "sp-app-default-color",
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(group.order_time_ago))]), _vm._v(" "), (group.order_is_business_agent && (group.order_is_business_agent == 1)) ? _c('p', {
      staticClass: "sp-app-default-color-off"
    }, [_c('b', [_vm._v(_vm._s(group.order_business_agent_name))])]) : _c('p', {
      staticClass: "sp-app-default-color-off"
    }, [_vm._v("Shop: "), _c('b', [_vm._v(_vm._s(group.order_business))])]), _vm._v(" "), ((group.order_business_agent_type && (group.order_business_agent_type == 19))) ? _c('p', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Selling for: ")]), _c('b', [_vm._v(_vm._s(group.order_business))])]) : _vm._e(), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (((Object.keys(_vm.share_cart_details).length == 0) && (Object.keys(group.order_share_cart_details).length > 0))) ? _c('div', [_c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('button', {
      staticClass: "btn sp-button-sm",
      staticStyle: {
        "background": "#ff0066",
        "color": "#ffffff"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView(_vm.menu_tab_inner_view['SHCR' + index] ? ' ' : 'SHCR' + index)
        }
      }
    }, [_vm._v("Share "), _c('i', {
      staticClass: "fa fa-angle-down"
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (_vm.menu_tab_inner_view['SHCR' + index]) ? _c('div', {
      staticClass: "card card-flat-pad",
      staticStyle: {
        "text-align": "center",
        "border": "3px solid #ff0066",
        "color": "inherit",
        "height": "auto",
        "padding": "2em",
        "border-radius": "5px"
      }
    }, [_c('h3', [_vm._v("Share Cart Order")]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._m(6, true), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.app_url) + _vm._s(group.order_share_cart_details.order_share_cart_ref_link))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF-CODE: ")]), _vm._v(_vm._s(group.order_share_cart_details.order_share_cart_ref_code))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1 sp-button-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.copyLink(_vm.app_url + group.order_share_cart_details.order_share_cart_ref_link, 'SHCRCOPY')
        }
      }
    }, [_vm._v("Copy Link")]), _vm._v(" "), (_vm.copied) ? _c('span', {
      staticStyle: {
        "background": "rgb(240, 227, 157)"
      },
      attrs: {
        "id": "SHCRCOPY"
      }
    }, [_vm._v("Copied")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((group.order_items_groups), function(item_group, igdex) {
      return _c('div', {
        staticClass: "row ck-card-row",
        staticStyle: {
          "clear": "both"
        }
      }, [_vm._v(_vm._s(igdex) + "\r\n                                    "), _vm._l((item_group), function(item) {
        return _c('div', {}, [_c('div', {
          staticStyle: {
            "width": "30%",
            "float": "left"
          }
        }, [_c('a', {
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "href": item.product_url
          }
        }, [((item.product_item_group_image && (item.product_item_group_image != ''))) ? _c('img', {
          staticClass: "sp-prd-img",
          attrs: {
            "src": item.product_item_group_image
          }
        }) : _c('img', {
          staticClass: "sp-prd-img",
          attrs: {
            "src": "/static/assets/images/dummy-image.png"
          }
        })])]), _vm._v(" "), _c('div', {
          staticStyle: {
            "width": "60%",
            "float": "right"
          }
        }, [_c('h5', [_vm._v(_vm._s(item.product_name))]), _c('p', [_vm._v(_vm._s(item.order_item_is_an_addon_to) + "--" + _vm._s(item.order_item_addon))]), _vm._v(" "), _c('p', [_vm._v(" QTY: " + _vm._s(item.order_item_quantity))]), _vm._v(" "), _c('p', [(item.order_item_quantity > 1) ? _c('span', {
          staticClass: "price"
        }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_total_price.toFixed(2))), _c('br')]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v("Total: ")]), _vm._v("₦" + _vm._s(item.order_item_total) + "\r\n                                            ")])]), _vm._v(" "), (group.order_status_id == 7) ? _c('div', {
          staticStyle: {
            "clear": "both",
            "width": "100%",
            "border-top": "#f3f0f0 solid 1px",
            "padding-top": "1em"
          }
        }, [_vm._m(7, true), _vm._v(" "), ((group.order_items.length > 1)) ? _c('div', {
          staticStyle: {
            "clear": "both"
          }
        }, [(item.order_item_delivery_fee != 0) ? _c('div', [_c('span', {
          staticStyle: {
            "color": "#ff0000",
            "float": "left"
          }
        }, [_vm._v("Product Shipping Fee:")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("₦" + _vm._s(item.order_item_delivery_fee))]), _c('br')]) : _vm._e(), _vm._v(" "), (item.order_item_delivery_fee != 0) ? _c('div', [_c('span', {
          staticStyle: {
            "color": "#ff0000",
            "float": "left"
          }
        }, [_vm._v("Total:")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "float": "left"
          }
        }, [_vm._v(" ₦" + _vm._s(item.order_item_total_delivery_fee))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
          staticStyle: {
            "float": "right",
            "margin-bottom": "5px",
            "display": "none"
          }
        }, [_c('span', [_c('a', {
          staticClass: "mobi-on",
          staticStyle: {
            "cursor": "pointer",
            "color": "#000000"
          },
          on: {
            "click": function($event) {
              _vm.removeFromCheckout(index, group, item)
            }
          }
        }, [_vm._v("Remove")]), _vm._v(" "), _c('a', {
          staticClass: "mobi-off",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              _vm.removeFromCheckout(index, group, item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-close"
        }), _vm._v("Remove")])])])]) : _vm._e()])
      })], 2)
    }), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), (group.order_status_id == 7) ? _c('div', {
      key: _vm.processed_single_order_count,
      staticClass: "c-cart-totals"
    }, [_c('div', {
      key: _vm.group_set_order_delivery_key,
      staticClass: "row",
      staticStyle: {
        "margin": "1.4em 0"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_vm._m(8, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "74%",
        "float": "left",
        "padding": "3px"
      }
    }, [(group.order_delivery_city) ? _c('p', {
      staticStyle: {
        "margin-top": "-1em",
        "font-size": "14px"
      }
    }, [_vm._v("Shipping: " + _vm._s(group.order_delivery_city))]) : _c('p', {
      staticStyle: {
        "margin-top": "-1em",
        "font-size": "14px"
      }
    }, [_vm._v("Shipping: Not set yet")]), _vm._v(" "), (group.order_user_delivery_address) ? _c('p', {
      staticStyle: {
        "margin-top": "-1em",
        "font-size": "14px"
      }
    }, [_vm._v(_vm._s(group.order_user_delivery_address))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "10%",
        "float": "right",
        "margin-left": "9em",
        "margin-top": "-3.3em",
        "padding": "1em",
        "text-align": "center"
      }
    }, [(group.order_delivery_city) ? _c('a', {
      staticStyle: {
        "color": "#000000",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('cdl' + index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-down",
      staticStyle: {
        "font-weight": "bolder",
        "font-size": "18px",
        "color": "#000000"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'cdl' + index
      }
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "border": "#ffffff dashed 1px",
        "margin": "2em 0 2em 0",
        "padding-bottom": "2em"
      }
    }, [_c('div', {
      staticClass: "pull-right",
      staticStyle: {
        "display": "none"
      }
    }, [(group.change_shipping) ? _c('a', {
      on: {
        "click": function($event) {
          group.change_shipping = false
        }
      }
    }, [_vm._v("CANCEL: Change Shipping")]) : _c('a', {
      on: {
        "click": function($event) {
          group.change_shipping = true
        }
      }
    }, [_vm._v("Change Shipping")])]), _vm._v(" "), (group.change_shipping) ? _c('div', [((group.order_business_delivery_options && (group.order_business_delivery_options.length != 0))) ? _c('div', [((group.order_business_delivery_options_custom && (group.order_business_delivery_options_custom.length != 0))) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "-2em"
      }
    }, [_c('label', [_vm._v("Select Shipping Location")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_location),
        expression: "group.order_delivery_location"
      }],
      staticClass: "form-control",
      on: {
        "click": function($event) {
          _vm.calc_delivery_fee(index, group.order_delivery_location)
        },
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_location = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((group.order_business_delivery_options_custom), function(location) {
      return _c('option', {
        domProps: {
          "value": location
        }
      }, [_vm._v(_vm._s(location.business_delivery_option))])
    })], 2), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default",
      on: {
        "click": function($event) {
          _vm.setComponent('cancel-change-delivery-option', index)
        }
      }
    }, [_vm._v("Done")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-bottom": "2em"
      }
    }, [((group.order_business_delivery_options_custom && (group.order_business_delivery_options_custom.length != 0))) ? _c('label', [_vm._v("OR Select State In Nigeria")]) : _c('label', [_vm._v("Select State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_selected_state),
        expression: "group.order_delivery_selected_state"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_selected_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getOrderLocations(index, group.order_delivery_selected_state)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((group.order_business_delivery_options_states), function(state) {
      return _c('option', {
        domProps: {
          "value": state
        }
      }, [_vm._v(_vm._s(state.state_name))])
    })], 2), _vm._v(" "), (_vm.action_loading) ? _c('div', [_c('div', {
      staticClass: "loading-sm"
    })]) : _vm._e()]), _vm._v(" "), (group.sorted_order_business_delivery_options) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "-2em"
      }
    }, [_c('label', [_vm._v("Select Location")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_location),
        expression: "group.order_delivery_location"
      }],
      staticClass: "form-control",
      on: {
        "click": function($event) {
          _vm.calc_delivery_fee(index, group.order_delivery_location)
        },
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_location = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((group.sorted_order_business_delivery_options), function(location) {
      return _c('option', {
        domProps: {
          "value": location
        }
      }, [_vm._v(_vm._s(location.business_delivery_option))])
    })], 2)]) : _vm._e()]) : _c('div', [_c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-bottom": "2em"
      }
    }, [_c('label', [_vm._v("Select State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_selected_state),
        expression: "group.order_delivery_selected_state"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_selected_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities(group.order_delivery_selected_state.state_id)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2)]), _vm._v(" "), (_vm.cities.length > 0) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "-2em"
      }
    }, [_c('label', [_vm._v("Select Location")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_location),
        expression: "group.order_delivery_location"
      }],
      staticClass: "form-control",
      on: {
        "click": function($event) {
          _vm.resetDeliveryLocation(index, group.order_delivery_location)
        },
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_location = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city
        }
      }, [_vm._v(_vm._s(city.city_name))])
    })], 2)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (group.order_delivery_city) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "0.3em"
      }
    }, [(group.order_user_city_delivery == group.order_delivery_city_id) ? _c('div', [(group.order_user_city_delivery_addresses.length != 0) ? _c('div', [_c('label', [_vm._v("Select from previous Shipping Address")]), _vm._v(" "), _vm._l((group.order_user_city_delivery_addresses), function(address) {
      return _c('label', [(address.address_city == group.order_delivery_city_id) ? _c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (group.order_user_delivery_address),
          expression: "group.order_user_delivery_address"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": address.address_address,
          "checked": _vm._q(group.order_user_delivery_address, address.address_address)
        },
        on: {
          "click": function($event) {
            _vm.setOrderUserCityDeliveryAddress(index, address)
          },
          "__c": function($event) {
            group.order_user_delivery_address = address.address_address
          }
        }
      }), _vm._v("\r\n                                                                    " + _vm._s(address.address_address) + "\r\n                                                                ")]) : _vm._e()])
    })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Enter Shipping Address")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_user_delivery_address),
        expression: "group.order_user_delivery_address"
      }],
      staticClass: "form-control input-group-lg",
      attrs: {
        "type": "text",
        "placeholder": "Shipping Address"
      },
      domProps: {
        "value": (group.order_user_delivery_address)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          group.order_user_delivery_address = $event.target.value
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('button', {
      staticClass: "pull-right btn btn-default sp-button-02 sp-button-md",
      on: {
        "click": function($event) {
          _vm.setComponent('cancel-change-delivery-option', index)
        }
      }
    }, [_vm._v("Done")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])]), _vm._v(" "), _c('div', {
      key: _vm.group_set_order_delivery_key,
      staticClass: "row",
      staticStyle: {
        "margin": "1.4em 0"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_vm._m(9, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "75%",
        "float": "left",
        "padding": "3px"
      }
    }, [_c('p', {
      staticStyle: {
        "margin-top": "-1em",
        "font-size": "14px"
      }
    }, [_vm._v(_vm._s(Object.keys(group.order_items).length) + " Item(s)")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "10%",
        "float": "right",
        "margin-left": "9em",
        "margin-top": "-3.3em",
        "padding": "1em",
        "text-align": "center"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "#000000",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('orditms' + index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-down",
      staticStyle: {
        "font-weight": "bolder",
        "font-size": "18px",
        "color": "#000000"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'orditms' + index
      }
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "border": "#f5f4e6 dashed 1px",
        "margin": "1em 0 2em 0",
        "padding": "1em"
      }
    }, [((group.order_items && (group.order_items.length != 0))) ? _c('div', [_c('p', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("Items Ordered")]), _vm._v(" "), _vm._l((group.order_items), function(item) {
      return _c('div', [_c('div', {
        staticStyle: {
          "width": "15%",
          "float": "left"
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.img_product_url + item.product_item_group_image,
          "height": "50",
          "width": "50"
        }
      })]), _vm._v(" "), _c('div', {
        staticStyle: {
          "width": "80%",
          "float": "right",
          "padding": "3px"
        }
      }, [_c('p', [_vm._v("\r\n                                                                " + _vm._s(item.product_name)), _c('br'), _vm._v("\r\n                                                                Quantity:  " + _vm._s(item.order_item_quantity)), _c('br'), _vm._v(" "), _c('span', [_vm._v("₦" + _vm._s(_vm.formatCurrency_2(item.order_item_total)))])])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      })])
    })], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
      key: _vm.componentOrderSummaryKey,
      staticClass: "row",
      staticStyle: {
        "margin": "1.4em 0"
      }
    }, [(group.order_payment_enabled == 1) ? _c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_vm._m(10, true), _vm._v(" "), _vm._m(11, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "10%",
        "float": "right",
        "margin-left": "9em",
        "margin-top": "-3.3em",
        "padding": "1em",
        "text-align": "center"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "#000000",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('paytl' + index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-down",
      staticStyle: {
        "font-weight": "bolder",
        "font-size": "18px",
        "color": "#000000"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'paytl' + index
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(group.data_processing_message))]), _vm._v(" "), ((group.order_delivery_city != undefined || group.order_delivery_city != '')) ? _c('div', {
      staticClass: "ck-card-row-slim"
    }, [(((group.order_user_delivery_address == '' || (group.order_user_delivery_address == undefined)))) ? _c('div', [_c('label', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Enter Shipping Address For "), _c('b', [_vm._v(_vm._s(group.order_delivery_city))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.set_order_user_delivery_address),
        expression: "set_order_user_delivery_address"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Shipping Address"
      },
      domProps: {
        "value": (_vm.set_order_user_delivery_address)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.set_order_user_delivery_address = $event.target.value
        }
      }
    }), _vm._v(" "), (group.order_user_city_delivery == group.order_delivery_city_id) ? _c('div', [(group.order_user_city_delivery_addresses.length != 0) ? _c('div', [_c('label', [_vm._v("Select from previous Shipping Address")]), _vm._v(" "), _vm._l((group.order_user_city_delivery_addresses), function(address) {
      return _c('label', [(address.address_city == group.order_delivery_city_id) ? _c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (group.order_user_delivery_address),
          expression: "group.order_user_delivery_address"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": address.address_address,
          "checked": _vm._q(group.order_user_delivery_address, address.address_address)
        },
        on: {
          "click": function($event) {
            _vm.setOrderUserCityDeliveryAddress(index, address)
          },
          "__c": function($event) {
            group.order_user_delivery_address = address.address_address
          }
        }
      }), _vm._v("\r\n                                                                        " + _vm._s(address.address_address) + "\r\n                                                                    ")]) : _vm._e()])
    })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          _vm.setComponent('close-enter-delivery-address', index)
        }
      }
    }, [_vm._v("Done")])])]) : _vm._e(), _vm._v(" "), (group.order_user_delivery_address != '' && (group.order_user_delivery_address != undefined)) ? _c('div', [(group.order_user_delivery_address != '' && (group.order_user_delivery_address != undefined)) ? _c('button', {
      staticClass: "pull-right btn btn-default",
      staticStyle: {
        "border-radius": "0",
        "color": "#ffffff",
        "background": "#fc4848"
      },
      attrs: {
        "id": 'PAYPOS' + index
      },
      on: {
        "click": function($event) {
          _vm.setProcessPaymentSingle(group, index, 'POS' + index);
          _vm.closeViews('PAYPOS' + index)
        }
      }
    }, [_vm._v("Make Payment")]) : _vm._e()]) : _vm._e()]) : _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Please set your delivery place.")]), _vm._v(" "), _c('div', {
      staticClass: "clearifix"
    }), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'POS' + index
      }
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "clear": "both",
        "margin": "0.1em"
      }
    }, [_c('h3', [_vm._v("Select a payment method\r\n                                                            "), _c('button', {
      staticClass: "pull-right btn btn-default",
      on: {
        "click": function($event) {
          _vm.closeViews('POS' + index);
          _vm.toggleSingleComponent('PAYPOS' + index);
        }
      }
    }, [_vm._v("X")])]), _vm._v(" "), _c('br'), _vm._v(" "), (group.order_cap_payment_banks) ? _c('div', [(((group.business_bank_details.length != 0) || (group.business_agent_bank_details.length != 0))) ? _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "color": "inherit"
      }
    }, [_c('div', {
      staticClass: "card card-colord-pad card-colord-pad-01",
      on: {
        "click": function($event) {
          _vm.toggleViews('BBanks' + index)
        }
      }
    }, [_vm._m(12, true), _vm._v(" "), _vm._m(13, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "ibox",
      staticStyle: {
        "display": "none",
        "border": "1px solid #ccc",
        "padding": "1.05em"
      },
      attrs: {
        "id": 'BBanks' + index
      }
    }, [_c('div', {
      staticStyle: {
        "margin": "1em !important"
      }
    }, [(group.order_can_part_payment && (group.order_part_payment_amount > 0)) ? _c('p', [_c('b', [_vm._v("Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(group.order_part_payment_amount)))]) : _c('p', [_c('b', [_vm._v("Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency_2(group.total_amount)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Ref: ")]), _vm._v(_vm._s(group.order_no))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Pay to:")]), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-xs sp-button-02 sp-button-sm",
      attrs: {
        "disabled": _vm.disable_btn
      },
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 3, 0)
        }
      }
    }, [(_vm.action_loading) ? _c('div', [_c('i', {
      staticClass: "fas fa-circle-notch fa-spin fa-2x"
    })]) : _c('span', [_vm._v("Confirm Transfer")])])]), _vm._v(" "), _vm._l((group.business_bank_details), function(bank) {
      return (group.order_receive_manual_payment_by == 1) ? _c('div', [_vm._v("\r\n                                                                            " + _vm._s(bank) + "\r\n                                                                        ")]) : _vm._e()
    }), _vm._v(" "), _vm._l((group.business_agent_bank_details), function(bank) {
      return (group.order_receive_manual_payment_by == 2) ? _c('div', [_vm._v("\r\n                                                                            " + _vm._s(bank) + "\r\n                                                                        ")]) : _vm._e()
    })], 2), _vm._v(" "), _c('div')]), _vm._v(" "), _c('br')]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "card card-colord-pad card-colord-pad-01"
    }, [_c('div', {
      staticStyle: {
        "width": "95%",
        "float": "left"
      }
    }, [(group.collections_business && (group.collections_business > 0)) ? _c('div', {
      staticStyle: {
        "clear": "both"
      },
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 2, 0)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-database"
    }), _vm._v(" Pay with Your Collections "), _c('br'), _vm._v("-"), _c('b', [_c('i', [_vm._v("You have ")]), _vm._v("NGN: " + _vm._s(group.collections_business) + " "), _c('i', [_vm._v("in your collections")])])]) : _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }, [_c('i', {
      staticClass: "fa fa-database"
    }), _vm._v(" Pay with Your Collections:"), _c('br'), _vm._v(" "), _c('b', [_c('i', [_vm._v("- You have ")]), _vm._v("NGN:" + _vm._s(group.collections_business) + " "), _c('i', [_vm._v("in your collections")])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "width": "5%",
        "margin-top": "0.8em"
      }
    }, [(group.collections_business && (group.collections_business > 0)) ? _c('span', [_c('i', {
      staticClass: "fa fa-angle-right",
      staticStyle: {
        "font-size": "18px",
        "font-weight": "bold"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "btn btn-default",
      staticStyle: {
        "display": "none"
      }
    }, [_c('div', [((Object.keys(_vm.order_gift_card).length > 0) && (_vm.order_gift_card.order_gift_card_data)) ? _c('div') : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "border-radius": "0",
        "text-align": "left"
      },
      on: {
        "click": function($event) {
          _vm.prepProcessGiftCardPayment(group, index, 7, 0)
        }
      }
    }, [_vm._v("Pay with Gift Cards")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.set_gift_card.gift_card_ref),
        expression: "set_gift_card.gift_card_ref"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.set_gift_card.gift_card_ref)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.set_gift_card.gift_card_ref = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "border-radius": "0",
        "text-align": "left"
      },
      on: {
        "click": function($event) {
          _vm.setProcessGiftCardPayment(group, index, 0, 0, 0)
        }
      }
    }, [_vm._v("SENDs")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "border-radius": "0",
        "text-align": "left"
      },
      on: {
        "click": function($event) {
          _vm.prepProcessGiftCardPayment(group, index, 7, 0)
        }
      }
    }, [_vm._v("Use Gift Card for Payment")])])]), _vm._v(" "), _c('a', {
      staticClass: "card-link"
    }, [_c('div', {
      staticClass: "card card-colord-pad card-colord-pad-01",
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 1, 0)
        }
      }
    }, [_vm._m(14, true), _vm._v(" "), _vm._m(15, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])])])])])]), _vm._v(" "), _c('div', {
      key: _vm.componentOrderSummaryKey,
      staticClass: "row",
      staticStyle: {
        "margin": "0.8em"
      }
    }, [_c('p', [_c('span', {
      staticClass: "pleft"
    }, [_vm._v("Subtotal:")]), _vm._v(" "), _c('span', {
      staticClass: "pright"
    }, [_vm._v("₦" + _vm._s(group.order_items_total.toFixed(2)))])]), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "pleft"
    }, [_vm._v("Shipping:")]), _vm._v(" "), (group.order_delivery_fee >= 0) ? _c('span', {
      staticClass: "pright"
    }, [_vm._v("₦" + _vm._s(group.order_delivery_fee))]) : _c('span', {
      staticClass: "pright"
    }, [_vm._v("₦" + _vm._s(group.order_delivery_fee.toFixed(2)))])]), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('p'), _vm._v(" "), (group.order_processing_fee_client_pay) ? _c('p', [_c('span', {
      staticClass: "pleft"
    }, [_vm._v("Processing Fee:")]), _vm._v(" "), _c('span', {
      staticClass: "pright"
    }, [_vm._v("₦" + _vm._s(group.order_processing_fee.toFixed(2)))])]) : _vm._e(), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "pleft"
    }, [_vm._v("Total:")]), _vm._v(" "), _c('span', {
      staticClass: "pright"
    }, [_vm._v("₦" + _vm._s(group.total_amount.toFixed(2)))])]), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('p'), _vm._v(" "), ((group.order_can_part_payment && (group.order_can_part_payment == 1))) ? _c('p', [_c('span', {
      staticClass: "pleft"
    }, [_vm._v("Part Payment Amount:"), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("(Total paid: "), _c('b', [_vm._v(_vm._s(_vm.formatCurrency(group.order_part_payment_total_amount_paid)))]), _vm._v(")")]), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#0077ff",
        "font-size": "12px"
      }
    }, [_vm._v("(Total to pay: "), _c('b', [_vm._v(_vm._s(_vm.formatCurrency((group.total_amount - group.order_part_payment_total_amount_paid))))])])]), _vm._v(" "), _c('span', {
      staticClass: "pright"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_part_payment_amount),
        expression: "group.order_part_payment_amount"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (group.order_part_payment_amount)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          group.order_part_payment_amount = $event.target.value
        }
      }
    })])]) : _vm._e(), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('p')]), _vm._v(" "), (group.order_payment_enabled == 0) ? _c('div', {
      key: _vm.componentOrderSummaryKey,
      staticClass: "row",
      staticStyle: {
        "margin": "1.4em 0"
      }
    }, [_c('div', {
      staticStyle: {
        "background": "#ffa800",
        "width": "92vw",
        "padding": "0.8em",
        "text-align": "center"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "#ffffff",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.updateOrders(group, index, 'requested')
        }
      }
    }, [(_vm.action_loading) ? _c('span', [_c('i', {
      staticClass: "fas fa-circle-notch fa-spin fa-2x"
    })]) : _c('span', [_vm._v("Place Order")])])])]) : _vm._e()]) : (group.order_part_payment_status == 200) ? _c('div', {
      staticClass: "c-cart-totals",
      staticStyle: {
        "border": "solid 1px#ffa800",
        "text-align": "center"
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ffa800",
        "padding-top": "5px"
      }
    }, [_vm._v("Part Payment Order Placed")])]) : _c('div', {
      staticClass: "c-cart-totals",
      staticStyle: {
        "border": "none",
        "text-align": "left"
      }
    }, [_vm._m(16, true)])], 2)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10em"
    }
  }), _vm._v(" "), (_vm.processed_single_order_count > 0) ? _c('div', {
    staticClass: "mobile-fix-nav",
    staticStyle: {
      "bottom": "4em"
    }
  }, [_vm._m(17)]) : _vm._e()], 2)]) : _c('div', [((Object.keys(_vm.checkout_orders).length == 0)) ? _c('div', {
    staticStyle: {
      "margin": "20vh 40vw"
    }
  }, [_vm._m(18)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.checkout_orders), function(group, index) {
    return (_vm.flexi_active_payment_status == 0) ? _c('div', {
      staticStyle: {
        "border": "none"
      }
    }, [_c('div', {
      staticClass: "card"
    }, [_vm._m(19, true), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("₦" + _vm._s(_vm.formatCurrency_2(group.total_amount)))]), _vm._v(" "), _vm._m(20, true), _vm._v(" "), (group.business_bank_details && (Object.keys(group.business_bank_details).length > 0)) ? _c('div', [_c('div', [_c('p', [_vm._v("\r\n                                            " + _vm._s(group.business_bank_details.bank_name)), _c('br'), _vm._v("\r\n                                            " + _vm._s(group.business_bank_details.bank_account_name)), _c('br'), _vm._v("\r\n                                            " + _vm._s(group.business_bank_details.bank_account_number)), _c('br')])])]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      key: _vm.componentOrderSummaryKey,
      staticClass: "row",
      staticStyle: {
        "margin": "1.4em 0"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_vm._m(21, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "10%",
        "float": "right",
        "margin-left": "9em",
        "margin-top": "-3.3em",
        "padding": "1em",
        "text-align": "center"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "#000000",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('paytl' + index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-down",
      staticStyle: {
        "font-weight": "bolder",
        "font-size": "18px",
        "color": "#000000"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "block",
        "background": "none"
      },
      attrs: {
        "id": 'paytl' + index
      }
    }, [_c('div', {
      staticStyle: {
        "margin": "0.1em 0.2em"
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#000000"
      }
    }, [_vm._v("After Transfer >>")]), _vm._v(" "), _c('div', {
      staticClass: "row",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "margin-bottom": "0.3em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.transfer_verification_mode),
        expression: "transfer_verification_mode"
      }],
      attrs: {
        "type": "radio",
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(_vm.transfer_verification_mode, "1")
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('transfer_verification_mode_ref')
        },
        "__c": function($event) {
          _vm.transfer_verification_mode = "1"
        }
      }
    }), _vm._v(" Enter Reference No/Code\r\n                                                "), (group.order_payment_third_party_ref && (group.order_payment_third_party_ref != 1)) ? _c('span', [_vm._v(" - " + _vm._s(group.order_payment_third_party_ref))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.transfer_verification_mode),
        expression: "transfer_verification_mode"
      }],
      attrs: {
        "type": "radio",
        "value": "2"
      },
      domProps: {
        "checked": _vm._q(_vm.transfer_verification_mode, "2")
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('transfer_verification_mode_receipt')
        },
        "__c": function($event) {
          _vm.transfer_verification_mode = "2"
        }
      }
    }), _vm._v(" Or Upload Transfer Receipt\r\n                                            ")]), _vm._v(" "), _c('hr')]), _vm._v(" "), (_vm.menu_tab_inner_view.transfer_verification_mode_ref) ? _c('div', {
      staticClass: "ck-card-row-slim"
    }, [_c('p', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("Please enter Reference Code or Number found on your Bank (or Other) Transaction Message")]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "form-group wnf-fl-form-group col-xs-12"
    }, [_vm._v("--" + _vm._s(group.order_payment_third_party_ref) + "\r\n                                                        "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_payment_third_party_ref),
        expression: "group.order_payment_third_party_ref"
      }],
      staticClass: "form-control input-bflat",
      attrs: {
        "type": "text",
        "placeholder": ""
      },
      domProps: {
        "value": (group.order_payment_third_party_ref)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          group.order_payment_third_party_ref = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default wnf-button btn-xs",
      staticStyle: {
        "width": "20vw",
        "margin-left": "60vw",
        "padding": "5px 3px"
      },
      attrs: {
        "disabled": _vm.disable_btn
      },
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 3, 0)
        }
      }
    }, [_vm._v("Enter")])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view.transfer_verification_mode_receipt) ? _c('div', {
      staticClass: "ck-card-row-slim"
    }, [((Object.keys(_vm.file_info).length == 0)) ? _c('div', {
      staticClass: "upload-btn-wrapper",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('button', {
      staticClass: "upload-btn",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("Upload Receipt")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "input-file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          _vm.onFileChangeNewPhoto($event, 'transfer-receipt')
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.file_info[0]) ? _c('div', [_c('p', [(_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Uploading Receipt: " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default wnf-button",
      staticStyle: {
        "width": "30vw",
        "margin-left": "0vw",
        "padding": "5px 3px"
      },
      attrs: {
        "disabled": _vm.disable_btn
      },
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 3, 0)
        }
      }
    }, [_vm._v("Yes, Upload")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default wnf-button",
      staticStyle: {
        "width": "30vw",
        "margin-left": "0vw",
        "padding": "5px 3px",
        "background-color": "#f5f4e6",
        "color": "#000000"
      },
      on: {
        "click": function($event) {
          _vm.file_info = []
        }
      }
    }, [_vm._v("Cancel")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearifix"
    })])]), _vm._v(" "), _c('div', {
      key: _vm.componentOrderSummaryKey,
      staticClass: "row",
      staticStyle: {
        "margin": "2.4em 0"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_vm._m(22, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "10%",
        "float": "right",
        "margin-left": "9em",
        "margin-top": "-3.3em",
        "padding": "1em",
        "text-align": "center"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "#000000",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('payopt' + index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-down",
      staticStyle: {
        "font-weight": "bolder",
        "font-size": "18px",
        "color": "#000000"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "block",
        "background": "none"
      },
      attrs: {
        "id": 'payopt' + index
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(group.data_processing_message))]), _vm._v(" "), _c('div', {
      staticClass: "clearifix"
    }), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "display": "block"
      },
      attrs: {
        "id": 'POS' + index
      }
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "clear": "both",
        "margin": "0",
        "padding": "0.4em"
      }
    }, [_c('p', {
      staticStyle: {
        "display": "none"
      }
    }, [_vm._v("Select a payment method\r\n                                                    ")]), _vm._v(" "), _c('div', {
      staticClass: "card  card-colord-pad-01"
    }, [_c('div', {
      staticStyle: {
        "width": "95%",
        "float": "left"
      }
    }, [(group.collections_business && (group.collections_business > 0)) ? _c('div', {
      staticStyle: {
        "clear": "both"
      },
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 2, 0)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-database"
    }), _vm._v(" Pay with Your Collections "), _c('br'), _vm._v("-"), _c('b', [_c('i', [_vm._v("You have ")]), _vm._v("NGN: " + _vm._s(group.collections_business) + " "), _c('i', [_vm._v("in your collections")])])]) : _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }, [_c('i', {
      staticClass: "fa fa-database"
    }), _vm._v(" Pay with Your Collections:"), _c('br'), _vm._v(" "), _c('b', [_c('i', [_vm._v("- You have ")]), _vm._v("NGN:" + _vm._s(group.collections_business) + " "), _c('i', [_vm._v("in your collections")])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "width": "5%",
        "margin-top": "0.8em"
      }
    }, [(group.collections_business && (group.collections_business > 0)) ? _c('span', [_c('i', {
      staticClass: "fa fa-angle-right",
      staticStyle: {
        "font-size": "18px",
        "font-weight": "bold"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "card-link"
    }, [_c('div', {
      staticClass: "card  card-colord-pad-01",
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 1, 0)
        }
      }
    }, [_vm._m(23, true), _vm._v(" "), _vm._m(24, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])])])])])])]) : _vm._e()
  }), _vm._v(" "), (_vm.flexi_active_payment_status == 1) ? _c('div', [_c('div', {
    key: _vm.componentOrderSummaryKey,
    staticClass: "row",
    staticStyle: {
      "margin": "1.4em 0"
    }
  }, [_vm._m(25), _vm._v(" "), _vm._m(26)]), _vm._v(" "), _vm._m(27)]) : _vm._e()], 2)])]) : _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(28)])], 2)]), _vm._v(" "), (!_vm.flexi_pay) ? _c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('component-footer')], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#000000",
      "color": "#ffffff",
      "margin": "-8px",
      "padding": "0.51em",
      "padding-top": "6px",
      "border-radius": "5px 5px 0px 0px"
    }
  }, [_c('h3', [_vm._v("Order Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#000000",
      "color": "#ffffff",
      "margin": "-8px",
      "padding": "0.51em",
      "padding-top": "6px",
      "border-radius": "5px 5px 0px 0px"
    }
  }, [_c('h3', [_vm._v("Payment Details")]), _vm._v(" "), _c('p', [_vm._v("To make payment use the details below")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('b', [_vm._v("Total Coupon Discount Amount:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('b', [_vm._v("Total Order Amount:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('b', [_vm._v("Total Shipping Fee:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Share Link")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Share Link")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('label', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v("Gift/Send this Product to a different location")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "16%",
      "float": "left",
      "margin-top": "-1em",
      "padding": "0.1em"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "12px"
    }
  }, [_vm._v("Location:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "15%",
      "float": "left",
      "margin-top": "-1em",
      "padding": "0.1em"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "12px"
    }
  }, [_vm._v("Items:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "15%",
      "float": "left",
      "margin-top": "-1em",
      "padding": "0.1em"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "12px"
    }
  }, [_vm._v("Payment:    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "75%",
      "float": "left",
      "padding": "3px"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "-1em",
      "font-size": "14px"
    }
  }, [_vm._v("No Payment Mode selected")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "95%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "fa fa-bank"
  }), _vm._v("Direct Bank Transfer"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Pay directly to Business Bank Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "width": "5%",
      "margin-top": "0.8em"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "bold"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "95%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" Automatic Bank transfer and"), _c('br'), _vm._v(" Debit Card Payments")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "width": "5%",
      "margin-top": "0.8em"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "bold"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#ffa800",
      "font-weight": "bold"
    }
  }, [_vm._v(">>")]), _vm._v(" Order Placed\r\n                                        "), _c('span', [_c('a', {
    staticStyle: {
      "float": "right",
      "color": "#ffa800",
      "text-decoration": "underline"
    },
    attrs: {
      "href": "/orders"
    }
  }, [_vm._v("View Orders")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#ffa800",
      "width": "100vw",
      "padding": "0.8em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#ffffff",
      "text-decoration": "none"
    },
    attrs: {
      "href": "/orders"
    }
  }, [_vm._v("View Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sp-app-default-color"
  }, [_c('i', {
    staticClass: "fas fa-circle-notch fa-spin fa-2x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('b', [_vm._v("Transfer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("To:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left",
      "padding": "3px"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "-1em",
      "font-size": "16px",
      "color": "#ff0000"
    }
  }, [_vm._v("Complete Transfer Verification")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left",
      "padding": "3px"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "-1em",
      "font-size": "18px",
      "font-weight": "bold"
    }
  }, [_vm._v("Pay with other options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "95%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" Automatic Bank transfer and"), _c('br'), _vm._v(" Debit Card Payments")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "width": "5%",
      "margin-top": "0.8em"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "bold"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "#000000",
      "font-size": "24px"
    }
  }, [_c('b', [_vm._v("Transfer Payment registered successfully")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin": "3em 0"
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "padding": "0.31em",
      "border-radius": "50%",
      "border": "#ff0000 solid",
      "font-size": "5em",
      "color": "#ff0000"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-fix-nav",
    staticStyle: {
      "bottom": "0em"
    }
  }, [_c('div', {
    staticStyle: {
      "background": "#ffa800",
      "width": "100vw",
      "padding": "0.8em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#ffffff",
      "text-decoration": "none"
    },
    attrs: {
      "href": "/orders"
    }
  }, [_vm._v("Done, View Orders")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000",
      "margin-top": "2em"
    }
  }, [_vm._v("No Orders for Checkout")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn default",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Shop Here")])])
}]}

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-card"
  }, [_c('form', {
    staticClass: "sp-form"
  }, [_c('h6', [_vm._v("Add New Category")]), _vm._v(" "), (_vm.categories.length != 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Pick a Category Name")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main_category),
      expression: "main_category"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.main_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getSubCategories(_vm.main_category)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.categories), function(ct) {
    return _c('option', {
      key: ct.category_id,
      domProps: {
        "value": ct
      }
    }, [_vm._v(_vm._s(ct.category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.sub_categories.length != 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select a Category under " + _vm._s(_vm.main_category.category_name))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.new_category),
      expression: "category.new_category"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "30px",
      "width": "245px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.category.new_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(ct) {
    return _c('option', {
      key: ct.sub_category_id,
      domProps: {
        "value": ct.sub_category_id
      }
    }, [_vm._v(_vm._s(ct.sub_category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.categories.length != 0) ? _c('label', [_c('b', [_vm._v("OR")]), _vm._v(" Add any other category"), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.new_listed_category),
      expression: "category.new_listed_category"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Category Name"
    },
    domProps: {
      "value": (_vm.category.new_listed_category)
    },
    on: {
      "change": _vm.resetCategoriesSelections,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.category.new_listed_category = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#084c8b"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.addCategory
    }
  }, [_vm._v("Add Category")])])])])])
},staticRenderFns: []}

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row"
  }) : _c('div', {
    staticStyle: {
      "margin-top": "-3em"
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "text-align": "left",
      "border": "#fdfdfd solid 1px",
      "padding": "3px"
    }
  }, [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(0), _c('b', [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.paymentdata.payment_currency))])]), _vm._v(" " + _vm._s(Number(_vm.paymentdata.payment_total_amount).toFixed(2)))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('form', {
    staticStyle: {
      "text-align": "left"
    }
  }, [(_vm.paymentdata.payment_modes_accepted.includes(1)) ? _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_mode),
      expression: "payment_mode"
    }],
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "type": "radio",
      "id": "pradio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.payment_mode, "1")
    },
    on: {
      "__c": function($event) {
        _vm.payment_mode = "1"
      }
    }
  }), _vm._v("Automatic Payment\r\n            "), _c('p', [_vm._v("geed ajhah enejckbb")])]) : _vm._e(), _vm._v(" "), (_vm.paymentdata.payment_modes_accepted.includes(2)) ? _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_mode),
      expression: "payment_mode"
    }],
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "type": "radio",
      "id": "pradio2",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.payment_mode, "2")
    },
    on: {
      "__c": function($event) {
        _vm.payment_mode = "2"
      }
    }
  }), _vm._v("My Collections\r\n            "), _c('p', [_vm._v("geed ajhah enejckbb")])]) : _vm._e(), _vm._v(" "), (_vm.paymentdata.payment_modes_accepted.includes(3)) ? _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_mode),
      expression: "payment_mode"
    }],
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "type": "radio",
      "id": "pradio2",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.payment_mode, "3")
    },
    on: {
      "__c": function($event) {
        _vm.payment_mode = "3"
      }
    }
  }), _vm._v("Manual Transfer\r\n            "), _c('p', [_vm._v("geed ajhah enejckbb")])]) : _vm._e(), _vm._v(" "), (((_vm.paymentdata.payment_modes_accepted.includes(5)) && (_vm.paymentdata.payment_fees_account_balance > 0))) ? _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_mode),
      expression: "payment_mode"
    }],
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "type": "radio",
      "id": "pradio2",
      "value": "5"
    },
    domProps: {
      "checked": _vm._q(_vm.payment_mode, "5")
    },
    on: {
      "__c": function($event) {
        _vm.payment_mode = "5"
      }
    }
  }), _vm._v("Payments Account\r\n            "), _c('p', [_vm._v("geed ajhah enejckbb")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', [(_vm.payment_service_update_data_status == 200) ? _c('div', [_c('component-account', {
    attrs: {
      "sellpoint_pending_orders": _vm.payment_service_update_data
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("CLOSE")])], 1) : _c('div', [(_vm.payment_mode > 0) ? _c('button', {
    staticClass: "sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.prepProcessPaymentSingle(_vm.payment_mode, 0)
      }
    }
  }, [_vm._v("CONTINUE")]) : _vm._e()]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sup', [_c('h5', [_vm._v("PAY")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('b', [_vm._v("pay with")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-load"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  })])
}]}

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "detail-card"
  }, [_c('h5', [_vm._v("Transfer Payment Invoice")]), _vm._v(" "), (_vm.set_select_mode > 0) ? _c('a', {
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.set_select_mode = 0;
        _vm.setMenuTabView('', '')
      }
    }
  }, [_vm._v(" Back")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.menu_tab_view.selectItemsForInvoice) ? _c('div', [((_vm.set_select_mode == 1) && (Object.keys(_vm.data_user).length > 0)) ? _c('div', [_c('h3', [_vm._v("Invoice For: " + _vm._s(_vm.data_user.name))])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view.previewSelectedItemsForInvoice) ? _c('div', [_c('h3', [_vm._v("Confirm selected Items")]), _vm._v(" "), _c('div', [(_vm.invoice_added_items && (Object.keys(_vm.invoice_added_items).length > 0)) ? _c('div', [_vm._l((_vm.invoice_added_items), function(product, index) {
    return _c('div', {
      key: index,
      staticClass: "card col-xs-12 card-col-2",
      staticStyle: {
        "margin-bottom": "2.2em",
        "text-align": "left"
      }
    }, [_c('div', {
      staticClass: "col-xs-4 card-col-img"
    }, [(product.product_data.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "max-height": "8em"
      },
      attrs: {
        "src": product.product_data.product_images[0].product_image
      }
    }) : _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "max-height": "8em"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8 card-col-details",
      staticStyle: {
        "display": "block",
        "padding": "3px"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "13px",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(product.product_data.product_name)), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sp-app-default-color",
      staticStyle: {
        "font-weight": "bolder"
      }
    }, [_vm._v("₦" + _vm._s(product.product_item_price_f))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Quantity: "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (product.order_item_order_quantity),
        expression: "product.order_item_order_quantity"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (product.order_item_order_quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          product.order_item_order_quantity = $event.target.value
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  }), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn sp-button-02",
    on: {
      "click": _vm.generatePaymentOrders
    }
  }, [_vm._v("Generate Invoice")])])], 2) : _vm._e()])]) : _c('div', [_c('p', [_vm._v("Add items to Invoice")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.data_loading.products) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(1)]) : _c('div', [(_vm.products && (Object.keys(_vm.products).length > 0)) ? _c('div', _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      key: index,
      staticClass: "card col-xs-4 card-col-2",
      staticStyle: {
        "margin-bottom": "2.2em",
        "min-height": "15em",
        "max-height": "15em"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setProduct(product)
        }
      }
    }, [_c('div', {
      staticClass: "card-col-img"
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "max-height": "8em"
      },
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "max-height": "8em"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block",
        "padding": "3px"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticClass: "sp-app-default-color",
      staticStyle: {
        "font-weight": "bolder"
      }
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "add-pad"
    }, [(_vm.isItemInList(product.product_items[0])) ? _c('div', [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": true
      },
      on: {
        "click": function($event) {
          _vm.removeItemsFromInvoice(product.product_items[0])
        }
      }
    }), _vm._v(" Added\n                                ")]) : _c('div', [(!(_vm.isItemInList(product.product_items[0]))) ? _c('input', {
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.addItemsToInvoice(product.product_items[0], product)
        }
      }
    }) : _vm._e(), _vm._v(" Add\n                                ")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No products yet")]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-vutton-02",
    attrs: {
      "href": "/account/business/newproduct"
    }
  }, [_vm._v("Add Products")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), ((Object.keys(_vm.invoice_added_items).length > 0)) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "bottom": "1em",
      "background-color": "#ff0000",
      "height": "2em"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-02",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('previewSelectedItemsForInvoice')
      }
    }
  }, [_vm._v("Add (" + _vm._s(Object.keys(_vm.invoice_added_items).length) + ") Item(s) to Invoice")])]) : _vm._e()])]) : _c('div', [_c('p', [_vm._v("Generate and send Transfer Invoice to a customer or more than one customer. Customers who \n                click on the link can quickly make transfers directly to your bank account for products you \n                added to the invoice.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Generate invoice:")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_select_mode),
      expression: "set_select_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.set_select_mode, "1")
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('one_customer')
      },
      "__c": function($event) {
        _vm.set_select_mode = "1"
      }
    }
  }), _vm._v(" For One Customer"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_select_mode),
      expression: "set_select_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.set_select_mode, "2")
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('', 'selectItemsForInvoice')
      },
      "__c": function($event) {
        _vm.set_select_mode = "2"
      }
    }
  }), _vm._v(" General - Anyone can pay"), _c('br')]), _vm._v(" "), (_vm.menu_tab_inner_view.one_customer) ? _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Customer's eShop username or phone number or email")]), _vm._v(" "), (_vm.data_error_message != '') ? _c('p', [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.custormer_name),
      expression: "customer.custormer_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.customer.custormer_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customer.custormer_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getUsersDetails(_vm.customer.custormer_name, _vm.customer, 'get_customer_details_for_invoice_request')
      }
    }
  }, [_vm._v("Enter")])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("loading products...")])])
}]}

/***/ }),
/* 563 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_c('h6', [_vm._v("Discounts And Coupons")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(!(_vm.product_details.setProductDiscount || _vm.product_details.setProductItemDiscount) && !_vm.product_details.editDiscount) ? _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "45%"
    }
  }, [(_vm.product_details.viewProductItemsDiscounts) ? _c('p', {
    staticClass: "sp-app-default-color"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setProductComponent('viewProductDiscounts', '', '')
      }
    }
  }, [_vm._v("\n                    General Product Discount/Coupons\n                  ")])]) : _c('p', {
    staticClass: "sp-app-default-color",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("General Product Discount/Coupons")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "45%"
    }
  }, [(!_vm.product_details.viewProductItemsDiscounts) ? _c('p', {
    staticClass: "sp-app-default-color"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setProductComponent('viewProductItemsDiscounts', '', '')
      }
    }
  }, [_vm._v("Product Groups Discount/Coupons")])]) : _c('p', {
    staticClass: "sp-app-default-color",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Product Groups Discount/Coupons")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (!_vm.product_details.viewProductItemsDiscounts) ? _c('div', [(((_vm.product.product_only_coupon_discount_count > 0) && (Object.keys(_vm.product.product_items[0].product_item_discounts).length > 0))) ? _c('div', {}, _vm._l((_vm.product.product_items[0].product_item_discounts), function(dc, dcdex) {
    return _c('div', {
      key: dcdex
    }, [((dc.discount_type == 4)) ? _c('div', {
      staticClass: "card card-flat-pad",
      staticStyle: {
        "border": "#f7f7f7 solid !important"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "90%"
      }
    }, [_c('div', [_c('p', [_vm._v(_vm._s(dc.discount_percentage) + "% Discount")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('div', [(_vm.menu_tab_inner_view['DCS' + dcdex]) ? _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('')
        }
      }
    }, [_vm._m(0, true)]) : _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('DCS' + dcdex)
        }
      }
    }, [_vm._m(1, true)])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (_vm.menu_tab_inner_view['DCS' + dcdex]) ? _c('div', [_c('div', [_c('div', {
      staticStyle: {
        "background": "#f8e7ce",
        "text-align": "center"
      }
    }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Minimum Quantity: ")]), _vm._v(_vm._s(dc.discount_min_quantity))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('editDiscount', '', dc)
        }
      }
    }, [_vm._v("\n                                Edit Discount")]), _vm._v("    \n                            "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('deactivateDiscount', _vm.product.product_items[0], dc)
        }
      }
    }, [_vm._v("\n                                Deactivate Discount")])]) : _vm._e(), (_vm.action_loading && (_vm.product.product_items[0].product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p')]) : _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Edit/Deactivate at Business Settings")]), _vm._v(" "), _c('hr')])]) : _vm._e()]) : _c('div', {
      staticStyle: {
        "display": "none"
      }
    })])
  })) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No set general product discount or coupon")])]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductDiscount', '', '')
      }
    }
  }, [_vm._v("Set New Product Discount Or Coupon")])]) : _vm._e(), _vm._v(" "), (_vm.product_details.viewProductItemsDiscounts) ? _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {}, [_c('h6', {
    staticClass: "pull-left",
    staticStyle: {
      "text-transform": "uppercase",
      "font-size": "14px"
    }
  }, [_vm._v("Items in this Product")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs v-tiny-btn sp-button-02 sp-button-sm pull-right",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._l((_vm.product.product_items), function(productItem) {
    return _c('div', {
      key: productItem.product_item_id,
      staticStyle: {
        "border-bottom": "dashed #f4f6f8",
        "padding": "5px",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "items-list-tiny",
      staticStyle: {
        "display": "inline",
        "font-size": "12px"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "20%"
      }
    }, [(productItem.product_item_group_is_color_image == 'IMG') ? _c('li', [((productItem.product_item_group_image && (productItem.product_item_group_image != 'error'))) ? _c('img', {
      staticStyle: {
        "height": "30px"
      },
      attrs: {
        "src": productItem.product_item_group_image
      }
    }) : _c('img', {
      staticStyle: {
        "height": "50px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (productItem.product_item_group_is_color_image == 'COL') ? _c('li', [_c('a', {
      staticClass: "btn box-color-cube",
      style: ({
        background: productItem.product_item_group_color
      })
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "width": "80%"
      }
    }, [_c('p', [(_vm.product.product_service == 'P' && (productItem.product_item_size)) ? _c('span', [_c('b', [_vm._v(_vm._s(productItem.product_item_size))])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (productItem.product_item_service_tag)) ? _c('span', [_c('b', [_vm._v(_vm._s(productItem.product_item_service_tag))])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('span', [_c('span', [_vm._v("Wt(kg):")]), _vm._v(_vm._s(productItem.product_item_weight))]) : _vm._e(), _vm._v(" "), _c('span', [(productItem.product_item_actual_price != 0) ? _c('span', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(productItem.product_item_actual_price))]) : _c('span', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(productItem.product_item_price))])]), _vm._v(" "), _c('span', [_c('span', [_vm._v("Qty:")]), _vm._v(_vm._s(productItem.product_item_quantity))])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "0.6em"
      }
    }, [_vm._l((productItem.product_item_discounts), function(dc, ptdcdex) {
      return _c('div', {
        key: ptdcdex
      }, [((dc.discount_type == 5)) ? _c('div', {
        staticClass: "card card-flat-pad",
        staticStyle: {
          "border": "#f7f7f7 solid !important"
        }
      }, [_c('div', {
        staticStyle: {
          "float": "left",
          "width": "90%"
        }
      }, [_c('div', [_c('p', [_vm._v(_vm._s(dc.discount_percentage) + "% Discount")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      })])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "float": "right"
        }
      }, [_c('div', [(_vm.menu_tab_inner_view['PTDCS' + ptdcdex]) ? _c('a', {
        staticStyle: {
          "cursor": "pointer",
          "color": "inherit"
        },
        on: {
          "click": function($event) {
            _vm.setMenuTabInnerView('');
            _vm.setProductComponent('viewProductItemsDiscounts', '', '');
          }
        }
      }, [_vm._m(2, true)]) : _c('a', {
        staticStyle: {
          "cursor": "pointer",
          "color": "inherit"
        },
        on: {
          "click": function($event) {
            _vm.setMenuTabInnerView('PTDCS' + ptdcdex);
            _vm.setProductComponent('viewProductItemsDiscounts', '', '');
          }
        }
      }, [_vm._m(3, true)])])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      }), _vm._v(" "), (_vm.menu_tab_inner_view['PTDCS' + ptdcdex]) ? _c('div', [_c('div', [_c('div', {
        staticStyle: {
          "background": "#d1ddf1",
          "text-align": "center"
        }
      }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Minimum Quantity: ")]), _vm._v(_vm._s(dc.discount_min_quantity))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
        staticStyle: {
          "cursor": "pointer",
          "text-decoration": "underline",
          "font-size": "13px",
          "color": "#448aff"
        },
        attrs: {
          "title": "Edit"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('editDiscount', '', dc)
          }
        }
      }, [_vm._v("\n                                Edit Discount")]), _vm._v("    \n                                "), _c('a', {
        staticStyle: {
          "cursor": "pointer",
          "text-decoration": "underline",
          "font-size": "13px",
          "color": "#448aff"
        },
        attrs: {
          "title": "De-Activate"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('deactivateDiscount', _vm.product.product_items[0], dc)
          }
        }
      }, [_vm._v("\n                                Deactivate Discount")])]) : _vm._e(), (_vm.action_loading && (_vm.product.product_items[0].product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e(), _vm._v(" "), _c('p')]) : _c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Edit/Deactivate at Business Settings")]), _vm._v(" "), _c('hr')])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      })]) : _c('div', {
        staticStyle: {
          "display": "none"
        }
      })])
    }), _vm._v(" "), _c('div', [_c('a', {
      staticClass: "sp-app-default-color",
      staticStyle: {
        "font-size": "13px",
        "line-height": "1.2",
        "text-decoration": "underline",
        "float": "right"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('setProductItemDiscount', 'productitem', productItem)
        }
      }
    }, [_c('span', {
      staticClass: "sp-app-default-color",
      staticStyle: {
        "font-size": "16px",
        "font-weight": "bolder"
      }
    }, [_vm._v("+")]), _vm._v(" New Discount / Coupon")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })], 2)])
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.product_details.setProductDiscount || _vm.product_details.setProductItemDiscount) ? _c('div', [_c('div', {
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.product_details.setProductDiscount) ? _c('label', [_vm._v("Set Product Coupon Or Discount")]) : _vm._e(), _vm._v(" "), (_vm.product_details.setProductItemDiscount) ? _c('label', [_vm._v("Set Product Item Coupon Or Discount")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.is_discount_coupon),
      expression: "discount_coupon.is_discount_coupon"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.is_discount_coupon = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("Discount")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Coupon")])])]), _vm._v(" "), (((_vm.product.product_discounts_active == 1) || (_vm.product_item.product_item_discounts_active == 1))) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have an active Discount")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "display": "none"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon_is_direct),
      expression: "discount_coupon_is_direct"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.discount_coupon_is_direct) ? _vm._i(_vm.discount_coupon_is_direct, null) > -1 : (_vm.discount_coupon_is_direct)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.discount_coupon_is_direct,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.discount_coupon_is_direct = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.discount_coupon_is_direct = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.discount_coupon_is_direct = $$c
        }
      }
    }
  }), _vm._v("\n                    Direct Discount (for a particular user)  ?")])]), _vm._v(" "), (_vm.discount_coupon_is_direct) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Enter username ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_username),
      expression: "discount_coupon.discount_username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_username = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Minimum Quantity")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_min_quantity),
      expression: "discount_coupon.discount_min_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_min_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_min_quantity = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "line-height": "1.2"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setDiscountsAndCoupons()
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.product_details.editDiscount) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Edit Discount")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Minimum Quantity")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_min_quantity),
      expression: "discount_coupon.discount_min_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_min_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_min_quantity = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date: " + _vm._s(_vm.discount_coupon.discount_start_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date: " + _vm._s(_vm.discount_coupon.discount_end_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "line-height": "2em"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editDiscountsAndCoupons()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e()]), _vm._v(" "), _c('br')])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#363535",
      "line-height": "1.2"
    }
  }, [_vm._v("Note that you can only set one Sellpoint Discount at a time.\n                  If you want to end an existing discount click on \"Stop Discount\" button on the Discount.\n                ")])])
}]}

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    staticStyle: {
      "background-color": "#ffffff"
    },
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "1em",
      "margin-right": "1em"
    }
  }, [_c('a', {
    staticClass: "col-xs-1 card-link",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _vm._v("   \r\n      "), _c('a', {
    staticClass: "col-xs-2 x-cta-btn card-link",
    staticStyle: {
      "float": "left",
      "width": "30px",
      "height": "40px",
      "text-align": "center"
    },
    attrs: {
      "href": '/' + _vm.order.order_business_username
    }
  }, [_c('p', {
    staticClass: "ltr-1"
  }, [_vm._v(_vm._s(_vm.order.order_business))])]), _vm._v(" "), _c('p', {
    staticClass: "col-xs-9"
  }, [_vm._v(_vm._s(_vm.order.order_business))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "pager",
    staticStyle: {
      "text-align": "left",
      "margin-top": "5em"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin-bottom": "5em"
    }
  }, [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.menu_tab_inner_view['order_details']) ? _c('div', {}, [_c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "800",
      "font-size": "22px",
      "line-height": "1.6"
    }
  }, [_vm._v("Order Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Order No: ")]), _vm._v(_vm._s(_vm.order.order_no))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Date: ")]), _vm._v(_vm._s(_vm.order.order_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("By: ")]), _vm._v(_vm._s(_vm.order.order_user))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("From: ")]), _vm._v(_vm._s(_vm.order.order_business))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Cost: ")]), _vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_items_total)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivery Charge: ")]), _vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_shipping_total)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Total to pay: ")]), _vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_total)))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right",
      "padding": "0.51em",
      "border-radius": "5px",
      "background-color": "#f7df2b",
      "color": "#000000"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.order.order_status))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Items Ordered")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "category-slide"
  }, [_c('ul', _vm._l((_vm.order.order_items), function(item, index) {
    return _c('li', {}, [(item.product_item_group_image && (item.product_item_group_image != '' && item.product_item_group_image != 'error')) ? _c('img', {
      staticStyle: {
        "width": "80px",
        "height": "100px",
        "border-radius": "8px"
      },
      attrs: {
        "src": _vm.img_product_url + item.product_item_group_image
      }
    }) : _c('img', {
      staticStyle: {
        "width": "80px",
        "height": "100px",
        "border-radius": "8px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('h6', [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), _c('h6', {
      staticStyle: {
        "font-size": "18px",
        "text-align": "left"
      }
    }, [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(item.order_item_total)) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "14px"
      }
    }, [_c('b', [_vm._v("Quantity: ")]), _vm._v(_vm._s(item.order_item_quantity))])])])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Delivery Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [(_vm.order.order_user_delivery_address != '') ? _c('p', [_vm._v(_vm._s(_vm.order.order_user_delivery_address))]) : _c('p', [_vm._v("Not set")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Order Contact Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.order.order_business))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email Address: ")]), _vm._v(_vm._s(_vm.order.order_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone Number: ")]), _vm._v(_vm._s(_vm.order.order_user))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Order Additional Information")]), _vm._v(" "), _c('hr'), _vm._v(" "), (Object.keys(_vm.order_additionals).length > 0) ? _c('div', _vm._l((_vm.order_additionals), function(detail, index) {
    return _c('div', [_c('p', [_c('b', [_vm._v(_vm._s(++index) + ". ")]), _vm._v(_vm._s(detail.order_additional_details))])])
  })) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No additional information")])])]) : (_vm.menu_tab_inner_view['re_order']) ? _c('div', {}, [_vm._m(0)]) : _c('div', {}, [_c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Shopping on "), _c('b', [_vm._v(_vm._s(_vm.order.order_date))])]), _vm._v(" "), _c('p', [_vm._v("Status: "), _c('b', [_c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.order.order_status))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', [_c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "container container-left"
  }, [_c('div', {
    staticClass: "card-box card-02"
  }, [_c('h5', [_vm._v("Shopping List "), _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "float": "right"
    }
  }, [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_total)))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_vm._l((_vm.order.order_items), function(item, index) {
    return (index < 4) ? _c('p', {
      key: item.order_item_no
    }, [_vm._v("\r\n                        " + _vm._s(item.product_name) + " - ₦" + _vm._s(item.order_item_total.toFixed(2)) + "\r\n                      ")]) : _vm._e()
  }), _vm._v(" "), _c('a', {}, [_vm._v("see Items")])], 2), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('h5', [_vm._v("Delivery"), _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "float": "right"
    }
  }, [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_shipping_total)))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [(_vm.order.order_user_delivery_address != '') ? _c('p', [_vm._v(_vm._s(_vm.order.order_user_delivery_address))]) : _c('p', [_vm._v("Not set")])])])])])])]), _vm._v(" "), _vm._l((_vm.order_chart), function(track) {
    return _c('div', [(_vm.user.user_id == track.order_status_user) ? _c('div', {
      staticClass: "timeline"
    }, [(track.order_status_id == 20) ? _c('div', {
      staticClass: "container container-left"
    }, [_c('div', {
      staticClass: "card-box card-02"
    }, [_c('h5', [_vm._v("Proof of payment")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', [_vm._v("Waiting for Payment confirmation")]), _vm._v(" "), _c('div', [(track.order_status_id == 20) ? _c('div', _vm._l((track.order_set_uploads), function(images) {
      return (images.data_image != '') ? _c('div', [(images.data_image) ? _c('img', {
        staticClass: "img-responsive",
        attrs: {
          "src": images.data_image
        }
      }) : _vm._e()]) : _vm._e()
    })) : _vm._e()])])]) : _vm._e()]) : _c('div', {
      staticClass: "timeline"
    }, [_c('div', {
      staticClass: "container container-right"
    }, [(track.order_status_id == 35) ? _c('div', {
      staticClass: "card-box card-02"
    }, [_c('h5', [_vm._v("How to Pay")]), _vm._v(" "), _c('hr'), _vm._v(" "), (track.order_set_bank_name != '') ? _c('h6', [_vm._v("Use the below account details to make payment")]) : _vm._e(), _vm._v(" "), (track.order_set_payment_link != '') ? _c('h6', [_vm._v("click the link below to make payment")]) : _vm._e(), _vm._v(" "), _c('div', [(track.order_status_id == 35) ? _c('div', [(track.order_set_bank_name != '') ? _c('div', [_c('p', [_c('b', [_vm._v("Bank Name: ")]), _vm._v(_vm._s(track.order_set_bank_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Bank Account Name: ")]), _vm._v(_vm._s(track.order_set_bank_account_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Bank Account No: ")]), _vm._v(_vm._s(track.order_set_bank_account_no))])]) : _vm._e(), _vm._v(" "), (_vm.order.order_payment_buyer_confirmation == 0) ? _c('div', [_c('div', [_c('hr'), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('setMakePayment')
        }
      }
    }, [_vm._v(_vm._s(track.order_status_cta))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": "setMakePayment"
      }
    }, [_c('div', {
      staticClass: "card"
    }, [_c('h4', [_vm._v("Have you made payment?")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      on: {
        "click": function($event) {
          _vm.setOrderCustomUpdates(_vm.order, 'custom_set_track_make_payment', 1)
        }
      }
    }, [_vm._v("YES\r\n                                "), (_vm.action_loading) ? _c('span', [_c('i', {
      staticClass: "fa fa-circle-o-notch"
    })]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02 btn-danger",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('setMakePayment')
        }
      }
    }, [_vm._v("NO")])])])]) : _vm._e()]) : _vm._e()])]) : _vm._e()])])])
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('hr'), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "prImagePreview"
    }
  }), _vm._v(" "), ((Object.keys(_vm.file_info).length == 0)) ? _c('div', [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn sp-button-02",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Upload Receipt")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeNewPhoto($event, 'transfer-receipt')
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.file_info[0]) ? _c('div', [_c('button', {
    staticClass: "btn btn-default wnf-button",
    staticStyle: {
      "width": "30vw",
      "margin-left": "0vw",
      "padding": "5px 3px"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.uploadFlexiPaymentReceipt(_vm.order, _vm.order.order_no, 'transferred')
      }
    }
  }, [_vm._v("Yes, Upload")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default wnf-button",
    staticStyle: {
      "width": "30vw",
      "margin-left": "0vw",
      "padding": "5px 3px",
      "background-color": "#f5f4e6",
      "color": "#000000"
    },
    on: {
      "click": function($event) {
        _vm.resetImageUpload()
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000",
      "width": "100%",
      "margin-left": "-0.11em",
      "border-left": "#ffffff solid"
    },
    attrs: {
      "id": "shareBox"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {}
    }
  }, [_c('span', {
    staticClass: "s-backdrop"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "max-height": "75vh",
      "overflow": "scroll",
      "bottom": "0",
      "margin": "0 -1.2em",
      "background": "none",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticClass: "z-box",
    staticStyle: {
      "width": "100%",
      "padding": "0.1em",
      "border-radius": "35px 35px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "200px",
      "padding": "2em",
      "margin-bottom": "5.8em",
      "border-bottom": "#eee solid",
      "text-align": "left"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('shareBox')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em",
      "margin-bottom": "5em"
    }
  }, [(_vm.set_view_box == '') ? _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Give a star rating")]), _vm._v(" "), _vm._l((5), function(star) {
    return _c('div', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "margin-right": "2em",
        "font-size": "28px",
        "line-height": "0.4",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.setRate(_vm.order.order_items[0], star)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-star-o",
      attrs: {
        "id": 'rate-' + star
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-star",
      staticStyle: {
        "display": "none",
        "color": "#f7df2b"
      },
      attrs: {
        "id": 'rated-' + star
      }
    })]), _vm._v(" "), _c('p', {
      staticStyle: {
        "margin-top": "0.2em",
        "color": "#000000",
        "font-size": "12px",
        "font-weight": "600"
      }
    }, [(star == 1) ? _c('span', [_vm._v("Bad")]) : _vm._e(), _vm._v(" "), (star == 2) ? _c('span', [_vm._v("Not Bad")]) : _vm._e(), _vm._v(" "), (star == 3) ? _c('span', [_vm._v("Okay")]) : _vm._e(), _vm._v(" "), (star == 4) ? _c('span', [_vm._v("Good")]) : _vm._e(), _vm._v(" "), (star == 5) ? _c('span', [_vm._v("Great")]) : _vm._e()])])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('a', {
    staticClass: "card-link x-cta-btn",
    on: {
      "click": function($event) {
        _vm.submitReview()
      }
    }
  }, [_vm._v("Send\r\n                    "), (_vm.action_loading) ? _c('span', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]) : _vm._e()])])], 2) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setDeliveryLocation') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setDeliveryLocation"
    }
  }, [(Object.keys(_vm.business_delivery_locations).length > 0) ? _c('div', [_vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-1em"
    }
  }, [_vm._l((_vm.business_delivery_locations), function(location, index) {
    return _c('div', [_c('p', [_c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.set_order_delivery_location),
        expression: "set_order_delivery_location"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": location.business_delivery_option_id,
        "checked": _vm._q(_vm.set_order_delivery_location, location.business_delivery_option_id)
      },
      on: {
        "click": function($event) {
          _vm.setOrderDeliveryLocation(location)
        },
        "__c": function($event) {
          _vm.set_order_delivery_location = location.business_delivery_option_id
        }
      }
    })]), _vm._v("\r\n                        " + _vm._s(location.business_delivery_state) + " - " + _vm._s(location.business_delivery_option) + " - " + _vm._s(location.business_delivery_option_price) + "\r\n                      ")])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setContactDetails') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setContactDetails"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Order Contact Details")]), _vm._v(" "), (_vm.user.user_id && (_vm.user.user_id > 0)) ? _c('div', [_c('p', [_vm._v("Review contact details")]), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.user.user_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.user.user_email))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.user.user_phone))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivety Address: ")]), _vm._v(_vm._s(_vm.user.user_order_delivey_address))]), _vm._v(" "), _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), ((_vm.set_payment_mode == 1) && (_vm.user.user_email == '')) ? _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]) : _vm._e()]) : _c('div', [(_vm.menu_tab_inner_view['showUserDetails']) ? _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.user.user_name))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.user.user_email))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.user.user_phone))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivety Address: ")]), _vm._v(_vm._s(_vm.user.user_order_delivey_address))]), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Reset")])])]) : _c('div', [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('showUserDetails')
      }
    }
  }, [_vm._v("Ok")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setPaymentOptions') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setPaymentOptions"
    }
  }, [(_vm.menu_tab_inner_view['showOrderPaymentConfirmation']) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setPaymentSuccess"
    }
  }, [_c('p', [_vm._v("Payment Made")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn card-link",
    attrs: {
      "href": '/placed/order/' + _vm.order.order_no
    }
  }, [_vm._v("View Order")])]) : _c('div', [_vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Payment Method")]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_payment_mode),
      expression: "set_payment_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.set_payment_mode, "4")
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('payBank')
      },
      "__c": function($event) {
        _vm.set_payment_mode = "4"
      }
    }
  })]), _vm._v("\r\n                        Pay to Bank")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "payBank"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Bank: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account Name: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_account_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account Number: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_account_number))])])])]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_payment_mode),
      expression: "set_payment_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.set_payment_mode, "1")
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('payDirect')
      },
      "__c": function($event) {
        _vm.set_payment_mode = "1"
      }
    }
  })]), _vm._v("\r\n                        Pay to Direct")]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', [(_vm.data_processing_messages.mode_err) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_messages.mode_err))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.setMakeOrder(_vm.set_payment_mode)
      }
    }
  }, [_vm._v("Place Order")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em",
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.2"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewBox('setDeliveryLocation')
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "38px"
    }
  }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0 0.61em"
    }
  }, [_vm._v("900")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.6"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewBox('setDeliveryLocation')
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "28px"
    }
  }, [_vm._v("+")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (_vm.product.product_addons && (_vm.product.product_addons.length > 0)) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('setOptions');
        _vm.set_view_box = 'setAddons'
      }
    }
  }, [_c('ul', {
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, _vm._l((_vm.product.product_addons), function(product, index) {
    return _c('li', [_c('div', {
      staticClass: "card",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle",
      staticStyle: {
        "width": "50px",
        "height": "45px"
      }
    }, [(product.product_images && (Object.keys(product.product_images).length > 0)) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "none",
        "padding": "3px",
        "text-align": "center"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(product.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])]), _vm._v(" "), (_vm.checkOrderProductAddons(product)) ? _c('div', [_c('input', {
      attrs: {
        "checked": "true",
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setOrderProductAddons(product)
        }
      }
    }), _vm._v(" Added\r\n                            ")]) : _c('div', [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setOrderProductAddons(product)
        }
      }
    }), _vm._v(" Add")])])])])
  }))])])]) : _c('div', {
    staticStyle: {
      "height": "0em"
    }
  }), _vm._v(" "), (Object.keys(_vm.business_delivery_locations).length > 0) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "background-color": "#f5e61d"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewBox('setDeliveryLocation')
      }
    }
  }, [_vm._v("select")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "position": "fixed",
      "border": "none",
      "width": "100%",
      "bottom": "0",
      "margin": "0",
      "padding-top": "1.2em",
      "padding-right": "0",
      "background": "#ffffff",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "block",
      "width": "100%",
      "height": "auto",
      "background-color": "rgba(0, 0, 0, 0)"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000",
      "width": "100%"
    },
    attrs: {
      "id": "shareBoxtt"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {}
    }
  }, [_c('span', {
    staticClass: "s-backdrop",
    staticStyle: {
      "bottom": "5em"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "max-height": "75vh",
      "overflow": "scroll",
      "bottom": "5em",
      "margin": "0 -1.2em",
      "background": "none",
      "z-index": "10000"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('shareBox')
      }
    }
  }, [_vm._m(9), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em",
      "margin-bottom": "5em"
    }
  }, [(_vm.set_view_box == '') ? _c('div', {
    staticClass: "row"
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "border-top": "#f5f3f3 solid"
    }
  }, [_c('div', {
    staticClass: "row-ic-02",
    staticStyle: {
      "margin-top": "0.01em"
    }
  }, [_c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "padding-left": "0",
      "background-color": "#f7df2b"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._m(10), _c('span', {
    staticClass: "ct-dsc"
  }, [_vm._v("Confirm Purchase")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "background-color": "#fae570"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('order_details')
      }
    }
  }, [_vm._m(11), _c('span', {
    staticClass: "ct-dsc",
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v("Shopping List")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Re Order")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-shopping-bag",
    staticStyle: {
      "font-size": "3em"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-right",
    staticStyle: {
      "margin-top": "-1.4em"
    }
  }, [_c('h3', [_vm._v("Delivery Locations")]), _vm._v(" "), _c('p', [_vm._v("set where you want this order delivered to")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-shopping-bag",
    staticStyle: {
      "font-size": "3em"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-right",
    staticStyle: {
      "margin-top": "-1.4em"
    }
  }, [_c('h3', [_vm._v("Payment")]), _vm._v(" "), _c('p', [_vm._v("set where you want this order delivered to")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Send to:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "payDirect"
    }
  }, [_c('p', [_vm._v("Pay with your Credit/ATM card")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', [_vm._v("Quantity")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', {
    staticStyle: {
      "line-height": "1.2"
    }
  }, [_vm._v("Add to Order"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "0.05em",
      "font-size": "13px"
    }
  }, [_vm._v("items you should buy with this order")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', [_vm._v("Delivery Location")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin": "0 1em",
      "border-radius": "38%",
      "color": "#000000",
      "padding": "0.22em 0.31em"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right",
    staticStyle: {
      "font-size": "1.6em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin": "0 1em",
      "border-radius": "38%",
      "color": "#000000",
      "padding": "0.22em 0.31em"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    staticStyle: {
      "font-size": "1.6em"
    }
  })])
}]}

/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('c-settings'), _vm._v(" "), _c('div', {
    staticClass: "page-wrapper",
    staticStyle: {
      "background": "#ffffff"
    },
    attrs: {
      "id": "topwrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  }), _vm._v(" "), (_vm.$route.query.upgrade) ? _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [(_vm.set_upgrade_plans) ? _c('section', {
    staticClass: "pricing-style-one",
    staticStyle: {
      "background": "#f0eeef",
      "margin-top": "5em"
    },
    attrs: {
      "id": "pricing"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-5em"
    }
  }, [(!_vm.set_upgrade_plan_process) ? _c('div', {
    staticClass: "container"
  }, [(_vm.upgradable_plans.length == 0) ? _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Sorry, no plans to upgrade to.")])]) : _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Select a plan to upgrade")])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane show active  animated fadeInUp",
    attrs: {
      "role": "tabpanel"
    }
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.upgradable_plans), function(plan) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-6 col-sm-12"
    }, [_c('div', {
      staticClass: "card-purchase basic-pack"
    }, [_c('div', {
      staticClass: "top-block"
    }, [((plan.product_items && plan.product_items.length > 0)) ? _c('span', {
      staticClass: "price"
    }, [_vm._v("₦" + _vm._s(plan.featured_plan.product_item_price))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "pack-name"
    }, [_vm._v(_vm._s(plan.product_name))]), _vm._v(" "), _c('div', {
      staticClass: "line"
    })]), _vm._v(" "), (plan.product_items.length > 0) ? _c('div', _vm._l((plan.product_items), function(item) {
      return _c('li', {
        staticStyle: {
          "list-style": "none"
        }
      }, [_vm._v("\r\n                                                        _ "), _c('b', [_vm._v(_vm._s(item.product_item_service_tag))]), _vm._v(" - "), _c('span', [_vm._v("₦" + _vm._s(_vm.setCurrency(item.product_item_price)))])])
    })) : _vm._e(), _vm._v(" "), (plan.product_url_name == 'plan1') ? _c('ul', {
      staticClass: "feature-lists"
    }, [_c('li', [_vm._v("Extra features")]), _vm._v(" "), _c('li', [_vm._v("Lifetime free support")]), _vm._v(" "), _c('li', [_vm._v("Upgrate options")]), _vm._v(" "), _c('li', [_vm._v("Full access")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "bottom-block"
    }, [_c('p', {
      staticClass: "sp-form-descr"
    }, [_vm._v("Your Upgrade details would be calculated appropriately when you choose plan")]), _vm._v(" "), _c('a', {
      staticClass: "price-btn",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.upgrade_plan(plan)
        }
      }
    }, [_vm._v("Purchase")])])])])
  }))])])]) : _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "10em"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(2)]) : _c('div', {
    staticClass: "row"
  }, [(_vm.setup_error_message != '') ? _c('div', {
    staticClass: "row onboarding-head"
  }, [_c('div', {
    staticClass: "col",
    staticStyle: {
      "margin": "5em",
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#000000",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.setup_error_message) + ".")])])]) : _c('div', [_c('div', {
    staticClass: "row onboarding-body"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-xs-12 col-md-6 offset-md-4 onboarding-center"
  }, [_c('div', [_c('h6', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Upgrade Plans")]), _vm._v(" "), (_vm.selected_plan && _vm.selected_plan.product_items) ? _c('h4', [_c('b', [_vm._v(_vm._s(_vm.selected_plan.product_name) + "(₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)) + ")")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {}, [_c('div', [_vm._l((_vm.selected_plan.product_items_upgrade_details), function(details) {
    return _c('div', {}, [(_vm.selected_plan_product_service_item.product_item_id == details.subscription_new_product_item_id) ? _c('div', [(details.subscription_is_unlimited == 0) ? _c('div', [_c('p', [_vm._v("Your last Subscription was on:"), _c('b', [_vm._v(_vm._s(details.subscription_subscribed_product_start_date))]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("You have "), _c('b', [_vm._v(_vm._s(details.subscription_subscribed_product_days_left))]), _vm._v(" days before your subscription expires.")])]) : _vm._e(), _vm._v(" "), ((details.subscription_new_product_total_amount_to_pay > 0)) ? _c('p', [_vm._v("To upgrade to this plan, the total sum to pay is "), _c('b', [_vm._v("₦" + _vm._s(_vm.setCurrency(details.subscription_new_product_total_amount_to_pay)))])]) : _c('p', [_vm._v("Sorry, you can not purchase this plan yet.")])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {}, [_c('form', {
    staticClass: "gw-form"
  }, [(_vm.selected_plan.product_items_upgrade_details.subscription_new_product_total_amount_to_pay > 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Subscription Duration: "), _c('b', [_vm._v(_vm._s(_vm.selected_plan_product_service_item.product_item_service_tag))])]), _c('br'), _vm._v(" "), _c('label', [_c('p', {
    staticClass: "sp-form-descr"
  }, [_c('b', [_vm._v("Total to pay: ₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)))])])])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_items && (_vm.selected_plan.product_items.length > 1)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "gw-btn-cta-light",
    staticStyle: {
      "color": "#000000"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('display-product_service_items', '')
      }
    }
  }, [_vm._v("\r\n                                                                    Change Subscription Duration\r\n                                                                ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "border": "#aa076b dashed",
      "margin-top": "6px",
      "padding": "5px"
    },
    attrs: {
      "id": "productServiceItems"
    }
  }, _vm._l((_vm.selected_plan.product_items), function(pt) {
    return _c('div', {
      staticClass: "radio-items"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_service_items_select),
        expression: "product_service_items_select"
      }],
      attrs: {
        "type": "radio",
        "id": pt.product_item_id
      },
      domProps: {
        "value": pt.product_item_id,
        "checked": _vm._q(_vm.product_service_items_select, pt.product_item_id)
      },
      on: {
        "click": function($event) {
          _vm.selectProductServiceItem(pt)
        },
        "__c": function($event) {
          _vm.product_service_items_select = pt.product_item_id
        }
      }
    }), _vm._v(_vm._s(pt.product_item_service_tag) + "\r\n                                                                    ")])
  }))]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.payment_successful) ? _c('div', {}, [_c('h3', {
    staticStyle: {
      "color": "#7c0b0b",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.payment_successful_message))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_items_upgrade_details.subscription_new_product_total_amount_to_pay > 0) ? _c('button', {
    staticClass: "btn pull-left gw-btn-cta-light",
    staticStyle: {
      "cursor": "pointer",
      "color": "#000000"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.proceedUpgradePlan()
      }
    }
  }, [_vm._v(" Proceed")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "background": "#f0de3d",
      "cursor": "pointer",
      "color": "#000000"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(" Cancel")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2)])])])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "5em"
    }
  }, [(_vm.set_purchase_process) ? _c('section', {
    staticClass: "home-page-two gw-banner-plain",
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "margin-top": "1em",
      "background": "#f0de3d",
      "cursor": "pointer",
      "color": "#000000"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(" Cancel")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row onboarding-head",
    staticStyle: {
      "background": "#000000",
      "color": "#ffffff",
      "padding": "5em",
      "margin-bottom": "1em"
    }
  }, [(_vm.setup_error_message != '') ? _c('div', {
    staticClass: "col",
    staticStyle: {
      "margin": "5em",
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ffffff",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.setup_error_message) + ".")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('h6', {
    staticClass: "gw-mobile",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Purchase Plans")]), _vm._v(" "), (_vm.selected_plan && _vm.selected_plan.product_items) ? _c('h4', [_c('b', [_vm._v(_vm._s(_vm.selected_plan.product_name) + "(₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)) + ")")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "1em",
      "margin-top": "-3em",
      "padding-top": "2em",
      "background": "#fff8fd",
      "border-radius": "8px"
    }
  }, [(!_vm.newBusinessForm) ? _c('div', {
    staticClass: "row onboarding-body"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-xs-12 col-md-6 onboarding-right"
  }, [(!_vm.loggedIn) ? _c('div', [(!_vm.set_up_with_existing_account) ? _c('div', [_c('div', {}, [_c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Have an account? "), _c('a', {
    staticClass: "card-link",
    staticStyle: {
      "cursor": "pointer",
      "margin-bottom": "1em",
      "color": "#aa076b",
      "text-decoration": "underline !important"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('setup-existing', '')
      }
    }
  }, [_vm._v("Log In")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {}, [_c('form', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('label', [_vm._v("Full Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_name),
      expression: "payment_payer_name"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "placeholder": "Your full name"
    },
    domProps: {
      "value": (_vm.payment_payer_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_email),
      expression: "payment_payer_email"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.payment_payer_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('label', [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_phone),
      expression: "payment_payer_phone"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "number",
      "placeholder": "Phone (format: 09088776655)"
    },
    domProps: {
      "value": (_vm.payment_payer_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_password),
      expression: "user.user_password"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.user_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('label', [_vm._v("ReferralCode")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px",
      "color": "#ff0000"
    }
  }, [_vm._v("Enter Referral Code if any")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.referral_code),
      expression: "referral_code"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.referral_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.referral_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [(_vm.selected_plan_product_service_item.product_item_service_tag) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Subscription Duration: "), _c('b', [_vm._v(_vm._s(_vm.selected_plan_product_service_item.product_item_service_tag))])]), _c('br'), _vm._v(" "), _c('label', [_c('p', {
    staticClass: "sp-form-descr"
  }, [_c('b', [_vm._v("Total to pay: ₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)))])])])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_items && (_vm.selected_plan.product_items.length > 1)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "gw-btn-cta-light",
    staticStyle: {
      "color": "#000000"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('display-product_service_items', '')
      }
    }
  }, [_vm._v("\r\n                                                                    Change Subscription Duration\r\n                                                                ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "border": "#aa076b dashed",
      "margin-top": "6px",
      "padding": "5px"
    },
    attrs: {
      "id": "productServiceItems"
    }
  }, _vm._l((_vm.selected_plan.product_items), function(pt) {
    return _c('div', {
      staticClass: "radio-items"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_service_items_select),
        expression: "product_service_items_select"
      }],
      attrs: {
        "type": "radio",
        "id": pt.product_item_id
      },
      domProps: {
        "value": pt.product_item_id,
        "checked": _vm._q(_vm.product_service_items_select, pt.product_item_id)
      },
      on: {
        "click": function($event) {
          _vm.selectProductServiceItem(pt)
        },
        "__c": function($event) {
          _vm.product_service_items_select = pt.product_item_id
        }
      }
    }), _vm._v(_vm._s(pt.product_item_service_tag) + "\r\n                                                                    ")])
  }))]) : _vm._e()]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.payment_successful) ? _c('div', {}, [_c('h3', {
    staticStyle: {
      "color": "#7c0b0b",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.payment_successful_message))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm sp-button-02",
    staticStyle: {
      "cursor": "pointer",
      "color": "#000000"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setUpNewAccount()
      }
    }
  }, [_vm._v(" Proceed")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _c('div', [_c('div', {}, [_c('div', {
    staticClass: "pull-right"
  }, [_c('p', {
    staticStyle: {
      "float": "right",
      "margin-top": "1em"
    }
  }, [_vm._v("Don't have an account? "), _c('a', {
    staticClass: "card-link",
    staticStyle: {
      "cursor": "pointer",
      "margin-bottom": "1em",
      "color": "#aa076b",
      "text-decoration": "underline !important"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('not-setup-existing', '')
      }
    }
  }, [_vm._v("Sign Up")])])]), _vm._v(" "), _c('p', {
    staticClass: "pull-left",
    staticStyle: {
      "color": "#aa076b"
    }
  }, [_vm._v("Provide your account details to sign in")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('form', {
    staticClass: "form-inline"
  }, [_c('div', [_c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_password),
      expression: "user.user_password"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.user_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.payment_successful) ? _c('div', {}, [_c('h3', {
    staticStyle: {
      "color": "#7c0b0b",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.payment_successful_message))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm sp-button-02",
    staticStyle: {
      "cursor": "pointer",
      "color": "#000000"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setUpWithAccount()
      }
    }
  }, [_vm._v(" Proceed")])])])])])])]) : _c('div', [(!_vm.set_checkout) ? _c('div', [(Object.keys(_vm.user_businesses).length > 0) ? _c('div', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('h3', [_vm._v("Activate for Shop:")]), _vm._v(" "), (Object.keys(_vm.user_businesses).length > 1) ? _c('div', _vm._l((_vm.user_businesses), function(business) {
    return _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_business),
        expression: "selected_business"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": business,
        "checked": _vm._q(_vm.selected_business, business)
      },
      on: {
        "__c": function($event) {
          _vm.selected_business = business
        }
      }
    }), _vm._v(" " + _vm._s(business.business_name) + "\r\n                                                        ")])
  })) : _c('p', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.selected_business.business_name))]), _vm._v(" "), _c('div', [(_vm.order_amount > 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Subscription Duration: "), _c('b', [_vm._v(_vm._s(_vm.selected_plan_product_service_item.product_item_service_tag))])]), _c('br'), _vm._v(" "), _c('label', [_c('p', {
    staticClass: "sp-form-descr"
  }, [_c('b', [_vm._v("Total to pay: ₦" + _vm._s(_vm.setCurrency(_vm.order_amount_to_pay)))])])])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_items && (_vm.selected_plan.product_items.length > 1)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "gw-btn-cta-light",
    staticStyle: {
      "color": "#000000"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('display-product_service_items', '')
      }
    }
  }, [_vm._v("\r\n                                                                Change Subscription Duration\r\n                                                            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "border": "#aa076b dashed",
      "margin-top": "6px",
      "padding": "5px"
    },
    attrs: {
      "id": "productServiceItems"
    }
  }, _vm._l((_vm.selected_plan.product_items), function(pt) {
    return _c('div', {
      staticClass: "radio-items"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_service_items_select),
        expression: "product_service_items_select"
      }],
      attrs: {
        "type": "radio",
        "id": pt.product_item_id
      },
      domProps: {
        "value": pt.product_item_id,
        "checked": _vm._q(_vm.product_service_items_select, pt.product_item_id)
      },
      on: {
        "click": function($event) {
          _vm.selectProductServiceItem(pt)
        },
        "__c": function($event) {
          _vm.product_service_items_select = pt.product_item_id
        }
      }
    }), _vm._v(_vm._s(pt.product_item_service_tag) + "\r\n                                                                ")])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.payment_successful) ? _c('div', {}, [_c('h3', {
    staticStyle: {
      "color": "#7c0b0b",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.payment_successful_message))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm sp-button-02",
    staticStyle: {
      "cursor": "pointer",
      "color": "#000000"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setAsUpgradePlan()
      }
    }
  }, [_vm._v(" Proceed")])])]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You can also set up a new business")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs sp-button-02",
    staticStyle: {
      "cursor": "pointer",
      "color": "#000000"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setComponent('show-new-business-form', '')
      }
    }
  }, [_vm._v(" Set up Business")])])]) : _c('div', [_c('h3', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You do not have any business, to activate this plan on yet.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs sp-button-02",
    staticStyle: {
      "cursor": "pointer",
      "color": "#000000"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setComponent('show-new-business-form', '')
      }
    }
  }, [_vm._v(" Set up Business")])])]) : _c('div', [_c('h3', [_vm._v("Payment Details")]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.set_checkout = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [(_vm.payment_payer_email != '') ? _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.payment_payer_email))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('label', [_vm._v("Have a coupon ?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px",
      "color": "#ff0000"
    }
  }, [_vm._v("Enter Coupon Code if any or just click Make Payment")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_coupon),
      expression: "order_coupon"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.order_coupon)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.order_coupon = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), (_vm.payment_payer_email == '') ? _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('p', {
    staticStyle: {
      "font-size": "12px",
      "color": "#ff0000"
    }
  }, [_vm._v("Please enter your email address to make payment")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_email),
      expression: "payment_payer_email"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.payment_payer_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_email = $event.target.value
      }
    }
  })]) : _c('div', [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm sp-button-02",
    staticStyle: {
      "cursor": "pointer",
      "color": "#000000"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setProcessPayment()
      }
    }
  }, [_vm._v(" Make Payment")])])])])])])]) : _c('div', {
    staticClass: "row onboarding-body"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-xs-12 col-md-6 onboarding-right"
  }, [_vm._m(7), _vm._v(" "), _c('div', {}, [_c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Business Name  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_name),
      expression: "business.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.business.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Business Username "), (_vm.validate_user_name_error) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.validate_user_name_message))]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_user_name),
      expression: "business.business_user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.business.business_user_name)
    },
    on: {
      "change": _vm.validateUserName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Business Category Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_category_type),
      expression: "business_category_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business_category_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Services")])])]), _vm._v(" "), (_vm.business_category_type == 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select a Product Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.business_product_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.business_category_type == 2) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select a Service Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.business_service_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn gw-btn-cta-light",
    staticStyle: {
      "color": "#000000"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.setUpNewAccountBusiness
    }
  }, [_vm._v("Create")])])])])])])])])])])])]) : _c('section', {
    staticClass: "pricing-style-one gw-mtp",
    attrs: {
      "id": "pricing"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "1.3em",
      "margin-bottom": "4em"
    }
  }, [_vm._m(8), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(9)]) : _c('div', {
    staticClass: "row"
  }, [((Object.keys(_vm.picked_plan).length == 0)) ? _c('div', [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-xs-6",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.picked_plan = _vm.plan1
      }
    }
  }, [_c('div', {
    staticClass: "card-purchase basic-pack"
  }, [_vm._l((_vm.plan1.product_items), function(item) {
    return (item.product_item_service_tag == '1 year') ? _c('div', {
      staticClass: "top-block"
    }, [_c('p', {
      staticClass: "pack-name"
    }, [_vm._v(_vm._s(_vm.plan1.product_name))]), _vm._v(" "), _c('p', {
      staticClass: "price"
    }, [_vm._v("₦" + _vm._s(_vm.setCurrency(item.product_item_price)))]), _vm._v(" "), _c('p', {
      staticClass: "pack-tag"
    }, [_vm._v("per year")]), _c('p', {
      staticClass: "pack-descr"
    }, [_vm._v("* Direct Personal Discounts ")])]) : _vm._e()
  }), _vm._v(" "), _vm._m(10)], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-xs-6",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.picked_plan = _vm.plan2
      }
    }
  }, [_c('div', {
    staticClass: "card-purchase pro-pack"
  }, _vm._l((_vm.plan2.product_items), function(item) {
    return (item.product_item_service_tag == '1 year') ? _c('div', {
      staticClass: "top-block"
    }, [_c('p', {
      staticClass: "pack-name"
    }, [_vm._v(_vm._s(_vm.plan2.product_name))]), _vm._v(" "), _c('p', {
      staticClass: "price"
    }, [_vm._v("₦" + _vm._s(_vm.setCurrency(item.product_item_price)))]), _vm._v(" "), _c('p', {
      staticClass: "pack-tag"
    }, [_vm._v("per year")]), _c('p', {
      staticClass: "pack-descr"
    }, [_vm._v("* Direct Personal Discounts ")])]) : _vm._e()
  })), _vm._v(" "), _vm._m(11)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.picked_plan = _vm.plan3
      }
    }
  }, [_c('div', {
    staticClass: "card-purchase biz-pack"
  }, _vm._l((_vm.plan3.product_items), function(item) {
    return (item.product_item_service_tag == '1 year') ? _c('div', {
      staticClass: "top-block"
    }, [_c('p', {
      staticClass: "pack-name"
    }, [_vm._v(_vm._s(_vm.plan3.product_name))]), _vm._v(" "), _c('p', {
      staticClass: "price"
    }, [_vm._v("₦" + _vm._s(_vm.setCurrency(item.product_item_price)))]), _vm._v(" "), _c('p', {
      staticClass: "pack-tag"
    }, [_vm._v("per year")]), _c('p', {
      staticClass: "pack-descr"
    }, [_vm._v("* Direct Personal Discounts ")])]) : _vm._e()
  })), _vm._v(" "), _vm._m(12)])])]) : _c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "margin-top": "2.9em",
      "background": "#ffffff"
    }
  }, [_c('a', {
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.picked_plan = {}
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" Back")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('ul', [((Object.keys(_vm.picked_plan).length > 0)) ? _c('li', [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "card-purchase basic-pack"
  }, [_vm._l((_vm.picked_plan.product_items), function(item) {
    return (item.product_item_service_tag == '1 year') ? _c('div', {
      staticClass: "container"
    }, [_c('p', {
      staticClass: "pack-name"
    }, [_vm._v(_vm._s(_vm.picked_plan.product_name))]), _vm._v(" "), _c('p', {
      staticClass: "price"
    }, [_vm._v("₦" + _vm._s(_vm.setCurrency(item.product_item_price)))]), _vm._v(" "), _c('p', {
      staticClass: "pack-tag"
    }, [_vm._v("per year")]), _c('p', {
      staticClass: "pack-descr"
    }, [_vm._v("* Direct Personal Discounts ")])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('button', {
    staticClass: "btn btn-sm sp-button-02",
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.picked_plan, 'n')
      }
    }
  }, [_vm._v("Purchase")])])], 2)])]) : _vm._e(), _vm._v(" "), (_vm.picked_plan.product_id != _vm.plan1.product_id) ? _c('li', [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "card-purchase basic-pack"
  }, [_vm._l((_vm.plan1.product_items), function(item) {
    return (item.product_item_service_tag == '1 year') ? _c('div', {
      staticClass: "container"
    }, [_c('p', {
      staticClass: "pack-name"
    }, [_vm._v(_vm._s(_vm.plan1.product_name))]), _vm._v(" "), _c('p', {
      staticClass: "price"
    }, [_vm._v("₦" + _vm._s(_vm.setCurrency(item.product_item_price)))]), _vm._v(" "), _c('p', {
      staticClass: "pack-tag"
    }, [_vm._v("per year")]), _c('p', {
      staticClass: "pack-descr"
    }, [_vm._v("* Direct Personal Discounts ")])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('button', {
    staticClass: "btn btn-sm sp-button-02",
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan1, 'n')
      }
    }
  }, [_vm._v("Purchase")])])], 2)])]) : _vm._e(), _vm._v(" "), (_vm.picked_plan.product_id != _vm.plan2.product_id) ? _c('li', [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "card-purchase pro-pack"
  }, [_vm._l((_vm.plan2.product_items), function(item) {
    return (item.product_item_service_tag == '1 year') ? _c('div', {
      staticClass: "top-block"
    }, [_c('p', {
      staticClass: "pack-name"
    }, [_vm._v(_vm._s(_vm.plan2.product_name))]), _vm._v(" "), _c('p', {
      staticClass: "price"
    }, [_vm._v("₦" + _vm._s(_vm.setCurrency(item.product_item_price)))]), _vm._v(" "), _c('p', {
      staticClass: "pack-tag"
    }, [_vm._v("per year")]), _c('p', {
      staticClass: "pack-descr"
    }, [_vm._v("* Direct Personal Discounts ")])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('button', {
    staticClass: "btn btn-sm sp-button-02",
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan2, 'n')
      }
    }
  }, [_vm._v("Purchase")])])], 2)])]) : _vm._e(), _vm._v(" "), (_vm.picked_plan.product_id != _vm.plan3.product_id) ? _c('li', [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "card-purchase biz-pack"
  }, [_vm._l((_vm.plan3.product_items), function(item) {
    return (item.product_item_service_tag == '1 year') ? _c('div', {
      staticClass: "top-block"
    }, [_c('p', {
      staticClass: "pack-name"
    }, [_vm._v(_vm._s(_vm.plan3.product_name))]), _vm._v(" "), _c('p', {
      staticClass: "price"
    }, [_vm._v("₦" + _vm._s(_vm.setCurrency(item.product_item_price)))]), _vm._v(" "), _c('p', {
      staticClass: "pack-tag"
    }, [_vm._v("per year")]), _vm._v(" "), _c('p', {
      staticClass: "pack-descr"
    }, [_vm._v("* Direct Personal Discounts ")])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('button', {
    staticClass: "btn btn-sm sp-button-02",
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan3, 'n')
      }
    }
  }, [_vm._v("Purchase")])])], 2)])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "tab-pane show active  animated fadeInUp",
    attrs: {
      "role": "tabpanel",
      "id": "monthly"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4"
  }, [_c('div', {
    staticClass: "card-purchase basic-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan1.product_items && _vm.plan1.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan1.product_items[0].product_item_price))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan1.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan1, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4"
  }, [_c('div', {
    staticClass: "card-purchase pro-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan2.product_items && _vm.plan2.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan2.product_items[0].product_item_price) + "/mo")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan2.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan2, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4"
  }, [_c('div', {
    staticClass: "card-purchase biz-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan3.product_items && _vm.plan3.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan3.product_items[0].product_item_price) + "/mo")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan3.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan3, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane animated fadeInUp",
    attrs: {
      "role": "tabpanel",
      "id": "yearly"
    }
  })])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#000000"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "true",
      "disabled": "disabled"
    }
  }), _vm._v(" By proceeding, you agree with the "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0055",
      "font-weight": "bold"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#terms-modal",
      "href": "#"
    }
  }, [_vm._v("Terms and Conditions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "true",
      "disabled": "disabled"
    }
  }), _vm._v(" By proceeding, you agree with the "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0055",
      "font-weight": "bold"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#terms-modal",
      "href": "#"
    }
  }, [_vm._v("Terms and Conditions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "true",
      "disabled": "disabled"
    }
  }), _vm._v(" By proceeding, you agree with the "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0055",
      "font-weight": "bold"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#terms-modal",
      "href": "#"
    }
  }, [_vm._v("Terms and Conditions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gw-mobile"
  }, [_c('h6', {
    staticClass: "gw-mobile",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Setup New Sellpoint Account")]), _vm._v(" "), _c('p', {
    staticClass: "sp-form-descr"
  }, [_vm._v("Setup New Sellpoint Account......")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "padding-top": "3em"
    }
  }, [_c('h2', {
    staticStyle: {
      "color": "#1f0113"
    }
  }, [_vm._v("Choose your plan")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pack-btm"
  }, [_c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "text-align": "center"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pack-btm"
  }, [_c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "text-align": "center"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pack-btm"
  }, [_c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "text-align": "center"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Max. 2 lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Max. of 5 posts per Lookbook")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Max. 10 Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Posts per Lookbook")]), _vm._v(" "), _c('li', [_vm._v("Free .com.ng domain")]), _vm._v(" "), _c('li', [_vm._v("*Max Storage Space of 500mb")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Unlimited Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Posts")]), _vm._v(" "), _c('li', [_vm._v("Free .com.ng domain\r\n                                                    ")]), _c('li', [_vm._v("Online Store (Functionality)")]), _vm._v(" "), _c('li', [_vm._v("*Max Storage Space of 1Gb")])])
}]}

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    staticStyle: {
      "background-color": "#ffffff"
    },
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "1em",
      "margin-right": "1em"
    }
  }, [_c('a', {
    staticClass: "col-xs-1 card-link",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _vm._v("   \r\n      "), _c('a', {
    staticClass: "col-xs-2 x-cta-btn card-link",
    staticStyle: {
      "float": "left",
      "width": "30px",
      "height": "40px",
      "text-align": "center"
    },
    attrs: {
      "href": '/' + _vm.order.order_business_username
    }
  }, [_c('p', {
    staticClass: "ltr-1"
  }, [_vm._v(_vm._s(_vm.order.order_user))])]), _vm._v(" "), _c('p', {
    staticClass: "col-xs-9"
  }, [_vm._v(_vm._s(_vm.order.order_user))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "pager",
    staticStyle: {
      "text-align": "left",
      "margin-top": "5em"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin-bottom": "5em"
    }
  }, [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.menu_tab_inner_view['order_details']) ? _c('div', {}, [_c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "800",
      "font-size": "22px",
      "line-height": "1.6"
    }
  }, [_vm._v("Order Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Order No: ")]), _vm._v(_vm._s(_vm.order.order_no))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Date: ")]), _vm._v(_vm._s(_vm.order.order_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("By: ")]), _vm._v(_vm._s(_vm.order.order_user))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("From: ")]), _vm._v(_vm._s(_vm.order.order_business))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Cost: ")]), _vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_items_total)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivery Charge: ")]), _vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_shipping_total)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Total to pay: ")]), _vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_total)))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right",
      "padding": "0.51em",
      "border-radius": "5px",
      "background-color": "#f7df2b",
      "color": "#000000"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.order.order_status))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Items Ordered")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "category-slide"
  }, [_c('ul', _vm._l((_vm.order.order_items), function(item, index) {
    return _c('li', {}, [(item.product_item_group_image && (item.product_item_group_image != '' && item.product_item_group_image != 'error')) ? _c('img', {
      staticStyle: {
        "width": "80px",
        "height": "100px",
        "border-radius": "8px"
      },
      attrs: {
        "src": _vm.img_product_url + item.product_item_group_image
      }
    }) : _c('img', {
      staticStyle: {
        "width": "80px",
        "height": "100px",
        "border-radius": "8px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('h6', [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), _c('h6', {
      staticStyle: {
        "font-size": "18px",
        "text-align": "left"
      }
    }, [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(item.order_item_total)) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "14px"
      }
    }, [_c('b', [_vm._v("Quantity: ")]), _vm._v(_vm._s(item.order_item_quantity))])])])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Delivery Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [(_vm.order.order_user_delivery_address != '') ? _c('p', [_vm._v(_vm._s(_vm.order.order_user_delivery_address))]) : _c('p', [_vm._v("Not set")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Order Contact Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.order.order_business))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email Address: ")]), _vm._v(_vm._s(_vm.order.order_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone Number: ")]), _vm._v(_vm._s(_vm.order.order_user))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Order Additional Information")]), _vm._v(" "), _c('hr'), _vm._v(" "), (Object.keys(_vm.order_additionals).length > 0) ? _c('div', _vm._l((_vm.order_additionals), function(detail, index) {
    return _c('div', [_c('p', [_c('b', [_vm._v(_vm._s(++index) + ". ")]), _vm._v(_vm._s(detail.order_additional_details))])])
  })) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No additional information")])])]) : _c('div', {}, [_c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Shopping on "), _c('b', [_vm._v(_vm._s(_vm.order.order_date))])]), _vm._v(" "), _c('p', [_vm._v("Status: "), _c('b', [_c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.order.order_status))])])]), _vm._v(" "), _c('p', [_vm._v("Deliver Items and Close this Shopping List Request")]), _vm._v(" "), _c('hr'), _vm._v(" "), (Object.keys(_vm.order_chart).length > 0) ? _c('div', [_c('div', [_c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "container container-right"
  }, [_c('div', {
    staticClass: "card-box card-02"
  }, [_c('h5', [_vm._v("Shopping List "), _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "float": "right"
    }
  }, [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_total)))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_vm._l((_vm.order.order_items), function(item, index) {
    return (index < 4) ? _c('p', {
      key: item.order_item_no
    }, [_vm._v("\r\n                        " + _vm._s(item.product_name) + " - ₦" + _vm._s(item.order_item_total.toFixed(2)) + "\r\n                      ")]) : _vm._e()
  }), _vm._v(" "), _c('a', {}, [_vm._v("see Items")])], 2), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('h5', [_vm._v("Delivery"), _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "float": "right"
    }
  }, [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_shipping_total)))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [(_vm.order.order_user_delivery_address != '') ? _c('p', [_vm._v(_vm._s(_vm.order.order_user_delivery_address))]) : _c('p', [_vm._v("Not set")])])]), _vm._v(" "), (_vm.checkOrderChart('status', 35)) ? _c('div', [_c('hr'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You confirmed these Items are available")])]) : _vm._e()])])])]), _vm._v(" "), _vm._l((_vm.order_chart), function(track) {
    return _c('div', [_c('div', {
      staticClass: "timeline"
    }, [(track.order_status_id == 20) ? _c('div', {
      staticClass: "container container-left"
    }, [_c('div', {
      staticClass: "card-box card-02"
    }, [_c('h5', [_vm._v("Proof of payment")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', [_vm._v("Please confirm payment")]), _vm._v(" "), _c('div', [(track.order_status_id == 20) ? _c('div', _vm._l((track.order_set_uploads), function(images) {
      return (images.data_image != '') ? _c('div', [(images.data_image) ? _c('img', {
        staticClass: "img-responsive",
        attrs: {
          "src": images.data_image
        }
      }) : _vm._e()]) : _vm._e()
    })) : _vm._e()]), _vm._v(" "), _c('div', [_c('hr'), _vm._v(" "), _c('button', {
      staticClass: "sp-button sp-button-lt",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('ConfirmPaymentUpdate')
        }
      }
    }, [_vm._v("Confirm Payment")]), _vm._v(" "), _c('div', {
      attrs: {
        "id": "ConfirmPaymentUpdate"
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Confirm Order Payment ?")]), _vm._v(" "), _c('button', {
      staticClass: "sp-button sp-button-lt",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderCustomConfirmPaymentUpdate(_vm.order)
        }
      }
    }, [_vm._v("Yes, Confirm Payment")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "timeline"
    }, [_c('div', {
      staticClass: "container container-right"
    }, [(track.order_status_id == 35) ? _c('div', {
      staticClass: "card-box card-02"
    }, [_c('h5', [_vm._v("How to Pay")]), _vm._v(" "), _c('hr'), _vm._v(" "), (track.order_set_bank_name != '') ? _c('h6', [_vm._v("Use the below account details to make payment")]) : _vm._e(), _vm._v(" "), (track.order_set_payment_link != '') ? _c('h6', [_vm._v("click the link below to make payment")]) : _vm._e(), _vm._v(" "), _c('div', [(track.order_status_id == 35) ? _c('div', [(track.order_set_bank_name != '') ? _c('div', [_c('p', [_c('b', [_vm._v("Bank Name: ")]), _vm._v(_vm._s(track.order_set_bank_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Bank Account Name: ")]), _vm._v(_vm._s(track.order_set_bank_account_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Bank Account No: ")]), _vm._v(_vm._s(track.order_set_bank_account_no))])]) : _vm._e(), _vm._v(" "), (_vm.order.order_payment_buyer_confirmation == 0) ? _c('div', [_c('div', [_c('hr'), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('setMakePayment')
        }
      }
    }, [_vm._v(_vm._s(track.order_status_cta))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": "setMakePayment"
      }
    }, [_c('div', {
      staticClass: "card"
    }, [_c('h4', [_vm._v("Have you made payment?")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      on: {
        "click": function($event) {
          _vm.setOrderCustomUpdates(_vm.order, 'custom_set_track_make_payment', 1)
        }
      }
    }, [_vm._v("YES\r\n                                "), (_vm.action_loading) ? _c('span', [_c('i', {
      staticClass: "fa fa-circle-o-notch"
    })]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02 btn-danger",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('setMakePayment')
        }
      }
    }, [_vm._v("NO")])])])]) : _vm._e()]) : _vm._e()])]) : _vm._e()])])])
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('hr'), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "prImagePreview"
    }
  }), _vm._v(" "), ((Object.keys(_vm.file_info).length == 0)) ? _c('div', [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn sp-button-02",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Upload Receipt")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeNewPhoto($event, 'transfer-receipt')
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.file_info[0]) ? _c('div', [_c('button', {
    staticClass: "btn btn-default wnf-button",
    staticStyle: {
      "width": "30vw",
      "margin-left": "0vw",
      "padding": "5px 3px"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.uploadFlexiPaymentReceipt(_vm.order, _vm.order.order_no, 'transferred')
      }
    }
  }, [_vm._v("Yes, Upload")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default wnf-button",
    staticStyle: {
      "width": "30vw",
      "margin-left": "0vw",
      "padding": "5px 3px",
      "background-color": "#f5f4e6",
      "color": "#000000"
    },
    on: {
      "click": function($event) {
        _vm.resetImageUpload()
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])])], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000",
      "width": "100%",
      "margin-left": "-0.11em",
      "border-left": "#ffffff solid"
    },
    attrs: {
      "id": "shareBox"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {}
    }
  }, [_c('span', {
    staticClass: "s-backdrop"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "max-height": "75vh",
      "overflow": "scroll",
      "bottom": "0",
      "margin": "0 -1.2em",
      "background": "none",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticClass: "z-box",
    staticStyle: {
      "width": "100%",
      "padding": "0.1em",
      "border-radius": "35px 35px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "200px",
      "padding": "2em",
      "margin-bottom": "5.8em",
      "border-bottom": "#eee solid",
      "text-align": "left"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('shareBox')
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em",
      "margin-bottom": "5em"
    }
  }, [(_vm.set_view_box == '') ? _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Give a star rating")]), _vm._v(" "), _vm._l((5), function(star) {
    return _c('div', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "margin-right": "2em",
        "font-size": "28px",
        "line-height": "0.4",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.setRate(_vm.order.order_items[0], star)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-star-o",
      attrs: {
        "id": 'rate-' + star
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-star",
      staticStyle: {
        "display": "none",
        "color": "#f7df2b"
      },
      attrs: {
        "id": 'rated-' + star
      }
    })]), _vm._v(" "), _c('p', {
      staticStyle: {
        "margin-top": "0.2em",
        "color": "#000000",
        "font-size": "12px",
        "font-weight": "600"
      }
    }, [(star == 1) ? _c('span', [_vm._v("Bad")]) : _vm._e(), _vm._v(" "), (star == 2) ? _c('span', [_vm._v("Not Bad")]) : _vm._e(), _vm._v(" "), (star == 3) ? _c('span', [_vm._v("Okay")]) : _vm._e(), _vm._v(" "), (star == 4) ? _c('span', [_vm._v("Good")]) : _vm._e(), _vm._v(" "), (star == 5) ? _c('span', [_vm._v("Great")]) : _vm._e()])])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('a', {
    staticClass: "card-link x-cta-btn",
    on: {
      "click": function($event) {
        _vm.submitReview()
      }
    }
  }, [_vm._v("Send\r\n                    "), (_vm.action_loading) ? _c('span', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]) : _vm._e()])])], 2) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setDeliveryLocation') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setDeliveryLocation"
    }
  }, [(Object.keys(_vm.business_delivery_locations).length > 0) ? _c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-1em"
    }
  }, [_vm._l((_vm.business_delivery_locations), function(location, index) {
    return _c('div', [_c('p', [_c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.set_order_delivery_location),
        expression: "set_order_delivery_location"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": location.business_delivery_option_id,
        "checked": _vm._q(_vm.set_order_delivery_location, location.business_delivery_option_id)
      },
      on: {
        "click": function($event) {
          _vm.setOrderDeliveryLocation(location)
        },
        "__c": function($event) {
          _vm.set_order_delivery_location = location.business_delivery_option_id
        }
      }
    })]), _vm._v("\r\n                        " + _vm._s(location.business_delivery_state) + " - " + _vm._s(location.business_delivery_option) + " - " + _vm._s(location.business_delivery_option_price) + "\r\n                      ")])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setContactDetails') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setContactDetails"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Order Contact Details")]), _vm._v(" "), (_vm.user.user_id && (_vm.user.user_id > 0)) ? _c('div', [_c('p', [_vm._v("Review contact details")]), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.user.user_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.user.user_email))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.user.user_phone))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivety Address: ")]), _vm._v(_vm._s(_vm.user.user_order_delivey_address))]), _vm._v(" "), _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), ((_vm.set_payment_mode == 1) && (_vm.user.user_email == '')) ? _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]) : _vm._e()]) : _c('div', [(_vm.menu_tab_inner_view['showUserDetails']) ? _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.user.user_name))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.user.user_email))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.user.user_phone))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivety Address: ")]), _vm._v(_vm._s(_vm.user.user_order_delivey_address))]), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Reset")])])]) : _c('div', [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('showUserDetails')
      }
    }
  }, [_vm._v("Ok")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setPaymentOptions') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setPaymentOptions"
    }
  }, [(_vm.menu_tab_inner_view['showOrderPaymentConfirmation']) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setPaymentSuccess"
    }
  }, [_c('p', [_vm._v("Payment Made")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn card-link",
    attrs: {
      "href": '/placed/order/' + _vm.order.order_no
    }
  }, [_vm._v("View Order")])]) : _c('div', [_vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Payment Method")]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_payment_mode),
      expression: "set_payment_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.set_payment_mode, "4")
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('payBank')
      },
      "__c": function($event) {
        _vm.set_payment_mode = "4"
      }
    }
  })]), _vm._v("\r\n                        Pay to Bank")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "payBank"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Bank: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account Name: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_account_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account Number: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_account_number))])])])]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_payment_mode),
      expression: "set_payment_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.set_payment_mode, "1")
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('payDirect')
      },
      "__c": function($event) {
        _vm.set_payment_mode = "1"
      }
    }
  })]), _vm._v("\r\n                        Pay to Direct")]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', [(_vm.data_processing_messages.mode_err) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_messages.mode_err))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.setMakeOrder(_vm.set_payment_mode)
      }
    }
  }, [_vm._v("Place Order")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em",
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.2"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewBox('setDeliveryLocation')
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "38px"
    }
  }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0 0.61em"
    }
  }, [_vm._v("900")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.6"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewBox('setDeliveryLocation')
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "28px"
    }
  }, [_vm._v("+")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (_vm.product.product_addons && (_vm.product.product_addons.length > 0)) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('setOptions');
        _vm.set_view_box = 'setAddons'
      }
    }
  }, [_c('ul', {
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, _vm._l((_vm.product.product_addons), function(product, index) {
    return _c('li', [_c('div', {
      staticClass: "card",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle",
      staticStyle: {
        "width": "50px",
        "height": "45px"
      }
    }, [(product.product_images && (Object.keys(product.product_images).length > 0)) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "none",
        "padding": "3px",
        "text-align": "center"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(product.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])]), _vm._v(" "), (_vm.checkOrderProductAddons(product)) ? _c('div', [_c('input', {
      attrs: {
        "checked": "true",
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setOrderProductAddons(product)
        }
      }
    }), _vm._v(" Added\r\n                            ")]) : _c('div', [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setOrderProductAddons(product)
        }
      }
    }), _vm._v(" Add")])])])])
  }))])])]) : _c('div', {
    staticStyle: {
      "height": "0em"
    }
  }), _vm._v(" "), (Object.keys(_vm.business_delivery_locations).length > 0) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "background-color": "#f5e61d"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewBox('setDeliveryLocation')
      }
    }
  }, [_vm._v("select")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "position": "fixed",
      "border": "none",
      "width": "100%",
      "bottom": "0",
      "margin": "0",
      "padding-top": "1.2em",
      "padding-right": "0",
      "background": "#ffffff",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "block",
      "width": "100%",
      "height": "auto",
      "background-color": "rgba(0, 0, 0, 0)"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000",
      "width": "100%"
    },
    attrs: {
      "id": "shareBoxtt"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {}
    }
  }, [_c('span', {
    staticClass: "s-backdrop",
    staticStyle: {
      "bottom": "5em"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "max-height": "75vh",
      "overflow": "scroll",
      "bottom": "5em",
      "margin": "0 -1.2em",
      "background": "none",
      "z-index": "10000"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('shareBox')
      }
    }
  }, [_vm._m(8), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em",
      "margin-bottom": "5em"
    }
  }, [(_vm.set_view_box == '') ? _c('div', {
    staticClass: "row"
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "border-top": "#f5f3f3 solid"
    }
  }, [_c('div', {
    staticClass: "row-ic-02",
    staticStyle: {
      "margin-top": "0.01em"
    }
  }, [_c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "padding-left": "0",
      "background-color": "#f7df2b"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._m(9), _c('span', {
    staticClass: "ct-dsc"
  }, [_vm._v("Confirm Purchase")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "background-color": "#fae570"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('order_details')
      }
    }
  }, [_vm._m(10), _c('span', {
    staticClass: "ct-dsc",
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v("Shopping List")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-shopping-bag",
    staticStyle: {
      "font-size": "3em"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-right",
    staticStyle: {
      "margin-top": "-1.4em"
    }
  }, [_c('h3', [_vm._v("Delivery Locations")]), _vm._v(" "), _c('p', [_vm._v("set where you want this order delivered to")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-shopping-bag",
    staticStyle: {
      "font-size": "3em"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-right",
    staticStyle: {
      "margin-top": "-1.4em"
    }
  }, [_c('h3', [_vm._v("Payment")]), _vm._v(" "), _c('p', [_vm._v("set where you want this order delivered to")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Send to:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "payDirect"
    }
  }, [_c('p', [_vm._v("Pay with your Credit/ATM card")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', [_vm._v("Quantity")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', {
    staticStyle: {
      "line-height": "1.2"
    }
  }, [_vm._v("Add to Order"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "0.05em",
      "font-size": "13px"
    }
  }, [_vm._v("items you should buy with this order")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', [_vm._v("Delivery Location")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin": "0 1em",
      "border-radius": "38%",
      "color": "#000000",
      "padding": "0.22em 0.31em"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right",
    staticStyle: {
      "font-size": "1.6em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin": "0 1em",
      "border-radius": "38%",
      "color": "#000000",
      "padding": "0.22em 0.31em"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    staticStyle: {
      "font-size": "1.6em"
    }
  })])
}]}

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _c('div', {
    key: _vm.componentKey,
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('div', [_vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "1em",
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "30%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint_transactions.transactions_total_today))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Total Transactions")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "45%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("NGN" + _vm._s(_vm.sellpoint_transactions.transactions_total_today_amount))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Total Amount Received")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', [_vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "1em",
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "30%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint_transactions.transactions_total))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Total Transactions")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "45%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("NGN" + _vm._s(_vm.sellpoint_transactions.transactions_total_amount))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Total Amount Received")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('p', [_vm._v(_vm._s(_vm.sellpoint_transactions.transactions_total) + " Transactions")]), _vm._v(" "), _c('div', {}, _vm._l((_vm.sellpoint_transactions.transactions), function(tx, tdex) {
    return _c('div', {
      key: tx.transaction_id,
      staticClass: "card card-flat-pad"
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "90%"
      }
    }, [_c('div', [_c('span', {
      staticStyle: {
        "float": "left",
        "width": "55%"
      }
    }, [_c('b', [_vm._v(_vm._s(tx.transaction_user_name))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "width": "35%"
      }
    }, [_vm._v("  ₦" + _vm._s(tx.transaction_amount_paid))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('div', [(_vm.menu_tab_inner_view['TX' + tdex]) ? _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('')
        }
      }
    }, [_vm._m(4, true)]) : _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('TX' + tdex)
        }
      }
    }, [_vm._m(5, true)])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (_vm.menu_tab_inner_view['TX' + tdex]) ? _c('div', [_c('div', {
      staticClass: "orders-panel",
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('p', {
      staticStyle: {
        "text-align": "center",
        "font-weight": "bolder",
        "font-size": "18px"
      }
    }, [_vm._v(" . . .")]), _vm._v(" "), _c('div', {
      staticClass: "card card-strip"
    }, [_vm._m(6, true), _vm._v(" "), _c('div', {
      staticClass: "card-right-50"
    }, [_c('p', [_vm._v(_vm._s(tx.transaction_user_name))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "card card-strip"
    }, [_vm._m(7, true), _vm._v(" "), _c('div', {
      staticClass: "card-right-50"
    }, [_c('p', [_vm._v(_vm._s(tx.transaction_details))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "card card-strip"
    }, [_vm._m(8, true), _vm._v(" "), _c('div', {
      staticClass: "card-right-50"
    }, [_c('p', [_vm._v(_vm._s(tx.transaction_type_name))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "card card-strip"
    }, [_vm._m(9, true), _vm._v(" "), _c('div', {
      staticClass: "card-right-50"
    }, [_c('p', [_vm._v(_vm._s(tx.transaction_payment_ref))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "card card-strip"
    }, [_vm._m(10, true), _vm._v(" "), _c('div', {
      staticClass: "card-right-50"
    }, [_c('p', [_vm._v(_vm._s(tx.transaction_payment_date))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (tx.transaction_transaction_type != 4) ? _c('div', {
      staticClass: "card card-strip"
    }, [_vm._m(11, true), _vm._v(" "), _c('div', {
      staticClass: "card-right-50"
    }, [_c('p', [_vm._v("₦" + _vm._s(tx.transaction_total_amount_paid))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "card card-strip"
    }, [_vm._m(12, true), _vm._v(" "), _c('div', {
      staticClass: "card-right-50"
    }, [_c('p', [_vm._v("₦" + _vm._s(tx.transaction_amount_paid))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (tx.transaction_transaction_type != 4) ? _c('div', [((tx.transaction_payment_settlements && (Object.keys(tx.transaction_payment_settlements).length !== 0))) ? _c('div', {
      staticClass: "card card-strip"
    }, [_vm._m(13, true), _vm._v(" "), (_vm.sellpoint.business_agent == 1) ? _c('div', _vm._l((tx.transaction_payment_settlements), function(txs) {
      return _c('div', {
        key: txs.payment_stl_id
      }, [(txs.payment_stl_type == 22) ? _c('div', [_c('div', {
        staticClass: "card-left-50"
      }, [_c('p', [_c('span', {
        staticStyle: {
          "color": "#7a7878"
        }
      }, [_c('b', [_vm._v(_vm._s(txs.payment_stl_type_name))])])])]), _vm._v(" "), _c('div', {
        staticClass: "card-right-50"
      }, [_c('p', [(txs.payment_stl_payment_name != '') ? _c('span', [_vm._v(_vm._s(txs.payment_stl_payment_name)), _c('br')]) : _vm._e(), _vm._v("NGN" + _vm._s(txs.payment_stl_amount) + "\n                                                  ")])]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })]) : _vm._e()])
    })) : _c('div', _vm._l((tx.transaction_payment_settlements), function(txs) {
      return _c('div', {
        key: txs.payment_stl_id
      }, [_c('div', {
        staticClass: "card-left-50"
      }, [_c('p', [_c('span', {
        staticStyle: {
          "color": "#7a7878"
        }
      }, [_c('b', [_vm._v(_vm._s(txs.payment_stl_type_name))])])])]), _vm._v(" "), _c('div', {
        staticClass: "card-right-50"
      }, [_c('p', [(txs.payment_stl_payment_name != '') ? _c('span', [_vm._v(_vm._s(txs.payment_stl_payment_name)), _c('br')]) : _vm._e(), _vm._v("NGN" + _vm._s(txs.payment_stl_amount) + "\n                                        ")])]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })])
    })), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]) : _vm._e()]) : _vm._e()])]) : _vm._e()])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_c('b', [_vm._v("Business")]), _vm._v(" - Transactions")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('b', [_vm._v("Today")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('b', [_vm._v("Total")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left-50"
  }, [_c('p', [_vm._v("Payment from")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left-50"
  }, [_c('p', [_vm._v("Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left-50"
  }, [_c('p', [_vm._v("Type of Payment")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left-50"
  }, [_c('p', [_vm._v("Payment Ref")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left-50"
  }, [_c('p', [_vm._v("Date")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left-50"
  }, [_c('p', [_vm._v("Amount Paid")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left-50"
  }, [_c('p', [_vm._v("Amount Received")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('u', [_vm._v("Payment Settlements")])])
}]}

/***/ }),
/* 568 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager",
    staticStyle: {
      "background": "#ffffff"
    }
  }, [_c('div', {
    staticClass: "section",
    staticStyle: {
      "margin-top": "1em",
      "text-align": "left"
    }
  }, [(_vm.store_loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._v("lodddi\r\n            "), _c('div', {
    staticClass: "loading-md"
  })]) : _c('div', [_vm._v("\r\n            " + _vm._s(_vm.data_store[0].data) + "\r\n        ")])])])
},staticRenderFns: []}

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticStyle: {
      "background-color": "#eee",
      "border-radius": "50%",
      "color": "#000000",
      "cursor": "pointer",
      "margin-top": "-0.9em",
      "padding": "5px 8px",
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.dropMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-user",
    staticStyle: {
      "font-size": "1.28em",
      "color": "#5703a5"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sidenav",
    attrs: {
      "id": "menu-nav"
    }
  }, [_c('a', {
    staticClass: "closebtn",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.dropMenu()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "clear": "both",
      "margin-top": "-2em",
      "margin-left": "0.71em",
      "font": "1.5em agency-fb",
      "font-weight": "200"
    }
  }, [_vm._v("XXXX")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "margin": "1em",
      "display": "none"
    }
  }), _vm._v(" "), (_vm.loggedIn) ? _c('p', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.user.user_name))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m-nav",
    staticStyle: {
      "margin-left": "0.71em"
    }
  }, [_c('ul', [_c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('a', {
    attrs: {
      "href": "/cart"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v("Shopping Cart")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('a', {
    attrs: {
      "href": "/wishlist"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-heart"
  }), _vm._v("Wishlist")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('a', {
    attrs: {
      "href": "/account"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v("My Account")])])])]), _vm._v(" "), _c('div', {
    staticClass: "m-navg",
    staticStyle: {
      "margin-left": "0.71em"
    }
  }, [_c('hr'), _vm._v(" "), _c('ul', [_c('li', {}, [_c('a', {
    attrs: {
      "href": "/agentservices"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v("MultiShop Agent")])])])]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border-top": "#f9f9fb solid",
      "margin": "1em",
      "margin-top": "0.3em",
      "margin-right": "1.73em"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
    staticStyle: {
      "display": "none"
    }
  }, [(_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/account"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.user.user_name))])])]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/account"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Account")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/timeline"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  }), _vm._v(" Market")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/orders"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v(" Orders")])]), _vm._v(" "), (_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/wishlist"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-heart"
  }), _vm._v(" Wishlist")])]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/buypoint"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" Shop Together")])]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/login"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-power-off"
  }), _vm._v(" Logout")])]) : _vm._e(), _vm._v(" "), (!_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/login"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-power-on"
  }), _vm._v(" Login")])]) : _vm._e(), _vm._v(" "), (!_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/register"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-power-on"
  }), _vm._v(" Register")])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-xs-12 row-01"
  }, [_c('div', {
    staticClass: "col-xs-6 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/orders"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("Recent Orders")])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "bottomnav m-nav"
  }, [_c('div', [_c('ul', {
    staticStyle: {
      "margin": "0",
      "padding": "0px"
    }
  }, [_c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('a', {
    attrs: {
      "href": "/notifications"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), (_vm.notifications_alert > 0) ? _c('sup', {
    staticClass: "notify-alert"
  }, [_vm._v(_vm._s(_vm.notifications_alert))]) : _vm._e(), _c('span', [_vm._v("Notifications & Messages")])])]), _vm._v(" "), (_vm.loggedIn) ? _c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('a', {
    attrs: {
      "href": "/login"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-power-off"
  }), _vm._v(" Logout")])]) : _vm._e(), _vm._v(" "), (!_vm.loggedIn) ? _c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('a', {
    attrs: {
      "href": "/login"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-power-on"
  }), _vm._v(" Login")])]) : _vm._e(), _vm._v(" "), (!_vm.loggedIn) ? _c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('a', {
    attrs: {
      "href": "/register"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-power-on"
  }), _vm._v(" Register")])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "0 1em"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-left": "45vw",
      "padding-right": "1em",
      "margin-top": "-0.5em",
      "font-size": "13px"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search For _____________ ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-shopping-basket"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-list"
  })]), _vm._v(" "), _c('p', [_vm._v("My Lists")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-credit-card",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Make Payment")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })]), _vm._v(" "), _c('p', [_vm._v("Add Shop")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-cubes"
  })]), _vm._v(" "), _c('p', [_vm._v("Manage Shop")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-upload"
  })]), _vm._v(" "), _c('p', [_vm._v("Upload Product")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "1.71em"
    }
  }, [_c('p', [_vm._v("Search For"), _c('br'), _vm._v("\r\n            _________________Men Wears")]), _vm._v(" "), _c('p', [_vm._v("Select Type (if sub)"), _c('br'), _vm._v("\r\n            _________________Trousers")]), _vm._v(" "), _c('p', [_vm._v("Pick Size(if sizes) or Color (if colors) + all_option"), _c('br'), _vm._v("\r\n            _________________Trousers")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-sm btn-sm"
  }, [_vm._v("Go >> ")])])
}]}

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row"
  }) : _c('div', {
    staticStyle: {
      "margin-top": "-3em"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', [_vm._v("\r\n        Hi Chat " + _vm._s(_vm.set_chat_view) + "\r\n        "), _c('a', {
    staticClass: "sp-button-1",
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('showProductGrid')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-th"
  })]), _vm._v(" "), (_vm.menu_tab_view.showProductGrid) ? _c('div', _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "card col-xs-6 card-col-2",
      staticStyle: {
        "margin-bottom": "0.8em"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.postChatObject(product)
        }
      }
    }, [_c('div', {
      staticClass: "card-col-img",
      staticStyle: {
        "margin-bottom": "0.8em",
        "border-left": "#f5f5f5 solid 0.35em",
        "border-radius": "4px"
      }
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e()])])])])
  })) : _c('div', [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-bottom": "8em"
    }
  }, [(_vm.set_chat_view) ? _c('div', [_vm._l((_vm.chat_log.chats), function(chat) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      style: (_vm.setChatStyle(chat))
    }, [(chat.chat_from != _vm.chatter.chatter_chat_from) ? _c('p', {
      staticClass: "sp-app-default-color"
    }, [_c('b', [_vm._v(_vm._s(chat.chat_from_name) + "\r\n                      "), (_vm.chatter_set.chatter_style == 2) ? _c('span', [_vm._v("\r\n                        > " + _vm._s(chat.chat_to_name) + "\r\n                      ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (chat.chat_message_type == 8) ? _c('div', [_c('div', {
      staticClass: "col-xs-6",
      staticStyle: {
        "border-radius": "4px"
      }
    }, [_c('div', {
      staticClass: "card-col-img",
      staticStyle: {
        "margin-bottom": "0.8em"
      }
    }, [(chat.chat_message_object_media) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": chat.chat_message_object_media
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(chat.chat_message_object_name)), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("₦" + _vm._s(chat.chat_message_object_price))]), _c('br'), _vm._v(" "), (chat.chat_message && (chat.chat_message != '')) ? _c('span', {
      staticStyle: {
        "font-weight": "bolder"
      }
    }, [_vm._v(_vm._s(chat.chat_message))]) : _vm._e()])])])]) : _c('div', [_vm._v("\r\n                    " + _vm._s(chat.chat_message) + "\r\n                  ")]), _vm._v(" "), (_vm.chatter.chatter_style == 2 && (chat.chat_reply_url != '')) ? _c('div', [_c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('a', {
      attrs: {
        "href": chat.chat_reply_url
      }
    }, [_vm._v("reply")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "bottom": "5em",
      "position": "fixed"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chat.chat_set_message),
      expression: "chat.chat_set_message"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.chat.chat_set_message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.chat.chat_set_message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "sp-button-1",
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.postChat
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  })])])], 2) : _c('div', {
    staticClass: "card"
  }, [(_vm.chat_logs && (Object.keys(_vm.chat_logs).length > 0)) ? _c('div', _vm._l((_vm.chat_logs), function(chatlog) {
    return _c('div', {
      staticClass: "row"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setChatLog(chatlog)
        }
      }
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "border": "gray solid",
        "padding": "0.5em",
        "width": "85%",
        "text-align": "left"
      }
    }, [_vm._v("\r\n                      " + _vm._s(chatlog.chatlog_from_to) + " - " + _vm._s(chatlog.chatlog_from_to_name) + "\r\n                    ")])])])
  })) : _c('div', [_c('p', [_vm._v("No chats yet")])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "bottom": "5em",
      "position": "fixed"
    }
  }, [(_vm.chatter.chatter_style == 2) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chat.chat_set_message),
      expression: "chat.chat_set_message"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": 'You are chatting as ' + _vm.user.user_name,
      "type": "text"
    },
    domProps: {
      "value": (_vm.chat.chat_set_message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.chat.chat_set_message = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chat.chat_set_message),
      expression: "chat.chat_set_message"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.chat.chat_set_message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.chat.chat_set_message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "sp-button-1",
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.postChat
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  })])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('u', [_vm._v("Direct Chat Messaging")])])
}]}

/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin": "0.1em",
      "margin-top": "-0.2em",
      "margin-bottom": "12em"
    }
  }, [(_vm.loading) ? _c('div', [_vm._m(0)]) : _c('div', {
    staticClass: "card"
  }, [(_vm.menu_tab_inner_view['general_goods_category_products']) ? _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "16em"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('h3', [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-left"
  })])]), _vm._v(_vm._s(_vm.general_goods_category.category_name) + "\r\n            ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-left": "2.2em",
      "color": "#5703a5"
    }
  }, [_vm._v("select products")])]), _vm._v(" "), _vm._l((_vm.general_goods_category_products), function(set_product, index) {
    return _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "col-xs-1"
    }, [_c('input', {
      staticStyle: {
        "height": "3em"
      },
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setAddItemsToList(set_product, index)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2"
    }, [_c('div', {
      staticClass: "card-avatar-square"
    }, [(set_product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": set_product.product_images[0].product_image
      }
    }) : _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('div', [_c('p', [_vm._v(_vm._s(set_product.product_name)), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("₦‎" + _vm._s(set_product.product_items[0].product_item_price_f))])]), _vm._v(" "), (_vm.checkItemInList(set_product)) ? _c('div', [_c('b', [_vm._v("Price: ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (set_product.product_items[0].product_item_price),
        expression: "set_product.product_items[0].product_item_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (set_product.product_items[0].product_item_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          set_product.product_items[0].product_item_price = $event.target.value
        }
      }
    }), _c('br'), _vm._v(" "), _c('b', [_vm._v("Quantity / Stock: ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (set_product.product_item_quantity),
        expression: "set_product.product_item_quantity"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (set_product.product_item_quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          set_product.product_item_quantity = $event.target.value
        }
      }
    }), _c('br')]) : _vm._e()])])])
  })], 2) : (_vm.menu_tab_inner_view['custom_add']) ? _c('div', {
    staticClass: "card"
  }, [_vm._v("\r\n          Custom Add New\r\n        ")]) : _c('div', [(_vm.business_type == 2) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "border": "none"
    }
  }, [_c('div', {
    staticClass: "card card-box",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('h4', {
    staticClass: "card-head"
  }, [_vm._v("Shop Specific Categories\r\n                  "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "18px"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_view = 'view_categories'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#777777",
      "line-height": "1.8"
    }
  }, [_vm._v("Add  your personal shop categories specific to\r\n                  your shop alone.\r\n                ")])]), _vm._v(" "), (_vm.set_view == 'view_custom') ? _c('div', [_c('hr'), _vm._v("\r\n                Add Category\r\n              ")]) : _vm._e()]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.set_view == 'view_general') ? _c('div', {
    staticClass: "card",
    staticStyle: {
      "border": "none"
    }
  }, [_c('div', {
    staticClass: "card card-box",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('h4', {
    staticClass: "card-head"
  }, [_vm._v("General Goods Store Categories\r\n                  "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "18px"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_view = 'view_general'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#777777",
      "line-height": "1.8"
    }
  }, [_vm._v("Add general goods categories by selecting products in that categories, This is \r\n                  specifically for shops that sells retail, wholesale general goods\r\n                ")])]), _vm._v(" "), (_vm.set_view == 'view_general') ? _c('div', {
    staticClass: "card card-box",
    staticStyle: {
      "margin-top": "-1em"
    }
  }, [_c('h4', {
    staticClass: "card-head",
    staticStyle: {
      "font-weight": "lighter"
    }
  }, [_vm._v("Select from these categories")]), _vm._v(" "), ((Object.keys(_vm.general_goods).length > 0)) ? _c('div', {
    key: _vm.componentKey
  }, _vm._l((_vm.general_goods), function(category, index) {
    return _c('div', {
      staticClass: "card card-box-fl"
    }, [_c('h5', [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setGeneralGoodsCategoryProducts(category)
        }
      }
    }, [_vm._v("\r\n                        " + _vm._s(category.category_name) + "\r\n                        "), _vm._m(1, true)])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })) : _vm._e()]) : _vm._e()]) : _vm._e()]) : _vm._e()])])])]), _vm._v(" "), (_vm.menu_tab_inner_view['general_goods_category_products']) ? _c('div', {
    staticStyle: {
      "display": "block",
      "position": "fixed",
      "width": "100%",
      "bottom": "4.6em",
      "background": "#ffffff",
      "z-index": "10000"
    },
    attrs: {
      "id": "xInfo"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', [_vm._v("Total Items selected")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.set_items_list.length))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "background-color": "rgb(41, 122, 245)",
      "border-radius": "18px",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.prepSetAddProductsInList()
      }
    }
  }, [_vm._v("\r\n          Add Category")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])
}]}

/***/ }),
/* 572 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.show_landing) ? _c('div', {
    staticClass: "main-wrap",
    staticStyle: {
      "background-color": "#fafafa"
    },
    attrs: {
      "id": "wrap"
    }
  }, [(((Object.keys(_vm.menu_tab_inner_view).length == 0) || (_vm.menu_tab_inner_view.length == 0) || (_vm.menu_tab_inner_view['']))) ? _c('div', {
    staticStyle: {
      "margin-bottom": "25em"
    }
  }, [_c('div', {
    key: _vm.headerComponentKey,
    staticClass: "header-wrap-sticky",
    staticStyle: {
      "z-index": "2"
    },
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pager",
    staticStyle: {
      "background-color": "none",
      "margin-top": "3.5em",
      "text-align": "left"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "background-color": "none"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container htro"
  }, [_c('h2', {
    staticClass: "ttro",
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "24px"
    }
  }, [_vm._v("\r\n                @ " + _vm._s(_vm.sellpoint.business_name) + "\r\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "container card",
    staticStyle: {
      "margin": "0",
      "padding": "1em",
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin-top": "-0.29em",
      "margin-left": "-0.8em",
      "color": "#000000"
    }
  }, [_c('ul', _vm._l((_vm.categories), function(data, index) {
    return _c('li', {
      staticClass: "card-col-2",
      staticStyle: {
        "background": "#ffffff",
        "border-radius": "5px"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "block",
        "padding": "5px 1em",
        "padding-bottom": "0"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(data.category_name) + " "), _c('br')])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container card",
    staticStyle: {
      "margin": "0",
      "padding": "1em",
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin-top": "-0.29em",
      "margin-left": "-0.8em",
      "color": "#000000"
    }
  }, [_c('ul', _vm._l((_vm.categories), function(data, index) {
    return _c('li', {
      staticClass: "card-col-2",
      staticStyle: {
        "background": "#ffffff",
        "border-radius": "5px"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "block",
        "padding": "5px 1em",
        "padding-bottom": "0"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(data.category_name) + " "), _c('br')])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])]), _vm._v(" "), _vm._l((_vm.categories), function(data, cindex) {
    return _c('div', {
      staticClass: "card",
      staticStyle: {
        "margin": "1.5em",
        "margin-top": "1.8em"
      }
    }, [_c('div', {
      staticStyle: {
        "border-radius": "1px",
        "border": "none",
        "margin": "0em",
        "margin-top": "1em"
      }
    }, [_c('h4', [_vm._v(_vm._s(data.category_name))]), _vm._v(" "), _c('div', {
      staticClass: "container",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "category-slide",
      staticStyle: {
        "border-radius": "1px",
        "border": "none",
        "margin-top": "-0.29em",
        "margin-left": "-0.8em",
        "color": "#000000"
      }
    }, [_c('ul', _vm._l((_vm.products), function(product, index) {
      return _c('li', [(Object.keys(product.product_images).length > 0) ? _c('div', {
        staticClass: "col-xs-12",
        staticStyle: {
          "margin": "0",
          "padding": "0.31em"
        }
      }, [_c('a', {
        staticClass: "card-link",
        on: {
          "click": function($event) {
            _vm.setProductView(product, index, product.product_items[0], 0)
          }
        }
      }, [_c('div', {
        staticClass: "card",
        staticStyle: {
          "padding": "0.2em",
          "margin-bottom": "1em"
        }
      }, [_c('div', {
        staticClass: "card-col-img",
        staticStyle: {
          "background-repeat": "no-repeat",
          "background-size": "cover"
        },
        style: ({
          'background-image': 'url(' + product.product_images[0].product_image + ')'
        })
      }), _vm._v(" "), _c('div', {
        staticClass: "card-details",
        staticStyle: {
          "z-index": "1",
          "height": "75px",
          "border-radius": "0 0 14px 14px",
          "background": "#ffffff",
          "padding": "1em",
          "padding-top": "0.6em"
        }
      }, [_c('div', {
        staticClass: "prd-name",
        staticStyle: {
          "font-size": "16px",
          "text-align": "left",
          "background": "#ffffff"
        }
      }, [_c('span', {
        staticStyle: {
          "float": "left"
        }
      }, [_c('span', [_c('b', [_vm._v(_vm._s(product.product_name))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])]), _vm._v(" "), _c('span', {
        staticStyle: {
          "float": "right",
          "display": "block"
        }
      }, [_c('div', {
        staticStyle: {
          "display": "none"
        }
      }, [_c('span', {
        staticStyle: {
          "display": "block"
        },
        attrs: {
          "id": 'prdQty' + index
        }
      }, [_c('button', {
        staticClass: "btn sp-button-02-lt",
        staticStyle: {
          "padding": "3px 3px",
          "line-height": "0.2"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setOrderQuantity(1, 1, 'sub', index, product.product_items[0], 0)
          }
        }
      }, [_c('span', {
        staticStyle: {
          "font-size": "38px"
        }
      }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
        staticStyle: {
          "padding": "0 0.61em"
        }
      }, [_vm._v(_vm._s(product.product_items[0].product_item_order_quantity))]), _vm._v(" "), _c('button', {
        staticClass: "btn sp-button-02-lt",
        staticStyle: {
          "padding": "3px 3px",
          "line-height": "0.6"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setOrderQuantity(1, 1, 'add', index, product.product_items[0], 0)
          }
        }
      }, [_c('span', {
        staticStyle: {
          "font-size": "28px"
        }
      }, [_vm._v("+")])])]), _vm._v(" "), (_vm.checkOrderItems(product.product_items[0])) ? _c('button', {
        staticClass: "btn sp-button-02-lt",
        staticStyle: {
          "padding": "3px 3px",
          "line-height": "0.6"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setAddOrderItems(1, product.product_items[0], index, 0);
            _vm.toggleSingleComponent('prdQty' + index)
          }
        }
      }, [_vm._m(0, true)]) : _c('button', {
        staticClass: "btn sp-button-02-lt",
        staticStyle: {
          "padding": "3px 3px",
          "line-height": "0.6",
          "border": "#d8d8d8 solid"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setAddOrderItems(1, product.product_items[0], index, 0);
            _vm.toggleSingleComponent('prdQty' + index)
          }
        }
      }, [_c('span', {
        staticStyle: {
          "font-size": "18px"
        }
      }, [_vm._v("  ")])])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "block"
        }
      }, [(_vm.checkProductOrderItems(product)) ? _c('button', {
        staticClass: "btn sp-button-02-lt",
        staticStyle: {
          "padding": "3px 3px",
          "line-height": "0.6"
        },
        attrs: {
          "type": "button"
        }
      }, [_vm._m(1, true)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      })])])])]) : _vm._e()])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "clear:both"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "clear:both"
    })])
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (_vm.shop_layout == 2) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container htro"
  }, [_c('h2', {
    staticClass: "ttro",
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "24px"
    }
  }, [_vm._v("\r\n                @ " + _vm._s(_vm.sellpoint.business_name) + "\r\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "container card",
    staticStyle: {
      "margin": "0",
      "padding": "1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin-top": "-0.29em",
      "margin-left": "-0.8em",
      "color": "#000000"
    }
  }, [_c('ul', _vm._l((_vm.categories), function(data, index) {
    return _c('li', {
      staticClass: "card-col-2",
      staticStyle: {
        "background": "#ffffff",
        "border-radius": "5px"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "block",
        "padding": "5px 1em",
        "padding-bottom": "0"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(data.category_name) + " "), _c('br')])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin": "1.5em",
      "margin-top": "-1.8em"
    }
  }, [_c('div', {
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin": "0em",
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, _vm._l((_vm.products), function(product, index) {
    return (Object.keys(product.product_images).length > 0) ? _c('div', {
      staticClass: "col-xs-6",
      staticStyle: {
        "margin": "0",
        "padding": "0.31em"
      }
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setProductView(product, index, product.product_items[0], 0)
        }
      }
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "padding": "0.2em",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "card-col-img",
      staticStyle: {
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      style: ({
        'background-image': 'url(' + product.product_images[0].product_image + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "card-details",
      staticStyle: {
        "z-index": "1",
        "height": "75px",
        "border-radius": "0 0 14px 14px",
        "background": "#ffffff",
        "padding": "1em",
        "padding-top": "0.6em"
      }
    }, [_c('div', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px",
        "text-align": "left",
        "background": "#ffffff"
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('span', [_c('b', [_vm._v(_vm._s(product.product_name))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "display": "block"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "none"
      }
    }, [_c('span', {
      staticStyle: {
        "display": "block"
      },
      attrs: {
        "id": 'prdQty' + index
      }
    }, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'sub', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(product.product_items[0].product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'add', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])])]), _vm._v(" "), (_vm.checkOrderItems(product.product_items[0])) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(1, product.product_items[0], index, 0);
          _vm.toggleSingleComponent('prdQty' + index)
        }
      }
    }, [_vm._m(2, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(1, product.product_items[0], index, 0);
          _vm.toggleSingleComponent('prdQty' + index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "block"
      }
    }, [(_vm.checkProductOrderItems(product)) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._m(3, true)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])])]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.shop_layout == 3) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container htro"
  }, [_c('h2', {
    staticClass: "ttro",
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "24px"
    }
  }, [_vm._v("\r\n                @ " + _vm._s(_vm.sellpoint.business_name) + "\r\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "container card",
    staticStyle: {
      "margin": "0",
      "padding": "1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin-top": "-0.29em",
      "margin-left": "-0.8em",
      "color": "#000000"
    }
  }, [_c('ul', _vm._l((_vm.categories), function(data, index) {
    return _c('li', {
      staticClass: "card-col-2",
      staticStyle: {
        "background": "#ffffff",
        "border-radius": "5px"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "block",
        "padding": "5px 1em",
        "padding-bottom": "0"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(data.category_name) + " "), _c('br')])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin": "1.5em",
      "margin-top": "-1.8em"
    }
  }, [_c('div', {
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin": "0em",
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "background-color": "#ffffff"
    }
  }, _vm._l((_vm.products), function(product, index) {
    return (Object.keys(product.product_images).length > 0) ? _c('div', {
      staticClass: "col-xs-4",
      staticStyle: {
        "margin": "0",
        "padding": "0.31em"
      }
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setProductView(product, index, product.product_items[0], 0)
        }
      }
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "padding": "0.2em",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "card-colxx",
      staticStyle: {
        "margin-bottom": "-1em",
        "z-index": "5",
        "background": "#ffffff",
        "border-radius": "14px"
      }
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "card-col-img",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-details",
      staticStyle: {
        "z-index": "1",
        "height": "75px",
        "border-radius": "0 0 14px 14px",
        "background": "#ffffff",
        "padding": "1em",
        "padding-top": "0.6em"
      }
    }, [_c('div', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px",
        "text-align": "left",
        "background": "#ffffff"
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('span', [_c('b', [_vm._v(_vm._s(product.product_name))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "display": "block"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "none"
      }
    }, [_c('span', {
      staticStyle: {
        "display": "block"
      },
      attrs: {
        "id": 'prdQty' + index
      }
    }, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'sub', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(product.product_items[0].product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'add', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])])]), _vm._v(" "), (_vm.checkOrderItems(product.product_items[0])) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(1, product.product_items[0], index, 0);
          _vm.toggleSingleComponent('prdQty' + index)
        }
      }
    }, [_vm._m(4, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(1, product.product_items[0], index, 0);
          _vm.toggleSingleComponent('prdQty' + index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "block"
      }
    }, [(_vm.checkProductOrderItems(product)) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(1, product.product_items[0], index, 0);
        }
      }
    }, [_vm._m(5, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(1, product.product_items[0], index, 0);
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])])]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e()])]), _vm._v(" "), (_vm.set_order_list.length == 0) ? _c('component-footer') : _vm._e()], 1) : (_vm.menu_tab_inner_view['addToList']) ? _c('div', {
    staticStyle: {
      "margin-bottom": "25em"
    }
  }, [(_vm.product && (Object.keys(_vm.product).length > 0)) ? _c('div', {
    staticClass: "container",
    staticStyle: {
      "background-color": "#ffffff",
      "margin-top": "3em"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#000000",
      "padding": "0.6em 0.8em",
      "font-size": "28px"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin": "0",
      "margin-bottom": "15em",
      "padding": "1em"
    }
  }, [_c('div', {
    staticClass: "card x-img-bg",
    staticStyle: {
      "background-repeat": "no-repeat",
      "background-size": "contain"
    },
    style: ({
      'background-image': 'url(' + _vm.product.product_images[0].product_image + ')'
    }),
    attrs: {
      "id": "dbgg"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pLess"
    }
  }, [_c('span', {
    staticClass: "max-lines"
  }, [_vm._v("Create stunning Food Delivery App designed by Lena Smirnova. \r\n              Connect with them on Dribbble; the global community for designers and \r\n              creative professionals. Create stunning Food Delivery App designed by Lena Smirnova. \r\n              Connect with them on Dribbble; the global community for designers and \r\n              creative professionals. \r\n              Create stunning Food Delivery App designed by Lena Smirnova. \r\n              Connect with them on Dribbble; the global community for designers and \r\n              creative professionals. Create stunning Food Delivery App designed by Lena Smirnova. \r\n              Connect with them on Dribbble; the global community for designers and \r\n              creative professionals.")]), _vm._v(".."), _c('a', {
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('pMore', 'pLess')
      }
    }
  }, [_vm._v("more")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "pMore"
    }
  }, [_vm._v("A Create stunning Food Delivery App designed by Lena Smirnova. \r\n                Connect with them on Dribbble; the global community for designers and \r\n                creative professionals. Create stunning Food Delivery App designed by Lena Smirnova. \r\n                Connect with them on Dribbble; the global community for designers and \r\n                creative professionals. \r\n                Create stunning Food Delivery App designed by Lena Smirnova. \r\n                Connect with them on Dribbble; the global community for designers and \r\n                creative professionals. Create stunning Food Delivery App designed by Lena Smirnova. \r\n                Connect with them on Dribbble; the global community for designers and \r\n                creative professionals...."), _c('a', {
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('pMore', 'pLess')
      }
    }
  }, [_vm._v("less")])])]), _vm._v(" "), (_vm.product.product_items && (Object.keys(_vm.product.product_items).length > 1)) ? _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-bottom": "15em"
    }
  }, [_c('h4', [_vm._v("Please select from (" + _vm._s(_vm.product.product_items.length) + ") below options")]), _vm._v(" "), _vm._l((_vm.product.product_items), function(item, product_item_index) {
    return _c('div', {}, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setProductItem(item, product_item_index);
        }
      }
    }, [_c('div', {
      staticClass: "card col-xs-4 mp0",
      staticStyle: {
        "margin-bottom": "1em",
        "padding": "1em 0.5em",
        "border": "1px solid #eee",
        "border-radius": "3px"
      }
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      key: _vm.componentKey,
      staticClass: "card"
    }, [(_vm.checkOrderItems(item)) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._m(6, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])]), _vm._v(" "), _c('p', [(product_item_index == 0) ? _c('span', [_c('b', [_vm._v("Main")])]) : _c('span', [_vm._v(_vm._s(item.product_item_service_tag))])]), _vm._v(" "), _c('p', [_vm._v("₦‎" + _vm._s(item.product_item_price_f))])])])])])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "border": "none",
      "width": "90%",
      "bottom": "5em",
      "z-index": "7"
    }
  }, [(_vm.product_item && (Object.keys(_vm.product_item).length > 0)) ? _c('div', {
    staticClass: "container",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', [((Object.keys(_vm.product.product_items).length == 1)) ? _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "background-color": "#eee",
      "border-radius": "45px 45px 45px 45px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddOrderItems(1, _vm.product_item, _vm.product_index, _vm.product_item_index);
        _vm.setMenuTabInnerView('');
      }
    }
  }, [_vm._v("Add to List")]) : _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "background-color": "#eee",
      "border-radius": "45px 45px 45px 45px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Add to List")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), ((_vm.product.product_images && (_vm.product.product_images.length > 0)) && (_vm.product.product_images[0].product_image != '' && _vm.product.product_images[0].product_image != 'error')) ? _c('img', {
    key: _vm.componentKey,
    staticClass: "pb_img",
    staticStyle: {
      "z-index": "1",
      "opacity": "0"
    },
    attrs: {
      "id": "xmg",
      "src": _vm.img_product_url + _vm.product.product_images[0].product_image,
      "alt": ""
    }
  }) : _vm._e()]) : _vm._e()]) : (_vm.menu_tab_inner_view['processOrder']) ? _c('div', {
    staticStyle: {
      "margin-bottom": "25em"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "background-color": "#ffffff",
      "margin-top": "3em"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "#000000",
      "padding": "0.6em 0.8em",
      "font-size": "28px"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._m(7), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "0 1em",
      "margin-bottom": "5em"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#000000",
      "padding": "0.6em 0.8em",
      "font-size": "28px"
    },
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setOrderAddons'
      }
    }
  }, [_vm._v("Proceed")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#000000",
      "padding": "0.6em 0.8em",
      "font-size": "28px"
    },
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setOrderCheckout'
      }
    }
  }, [_vm._v("Checkout")]), _vm._v(" "), (_vm.set_view_box == '') ? _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Order List")]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.set_order_list), function(item, index) {
    return _c('div', {
      staticClass: "col-xs-12 mp0 card-row-box"
    }, [_c('div', {
      staticClass: "col-xs-2 mp0"
    }, [_c('div', {
      staticStyle: {
        "height": "80px",
        "margin": "0",
        "padding": "0",
        "margin-right": "0"
      }
    }, [(item.product_item_group_image && (item.product_item_group_image != '')) ? _c('img', {
      staticClass: "card-img",
      attrs: {
        "src": item.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "card-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10 mp0"
    }, [_c('div', {
      staticClass: "col-xs-7",
      staticStyle: {
        "padding": "3px",
        "padding-left": "8px",
        "margin": "0",
        "text-align": "left"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(item.product_name) + " "), _c('br'), _vm._v(" "), ((item.product_item_service_tag != '') && (item.product_item_service_tag != 'Nill')) ? _c('span', [_vm._v(_vm._s(item.product_item_service_tag)), _c('br')]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "sm-x",
      staticStyle: {
        "color": "#ff0000",
        "font-weight": "600"
      }
    }, [_vm._v("₦‎" + _vm._s(item.product_item_price_f))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-5",
      staticStyle: {
        "margin": "0",
        "padding": "0",
        "width": "39.87%"
      }
    }, [_c('div', {}, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 2, 'sub', 0, item, index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(item.product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 2, 'add', 0, item, index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])]), _vm._v(" "), (_vm.checkOrderItems(item)) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(2, item, 0, index)
        }
      }
    }, [_vm._m(8, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(2, item, 0, index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 mp0",
      staticStyle: {
        "display": "none"
      }
    }, [_c('div', {
      staticClass: "category-slide",
      staticStyle: {
        "margin-top": "0"
      }
    }, [((Object.keys(item.product_order_options).length > 0)) ? _c('ul', {
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setProductOrderOptions(index, item, item.product_order_options)
        }
      }
    }, _vm._l((item.product_order_options), function(item, index) {
      return (index < 3) ? _c('li', [_c('div', {
        staticClass: "card",
        staticStyle: {
          "margin-bottom": "1em"
        }
      }, [_c('div', {
        staticClass: "card-avatar-circle",
        staticStyle: {
          "width": "35px",
          "height": "35px"
        }
      }, [(item.product_info_set_image && (item.product_info_set_image != '')) ? _c('img', {
        staticClass: "img-responsive",
        attrs: {
          "src": item.product_info_set_image
        }
      }) : _c('img', {
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })]), _vm._v(" "), _vm._m(9, true), _vm._v(" "), _c('div', {
        staticClass: "card-col-details",
        staticStyle: {
          "display": "block",
          "padding": "3px",
          "text-align": "center"
        }
      }, [_c('p', {
        staticClass: "prd-name",
        staticStyle: {
          "font-size": "16px"
        }
      }, [_vm._v(_vm._s(item.product_info_set_name) + " "), _c('br'), _vm._v(" "), (item.product_info_set_cost > 0) ? _c('span', {
        staticClass: "sm-x"
      }, [_vm._v("₦‎" + _vm._s(item.product_info_set_cost))]) : _vm._e()])])])]) : _vm._e()
    }))]) : _vm._e()])])])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setOrderAddons') ? _c('div', {
    staticClass: "row"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "0"
    }
  }, _vm._l((_vm.set_order_addons), function(product, index) {
    return _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "col-xs-2 card-avatar-square",
      staticStyle: {
        "width": "80px",
        "height": "80px",
        "margin": "0",
        "padding": "0",
        "margin-right": "0"
      }
    }, [(product.product_images && (Object.keys(product.product_images).length > 0)) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4",
      staticStyle: {
        "padding": "3px",
        "padding-left": "8px",
        "margin": "0",
        "text-align": "left"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_c('b', [_vm._v("Add ")]), _vm._v(_vm._s(product.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x",
      staticStyle: {
        "color": "#ff0000",
        "font-weight": "600"
      }
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-5",
      staticStyle: {
        "margin": "0",
        "padding": "0",
        "width": "39.87%"
      }
    }, [_c('div', {}, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 3, 'sub', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(product.product_items[0].product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 3, 'add', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])]), _vm._v(" "), (_vm.checkOrderItems(product.product_items[0])) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(3, product.product_items[0], index, 0)
        }
      }
    }, [_vm._m(11, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(3, product.product_items[0], index, 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])])])])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setOrderCheckout') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setOrderCheckout"
    }
  }, [(_vm.set_view_box == 'setOrderCheckout') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setDeliveryLocation"
    }
  }, [(Object.keys(_vm.business_delivery_locations).length > 0) ? _c('div', [_vm._m(12), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-1em"
    }
  }, [_vm._l((_vm.business_delivery_locations), function(location, index) {
    return _c('div', [_c('p', [_c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.set_order_delivery_location),
        expression: "set_order_delivery_location"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": location.business_delivery_option_id,
        "checked": _vm._q(_vm.set_order_delivery_location, location.business_delivery_option_id)
      },
      on: {
        "click": function($event) {
          _vm.setOrderDeliveryLocation(location)
        },
        "__c": function($event) {
          _vm.set_order_delivery_location = location.business_delivery_option_id
        }
      }
    })]), _vm._v("\r\n                    " + _vm._s(location.business_delivery_state) + " - " + _vm._s(location.business_delivery_option) + " - " + _vm._s(location.business_delivery_option_price) + "\r\n                  ")])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setOrderCheckout') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setContactDetails"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Order Contact Details")]), _vm._v(" "), (_vm.agent_is_active && (_vm.agent_is_active == 1)) ? _c('p', [_vm._v("\r\n                Provide Order Contact details\r\n              ")]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.menu_tab_inner_view['showUserDetails']) ? _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.user.user_name))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.user.user_email))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.user.user_phone))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivery Address: ")]), _vm._v(_vm._s(_vm.user.user_order_delivey_address))]), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Reset")])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('showUserDetails')
      }
    }
  }, [_vm._v("Ok")])])])]), _vm._v(" "), (_vm.user.user_id && (_vm.user.user_id > 0)) ? _c('div', [_c('p', [_vm._v("Review contact details")]), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.user.user_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.user.user_email))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.user.user_phone))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivety Address: ")]), _vm._v(_vm._s(_vm.user.user_order_delivey_address))]), _vm._v(" "), _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), ((_vm.set_payment_mode == 1) && (_vm.user.user_email == '')) ? _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setOrderCheckout') ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "setPaymentOptions"
    }
  }, [_c('div', [_vm._m(13), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Payment Method")]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_payment_mode),
      expression: "set_payment_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.set_payment_mode, "4")
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('payBank')
      },
      "__c": function($event) {
        _vm.set_payment_mode = "4"
      }
    }
  })]), _vm._v("\r\n                    Pay to Bank")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "payBank"
    }
  }, [_vm._m(14), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Bank: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account Name: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_account_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account Number: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_account_number))])])])]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_payment_mode),
      expression: "set_payment_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.set_payment_mode, "1")
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('payDirect')
      },
      "__c": function($event) {
        _vm.set_payment_mode = "1"
      }
    }
  })]), _vm._v("\r\n                    Pay to Direct")]), _vm._v(" "), _vm._m(15)]), _vm._v(" "), _c('div', [(_vm.data_processing_messages.mode_err) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_messages.mode_err))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.setMakeOrder(_vm.set_payment_mode)
      }
    }
  }, [_vm._v("Place Order")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', [_c('div', {
    staticClass: "card"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "card-right",
    staticStyle: {
      "margin-top": "-1.4em"
    }
  }, [_c('p', [_vm._v("Send Shopping List to "), _c('b', [_vm._v(_vm._s(_vm.sellpoint.business_name))])]), _vm._v(" "), _c('div', [(_vm.data_processing_messages.mode_err) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_messages.mode_err))]) : _vm._e(), _vm._v(" "), (_vm.agent_is_active && (_vm.agent_is_active == 1)) ? _c('div', [_c('h5', [_vm._v("Agent Service Order")]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    on: {
      "click": function($event) {
        _vm.customSetAgentServices(5, 5)
      }
    }
  }, [_vm._v("Continue")])]) : _c('div', [_c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.setMakeOrder(1)
      }
    }
  }, [_vm._v("Send Shopping List")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })])])])]) : _vm._e()])])]) : (_vm.menu_tab_inner_view['showOrderPaymentConfirmation']) ? _c('div', [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "setPaymentSuccess"
    }
  }, [_c('p', [_vm._v("Payment Made")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn card-link",
    attrs: {
      "href": '/placed/order/' + _vm.order.order_no
    }
  }, [_vm._v("View Order")])])]) : _vm._e(), _vm._v(" "), (_vm.set_order_list.length > 0) ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "border": "none",
      "width": "100%",
      "bottom": "0",
      "margin": "0",
      "padding": "0 2em",
      "padding-top": "1.2em",
      "padding-right": "0",
      "background": "#ffffff",
      "z-index": "1"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "block",
      "width": "100%",
      "height": "4em",
      "padding": "0.1em",
      "background-color": "rgba(0, 0, 0, 0)",
      "border-top": "none",
      "border-radius": "45px 45px 0px 0px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "x-totals"
  }, [(_vm.set_order_total_amount && (_vm.set_order_total_amount > 0)) ? _c('h3', [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.set_order_total_amount)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "x-cta-btn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('processOrder');
      }
    }
  }, [_vm._v("Order Now>>")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000",
      "width": "100%",
      "margin-left": "-0.11em"
    },
    attrs: {
      "id": "infoBox"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {}
    }
  }, [_c('span', {
    staticClass: "s-backdrop88"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "max-height": "60vh",
      "overflow": "scroll",
      "bottom": "20vh",
      "margin": "0 -1.2em",
      "background": "#ffffff",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticClass: "z-box",
    staticStyle: {
      "width": "100%",
      "padding": "0.1em",
      "border-radius": "35px 35px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "60vh",
      "padding": "2em",
      "text-align": "left"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('infoBox')
      }
    }
  }, [_vm._m(18), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em",
      "margin-bottom": "5em"
    }
  }, [(_vm.set_view_box_2 == 'setProductOrderOptions') ? _c('div', {
    key: _vm.componentKey,
    staticClass: "row"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "0"
    }
  }, _vm._l((_vm.set_order_list[_vm.set_order_options_item_index].product_order_options), function(option, index) {
    return _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "col-xs-2 card-avatar-square",
      staticStyle: {
        "width": "80px",
        "height": "80px",
        "margin": "0",
        "padding": "0",
        "margin-right": "0"
      }
    }, [(option.product_info_set_image && (option.product_info_set_image != '')) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": option.product_info_set_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4",
      staticStyle: {
        "padding": "3px",
        "padding-left": "8px",
        "margin": "0",
        "text-align": "left"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(option.product_info_set_name) + " "), _c('br'), _vm._v(" "), (option.product_info_set_cost > 0) ? _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(option.product_info_set_cost))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-5",
      staticStyle: {
        "margin": "0",
        "padding": "0",
        "width": "39.87%"
      }
    }, [_c('div', [_c('a', {
      staticStyle: {
        "margin-top": "-15em"
      },
      on: {
        "click": function($event) {
          _vm.setItemProductOrderOptions(option, index, _vm.product_item, _vm.set_order_options_item_index)
        }
      }
    }, [_vm._v("x")]), _vm._v("bb\r\n                        ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(option.set_status))])])])])
  }))]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), (_vm.product && (Object.keys(_vm.product).length > 0)) ? _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000",
      "width": "100%",
      "margin-left": "0"
    },
    attrs: {
      "id": "productBox"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {}
    }
  }, [_c('span', {
    staticClass: "s-backdrop88"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "90%",
      "max-height": "90vh",
      "overflow": "scroll",
      "bottom": "5vh",
      "margin": "0",
      "margin-left": "0.5em",
      "border-radius": "14px",
      "background": "#ffffff",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticClass: "z-box",
    staticStyle: {
      "width": "100%",
      "border-radius": "35px 35px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "60vh",
      "text-align": "left",
      "overflow": "scroll"
    }
  }, [_c('div', {
    staticClass: "card x-img-bg",
    staticStyle: {
      "background-repeat": "no-repeat",
      "background-size": "contain"
    },
    style: ({
      'background-image': 'url(' + _vm.product.product_images[0].product_image + ')'
    }),
    attrs: {
      "id": "dbgg"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('productBox')
      }
    }
  }, [_vm._m(20), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em",
      "background-color": "#eee",
      "color": "#000000",
      "border-radius": "50%"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin": "0",
      "margin-bottom": "15em",
      "padding": "1em"
    }
  }, [_c('div', {
    staticClass: "card x-img-bg",
    staticStyle: {
      "background-repeat": "no-repeat",
      "background-size": "contain"
    },
    style: ({
      'background-image': 'url(' + _vm.product.product_images[0].product_image + ')'
    }),
    attrs: {
      "id": "dbgg"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pLess"
    }
  }, [_c('span', {
    staticClass: "max-lines"
  }, [_vm._v("Create stunning Food Delivery App designed by Lena Smirnova. \r\n                Connect with them on Dribbble; the global community for designers and \r\n                creative professionals. Create stunning Food Delivery App designed by Lena Smirnova. \r\n                Connect with them on Dribbble; the global community for designers and \r\n                creative professionals. \r\n                Create stunning Food Delivery App designed by Lena Smirnova. \r\n                Connect with them on Dribbble; the global community for designers and \r\n                creative professionals. Create stunning Food Delivery App designed by Lena Smirnova. \r\n                Connect with them on Dribbble; the global community for designers and \r\n                creative professionals.")]), _vm._v(".."), _c('a', {
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('pMore', 'pLess')
      }
    }
  }, [_vm._v("more")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "pMore"
    }
  }, [_vm._v("A Create stunning Food Delivery App designed by Lena Smirnova. \r\n                  Connect with them on Dribbble; the global community for designers and \r\n                  creative professionals. Create stunning Food Delivery App designed by Lena Smirnova. \r\n                  Connect with them on Dribbble; the global community for designers and \r\n                  creative professionals. \r\n                  Create stunning Food Delivery App designed by Lena Smirnova. \r\n                  Connect with them on Dribbble; the global community for designers and \r\n                  creative professionals. Create stunning Food Delivery App designed by Lena Smirnova. \r\n                  Connect with them on Dribbble; the global community for designers and \r\n                  creative professionals...."), _c('a', {
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('pMore', 'pLess')
      }
    }
  }, [_vm._v("less")])])]), _vm._v(" "), (_vm.product.product_items && (Object.keys(_vm.product.product_items).length > 0)) ? _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-bottom": "15em"
    }
  }, [_c('h4', [_vm._v("Please select from (" + _vm._s(_vm.product.product_items.length) + ") below options")]), _vm._v(" "), _vm._l((_vm.product.product_items), function(item, product_item_index) {
    return _c('div', {}, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setProductItem(item, product_item_index);
        }
      }
    }, [_c('div', {
      staticClass: "card col-xs-12 mp0",
      staticStyle: {
        "margin-bottom": "1em",
        "padding": "1em 0.5em",
        "border": "1px solid #eee",
        "border-radius": "3px"
      }
    }, [_c('div', {
      staticClass: "col-xs-1 mp0"
    }, [(_vm.checkOrderItems(item)) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._m(21, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8"
    }, [_c('p', [(product_item_index == 0) ? _c('span', [_c('b', [_vm._v("Main")])]) : _c('span', [_vm._v(_vm._s(item.product_item_service_tag))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 mp0"
    }, [_c('p', [_vm._v("₦‎" + _vm._s(item.product_item_price_f))])])])])])
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.checkProductOrderItems(_vm.product)) ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "border": "none",
      "width": "90%",
      "margin-left": "-1.2em",
      "bottom": "3.4em",
      "background-color": "#eee",
      "border-top": "#eee solid 1px",
      "z-index": "1",
      "border-radius": "45px 45px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "block",
      "width": "100%",
      "height": "4em",
      "padding": "0.1em",
      "background-color": "rgba(0, 0, 0, 0)",
      "border-top": "none",
      "border-radius": "45px 45px 0px 0px"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [(_vm.set_order_total_amount && (_vm.set_order_total_amount > 0)) ? _c('h3', [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.set_order_total_amount)))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "display": "block"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('p', [_c('span', {
    attrs: {
      "id": 'prdQty' + _vm.product_index
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.2"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderQuantity(1, 1, 'sub', _vm.product_index, _vm.product_item, _vm.product_item_index)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "38px"
    }
  }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0 0.61em"
    }
  }, [_vm._v(_vm._s(_vm.product_item.product_item_order_quantity))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.6"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderQuantity(1, 1, 'add', _vm.product_index, _vm.product_item, _vm.product_item_index)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "28px"
    }
  }, [_vm._v("+")])])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [(_vm.checkOrderItems(_vm.product_item)) ? _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.6"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddOrderItems(1, _vm.product_item, _vm.product_index, _vm.product_item_index);
        _vm.toggleSingleComponent('prdQty' + _vm.product_index)
      }
    }
  }, [_vm._m(22)]) : _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.6",
      "border": "#d8d8d8 solid"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddOrderItems(1, _vm.product_item, _vm.product_index, _vm.product_item_index);
        _vm.toggleSingleComponent('prdQty' + _vm.product_index)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("  ")])])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.6",
      "border": "#d8d8d8 solid"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('productBox')
      }
    }
  }, [_vm._m(23)])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]) : _vm._e(), _vm._v(" "), ((_vm.product.product_images && (_vm.product.product_images.length > 0)) && (_vm.product.product_images[0].product_image != '' && _vm.product.product_images[0].product_image != 'error')) ? _c('img', {
    key: _vm.componentKey,
    staticClass: "pb_img",
    staticStyle: {
      "opacity": "0"
    },
    attrs: {
      "id": "xmg",
      "src": _vm.img_product_url + _vm.product.product_images[0].product_image,
      "alt": ""
    }
  }) : _vm._e()])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "display": "none",
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticStyle: {
      "margin-top": "-15em"
    }
  }, [_vm._v("x")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', {
    staticStyle: {
      "line-height": "1.2"
    }
  }, [_vm._v("Add to Order"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "0.05em",
      "font-size": "13px"
    }
  }, [_vm._v("items you should buy with this order")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-shopping-bag",
    staticStyle: {
      "font-size": "3em"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-right",
    staticStyle: {
      "margin-top": "-1.4em"
    }
  }, [_c('h3', [_vm._v("Delivery Locations")]), _vm._v(" "), _c('p', [_vm._v("set where you want this order delivered to")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-shopping-bag",
    staticStyle: {
      "font-size": "3em"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-right",
    staticStyle: {
      "margin-top": "-1.4em"
    }
  }, [_c('h3', [_vm._v("Payment")]), _vm._v(" "), _c('p', [_vm._v("set where you want this order delivered to")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Send to:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "payDirect"
    }
  }, [_c('p', [_vm._v("Pay with your Credit/ATM card")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-shopping-bag",
    staticStyle: {
      "font-size": "3em"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Service Charge: ")]), _vm._v("500")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "display": "none",
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', {
    staticStyle: {
      "line-height": "1.2"
    }
  }, [_vm._v("Order Options"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "0.05em",
      "font-size": "13px"
    }
  }, [_vm._v("Remove items you don't want included in an order")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "display": "none",
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  })])
}]}

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/favicon-o.png"
    }
  })])
}]}

/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "0em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "sp1-reg",
    staticStyle: {
      "background": "#ffffff",
      "padding": "0.82em",
      "padding-top": "0",
      "border-radius": "2px"
    }
  }, [_c('div', [_c('a', {
    staticClass: "header-nav-back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "16px",
      "color": "#000000"
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('div', [_vm._m(0)]) : _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "register"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("send, share and sell")]), _vm._v(" "), _c('form', {
    staticClass: "form-inline",
    attrs: {
      "name": "registration_form",
      "id": "registration_form"
    }
  }, [_c('div', {
    staticClass: "card card-colord-pad card-colord-01 card-box"
  }, [_c('div', {
    staticClass: "card-top",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "viewSetOrderDetails"
    }
  }, [_c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h4', [_vm._v("Order details")]), _vm._v(" "), _c('p', [_vm._v("Name, Price and Details")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn sp-button-02-alt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('setOrderDetails', 'viewSetOrderDetails')
      }
    }
  }, [_vm._v("Add")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "checkbox",
      "checked": "set_checked('setOrderDetails')"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('setOrderDetails');
        _vm.set_checked('setOrderDetails')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "setOrderDetails"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Price")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_price),
      expression: "product.product_price"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "number",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.product.product_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Details")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('setOrderDetails', 'viewSetOrderDetails')
      }
    }
  }, [_vm._v("Done")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Product Photo ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "prImagePreview"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sp-form-descr"
  }, [_vm._v("Maximum Upload Size " + _vm._s(_vm.max_upload))]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Upload Display "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.is_product_service))]), _vm._v(" Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeNewProduct($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), (Object.keys(_vm.sellpoint).length == 0) ? _c('div', [_c('h3', [_vm._v("Contact Details")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_name),
      expression: "sellpoint.business_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.sellpoint.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_phone),
      expression: "sellpoint.business_phone"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.sellpoint.business_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_email),
      expression: "sellpoint.business_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.sellpoint.business_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_email = $event.target.value
      }
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v("Order Types and Options")]), _vm._v(" "), _c('p', [_vm._v("Different options that can be selected for this order . eg:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "display": "block"
    }
  }, [_c('li', [_vm._v("Chicken large portion - \r\n                            "), (_vm.product.product_price && (Number(_vm.product.product_price) > 0)) ? _c('span', [_vm._v(" ₦‎" + _vm._s(_vm.formatCurrency_2(Number(Number(_vm.product.product_price) + 750))))]) : _c('span', [_vm._v("Total Cost")])]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Beef only:  - \r\n                            "), (_vm.product.product_price && (Number(_vm.product.product_price) > 0)) ? _c('span', [_vm._v(" ₦‎" + _vm._s(_vm.formatCurrency_2(Number(Number(_vm.product.product_price) + 1750))))]) : _c('span', [_vm._v("Total Cost")])]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Fish Tail side - \r\n                            "), (_vm.product.product_price && (Number(_vm.product.product_price) > 0)) ? _c('span', [_vm._v(" ₦‎" + _vm._s(_vm.formatCurrency_2(Number(Number(_vm.product.product_price) + 850))))]) : _c('span', [_vm._v("Total Cost")])]), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, _vm._l((_vm.product_set_items), function(d) {
    return _c('p', [_vm._v(_vm._s(d.name) + " - " + _vm._s(d.amount) + " "), _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.removeOrderProductItemsOptions(d)
        }
      }
    }, [_vm._v("xx")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Option")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_item.name),
      expression: "product_item.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product_item.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_item.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Total Cost")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_item.amount),
      expression: "product_item.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product_item.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_item.amount = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn sp-button-02-lt",
    on: {
      "click": function($event) {
        _vm.setAddOrderProductItemsOptions(_vm.product_item)
      }
    }
  }, [_vm._v("Add")])]), _vm._v(" "), ((Object.keys(_vm.products).length > 0)) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "card col-xs-4"
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + _vm.user.business_username
      }
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "card-avatar-square",
      staticStyle: {
        "width": "100px",
        "height": "95px"
      }
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block",
        "padding": "3px",
        "padding-left": "2em",
        "text-align": "center"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(product.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setAddToProductAddons(product)
        }
      }
    })])])])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px",
      "display": "none"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-sm",
    staticStyle: {
      "float": "right",
      "background": "#ff0066",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.addToProductAddons()
      }
    }
  }, [_vm._v("Done, Add Products to Add-ons")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Order Extras")]), _vm._v(" "), _c('p', [_vm._v("What is in your order that can be removed, can be ordered without... eg. onions, vegetable ...")]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, _vm._l((_vm.product_set_details), function(d) {
    return _c('p', [_vm._v(_vm._s(d.set_name) + " "), _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.removeProductOrderOptions(d)
        }
      }
    }, [_vm._v("xx")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name of Item")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_detail.set_name),
      expression: "set_detail.set_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.set_detail.set_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.set_detail.set_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Cost")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_detail.set_cost),
      expression: "set_detail.set_cost"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.set_detail.set_cost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.set_detail.set_cost = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn sp-button-02-lt",
    on: {
      "click": function($event) {
        _vm.setAddProductOrderOptions(_vm.set_detail)
      }
    }
  }, [_vm._v("Add")])]), _vm._v(" "), ((Object.keys(_vm.products).length > 0)) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "card col-xs-4"
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + _vm.user.business_username
      }
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "card-avatar-square",
      staticStyle: {
        "width": "100px",
        "height": "95px"
      }
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block",
        "padding": "3px",
        "padding-left": "2em",
        "text-align": "center"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(product.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setAddToProductAddons(product)
        }
      }
    })])])])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px",
      "display": "none"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-sm",
    staticStyle: {
      "float": "right",
      "background": "#ff0066",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.addToProductAddons()
      }
    }
  }, [_vm._v("Done, Add Products to Add-ons")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])], 2) : _vm._e()]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#43a1fa"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createOrder
    }
  }, [_vm._v("Create")])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("Create your order "), _c('br'), _vm._v(" for purchases")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(You can always add more images or video on this post)")])])
}]}

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _c('div', [(_vm.products && (Object.keys(_vm.products).length > 0)) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h6', [_vm._v("You have "), _c('b', [_vm._v(_vm._s(_vm.products.length))]), _vm._v(" product(s) in your shop")]), _vm._v(" "), _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "card col-xs-4 card-col-2",
      staticStyle: {
        "margin-bottom": "2.2em"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setProduct(product)
        }
      }
    }, [_c('div', {
      staticClass: "card-col-img"
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "max-height": "8em"
      },
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block",
        "padding": "3px"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticClass: "sp-app-default-color",
      staticStyle: {
        "font-weight": "bolder"
      }
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Stock: ")]), _vm._v(_vm._s(product.product_items[0].product_item_quantity))])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2) : _c('div', [_vm._m(1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em",
      "margin-left": "1,2em"
    }
  }, [(_vm.categories && (Object.keys(_vm.categories).length == 0)) ? _c('div', [_c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "href": "/account/business/newcategory"
    }
  }, [_vm._v("Add New Category to add products")])]) : _c('div', [_c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "href": "/account/business/categories"
    }
  }, [_vm._v("Add New Product")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticStyle: {
      "color": "#e94b4b"
    }
  }, [_vm._v("You have not added any Product yet")])])
}]}

/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _c('div', {
    key: _vm.componentKey,
    staticClass: "detail-card"
  }, [_c('h6', {
    staticStyle: {
      "margin-left": "1px"
    }
  }, [_vm._v("Store Rewards ")]), _vm._v(" "), _vm._l((_vm.sellpoint.reward_settings), function(reward_type) {
    return _c('div', {
      key: reward_type.reward_type_id
    }, [((reward_type.reward_type_id == 2)) ? _c('div', [_c('p', [_c('b', [_vm._v(_vm._s(reward_type.reward_type_name) + " Reward")])]), _vm._v(" "), _c('p', {
      staticClass: "p-tiny-info"
    }, [_vm._v(_vm._s(reward_type.reward_type_descr))]), _vm._v(" "), (reward_type.reward_type_is_set) ? _c('div', [_c('a', {
      staticClass: "btn sp-button-02 sp-button-sm",
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('edit' + reward_type.reward_type_name + reward_type.reward_type_id)
        }
      }
    }, [_vm._v("Edit")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Reward: \n                        "), (reward_type.reward_type_setting.reward_set_amount_type == 'C') ? _c('span', [_vm._v("₦")]) : _vm._e(), (reward_type.reward_type_setting.reward_set_amount) ? _c('span', [_vm._v(_vm._s(reward_type.reward_type_setting.reward_set_amount))]) : _vm._e(), _vm._v(" "), (reward_type.reward_type_setting.reward_set_amount_type == 'P') ? _c('span', [_vm._v("%")]) : _vm._e()])])]) : _c('div', [_c('a', {
      staticClass: "btn sp-button-02 sp-button-sm",
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('set' + reward_type.reward_type_name + reward_type.reward_type_id)
        }
      }
    }, [_vm._v("SET")]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "13px"
      }
    }, [_vm._v("No reward set")])]), _vm._v(" "), (_vm.menu_tab_inner_view['set' + reward_type.reward_type_name + reward_type.reward_type_id] || _vm.menu_tab_inner_view['edit' + reward_type.reward_type_name + reward_type.reward_type_id]) ? _c('div', [_c('h6', {
      staticClass: "margin-t-40"
    }, [_vm._v("Set a Reward for " + _vm._s(reward_type.reward_type_name) + " ")]), _vm._v(" "), _c('form', {
      staticClass: "sp-form",
      staticStyle: {
        "padding-left": "0"
      }
    }, [_c('label', [_c('b', [_vm._v("Reward Amount: "), (reward_type.reward_type_setting.reward_set_amount) ? _c('span', [_vm._v(_vm._s(reward_type.reward_type_setting.reward_set_amount))]) : _vm._e()]), _vm._v(" "), (_vm.menu_tab_inner_view['set' + reward_type.reward_type_name + reward_type.reward_type_id]) ? _c('div', {
      staticStyle: {
        "display": "flex",
        "flex-flow": "row wrap",
        "align-items": "center"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.business_details.set_reward_type_amount),
        expression: "business_details.set_reward_type_amount"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "25%",
        "margin-right": "5px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.business_details.set_reward_type_amount)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.business_details.set_reward_type_amount = $event.target.value
        }
      }
    }), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.set_reward_type_amount_type),
        expression: "set_reward_type_amount_type"
      }],
      staticClass: "sp-form-select form-control",
      staticStyle: {
        "width": "45%"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.set_reward_type_amount_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "P"
      }
    }, [_vm._v("% (percentage)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "C"
      }
    }, [_vm._v("₦ (cash)")])])]) : _c('div', {
      staticStyle: {
        "display": "flex",
        "flex-flow": "row wrap",
        "align-items": "center"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (reward_type.reward_type_setting.reward_set_amount),
        expression: "reward_type.reward_type_setting.reward_set_amount"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "25%",
        "margin-right": "5px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (reward_type.reward_type_setting.reward_set_amount)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          reward_type.reward_type_setting.reward_set_amount = $event.target.value
        }
      }
    }), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (reward_type.reward_type_setting.reward_set_amount_type),
        expression: "reward_type.reward_type_setting.reward_set_amount_type"
      }],
      staticClass: "sp-form-select form-control",
      staticStyle: {
        "width": "45%"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          reward_type.reward_type_setting.reward_set_amount_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "P"
      }
    }, [_vm._v("% (percentage)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "C"
      }
    }, [_vm._v("₦ (cash)")])])])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.menu_tab_inner_view['set' + reward_type.reward_type_name + reward_type.reward_type_id]) ? _c('button', {
      staticClass: "btn",
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.postBusinessRewardSettings(reward_type)
        }
      }
    }, [_vm._v("Save")]) : _c('button', {
      staticClass: "btn",
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.updateBusinessRewardSettings(reward_type.reward_type_setting)
        }
      }
    }, [_vm._v("Save")])]), _vm._v(" "), _c('a', {
      staticClass: "btn sp-button-02 sp-button-sm",
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('')
        }
      }
    }, [_vm._v("close")]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]) : _vm._e()])
  }), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Turn on Agent Marketing")]), _vm._v(" "), ((_vm.sellpoint.business_is_agents_open == 1)) ? _c('span', {
    staticStyle: {
      "margin-left": "1em",
      "color": "#ff0000"
    }
  }, [_vm._v("ON")]) : _vm._e(), _vm._v(" "), ((_vm.sellpoint.business_is_agents_open == 0)) ? _c('span', {
    staticStyle: {
      "margin-left": "1em",
      "color": "#ff0000"
    }
  }, [_vm._v("OFF")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("You must set a Reward amount before turning on this feature")]), _vm._v(" "), ((_vm.set_reward_commission > 0)) ? _c('div', [_c('div', [((_vm.sellpoint.business_is_agents_open == 1)) ? _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.updateBusinessGeneralSettings(1, {})
      }
    }
  }, [_vm._v("TURN OFF")]) : _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.updateBusinessGeneralSettings(1, {})
      }
    }
  }, [_vm._v("TURN ON")])])]) : _c('div', [_c('div', [((_vm.sellpoint.business_is_agents_open == 1)) ? _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.updateBusinessGeneralSettings(1, {})
      }
    }
  }, [_vm._v("TURN OFF")]) : _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": true
    }
  }, [_vm._v("TURN ON")])])])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
}]}

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), (_vm.loggedIn) ? _c('div', {
    staticClass: "hidden-md hidden-lg"
  }, [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Your Profile")]), _vm._v(" "), _c('div', {
    staticClass: "profile-card"
  }, [_c('img', {
    staticClass: "profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _vm._v(" "), _c('h5', [_c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "timeline"
    }
  }, [_vm._v(_vm._s(_vm.user.user_name))])]), _vm._v(" "), _vm._m(1), _c('br'), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "suggestions",
    attrs: {
      "id": "sticky-sidebar"
    }
  }, [_c('h4', {
    staticClass: "grey"
  }, [_vm._v("Shops Followed")]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Simi Shapers")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Chris Foodstore")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Olafumi Jewellries")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Trish Hairs")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Nina Organics")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" 62 shops")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ion ion-android-person-add"
  }), _vm._v(" 1,500 friends")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav-news-feed"
  }, [_c('li', [_c('i', {
    staticClass: "icon ion-ios-paper"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Tradefair Newsfeed")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon fa fa-shopping-cart"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Shops Following")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-ios-people-outline"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Friends")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-chatboxes"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Discussions / Messages")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-images"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Orders")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon fa fa-bell"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("No6ifications")])])])])
}]}

/***/ }),
/* 578 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap"
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "4em"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "1em"
    }
  }, [_vm._l((_vm.myshops), function(shop, index) {
    return _c('div', {
      staticClass: "card card-row",
      staticStyle: {
        "background": "#ffffff",
        "border-radius": "0px",
        "margin-bottom": "0.6em"
      }
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + shop.folder_item_module_data.business_username
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle",
      staticStyle: {
        "width": "60px",
        "height": "65px"
      }
    }, [_c('img', {
      attrs: {
        "src": shop.folder_item_module_data.business_brand_image
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "width": "80%",
        "padding-top": "0.1em"
      }
    }, [_c('div', {
      staticClass: "col-xs-12 colx"
    }, [_c('div', {
      staticClass: "col-xs-9 colx"
    }, [_c('p', [_c('span', {
      staticStyle: {
        "width": "100%",
        "font-weight": "bolder"
      }
    }, [_vm._v(_vm._s(shop.folder_item_module_data.business_username))]), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "100%"
      }
    }, [_vm._v(_vm._s(shop.folder_item_module_data.business_name)), _c('br')]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "100%",
        "font-weight": "lighter"
      }
    }, [_vm._v(_vm._s(shop.folder_item_module_data.business_category_name))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3 colx"
    }, [_c('a', {
      staticClass: "card-link btn sp-button-02 sp-button-02-lt",
      staticStyle: {
        "float": "right",
        "font-size": "13px",
        "margin-top": "0.1em",
        "text-transform": "inherit",
        "background-color": "#21a6f3",
        "color": "#ffffff",
        "border-radius": "5px",
        "padding": "3px 10px"
      },
      attrs: {
        "href": '/' + shop.folder_item_module_data.business_username
      }
    }, [_vm._v("\r\n                   View Shop\r\n                ")])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2)]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 579 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "timeline-cover sp-page-banner"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-contents"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left-sidebar')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('search-box'), _vm._v(" "), (!_vm.search_data != '') ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.search_data != '') ? _c('h4', {
    staticClass: "grey"
  }, [_vm._v("Products found in " + _vm._s(_vm.search_data))]) : _vm._e(), _vm._v(" "), (_vm.products.length == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("no matching products")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "friend-list"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "col-md-4 col-sm-4 col-xs-6"
    }, [((product.product_items.length != 0)) ? _c('div', {
      staticStyle: {
        "min-height": "23em",
        "max-height": "22em"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "inherit",
        "text-decoration": "none"
      },
      attrs: {
        "href": '/' + product.product_business_username + '/' + product.product_url_name
      }
    }, _vm._l((product.product_items), function(product_item, index2) {
      return _c('div', {
        staticClass: "friend-card",
        staticStyle: {
          "min-height": "22em",
          "max-height": "22em",
          "border-bottom-color": "rgb(182, 176, 176)"
        }
      }, [(index2 == 0) ? _c('div', [_c('div', {
        staticStyle: {
          "height": "10em"
        }
      }, [_c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": product.product_images[0].product_image,
          "alt": "photo"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "card-info"
      }, [_c('div', {
        staticClass: "friend-info"
      }, [_c('a', {
        staticClass: "pull-right text-green",
        staticStyle: {
          "font-size": "12px"
        },
        attrs: {
          "href": "#"
        }
      }, [_vm._v("@" + _vm._s(product.product_business_name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', {
        staticStyle: {
          "height": "3em"
        }
      }, [_c('a', {
        staticClass: "profile-link",
        attrs: {
          "href": "#"
        }
      }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('p', [_vm._v("₦" + _vm._s(product_item.product_item_price.toLocaleString('en', {
        useGrouping: true
      })))]), _vm._v(" "), _vm._m(1, true)])])]) : _vm._e()])
    }))]) : _vm._e()])
  }))]), _vm._v(" "), _c('active-products')], 1)])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-md-offset-2 col-sm-12 col-xs-12",
    staticStyle: {
      "padding": "5em"
    }
  }, [_c('div', {
    staticClass: "wn-loader"
  }), _vm._v(" "), _c('p', [_vm._v("loading...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('a', {
    staticClass: "btn text-red",
    attrs: {
      "title": "Like"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o",
    staticStyle: {
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn text-red",
    attrs: {
      "title": "Add to Cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart",
    staticStyle: {
      "font-size": "14px"
    }
  })])])
}]}

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap"
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "4em"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "0.3em"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1em",
      "padding-bottom": "0.2em",
      "border-bottom": "#f3f2f2 solid"
    }
  }, [_c('a', {
    staticClass: "col-xs-4 sp-app-default-color card-link",
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "font-size": "15px"
    },
    on: {
      "click": function($event) {
        _vm.setTabComponent('tab01')
      }
    }
  }, [(_vm.tab_view.tab01) ? _c('div', {
    staticStyle: {
      "border-bottom": "#f33e5c solid 3px"
    }
  }, [_vm._v("Shopping Cart")]) : _c('div', [_vm._v("Shopping Cart")])]), _vm._v(" "), _c('a', {
    staticClass: "col-xs-4 sp-app-default-color card-link",
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "font-size": "15px"
    },
    on: {
      "click": function($event) {
        _vm.setTabComponent('tab02')
      }
    }
  }, [(_vm.tab_view.tab02) ? _c('div', {
    staticStyle: {
      "border-bottom": "#f33e5c solid 3px"
    }
  }, [_vm._v("Collections")]) : _c('div', [_vm._v("Collections")])]), _vm._v(" "), _c('a', {
    staticClass: "col-xs-4 sp-app-default-color card-link",
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "font-size": "15px",
      "text-decoration": "none",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.setTabComponent('tab03')
      }
    }
  }, [(_vm.tab_view.tab03) ? _c('div', {
    staticStyle: {
      "border-bottom": "#f33e5c solid 3px"
    }
  }, [_vm._v("Orders "), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  })]) : _c('div', [_vm._v("Orders "), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "2em 1em"
    }
  }, [(_vm.tab_view.tab01) ? _c('div', [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.tab_view.tab02) ? _c('div', [_c('div', {
    staticClass: "w-richtext"
  }, [((Object.keys(_vm.collections).length == 0)) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have (0) collections")])]) : _vm._e(), _vm._v(" "), _vm._m(2)])]) : _vm._e(), _vm._v(" "), (_vm.tab_view.tab03) ? _c('div', [_vm._m(3)]) : _vm._e()])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "border-radius": "5px",
      "background": "#f72777",
      "margin": "0.8em 2em 0em 2em"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center",
      "color": "#ffffff",
      "margin": "1em"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "15px",
      "padding-top": "0.8em"
    }
  }, [_vm._v("A faster, easier way to shop online")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Set Up for Free")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-richtext"
  }, [_c('p', {
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_vm._v("cart")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticClass: "btn sp-button-02 sp-button-02-lt",
    staticStyle: {
      "font-size": "13px",
      "margin-top": "0.9em",
      "text-transform": "inherit",
      "background-color": "#f7af13",
      "border-radius": "25px",
      "padding": "3px 10px"
    },
    attrs: {
      "href": "/register"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" New Collection\r\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-richtext"
  }, [_c('p', {
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_vm._v("orders")])])
}]}

/***/ }),
/* 581 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "products"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n     vbvbvb " + _vm._s(_vm.products) + "bvbvbv\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.set_headers
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('router-view')], 1)])]), _vm._v(" "), ((!(this.$route.path == '/order') && !(this.$route.path == '/order/') && !(this.$route.path == '/cart') && !(this.$route.path == '/cart/') && !(this.$route.path == '/checkout') && !(this.$route.path == '/checkout/'))) ? _c('component-footer') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 583 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bottombar-large",
    staticStyle: {
      "margin-top": "5em",
      "margin-left": "-2em",
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/notifications"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), (_vm.notifications_alert > 0) ? _c('sup', {
    staticClass: "notify-alert"
  }, [_vm._v(_vm._s(_vm.notifications_alert))]) : _vm._e(), _c('br'), _c('span', [_vm._v("Notifications")])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "bottombar"
  }, [_c('div', [_vm._m(4), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/orders"
    }
  }, [_c('i', {
    staticClass: "fas fa-shopping-basket",
    attrs: {
      "id": "m_orders"
    }
  }), (_vm.notifications_alert > 0) ? _c('sup', {
    staticClass: "notify-alert"
  }, [_vm._v(_vm._s(_vm.notifications_alert))]) : _vm._e(), _c('br'), _c('span', [_vm._v("Orders")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/account"
    }
  }, [_c('i', {
    staticClass: "fas fa-cog",
    attrs: {
      "id": "m_account"
    }
  }), (_vm.notifications_alert > 0) ? _c('sup', {
    staticClass: "notify-alert"
  }, [_vm._v(_vm._s(_vm.notifications_alert))]) : _vm._e(), _c('br'), _c('span', [_vm._v("Settings")])]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "color": "#ffffff",
      "padding": "1em",
      "background-color": "#5703a5",
      "border-radius": "8px"
    },
    attrs: {
      "href": "/shopping/lists/new"
    }
  }, [_vm._v("\r\n            Shop ›")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _c('br'), _c('span', [_vm._v("Feeds")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/shop"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  }), _c('br'), _c('span', [_vm._v("Bag")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/account"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _c('br'), _c('span', [_vm._v("Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _c('br'), _c('span', [_vm._v("Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('i', {
    staticClass: "fas fa-store-alt",
    attrs: {
      "id": "m_trending"
    }
  }), _c('br'), _c('span', [_vm._v("Home")])])
}]}

/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('header', {
    staticClass: "site-header header-one home-page-one",
    staticStyle: {
      "margin-top": "3em"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-expand-lg navbar-light header-navigation stricky"
  }, [_c('div', {
    staticClass: "container clearfix"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "header-name"
  }, [_vm._v(_vm._s(_vm.sellpoint.business_name))])]), _vm._v(" "), (_vm.loggedIn) ? _c('div', {
    staticClass: "right-side-box"
  }, [(_vm.edit_mode) ? _c('a', {
    staticClass: "header-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('open')
      }
    }
  }, [_vm._v("Manage")]) : _c('a', {
    staticClass: "header-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('open')
      }
    }
  }, [_vm._v("Connect")])]) : _c('div', {
    staticClass: "right-side-box"
  }, [_c('a', {
    staticClass: "header-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('open')
      }
    }
  }, [_vm._v("Connect")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-wrapper"
  }, [(_vm.sellpoint.business_banner_image != _vm.default_banner_image) ? _c('section', {
    staticClass: "banner-style-one home-page-two",
    staticStyle: {
      "margin-top": "-2em",
      "height": "100vh"
    },
    style: ({
      backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.78), rgba(0, 0, 0, 0.48)), url(' + _vm.img_sellpoint_url + _vm.sellpoint.business_banner_image + ')'
    }),
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "container gw-container"
  }, [(_vm.business_load_error_msg != '') ? _c('div', {
    staticClass: "row content-block"
  }, [_c('p', {
    staticStyle: {
      "color": "#ffc107",
      "margin": "1em"
    }
  }, [_vm._v(_vm._s(_vm.business_load_error_msg))])]) : _c('div', {
    staticClass: "row content-block"
  }, [_c('div', {
    staticClass: "col-sm-6 gw-large"
  }, [_c('div', {
    staticStyle: {
      "display": "block",
      "margin-top": "8em"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 gw-lookbook"
  }, [(_vm.edit_mode) ? _c('button', {
    staticClass: "btn btn-xs pull-right",
    staticStyle: {
      "background": "#f8ecf0",
      "color": "#161515",
      "margin-bottom": "1em"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('refresh-store', '')
      }
    }
  }, [_vm._v("Refresh Lookbook")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "addPanelView"
    }
  }, [(_vm.addPanel) ? _c('div', [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff",
      "margin-bottom": "1em"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.newLookbookForm) ? _c('div', [_c('add-lookbook')], 1) : _vm._e(), _vm._v(" "), (_vm.newProductLookbookForm) ? _c('div', [_c('add-product-lookbook')], 1) : _vm._e(), _vm._v(" "), (_vm.addNewPost) ? _c('div', {}, [_c('h6', [_vm._v("New Gallery Post")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Caption")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_caption),
      expression: "post.post_caption"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.post.post_caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_caption = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_details),
      expression: "post.post_details"
    }],
    domProps: {
      "value": (_vm.post.post_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_details = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#e4abbe"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addPostToGallery
    }
  }, [_vm._v("Add")])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.loading) ? _c('div', [_vm._m(3)]) : _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "60vh",
      "overflow": "scroll"
    }
  }, _vm._l((_vm.galleria), function(gallery, gndex) {
    return _c('div', {
      staticClass: "folder-main col-6 col-md-4"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getPostsInGallery(gallery)
        }
      }
    }, [_c('div', {
      staticClass: "folder-inner"
    }, [(gallery.gallery_posts_group_posts_media.length > 0) ? _c('div', {
      staticClass: "folder-inner-image"
    }, [(_vm.checkIfVideo(gallery.gallery_posts_group_posts_media[0].gallery_post_media)) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": gallery.gallery_posts_group_posts_media[0].gallery_post_media
      }
    })]) : _c('div', {
      staticClass: "folder-inner-image"
    }, [_c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "folder-inner-words"
    }, [_c('h5', [_c('a', {
      on: {
        "click": function($event) {
          _vm.getPostsInGallery(gallery)
        }
      }
    }, [_vm._v(_vm._s(gallery.gallery_posts_group_name))])])])])])])
  })), _vm._v(" "), (_vm.edit_mode && _vm.can_add_more_lookbook) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "none"
    }
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "folder-main col-6 col-md-4"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-lookbook', '')
      }
    }
  }, [_vm._m(4)])]) : _vm._e(), _vm._v(" "), (_vm.edit_mode && _vm.can_add_product_lookbook) ? _c('div', {
    staticClass: "folder-main col-6 col-md-4"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-product-lookbook', '')
      }
    }
  }, [_vm._m(5)])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _vm._m(6)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sidenav",
    attrs: {
      "id": "mobileSideNav"
    }
  }, [_c('a', {
    staticClass: "closebtn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('close')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "container sidenav-links"
  }, [_c('ul', [_vm._m(7), _vm._v(" "), (_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "account"
    }
  }, [_vm._v("My Account")])]) : _c('li', [_c('a', {
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Login")])]), _vm._v(" "), (_vm.loggedIn) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.manageLookbook
    }
  }, [_vm._v("Go to Sellpoint")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "container sidenav-container"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "2em"
    }
  }, [(_vm.addPanel) ? _c('div', {
    attrs: {
      "id": "addPanelView"
    }
  }, [(_vm.addPanel) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "float": "right",
      "background": "#ff0055",
      "color": "#ffffff",
      "margin-bottom": "1em"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.newLookbookForm) ? _c('div', [_c('add-lookbook')], 1) : _vm._e(), _vm._v(" "), (_vm.newProductLookbookForm) ? _c('div', [_c('add-product-lookbook')], 1) : _vm._e(), _vm._v(" "), (_vm.addNewPost) ? _c('div', {}, [_c('h6', [_vm._v("Add a new Post to "), _c('b', [_vm._v(_vm._s(_vm.gallery.gallery_posts_group_name))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Caption")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_caption),
      expression: "post.post_caption"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.post.post_caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_caption = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_details),
      expression: "post.post_details"
    }],
    domProps: {
      "value": (_vm.post.post_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_details = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#e4abbe"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addPostToGallery
    }
  }, [_vm._v("Add")])])])]) : _vm._e()]) : _vm._e()]) : _c('div', [_c('div', {
    staticStyle: {
      "margin-right": "2em"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('div', {
    staticClass: "sidenav-banner-img"
  }, [_c('img', {
    staticClass: "sp-prd-img",
    attrs: {
      "src": _vm.sellpoint.business_banner_image
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (!_vm.edit_mode) ? _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('h5', [_vm._v("Contact Us")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "button-block"
  })]) : _vm._e(), _vm._v(" "), (_vm.edit_mode) ? _c('div', {}, [_c('p', [_vm._v("Welcome "), _c('b', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(", here you can set up and manage your gallery with any of these actions below")]), _vm._v(" "), (_vm.edit_mode && _vm.can_add_more_lookbook) ? _c('div', {
    staticClass: "row"
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "col-6 col-md-4"
  }, [_c('div', {
    staticClass: "gw-add-btn"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-lookbook', '')
      }
    }
  }, [_c('h5', [_vm._v("Add New Lookbook")])])])]) : _vm._e(), _vm._v(" "), (_vm.edit_mode && _vm.can_add_product_lookbook) ? _c('div', {
    staticClass: "col-6 col-md-4"
  }, [_c('div', {
    staticClass: "gw-add-btn"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-product-lookbook', '')
      }
    }
  }, [_c('h5', [_vm._v("Add Product Lookbook")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [(!(_vm.edit_mode && _vm.can_add_more_lookbook)) ? _c('div', {
    staticClass: "col-md-6 col-sm-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "manage-action-block"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": _vm.manageLookbook
    }
  }, [_c('h5', [_vm._v("You have reached the limit of your gallery")]), _vm._v(" "), _vm._m(9)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "manage-action-block"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": _vm.manageLookbook
    }
  }, [_c('h5', [_vm._v("Manage Your Gallery on Sellpoint")]), _vm._v(" "), _c('p', [_vm._v("Once clicked you would be directed to your Sellpoint account to further set-up your page")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.manageLookbook
    }
  }, [_vm._v("Manage")])])])])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade modal-c p-modal",
    attrs: {
      "id": "quickviewModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [(_vm.place_order) ? _c('div', {
    staticClass: "modal-content"
  }, [_c('button', {
    staticClass: "pul-right close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.resetOptions
    }
  }, [_c('b', [_vm._v("close")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-20 mb-20 mb-xs-0"
  }, [(_vm.payment_successful) ? _c('div', {
    staticClass: "col-xs-12 mb-40"
  }, [_c('h3', {
    staticStyle: {
      "line-height": "1.6"
    }
  }, [_vm._v(_vm._s(this.payment_successful_message))])]) : _c('div', {
    staticClass: "col-xs-12 mb-40"
  }, [_c('h4', [_vm._v("Place Order For "), _c('b', [_vm._v(_vm._s(_vm.ordered_product.product_name) + "(₦" + _vm._s(_vm.ordered_product_item.product_item_price) + ")")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('div', {}, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_name),
      expression: "payment_payer_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.payment_payer_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_email),
      expression: "payment_payer_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.payment_payer_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_phone),
      expression: "payment_payer_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Phone (format: 09088776655)"
    },
    domProps: {
      "value": (_vm.payment_payer_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn pull-left",
    staticStyle: {
      "cursor": "pointer",
      "border-radius": "2px",
      "background": "#ffc107",
      "color": "#000"
    },
    on: {
      "click": function($event) {
        _vm.processPayment()
      }
    }
  }, [_vm._v(" Proceed")])])])])])])]) : _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [(_vm.edit_mode) ? _c('button', {
    staticClass: "btn btn-xs pull-left",
    staticStyle: {
      "background": "#f8ecf0",
      "color": "#161515",
      "margin-bottom": "1em"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.manageLookbook
    }
  }, [_vm._v("ManageLookbook")]) : _vm._e(), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.edit_mode) ? _c('div', [(_vm.gallery.gallery_posts_group_posts_total < _vm.max_plan_lookbook_posts) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0055"
    }
  }, [_vm._v("Add new Post to " + _vm._s(_vm.gallery.gallery_posts_group_name) + ", \r\n                                    "), (((_vm.gallery.gallery_posts_group_type == 2) && _vm.can_add_product_lookbook)) ? _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "background": "#ffc107",
      "padding": "5px"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-product-post', _vm.gallery)
      }
    }
  }, [_vm._v("Add")]) : _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "background": "#ffc107",
      "padding": "5px"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-post', _vm.gallery)
      }
    }
  }, [_vm._v("Add")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-size": "28px"
    }
  }, [_vm._v(_vm._s(_vm.gallery_post.gallery_post_caption) + "\r\n                                                "), (_vm.gallery_post.gallery_post_product_items) ? _c('span', [_vm._v("(₦" + _vm._s(_vm.gallery_post.gallery_post_product_items[0].product_item_price) + ")")]) : _vm._e()]), _vm._v(" "), (_vm.gallery_post_set_image.gallery_post_media != '') ? _c('div', {
    staticClass: "image",
    staticStyle: {
      "height": "250px",
      "width": "100%"
    }
  }, [(_vm.checkIfVideo(_vm.gallery_post_set_image.gallery_post_media)) ? _c('img', {
    staticClass: "rounded",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "object-fit": "contain"
    },
    attrs: {
      "src": "/static/assets/images/video-placeholder.png",
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "rounded",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "object-fit": "contain"
    },
    attrs: {
      "src": _vm.gallery_post_set_image.gallery_post_media,
      "alt": ""
    }
  }), _vm._v(" "), (_vm.gallery_post.gallery_post_media) ? _c('div', {
    staticClass: "image-overlay",
    staticStyle: {
      "top": "80px"
    }
  }, [(_vm.gallery_post.gallery_post_media.length > 1) ? _c('ul', {
    staticClass: "food-menu-list-num"
  }, _vm._l((_vm.gallery_post.gallery_post_media), function(img, imdex) {
    return _c('li', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showPostImage(img)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-circle-o"
    })])])
  })) : _vm._e()]) : _vm._e()]) : _c('div', [_c('img', {
    staticClass: "sp-prd-img",
    attrs: {
      "src": "/static/assets/images/dummy-image.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "top": "200px"
    }
  }, [_c('div', {
    staticClass: "content-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.gallery_post.gallery_post_details))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.gallery.gallery_posts_group_posts) ? _c('div', {
    staticClass: "col-xs-12 mb-40 pull-right"
  }, [(_vm.gallery.gallery_posts_group_posts.length > 1) ? _c('ol', {
    staticClass: "food-menu-list-num"
  }, _vm._l((_vm.gallery.gallery_posts_group_posts), function(post, prdex) {
    return _c('li', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showPost(post)
        }
      }
    }, [_vm._v(_vm._s(++prdex))])])
  })) : _vm._e()]) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logo-sm.png",
      "alt": "Awesome Image"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Capture your moments "), _c('br'), _vm._v(" save and organise and "), _c('br'), _vm._v(" make your work roll out like a gallery.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button-block"
  }, [_c('a', {
    staticClass: "banner-btn",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Contact Us")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "6em"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/loader.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "folder-inner"
  }, [_c('div', {
    staticClass: "folder-inner-image",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h2', {
    staticStyle: {
      "padding": "6px",
      "font-size": "24px",
      "color": "#ff0055"
    }
  }, [_vm._v("Add New Lookbook")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "folder-inner"
  }, [_c('div', {
    staticClass: "folder-inner-image",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h2', {
    staticStyle: {
      "padding": "6px",
      "font-size": "24px",
      "color": "#ff0055"
    }
  }, [_vm._v("Add New Product Lookbook")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gw-mobile",
    staticStyle: {
      "display": "none"
    }
  }, [_c('p', [_vm._v("Capture your moments "), _c('br'), _vm._v(" save and organise and "), _c('br'), _vm._v(" make your work roll out like a gallery.")]), _vm._v(" "), _c('div', {
    staticClass: "button-block"
  }, [_c('a', {
    staticClass: "banner-btn",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Contact Us")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Capture your moments "), _c('br'), _vm._v(" save and organise and "), _c('br'), _vm._v(" make your work roll out like a gallery.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("To add more lookboks to your gallery, "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Upgrade your Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "true",
      "disabled": "disabled"
    }
  }), _vm._v(" By proceeding, you agree with the "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0055",
      "font-weight": "bold"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#terms-modal",
      "href": "#"
    }
  }, [_vm._v("Terms and Conditions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "pull-right close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('b', [_vm._v("close")])])
}]}

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin": "0.1em",
      "margin-top": "-0.2em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card card-box-fl"
  }, [_c('h4', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/manage/items/settings/resetcategory"
    }
  }, [_vm._v("\n                            Move to new Category\n                            "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-box-fl"
  }, [_c('h4', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/manage/items/settings/addtocategories"
    }
  }, [_vm._v("\n                            Add to new Categories\n                            "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])
}]}

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "shop-page padding-top-100 padding-bottom-100"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v("setting up your account....")])])])])])])
}]}

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "timeline-cover sp-page-banner"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-contents"
    }
  }, [_c('div', {
    staticClass: "card card-flat"
  }, [_c('div', [_c('h3', [_vm._v("Want to shop together with friends?")]), _vm._v(" "), (_vm.data_ref_link != '') ? _c('div', {
    staticClass: "card card-flat-pad",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.data_ref_link))])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setReferralBash
    }
  }, [_vm._v("Generate Shopping Link")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('viewChatLog')
      }
    }
  }, [_vm._v("View Chat")]), _vm._v(" "), (_vm.menu_tab_view.viewChatLog) ? _c('div', [_c('h4', [_vm._v("Group Chat")]), _c('br'), _vm._v(" "), _c('component-chatroom', {
    attrs: {
      "chatter": {
        chatter_chat_from: _vm.user.user_id,
        chatter_chat_from_module: 1,
        chatter_set_active_chat: '16201620',
        chatter_chat_to: 16,
        chatter_chat_to_module: 20,
        chatter_chat_group: 16,
        chat_components_products: []
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card card-flat"
  }, [(_vm.set_shop_together) ? _c('div', [_c('h3', [_vm._v("Shop Together Active")]), _vm._v(" "), (_vm.data_ref_link != '') ? _c('div', {
    staticClass: "card card-flat-pad",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.data_ref_link))])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setReferralBash
    }
  }, [_vm._v("Generate Shopping Link")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat"
  }, [(_vm.shop_together_join) ? _c('div', [_c('h3', [_vm._v("Do you want to shop together with "), _c('span', {
    staticClass: "sp-app-default-color"
  }, [_vm._v(_vm._s(_vm.ref_bash_details.ref_initiator_name))])]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setShopTogetherJoinIn
    }
  }, [_vm._v("Yes, Please")])]) : _vm._e()])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Share the link below")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Invite more friends "), _c('br'), _vm._v("Share the link below")])])
}]}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.menu_tab_view.setBusinessCategoryProductOrders) ? _c('div', [(Object.keys(_vm.product.product_orders).length > 0) ? _c('div', {
    staticClass: "detail-card"
  }, [_c('h6', [_vm._v("Product Orders")]), _vm._v(" "), _c('div', {
    staticClass: "orders-panel"
  }, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("From")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Qty")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _vm._l((_vm.product.product_orders), function(order) {
    return _c('tr', {
      key: order.order_id
    }, [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#df4d4d",
        "font-size": "10px"
      }
    }, [_c('u', [_c('b', [_vm._v(_vm._s(order.order_time_ago))])])]), _c('br'), _vm._v("\n                " + _vm._s(order.order_date) + "\n            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v("\n              " + _vm._s(order.order_user) + "\n            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(order.order_item_quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      style: ({
        color: order.order_payment_status_color
      })
    }, [_vm._v(_vm._s(order.order_payment_status))])])])
  })], 2)])]) : _c('p', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("No orders yet")])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    staticStyle: {
      "background-color": "#ffffff"
    },
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "1em",
      "margin-right": "1em"
    }
  }, [_c('a', {
    staticClass: "col-xs-1 card-link",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _vm._v("   \r\n       "), _c('a', {
    staticClass: "col-xs-2 x-cta-btn card-link",
    staticStyle: {
      "float": "left",
      "width": "30px",
      "height": "40px",
      "text-align": "center"
    },
    attrs: {
      "href": '/' + _vm.order.order_business_username
    }
  }, [_c('p', {
    staticClass: "ltr-1"
  }, [_vm._v(_vm._s(_vm.order.order_user))])]), _vm._v(" "), _c('p', {
    staticClass: "col-xs-9"
  }, [_vm._v(_vm._s(_vm.order.order_user))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "pager",
    staticStyle: {
      "text-align": "left",
      "margin-top": "5em"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin-bottom": "5em"
    }
  }, [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.menu_tab_inner_view['order_details']) ? _c('div', {}, [_c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "800",
      "font-size": "22px",
      "line-height": "1.6"
    }
  }, [_vm._v("Order Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Order No: ")]), _vm._v(_vm._s(_vm.order.order_no))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Date: ")]), _vm._v(_vm._s(_vm.order.order_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("By: ")]), _vm._v(_vm._s(_vm.order.order_user))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("From: ")]), _vm._v(_vm._s(_vm.order.order_business))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Cost: ")]), _vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_items_total)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivery Charge: ")]), _vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_shipping_total)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Total to pay: ")]), _vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_total)))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right",
      "padding": "0.51em",
      "border-radius": "5px",
      "background-color": "#f7df2b",
      "color": "#000000"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.order.order_status))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Items Ordered")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "category-slide"
  }, [_c('ul', _vm._l((_vm.order.order_items), function(item, index) {
    return _c('li', {}, [(item.product_item_group_image && (item.product_item_group_image != '' && item.product_item_group_image != 'error')) ? _c('img', {
      staticStyle: {
        "width": "80px",
        "height": "100px",
        "border-radius": "8px"
      },
      attrs: {
        "src": _vm.img_product_url + item.product_item_group_image
      }
    }) : _c('img', {
      staticStyle: {
        "width": "80px",
        "height": "100px",
        "border-radius": "8px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('h6', [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), _c('h6', {
      staticStyle: {
        "font-size": "18px",
        "text-align": "left"
      }
    }, [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(item.order_item_total)) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "14px"
      }
    }, [_c('b', [_vm._v("Quantity: ")]), _vm._v(_vm._s(item.order_item_quantity))])])])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Delivery Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [(_vm.order.order_user_delivery_address != '') ? _c('p', [_vm._v(_vm._s(_vm.order.order_user_delivery_address))]) : _c('p', [_vm._v("Not set")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Order Contact Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.order.order_business))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email Address: ")]), _vm._v(_vm._s(_vm.order.order_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone Number: ")]), _vm._v(_vm._s(_vm.order.order_user))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Order Additional Information")]), _vm._v(" "), _c('hr'), _vm._v(" "), (Object.keys(_vm.order_additionals).length > 0) ? _c('div', _vm._l((_vm.order_additionals), function(detail, index) {
    return _c('div', [_c('p', [_c('b', [_vm._v(_vm._s(++index) + ". ")]), _vm._v(_vm._s(detail.order_additional_details))])])
  })) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No additional information")])])]) : _c('div', {}, [_c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Shopping on "), _c('b', [_vm._v(_vm._s(_vm.order.order_date))])]), _vm._v(" "), _c('p', [_vm._v("Status: "), _c('b', [_c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.order.order_status))])])]), _vm._v(" "), _c('p', [_vm._v("Deliver Items and Close this Shopping List Request")]), _vm._v(" "), _c('hr'), _vm._v(" "), (Object.keys(_vm.order_chart).length > 0) ? _c('div', [_c('div', [_c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "container container-right"
  }, [_c('div', {
    staticClass: "card-box card-02"
  }, [_c('h5', [_vm._v("Shopping List "), _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "float": "right"
    }
  }, [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_total)))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_vm._l((_vm.order.order_items), function(item, index) {
    return (index < 4) ? _c('p', {
      key: item.order_item_no
    }, [_vm._v("\r\n                         " + _vm._s(item.product_name) + " - ₦" + _vm._s(item.order_item_total.toFixed(2)) + "\r\n                       ")]) : _vm._e()
  }), _vm._v(" "), _c('a', {}, [_vm._v("see Items")])], 2), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('h5', [_vm._v("Delivery"), _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "float": "right"
    }
  }, [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_shipping_total)))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [(_vm.order.order_user_delivery_address != '') ? _c('p', [_vm._v(_vm._s(_vm.order.order_user_delivery_address))]) : _c('p', [_vm._v("Not set")])])]), _vm._v(" "), (_vm.checkOrderChart('status', 35)) ? _c('div', [_c('hr'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You confirmed these Items are available")])]) : _c('div', [_c('div', [_c('button', {
    staticClass: "btn sp-button-02",
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('setPaymentDetails')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Yes, I have these Items")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "setPaymentDetails"
    }
  }, [_c('div', [_c('hr'), _vm._v(" "), _c('b', [_vm._v("Send Bank Details")]), _c('br'), _vm._v(" "), (_vm.sellpoint.business_bank_details && (Object.keys(_vm.sellpoint.business_bank_details).length > 0)) ? _c('div', [_c('span', [_vm._v("Send bank details details to receive order payment")]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "color": "#444444"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_name)), _c('br'), _vm._v("\r\n                                 " + _vm._s(_vm.sellpoint.business_bank_details.bank_account_name)), _c('br'), _vm._v("\r\n                                 " + _vm._s(_vm.sellpoint.business_bank_details.bank_account_number) + "\r\n                               ")])]), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderCustomOrderDetailsUpdate(_vm.order)
      }
    }
  }, [_vm._v("Send")])]) : _c('div', [_vm._m(0)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('ConfirmPaymentUpdate')
      }
    }
  }, [_vm._v("Confirm Payment")]), _vm._v(" "), (_vm.menu_tab_inner_view['ConfirmPaymentUpdate']) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Confirm Order Payment ?")]), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderCustomConfirmPaymentUpdate(_vm.order)
      }
    }
  }, [_vm._v("Yes, Confirm Payment")])]) : _vm._e(), _vm._v(" "), _c('hr')])])])])])]), _vm._v(" "), _vm._l((_vm.order_chart), function(track) {
    return _c('div', [_c('div', {
      staticClass: "timeline"
    }, [(track.order_status_id == 20) ? _c('div', {
      staticClass: "container container-left"
    }, [_c('div', {
      staticClass: "card-box card-02"
    }, [_c('h5', [_vm._v("Proof of payment")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', [_vm._v("Please confirm payment")]), _vm._v(" "), _c('div', [(track.order_status_id == 20) ? _c('div', _vm._l((track.order_set_uploads), function(images) {
      return (images.data_image != '') ? _c('div', [(images.data_image) ? _c('img', {
        staticClass: "img-responsive",
        attrs: {
          "src": images.data_image
        }
      }) : _vm._e()]) : _vm._e()
    })) : _vm._e()]), _vm._v(" "), _c('div', [_c('hr'), _vm._v(" "), _c('button', {
      staticClass: "sp-button sp-button-lt",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('ConfirmPaymentUpdate')
        }
      }
    }, [_vm._v("Confirm Payment")]), _vm._v(" "), _c('div', {
      attrs: {
        "id": "ConfirmPaymentUpdate"
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Confirm Order Payment ?")]), _vm._v(" "), _c('button', {
      staticClass: "sp-button sp-button-lt",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderCustomConfirmPaymentUpdate(_vm.order)
        }
      }
    }, [_vm._v("Yes, Confirm Payment")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "timeline"
    }, [_c('div', {
      staticClass: "container container-right"
    }, [(track.order_status_id == 35) ? _c('div', {
      staticClass: "card-box card-02"
    }, [_c('h5', [_vm._v("How to Pay")]), _vm._v(" "), _c('hr'), _vm._v(" "), (track.order_set_bank_name != '') ? _c('h6', [_vm._v("Use the below account details to make payment")]) : _vm._e(), _vm._v(" "), (track.order_set_payment_link != '') ? _c('h6', [_vm._v("click the link below to make payment")]) : _vm._e(), _vm._v(" "), _c('div', [(track.order_status_id == 35) ? _c('div', [(track.order_set_bank_name != '') ? _c('div', [_c('p', [_c('b', [_vm._v("Bank Name: ")]), _vm._v(_vm._s(track.order_set_bank_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Bank Account Name: ")]), _vm._v(_vm._s(track.order_set_bank_account_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Bank Account No: ")]), _vm._v(_vm._s(track.order_set_bank_account_no))])]) : _vm._e()]) : _vm._e()])]) : _vm._e()])])])
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('hr'), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "prImagePreview"
    }
  }), _vm._v(" "), ((Object.keys(_vm.file_info).length == 0)) ? _c('div', [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn sp-button-02",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Upload Receipt")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeNewPhoto($event, 'transfer-receipt')
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.file_info[0]) ? _c('div', [_c('button', {
    staticClass: "btn btn-default wnf-button",
    staticStyle: {
      "width": "30vw",
      "margin-left": "0vw",
      "padding": "5px 3px"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.uploadFlexiPaymentReceipt(_vm.order, _vm.order.order_no, 'transferred')
      }
    }
  }, [_vm._v("Yes, Upload")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default wnf-button",
    staticStyle: {
      "width": "30vw",
      "margin-left": "0vw",
      "padding": "5px 3px",
      "background-color": "#f5f4e6",
      "color": "#000000"
    },
    on: {
      "click": function($event) {
        _vm.resetImageUpload()
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])])], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "position": "fixed",
      "border": "none",
      "width": "100%",
      "bottom": "0",
      "margin": "0",
      "padding-top": "1.2em",
      "padding-right": "0",
      "background": "#ffffff",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "block",
      "width": "100%",
      "height": "auto",
      "background-color": "rgba(0, 0, 0, 0)"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000",
      "width": "100%"
    },
    attrs: {
      "id": "shareBoxtt"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {}
    }
  }, [_c('span', {
    staticClass: "s-backdrop",
    staticStyle: {
      "bottom": "5em"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "max-height": "75vh",
      "overflow": "scroll",
      "bottom": "5em",
      "margin": "0 -1.2em",
      "background": "none",
      "z-index": "10000"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('shareBox')
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em",
      "margin-bottom": "5em"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "border-top": "#f5f3f3 solid"
    }
  }, [_c('div', {
    staticClass: "row-ic-02",
    staticStyle: {
      "margin-top": "0.01em"
    }
  }, [_c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "padding-left": "0",
      "background-color": "#f7df2b"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._m(3), _c('span', {
    staticClass: "ct-dsc"
  }, [_vm._v("Confirm Purchase")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "background-color": "#fae570"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('order_details')
      }
    }
  }, [_vm._m(4), _c('span', {
    staticClass: "ct-dsc",
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v("Shopping List")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Set Bank details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Send Payment Link")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("A Payment link with payment details would be generated for payment")]), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Send Payment Link")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin": "0 1em",
      "border-radius": "38%",
      "color": "#000000",
      "padding": "0.22em 0.31em"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right",
    staticStyle: {
      "font-size": "1.6em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin": "0 1em",
      "border-radius": "38%",
      "color": "#000000",
      "padding": "0.22em 0.31em"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    staticStyle: {
      "font-size": "1.6em"
    }
  })])
}]}

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    key: _vm.componentKey,
    staticClass: "row",
    staticStyle: {
      "background": "#ffffff"
    },
    attrs: {
      "id": "topPanel"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h6', [_vm._v("Group")]), _vm._v(_vm._s(_vm.group) + "\r\n        "), (_vm.menu_view.showDisplayMembers) ? _c('div', {
    staticClass: "container"
  }, [_vm._l((_vm.display_members), function(member) {
    return _c('div', {
      staticClass: "card card-row",
      staticStyle: {
        "border-radius": "0px",
        "margin-bottom": "0.6em"
      }
    }, [_c('div', [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle",
      staticStyle: {
        "width": "60px",
        "height": "65px"
      }
    }, [_c('img', {
      attrs: {
        "src": member.data_image
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "width": "80%",
        "padding-top": "0.1em"
      }
    }, [_c('div', {
      staticClass: "col-xs-12 colx"
    }, [_c('div', {
      staticClass: "col-xs-9 colx"
    }, [_c('p', [_c('span', {
      staticStyle: {
        "width": "100%",
        "font-weight": "bolder"
      }
    }, [_vm._v(_vm._s(member.data_username))]), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "100%"
      }
    }, [_vm._v(_vm._s(member.data_name)), _c('br')]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "100%",
        "font-weight": "lighter"
      }
    }, [_vm._v(_vm._s(member.data_category))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3 colx"
    }, [_c('a', {
      staticClass: "card-link btn sp-button-02 sp-button-02-lt",
      staticStyle: {
        "float": "right",
        "font-size": "13px",
        "margin-top": "0.1em",
        "text-transform": "inherit",
        "background-color": "#21a6f3",
        "color": "#ffffff",
        "border-radius": "5px",
        "padding": "3px 10px"
      },
      on: {
        "click": function($event) {
          _vm.setAddMemberToGroup(member)
        }
      }
    }, [_vm._v("\r\n                      Add\r\n                    ")])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  }), _vm._v(" "), _c('br')], 2) : _c('div', [_c('div', [_c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Enter username  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_member.username),
      expression: "search_member.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.search_member.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_member.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.searchMember
    }
  }, [_vm._v("Enter gty66")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "card-link btn sp-button-02 sp-button-02-lt",
    staticStyle: {
      "float": "right",
      "font-size": "13px",
      "margin-top": "0.1em",
      "text-transform": "inherit",
      "background-color": "#21a6f3",
      "color": "#ffffff",
      "border-radius": "5px",
      "padding": "3px 10px"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('')
      }
    }
  }, [_vm._v("\r\n                Cancel\r\n              ")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Title  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_title),
      expression: "post.post_title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.post.post_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.setAddGroupPost
    }
  }, [_vm._v("Post")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "card-link btn sp-button-02 sp-button-02-lt",
    staticStyle: {
      "float": "right",
      "font-size": "13px",
      "margin-top": "0.1em",
      "text-transform": "inherit",
      "background-color": "#21a6f3",
      "color": "#ffffff",
      "border-radius": "5px",
      "padding": "3px 10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('')
      }
    }
  }, [_vm._v("\r\n                Cancel\r\n              ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "card-link btn sp-button-02 sp-button-02-lt",
    staticStyle: {
      "font-size": "13px",
      "margin-top": "0.1em",
      "text-transform": "inherit",
      "background-color": "#21a6f3",
      "color": "#ffffff",
      "border-radius": "5px",
      "padding": "3px 10px"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('showCreateGroup')
      }
    }
  }, [_vm._v("\r\n            Add New Member\r\n          ")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "detail-card"
  }, [_c('h6', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("Payment Information")]), _vm._v(" "), _c('div', {
    staticClass: "card card-colord-01 card-colord-pad"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Set up your Bank Details for direct Transfers")]), _vm._v(" "), (_vm.sellpoint.business_bank_details && (Object.keys(_vm.sellpoint.business_bank_details).length == 0)) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("\n                    You have not set up your bank yet\n                  ")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('setBankDetails')
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.menu_tab_inner_view.setBankDetails || _vm.menu_tab_inner_view.editBankDetails) ? _c('div', [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set Bank Details")]), _vm._v(" "), _c('p', [_vm._v("This account is where your payout would be sent to.")]), _vm._v(" "), _c('div', [(_vm.sellpoint.business_bank_details.length == 0 || _vm.menu_tab_inner_view.editBankDetails) ? _c('form', {
    staticClass: "sp-form",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('label', [_c('b', [_vm._v("Bank Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_bank_details.bank_name),
      expression: "sellpoint.business_bank_details.bank_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_bank_details.bank_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_bank_details.bank_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account Holder's Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_bank_details.bank_account_name),
      expression: "sellpoint.business_bank_details.bank_account_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_bank_details.bank_account_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_bank_details.bank_account_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account No:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_bank_details.bank_account_number),
      expression: "sellpoint.business_bank_details.bank_account_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.sellpoint.business_bank_details.bank_account_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_bank_details.bank_account_number = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("your details are secured")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.setBankDetails
    }
  }, [_vm._v("Save Bank Details")])]), _vm._v(" "), _c('div', [_c('label', [_c('b', [_vm._v("Bank Name:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ravepay_sba.account_bank),
      expression: "ravepay_sba.account_bank"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ravepay_sba.account_bank = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select your bank")]), _vm._v(" "), _vm._l((_vm.ravepay_bank_list), function(bank) {
    return _c('option', {
      key: bank.code,
      domProps: {
        "value": bank.Code
      }
    }, [_vm._v(_vm._s(bank.Name))])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account No:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ravepay_sba.account_number),
      expression: "ravepay_sba.account_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.ravepay_sba.account_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ravepay_sba.account_number = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_c('b', [_vm._v("Contact Email:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_contact_email),
      expression: "sellpoint.business_contact_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_contact_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_contact_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_c('b', [_vm._v("Contact Phone Number:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_contact_phone),
      expression: "sellpoint.business_contact_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_contact_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_contact_phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.setBankDetailsRavePay
    }
  }, [_vm._v("Save Bank Details")])])]) : _c('div', [_c('p', [_c('b', [_vm._v("Bank:")]), _vm._v(" " + _vm._s(_vm.sellpoint.business_bank_details.bank_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account Holder's Name:")]), _vm._v(" " + _vm._s(_vm.sellpoint.business_bank_details.bank_account_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account No:")]), _vm._v(" " + _vm._s(_vm.sellpoint.business_bank_details.bank_account_number))]), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("you can edit or change bank details")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('editBankDetails', '')
      }
    }
  }, [_vm._v("Edit Bank Details")])]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card card-out-colord-pad mt1"
  }, [_vm._m(1), _vm._v(" "), ((_vm.sellpoint.business_processing_fee_balance >= 0)) ? _c('p', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("Processing Fee Balance: "), _c('b', [(_vm.sellpoint.business_processing_fee_balance < 1000) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_processing_fee_balance))]) : _c('span', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.sellpoint.business_processing_fee_balance))])])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('viewProcessingFees')
      }
    }
  }, [_vm._v("Set")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.menu_tab_inner_view.viewProcessingFees || _vm.menu_tab_inner_view.addProcessingFees) ? _c('div', [_c('div', [_c('h6', [_vm._v("Processing Fee Balance")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("Processing Fee Balance: "), _c('b', [(_vm.sellpoint.business_processing_fee_balance < 1000) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_processing_fee_balance))]) : _c('span', [_vm._v(_vm._s(_vm.sellpoint.business_processing_fee_balance))])])]), _vm._v(" "), ((_vm.sellpoint.business_processing_fee_balance < 2000) && (_vm.sellpoint.business_processing_fee_balance > 0)) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("\n                        Processing Fee is running low\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_processing_fee_balance == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("\n                        Processing Fee is low\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_processing_fee_debt > 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("\n                        Processing Fee is low and you are owing processing fee charge of "), _c('span', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v(" -" + _vm._s(_vm.sellpoint.business_processing_fee_debt))])]) : _vm._e(), _vm._v(" "), (!_vm.menu_tab_inner_view.addProcessingFees) ? _c('a', {
    staticClass: "btn sp-button-02 sp-button-md",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('addProcessingFees')
      }
    }
  }, [_vm._v("Add Processing Fees")]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view.addProcessingFees) ? _c('div', [_c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Enter Amount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.processing_fee.amount),
      expression: "processing_fee.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.processing_fee.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.processing_fee.amount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.addtoProcessingFee()
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card card-colord-01 card-colord-pad mt1"
  }, [_vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Set how you would want to settle your proccessing fees")]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('setProcessingFees')
      }
    }
  }, [_vm._v("Set")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.menu_tab_inner_view.setProcessingFees || _vm.menu_tab_inner_view.setProcessingFees) ? _c('div', [_c('h6', [_vm._v("Set Processing Fee Option")]), _vm._v(" "), _c('p', [_vm._v("Each sale of an Item attracts a processing fee. The processng fee could\n                      be paid by you as you set your product, or by your customers as they buy. \n                      Processing Fees are subject to change.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#363535"
    }
  }, [_vm._v("Processing Fee is set to: 13% of your product Item")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "info info-processing"
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.sellpoint.business_processing_fee_pay_status == 3) ? _c('span', [_vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("Switch Pay to your Custmers, notice this would increase the amount they pay on checkout")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.switchProcessingFee(4)
      }
    }
  }, [_vm._v("Switch Pay to your Custmers")])]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_processing_fee_pay_status == 4) ? _c('span', [_vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Switch Pay back to you, and let your Customers enjoy to pay only for their orders on checkout")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.switchProcessingFee(3)
      }
    }
  }, [_vm._v("Switch Pay Back to Me")])]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card card-out-colord-pad mt1"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('p', [_vm._v("Ravepay  - Direct Personal Integration")]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("You would be directed to Ravepay Website to create and set up your account")]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('setRavepay')
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.menu_tab_inner_view.setRavepay) ? _c('div', [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set Ravepay Details")]), _vm._v(" "), _c('p', [_vm._v("This account is where your payout would be sent to.")]), _vm._v(" "), (_vm.sellpoint.business_ravepay_accounts && (Object.keys(_vm.sellpoint.business_ravepay_accounts).length > 0)) ? _c('div', [_c('p', [_vm._v("Accounts on Ravepay")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_ravepay_accounts), function(pg) {
    return _c('div', {
      key: pg.account_email,
      staticClass: "card"
    }, [_vm._v("\n                          " + _vm._s(pg.account_email) + "\n                        ")])
  })], 2) : _c('p', {
    staticClass: "info-processing"
  }, [_vm._v("No Ravepay Account set yet")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]), _vm._v(" "), _vm._m(8)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Bank Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Processing Fees Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("To keep receiving Buyers Order transfers "), _c('b', [_vm._v("*directly*")]), _vm._v(" to your Bank Account, please ensure your Processing Fee\n                      is not zero or below")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Processing Fees Settings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Status:")]), _vm._v(" Paid by Me ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Status:")]), _vm._v(" Paid by My Customers")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Set your Payment Collection Gateway")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://ravepay.co",
      "target": "_blank"
    }
  }, [_vm._v("Checkout Ravepay")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('p', [_vm._v("Paystack  - Direct Personal Integration")]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("You would be directed to Paystack Website to create and set up your account")])])
}]}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container card-box"
  }, [_c('div', {
    staticClass: "row card-box-o"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-6 col-sm-offset-1"
  }, [_c('div', {
    staticClass: "sp1-reg",
    staticStyle: {
      "background": "#ffffff",
      "padding": "2em",
      "padding-top": "0",
      "border-radius": "2px"
    }
  }, [(_vm.loading) ? _c('div', [_vm._m(0)]) : _c('div', {
    staticClass: "card"
  }, [_c('div', [_c('div', {
    staticClass: "card"
  }, [_c('form', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Price")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_price),
      expression: "product.product_price"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "number",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.product.product_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Details")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#43a1fa"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "color": "#000000",
      "background-color": "#e8fa43"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.editProduct()
      }
    }
  }, [_vm._v("Save Details")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Product Images")]), _vm._v(" "), _c('div', {
    staticClass: "category-slide"
  }, [_c('ul', _vm._l((_vm.product.product_images), function(img) {
    return _c('li', {
      staticStyle: {
        "width": "30%"
      }
    }, [(img.product_image && (img.product_image != '' && img.product_image != 'error')) ? _c('img', {
      staticClass: "pb_img",
      attrs: {
        "src": _vm.img_product_url + img.product_image,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "pb_img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs sp-button-02 sp-button-sm sp-button-style-1",
      staticStyle: {
        "font-size": "12px",
        "padding": "6px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteProductImage(img.product_image_id)
        }
      }
    }, [_vm._v("Remove")])])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.product.product_images && (_vm.product.product_images.length > 1)) ? _c('div', [_c('hr'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-transform": "uppercase"
    }
  }, [_vm._v(_vm._s(_vm.product.product_images.length) + " pictures, Swipe >>")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [(_vm.action_loading && _vm.product_details.uploading_image) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "upload-btn sp-button-02 sp-button-sm",
    staticStyle: {
      "line-height": "1.8",
      "font-size": "14px",
      "background-color": "#f7f7f7"
    }
  }, [_vm._v("Add new Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'products', _vm.product.product_id)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    key: _vm.componentKey,
    staticClass: "row"
  }, [_c('h3', [_vm._v("Order Addons")]), _vm._v(" "), _c('p', [_vm._v("Add Items that could be ordered together with this Order")]), _vm._v(" "), ((_vm.product.product_addons && (Object.keys(_vm.product.product_addons).length > 0))) ? _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.product.product_addons), function(product, index) {
    return _c('div', {
      staticClass: "card col-xs-4"
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + _vm.user.business_username
      }
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "card-avatar-square",
      staticStyle: {
        "width": "100px",
        "height": "95px"
      }
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block",
        "padding": "3px",
        "padding-left": "2em",
        "text-align": "center"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(product.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setAddToProductAddons(product)
        }
      }
    }), _vm._v("Remove\r\n                                    ")])])])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-sm",
    staticStyle: {
      "float": "right",
      "background": "#ff0066",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.removeProductAddons()
      }
    }
  }, [_vm._v("Done, remove Products to Add-ons")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "0.2em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('setProductAddons')
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), (_vm.menu_tab_inner_view['setProductAddons']) ? _c('div', [((Object.keys(_vm.set_product_addons).length > 0)) ? _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.set_product_addons), function(prd, index) {
    return (_vm.product.product_id != prd.product_id) ? _c('div', {
      staticClass: "card col-xs-4"
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "card-avatar-square",
      staticStyle: {
        "width": "100px",
        "height": "95px"
      }
    }, [(prd.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": prd.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block",
        "padding": "3px",
        "padding-left": "2em",
        "text-align": "center"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(prd.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(prd.product_items[0].product_item_price_f))])]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setAddToProductAddons(prd)
        }
      }
    })])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px",
      "display": "none"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-sm",
    staticStyle: {
      "float": "right",
      "background": "#ff0066",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.addToProductAddons()
      }
    }
  }, [_vm._v("Done, Add Products to Add-ons")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('form', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_product.product_name),
      expression: "set_product.product_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.set_product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.set_product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Price")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_product.product_price),
      expression: "set_product.product_price"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "number",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.set_product.product_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.set_product.product_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Details")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_product.product_description),
      expression: "set_product.product_description"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.set_product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.set_product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Product Photo ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "prImagePreview"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sp-form-descr"
  }, [_vm._v("Maximum Upload Size " + _vm._s(_vm.max_upload))]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Upload Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeNewProduct($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading && _vm.product_details.uploading_image) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "color": "#000000",
      "background-color": "#e8fa43"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddProductAsAddon(_vm.set_product)
      }
    }
  }, [_vm._v("Add")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Settings")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "0.2em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('contactDetails')
      }
    }
  }, [_vm._m(2)]), _vm._v(" "), (_vm.menu_tab_inner_view['contactDetails']) ? _c('div', [_c('div', [_c('h4', [_vm._v("Contact Details")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.sellpoint.business_phones))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.sellpoint.business_emails))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('editBusinessDetails');
      }
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "editBusinessDetails"
    }
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_name),
      expression: "sellpoint.business_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.sellpoint.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_phones),
      expression: "sellpoint.business_phones"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.sellpoint.business_phones)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_phones = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_emails),
      expression: "sellpoint.business_emails"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.sellpoint.business_emails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_emails = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('main')
      }
    }
  }, [_vm._v("Save Details")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('editBusinessDetails')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center",
      "padding-top": "0.2em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('bankDetails')
      }
    }
  }, [_vm._m(3)]), _vm._v(" "), (_vm.menu_tab_inner_view['bankDetails']) ? _c('div', {
    attrs: {
      "id": "bankDetails"
    }
  }, [_c('div', {
    staticClass: "card card-colord-01 card-colord-pad"
  }, [_vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Add your Bank Details to receive order payments")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [((!_vm.setEditBankDetails && (Object.keys(_vm.business_bank_details).length > 0))) ? _c('div', [_c('p', [_c('b', [_vm._v("Bank:")]), _vm._v(" " + _vm._s(_vm.business_bank_details.bank_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account Holder's Name:")]), _vm._v(" " + _vm._s(_vm.business_bank_details.bank_account_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account No:")]), _vm._v(" " + _vm._s(_vm.business_bank_details.bank_account_number))]), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("you can edit or change bank details")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setEditBankDetails = true;
      }
    }
  }, [_vm._v("Edit Bank Details")])]) : _vm._e(), _vm._v(" "), (((Object.keys(_vm.business_bank_details).length == 0) || _vm.setEditBankDetails)) ? _c('form', {
    staticClass: "sp-form",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(_vm.ravepay_bank_list && ((Object.keys(_vm.ravepay_bank_list).length == 0))) ? _c('div', [_vm._m(5)]) : _c('div', [_c('label', [_c('b', [_vm._v("Bank Name:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_bank_details.bank_name),
      expression: "business_bank_details.bank_name"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business_bank_details.bank_name = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select your bank")]), _vm._v(" "), _vm._l((_vm.ravepay_bank_list), function(bank) {
    return _c('option', {
      domProps: {
        "value": bank.Name
      }
    }, [_vm._v(_vm._s(bank.Name))])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_bank_details.bank_account_name),
      expression: "business_bank_details.bank_account_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.business_bank_details.bank_account_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business_bank_details.bank_account_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account No:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_bank_details.bank_account_number),
      expression: "business_bank_details.bank_account_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.business_bank_details.bank_account_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business_bank_details.bank_account_number = $event.target.value
      }
    }
  })]), _vm._v(" "), ((Object.keys(_vm.sellpoint).length > 0)) ? _c('div', [_c('p', {
    staticClass: "tiny-p"
  }), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.setBankDetails
    }
  }, [_vm._v("Save Bank Details")])]) : _vm._e()])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center",
      "padding-top": "0.2em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('deliveryLocations')
      }
    }
  }, [_vm._m(6)]), _vm._v(" "), (_vm.menu_tab_inner_view['deliveryLocations']) ? _c('div', {
    attrs: {
      "id": "deliveryLocations"
    }
  }, [((!_vm.setAddDeliveryLocation && (Object.keys(_vm.business_delivery_locations).length > 0))) ? _c('div', [_c('h3', [_vm._v("Delivery Locations")]), _vm._v(" "), _vm._l((_vm.business_delivery_locations), function(location, index) {
    return _c('div', [_c('p', [_vm._v(_vm._s(++index) + " - " + _vm._s(location.business_delivery_state) + " - " + _vm._s(location.business_delivery_option) + " - " + _vm._s(location.business_delivery_option_price) + "\r\n                                    "), _c('br'), _vm._v(" "), _c('span', [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('DL-CHANGE-PRICE-' + index)
        }
      }
    }, [_vm._v("Change Price")]), _vm._v("  | \r\n                                      "), _c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('DL-REMOVE-' + index)
        }
      }
    }, [_vm._v("Remove")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-box",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'DL-CHANGE-PRICE-' + index
      }
    }, [_c('p', [_c('b', [_vm._v("Current Price: ")]), _vm._v(_vm._s(location.business_delivery_option_price))]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Delivery Price")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (location.business_delivery_option_price),
        expression: "location.business_delivery_option_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (location.business_delivery_option_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          location.business_delivery_option_price = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.delivery_option = location;
          _vm.set_single_component_view = 'DL-CHANGE-PRICE-' + index;
          _vm.editDeliveryOption();
        }
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-box",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'DL-REMOVE-' + index
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Do you want to delete this location.")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.delivery_option = location;
          _vm.set_single_component_view = 'DL-REMOVE-' + index;
          _vm.deleteDeliveryOption(location.business_delivery_option_id);
        }
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('div'), _vm._v(" "), _c('hr')])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddDeliveryLocation = true;
      }
    }
  }, [_vm._v("Add Delivery Locations")])], 2) : _vm._e(), _vm._v(" "), (((Object.keys(_vm.business_delivery_locations).length == 0) || _vm.setAddDeliveryLocation)) ? _c('div', {
    key: _vm.componentDeliveryKey,
    staticClass: "card"
  }, [_c('h5', [_vm._v("Add a Delivery Location and Price")]), _vm._v(" "), (_vm.states && (Object.keys(_vm.states).length == 0)) ? _c('div', [_vm._m(7)]) : _c('div', [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.state),
      expression: "delivery_option.state"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.delivery_option.state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      key: state.state_id,
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.action_loading) ? _c('div', [_c('p', [_vm._v("...loading cities")])]) : _vm._e(), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.city),
      expression: "delivery_option.city"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOtherOptions(_vm.delivery_option.city, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      key: city.city_id,
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other Areas / Cities ")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.other_delivery_option) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_other_option),
      expression: "delivery_option.delivery_other_option"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "eg. Abuja"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_other_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_other_option = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Free Delivery?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_free),
      expression: "delivery_option.delivery_option_free"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.delivery_option.delivery_option_free) ? _vm._i(_vm.delivery_option.delivery_option_free, null) > -1 : (_vm.delivery_option.delivery_option_free)
    },
    on: {
      "click": function($event) {
        _vm.setFreeDelivery(1)
      },
      "__c": function($event) {
        var $$a = _vm.delivery_option.delivery_option_free,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.delivery_option.delivery_option_free = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.delivery_option.delivery_option_free = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.delivery_option.delivery_option_free = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.delivery_option.delivery_option_free != 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Delivery Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_price),
      expression: "delivery_option.delivery_option_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "eg. 1000"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_option_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_option_price = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (((Object.keys(_vm.sellpoint).length > 0) && (_vm.sellpoint.business_id > 0))) ? _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addDeliveryOption()
      }
    }
  }, [_vm._v("Add")]) : _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddDeliveryOptions(_vm.delivery_option)
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddDeliveryLocation = false;
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()]) : _vm._e()])])])])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "background": "#fff",
      "border-radius": "5px",
      "padding": "10px",
      "margin": "5px 5vw",
      "box-shadow": "0 7px 30px -10px rgba(150,170,180,0.5)"
    }
  }, [_vm._v("Add Addons "), _c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "font-size": "18px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "background": "#fff",
      "border-radius": "5px",
      "padding": "10px",
      "margin": "5px 35vw",
      "box-shadow": "0 7px 30px -10px rgba(150,170,180,0.5)"
    }
  }, [_vm._v("Contact Details "), _c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "font-size": "18px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "background": "#fff",
      "border-radius": "5px",
      "padding": "10px",
      "margin": "5px 35vw",
      "box-shadow": "0 7px 30px -10px rgba(150,170,180,0.5)"
    }
  }, [_vm._v("Manage "), _c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "font-size": "18px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Bank Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "background": "#fff",
      "border-radius": "5px",
      "padding": "10px",
      "margin": "5px 35vw",
      "box-shadow": "0 7px 30px -10px rgba(150,170,180,0.5)"
    }
  }, [_vm._v("Manage "), _c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "font-size": "18px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
}]}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    staticStyle: {
      "background-color": "#711ae4",
      "margin-top": "-5em"
    },
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "pager"
  }, [_c('div', {}, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "2em",
      "margin-left": "3em",
      "margin-top": "10em",
      "text-align": "center"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('h3', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "text-transform": "uppercase",
      "letter-spacing": "7px"
    }
  }, [_vm._v(_vm._s(_vm.app_name))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ececec"
    }
  }, [_vm._v("Smart Shopping")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/assets/images/ms-guy.png"
    }
  })])
}]}

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create-post"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9 col-sm-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('img', {
    staticClass: "profile-photo-md",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_words),
      expression: "search_words"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "texts",
      "id": "exampleTextarea",
      "cols": "100",
      "rows": "1",
      "placeholder": "Search: enter name or handle or hashtag"
    },
    domProps: {
      "value": (_vm.search_words)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_words = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-left": "5em"
    }
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_type),
      expression: "search_type"
    }],
    attrs: {
      "type": "radio",
      "value": "business",
      "id": "business"
    },
    domProps: {
      "checked": _vm._q(_vm.search_type, "business")
    },
    on: {
      "__c": function($event) {
        _vm.search_type = "business"
      }
    }
  }), _vm._v("Business\n                  ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_type),
      expression: "search_type"
    }],
    attrs: {
      "type": "radio",
      "value": "product",
      "id": "product"
    },
    domProps: {
      "checked": _vm._q(_vm.search_type, "product")
    },
    on: {
      "__c": function($event) {
        _vm.search_type = "product"
      }
    }
  }), _vm._v("Product/Service\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-3"
  }, [_c('div', {
    staticClass: "tools"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.search
    }
  }, [_vm._v("Search")])])])])])
},staticRenderFns: []}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "detail-card card-colord-pad card-colord-01"
  }, [_c('h5', [_vm._v("Shipping Information ")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _c('div', [_c('br'), _vm._v(" "), _c('h6', [_vm._v("Delivery Locations and Prices")]), _vm._v(" "), (_vm.sellpoint.business_delivery_options && (_vm.sellpoint.business_delivery_options.length == 0)) ? _c('p', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("\n        You have not set any delivery location\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.business_details.delivery_add && !_vm.business_details.delivery_add_by_dco) ? _c('div', _vm._l((_vm.business_delivery_options_nodes), function(delivery_option_node, dvsndex) {
    return _c('div', {
      key: delivery_option_node.state_id,
      staticClass: "card-flat-pad"
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(delivery_option_node.state_name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('button', {
      staticClass: "btn sp-button-sm",
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView(_vm.menu_tab_inner_view['DVOP_S' + dvsndex] ? ' ' : 'DVOP_S' + dvsndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (_vm.menu_tab_inner_view['DVOP_S' + dvsndex]) ? _c('div', {
      staticClass: "card card-flat-pad"
    }, _vm._l((delivery_option_node.state_locations), function(delivery_option) {
      return _c('div', {
        key: delivery_option.business_delivery_option
      }, [(_vm.business_details.delivery_option_edit && delivery_option.edit_set) ? _c('div', {
        key: _vm.componentDeliveryKey,
        staticClass: "contact_form"
      }, [_c('h5', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Editing " + _vm._s(delivery_option.business_delivery_option))]), _vm._v(" "), (delivery_option.business_delivery_is_custom && (delivery_option.business_delivery_is_custom == 1)) ? _c('div', [_c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v("Delivery Location")]), _vm._v(" "), _c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (delivery_option.business_delivery_custom_option),
          expression: "delivery_option.business_delivery_custom_option"
        }],
        staticClass: "form-control",
        domProps: {
          "value": (delivery_option.business_delivery_custom_option)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            delivery_option.business_delivery_custom_option = $event.target.value
          }
        }
      })])]) : _c('div', [_c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v("State: "), _c('b', [_vm._v(_vm._s(delivery_option.business_delivery_state))])]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (delivery_option.business_delivery_state_id),
          expression: "delivery_option.business_delivery_state_id"
        }],
        staticClass: "form-control",
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            delivery_option.business_delivery_state_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
          }, function($event) {
            _vm.getCities(delivery_option.business_delivery_state_id, 'edit')
          }]
        }
      }, [_c('option', {
        domProps: {
          "value": undefined
        }
      }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
        return _c('option', {
          key: state.state_id,
          domProps: {
            "value": state.state_id
          }
        }, [_vm._v(_vm._s(state.name))])
      })], 2)]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v("City: "), _c('b', [_vm._v(_vm._s(delivery_option.business_delivery_option))])]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (delivery_option.city),
          expression: "delivery_option.city"
        }],
        staticClass: "form-control",
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
          }, function($event) {
            _vm.setOtherOptions(delivery_option.city, 'edit')
          }]
        }
      }, [_c('option', {
        domProps: {
          "value": undefined
        }
      }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "all"
        }
      }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
        return _c('option', {
          key: city.city_id,
          domProps: {
            "value": city.city_id
          }
        }, [_vm._v(_vm._s(city.city_name))])
      }), _vm._v(" "), _c('option', {
        attrs: {
          "value": "other"
        }
      }, [_vm._v("Other Areas / Cities ")])], 2)]), _vm._v(" "), (_vm.edit_other_delivery_option) ? _c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (delivery_option.business_delivery_other_option),
          expression: "delivery_option.business_delivery_other_option"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "placeholder": "eg. Abuja"
        },
        domProps: {
          "value": (delivery_option.business_delivery_other_option)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            delivery_option.business_delivery_other_option = $event.target.value
          }
        }
      }), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v("Free Delivery?")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (delivery_option.business_delivery_option_free),
          expression: "delivery_option.business_delivery_option_free"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(delivery_option.business_delivery_option_free) ? _vm._i(delivery_option.business_delivery_option_free, null) > -1 : (delivery_option.business_delivery_option_free)
        },
        on: {
          "click": function($event) {
            _vm.setFreeDelivery(2)
          },
          "__c": function($event) {
            var $$a = delivery_option.business_delivery_option_free,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (delivery_option.business_delivery_option_free = $$a.concat($$v))
              } else {
                $$i > -1 && (delivery_option.business_delivery_option_free = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              delivery_option.business_delivery_option_free = $$c
            }
          }
        }
      })]), _vm._v(" "), (delivery_option.business_delivery_option_free != 1) ? _c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v("Delivery Amount")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (delivery_option.business_delivery_option_price),
          expression: "delivery_option.business_delivery_option_price"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "required": ""
        },
        domProps: {
          "value": (delivery_option.business_delivery_option_price)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            delivery_option.business_delivery_option_price = $event.target.value
          }
        }
      })]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [(_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e(), _vm._v(" "), _c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
        staticClass: "btn sp-button-02",
        staticStyle: {
          "line-height": "1.6",
          "padding": "10px"
        },
        attrs: {
          "disabled": _vm.disable_btn,
          "title": "save",
          "type": "submit"
        },
        on: {
          "click": _vm.editDeliveryOption
        }
      }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
        staticClass: "btn sp-button-02",
        staticStyle: {
          "line-height": "1.6",
          "padding": "10px"
        },
        attrs: {
          "title": "cancel",
          "type": "submit"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('reset-edit', '')
          }
        }
      }, [_vm._v("Cancel")])])]) : _c('div', [(delivery_option.business_delivery_product == 0) ? _c('div', [(((_vm.sellpoint.business_category_id != 37) && (delivery_option.business_is_delivery_business == 1))) ? _c('span', {
        staticStyle: {
          "font-size": "12px",
          "color": "#96c5f5"
        }
      }, [_vm._v(_vm._s(delivery_option.business_delivery_business_name)), _c('br')]) : _vm._e(), _vm._v("\n                            " + _vm._s(delivery_option.business_delivery_option) + " - " + _vm._s(delivery_option.business_delivery_option_price) + "\n                            "), (_vm.sellpoint.business_id == delivery_option.business_delivery_option_business) ? _c('span', [_c('button', {
        staticClass: "btn sp-button-02 sp-button-sm",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('edit-delivery-option', delivery_option)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil"
      })]), _vm._v(" "), _c('button', {
        staticClass: "btn sp-button-02 sp-button-sm",
        attrs: {
          "disabled": _vm.disable_btn,
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.deleteDeliveryOption(delivery_option.business_delivery_option_id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })]), _vm._v(" "), (_vm.sellpoint.business_category_id == 37) ? _c('button', {
        staticClass: "btn sp-button-02 sp-button-sm",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('set-business-details', 'delivery_add_by_dco');
            _vm.setDeliveryOptionParams(delivery_option, 'add-new-from');
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-plus"
      })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      }), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "none"
        },
        attrs: {
          "id": "vfo"
        }
      }, _vm._l((delivery_option.business_delivery_from_points_states_nodes), function(delivery_option_from_node, dvfndex) {
        return _c('div', {
          key: delivery_option_from_node.state_id,
          staticClass: "card-flat-pad"
        }, [_c('div', {
          staticStyle: {
            "float": "left"
          }
        }, [_c('b', [_vm._v(_vm._s(delivery_option_from_node.state_name))])]), _vm._v(" "), _c('div', {
          staticStyle: {
            "float": "right"
          }
        }, [_c('button', {
          staticClass: "btn sp-button-sm",
          on: {
            "click": function($event) {
              _vm.toggleSingleComponent('vfn' + dvfndex)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-angle-down"
        })])]), _vm._v(" "), _c('div', {
          staticStyle: {
            "clear": "both"
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "card card-flat-pad",
          staticStyle: {
            "display": "none"
          },
          attrs: {
            "id": 'vfn' + dvfndex
          }
        }, _vm._l((delivery_option_from_node.state_locations), function(dv_from) {
          return _c('div', {
            key: dv_from.business_delivery_option_id
          }, [_vm._v("\n                                      " + _vm._s(dv_from.business_delivery_from_location) + " "), _c('b', [_vm._v("to")]), _vm._v(" " + _vm._s(delivery_option.business_delivery_option) + " - " + _vm._s(dv_from.business_delivery_from_price) + "\n                                      "), _c('button', {
            staticClass: "btn sp-button-02 sp-button-sm",
            attrs: {
              "type": "button"
            },
            on: {
              "click": function($event) {
                _vm.setComponent('edit-delivery-option', delivery_option)
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-pencil"
          })]), _vm._v(" "), _c('button', {
            staticClass: "btn sp-button-02 sp-button-sm",
            attrs: {
              "disabled": _vm.disable_btn,
              "type": "button"
            },
            on: {
              "click": function($event) {
                _vm.updateDeliveryFromOption('delete-delivery-from', dv_from)
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-trash"
          })]), _vm._v(" "), (_vm.sellpoint.business_category_id == 37) ? _c('button', {
            staticClass: "btn sp-button-02 sp-button-sm",
            attrs: {
              "type": "button"
            },
            on: {
              "click": function($event) {
                _vm.setComponent('set-business-details', 'delivery_add_by_dco');
                _vm.setDeliveryOptionParams(delivery_option, 'add-new-from');
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-plus"
          })]) : _vm._e(), _vm._v(" "), _c('a', {
            staticStyle: {
              "cursor": "pointer",
              "color": "inherit"
            },
            on: {
              "click": function($event) {
                _vm.toggleSingleComponent('vfo')
              }
            }
          }, [_vm._m(1, true)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
            staticClass: "form-group"
          }, [_c('label', [_vm._v("Update Delivery Amount")]), _vm._v(" "), _c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (dv_from.business_delivery_from_price),
              expression: "dv_from.business_delivery_from_price"
            }],
            staticClass: "form-control",
            attrs: {
              "type": "number",
              "required": ""
            },
            domProps: {
              "value": (dv_from.business_delivery_from_price)
            },
            on: {
              "input": function($event) {
                if ($event.target.composing) { return; }
                dv_from.business_delivery_from_price = $event.target.value
              }
            }
          })]), _vm._v(" "), _c('div', {
            staticClass: "form-group"
          }, [(_vm.action_loading) ? _c('div', {
            staticClass: "loading-sm"
          }) : _vm._e(), _vm._v(" "), _c('p', {
            staticStyle: {
              "color": "#ff0000"
            }
          }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
            staticClass: "btn sp-button-02 sp-button-sm",
            staticStyle: {
              "line-height": "1.6",
              "padding": "10px"
            },
            attrs: {
              "disabled": _vm.disable_btn,
              "title": "save",
              "type": "submit"
            },
            on: {
              "click": function($event) {
                _vm.updateDeliveryFromOption('edit-delivery-from', dv_from)
              }
            }
          }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
            staticClass: "btn sp-button-02 sp-button-sm",
            staticStyle: {
              "line-height": "1.6",
              "padding": "10px"
            },
            attrs: {
              "title": "cancel",
              "type": "submit"
            },
            on: {
              "click": function($event) {
                _vm.setComponent('reset-edit', '')
              }
            }
          }, [_vm._v("Cancel")])])])
        }))])
      }))]) : _vm._e()])])
    })) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [(!_vm.business_details.delivery_add) ? _c('div', [(_vm.sellpoint.business_category_id == 37) ? _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'delivery_add_by_dco')
      }
    }
  }, [_vm._v("Set New Delivery Location")]) : _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'delivery_add')
      }
    }
  }, [_vm._v("Add New Delivery Information")])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [(_vm.sellpoint.business_category_id != 37) ? _c('div', [(!_vm.business_details.delivery_add) ? _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('addDeliveryPartner')
      }
    }
  }, [_vm._v("Add A Delivery / logistics partner")]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view.addDeliveryPartner) ? _c('div', [_c('h3', [_vm._v("Select Delivery Partner")]), _vm._v(" "), _vm._l((_vm.delivery_partners), function(dp) {
    return _c('div', {
      key: dp.business_delivery_partner_name
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.addDeliveryPartner(dp)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(dp.business_delivery_partner_name))])])])
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('hr')])]), _vm._v(" "), (_vm.business_details.delivery_add) ? _c('div', {
    key: _vm.componentDeliveryKey,
    staticClass: "card"
  }, [_c('h5', [_vm._v("Add a Delivery Location and Price")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.state),
      expression: "delivery_option.state"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.delivery_option.state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      key: state.state_id,
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.action_loading) ? _c('div', [_c('p', [_vm._v("...loading cities")])]) : _vm._e(), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.city),
      expression: "delivery_option.city"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOtherOptions(_vm.delivery_option.city, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      key: city.city_id,
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other Areas / Cities ")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.other_delivery_option) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_other_option),
      expression: "delivery_option.delivery_other_option"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "eg. Abuja"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_other_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_other_option = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Free Delivery?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_free),
      expression: "delivery_option.delivery_option_free"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.delivery_option.delivery_option_free) ? _vm._i(_vm.delivery_option.delivery_option_free, null) > -1 : (_vm.delivery_option.delivery_option_free)
    },
    on: {
      "click": function($event) {
        _vm.setFreeDelivery(1)
      },
      "__c": function($event) {
        var $$a = _vm.delivery_option.delivery_option_free,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.delivery_option.delivery_option_free = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.delivery_option.delivery_option_free = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.delivery_option.delivery_option_free = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.delivery_option.delivery_option_free != 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Delivery Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_price),
      expression: "delivery_option.delivery_option_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "eg. 1000"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_option_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_option_price = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.addDeliveryOption
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e(), _vm._v(" "), (_vm.business_details.delivery_add_by_dco) ? _c('div', {
    key: _vm.deliveryAddByDcoKey,
    staticClass: "card"
  }, [_c('h5', [_vm._v("Add a new Delivery Location and Price")]), _vm._v(" "), ((_vm.delivery_option.city) || ((_vm.delivery_option.business_delivery_city) && (_vm.delivery_option.business_delivery_city > 0))) ? _c('div', [_c('p', [_vm._v("Delivering to "), _c('b', [_vm._v(_vm._s(_vm.delivery_option.business_delivery_option))])]), _vm._v(_vm._s(_vm.delivery_option.business_delivery_option_id) + "\n                      ")]) : _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custom_delivery_option),
      expression: "custom_delivery_option"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.custom_delivery_option) ? _vm._i(_vm.custom_delivery_option, null) > -1 : (_vm.custom_delivery_option)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.custom_delivery_option,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.custom_delivery_option = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.custom_delivery_option = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.custom_delivery_option = $$c
        }
      }
    }
  }), _vm._v(" Do you want to add customised delivery locations(Suitable for Countries outside Nigeria)\n                        "), (_vm.custom_delivery_option) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Delivery Location")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_custom_option),
      expression: "delivery_option.delivery_custom_option"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "eg. Country, City, Location"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_custom_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_custom_option = $event.target.value
      }
    }
  })])]) : _c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.state),
      expression: "delivery_option.state"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.delivery_option.state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      key: state.state_id,
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.action_loading) ? _c('div', [_c('p', [_vm._v("...loading cities")])]) : _vm._e(), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name of Location")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.city),
      expression: "delivery_option.city"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOtherOptions(_vm.delivery_option.city, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      key: city.city_id,
      domProps: {
        "value": city
      }
    }, [_vm._v(_vm._s(city.city_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other Areas / Cities ")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.other_delivery_option) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_other_option),
      expression: "delivery_option.delivery_other_option"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "eg. Abuja"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_other_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_other_option = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e()])]), _vm._v(" "), ((_vm.delivery_option.city) || ((_vm.delivery_option.business_delivery_city) && (_vm.delivery_option.business_delivery_city > 0))) ? _c('div', {
    staticClass: "card card-flat-pad"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.dvco_state),
      expression: "delivery_option.dvco_state"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.dvco_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.set_dvco_delivery_option = true;
        _vm.getCities(_vm.delivery_option.dvco_state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      key: state.state_id,
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.action_loading) ? _c('div', [_c('p', [_vm._v("...loading cities")])]) : _vm._e(), _vm._v(" "), (_vm.dvco_cities.length && _vm.dvco_cities.length != 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Locations")]), _vm._v(" "), _vm._l((_vm.dvco_cities), function(city, dvco_city_index) {
    return _c('div', {
      key: city.city_id
    }, [((_vm.delivery_option.city) && (_vm.delivery_option.city.length && _vm.delivery_option.city.length != 0)) ? _c('div', [_c('b', [_vm._v(_vm._s(city.city_name) + " -")]), _vm._v(" " + _vm._s(_vm.delivery_option.city.city_name)), _c('br')]) : _vm._e(), _vm._v(" "), (((_vm.delivery_option.business_delivery_option_id) && (_vm.delivery_option.business_delivery_option_id > 0))) ? _c('div', [_c('b', [_vm._v(_vm._s(city.city_name) + " -")]), _vm._v(" " + _vm._s(_vm.delivery_option.business_delivery_option)), _c('br')]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Delivery Charge: "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.dvco_cities[dvco_city_index].delivery_option_price),
        expression: "dvco_cities[dvco_city_index].delivery_option_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "placeholder": "eg. 1000"
      },
      domProps: {
        "value": (_vm.dvco_cities[dvco_city_index].delivery_option_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.dvco_cities[dvco_city_index].delivery_option_price = $event.target.value
        }
      }
    })])])
  })], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.dvco_cities.length && _vm.dvco_cities.length != 0) ? _c('div', [_c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.addDeliveryOption
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "padding": "0.15em",
      "border": "1px solid #000000",
      "border-radius": "50%"
    }
  }, [_c('b', [_vm._v("▼")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("What State is this location "), _c('span', {
    staticClass: "sp-form-descr sp-app-default-color"
  }, [_vm._v("You will add delivery points to this location")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticStyle: {
      "color": "#df4d4d"
    }
  }, [_vm._v("Set location "), _c('b', [_vm._v("FROM")]), _vm._v(" points")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Delivering from this State "), _c('span', {
    staticClass: "sp-form-descr sp-app-default-color"
  }, [_vm._v("You will add delivery points to this location")])])
}]}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.loadx) ? _c('div', {
    staticClass: "form-card"
  }, [_c('h3', [_vm._v("Add new product")]), _vm._v(" "), _c('h4', [_c('u', [_vm._v(_vm._s(_vm.category.business_category))])]), _vm._v(" "), (_vm.subscription_offer.products && (_vm.subscription_offer.products.service_offer_active == 1)) ? _c('div', [_c('form', {
    staticClass: "sp-form"
  }, [_c('h6', [_vm._v("Add New "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.is_product_service))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Product Photo ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "prImagePreview"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sp-form-descr"
  }, [_vm._v("Maximum Upload Size " + _vm._s(_vm.max_upload))]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Upload Display "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.is_product_service))]), _vm._v(" Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeNewProduct($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('td', [_vm._v("Name")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name of Product / Service"
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Price")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "change": function($event) {
        _vm.numStrip()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('h5', [_vm._v("Product Details")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.product_set_details), function(detail, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_set_details[index].title),
        expression: "product_set_details[index].title"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.product_set_details[index].title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_set_details[index].title = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "75%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_set_details[index].detail),
        expression: "product_set_details[index].detail"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.product_set_details[index].detail)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_set_details[index].detail = $event.target.value
        }
      }
    })])])
  })], 2), _vm._v(" "), _c('h5', [_vm._v("Other details")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('td', [_vm._v("Weight(Kg)")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Product Adddotional Details")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#1a73da"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message)), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("ADD "), _c('span', {
    staticStyle: {
      "text-transform": "uppercase"
    }
  }, [_vm._v(_vm._s(_vm.is_product_service))])]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Cancel")])])])]) : _c('div', [(_vm.subscription_offer.products) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_c('b', [_vm._v("Sorry you can only add " + _vm._s(_vm.subscription_offer.products.service_offer_limit) + " product(s) on this plan")])]), _vm._v(" "), _c('router-link', {
    staticClass: "btn  sp-button-02 sp-button-sm",
    staticStyle: {
      "background-color": "#ff3c00"
    },
    attrs: {
      "to": '/purchase?upgrade=' + _vm.set_business.business_username
    }
  }, [_vm._v("Upgrade Shop")])], 1) : _c('div', [_vm._m(3)])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(You can always add more images or video on this post)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v("eg:")]), _vm._v(" Material: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "75%"
    }
  }, [_vm._v("Pure Leather")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Quantity"), _c('br'), _vm._v("in Stock")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_c('b', [_vm._v("Sorry no subscription details found, you cannot add products at the moment")])])
}]}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container card-box card-box-full"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "id": "login"
    }
  }, [_c('p', {
    staticClass: "sp-app-default-color",
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bolder"
    }
  }, [_vm._v("Log into your account")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-xs-offset-5",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('label', {}, [_vm._v("Email or Phone or Username")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "name": "Email",
      "title": "Enter Email",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('label', {}, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "password",
      "name": "password",
      "title": "Enter password",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn wnf-button",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticStyle: {
      "color": "#777777"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Forgot Password?")]), _vm._v(" or "), _c('a', {
    staticStyle: {
      "color": "#888888"
    },
    attrs: {
      "href": "/register"
    }
  }, [_vm._v("Register?")])])
}]}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin": "0.1em",
      "margin-top": "-0.2em"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card card-box"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h4', [_vm._v("Customers\r\n            "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "13px"
    }
  }, [_vm._v("Total: " + _vm._s(_vm.products.length))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', [_c('table', [_vm._m(1), _vm._v(" "), _vm._l((_vm.customers), function(data, index) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s((index + 1)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "80%"
      }
    }, [_c('div', {
      staticClass: "col-xs-2"
    }, [_c('div', {
      staticClass: "card-avatar-circle",
      staticStyle: {
        "width": "30px",
        "height": "30px"
      }
    }, [(data.customer_image && (data.customer_image != '')) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": data.customer_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10"
    }, [_c('p', [_vm._v(_vm._s(data.customer_name)), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x"
    }, [_vm._v(_vm._s(data.customer_phone))])])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(data.customer_total_items_purchased))]), _vm._v(" "), _vm._m(2, true)])
  })], 2)])])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-box"
  }, [_c('p', [_vm._v("Search for Customer")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "border-radius": "8px"
    },
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('th', [_vm._v("-")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding-left": "1em",
      "padding-bottom": "1em",
      "font-size": "0"
    }
  }, [_vm._v("item")]), _vm._v(" "), _c('th', [_vm._v("items"), _c('br'), _vm._v("bought")]), _vm._v(" "), _c('th', [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "5%"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    staticStyle: {
      "color": "#5703a5"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-box"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h4')]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "block",
      "position": "fixed",
      "width": "100%",
      "bottom": "4.6em",
      "background": "#ffffff",
      "z-index": "10000"
    },
    attrs: {
      "id": "xInfo"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "background-color": "rgb(41, 122, 245)",
      "border-radius": "18px",
      "color": "#ffffff"
    }
  }, [_vm._v("\r\n        Add Items to Shop")])])])])
}]}

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bottombar-large",
    staticStyle: {
      "margin-top": "5em",
      "margin-left": "-2em",
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/notifications"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), (_vm.notifications_alert > 0) ? _c('sup', {
    staticClass: "notify-alert"
  }, [_vm._v(_vm._s(_vm.notifications_alert))]) : _vm._e(), _c('br'), _c('span', [_vm._v("Notifications")])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "bottombar"
  }, [_c('div', [_vm._m(4), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/manage/items"
    }
  }, [_c('i', {
    staticClass: "fas fa-list",
    attrs: {
      "id": "m_orders"
    }
  }), (_vm.notifications_alert > 0) ? _c('sup', {
    staticClass: "notify-alert"
  }, [_vm._v(_vm._s(_vm.notifications_alert))]) : _vm._e(), _c('br'), _c('span', [_vm._v("Stock")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/manage/lists"
    }
  }, [_c('i', {
    staticClass: "fas fa-shopping-cart",
    attrs: {
      "id": "m_orders"
    }
  }), (_vm.notifications_alert > 0) ? _c('sup', {
    staticClass: "notify-alert"
  }, [_vm._v(_vm._s(_vm.notifications_alert))]) : _vm._e(), _c('br'), _c('span', [_vm._v("Lists")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/manage/customers"
    }
  }, [_c('i', {
    staticClass: "fas fa-users",
    attrs: {
      "id": "m_account"
    }
  }), (_vm.notifications_alert > 0) ? _c('sup', {
    staticClass: "notify-alert"
  }, [_vm._v(_vm._s(_vm.notifications_alert))]) : _vm._e(), _c('br'), _c('span', [_vm._v("Customers")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _c('br'), _c('span', [_vm._v("Feeds")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/shop"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  }), _c('br'), _c('span', [_vm._v("Bag")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/account"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _c('br'), _c('span', [_vm._v("Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _c('br'), _c('span', [_vm._v("Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/dashboard"
    }
  }, [_c('i', {
    staticClass: "fas fa-store-alt",
    attrs: {
      "id": "m_trending"
    }
  }), _c('br'), _c('span', [_vm._v("Shop")])])
}]}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.open_request) ? _c('div', {}, [(_vm.loading) ? _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "loading-md"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px",
      "color": "#000000"
    }
  }, [_vm._v("Preparing and Checking your Sellpoint for previously added products and services")])]) : _c('form', {
    staticClass: "gw-form"
  }, [_c('h6', [_vm._v("Add a New Product Lookbook to your Gallery")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.showGalleryForm) ? _c('div', [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_name),
      expression: "gallery.gallery_name"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "What's the Name of your Lookbook"
    },
    domProps: {
      "value": (_vm.gallery.gallery_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_description),
      expression: "gallery.gallery_description"
    }],
    attrs: {
      "placeholder": "What's this Lookbook all about"
    },
    domProps: {
      "value": (_vm.gallery.gallery_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_description = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.products.length > 0) ? _c('div', [_c('h6', {
    staticStyle: {
      "font-size": "16px",
      "margin-bottom": "1em"
    }
  }, [_vm._v("Do you want to add from your products?")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n                        " + _vm._s(this.selected_produts) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "row sp-products-row"
  }, _vm._l((_vm.products), function(p, pdex) {
    return _c('div', {
      key: pdex,
      staticClass: "col-xs-4",
      staticStyle: {
        "padding": "5px",
        "margin": "1em",
        "width": "10%",
        "height": "6em"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": p.product_name
      },
      on: {
        "click": function($event) {
          _vm.setComponent('add-to-gallery-product', p)
        }
      }
    }, [(p.product_images[0]) ? _c('div', {
      staticClass: "box-color-cube"
    }, [_c('sup', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (p.product_checked),
        expression: "p.product_checked"
      }],
      attrs: {
        "type": "checkbox",
        "id": p.product_id + 'PRDC'
      },
      domProps: {
        "checked": Array.isArray(p.product_checked) ? _vm._i(p.product_checked, null) > -1 : (p.product_checked)
      },
      on: {
        "__c": function($event) {
          var $$a = p.product_checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (p.product_checked = $$a.concat($$v))
            } else {
              $$i > -1 && (p.product_checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            p.product_checked = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('img', {
      staticClass: "product-select sp-prd-img",
      staticStyle: {
        "height": "5em",
        "width": "95%"
      },
      attrs: {
        "src": p.product_images[0].product_image,
        "id": p.product_id + 'PRD'
      }
    })]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "9px",
        "line-height": "1.2"
      }
    }, [_c('b', [_vm._v(_vm._s(p.product_name))])])])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', [_c('hr'), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ffcc00"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('show-add-product-form', '')
      }
    }
  }, [_c('b', [(_vm.products.length > 0) ? _c('span', [_vm._v(" Or ")]) : _vm._e(), _vm._v(" Add New Product / Service")])])]), _vm._v(" "), (_vm.showProductForm) ? _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('h6', [_vm._v("Add Product / Service")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn",
    staticStyle: {
      "background": "#cc6655",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('form', {
    staticClass: "gw-form",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "line-wrap"
  }, [_vm._v("Product")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.is_product_service),
      expression: "is_product_service"
    }],
    staticClass: "sp-radio-btn",
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "type": "radio",
      "value": "product"
    },
    domProps: {
      "checked": _vm._q(_vm.is_product_service, "product")
    },
    on: {
      "__c": function($event) {
        _vm.is_product_service = "product"
      }
    }
  }), _vm._v("\n                                           \n                                     "), _c('label', [_vm._v(" Service ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.is_product_service),
      expression: "is_product_service"
    }],
    staticClass: "sp-radio-btn",
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "type": "radio",
      "value": "service"
    },
    domProps: {
      "checked": _vm._q(_vm.is_product_service, "service")
    },
    on: {
      "__c": function($event) {
        _vm.is_product_service = "service"
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sp-form-descr"
  }, [_vm._v("is this a Product or Service?")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "Name of Product / Service"
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.sellpoint_categories.length > 0) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "category-type-1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-1')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_1
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('option', {
      key: category.business_category_id,
      attrs: {
        "disabled": _vm.category_type_1
      },
      domProps: {
        "value": category.business_category_id
      }
    }, [_vm._v(_vm._s(category.business_category))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [(_vm.sellpoint_categories.length > 0) ? _c('span', [_c('b', [_vm._v("Or ")])]) : _vm._e(), _vm._v(" Select from Related Categories ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main_category),
      expression: "main_category"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.main_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getSubCategories(_vm.main_category)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      key: category.category_id,
      domProps: {
        "value": category
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.sub_categories.length != 0) ? _c('label', [_vm._v(" Select a Category ")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_sub_category),
      expression: "product.product_sub_category"
    }],
    staticClass: "form-control category-type-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_sub_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-2')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_2
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(category) {
    return _c('option', {
      key: category.sub_category_id,
      attrs: {
        "disabled": _vm.category_type_2
      },
      domProps: {
        "value": category.sub_category_id
      }
    }, [_vm._v(_vm._s(category.sub_category_name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_listed_category),
      expression: "product.product_listed_category"
    }],
    attrs: {
      "disabled": _vm.category_type_3,
      "type": "text",
      "placeholder": "",
      "id": "category-type-3"
    },
    domProps: {
      "value": (_vm.product.product_listed_category)
    },
    on: {
      "change": function($event) {
        _vm.trackevent('category-type-3')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_listed_category = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    attrs: {
      "placeholder": "Provide details of your product/service"
    },
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.is_product_service == 'product') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Weight(Kg)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Quantity ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.is_product_service))]), _vm._v(" Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ee87a6"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message)), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ffcc00"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "pull-left btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("Add Product")]), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn",
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.canAddGallery) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ee87a6"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.addProductPost) ? _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProductPostGallery
    }
  }, [_vm._v("Add Post to Lookbook")]) : _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addGallery
    }
  }, [_vm._v("Add Lookbook")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]) : _vm._e()])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(your product lookbook is a collection or group of products you want to keep together as posts)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Product lookbook Name "), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("Select from your Products/Services to add to Lookbook")]), _vm._v(" (scroll to view all products)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(This would also be added to products in your sellpoint)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Name"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v(" Select from My Shop Categories"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v("Or ")]), _vm._v(" Enter a specific Category")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Price"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(You can always add more images or video on this post)")])])
}]}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "pager"
  }, [(_vm.menu_tab_inner_view['getProduct']) ? _c('div', {
    staticClass: "container card-box",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('a', {
    staticClass: "x-cta-btn card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('getCategoryBusinesses')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])]), _vm._v(" "), _c('div', [_c('h4', {
    staticStyle: {
      "font-weight": "800",
      "font-size": "28px"
    }
  }, [_vm._v(_vm._s(_vm.product.product_name))]), _c('hr')]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view['getCategoryProducts']) ? _c('div', {
    staticClass: "container card-box",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('a', {
    staticClass: "x-cta-btn card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('getCategoryBusinesses')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])]), _vm._v(" "), _c('div', [_c('h4', {
    staticStyle: {
      "font-weight": "800",
      "font-size": "28px"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.products), function(product, index) {
    return (product.product_images.length > 0) ? _c('div', {
      staticClass: "col-xs-12 mp0 card-crow"
    }, [_c('div', [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setProductView(product)
        }
      }
    }, [_c('div', {
      staticClass: "col-xs-4"
    }, [_c('div', {
      staticClass: "col-xs-3 mp0"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {}
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9 mp0 card-col-2c-img",
      staticStyle: {
        "background-repeat": "no-repeat",
        "background-size": "contain"
      },
      style: ({
        'background-image': 'linear-gradient(to bottom, rgba(17, 17, 17, 0.247), rgba(8, 8, 8, 0.111)),' + 'url(' + product.product_images[0].product_image + ')'
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('p', [_vm._v(_vm._s(product.product_name))]), _vm._v(" "), _c('p', [_c('span', {
      attrs: {
        "classs": "nra-fmt"
      }
    }, [_vm._v("₦‎")]), _vm._v(_vm._s(product.product_items[0].product_item_price_f))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.product_items.length))])])]), _vm._v(" "), _vm._m(1, true)])]), _vm._v(" "), _c('hr')]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view['getCategoryBusinesses']) ? _c('div', {
    staticClass: "container card-box",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('a', {
    staticClass: "x-cta-btn card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])]), _vm._v(" "), _c('div', [_c('h4', {
    staticStyle: {
      "font-weight": "800",
      "font-size": "28px"
    }
  }, [_vm._v(_vm._s(_vm.category.category_name))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('a', {
    staticClass: "card-link sp-app-default-color",
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('setLocation')
      }
    }
  }, [_vm._v("Set location")])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.businesses), function(business, index) {
    return _c('div', {
      staticClass: "col-xs-12 mp0 card-crow"
    }, [_c('div', [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setBusinessView(business)
        }
      }
    }, [_c('div', {
      staticClass: "col-xs-4"
    }, [_c('div', {
      staticClass: "col-xs-10 mp0 card-col-2c-img",
      staticStyle: {
        "background-repeat": "no-repeat",
        "background-size": "contain"
      },
      style: ({
        'background-image': 'linear-gradient(to bottom, rgba(17, 17, 17, 0.247), rgba(8, 8, 8, 0.111)),' + 'url(' + business.business_brand_image + ')'
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('p', [_vm._v(_vm._s(business.business_name))])])]), _vm._v(" "), _vm._m(2, true)])]), _vm._v(" "), _c('hr')])
  }))]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view['newShoppingList']) ? _c('div', {
    staticClass: "container card-box",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('a', {
    staticClass: "x-cta-btn card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.preset_categories), function(set_category, index) {
    return _c('div', {
      staticClass: "col-xs-12 mp0"
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.category = set_category;
          _vm.setMenuTabInnerView('getCategoryBusinesses')
        }
      }
    }, [_vm._m(4, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('h3', [_vm._v(_vm._s(set_category.category_name))])])]), _vm._v(" "), _vm._m(5, true)])])
  }))]) : _c('div', {
    staticClass: "container card-box",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('a', {
    staticClass: "x-cta-btn card-link",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])]), _vm._v(" "), _vm._m(6), _vm._v(" "), (_vm.loading) ? _c('div', [_vm._m(7)]) : _c('div', {
    staticClass: "card"
  }, [((Object.keys(_vm.orders).length > 0)) ? _c('div', _vm._l((_vm.orders), function(order) {
    return _c('div', {
      staticClass: "row card-box card-02",
      staticStyle: {
        "border-bottom": "#eee solid",
        "margin-bottom": "2em"
      }
    }, [_vm._m(8, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "card-link",
      attrs: {
        "href": '/placed/order/' + order.order_no
      }
    }, [_c('div', {
      staticClass: "col-xs-4"
    }, [_c('div', {
      staticStyle: {
        "display": "inline",
        "padding-bottom": "1em"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "80px",
        "height": "100px",
        "border-radius": "8px"
      },
      attrs: {
        "src": _vm.img_product_url + order.order_items[0].product_item_group_image
      }
    }), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8"
    }, [_c('h4', {
      staticStyle: {
        "font-weight": "800"
      }
    }, [_vm._v(_vm._s(order.order_items[0].product_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(order.order_details))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(order.order_time_ago) + " >")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  })) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No List yet")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000",
      "width": "100%",
      "margin-left": "-0.11em",
      "border-left": "#ffffff solid"
    },
    attrs: {
      "id": "productItemsBox"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {}
    }
  }, [_c('span', {
    staticClass: "s-backdrop"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "max-height": "75vh",
      "overflow": "scroll",
      "bottom": "0",
      "margin": "0 -1.2em",
      "background": "#ffffff",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticClass: "z-box",
    staticStyle: {
      "width": "100%",
      "padding": "0.1em",
      "border-radius": "35px 35px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "200px",
      "padding": "2em",
      "margin-bottom": "5.8em",
      "border-bottom": "#eee solid",
      "text-align": "left"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('productItemsBox')
      }
    }
  }, [_vm._m(9), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.product.product_items && (Object.keys(_vm.product.product_items).length > 1)) ? _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-bottom": "15em"
    }
  }, [_c('h4', [_vm._v("Please select from (" + _vm._s(_vm.product.product_items.length) + ") below options")]), _vm._v(" "), _vm._l((_vm.product.product_items), function(item, product_item_index) {
    return _c('div', {
      key: product_item_index
    }, [_c('div', {
      staticClass: "card col-xs-12 mp0",
      staticStyle: {
        "margin-bottom": "1em",
        "padding": "1em 0.2em",
        "border": "1px solid #eee",
        "border-radius": "3px"
      }
    }, [_c('div', {
      staticClass: "col-xs-1 mp0"
    }, [(_vm.checkOrderItems(item)) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._m(10, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setProductItem(item, product_item_index);
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6"
    }, [_c('p', [(product_item_index == 0) ? _c('span', [_c('b', [_vm._v("Main")])]) : _c('span', [_vm._v(_vm._s(item.product_item_service_tag))])]), _vm._v(" "), (_vm.checkOrderItems(item)) ? _c('p', [_c('span', {
      attrs: {
        "id": 'prdQty' + product_item_index
      }
    }, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'sub', _vm.product_index, _vm.product_item, product_item_index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(_vm.product_item.product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'add', _vm.product_index, _vm.product_item, product_item_index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-5 mp0"
    }, [_c('p', [_vm._v("₦‎" + _vm._s(item.product_item_price_f))])])])])
  })], 2) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000",
      "width": "100%",
      "margin-left": "-0.11em",
      "border-left": "#ffffff solid"
    },
    attrs: {
      "id": "setLocation"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {}
    }
  }, [_c('span', {
    staticClass: "s-backdrop"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "max-height": "75vh",
      "overflow": "scroll",
      "bottom": "0",
      "margin": "0 -1.2em",
      "background": "#ffffff",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticClass: "z-box",
    staticStyle: {
      "width": "100%",
      "padding": "0.1em",
      "border-radius": "35px 35px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "200px",
      "padding": "2em",
      "margin-bottom": "5.8em",
      "border-bottom": "#eee solid",
      "text-align": "left"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('setLocation')
      }
    }
  }, [_vm._m(11), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _vm._m(12)])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-1"
  }, [_c('div', [_c('span', [_c('i', {
    staticClass: "fas fa-angle-right",
    staticStyle: {
      "font-size": "18px"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-1"
  }, [_c('div', [_c('span', [_c('i', {
    staticClass: "fas fa-angle-right",
    staticStyle: {
      "font-size": "18px"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticStyle: {
      "font-weight": "800",
      "font-size": "28px"
    }
  }, [_vm._v("New Shopping Lists")]), _c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2"
  }, [_c('div', {
    staticClass: "card-avatar-square",
    staticStyle: {
      "padding": "1em",
      "background-color": "#f3f3f3"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2"
  }, [_c('div', [_c('span', [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticStyle: {
      "font-weight": "800",
      "font-size": "28px"
    }
  }, [_vm._v("Shopping Lists")]), _c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    staticStyle: {
      "color": "#ff0000",
      "font-weight": "600"
    }
  }), _vm._v(" Re-Order")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-bottom": "15em"
    }
  }, [_vm._v("\r\n                location 1"), _c('br'), _vm._v("\r\n                Location 2\r\n              ")])])
}]}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "friend-list"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticStyle: {
      "color": "#ff5566",
      "padding": "1em"
    }
  }, [_vm._v("Top activity products")]), _vm._v(" "), _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      key: index,
      staticClass: "col-md-4 col-sm-4 col-xs-6"
    }, [((product.product_items.length != 0)) ? _c('div', {
      staticStyle: {
        "min-height": "23em",
        "max-height": "22em"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "inherit",
        "text-decoration": "none"
      },
      attrs: {
        "href": '/' + product.product_business_ownername + '/' + product.product_url_name
      }
    }, _vm._l((product.product_items), function(product_item, index2) {
      return _c('div', {
        key: index2,
        staticClass: "friend-card",
        staticStyle: {
          "min-height": "22em",
          "max-height": "22em",
          "border-bottom-color": "rgb(182, 176, 176)"
        }
      }, [(index2 == 0) ? _c('div', [_c('div', {
        staticStyle: {
          "height": "10em"
        }
      }, [_c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": product.product_images[0].product_image,
          "alt": "photo"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "card-info"
      }, [_c('div', {
        staticClass: "friend-info"
      }, [_c('a', {
        staticClass: "pull-right text-green",
        staticStyle: {
          "font-size": "12px"
        },
        attrs: {
          "href": "#"
        }
      }, [_vm._v("@" + _vm._s(product.product_business_name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', {
        staticStyle: {
          "height": "3em"
        }
      }, [_c('a', {
        staticClass: "profile-link",
        attrs: {
          "href": "#"
        }
      }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('p', [_vm._v("₦" + _vm._s(product_item.product_item_price.toLocaleString('en', {
        useGrouping: true
      })))]), _vm._v(" "), _vm._m(0, true)])])]) : _vm._e()])
    }))]) : _vm._e()])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('a', {
    staticClass: "btn text-red",
    attrs: {
      "title": "Like"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o",
    staticStyle: {
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn text-red",
    attrs: {
      "title": "Add to Cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart",
    staticStyle: {
      "font-size": "14px"
    }
  })])])
}]}

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path != '/agentservices') ? _c('div', [_c('router-view')], 1) : _c('div', {
    staticClass: "main-wrap"
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "6em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Welcome, "), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.user.user_name))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#242323",
      "font-size": "18px"
    }
  }, [_vm._v("Manage your Agent Services")]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "1em 0.2em",
      "padding": "1em",
      "background-color": "#297af5",
      "border-radius": "5px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "margin-top": "-0.5em"
    }
  }, [(_vm.service_charge_balance < 10000) ? _c('span', {
    staticStyle: {
      "float": "left",
      "width": "85%",
      "color": "#ffffff"
    }
  }, [_vm._v("\r\n            Your Service Charge is low, it may not cover your Agent Service payments\r\n            ")]) : _vm._e(), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "col-xs-12 mp0"
  }, [_c('div', {
    staticClass: "col-xs-6 mp0"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "-0.2em",
      "color": "#ffffff",
      "padding": "1em",
      "background-color": "#5703a5",
      "border-radius": "12px",
      "margin-right": "0.5em"
    }
  }, [_vm._m(2), _vm._v(" "), _c('h3', [_c('span', {
    staticClass: "nra-fmt"
  }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(_vm.service_charge_balance)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 mp0"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "color": "#000000",
      "padding": "1em",
      "background-color": "#F8B940",
      "border-radius": "12px",
      "margin-left": "0.5em",
      "margin-right": "0.5em"
    }
  }, [_vm._m(3), _vm._v(" "), _c('h3', [_c('span', {
    staticClass: "nra-fmt"
  }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(_vm.earnings_balance)))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "color": "#000000",
      "padding": "1em",
      "background-color": "#F8B940",
      "border-radius": "12px",
      "margin-left": "0.5em",
      "margin-right": "0.1em"
    }
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "0.4em",
      "padding": "0 0em",
      "font-size": "18px"
    }
  }, [_c('h5', {
    staticStyle: {
      "float": "left",
      "font-size": "16px"
    }
  }, [_vm._v("Total amount earned today:")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right",
      "padding-top": "0.41em"
    }
  }, [_c('span', {
    staticClass: "nra-fmt"
  }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(_vm.earnings_balance)))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "display": "none",
      "background-color": "rgb(41, 122, 245)",
      "width": "100%",
      "border-radius": "8px",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.prepSetCustomAgentBusiness()
      }
    }
  }, [_c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Service Charge Balance:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.sellpoint.business_processing_fee_balance && (_vm.sellpoint.business_processing_fee_balance > 0)) ? _c('span', [_c('span', {
    staticClass: "nra-fmt"
  }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(_vm.sellpoint.business_processing_fee_balance)))]) : _c('span', [_c('span', {
    staticClass: "nra-fmt"
  }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(_vm.service_charge_balance)))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [(_vm.site_user_type == 3) ? _c('div', {
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('h4', {
    staticStyle: {
      "color": "#5703a5"
    }
  }, [_vm._v("Agent services you can do")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10)]) : _c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('div', [_c('div', {
    staticClass: "card",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', {
    staticStyle: {
      "color": "#242323"
    }
  }, [_vm._v("Turn on Agent Services")]), _vm._v(" "), _c('p', [_vm._v("An Agent business account would be created for you. You will get to earn from\r\n                    service charges paid when creating shop accounts, managing shops, making orders and more")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "background-color": "rgb(41, 122, 245)",
      "border-radius": "18px",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.prepSetCustomAgentBusiness()
      }
    }
  }, [_vm._v("\r\n                   "), (_vm.action_loading) ? _c('i', {
    staticClass: "fas fa-circle-o-notch fa-spin",
    staticStyle: {
      "color": "#ffffff"
    }
  }) : _vm._e(), _vm._v(" Yes, Turn on my Agent Services")]), _vm._v(" "), _c('br'), _c('br')])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15)])])])])]), _vm._v(" "), _c('component-footer')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin-top": "-1em",
      "color": "#ffffff"
    }
  }, [_c('a', {
    staticClass: "card-link"
  }, [_vm._v("x")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "right",
      "width": "15%",
      "text-align": "right"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "background-color": "#eee",
      "color": "#5703a5",
      "text-decoration": "none"
    },
    attrs: {
      "href": "/agentservices/servicecharges"
    }
  }, [_vm._v("Add")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_vm._v("Service Charge"), _c('br'), _vm._v("Balance")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_vm._v("Earnings"), _c('br'), _vm._v("Available")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 mp0",
    staticStyle: {
      "background-color": "#ffffff",
      "border-radius": "12px"
    }
  }, [_c('div', {
    staticClass: "col-xs-6 w-any",
    staticStyle: {
      "border-right": "solid 3px #eee"
    }
  }, [_c('h5', [_vm._v("Shop Accounts")]), _vm._v(" "), _c('p', [_vm._v("0")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 w-any"
  }, [_c('h5', [_vm._v("Successful Orders")]), _vm._v(" "), _c('p', [_vm._v("0")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "right",
      "color": "#5703a5"
    }
  }, [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "/agentservices/addedservices"
    }
  }, [_vm._v("\r\n                View all added services  \r\n                "), _c('i', {
    staticClass: "fas fa-angle-right",
    staticStyle: {
      "color": "#5703a5",
      "font-size": "16px"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq card-active"
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/agentservices/setupshop"
    }
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Create a Shop Account")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Upload Product")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Make Orders")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Service Charges ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq card-na"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Manage your Account ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq card-na"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Create a Shop Account")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq card-na"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Upload Product")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq card-na"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Make Orders")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq card-na"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Service Charges ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq card-na"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Manage your Account ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
}]}

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(Object.keys(_vm.product.product_reviews).length > 0) ? _c('div', {
    staticClass: "detail-card"
  }, [_c('h6', [_vm._v("Product Reviews")]), _vm._v(" "), _vm._l((_vm.product.product_reviews), function(review, rdex) {
    return _c('div', {
      key: rdex,
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-circle"
    }, [(review.product_reviewed_by_image && (review.product_reviewed_by_image != '')) ? _c('img', {
      attrs: {
        "src": review.product_reviewed_by_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right",
      staticStyle: {
        "padding-left": "6px"
      }
    }, [_c('div', {}, [_c('div', [_vm._v(_vm._s(review.product_review) + "\n              "), _c('div', {
      staticStyle: {
        "color": "#ffd900"
      }
    }, [_vm._l((parseInt(review.product_rate)), function(index) {
      return _c('span', {
        key: index,
        staticClass: "fa is-filled"
      }, [_vm._v("")])
    }), _vm._l(((5 - parseInt(review.product_rate))), function(index) {
      return _c('span', {
        key: index,
        staticClass: "fa is-filled"
      }, [_vm._v("")])
    })], 2), _vm._v("\n              " + _vm._s(review.product_reviewed_by)), _c('br'), _vm._v("\n              " + _vm._s(review.product_review_date) + "\n            ")])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })], 2) : _c('p', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("No reviews yet")])])
},staticRenderFns: []}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.action_loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "container"
  }, [_c('div', {}, [_c('div', [_vm._v("Order number: " + _vm._s(_vm.order_data.order_no))]), _vm._v(" "), _c('div', [_vm._v("Date: " + _vm._s(_vm.order_data.order_date))]), _vm._v(" "), _c('div', [_vm._v("Payment method: Online Payment")]), _vm._v(" "), _c('div', [_vm._v("Status: "), _c('span', {
    style: ({
      color: _vm.order_data.order_status_color
    })
  }, [_vm._v(_vm._s(_vm.order_data.order_status))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', [_vm._v("Order Amount: ₦" + _vm._s(_vm.order_data.order_items_total))]), _vm._v(" "), _c('div', [_vm._v("Shipping:  ₦" + _vm._s(_vm.order_data.order_shipping_total))]), _vm._v(" "), _c('div', [_vm._v("Total: ₦" + _vm._s(_vm.order_data.order_total))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', [_vm._v("Delivery Location: " + _vm._s(_vm.order_data.order_delivery_city))]), _vm._v(" "), _c('div', [_vm._v("Address: " + _vm._s(_vm.order_data.order_user_delivery_address))])]), _vm._v(" "), _c('div', {}, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Order No")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Order")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Qty")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _vm._l((_vm.order_data.order_items), function(item) {
    return _c('tr', {
      key: item.order_item_no
    }, [_c('td', {
      staticStyle: {
        "width": "20%",
        "font-size": "12px"
      }
    }, [_vm._v("\n                " + _vm._s(item.order_item_no) + "\n              ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v("\n                " + _vm._s(item.product_name) + "\n                "), _c('br'), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + item.product_item_group_image,
        "height": "50",
        "width": "50"
      }
    })])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.order_item_quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.order_item_total.toFixed(2)))])])
  })], 2)]), _vm._v(" "), _c('div', {}, [_vm._m(1), _vm._v(" "), _c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Earner")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Item")]), _vm._v(" "), _vm._l((_vm.order_data.order_commissions_stl), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', {
      staticStyle: {
        "width": "20%",
        "font-size": "11px"
      }
    }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.service_commission_amount.toFixed(2)) + "\n              ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("\n                " + _vm._s(item.service_commission_earner_name) + "\n              ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v("\n                " + _vm._s(item.service_commission_module_name) + "\n                "), _c('br'), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + item.service_commission_module_image_url,
        "height": "50",
        "width": "50"
      }
    })])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_c('h5', [_vm._v("Order Additional Information")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#e94b4b"
    }
  }, [_vm._v("Add any order addtional information")]), _vm._v(" "), (_vm.setAddOrderAdditionalView) ? _c('div', [_c('form', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_add_info.title),
      expression: "order_add_info.title"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.order_add_info.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.order_add_info.title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_add_info.details),
      expression: "order_add_info.details"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.order_add_info.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.order_add_info.details = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Cost")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_add_info.cost),
      expression: "order_add_info.cost"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.order_add_info.cost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.order_add_info.cost = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff",
      "text-decoration": "none"
    },
    on: {
      "click": _vm.addOrderAdditionalView
    }
  }, [_vm._v("Add Information to Order")])])]) : _c('div', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.setAddOrderAdditionalView = true
      }
    }
  }, [_vm._v("Add Information")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_c('h5', [_vm._v("Process Order Request")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Send Bank Details")]), _c('br'), _vm._v(" "), (_vm.sellpoint.business_bank_details && (Object.keys(_vm.sellpoint.business_bank_details).length > 0)) ? _c('div', [_c('span', [_vm._v("Send bank details details to receive order payment")]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "color": "#444444"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_name)), _c('br'), _vm._v("\n                    " + _vm._s(_vm.sellpoint.business_bank_details.bank_account_name)), _c('br'), _vm._v("\n                    " + _vm._s(_vm.sellpoint.business_bank_details.bank_account_number) + "\n                  ")])]), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderCustomOrderDetailsUpdate(_vm.order_data)
      }
    }
  }, [_vm._v("Send")])]) : _c('div', [_vm._m(2)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('ConfirmPaymentUpdate')
      }
    }
  }, [_vm._v("Confirm Payment")]), _vm._v(" "), (_vm.menu_tab_inner_view['ConfirmPaymentUpdate']) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Confirm Order Payment ?")]), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderCustomConfirmPaymentUpdate(_vm.order_data)
      }
    }
  }, [_vm._v("Yes, Confirm Payment")])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderCustomUpdates(_vm.order_data, 'delivered')
      }
    }
  }, [_vm._v("Mark as delivered")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderCustomUpdates(_vm.order_data, 'closed')
      }
    }
  }, [_vm._v("Close Order")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div')])]), _vm._v(" "), (_vm.order_data.order_payment_status_id != 18) ? _c('div', {
    staticClass: "mobile-fix-nav-2"
  }, [_c('p', {
    staticStyle: {
      "padding": "0 5px"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.order_data.order_status_id == 7) ? _c('div', {
    staticStyle: {
      "background": "#e94b4b",
      "width": "100vw",
      "padding": "0.8em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.updateOrders(_vm.order, 'delivered')
      }
    }
  }, [_vm._v("Confirm Order ")])]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Commissions earned in this Order")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Set Bank details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Send Payment Link")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("A Payment link with payment details would be generated for payment")]), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Send Payment Link")])])
}]}

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h6', [_vm._v("Shop Settings")]), _vm._v(" "), (_vm.menu_tab_view.manageBusiness) ? _c('div', [(_vm.sellpoint) ? _c('div', {
    staticStyle: {
      "text-align": "left",
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "menu-links-strip menu-links-strip-2"
  }, [_c('ul', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'setBusinessProfile', _vm.sellpoint, '/account/business')
      }
    }
  }, [_c('li', [_vm._v("\r\n            Store Profile\r\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'setBusinessOrders', _vm.sellpoint, '/account/business/orders')
      }
    }
  }, [_c('li', [_vm._v("\r\n            Orders\r\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'setBusinessTransactions', _vm.sellpoint, '/account/business/transactions')
      }
    }
  }, [_c('li', [_vm._v("\r\n            Transactions\r\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'setBusinessShippingInformation', _vm.sellpoint, '/account/business/shipping')
      }
    }
  }, [_c('li', [_vm._v("\r\n            Shipping\r\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'setBusinessDiscountsCoupons', _vm.sellpoint, '/account/business/discounts')
      }
    }
  }, [_c('li', [_vm._v("\r\n            Discounts ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'setBusinessPaymentInformation', _vm.sellpoint, '/account/business/payments')
      }
    }
  }, [_c('li', [_vm._v("\r\n            Payments\r\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'setBusinessRewards', _vm.sellpoint, '/account/business/rewards')
      }
    }
  }, [_c('li', [_vm._v("\r\n            Rewards\r\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat component-tabs"
  })]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_c('h6', [_vm._v("Product Delivery Location Fees")]), _vm._v(" "), ((_vm.product.product_business_delivery_options) && (_vm.product.product_business_delivery_options.length != 0)) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have set some general delivery settings")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v("You can set a different delivery fee for this product")]), _vm._v(" "), _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('div', {
      key: delivery.business_delivery_option_id,
      staticStyle: {
        "margin": "8px 0",
        "border-bottom": "#e4e4e1 solid",
        "padding": "0.6em 0"
      }
    }, [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" "), (delivery.business_products_delivery_fees.length > 0) ? _c('span', _vm._l((delivery.business_products_delivery_fees), function(fee, fdex) {
      return _c('span', {
        key: fdex
      }, [((fee.product_delivery_product == _vm.product.product_id)) ? _c('span', [_vm._v(" -  ₦" + _vm._s(fee.product_delivery_fee) + "\n                    ")]) : _vm._e()])
    })) : _c('span'), _vm._v(" "), (_vm.product_details.setProductDeliveryInformation && delivery.edit_set) ? _c('div', {
      staticClass: "contact_form"
    }, [_c('div', {
      staticClass: "form-group",
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('label', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(" Set Delivery Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery.product_delivery_fee),
        expression: "delivery.product_delivery_fee"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (delivery.product_delivery_fee)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery.product_delivery_fee = $event.target.value
        }
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Business Set Shipping Fee: ₦" + _vm._s(delivery.business_delivery_option_price))])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.product_details.setProductDeliveryInformation && _vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02 sp-button-sm",
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "submit"
      },
      on: {
        "click": _vm.setProductDeliveryOption
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02 sp-button-sm",
      attrs: {
        "title": "cancel",
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_id == delivery.business_delivery_option_business) ? _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "font-size": "10px"
      },
      attrs: {
        "type": "btn",
        "title": "Set Product Delivery Fee"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('setProductDeliveryInformation', delivery)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Set Fee")]) : _c('span', {
      staticStyle: {
        "font-size": "10px",
        "color": "#063b77"
      }
    }, [_vm._v(_vm._s(delivery.business_delivery_business_name))])])
  })], 2) : _c('div', [_c('p', {
    staticClass: "info"
  }, [_vm._v("You have not set your Business Delivery Locations")])])])])
},staticRenderFns: []}

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager",
    staticStyle: {
      "background": "#fcfcfc"
    }
  }, [_c('div', {
    staticClass: "section",
    staticStyle: {
      "margin-top": "0em",
      "text-align": "left"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', [(_vm.checkout_orders.length != 0) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [(!_vm.checkout_processed) ? _c('div', [_c('div', {
    staticClass: "container",
    staticStyle: {
      "background": "#ffffff",
      "margin": "0 1em",
      "margin-top": "-1em"
    }
  }, [_c('h4', {
    staticClass: "ck-hh"
  }, [_vm._v("Billing details")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#000000",
      "font-size": "13px"
    }
  }, [_vm._v("Enter the details below to Checkout"), _c('br'), _vm._v(" "), (_vm.new_account) ? _c('span', [_vm._v("Do you have a "), _c('b', [_vm._v("Buypoint Account? ")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "sp-app-default-color",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('login', '')
      }
    }
  }, [_vm._v("You can use it to process your orders")])]) : _c('span', [_vm._v("Don't have a "), _c('b', [_vm._v("Buypoint Account? ")]), _vm._v(" "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('new-account', '')
      }
    }
  }, [_vm._v("Click Here")])])])]), _vm._v(" "), _c('div', {}, [(_vm.new_account) ? _c('form', [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "email",
      "placeholder": "Email",
      "id": "Last-name-2"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "number",
      "placeholder": "Phone No"
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [(_vm.data_success_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]) : _vm._e(), _vm._v(" "), (_vm.data_error_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn wnf-button",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.prep_process_checkout
    }
  }, [_vm._v("Process Checkout")])])])]) : _c('form', [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-groupw"
  }, [(_vm.data_success_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]) : _vm._e(), _vm._v(" "), (_vm.data_error_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn wnf-button",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.loginAndProcess()
      }
    }
  }, [_vm._v("Process Checkout")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('h4', {
    staticClass: "ck-hh"
  }, [_vm._v("Items to Checkout")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1em",
      "margin-top": "-1em"
    }
  }, _vm._l((_vm.checkout_orders), function(group, index) {
    return _c('div', {
      staticClass: "group-row",
      staticStyle: {
        "height": "auto"
      }
    }, [_c('div', {
      staticStyle: {
        "margin": "1em"
      }
    }, [_vm._l((group.order_items), function(item) {
      return _c('div', {
        staticStyle: {
          "width": "100%",
          "padding-top": "1em"
        }
      }, [_c('div', [_c('div', {
        staticStyle: {
          "width": "30%",
          "float": "left"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "href": item.product_url
        }
      }, [((item.product_item_image && (item.product_item_image != ''))) ? _c('img', {
        staticClass: "sp-prd-img",
        staticStyle: {
          "height": "80px"
        },
        attrs: {
          "src": _vm.img_product_url + item.product_item_image
        }
      }) : _c('img', {
        staticClass: "sp-prd-img",
        staticStyle: {
          "height": "80px"
        },
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "width": "60%",
          "float": "right"
        }
      }, [_c('h5', [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), _c('p', {
        staticClass: "sp-app-default-color",
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v(" Qty: " + _vm._s(item.product_item_order_quantity))]), _c('br'), _vm._v(" "), _c('p', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v("  ₦" + _vm._s(_vm.formatCurrency_2(item.product_item_price * item.product_item_order_quantity)))]), _c('br'), _vm._v(" "), (group.order_items.length > 1) ? _c('div', {
        staticClass: "col-xs-9 pull-right"
      }, [(item.calculated_product_delivery_fee > 0) ? _c('p', [_vm._v("This item's Shipping Fee: " + _vm._s(item.calculated_product_delivery_fee))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      })])])
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none",
        "clear": "both",
        "width": "100%",
        "border-top": "#f3f0f0 solid 1px",
        "padding-top": "1em",
        "padding-bottom": "1em"
      }
    }, [(group.total_order_coupons_amount != 0) ? _c('div', [_vm._m(0, true), _vm._v(" "), _c('label', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("₦" + _vm._s((group.total_order_coupons_amount).toFixed(2)))])]) : _vm._e(), _vm._v(" "), _c('div', [_vm._m(1, true), _vm._v(" "), _c('label', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("₦" + _vm._s((group.order_total_amount).toFixed(2)))])]), _vm._v(" "), (group.order_total_delivery_charge > 0) ? _c('div', [_vm._m(2, true), _vm._v(" "), _c('label', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("₦" + _vm._s(group.order_total_delivery_charge))])]) : _vm._e()])], 2)])
  }))])]) : _c('div', {
    staticClass: "container"
  }, [(!_vm.flexi_pay) ? _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1em",
      "margin-top": "0.5em"
    }
  }, [(Object.keys(_vm.share_cart_details).length > 0) ? _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "card card-flat-pad",
    staticStyle: {
      "text-align": "center",
      "background": "#ff0066",
      "color": "#ffffff",
      "height": "auto",
      "padding": "2em",
      "border-radius": "5px"
    }
  }, [_c('h3', [_vm._v("Share Cart Order")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._m(3), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.app_url) + "sharecart/" + _vm._s(_vm.share_cart_details.order_share_cart_ref_link))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF-CODE: ")]), _vm._v(_vm._s(_vm.share_cart_details.order_share_cart_ref_code))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.copyLink(_vm.app_url + 'sharecart/' + _vm.share_cart_details.order_share_cart_ref_link, 'MAINSHCRCOPY')
      }
    }
  }, [_vm._v("Copy Link")]), _vm._v(" "), (_vm.copied) ? _c('span', {
    staticStyle: {
      "background": "rgb(240, 227, 157)"
    },
    attrs: {
      "id": "MAINSHCRCOPY"
    }
  }, [_vm._v("Copied")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "ck-hh"
  }, [_vm._v("Checkout")]), _vm._v(" "), _c('div', {
    staticClass: "row cktop ck-card-row card",
    staticStyle: {
      "background": "#ffffff",
      "margin-left": "-1em"
    }
  }, [_c('div', {
    staticClass: "mobi-on"
  }, [_c('p', [_c('b', [_c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("\r\n                                            Total")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("₦" + _vm._s(_vm.formatCurrency_2(_vm.total_orders_amount)))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {}, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.payment_details.payment_payer_name))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.payment_details.payment_payer_phone))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.payment_details.payment_payer_email))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1.5em 2.5em"
    }
  }, [_vm._l((_vm.checkout_orders), function(group, index) {
    return _c('div', {
      staticClass: "group-row gp-row00",
      staticStyle: {
        "box-shadow": "0 0 30px 4px rgba(0,0,0,0.03)"
      }
    }, [_c('div', {
      staticStyle: {
        "background": "#000000",
        "color": "#ffffff",
        "margin": "-8px",
        "padding": "0 8px",
        "padding-top": "6px",
        "border-radius": "15px 15px 0px 0px"
      }
    }, [_c('span', {
      staticClass: "sp-app-default-color",
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(group.order_time_ago))]), _vm._v(" "), (group.order_is_business_agent && (group.order_is_business_agent == 1)) ? _c('p', {
      staticClass: "sp-app-default-color-off"
    }, [_c('b', [_vm._v(_vm._s(group.order_business_agent_name))])]) : _c('p', {
      staticClass: "sp-app-default-color-off"
    }, [_vm._v("Shop: "), _c('b', [_vm._v(_vm._s(group.order_business))])]), _vm._v(" "), ((group.order_business_agent_type && (group.order_business_agent_type == 19))) ? _c('p', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Selling for: ")]), _c('b', [_vm._v(_vm._s(group.order_business))])]) : _vm._e(), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (((Object.keys(_vm.share_cart_details).length == 0) && (Object.keys(group.order_share_cart_details).length > 0))) ? _c('div', [_c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('button', {
      staticClass: "btn sp-button-sm",
      staticStyle: {
        "background": "#ff0066",
        "color": "#ffffff"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView(_vm.menu_tab_inner_view['SHCR' + index] ? ' ' : 'SHCR' + index)
        }
      }
    }, [_vm._v("Share "), _c('i', {
      staticClass: "fa fa-angle-down"
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (_vm.menu_tab_inner_view['SHCR' + index]) ? _c('div', {
      staticClass: "card card-flat-pad",
      staticStyle: {
        "text-align": "center",
        "border": "3px solid #ff0066",
        "color": "inherit",
        "height": "auto",
        "padding": "2em",
        "border-radius": "5px"
      }
    }, [_c('h3', [_vm._v("Share Cart Order")]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._m(4, true), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.app_url) + _vm._s(group.order_share_cart_details.order_share_cart_ref_link))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF-CODE: ")]), _vm._v(_vm._s(group.order_share_cart_details.order_share_cart_ref_code))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1 sp-button-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.copyLink(_vm.app_url + group.order_share_cart_details.order_share_cart_ref_link, 'SHCRCOPY')
        }
      }
    }, [_vm._v("Copy Link")]), _vm._v(" "), (_vm.copied) ? _c('span', {
      staticStyle: {
        "background": "rgb(240, 227, 157)"
      },
      attrs: {
        "id": "SHCRCOPY"
      }
    }, [_vm._v("Copied")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((group.order_items_groups), function(item_group, igdex) {
      return _c('div', {
        staticClass: "row ck-card-row",
        staticStyle: {
          "clear": "both"
        }
      }, [_vm._v(_vm._s(igdex) + "\r\n                                    "), _vm._l((item_group), function(item) {
        return _c('div', {}, [_c('div', {
          staticStyle: {
            "width": "30%",
            "float": "left"
          }
        }, [_c('a', {
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "href": item.product_url
          }
        }, [((item.product_item_group_image && (item.product_item_group_image != ''))) ? _c('img', {
          staticClass: "sp-prd-img",
          attrs: {
            "src": item.product_item_group_image
          }
        }) : _c('img', {
          staticClass: "sp-prd-img",
          attrs: {
            "src": "/static/assets/images/dummy-image.png"
          }
        })])]), _vm._v(" "), _c('div', {
          staticStyle: {
            "width": "60%",
            "float": "right"
          }
        }, [_c('h5', [_vm._v(_vm._s(item.product_name))]), _c('p', [_vm._v(_vm._s(item.order_item_is_an_addon_to) + "--" + _vm._s(item.order_item_addon))]), _vm._v(" "), _c('p', [_vm._v(" QTY: " + _vm._s(item.order_item_quantity))]), _vm._v(" "), _c('p', [(item.order_item_quantity > 1) ? _c('span', {
          staticClass: "price"
        }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_total_price.toFixed(2))), _c('br')]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v("Total: ")]), _vm._v("₦" + _vm._s(item.order_item_total) + "\r\n                                            ")])]), _vm._v(" "), (group.order_status_id == 7) ? _c('div', {
          staticStyle: {
            "clear": "both",
            "width": "100%",
            "border-top": "#f3f0f0 solid 1px",
            "padding-top": "1em"
          }
        }, [_vm._m(5, true), _vm._v(" "), ((group.order_items.length > 1)) ? _c('div', {
          staticStyle: {
            "clear": "both"
          }
        }, [(item.order_item_delivery_fee != 0) ? _c('div', [_c('span', {
          staticStyle: {
            "color": "#ff0000",
            "float": "left"
          }
        }, [_vm._v("Product Shipping Fee:")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("₦" + _vm._s(item.order_item_delivery_fee))]), _c('br')]) : _vm._e(), _vm._v(" "), (item.order_item_delivery_fee != 0) ? _c('div', [_c('span', {
          staticStyle: {
            "color": "#ff0000",
            "float": "left"
          }
        }, [_vm._v("Total:")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "float": "left"
          }
        }, [_vm._v(" ₦" + _vm._s(item.order_item_total_delivery_fee))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
          staticStyle: {
            "float": "right",
            "margin-bottom": "5px",
            "display": "none"
          }
        }, [_c('span', [_c('a', {
          staticClass: "mobi-on",
          staticStyle: {
            "cursor": "pointer",
            "color": "#000000"
          },
          on: {
            "click": function($event) {
              _vm.removeFromCheckout(index, group, item)
            }
          }
        }, [_vm._v("Remove")]), _vm._v(" "), _c('a', {
          staticClass: "mobi-off",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              _vm.removeFromCheckout(index, group, item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-close"
        }), _vm._v("Remove")])])])]) : _vm._e()])
      })], 2)
    }), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), (group.order_status_id == 7) ? _c('div', {
      key: _vm.processed_single_order_count,
      staticClass: "c-cart-totals"
    }, [_c('div', {
      key: _vm.group_set_order_delivery_key,
      staticClass: "row",
      staticStyle: {
        "margin": "1.4em 0"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_vm._m(6, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "74%",
        "float": "left",
        "padding": "3px"
      }
    }, [(group.order_delivery_city) ? _c('p', {
      staticStyle: {
        "margin-top": "-1em",
        "font-size": "14px"
      }
    }, [_vm._v("Shipping: " + _vm._s(group.order_delivery_city))]) : _c('p', {
      staticStyle: {
        "margin-top": "-1em",
        "font-size": "14px"
      }
    }, [_vm._v("Shipping: Not set yet")]), _vm._v(" "), (group.order_user_delivery_address) ? _c('p', {
      staticStyle: {
        "margin-top": "-1em",
        "font-size": "14px"
      }
    }, [_vm._v(_vm._s(group.order_user_delivery_address))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "10%",
        "float": "right",
        "margin-left": "9em",
        "margin-top": "-3.3em",
        "padding": "1em",
        "text-align": "center"
      }
    }, [(group.order_delivery_city) ? _c('a', {
      staticStyle: {
        "color": "#000000",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('cdl' + index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-down",
      staticStyle: {
        "font-weight": "bolder",
        "font-size": "18px",
        "color": "#000000"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'cdl' + index
      }
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "border": "#ffffff dashed 1px",
        "margin": "2em 0 2em 0",
        "padding-bottom": "2em"
      }
    }, [_c('div', {
      staticClass: "pull-right",
      staticStyle: {
        "display": "none"
      }
    }, [(group.change_shipping) ? _c('a', {
      on: {
        "click": function($event) {
          group.change_shipping = false
        }
      }
    }, [_vm._v("CANCEL: Change Shipping")]) : _c('a', {
      on: {
        "click": function($event) {
          group.change_shipping = true
        }
      }
    }, [_vm._v("Change Shipping")])]), _vm._v(" "), (group.change_shipping) ? _c('div', [((group.order_business_delivery_options && (group.order_business_delivery_options.length != 0))) ? _c('div', [((group.order_business_delivery_options_custom && (group.order_business_delivery_options_custom.length != 0))) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "-2em"
      }
    }, [_c('label', [_vm._v("Select Shipping Location")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_location),
        expression: "group.order_delivery_location"
      }],
      staticClass: "form-control",
      on: {
        "click": function($event) {
          _vm.calc_delivery_fee(index, group.order_delivery_location)
        },
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_location = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((group.order_business_delivery_options_custom), function(location) {
      return _c('option', {
        domProps: {
          "value": location
        }
      }, [_vm._v(_vm._s(location.business_delivery_option))])
    })], 2), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default",
      on: {
        "click": function($event) {
          _vm.setComponent('cancel-change-delivery-option', index)
        }
      }
    }, [_vm._v("Done")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-bottom": "2em"
      }
    }, [((group.order_business_delivery_options_custom && (group.order_business_delivery_options_custom.length != 0))) ? _c('label', [_vm._v("OR Select State In Nigeria")]) : _c('label', [_vm._v("Select State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_selected_state),
        expression: "group.order_delivery_selected_state"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_selected_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getOrderLocations(index, group.order_delivery_selected_state)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((group.order_business_delivery_options_states), function(state) {
      return _c('option', {
        domProps: {
          "value": state
        }
      }, [_vm._v(_vm._s(state.state_name))])
    })], 2), _vm._v(" "), (_vm.action_loading) ? _c('div', [_c('div', {
      staticClass: "loading-sm"
    })]) : _vm._e()]), _vm._v(" "), (group.sorted_order_business_delivery_options) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "-2em"
      }
    }, [_c('label', [_vm._v("Select Location")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_location),
        expression: "group.order_delivery_location"
      }],
      staticClass: "form-control",
      on: {
        "click": function($event) {
          _vm.calc_delivery_fee(index, group.order_delivery_location)
        },
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_location = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((group.sorted_order_business_delivery_options), function(location) {
      return _c('option', {
        domProps: {
          "value": location
        }
      }, [_vm._v(_vm._s(location.business_delivery_option))])
    })], 2)]) : _vm._e()]) : _c('div', [_c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-bottom": "2em"
      }
    }, [_c('label', [_vm._v("Select State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_selected_state),
        expression: "group.order_delivery_selected_state"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_selected_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities(group.order_delivery_selected_state.state_id)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2)]), _vm._v(" "), (_vm.cities.length > 0) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "-2em"
      }
    }, [_c('label', [_vm._v("Select Location")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_location),
        expression: "group.order_delivery_location"
      }],
      staticClass: "form-control",
      on: {
        "click": function($event) {
          _vm.resetDeliveryLocation(index, group.order_delivery_location)
        },
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_location = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city
        }
      }, [_vm._v(_vm._s(city.city_name))])
    })], 2)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (group.order_delivery_city) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "0.3em"
      }
    }, [(group.order_user_city_delivery == group.order_delivery_city_id) ? _c('div', [(group.order_user_city_delivery_addresses.length != 0) ? _c('div', [_c('label', [_vm._v("Select from previous Shipping Address")]), _vm._v(" "), _vm._l((group.order_user_city_delivery_addresses), function(address) {
      return _c('label', [(address.address_city == group.order_delivery_city_id) ? _c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (group.order_user_delivery_address),
          expression: "group.order_user_delivery_address"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": address.address_address,
          "checked": _vm._q(group.order_user_delivery_address, address.address_address)
        },
        on: {
          "click": function($event) {
            _vm.setOrderUserCityDeliveryAddress(index, address)
          },
          "__c": function($event) {
            group.order_user_delivery_address = address.address_address
          }
        }
      }), _vm._v("\r\n                                                                    " + _vm._s(address.address_address) + "\r\n                                                                ")]) : _vm._e()])
    })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Enter Shipping Address")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_user_delivery_address),
        expression: "group.order_user_delivery_address"
      }],
      staticClass: "form-control input-group-lg",
      attrs: {
        "type": "text",
        "placeholder": "Shipping Address"
      },
      domProps: {
        "value": (group.order_user_delivery_address)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          group.order_user_delivery_address = $event.target.value
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('button', {
      staticClass: "pull-right btn btn-default sp-button-02 sp-button-md",
      on: {
        "click": function($event) {
          _vm.setComponent('cancel-change-delivery-option', index)
        }
      }
    }, [_vm._v("Done")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])]), _vm._v(" "), _c('div', {
      key: _vm.group_set_order_delivery_key,
      staticClass: "row",
      staticStyle: {
        "margin": "1.4em 0"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_vm._m(7, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "75%",
        "float": "left",
        "padding": "3px"
      }
    }, [_c('p', {
      staticStyle: {
        "margin-top": "-1em",
        "font-size": "14px"
      }
    }, [_vm._v(_vm._s(Object.keys(group.order_items).length) + " Item(s)")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "10%",
        "float": "right",
        "margin-left": "9em",
        "margin-top": "-3.3em",
        "padding": "1em",
        "text-align": "center"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "#000000",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('orditms' + index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-down",
      staticStyle: {
        "font-weight": "bolder",
        "font-size": "18px",
        "color": "#000000"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'orditms' + index
      }
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "border": "#f5f4e6 dashed 1px",
        "margin": "1em 0 2em 0",
        "padding": "1em"
      }
    }, [((group.order_items && (group.order_items.length != 0))) ? _c('div', [_c('p', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("Items Ordered")]), _vm._v(" "), _vm._l((group.order_items), function(item) {
      return _c('div', [_c('div', {
        staticStyle: {
          "width": "15%",
          "float": "left"
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.img_product_url + item.product_item_group_image,
          "height": "50",
          "width": "50"
        }
      })]), _vm._v(" "), _c('div', {
        staticStyle: {
          "width": "80%",
          "float": "right",
          "padding": "3px"
        }
      }, [_c('p', [_vm._v("\r\n                                                                " + _vm._s(item.product_name)), _c('br'), _vm._v("\r\n                                                                Quantity:  " + _vm._s(item.order_item_quantity)), _c('br'), _vm._v(" "), _c('span', [_vm._v("₦" + _vm._s(_vm.formatCurrency_2(item.order_item_total)))])])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      })])
    })], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
      key: _vm.componentOrderSummaryKey,
      staticClass: "row",
      staticStyle: {
        "margin": "1.4em 0"
      }
    }, [(group.order_payment_enabled == 1) ? _c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_vm._m(8, true), _vm._v(" "), _vm._m(9, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "10%",
        "float": "right",
        "margin-left": "9em",
        "margin-top": "-3.3em",
        "padding": "1em",
        "text-align": "center"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "#000000",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('paytl' + index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-down",
      staticStyle: {
        "font-weight": "bolder",
        "font-size": "18px",
        "color": "#000000"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'paytl' + index
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(group.data_processing_message))]), _vm._v(" "), ((group.order_delivery_city != undefined || group.order_delivery_city != '')) ? _c('div', {
      staticClass: "ck-card-row-slim"
    }, [(((group.order_user_delivery_address == '' || (group.order_user_delivery_address == undefined)))) ? _c('div', [_c('label', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Enter Shipping Address For "), _c('b', [_vm._v(_vm._s(group.order_delivery_city))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.set_order_user_delivery_address),
        expression: "set_order_user_delivery_address"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Shipping Address"
      },
      domProps: {
        "value": (_vm.set_order_user_delivery_address)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.set_order_user_delivery_address = $event.target.value
        }
      }
    }), _vm._v(" "), (group.order_user_city_delivery == group.order_delivery_city_id) ? _c('div', [(group.order_user_city_delivery_addresses.length != 0) ? _c('div', [_c('label', [_vm._v("Select from previous Shipping Address")]), _vm._v(" "), _vm._l((group.order_user_city_delivery_addresses), function(address) {
      return _c('label', [(address.address_city == group.order_delivery_city_id) ? _c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (group.order_user_delivery_address),
          expression: "group.order_user_delivery_address"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": address.address_address,
          "checked": _vm._q(group.order_user_delivery_address, address.address_address)
        },
        on: {
          "click": function($event) {
            _vm.setOrderUserCityDeliveryAddress(index, address)
          },
          "__c": function($event) {
            group.order_user_delivery_address = address.address_address
          }
        }
      }), _vm._v("\r\n                                                                        " + _vm._s(address.address_address) + "\r\n                                                                    ")]) : _vm._e()])
    })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          _vm.setComponent('close-enter-delivery-address', index)
        }
      }
    }, [_vm._v("Done")])])]) : _vm._e(), _vm._v(" "), (group.order_user_delivery_address != '' && (group.order_user_delivery_address != undefined)) ? _c('div', [(group.order_user_delivery_address != '' && (group.order_user_delivery_address != undefined)) ? _c('button', {
      staticClass: "pull-right btn btn-default",
      staticStyle: {
        "border-radius": "0",
        "color": "#ffffff",
        "background": "#fc4848"
      },
      attrs: {
        "id": 'PAYPOS' + index
      },
      on: {
        "click": function($event) {
          _vm.setProcessPaymentSingle(group, index, 'POS' + index);
          _vm.closeViews('PAYPOS' + index)
        }
      }
    }, [_vm._v("Make Payment")]) : _vm._e()]) : _vm._e()]) : _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Please set your delivery place.")]), _vm._v(" "), _c('div', {
      staticClass: "clearifix"
    }), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'POS' + index
      }
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "clear": "both",
        "margin": "0.1em"
      }
    }, [_c('h3', [_vm._v("Select a payment method\r\n                                                            "), _c('button', {
      staticClass: "pull-right btn btn-default",
      on: {
        "click": function($event) {
          _vm.closeViews('POS' + index);
          _vm.toggleSingleComponent('PAYPOS' + index);
        }
      }
    }, [_vm._v("X")])]), _vm._v(" "), _c('br'), _vm._v(" "), (group.order_cap_payment_banks) ? _c('div', [(((group.business_bank_details.length != 0) || (group.business_agent_bank_details.length != 0))) ? _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "color": "inherit"
      }
    }, [_c('div', {
      staticClass: "card card-colord-pad card-colord-pad-01",
      on: {
        "click": function($event) {
          _vm.toggleViews('BBanks' + index)
        }
      }
    }, [_vm._m(10, true), _vm._v(" "), _vm._m(11, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "ibox",
      staticStyle: {
        "display": "none",
        "border": "1px solid #ccc",
        "padding": "1.05em"
      },
      attrs: {
        "id": 'BBanks' + index
      }
    }, [_c('div', {
      staticStyle: {
        "margin": "1em !important"
      }
    }, [(group.order_can_part_payment && (group.order_part_payment_amount > 0)) ? _c('p', [_c('b', [_vm._v("Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(group.order_part_payment_amount)))]) : _c('p', [_c('b', [_vm._v("Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency_2(group.total_amount)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Ref: ")]), _vm._v(_vm._s(group.order_no))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Pay to:")]), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-xs sp-button-02 sp-button-sm",
      attrs: {
        "disabled": _vm.disable_btn
      },
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 3, 0)
        }
      }
    }, [(_vm.action_loading) ? _c('div', [_c('i', {
      staticClass: "fas fa-circle-notch fa-spin fa-2x"
    })]) : _c('span', [_vm._v("Confirm Transfer")])])]), _vm._v(" "), _vm._l((group.business_bank_details), function(bank) {
      return (group.order_receive_manual_payment_by == 1) ? _c('div', [_vm._v("\r\n                                                                            " + _vm._s(bank) + "\r\n                                                                        ")]) : _vm._e()
    }), _vm._v(" "), _vm._l((group.business_agent_bank_details), function(bank) {
      return (group.order_receive_manual_payment_by == 2) ? _c('div', [_vm._v("\r\n                                                                            " + _vm._s(bank) + "\r\n                                                                        ")]) : _vm._e()
    })], 2), _vm._v(" "), _c('div')]), _vm._v(" "), _c('br')]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "card card-colord-pad card-colord-pad-01"
    }, [_c('div', {
      staticStyle: {
        "width": "95%",
        "float": "left"
      }
    }, [(group.collections_business && (group.collections_business > 0)) ? _c('div', {
      staticStyle: {
        "clear": "both"
      },
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 2, 0)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-database"
    }), _vm._v(" Pay with Your Collections "), _c('br'), _vm._v("-"), _c('b', [_c('i', [_vm._v("You have ")]), _vm._v("NGN: " + _vm._s(group.collections_business) + " "), _c('i', [_vm._v("in your collections")])])]) : _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }, [_c('i', {
      staticClass: "fa fa-database"
    }), _vm._v(" Pay with Your Collections:"), _c('br'), _vm._v(" "), _c('b', [_c('i', [_vm._v("- You have ")]), _vm._v("NGN:" + _vm._s(group.collections_business) + " "), _c('i', [_vm._v("in your collections")])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "width": "5%",
        "margin-top": "0.8em"
      }
    }, [(group.collections_business && (group.collections_business > 0)) ? _c('span', [_c('i', {
      staticClass: "fa fa-angle-right",
      staticStyle: {
        "font-size": "18px",
        "font-weight": "bold"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "btn btn-default",
      staticStyle: {
        "display": "none"
      }
    }, [_c('div', [((Object.keys(_vm.order_gift_card).length > 0) && (_vm.order_gift_card.order_gift_card_data)) ? _c('div') : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "border-radius": "0",
        "text-align": "left"
      },
      on: {
        "click": function($event) {
          _vm.prepProcessGiftCardPayment(group, index, 7, 0)
        }
      }
    }, [_vm._v("Pay with Gift Cards")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.set_gift_card.gift_card_ref),
        expression: "set_gift_card.gift_card_ref"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.set_gift_card.gift_card_ref)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.set_gift_card.gift_card_ref = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "border-radius": "0",
        "text-align": "left"
      },
      on: {
        "click": function($event) {
          _vm.setProcessGiftCardPayment(group, index, 0, 0, 0)
        }
      }
    }, [_vm._v("SENDs")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "border-radius": "0",
        "text-align": "left"
      },
      on: {
        "click": function($event) {
          _vm.prepProcessGiftCardPayment(group, index, 7, 0)
        }
      }
    }, [_vm._v("Use Gift Card for Payment")])])]), _vm._v(" "), _c('a', {
      staticClass: "card-link"
    }, [_c('div', {
      staticClass: "card card-colord-pad card-colord-pad-01",
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 1, 0)
        }
      }
    }, [_vm._m(12, true), _vm._v(" "), _vm._m(13, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])])])])])]), _vm._v(" "), _c('div', {
      key: _vm.componentOrderSummaryKey,
      staticClass: "row",
      staticStyle: {
        "margin": "0.8em"
      }
    }, [_c('p', [_c('span', {
      staticClass: "pleft"
    }, [_vm._v("Subtotal:")]), _vm._v(" "), _c('span', {
      staticClass: "pright"
    }, [_vm._v("₦" + _vm._s(group.order_items_total.toFixed(2)))])]), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "pleft"
    }, [_vm._v("Shipping:")]), _vm._v(" "), (group.order_delivery_fee >= 0) ? _c('span', {
      staticClass: "pright"
    }, [_vm._v("₦" + _vm._s(group.order_delivery_fee))]) : _c('span', {
      staticClass: "pright"
    }, [_vm._v("₦" + _vm._s(group.order_delivery_fee.toFixed(2)))])]), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('p'), _vm._v(" "), (group.order_processing_fee_client_pay) ? _c('p', [_c('span', {
      staticClass: "pleft"
    }, [_vm._v("Processing Fee:")]), _vm._v(" "), _c('span', {
      staticClass: "pright"
    }, [_vm._v("₦" + _vm._s(group.order_processing_fee.toFixed(2)))])]) : _vm._e(), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "pleft"
    }, [_vm._v("Total:")]), _vm._v(" "), _c('span', {
      staticClass: "pright"
    }, [_vm._v("₦" + _vm._s(group.total_amount.toFixed(2)))])]), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('p'), _vm._v(" "), ((group.order_can_part_payment && (group.order_can_part_payment == 1))) ? _c('p', [_c('span', {
      staticClass: "pleft"
    }, [_vm._v("Part Payment Amount:"), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("(Total paid: "), _c('b', [_vm._v(_vm._s(_vm.formatCurrency(group.order_part_payment_total_amount_paid)))]), _vm._v(")")]), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#0077ff",
        "font-size": "12px"
      }
    }, [_vm._v("(Total to pay: "), _c('b', [_vm._v(_vm._s(_vm.formatCurrency((group.total_amount - group.order_part_payment_total_amount_paid))))])])]), _vm._v(" "), _c('span', {
      staticClass: "pright"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_part_payment_amount),
        expression: "group.order_part_payment_amount"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (group.order_part_payment_amount)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          group.order_part_payment_amount = $event.target.value
        }
      }
    })])]) : _vm._e(), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('p')]), _vm._v(" "), (group.order_payment_enabled == 0) ? _c('div', {
      key: _vm.componentOrderSummaryKey,
      staticClass: "row",
      staticStyle: {
        "margin": "1.4em 0"
      }
    }, [_c('div', {
      staticStyle: {
        "background": "#ffa800",
        "width": "92vw",
        "padding": "0.8em",
        "text-align": "center"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "#ffffff",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.updateOrders(group, index, 'requested')
        }
      }
    }, [(_vm.action_loading) ? _c('span', [_c('i', {
      staticClass: "fas fa-circle-notch fa-spin fa-2x"
    })]) : _c('span', [_vm._v("Place Order")])])])]) : _vm._e()]) : (group.order_part_payment_status == 200) ? _c('div', {
      staticClass: "c-cart-totals",
      staticStyle: {
        "border": "solid 1px#ffa800",
        "text-align": "center"
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ffa800",
        "padding-top": "5px"
      }
    }, [_vm._v("Part Payment Order Placed")])]) : _c('div', {
      staticClass: "c-cart-totals",
      staticStyle: {
        "border": "none",
        "text-align": "left"
      }
    }, [_vm._m(14, true)])], 2)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10em"
    }
  }), _vm._v(" "), (_vm.processed_single_order_count > 0) ? _c('div', {
    staticClass: "mobile-fix-nav",
    staticStyle: {
      "bottom": "4em"
    }
  }, [_vm._m(15)]) : _vm._e()], 2)]) : _c('div', [((Object.keys(_vm.checkout_orders).length == 0)) ? _c('div', {
    staticStyle: {
      "margin": "20vh 40vw"
    }
  }, [_vm._m(16)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.checkout_orders), function(group, index) {
    return (_vm.flexi_active_payment_status == 0) ? _c('div', {
      staticStyle: {
        "border": "none"
      }
    }, [_c('div', {
      staticClass: "card"
    }, [_vm._m(17, true), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("₦" + _vm._s(_vm.formatCurrency_2(group.total_amount)))]), _vm._v(" "), _vm._m(18, true), _vm._v(" "), (group.business_bank_details && (Object.keys(group.business_bank_details).length > 0)) ? _c('div', [_c('div', [_c('p', [_vm._v("\r\n                                            " + _vm._s(group.business_bank_details.bank_name)), _c('br'), _vm._v("\r\n                                            " + _vm._s(group.business_bank_details.bank_account_name)), _c('br'), _vm._v("\r\n                                            " + _vm._s(group.business_bank_details.bank_account_number)), _c('br')])])]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      key: _vm.componentOrderSummaryKey,
      staticClass: "row",
      staticStyle: {
        "margin": "1.4em 0"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_vm._m(19, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "10%",
        "float": "right",
        "margin-left": "9em",
        "margin-top": "-3.3em",
        "padding": "1em",
        "text-align": "center"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "#000000",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('paytl' + index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-down",
      staticStyle: {
        "font-weight": "bolder",
        "font-size": "18px",
        "color": "#000000"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "block",
        "background": "none"
      },
      attrs: {
        "id": 'paytl' + index
      }
    }, [_c('div', {
      staticStyle: {
        "margin": "0.1em 0.2em"
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#000000"
      }
    }, [_vm._v("After Transfer >>")]), _vm._v(" "), _c('div', {
      staticClass: "row",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "margin-bottom": "0.3em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.transfer_verification_mode),
        expression: "transfer_verification_mode"
      }],
      attrs: {
        "type": "radio",
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(_vm.transfer_verification_mode, "1")
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('transfer_verification_mode_ref')
        },
        "__c": function($event) {
          _vm.transfer_verification_mode = "1"
        }
      }
    }), _vm._v(" Enter Reference No/Code\r\n                                                "), (group.order_payment_third_party_ref && (group.order_payment_third_party_ref != 1)) ? _c('span', [_vm._v(" - " + _vm._s(group.order_payment_third_party_ref))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.transfer_verification_mode),
        expression: "transfer_verification_mode"
      }],
      attrs: {
        "type": "radio",
        "value": "2"
      },
      domProps: {
        "checked": _vm._q(_vm.transfer_verification_mode, "2")
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('transfer_verification_mode_receipt')
        },
        "__c": function($event) {
          _vm.transfer_verification_mode = "2"
        }
      }
    }), _vm._v(" Or Upload Transfer Receipt\r\n                                            ")]), _vm._v(" "), _c('hr')]), _vm._v(" "), (_vm.menu_tab_inner_view.transfer_verification_mode_ref) ? _c('div', {
      staticClass: "ck-card-row-slim"
    }, [_c('p', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("Please enter Reference Code or Number found on your Bank (or Other) Transaction Message")]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "form-group wnf-fl-form-group col-xs-12"
    }, [_vm._v("--" + _vm._s(group.order_payment_third_party_ref) + "\r\n                                                        "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_payment_third_party_ref),
        expression: "group.order_payment_third_party_ref"
      }],
      staticClass: "form-control input-bflat",
      attrs: {
        "type": "text",
        "placeholder": ""
      },
      domProps: {
        "value": (group.order_payment_third_party_ref)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          group.order_payment_third_party_ref = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default wnf-button btn-xs",
      staticStyle: {
        "width": "20vw",
        "margin-left": "60vw",
        "padding": "5px 3px"
      },
      attrs: {
        "disabled": _vm.disable_btn
      },
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 3, 0)
        }
      }
    }, [_vm._v("Enter")])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view.transfer_verification_mode_receipt) ? _c('div', {
      staticClass: "ck-card-row-slim"
    }, [((Object.keys(_vm.file_info).length == 0)) ? _c('div', {
      staticClass: "upload-btn-wrapper",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('button', {
      staticClass: "upload-btn",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("Upload Receipt")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "input-file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          _vm.onFileChangeNewPhoto($event, 'transfer-receipt')
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.file_info[0]) ? _c('div', [_c('p', [(_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Uploading Receipt: " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default wnf-button",
      staticStyle: {
        "width": "30vw",
        "margin-left": "0vw",
        "padding": "5px 3px"
      },
      attrs: {
        "disabled": _vm.disable_btn
      },
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 3, 0)
        }
      }
    }, [_vm._v("Yes, Upload")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default wnf-button",
      staticStyle: {
        "width": "30vw",
        "margin-left": "0vw",
        "padding": "5px 3px",
        "background-color": "#f5f4e6",
        "color": "#000000"
      },
      on: {
        "click": function($event) {
          _vm.file_info = []
        }
      }
    }, [_vm._v("Cancel")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearifix"
    })])]), _vm._v(" "), _c('div', {
      key: _vm.componentOrderSummaryKey,
      staticClass: "row",
      staticStyle: {
        "margin": "2.4em 0"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_vm._m(20, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "10%",
        "float": "right",
        "margin-left": "9em",
        "margin-top": "-3.3em",
        "padding": "1em",
        "text-align": "center"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "#000000",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('payopt' + index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-down",
      staticStyle: {
        "font-weight": "bolder",
        "font-size": "18px",
        "color": "#000000"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "block",
        "background": "none"
      },
      attrs: {
        "id": 'payopt' + index
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(group.data_processing_message))]), _vm._v(" "), _c('div', {
      staticClass: "clearifix"
    }), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "display": "block"
      },
      attrs: {
        "id": 'POS' + index
      }
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "clear": "both",
        "margin": "0",
        "padding": "0.4em"
      }
    }, [_c('p', {
      staticStyle: {
        "display": "none"
      }
    }, [_vm._v("Select a payment method\r\n                                                    ")]), _vm._v(" "), _c('div', {
      staticClass: "card  card-colord-pad-01"
    }, [_c('div', {
      staticStyle: {
        "width": "95%",
        "float": "left"
      }
    }, [(group.collections_business && (group.collections_business > 0)) ? _c('div', {
      staticStyle: {
        "clear": "both"
      },
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 2, 0)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-database"
    }), _vm._v(" Pay with Your Collections "), _c('br'), _vm._v("-"), _c('b', [_c('i', [_vm._v("You have ")]), _vm._v("NGN: " + _vm._s(group.collections_business) + " "), _c('i', [_vm._v("in your collections")])])]) : _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }, [_c('i', {
      staticClass: "fa fa-database"
    }), _vm._v(" Pay with Your Collections:"), _c('br'), _vm._v(" "), _c('b', [_c('i', [_vm._v("- You have ")]), _vm._v("NGN:" + _vm._s(group.collections_business) + " "), _c('i', [_vm._v("in your collections")])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "width": "5%",
        "margin-top": "0.8em"
      }
    }, [(group.collections_business && (group.collections_business > 0)) ? _c('span', [_c('i', {
      staticClass: "fa fa-angle-right",
      staticStyle: {
        "font-size": "18px",
        "font-weight": "bold"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "card-link"
    }, [_c('div', {
      staticClass: "card  card-colord-pad-01",
      on: {
        "click": function($event) {
          _vm.prepProcessPaymentSingle(group, index, 1, 0)
        }
      }
    }, [_vm._m(21, true), _vm._v(" "), _vm._m(22, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])])])])])])]) : _vm._e()
  }), _vm._v(" "), (_vm.flexi_active_payment_status == 1) ? _c('div', [_c('div', {
    key: _vm.componentOrderSummaryKey,
    staticClass: "row",
    staticStyle: {
      "margin": "1.4em 0"
    }
  }, [_vm._m(23), _vm._v(" "), _vm._m(24)]), _vm._v(" "), _vm._m(25)]) : _vm._e()], 2)])]) : _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(26)])])]), _vm._v(" "), (!_vm.flexi_pay) ? _c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('component-footer')], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('b', [_vm._v("Total Coupon Discount Amount:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('b', [_vm._v("Total Order Amount:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('b', [_vm._v("Total Shipping Fee:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Share Link")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Share Link")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('label', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v("Gift/Send this Product to a different location")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "16%",
      "float": "left",
      "margin-top": "-1em",
      "padding": "0.1em"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "12px"
    }
  }, [_vm._v("Location:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "15%",
      "float": "left",
      "margin-top": "-1em",
      "padding": "0.1em"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "12px"
    }
  }, [_vm._v("Items:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "15%",
      "float": "left",
      "margin-top": "-1em",
      "padding": "0.1em"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "12px"
    }
  }, [_vm._v("Payment:    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "75%",
      "float": "left",
      "padding": "3px"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "-1em",
      "font-size": "14px"
    }
  }, [_vm._v("No Payment Mode selected")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "95%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "fa fa-bank"
  }), _vm._v("Direct Bank Transfer"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Pay directly to Business Bank Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "width": "5%",
      "margin-top": "0.8em"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "bold"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "95%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" Automatic Bank transfer and"), _c('br'), _vm._v(" Debit Card Payments")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "width": "5%",
      "margin-top": "0.8em"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "bold"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#ffa800",
      "font-weight": "bold"
    }
  }, [_vm._v(">>")]), _vm._v(" Order Placed\r\n                                        "), _c('span', [_c('a', {
    staticStyle: {
      "float": "right",
      "color": "#ffa800",
      "text-decoration": "underline"
    },
    attrs: {
      "href": "/orders"
    }
  }, [_vm._v("View Orders")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#ffa800",
      "width": "100vw",
      "padding": "0.8em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#ffffff",
      "text-decoration": "none"
    },
    attrs: {
      "href": "/orders"
    }
  }, [_vm._v("View Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sp-app-default-color"
  }, [_c('i', {
    staticClass: "fas fa-circle-notch fa-spin fa-2x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('b', [_vm._v("Transfer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("To:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left",
      "padding": "3px"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "-1em",
      "font-size": "16px",
      "color": "#ff0000"
    }
  }, [_vm._v("Complete Transfer Verification")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left",
      "padding": "3px"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "-1em",
      "font-size": "18px",
      "font-weight": "bold"
    }
  }, [_vm._v("Pay with other options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "95%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" Automatic Bank transfer and"), _c('br'), _vm._v(" Debit Card Payments")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "width": "5%",
      "margin-top": "0.8em"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "bold"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "#000000",
      "font-size": "24px"
    }
  }, [_c('b', [_vm._v("Transfer Payment registered successfully")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin": "3em 0"
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "padding": "0.31em",
      "border-radius": "50%",
      "border": "#ff0000 solid",
      "font-size": "5em",
      "color": "#ff0000"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-fix-nav",
    staticStyle: {
      "bottom": "0em"
    }
  }, [_c('div', {
    staticStyle: {
      "background": "#ffa800",
      "width": "100vw",
      "padding": "0.8em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#ffffff",
      "text-decoration": "none"
    },
    attrs: {
      "href": "/orders"
    }
  }, [_vm._v("Done, View Orders")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000",
      "margin-top": "2em"
    }
  }, [_vm._v("No Orders for Checkout")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn default",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Shop Here")])])
}]}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.show_login) ? _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header')], 1), _vm._v(" "), _c('div', {
    staticClass: "pager pager-clear-sticky"
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "topPanel"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "4em"
    }
  }, [_c('div', {
    staticClass: "card-box-0",
    staticStyle: {
      "padding": "0 1em"
    }
  }, _vm._l((_vm.feeds), function(feed, index) {
    return _c('div', {
      staticClass: "card card-strip",
      staticStyle: {
        "border-bottom": "#eeeded solid",
        "padding": "8px 0"
      }
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.clickNotifications(_vm.noti.notification_ref, _vm.noti.notification_url)
        }
      }
    }, [(feed.following_type == '1a' || feed.following_type == '1b') ? _c('div', [(feed.following_recent_update.length != 0) ? _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {}, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": feed.following_recent_update.update_media
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "col-xs-2",
      staticStyle: {
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle card-avatar-circle-sm"
    }, [_c('img', {
      attrs: {
        "src": feed.following_profile_image
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10",
      staticStyle: {
        "padding": "0"
      }
    }, [_c('span', [_c('h4', [_vm._v(_vm._s(feed.following_username))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "card"
    }, [_c('span', [(feed.following_recent_update.update_name && (feed.following_recent_update.update_name != '')) ? _c('h6', [_vm._v(_vm._s(feed.following_recent_update.update_name))]) : _vm._e()]), _vm._v(" "), _c('div', [(feed.following_recent_update.update_cta && (feed.following_recent_update.update_cta != 0)) ? _c('span', {
      staticStyle: {
        "float": "left",
        "font-size": "12px",
        "color": "#ff0066"
      }
    }, [_vm._v(_vm._s(feed.following_recent_update.update_cta_name))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "font-size": "12px",
        "color": "#ff0066"
      }
    }, [_vm._v(_vm._s(feed.following_recent_update.update_time_ago))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (feed.following_type == 3) ? _c('div', [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {}, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": feed.following_update_media
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "col-xs-2",
      staticStyle: {
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle card-avatar-circle-sm"
    }, [_c('img', {
      attrs: {
        "src": feed.following_profile_image
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10"
    }, [_c('span', [_c('h4', [_vm._v(_vm._s(feed.following_username))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card"
    }, [_c('span', [(feed.following_update_name && (feed.following_update_name != '')) ? _c('h6', [_vm._v(_vm._s(feed.following_update_name))]) : _vm._e(), _vm._v(" "), (feed.following_update_cta && (feed.following_update_cta != 0)) ? _c('span', {
      staticStyle: {
        "float": "left",
        "font-size": "12px",
        "color": "#ff0066"
      }
    }, [_vm._v(_vm._s(feed.following_update_cta_name))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "font-size": "12px",
        "color": "#ff0066"
      }
    }, [_vm._v(_vm._s(feed.following_update_time_ago))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])]) : _vm._e(), _vm._v(" "), (feed.following_type == 4) ? _c('div', [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "80%"
      }
    }, [_c('div', {}, [_c('span', [(feed.following_update_name && (feed.following_update_name != '')) ? _c('h4', {
      staticClass: "sp-app-default-color"
    }, [_vm._v(_vm._s(feed.following_update_name))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(feed.following_update_details))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "card-avatar-square"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": feed.following_update_media
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "col-xs-2",
      staticStyle: {
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle card-avatar-circle-sm"
    }, [_c('img', {
      attrs: {
        "src": feed.following_profile_image
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10"
    }, [_c('span', [_c('h4', [_vm._v(_vm._s(feed.following_username))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])]) : _vm._e()])])
  }))])])]), _vm._v(" "), _c('component-footer', {
    key: _vm.componentMenuBottomkey
  })], 1) : _c('div', [_c('component-landing')], 1)])
},staticRenderFns: []}

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("for product groups or types eg. colors, materials, plans, sizes etc")]), _vm._v(" "), _c('div', {
    staticClass: "card card-colord-pad card-colord-01",
    staticStyle: {
      "margin-top": "1.5em"
    }
  }, [_c('div', {}, [_c('p', [_c('b', [_vm._v("Group Name: ")]), _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.product.product_groups_set_name))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("(eg: Colours)")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Sub Group Name: ")]), _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.product.product_groups_items_set_name))]), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("(eg: Sizes)")])]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "line-height": "0.8"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductSettings', '', '')
      }
    }
  }, [_vm._v(" Change Group Name and Sub Group Name")]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.product_details.setProductSettings) ? _c('div', [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('b', [_vm._v("Group Name: ")]), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("(eg: Colours)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_groups_set_name),
      expression: "product.product_groups_set_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_groups_set_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_groups_set_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('b', [_vm._v("Group Items Name: ")]), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("(eg: Sizes)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_groups_items_set_name),
      expression: "product.product_groups_items_set_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_groups_items_set_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_groups_items_set_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProductSettings
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), (!_vm.product_details.addProductItemPanel) ? _c('div', {
    staticClass: "card card-out-colord-pad"
  }, [(_vm.product.product_set_groups == 0) ? _c('div') : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "1em 0",
      "display": "none"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('addProductItemPanel', '', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Product Variation")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (!_vm.product_details.addProductItemPanel) ? _c('div', {
    staticClass: "card card-out-colord-pad",
    staticStyle: {
      "margin-top": "1.5em"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right",
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('addProductItemPanel', '', '')
      }
    }
  }, [_vm._v("Add new Group")]), _vm._v(" "), _c('h5', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_vm._v("Product Groups/Types ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (((_vm.product.product_set_groups > 0) && (_vm.product.product_set_items > 0))) ? _c('div', {}, _vm._l((_vm.product.product_item_groups), function(pg, pgdex) {
    return _c('div', {
      key: pg.id,
      staticClass: "card card-flat-pad",
      staticStyle: {
        "border": "#f7f7f7 solid !important"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "90%"
      }
    }, [_c('div', [_c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("  " + _vm._s(Object.keys(pg.product_items).length) + " items")]), _vm._v(" "), _c('div', {
      staticClass: "box-cube"
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', {
      staticClass: "box-color-cube",
      staticStyle: {
        "z-index": "3"
      }
    }, [((pg.product_item_group_image && (pg.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "-1.5em"
      }
    }, [_c('b', [_vm._v(_vm._s(pg.product_item_group_name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('div', [(_vm.menu_tab_inner_view['PGITMS' + pgdex]) ? _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('')
        }
      }
    }, [_vm._m(1, true)]) : _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('PGITMS' + pgdex)
        }
      }
    }, [_vm._m(2, true)])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (_vm.menu_tab_inner_view['PGITMS' + pgdex]) ? _c('div', [_c('div', {
      staticClass: "orders-panel",
      staticStyle: {
        "margin-top": "1em"
      }
    }, [((!_vm.product_details.editProductItemGroup && !_vm.product_details.removeItemGroup && !_vm.product_details.addProductItemToGroup)) ? _c('div', [_c('div', {
      staticClass: "card card-strip"
    }, [_c('span', [_c('a', {
      staticClass: "sp-app-default-color",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('editProductItemGroup', 'productitemgroup', pg)
        }
      }
    }, [_vm._v("Edit Group")])]), _vm._v("   \n                    "), (_vm.product.product_item_groups && _vm.product.product_item_groups.length > 1) ? _c('span', [_c('a', {
      staticClass: "sp-app-default-color",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('removeItemGroup', 'productitemgroup', pg)
        }
      }
    }, [_vm._v("Delete group")])]) : _vm._e()]), _vm._v(" "), _c('div', {}, [_c('div', {}, [_c('h5', {
      staticStyle: {
        "font-size": "10px",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(_vm.product.product_groups_items_set_name) + "\n                          ")]), _vm._v(" "), _vm._l((pg.product_items), function(pt, ptdex) {
      return _c('div', {
        key: ptdex,
        staticClass: "items-list-tiny",
        staticStyle: {
          "display": "inline"
        }
      }, [_c('div', {
        staticClass: "row",
        staticStyle: {
          "padding": "1em"
        }
      }, [_c('div', {
        staticClass: "box-cube col-xs-2 mp-flat",
        staticStyle: {
          "margin": "0",
          "padding": "0"
        }
      }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', {
        staticClass: "box-color-cube",
        staticStyle: {
          "z-index": "3"
        }
      }, [((pg.product_item_group_image && (pg.product_item_group_image != 'error'))) ? _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": pg.product_item_group_image
        }
      }) : _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
        staticClass: "box-color-cube",
        style: ({
          background: pg.product_item_group_color
        })
      })]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-9 mp-flat",
        staticStyle: {
          "margin": "0",
          "padding": "0"
        }
      }, [(_vm.product.product_service == 'P' && (pt.product_item_size)) ? _c('span', {
        staticStyle: {
          "font-weight": "bolder",
          "font-size": "10px"
        }
      }, [_vm._v(_vm._s(pt.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (pt.product_item_service_tag)) ? _c('span', {
        staticStyle: {
          "font-weight": "bolder",
          "font-size": "10px"
        }
      }, [_vm._v(_vm._s(pt.product_item_service_tag))]) : _vm._e(), _vm._v(" "), _c('span', [_c('a', {
        staticClass: "sp-app-default-color",
        staticStyle: {
          "cursor": "pointer",
          "font-size": "10px"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('editProductItem', 'productitem', pt)
          }
        }
      }, [_vm._v("Edit")])]), _vm._v(" "), (_vm.product.product_items.length > 1) ? _c('span', [_c('a', {
        staticClass: "sp-app-default-color",
        staticStyle: {
          "cursor": "pointer",
          "font-size": "10px"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('removeProductItem', 'productitem', pt)
          }
        }
      }, [_vm._v("Delete")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
        staticStyle: {
          "font-size": "11px"
        }
      }, [(_vm.product.product_service == 'P') ? _c('span', [_vm._m(3, true), _vm._v(_vm._s(pt.product_item_weight))]) : _vm._e(), _vm._v(" "), (pt.product_item_actual_price != 0) ? _c('span', [_vm._m(4, true), _vm._v(_vm._s(pt.product_item_actual_price))]) : _c('span', [_vm._m(5, true), _vm._v(_vm._s(pt.product_item_price))]), _vm._v(" "), _c('span', [_vm._m(6, true), _vm._v(_vm._s(pt.product_item_quantity))])])]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })]), _vm._v(" "), (_vm.product_details.editProductItem && (_vm.product_item.product_item_id == pt.product_item_id)) ? _c('div', {
        staticClass: "col-sm-12",
        staticStyle: {
          "margin-top": "1em",
          "margin-bottom": "1em"
        },
        attrs: {
          "id": "editProductItem"
        }
      }, [_c('h6', {
        attrs: {
          "align": "left"
        }
      }, [_vm._v("Edit Product Item")]), _vm._v(" "), _c('form', {
        staticClass: "sp-form"
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "form-group col-xs-6"
      }, [_c('label', [(_vm.product.product_service == 'P') ? _c('span', [_vm._v(" Size")]) : _vm._e(), (_vm.product.product_service == 'S') ? _c('span', [_vm._v(" Type")]) : _vm._e(), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_size),
          expression: "product_item.product_item_size"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_size)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_size = $event.target.value
          }
        }
      })])]), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('div', {
        staticClass: "form-group col-xs-6"
      }, [_c('label', [_vm._v(" Service Tag\n                                  "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_service_tag),
          expression: "product_item.product_item_service_tag"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_service_tag)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_service_tag = $event.target.value
          }
        }
      })])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "form-group col-xs-6"
      }, [_c('label', [_vm._v(" Price\n                                        "), (_vm.product_item.product_item_actual_price != 0) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_actual_price),
          expression: "product_item.product_item_actual_price"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_actual_price)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_actual_price = $event.target.value
          }
        }
      }) : _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_price),
          expression: "product_item.product_item_price"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_price)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_price = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "form-group col-xs-6"
      }, [_c('label', [_vm._v(" Weight\n                                      "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_weight),
          expression: "product_item.product_item_weight"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "step": "any",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_weight)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_weight = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "form-group col-xs-6"
      }, [_c('label', [_vm._v(" Quantity\n                                      "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_quantity),
          expression: "product_item.product_item_quantity"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_quantity)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_quantity = $event.target.value
          }
        }
      })])]), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('div', {
        staticClass: "col-md-3 col-xs-12"
      }, [_vm._m(7, true), _c('br'), _vm._v(" "), (_vm.product_item.product_item_service_duration != '') ? _c('label', [_c('b', [_vm._v("SET: " + _vm._s(_vm.product_item.product_item_service_duration))])]) : _vm._e(), _vm._v(" "), _c('table', {
        staticStyle: {
          "width": "100%"
        }
      }, [_c('tr', [_c('td', {
        staticStyle: {
          "width": "30%"
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product.product_item_service_duration),
          expression: "product.product_item_service_duration"
        }],
        staticClass: "form-control",
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "type": "number",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product.product_item_service_duration)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product.product_item_service_duration = $event.target.value
          }
        }
      })]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "70%"
        }
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.service_duration),
          expression: "service_duration"
        }],
        staticClass: "form-control",
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.service_duration = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
          }
        }
      }, [_c('option', {
        domProps: {
          "value": undefined
        }
      }, [_vm._v("Select")]), _vm._v(" "), _c('option', [_vm._v("days")]), _vm._v(" "), _c('option', [_vm._v("months")]), _vm._v(" "), _c('option', [_vm._v("years")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "col-md-12 col-xs-12"
      }, [(_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e(), _vm._v(" "), _c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
        staticClass: "btn sp-button-02 sp-button-md",
        staticStyle: {
          "line-height": "1.2",
          "margin-right": "5px"
        },
        attrs: {
          "disabled": _vm.disable_btn,
          "type": "button"
        },
        on: {
          "click": _vm.editProductItem
        }
      }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
        staticClass: "btn sp-button-02 sp-button-md",
        staticStyle: {
          "line-height": "1.2",
          "margin-right": "5px"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('reset-edit', '')
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-ban"
      }), _vm._v(" Cancel")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.product_details.removeProductItem && (_vm.product_item.product_item_id == pt.product_item_id)) ? _c('span', {}, [_c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Do you really want to remove this Item?")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs sp-button-02 sp-button-sm",
        attrs: {
          "disabled": _vm.disable_btn
        },
        on: {
          "click": function($event) {
            _vm.removeProductItem()
          }
        }
      }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs sp-button-02 sp-button-sm",
        on: {
          "click": function($event) {
            _vm.setComponent('reset-edit', '')
          }
        }
      }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e()]) : _vm._e()])])
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs sp-button-02 sp-button-sm",
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('addProductItemToGroup', 'productitemgroup', pg)
        }
      }
    }, [_vm._v(" Add New Item")])], 2), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.product_details.editProductItemGroup || _vm.product_details.removeItemGroup) ? _c('div', {}, [(_vm.product_details.editProductItemGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('div', {
      staticClass: "col-sm-12",
      attrs: {
        "id": "editProductItemGroup"
      }
    }, [_c('h6', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("Edit Group ")]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "form-group col-xs-12"
    }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item_group.product_item_group_name),
        expression: "product_item_group.product_item_group_name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.product_item_group.product_item_group_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item_group.product_item_group_name = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12"
    }, [_c('p', [_vm._v("Group Label (Colour/Image)")]), _vm._v(" "), _c('div', {
      staticClass: "box-cube"
    }, [(_vm.product_item_group.product_item_group_is_color_image == 'IMG') ? _c('div', {}, [((_vm.product_item_group.product_item_group_image && (_vm.product_item_group.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": _vm.product_item_group.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.product_item_group.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _vm._m(8, true), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12"
    }, [_c('label', {
      staticClass: "col-xs-4",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('input', {
      staticStyle: {
        "height": "1em"
      },
      attrs: {
        "type": "radio",
        "name": "prt-color-image",
        "value": "colour"
      },
      on: {
        "click": function($event) {
          _vm.toggleDoubleComponent('prt-color-edit', 'prt-image-edit')
        }
      }
    }), _vm._v("\n                          Colour\n                        ")]), _vm._v(" "), _c('label', {
      staticClass: "col-xs-4",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('input', {
      staticStyle: {
        "height": "1em"
      },
      attrs: {
        "type": "radio",
        "name": "prt-color-image",
        "value": "image"
      },
      on: {
        "click": function($event) {
          _vm.toggleDoubleComponent('prt-image-edit', 'prt-color-edit')
        }
      }
    }), _vm._v("\n                          Image\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "clear": "both",
        "display": "none",
        "padding": "1em"
      },
      attrs: {
        "id": "prt-color-edit"
      }
    }, [_c('label', {
      staticClass: "sp-app-default-color"
    }, [_vm._v(" Select a Colour ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item_group.product_item_group_color_new),
        expression: "product_item_group.product_item_group_color_new"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "4em"
      },
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": (_vm.product_item_group.product_item_group_color_new)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item_group.product_item_group_color_new = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "clear": "both",
        "display": "none",
        "padding": "1em"
      },
      attrs: {
        "id": "prt-image-edit"
      }
    }, [(_vm.product.product_images && (Object(_vm.product.product_images).length > 0)) ? _c('div', [_c('label', [_vm._v("Pick Image")]), _vm._v(" "), _c('div', {
      staticClass: "row img-row"
    }, _vm._l((_vm.product.product_images), function(img, index) {
      return _c('div', {
        key: index,
        staticClass: "col-xs-1",
        staticStyle: {
          "height": "40px",
          "width": "100px",
          "margin-bottom": "5px"
        },
        attrs: {
          "id": "groupImage"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.setInnerComponent('set-product-item-group-image', img.product_image_id)
          }
        }
      }, [_c('img', {
        staticClass: "product-item-group-image sp-prd-img",
        attrs: {
          "id": img.product_image_id + 'PRTG',
          "src": img.product_image,
          "alt": ""
        }
      })])])
    })), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "z-index": "9"
      }
    }, [_c('div', {
      staticClass: "upload-btn-wrapper",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "id": "uploadDiv"
      }
    }, [_c('button', {
      staticClass: "upload-btn sp-button-02 sp-button-md",
      staticStyle: {
        "line-height": "1.2"
      }
    }, [_vm._v("Add new Image")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "input-file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          _vm.onFileChange($event, 'products', _vm.product.product_id)
        }
      }
    })])]), _c('hr')]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02 sp-button-md",
      staticStyle: {
        "line-height": "1.2",
        "margin-right": "5px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": _vm.editProductItemGroup
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02 sp-button-md",
      staticStyle: {
        "line-height": "1.2",
        "margin-right": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ban"
    }), _vm._v(" Cancel")])])])]) : _vm._e(), _vm._v(" "), (_vm.product_details.removeItemGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('div', {}, [_c('span', {}, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Do you really want to remove this Group?")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs sp-button-02 sp-button-sm",
      on: {
        "click": function($event) {
          _vm.removeProductItemGroup()
        }
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs sp-button-02 sp-button-sm",
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.product_details.addProductItemToGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('div', {
      staticClass: "row"
    }, [(_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "col-md-6 col-xs-12"
    }, [_c('label', [_vm._v("Attributes (eg: Size, Plan, Length etc,)\n                          "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_size),
        expression: "product.product_item_size"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_size)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_size = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('div', {
      staticClass: "col-md-4 col-xs-4"
    }, [_c('label', [_vm._v(" Service Tag\n                            "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_service_tag),
        expression: "product.product_item_service_tag"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_service_tag)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_service_tag = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 col-xs-4"
    }, [_c('label', [_vm._v(" Price\n                            "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_price),
        expression: "product.product_item_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "value": "",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_price = $event.target.value
        }
      }
    })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "col-md-3 col-xs-4"
    }, [_c('label', [_vm._v(" Weight(KG)\n                            "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_weight),
        expression: "product.product_item_weight"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "step": "any",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_weight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_weight = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 col-xs-4"
    }, [_c('label', [_vm._v(" Quantity\n                            "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_quantity),
        expression: "product.product_item_quantity"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_quantity = $event.target.value
        }
      }
    })])]), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('div', {
      staticClass: "col-md-3 col-xs-6"
    }, [_vm._m(9, true), _vm._v(" "), _c('table', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_service_duration),
        expression: "product.product_item_service_duration"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "number",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_service_duration)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_service_duration = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "70%"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.service_duration),
        expression: "service_duration"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.service_duration = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _c('option', [_vm._v("days")]), _vm._v(" "), _c('option', [_vm._v("months")]), _vm._v(" "), _c('option', [_vm._v("years")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 col-xs-12"
    }, [_c('p', {
      staticClass: "data-error-message"
    }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
      staticClass: "data-success-message"
    }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02 sp-button-md",
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": _vm.addProductItem
      }
    }, [_vm._v("Add Item")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02 sp-button-md",
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _vm._e()])]) : _vm._e()])
  })) : _c('div', {
    staticStyle: {
      "margin": "5px 0.89em"
    }
  }, [_c('p', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("You have not set any Product item variation")])])]) : _vm._e(), _vm._v(" "), (_vm.product_details.addProductItemPanel) ? _c('div', {}, [_c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right",
      "line-height": "1.2"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")]), _vm._v(" "), _c('h6', [_vm._v("Add New Group or Variation")]), _vm._v(" "), _c('form', {
    key: _vm.productVariationComponentKey,
    staticClass: "sp-form",
    staticStyle: {
      "margin-top": "1em",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.product.product_set_groups > 0) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "line-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showProductItemGroups),
      expression: "showProductItemGroups"
    }],
    staticStyle: {
      "height": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "showtrue"
    },
    domProps: {
      "checked": _vm._q(_vm.showProductItemGroups, "showtrue")
    },
    on: {
      "__c": function($event) {
        _vm.showProductItemGroups = "showtrue"
      }
    }
  }), _vm._v(" "), _vm._v("\n                          Add new Items to "), _c('span', [_vm._v(_vm._s(_vm.product.product_groups_set_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "line-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showProductItemGroups),
      expression: "showProductItemGroups"
    }],
    staticStyle: {
      "height": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "showfalse"
    },
    domProps: {
      "checked": _vm._q(_vm.showProductItemGroups, "showfalse")
    },
    on: {
      "__c": function($event) {
        _vm.showProductItemGroups = "showfalse"
      }
    }
  }), _vm._v("\n                              Or Add new " + _vm._s(_vm.product.product_groups_set_name) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.showProductItemGroups == 'showtrue') ? _c('div', [_c('br'), _vm._v(" "), _vm._m(10), _vm._v(" "), ((_vm.product.product_item_groups.length && _vm.product.product_item_groups.length > 0)) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._l((_vm.product.product_item_groups), function(pg, pgdex) {
    return _c('div', {
      key: pgdex
    }, [_c('div', {
      staticClass: "col-xs-2"
    }, [_c('div', {
      staticStyle: {
        "padding": "5px",
        "margin-bottom": "5px",
        "width": "10%"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": pg.product_item_group_name
      },
      on: {
        "click": function($event) {
          _vm.setInnerComponent('set-product-item-group', pg)
        }
      }
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', [_c('div', {
      staticClass: "box-color-cube"
    }, [_c('img', {
      staticClass: "product-item-group sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image,
        "id": pg.product_item_group_id + 'PRTGR'
      }
    })])]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "product-item-group",
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    }, [_c('div', {
      staticClass: "box-color-cube",
      staticStyle: {
        "height": "3em",
        "width": "85%"
      },
      style: ({
        background: pg.product_item_group_color
      })
    })])]) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#000000",
        "font-weight": "bold",
        "font-size": "12px",
        "line-height": "1.2",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(pg.product_item_group_name))])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showProductItemGroups == 'showfalse') ? _c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Name of new " + _vm._s(_vm.product.product_groups_set_name) + " "), _c('br'), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("(eg:Blue,Black,Custom,Anyname..)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_group_name),
      expression: "product.product_item_group_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_item_group_name)
    },
    on: {
      "change": function($event) {
        (_vm.productVariationComponentKey++)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_group_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12",
    staticStyle: {
      "font-size": "16px",
      "margin": "0",
      "padding": "0"
    }
  }, [_vm._v("Group Colour/Image")]), _vm._v(" "), _c('label', {
    staticClass: "col-xs-4",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('input', {
    staticStyle: {
      "height": "1em"
    },
    attrs: {
      "type": "radio",
      "name": "prt-color-image",
      "value": "colour"
    },
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('prt-color', 'prt-image')
      }
    }
  }), _vm._v("\n                        Colour\n                      ")]), _vm._v(" "), _c('label', {
    staticClass: "col-xs-4",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('input', {
    staticStyle: {
      "height": "1em"
    },
    attrs: {
      "type": "radio",
      "name": "prt-color-image",
      "value": "image"
    },
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('prt-image', 'prt-color')
      }
    }
  }), _vm._v("\n                        Image\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "clear": "both",
      "display": "none",
      "padding": "1em"
    },
    attrs: {
      "id": "prt-color"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(" Pick Colour\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_group_color),
      expression: "product.product_item_group_color"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "4em"
    },
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.product.product_item_group_color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_group_color = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "clear": "both",
      "display": "none",
      "border": "1px dashed #eeccee",
      "padding": "1em"
    },
    attrs: {
      "id": "prt-image"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(" Or Pick Image ")]), _vm._v(" "), _c('div', {
    staticClass: "row img-row"
  }, [_vm._l((_vm.product.product_images), function(img, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-1",
      staticStyle: {
        "height": "50px",
        "width": "70px"
      },
      attrs: {
        "id": "groupImage"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setInnerComponent('set-product-item-group-image', img.product_image_id)
        }
      }
    }, [_c('img', {
      staticClass: "product-item-group-image sp-prd-img",
      attrs: {
        "id": img.product_image_id + 'PRTG',
        "src": img.product_image,
        "alt": ""
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "z-index": "9"
    }
  }, [_c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v(_vm._s(_vm.max_media_info))]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer",
      "margin-top": "2em"
    }
  }, [_c('button', {
    staticClass: "sp-button-02 sp-button-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Or Add new Image or Video ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "video/*,image/*",
      "capture": ""
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeProductItems($event, 'products', _vm.product.product_id)
      }
    }
  })]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_media_error_message))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('br')]), _vm._v(" "), ((_vm.showProductItemGroups == 'showtrue') || (_vm.showProductItemGroups == 'showfalse')) ? _c('div', {
    key: _vm.productAddView02ComponentKey,
    staticClass: "row col-md-12"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "sp-app-default-text-color-dim-1",
    staticStyle: {
      "color": "#898989"
    }
  }, [_vm._v("Add an Item to this Group\n                      "), (_vm.product.product_item_group_name && (_vm.product.product_item_group_name != '')) ? _c('span', [_vm._v("\n                      : ("), _c('b', [_vm._v(_vm._s(_vm.product.product_item_group_name))]), _vm._v(")")]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('span', [_vm._v("(eg:sizes,lengths,materials)")]) : _vm._e()])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_size),
      expression: "product.product_item_size"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_size)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_size = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "1em",
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "col-xs-5"
  }, [_vm._v(" \n                    " + _vm._s(_vm.product.product_groups_items_set_name)), _c('br'), _vm._v("(eg:sizes,lengths,materials)\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1"
  }, [_vm._v(" - ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_vm._v("\n                      (eg:big,long,short,xl,m...)"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_size),
      expression: "product.product_item_size"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_size)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_size = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('div', {
    staticClass: "col-md-3 col-xs-6"
  }, [_c('label', [_vm._v(" Service Tag "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_service_tag),
      expression: "product.product_item_service_tag"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_service_tag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_service_tag = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-6"
  }, [_c('label', [_vm._v(" Price\n                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('div', {
    staticClass: "col-md-3 col-xs-6"
  }, [_vm._m(12), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_service_duration),
      expression: "product.product_item_service_duration"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_service_duration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_service_duration = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service_duration),
      expression: "service_duration"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.service_duration = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', [_vm._v("days")]), _vm._v(" "), _c('option', [_vm._v("months")]), _vm._v(" "), _c('option', [_vm._v("years")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v(" Weight(KG)\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v(" Quantity\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticClass: "data-success-message"
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProductItem
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Product Types / Groups")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Wt(kg):")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Price:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Price:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Qty:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v(" Duration "), _c('span', {
    staticClass: "sp-info-sm"
  }, [_vm._v("eg: 3 months")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("To change Group Label, pick Colour or Image")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v(" Duration "), _c('span', {
    staticClass: "sp-info-sm"
  }, [_vm._v("eg: 3 months")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Select a Group from below:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Name of item / Describe product "), _c('br'), _vm._v("(eg:big,long,short,xl,m...)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v(" Duration "), _c('span', {
    staticClass: "sp-info-sm"
  }, [_vm._v("eg: 3 months")])])
}]}

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('header', {
    staticClass: "header-wrap-sticky",
    staticStyle: {
      "display": "none",
      "background": "#000000",
      "color": "#ffffff",
      "border-bottom": "none"
    },
    attrs: {
      "id": "mainStickyHeader"
    }
  }, [_c('div', {
    staticClass: "row header-wrap-inner",
    staticStyle: {
      "border-bottom": "none",
      "margin": "0"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "-20em"
    }
  }, [_c('a', {
    staticClass: "header-nav-back",
    staticStyle: {
      "background": "#000000 !important",
      "color": "#ffffff"
    },
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "color": "#ffffff",
      "font-size": "14px"
    }
  }), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("  "), _c('b', [_vm._v(_vm._s(_vm.header_name))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "width": "100%",
      "margin-left": "-2em",
      "margin-top": "-3em",
      "background-color": "#000000",
      "height": "auto",
      "padding": "2em",
      "text-align": "center",
      "color": "#ffffff"
    }
  }, [_c('h3', {}, [_vm._v(_vm._s(_vm.sellpoint.business_name)), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("C A T A L O G")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "row"
  }, [(!_vm.has_sellpoints) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(1)]) : _c('div', {}, [_c('div', {
    staticClass: "row page-top-header sticky-tab",
    staticStyle: {
      "display": "none",
      "width": "100% !important",
      "margin": "0 !important",
      "margin-top": "-0.3em !important",
      "background": "#000000 !important",
      "color": "#ffffff"
    },
    attrs: {
      "id": "pageStickyHeaderMAIN"
    }
  }, [_c('div', {
    staticClass: "head-tags"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "90% !important"
    }
  }, [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'viewBusinessProducts', _vm.sellpoint, '/account/business')
      }
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {}, [_c('p', {
    staticStyle: {
      "text-transform": "capitalize",
      "margin-top": "0.8em",
      "margin-left": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_name))])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "7% !important"
    }
  }, [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "color": "#ffffff",
      "margin-right": "1em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'manageBusiness', _vm.sellpoint, '/account/business/settings')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear",
    staticStyle: {
      "color": "#ffffff",
      "font-size": "16px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tab-slide",
    staticStyle: {
      "clear": "both",
      "margin-top": "-1.5em"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', '', _vm.sellpoint, '/account/business')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _c('br'), _vm._v("Business")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'viewBusinessProducts', _vm.sellpoint, '/account/business/products')
      }
    }
  }, [_vm._v("Products")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'viewBusiness', _vm.sellpoint, '/account/business/categories')
      }
    }
  }, [_vm._v("Categories")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'setBusinessOrders', _vm.sellpoint, '/account/business/orders')
      }
    }
  }, [_vm._v("Orders")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'manageBusiness', _vm.sellpoint, '/account/business/settings')
      }
    }
  }, [_vm._v("Settings")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel"
  }, [((Object.keys(_vm.sellpoint).length > 0)) ? _c('div', [(_vm.sellpoint) ? _c('div', {
    staticStyle: {
      "text-align": "left",
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "page-top-header sticky-tab",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "pageStickyHeaderMAIN"
    }
  }, [_c('div', {
    staticClass: "head-tags"
  }, [_c('div', {
    staticClass: "col-xs-2 header-left",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "headTagBack"
    }
  }, [_c('a', {
    staticClass: "header-nav-back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "-1em"
    }
  }, [_c('p', {
    staticClass: "sp-app-default-color",
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bolder"
    }
  }, [_vm._v("STORE")]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": _vm.back
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-transform": "uppercase",
      "margin-top": "-0.8em"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_name))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-slide",
    staticStyle: {
      "margin-top": "-1.5em"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'viewBusinessProducts', _vm.sellpoint, '/account/business')
      }
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'viewBusinessProducts', _vm.sellpoint, '/account/business/product')
      }
    }
  }, [_vm._v("Products")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'viewBusiness', _vm.sellpoint, '/account/business/categories')
      }
    }
  }, [_vm._v("Categories")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'setBusinessOrders', _vm.sellpoint, '/account/business/orders')
      }
    }
  }, [_vm._v("Orders")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'manageBusiness', _vm.sellpoint, '/account/business/settings')
      }
    }
  }, [_vm._v("Settings")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row-after-stick",
    staticStyle: {
      "padding": "0.7em"
    }
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(2)]) : _c('div', [(this.$route.path != '/account/business') ? _c('div', [_c('router-view')], 1) : _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "card detail-card",
    staticStyle: {
      "padding": "0.3em"
    }
  }, [(Object.keys(_vm.menu_tab_inner_view).length == 0) ? _c('div', {
    staticClass: "card row"
  }, [_c('div', {
    staticClass: "col-xs-12 row00"
  }, [_c('div', {
    staticClass: "card card-strip"
  }, [_c('p', [_c('b', [_vm._v("Name")]), _c('br'), _vm._v(_vm._s(_vm.sellpoint.business_name))])]), _vm._v(" "), _c('div', {
    staticClass: "card card-strip"
  }, [_c('p', [_c('b', [_vm._v("Phone numbers and Emails")]), _c('br'), _vm._v("\r\n                              " + _vm._s(_vm.sellpoint.business_phones) + " "), (_vm.sellpoint.business_emails != '') ? _c('span', [_vm._v(", " + _vm._s(_vm.sellpoint.business_emails))]) : _vm._e()]), _vm._v(" "), ((_vm.sellpoint.business_phones == '') && (_vm.sellpoint.business_emails == '')) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Not yet added")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('viewBusinessProfile', '', '')
      }
    }
  }, [_vm._v("See Business Profile")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('hr')]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view.viewBusinessProfile) ? _c('div', {
    staticClass: "card"
  }, [_c('h6', [_vm._v("Business Details")]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.menu_tab_inner_view = {}
      }
    }
  }, [_vm._v("<< Back")]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  }), _vm._v(" "), _c('div', {
    staticClass: "card card-strip"
  }, [_c('p', [_vm._m(5), _c('br'), _vm._v(_vm._s(_vm.sellpoint.business_name))])]), _vm._v(" "), _c('div', {
    staticClass: "card card-strip"
  }, [_c('p', [_vm._m(6), _c('br'), _vm._v(_vm._s(_vm.sellpoint.business_profile))])]), _vm._v(" "), _c('div', {
    staticClass: "card card-strip"
  }, [_c('p', [_vm._m(7), _c('br'), _vm._v(_vm._s(_vm.sellpoint.business_address))])]), _vm._v(" "), _c('div', {
    staticClass: "card card-strip"
  }, [_c('p', [_vm._m(8), _c('br'), _vm._v(_vm._s(_vm.sellpoint.business_emails))])]), _vm._v(" "), _c('div', {
    staticClass: "card card-strip"
  }, [_c('p', [_vm._m(9), _c('br'), _vm._v(_vm._s(_vm.sellpoint.business_phones))])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('editBusinessProfile', '', '')
      }
    }
  }, [_vm._v("Edit Business Profile")]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'manageBusiness', _vm.sellpoint, '/account/business/settings')
      }
    }
  }, [_vm._v("Shop Settings")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card card-out-colord-pad",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('p', [_vm._v("Shop Banner Image")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "rounded",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "object-fit": "cover"
    },
    attrs: {
      "src": _vm.sellpoint.business_banner_image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "banner-btn upload-btn-wrapper"
  }, [_c('button', {
    staticClass: "upload-btn btn sp-button-02",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "12px",
      "line-height": "0.6"
    },
    attrs: {
      "disabled": _vm.disable_btn
    }
  }, [_vm._v("Change Banner Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeBannerImage($event, 'business_banner_image')
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card card-out-colord-pad",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('p', [_vm._v("Shop Profile Image")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "rounded",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "object-fit": "cover"
    },
    attrs: {
      "src": _vm.sellpoint.business_brand_image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "banner-btn upload-btn-wrapper"
  }, [_c('button', {
    staticClass: "upload-btn btn sp-button-02",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "12px",
      "line-height": "0.6"
    },
    attrs: {
      "disabled": _vm.disable_btn
    }
  }, [_vm._v("Change Profile Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeBannerImage($event, 'business_brand_image')
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view.editBusinessProfile) ? _c('div', [_c('hr'), _vm._v(" "), _c('h6', [_vm._v("Edit Business Details")]), _vm._v(" "), _c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_name),
      expression: "sellpoint.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Tagline")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_tagline),
      expression: "sellpoint.business_tagline"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_tagline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_tagline = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Brief")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_profile),
      expression: "sellpoint.business_profile"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.sellpoint.business_profile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_profile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_address),
      expression: "sellpoint.business_address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Emails")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_emails),
      expression: "sellpoint.business_emails"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_emails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_emails = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_phones),
      expression: "sellpoint.business_phones"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_phones)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_phones = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('main')
      }
    }
  }, [_vm._v("Save Details")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('');
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e()])])])])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "mobile-fix-nav",
    staticStyle: {
      "z-index": "7",
      "height": "4em",
      "background": "#000000",
      "bottom": "0em",
      "border-top": "#afadad 1px solid",
      "padding-top": "1.5em"
    }
  }, [_c('div', {
    staticClass: "tab-slide",
    staticStyle: {
      "clear": "both",
      "margin-top": "-1.5em"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', '', _vm.sellpoint, '/account/business')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _c('br'), _vm._v("Business")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'viewBusinessProducts', _vm.sellpoint, '/account/business/products')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clone"
  }), _c('br'), _vm._v("Products")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'viewBusiness', _vm.sellpoint, '/account/business/categories')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _c('br'), _vm._v("Categories")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'setBusinessOrders', _vm.sellpoint, '/account/business/orders')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _c('br'), _vm._v("Orders")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "4em"
    }
  }, [_c('div', {
    staticClass: "card card-row"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("You do not have a store yet")]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "href": "/account/business/newbusiness"
    }
  }, [_vm._v("Register Businesses and create Sellpoints")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 row01"
  }, [_c('h6', {
    staticClass: "col-xs-12"
  }, [_vm._v("Quick Links")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/orders"
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-shopping-basket"
  })]), _vm._v(" "), _c('p', [_vm._v("About Shop Information")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-list"
  })]), _vm._v(" "), _c('p', [_vm._v("Add Product to Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-credit-card",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Generate Transfer Receipt")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })]), _vm._v(" "), _c('p', [_vm._v("Set Bank & Payment Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-cubes"
  })]), _vm._v(" "), _c('p', [_vm._v("Manage Shipping")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-upload"
  })]), _vm._v(" "), _c('p', [_vm._v("Set Rewards & Commissions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 row01"
  }, [_c('h6', {
    staticClass: "col-xs-12"
  }, [_vm._v("How my shop appears to people")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/orders"
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-shopping-basket"
  })]), _vm._v(" "), _c('p', [_vm._v("Shop Banner Photo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-list"
  })]), _vm._v(" "), _c('p', [_vm._v("Shop Display or Logo Photo")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-credit-card",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Products and thier photos")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })]), _vm._v(" "), _c('p', [_vm._v("Category List of my shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-cubes"
  })]), _vm._v(" "), _c('p', [_vm._v("See Posts & Updates")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-upload"
  })]), _vm._v(" "), _c('p', [_vm._v("Promos & Discounts")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('u', [_vm._v("Name ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('u', [_vm._v("About ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('u', [_vm._v("Address ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('u', [_vm._v("Emails ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('u', [_vm._v("Phone ")])])
}]}

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "chart-page"
  }, [_c('div', {
    staticClass: "container"
  }, [(!_vm.cart.length) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "1.4em"
    }
  }, [_vm._m(2)]) : _c('div', {
    staticClass: "col-sm-12 chart-card"
  }, [_c('cart-widget')], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "2px 1em"
    }
  }, [_c('h3', {
    staticClass: "on-dark",
    staticStyle: {
      "float": "left",
      "text-align": "left",
      "margin-top": "-0.3px",
      "font-size": "18px"
    }
  }, [_vm._v("Process order")]), _vm._v(" "), _c('div', {
    staticClass: "sp-app-default-color"
  }, [_c('a', {
    staticClass: "on-dark",
    staticStyle: {
      "float": "right",
      "color": "inherit"
    },
    attrs: {
      "href": "/"
    }
  }, [_vm._v("or Continue shopping")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h5', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center"
    }
  }, [_vm._v("Your cart is empty,")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "padding": "0.5em",
      "background": "#ffa800",
      "color": "#000000"
    },
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Start Buying")])])
}]}

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container card-box",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('a', {
    staticClass: "x-cta-btn card-link",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', [_vm._m(1)]) : _c('div', {
    staticClass: "card"
  }, [((Object.keys(_vm.orders).length > 0)) ? _c('div', _vm._l((_vm.orders), function(order) {
    return _c('div', {
      staticClass: "row card-box card-02",
      staticStyle: {
        "border-bottom": "#eee solid",
        "margin-bottom": "2em"
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "card-link",
      attrs: {
        "href": '/placed/order/' + order.order_no
      }
    }, [_c('div', {
      staticClass: "col-xs-4"
    }, [_c('div', {
      staticStyle: {
        "display": "inline",
        "padding-bottom": "1em"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "80px",
        "height": "100px",
        "border-radius": "8px"
      },
      attrs: {
        "src": _vm.img_product_url + order.order_items[0].product_item_group_image
      }
    }), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8"
    }, [_c('h4', {
      staticStyle: {
        "font-weight": "800"
      }
    }, [_vm._v(_vm._s(order.order_items[0].product_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(order.order_details))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(order.order_time_ago) + " >")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  })) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No Orders yet")])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticStyle: {
      "font-weight": "800",
      "font-size": "28px"
    }
  }, [_vm._v("Orders")]), _c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    staticStyle: {
      "color": "#ff0000",
      "font-weight": "600"
    }
  }), _vm._v(" Re-Order")])
}]}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap"
  }, [(_vm.menu_tab_view.viewTransfer) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.transfer_ref == '') ? _c('a', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "16px",
      "color": "#000000"
    }
  }), _vm._v(" BACK\r\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('h2', {
    staticStyle: {
      "float": "left",
      "margin-top": "-0.01em"
    }
  }, [_vm._v("eShop")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right",
      "color": "#000000",
      "font-weight": "bold"
    }
  }, [_c('b', [_vm._v("REF NO: ")]), _c('br'), _vm._v(_vm._s(_vm.transfer.payment_order_ref))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.transfer.payment_order_business_name))]), _vm._v(" "), _c('p', [(_vm.transfer.payment_order_business_email != '') ? _c('span', [_vm._v(_vm._s(_vm.transfer.payment_order_business_email)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.transfer.payment_order_business_phone != '') ? _c('span', [_vm._v(_vm._s(_vm.transfer.payment_order_business_phone))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('p', {
    staticStyle: {
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.transfer.payment_order_user_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.transfer.payment_order_user_email))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.transfer.payment_order_user_phone))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4",
    staticStyle: {
      "margin-top": "0.2em"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.transfer.payment_order_set_date))]), _vm._v(" "), (_vm.transfer.payment_order_payment_status) ? _c('p', [_vm._v("Status: \r\n            "), _c('span', {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.transfer.payment_order_payment_status))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('h5', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Order Items")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "border": "#000000 solid 1px",
      "width": "100% !important"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.transfer.payment_order_items), function(item, index) {
    return _c('tr', {}, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_c('p', [_vm._v(_vm._s(item.product_name) + "\r\n                "), _vm._v(" "), _c('a', {
      staticClass: "card-link",
      staticStyle: {
        "float": "right",
        "color": "#f32144",
        "font-size": "12px"
      },
      on: {
        "click": function($event) {
          _vm.transfer_item = item;
          _vm.set_view = true;
        }
      }
    }, [_vm._v("View")])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.product_item_order_quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency_2(item.product_item_order_total)))])])
  })], 2), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "col-xs-8",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('p', [_c('b', [_vm._v("Total: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency_2(_vm.transfer.payment_order_total_amount)))]), _vm._v(" "), (_vm.transfer.payment_order_payment_status) ? _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.transfer.payment_order_payment_status))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "text-align": "center"
    }
  }, [_c('hr'), _vm._v(" "), (_vm.transfer.payment_order_payment_status_id == 7) ? _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "background": "#f32144",
      "color": "#ffffff"
    },
    on: {
      "click": _vm.preparePaymentData
    }
  }, [_vm._v("Make Payment")]) : _vm._e()])])])]) : _c('div', [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), (_vm.loading) ? _c('div', [_c('p', [_vm._v("loading...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "4em"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "1em"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("Generate and make Transfer payments for goods and services")]), _vm._v(" "), _c('a', {
    staticClass: "card-link btn sp-button-02 sp-button-02-lt",
    staticStyle: {
      "float": "right",
      "font-size": "13px",
      "margin-top": "0.1em",
      "text-transform": "inherit",
      "background-color": "#f32144",
      "color": "#ffffff",
      "border-radius": "5px",
      "padding": "3px 10px"
    },
    on: {
      "click": function($event) {
        _vm.setGenerateReceipt()
      }
    }
  }, [_vm._v("\r\n        Generate Transfer Receipt\r\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin": "1em 0"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.getGeneratedTransferOrders()
      }
    }
  }, [_vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.getTransferOrders()
      }
    }
  }, [_c('h4', {
    attrs: {
      "id": "t_payment"
    }
  }, [_vm._v("Payments")])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "2em",
      "margin-bottom": "2em"
    }
  }, [(_vm.action_loading) ? _c('div', [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("loading...")])]) : _c('div', [_vm._l((_vm.transfers), function(transfer, index) {
    return _c('div', {
      staticClass: "card card-row",
      staticStyle: {
        "background": "#ffffff",
        "border-radius": "0px",
        "margin-bottom": "0.6em"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "99%",
        "padding-top": "0.1em"
      }
    }, [_c('div', {
      staticClass: "col-xs-12 colx"
    }, [_c('div', {
      staticClass: "col-xs-9 colx"
    }, [_c('p', [(_vm.data_view == 'invoices') ? _c('span', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px",
        "text-transform": "uppercase"
      }
    }, [_vm._v("invoice")]) : _vm._e(), _vm._v(" "), (transfer.payment_order_is_from == 1) ? _c('span', [_vm._m(3, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(transfer.payment_order_from))])]) : _vm._e(), _vm._v(" "), (transfer.payment_order_is_to == 1) ? _c('span', [_vm._m(4, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(transfer.payment_order_to))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("₦" + _vm._s(_vm.formatCurrency_2(transfer.payment_order_total_amount)))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(transfer.payment_order_set_date_f))]), _c('br'), _vm._v(" "), (transfer.payment_order_payment_status) ? _c('span', {
      staticStyle: {
        "color": "#ff0000",
        "padding-top": "2.5em"
      }
    }, [_vm._v(_vm._s(transfer.payment_order_payment_status))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3 colx"
    }, [_c('p', {
      staticStyle: {
        "margin-top": "1.5em"
      }
    }, [_c('span', [_c('a', {
      staticClass: "card-link btn sp-button-02 sp-button-02-lt",
      staticStyle: {
        "font-size": "13px",
        "margin-top": "0.1em",
        "text-transform": "inherit",
        "background-color": "#21a6f3",
        "color": "#ffffff",
        "border-radius": "5px",
        "padding": "3px 10px"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabView('viewTransfer', transfer)
        }
      }
    }, [_vm._v("\r\n                            View\r\n                          ")])])])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('hr')])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (Object.keys(_vm.transfers).length == 0) ? _c('div', [(_vm.data_view == 'invoices') ? _c('div', [_vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.data_view == 'payments') ? _c('div', [_vm._m(6)]) : _vm._e()]) : _vm._e()], 2)])])])]), _vm._v(" "), _c('component-footer'), _vm._v(" "), (_vm.set_view) ? _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "block",
      "z-index": "10000"
    },
    attrs: {
      "id": "viewBox"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_view = false
      }
    }
  }, [_c('span', {
    staticClass: "s-backdrop"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "bottom": "0",
      "margin": "0 -1.2em",
      "background": "none",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "0.1em",
      "background": "#ffffff",
      "color": "#000000",
      "border-top": "#061433 solid",
      "border-radius": "45px 45px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "80vh"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.set_view = false
      }
    }
  }, [_vm._m(7), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em",
      "font-size": "28px"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 5em",
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.img_product_url + _vm.transfer_item.product_display_image
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.transfer_item.product_name))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("₦" + _vm._s(_vm.formatCurrency_2(_vm.transfer_item.product_item_total_price)))])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.set_payment) ? _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "block",
      "z-index": "10000"
    },
    attrs: {
      "id": "viewBox"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_payment = false
      }
    }
  }, [_c('span', {
    staticClass: "s-backdrop"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "bottom": "0",
      "margin": "0 -1.2em",
      "background": "none",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "0.1em",
      "background": "#fcfcfc",
      "color": "#000000",
      "border-top": "#d8d8d8 solid",
      "border-radius": "45px 45px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "60vh"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.set_payment = false
      }
    }
  }, [_vm._m(8), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em",
      "font-size": "24px"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 0.5em",
      "text-align": "center"
    }
  }, [(_vm.show_empty_fields) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('p', [_vm._v("Please provide and confirm your details")]), _vm._v(" "), _c('form', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "title": "Enter  Name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "title": "Enter  Email",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "number",
      "title": "Enter Phone Number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "color": "#0400ff",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default wnf-button",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": ""
    },
    on: {
      "click": _vm.setUserData
    }
  }, [_vm._v("Enter")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "-6em"
    }
  }, [_c('component-checkout', {
    attrs: {
      "paymentdata": _vm.payment_data
    }
  })], 1)])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("S/N")]), _vm._v(" "), _c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Qty")]), _vm._v(" "), _c('th', [_vm._v("Amount(₦)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "htro"
  }, [_c('span', [_vm._v(" ")]), _vm._v("Transfer Payments")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    attrs: {
      "id": "t_invoice"
    }
  }, [_vm._v("Invoices\r\n              "), _c('span', {
    staticStyle: {
      "border-right": "solid 1px #91918f",
      "margin-left": "4em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("From: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("To: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("You have no invoice yet; "), _c('br'), _vm._v("\r\n                  1. if you sell, Generate an Invoice to receive Transfer Payments "), _c('br'), _vm._v("\r\n                  2. Ask the Business owner you shop from to generate an Invoice for you, so you can make Transfer Payment "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("You have no Transfer record yet; "), _c('br'), _vm._v("\r\n                  1. if you sell, Generate and share your Invoice to receive Transfer Payments "), _c('br'), _vm._v("\r\n                  2. Check your invoices or Ask the Business owner you shop from to share an Invoice with you, so you can make Transfer Payment "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
}]}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "page-top-header",
    attrs: {
      "id": "pageStickyHeader"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "h-menu"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('timeline')
      }
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('markets')
      }
    }
  }, [_vm._v("Markets")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('trending')
      }
    }
  }, [_vm._v("Trending")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pager",
    staticStyle: {
      "border": "indigo solid"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "border": "rgb(26, 130, 0) solid"
    },
    attrs: {
      "id": "topPanel"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', {
    staticStyle: {
      "border": "indigo solid"
    }
  }, [(_vm.menu_view.timeline) ? _c('div', {
    staticClass: "row card-box-o"
  }, _vm._l((_vm.market.business_markets), function(user, index) {
    return _c('div', {
      staticClass: "card card-01 timeline-user-card"
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + user.business_username
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-circle"
    }, [_c('img', {
      attrs: {
        "src": user.business_banner_image
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right"
    }, [_c('div', {
      staticClass: "card-arm-line"
    }, [_c('p', [_vm._v(_vm._s(user.business_name)), _c('br'), _c('span', [_vm._v("@" + _vm._s(user.business_username))])])]), _vm._v(" "), _vm._m(1, true)])])])
  })) : _vm._e(), _vm._v(" "), (_vm.menu_view.markets) ? _c('div', {
    staticClass: "row card-box-o"
  }, _vm._l((_vm.market_groups), function(group, index) {
    return _c('div', {
      staticClass: "card card-01"
    }, [_c('h5', [_vm._v(_vm._s(group.business_market_group_name))]), _vm._v(" "), _vm._l((group.businesses_in_business_market_group), function(business, index) {
      return _c('div', _vm._l((business.business_market_group_business_products), function(product, index2) {
        return _c('div', {
          staticClass: "card card-01 timeline-user-card"
        }, [_c('a', {
          staticStyle: {
            "text-decoration": "none",
            "color": "inherit"
          },
          attrs: {
            "href": '/' + product.product_business_ownername + '/' + product.product_url_name
          }
        }, [_vm._m(2, true), _vm._v(" "), _c('div', {
          staticClass: "card-left"
        }, [_c('div', {
          staticClass: "card-avatar-square"
        }, [(product.product_images[0]) ? _c('img', {
          attrs: {
            "src": product.product_images[0].product_image
          }
        }) : _c('img', {
          attrs: {
            "src": "/static/assets/images/dummy-image.png"
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "card-right"
        }, [_c('div', {
          staticClass: "card-arm-line"
        }, [_c('p', [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price) + " - ₦" + _vm._s(product.product_items[0].product_item_price))]) : _vm._e()])]), _vm._v(" "), _vm._m(3, true)])])])
      }))
    })], 2)
  })) : _vm._e(), _vm._v(" "), (_vm.menu_view.trending) ? _c('div', {
    staticClass: "row card-box-o"
  }, _vm._l((_vm.market_trending), function(product, index) {
    return _c('div', {
      staticClass: "card card-01 timeline-user-card"
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + product.product_business_ownername + '/' + product.product_url_name
      }
    }, [_c('span', {
      staticClass: "card-thumb-up-left"
    }, [_vm._v("@" + _vm._s(product.product_business_ownername))]), _vm._v(" "), _c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-square"
    }, [(product.product_images[0]) ? _c('img', {
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right"
    }, [_c('div', {
      staticClass: "card-arm-line"
    }, [_c('p', [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price) + " - ₦" + _vm._s(product.product_items[0].product_item_price))]) : _vm._e()])]), _vm._v(" "), _vm._m(4, true)])])])
  })) : _vm._e()])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "card-thumb-up-left"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-arm-alt-bottom"
  }, [_c('div', {
    staticClass: "card-analytics"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-tag"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-users"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-certificate"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "card-thumb-up-left"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-arm-alt-bottom"
  }, [_c('div', {
    staticClass: "card-analytics"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-tag"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-users"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-certificate"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-arm-alt-bottom"
  }, [_c('div', {
    staticClass: "card-analytics"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-tag"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })])])])])
}]}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {}, [_vm._m(0)]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "form-card"
  }, [_c('h4', [_vm._v("Create Your Store Account")]), _vm._v(_vm._s(_vm.ko) + _vm._s(_vm.business_open_to_agents) + "\n                "), _c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "display": "none"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_agent),
      expression: "business_agent"
    }],
    attrs: {
      "type": "radio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.business_agent, "0")
    },
    on: {
      "__c": function($event) {
        _vm.business_agent = "0"
      }
    }
  }), _vm._v(" Personal Business")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_agent),
      expression: "business_agent"
    }],
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.business_agent, "1")
    },
    on: {
      "__c": function($event) {
        _vm.business_agent = "1"
      }
    }
  }), _vm._v(" Agent/Side Hustle Business")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Business Name  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_name),
      expression: "business.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.business.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Business Username "), (_vm.validate_user_name_error) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.validate_user_name_message))]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_user_name),
      expression: "business.business_user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.business.business_user_name)
    },
    on: {
      "change": _vm.validateUserName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Business Category Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_category_type),
      expression: "business_category_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business_category_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Services")])])]), _vm._v(" "), (_vm.business_category_type == 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select a Product Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.business_product_categories), function(category) {
    return _c('option', {
      key: category.category_id,
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.business_category_type == 2) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select a Service Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.business_service_categories), function(category) {
    return _c('option', {
      key: category.category_id,
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('h5', [_vm._v("Market Settings")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Do you sell in any of these markets?")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_market_group),
      expression: "business.business_market_group"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_market_group = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select a Market")]), _vm._v(" "), _vm._l((_vm.market_groups), function(business_market_group) {
    return _c('option', {
      key: business_market_group.id,
      domProps: {
        "value": business_market_group.business_market_group
      }
    }, [_vm._v(_vm._s(business_market_group.business_market_group_name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.setUpNewBusiness
    }
  }, [_vm._v("Create")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
}]}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.set_headers
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container card-box",
    staticStyle: {
      "height": "100vh",
      "padding": "1em 2em"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(!_vm.know_terms) ? _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.card_view.card1) ? _c('div', {
    staticClass: "card-view",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "id": "login"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ff3c00"
    }
  }, [_vm._v("Create your account")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-xs-offset-5",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _c('form', {
    key: _vm.formComponentKey,
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "id": "email",
      "type": "text",
      "title": "Enter Email",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "change": function($event) {
        _vm.validateEmail(_vm.user.email)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "-2.3em",
      "float": "right"
    }
  }, [(_vm.action_checking.email) ? _c('i', {}, [_c('div', {
    staticClass: "loading-xxs"
  })]) : _vm._e(), _vm._v(" "), ((_vm.user.email && _vm.action_verified.email) && (!_vm.error_messages.email)) ? _c('i', {
    staticClass: "fa fa-check"
  }) : _vm._e(), _vm._v(" "), (_vm.error_messages.email) ? _c('i', {
    staticClass: "fa fa-times",
    staticStyle: {
      "color": "#ff0000"
    }
  }) : _vm._e()])])]), _vm._v(" "), (_vm.error_messages.email) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.error_messages.email))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone),
      expression: "user.phone"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "id": "phone",
      "type": "number",
      "name": "Phone",
      "title": "Enter Phone Number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.phone)
    },
    on: {
      "change": function($event) {
        _vm.validatePhone(_vm.user.phone)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "-2.3em",
      "float": "right"
    }
  }, [(_vm.action_checking.phone) ? _c('i', {}, [_c('div', {
    staticClass: "loading-xxs"
  })]) : _vm._e(), _vm._v(" "), ((_vm.user.phone && _vm.action_verified.phone) && (!_vm.error_messages.phone)) ? _c('i', {
    staticClass: " fa fa-check"
  }) : _vm._e(), _vm._v(" "), (_vm.error_messages.phone) ? _c('i', {
    staticClass: " fa fa-times",
    staticStyle: {
      "color": "#ff0000"
    }
  }) : _vm._e()])])]), _vm._v(" "), (_vm.error_messages.phone) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.error_messages.phone))]) : _vm._e(), _vm._v(" "), (_vm.ref_code == '') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Referral Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ref_code),
      expression: "ref_code"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "size": "4",
      "title": "Enter Ref Code",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.ref_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ref_code = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.terms),
      expression: "terms"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.terms) ? _vm._i(_vm.terms, null) > -1 : (_vm.terms)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.terms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.terms = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.terms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.terms = $$c
        }
      }
    }
  }), _vm._v(" I agree to "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff3c00"
    },
    on: {
      "click": function($event) {
        _vm.showTerms(true)
      }
    }
  }, [_vm._v("Terms and Conditions")]), _vm._v(" "), (!_vm.terms) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.error_messages.terms))]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#0400ff",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default wnf-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reg_step_01
    }
  }, [_vm._v("Next")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v("Next >> secure your account")])]) : _vm._e(), _vm._v(" "), (_vm.card_view.card2) ? _c('div', {
    staticClass: "card-view",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "id": "login"
    }
  }, [_c('a', {
    staticStyle: {
      "float": "right",
      "cursor": "pointer",
      "margin-bottom": "10px",
      "color": "#000000"
    },
    on: {
      "click": function($event) {
        _vm.setCardGuide('card1')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  }), _vm._v(" Back")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-xs-offset-5",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _c('form', {
    key: _vm.form2ComponentKey,
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Username")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.username),
      expression: "user.username"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "id": "firstname",
      "type": "text",
      "name": "username",
      "title": "Enter  name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.username)
    },
    on: {
      "change": function($event) {
        _vm.validateUsername(_vm.user.username)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "-2.3em",
      "float": "right"
    }
  }, [(_vm.action_checking.username) ? _c('i', {}, [_c('div', {
    staticClass: "loading-xxs"
  })]) : _vm._e(), _vm._v(" "), ((_vm.user.username && _vm.action_verified.username) && (!_vm.error_messages.username)) ? _c('i', {
    staticClass: " fa fa-check"
  }) : _vm._e(), _vm._v(" "), (_vm.error_messages.username) ? _c('i', {
    staticClass: " fa fa-times",
    staticStyle: {
      "color": "#ff0000"
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.error_messages.username) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.error_messages.username))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "id": "password",
      "type": "password",
      "title": "Enter password",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#0400ff",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default wnf-button",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.reg_step_02
    }
  }, [_vm._v("Continue")])]) : _vm._e(), _vm._v(" "), (!_vm.card_view.card3) ? _c('div', {}, [_c('br'), _c('br'), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.card_view.card3) ? _c('div', {
    staticClass: "card-view",
    staticStyle: {
      "text-align": "center",
      "margin-top": "-4em"
    }
  }, [_vm._m(2), _vm._v(" "), (_vm.group_name != '') ? _c('p', {
    staticClass: "text-muted"
  }, [_c('b', [_vm._v(".. " + _vm._s(_vm.group_name) + " ..")])]) : _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("next")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-onboarding"
  }, [_c('div', {
    staticClass: "row card card-row",
    staticStyle: {
      "display": "none",
      "padding": "0",
      "box-shadow": "0 0 15px 4px rgba(0,0,0,0.06)"
    }
  }, [_c('div', {}, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/buypoint"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9",
    staticStyle: {
      "background-color": "#ffd4cc",
      "padding": "1.2em 0.1em",
      "text-align": "left"
    }
  }, [(_vm.group_is_set) ? _c('p', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Start Shopping "), _c('br'), _vm._v("Check out Stores in tribe")]) : _c('p', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Start Shopping Grow your list "), _c('br'), _vm._v("Check out Stores and Tribes")])])])]), _c('br')]), _vm._v(" "), _vm._m(4)])]) : _vm._e()]) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "float": "right",
      "font-size": "24px",
      "color": "#000000"
    },
    on: {
      "click": function($event) {
        _vm.showTerms(false)
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('h3', [_vm._v("Terms and condition")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "clear": "both",
      "color": "#ff3c00",
      "font-weight": "bold"
    }
  }, [_vm._v("Secure your account with a "), _c('br'), _vm._v(" Username and Password")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff3c00",
      "font-weight": "bolder"
    },
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("Have you set up an account? - Login here")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticStyle: {
      "display": "none",
      "cursor": "pointer",
      "color": "#ff3c00",
      "font-weight": "bolder"
    },
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("Your account have been created, pick any option below to get started")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-3",
    staticStyle: {
      "text-align": "center",
      "padding": "1.2em 5px",
      "background-color": "#ffffff"
    }
  }, [_c('i', {
    staticClass: "wn-icon-lgflt fa fa-users",
    staticStyle: {
      "font-size": "42px",
      "color": "#ee4917"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row card card-row",
    staticStyle: {
      "padding": "0",
      "box-shadow": "0 0 15px 4px rgba(0,0,0,0.06)"
    }
  }, [_c('div', {}, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "color": "#000000",
      "border": "#dbdbdb 1px solid",
      "padding": "1.2em 1.1em",
      "text-align": "left",
      "font-size": "18px",
      "line-height": "1.8"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "1.2em 5px",
      "background-color": "#ffffff"
    }
  }, [_c('i', {
    staticClass: "wn-icon-lgflt fas fa-store-alt",
    staticStyle: {
      "font-size": "42px",
      "color": "#ee4917"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("You have successfully created your account. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('b', [_vm._v("Next_")])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding": "0.5em 1em",
      "margin-bottom": "1em",
      "border-radius": "3px",
      "border": "#e4e4e4 solid 1px"
    }
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Check out Trending posts, products and services.")]), _vm._v(" "), _c('p', {
    staticClass: "sp-app-default-color-cta",
    staticStyle: {
      "text-align": "center",
      "margin-top": "-0.8em",
      "margin-bottom": "-0.4em"
    }
  }, [_vm._v(" >> ")])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding": "0.5em 1em",
      "margin-bottom": "1em",
      "border-radius": "3px",
      "border": "#e4e4e4 solid 1px"
    }
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/account/business/newbusiness"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Create your own shop to sell your products and services.")]), _vm._v(" "), _c('p', {
    staticClass: "sp-app-default-color-cta",
    staticStyle: {
      "text-align": "center",
      "margin-top": "-0.8em",
      "margin-bottom": "-0.4em"
    }
  }, [_vm._v(" >> ")])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding": "0.5em 1em",
      "margin-bottom": "1em",
      "border-radius": "3px",
      "border": "#e4e4e4 solid 1px"
    }
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/myshops"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Search for shops you may know.")]), _vm._v(" "), _c('p', {
    staticClass: "sp-app-default-color-cta",
    staticStyle: {
      "text-align": "center",
      "margin-top": "-0.8em",
      "margin-bottom": "-0.4em"
    }
  }, [_vm._v(" >> ")])])])])])])
}]}

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.product_info) ? _c('div', {
    staticClass: "margin-top-50 pretty-banner"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("Same product but different variations")]), _vm._v(" "), _c('p', [_vm._v("if this product has different colours, sizes, etc... no need filling this long form again, go to this product view and set them.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  }), _c('a', {
    attrs: {
      "href": _vm.product_url
    }
  }, [_vm._v("Proceed to this Product's View ")])])]) : _vm._e(), _vm._v(" "), (!_vm.product_info) ? _c('div', {
    staticClass: "col-sm-10 col-sm-offset-4"
  }, [_c('h6', [_vm._v("Add Product / Service")]), _vm._v(" "), _c('form', [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Product Name\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.sellpoint_categories.length != 0) ? _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" Select Product Category\n                        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    attrs: {
      "id": "category-type-1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-1')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_1
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('option', {
      key: category.business_category_id,
      attrs: {
        "disabled": _vm.category_type_1
      },
      domProps: {
        "value": category.business_category_id
      }
    }, [_vm._v(_vm._s(category.business_category))])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.sellpoint_categories.length != 0) ? _c('li', {
    staticClass: "col-sm-4 col-sm-offset-4"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Select from related Shop Categories\n                        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_sub_category),
      expression: "product.product_sub_category"
    }],
    staticClass: "category-type-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_sub_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-2')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_2
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(category) {
    return _c('option', {
      key: category.sub_category_id,
      attrs: {
        "disabled": _vm.category_type_2
      },
      domProps: {
        "value": category.sub_category_id
      }
    }, [_vm._v(_vm._s(category.sub_category_name))])
  })], 2)])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_c('b', [_vm._v(" *Or ")]), _vm._v(" Enter a specific Category\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_listed_category),
      expression: "product.product_listed_category"
    }],
    attrs: {
      "disabled": _vm.category_type_3,
      "type": "text",
      "placeholder": "",
      "id": "category-type-3"
    },
    domProps: {
      "value": (_vm.product.product_listed_category)
    },
    on: {
      "change": function($event) {
        _vm.trackevent('category-type-3')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_listed_category = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Description\n                            "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Price\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Weight\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Quantity\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Add Product Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("Add")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" *Or ")])])
}]}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_c('div', {
    staticClass: "card card-colord-01 card-colord-pad"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set My Store's Discounts and Coupons")]), _vm._v(" "), _c('p', [_vm._v("Set discounts and coupons that would apply to all products and services in your sellpoint. \n                    ")]), _vm._v(" "), (_vm.no_data) ? _c('p', {
    staticClass: "sp-app-default-color",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("\n                      You have not set any dicount or coupon.\n                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card card-colord-01 card-colord-pad"
  }, [(!_vm.business_details.setDiscount) ? _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'setDiscount')
      }
    }
  }, [_vm._v("Set New Discount Or Coupon")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card card-out-colord-pad",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [(_vm.business_details.setDiscount) ? _c('div', [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(_vm.sellpoint.business_discounts_active == 1) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have an ongoing active Discount")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Set Coupon Or Discount")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.is_discount_coupon),
      expression: "discount_coupon.is_discount_coupon"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.is_discount_coupon = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("Discount")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Coupon")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "display": "none"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon_is_private),
      expression: "discount_coupon_is_private"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.discount_coupon_is_private) ? _vm._i(_vm.discount_coupon_is_private, null) > -1 : (_vm.discount_coupon_is_private)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.discount_coupon_is_private,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.discount_coupon_is_private = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.discount_coupon_is_private = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.discount_coupon_is_private = $$c
        }
      }
    }
  }), _vm._v("\n                              Private Coupon (code must be entered before use)  ?")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "display": "none"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon_is_direct),
      expression: "discount_coupon_is_direct"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.discount_coupon_is_direct) ? _vm._i(_vm.discount_coupon_is_direct, null) > -1 : (_vm.discount_coupon_is_direct)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.discount_coupon_is_direct,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.discount_coupon_is_direct = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.discount_coupon_is_direct = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.discount_coupon_is_direct = $$c
        }
      }
    }
  }), _vm._v("\n                              Direct Discount (for a particular user)  ?")])]), _vm._v(" "), (_vm.discount_coupon_is_direct) ? _c('div', {
    staticClass: "form-group wn-i-input-container"
  }, [_c('label', [_vm._v("Enter username ")]), _c('br'), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_username),
      expression: "discount_coupon.discount_username"
    }],
    staticClass: "form-control wn-i-input-field",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_username)
    },
    on: {
      "change": function($event) {
        _vm.validateUsername(_vm.discount_coupon.discount_username)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_username = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.action_verified.username) ? _c('i', {
    staticClass: "icon wn-i-input-icon fa fa-check"
  }) : _c('i', {
    staticClass: "icon wn-i-input-icon fa fa-times",
    staticStyle: {
      "color": "#ff0000"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "display": "none"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon_is_gift_card),
      expression: "discount_coupon_is_gift_card"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.discount_coupon_is_gift_card) ? _vm._i(_vm.discount_coupon_is_gift_card, null) > -1 : (_vm.discount_coupon_is_gift_card)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.discount_coupon_is_gift_card,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.discount_coupon_is_gift_card = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.discount_coupon_is_gift_card = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.discount_coupon_is_gift_card = $$c
        }
      }
    }
  }), _vm._v("\n                              Do you want to set this as a gift card ?")])]), _vm._v(" "), (_vm.discount_coupon_is_gift_card) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_min_amount),
      expression: "discount_coupon.discount_min_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_min_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_min_amount = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label'), _vm._v(" "), (_vm.sellpoint.business_discounts_active != 1) ? _c('label', [_vm._v("Select Discount Category")]) : _c('label', [_vm._v("Select Coupon Discount Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_category),
      expression: "discount_coupon.discount_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.discount_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('option', {
      key: cat.business_category_id,
      domProps: {
        "value": cat.business_category_id
      }
    }, [_vm._v(_vm._s(cat.business_category_name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Minimum Quantity")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_min_quantity),
      expression: "discount_coupon.discount_min_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_min_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_min_quantity = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.discount_coupon_is_gift_card) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_description),
      expression: "discount_coupon.discount_description"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "250px"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_description = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setDiscountsAndCoupons()
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.discount_coupon.edit && (!_vm.business_details.viewDiscounts || !_vm.business_details.setDiscount)) ? _c('div', [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Edit Discount")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_category),
      expression: "discount_coupon.discount_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.discount_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Another Category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('option', {
      key: cat.business_category_id,
      domProps: {
        "value": cat.business_category_id
      }
    }, [_vm._v(_vm._s(cat.business_category))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Minimum Quantity")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_min_quantity),
      expression: "discount_coupon.discount_min_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_min_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_min_quantity = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date1: " + _vm._s(_vm.discount_coupon.discount_start_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date: " + _vm._s(_vm.discount_coupon.discount_end_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editDiscountsAndCoupons()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), ((!_vm.business_details.setDiscount && !_vm.discount_coupon.edit) && _vm.sellpoint.business_discounts_coupons) ? _c('div', [(_vm.sellpoint.business_discounts_coupons && (_vm.sellpoint.business_discounts_coupons.length != 0)) ? _c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("View Discounts")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.sellpoint.business_discounts_coupons), function(dc, index) {
    return _c('div', {
      key: dc.discount_id,
      staticClass: "card card-flat-pad",
      staticStyle: {
        "border": "#f7f7f7 solid !important"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "80%"
      }
    }, [_c('div', [_c('p', [_vm._v(_vm._s(dc.discount_percentage) + "% Off")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('div', [(_vm.menu_tab_inner_view['DCM' + index]) ? _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('')
        }
      }
    }, [_c('div', {}, [(dc.discount_status != '') ? _c('span', {
      staticClass: "card-link sp-app-default-color",
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "none"
      }
    }, [_vm._v(_vm._s(dc.discount_status))]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fa fa-angle-down"
    })])]) : _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('DCM' + index)
        }
      }
    }, [_c('div', {}, [(dc.discount_status != '') ? _c('span', {
      staticClass: "sp-app-default-color",
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "none"
      }
    }, [_vm._v(_vm._s(dc.discount_status))]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fa fa-angle-down"
    })])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (_vm.menu_tab_inner_view['DCM' + index]) ? _c('div', [_c('div', {}, [_c('div', {
      staticStyle: {
        "border": "#f1dee4 solid 1px",
        "padding": "1em"
      }
    }, [_c('div', {
      staticStyle: {
        "background": "#d1ddf1",
        "text-align": "center"
      }
    }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('p', [_c('b', [_vm._v("Type: ")]), _vm._v(_vm._s(dc.discount_type_name))]) : _c('p', [_c('b', [_vm._v("Type: ")]), _vm._v(_vm._s(dc.discount_category_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Minimum Quantity: ")]), _vm._v(_vm._s(dc.discount_min_quantity))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Added On: ")]), _vm._v(_vm._s(dc.discount_reg_date))]), _vm._v(" "), ((dc.discount_type == 2) || (dc.discount_type == 3)) ? _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-discount-coupon', dc)
        }
      }
    }, [_vm._v("\n                                      Edit")]), _vm._v("     "), (_vm.action_loading) ? _c('i', {
      staticClass: "fa fa-circle-o-notch fa-spin 1x"
    }) : _vm._e(), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.deactivateDiscountsAndCoupons(dc)
        }
      }
    }, [_vm._v("\n                                      Deactivate")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Edit/Deactivate at Product Settings")]) : _vm._e()])])]) : _vm._e()])
  }))]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Minimum Amount for Gift Card "), _c('span', {
    staticClass: "sp-app-default-color"
  }, [_c('b', [_vm._v("NGN")]), _vm._v("5,000")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Add a Description "), _c('span', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("Optional except, if this is a gift card")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticStyle: {
      "color": "#363535",
      "font-size": "14px"
    }
  }, [_vm._v("Note that you can only set one Sellpoint Discount at a time.\n                              If you want to end an existing discount click on \"Stop Discount\" button near the\n                              button.\n                          ")])])
}]}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "0em",
      "background": "#ffffff"
    },
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "section"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container is-wide"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _vm._e()]) : _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding": "0.2em",
      "background-color": "#ffffff"
    }
  }, [_c('div', {
    staticClass: "header-wrap-inner",
    staticStyle: {
      "background-color": "#ffffff",
      "margin": "0",
      "padding": "0.5em",
      "padding-left": "1em",
      "border": "none"
    }
  }, [_c('li', {
    staticClass: "header-left-2"
  }, [_c('a', {
    staticClass: "header-nav-back card-link",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "color": "#000000",
      "font-size": "16px"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Back to Catalog")])])]), _vm._v(" "), _c('li', {
    staticClass: "header-right-2"
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "font-size": "14px",
      "color": "#000000",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.toggleSection('shareBox')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt",
    staticStyle: {
      "color": "#000000",
      "font-size": "12px"
    }
  }), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" Share")])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card pb_img_box"
  }, [_c('div', {
    staticClass: "category-slide"
  }, [_c('ul', _vm._l((_vm.product.product_images), function(img) {
    return _c('li', {}, [(img.product_image && (img.product_image != '' && img.product_image != 'error')) ? _c('img', {
      staticClass: "pb_img",
      attrs: {
        "src": _vm.img_product_url + img.product_image,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "pb_img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.product.product_images && (_vm.product.product_images.length > 1)) ? _c('div', [_c('hr'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-transform": "uppercase"
    }
  }, [_vm._v("Swipe >>")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.product.product_images && (_vm.product.product_images.length > 1)) ? _c('div', {
    staticClass: "img-row",
    staticStyle: {
      "display": "none",
      "margin-top": "0em"
    }
  }, _vm._l((_vm.product.product_images), function(img) {
    return _c('div', {
      staticClass: "img-column"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-display-image', img)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + img.product_image,
        "alt": ""
      }
    })])])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both !important"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row prd-info",
    staticStyle: {
      "margin": "1em",
      "margin-top": "0.2em",
      "clear": "both"
    }
  }, [_c('div', {
    staticClass: "card-row"
  }, [_c('h1', [_vm._v("₦" + _vm._s(_vm.product_item.product_item_price_f))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card-row",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('h4', {
    staticClass: "t-intro"
  }, [_vm._v("Order Add-ons")]), _vm._v(" "), _c('p', [_vm._v("Items you should buy together with this order")]), _vm._v(" "), _c('div', {
    staticClass: "card o-addons"
  }, [_c('div', {
    staticClass: "category-slide"
  }, [_c('ul', _vm._l((_vm.product.product_addons), function(prd) {
    return _c('li', {}, [(prd.product_images[0] && (prd.product_images[0] != '' && prd.product_images[0] != 'error')) ? _c('img', {
      staticClass: "oad-img",
      attrs: {
        "src": _vm.img_product_url + prd.product_images[0].product_image,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "oad-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(prd.product_name))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("₦" + _vm._s(prd.product_items[0].product_item_price_f))])])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.product.product_images && (_vm.product.product_images.length > 1)) ? _c('div', [_c('hr'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-transform": "uppercase"
    }
  }, [_vm._v("Swipe >>")])]) : _vm._e()])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card-row",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('h4', {
    staticClass: "t-intro"
  }, [_vm._v("Details")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.product_description))])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "1em",
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.product.product_addons && (_vm.product.product_addons.length != 0)) ? _c('div', [_c('h5', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("Select additional items")]), _vm._v(" "), _vm._l((_vm.product.product_addons), function(product, index) {
    return _c('div', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.setProductAddOn(product);
          _vm.openModal('activeProductAddonModal')
        }
      }
    }, [_c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-square"
    }, [(product.product_images[0]) ? _c('img', {
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', [_c('p', {
      staticStyle: {
        "font-size": "10px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e()])])])])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1em",
      "padding-bottom": "0.2em",
      "border-bottom": "#f3f2f2 solid"
    }
  }, [_c('a', {
    staticClass: "col-xs-4 sp-app-default-color card-link",
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "font-size": "18px"
    },
    on: {
      "click": function($event) {
        _vm.setTabComponent('descr')
      }
    }
  }, [(_vm.tab_view.descr) ? _c('div', {
    staticStyle: {
      "border-bottom": "#f33e5c solid 3px"
    }
  }, [_vm._v("Details")]) : _c('div', [_vm._v("Details")])]), _vm._v(" "), _c('a', {
    staticClass: "col-xs-4 sp-app-default-color card-link",
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "font-size": "18px"
    },
    on: {
      "click": function($event) {
        _vm.setTabComponent('info')
      }
    }
  }, [(_vm.tab_view.info) ? _c('div', {
    staticStyle: {
      "border-bottom": "#f33e5c solid 3px"
    }
  }, [_vm._v("Shipping")]) : _c('div', [_vm._v("Shipping")])]), _vm._v(" "), _c('a', {
    staticClass: "col-xs-4 sp-app-default-color card-link",
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "font-size": "18px",
      "text-decoration": "none",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.setTabComponent('reviews')
      }
    }
  }, [(_vm.tab_view.reviews) ? _c('div', {
    staticStyle: {
      "border-bottom": "#f33e5c solid 3px"
    }
  }, [_vm._v("Reviews "), (_vm.product.product_reviews && (Object.keys(_vm.product.product_reviews).length > 0)) ? _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("(" + _vm._s(Object.keys(_vm.product.product_reviews).length) + ")")]) : _vm._e()]) : _c('div', [_vm._v("Reviews "), (_vm.product.product_reviews && (Object.keys(_vm.product.product_reviews).length > 0)) ? _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("(" + _vm._s(Object.keys(_vm.product.product_reviews).length) + ")")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "2em 1em"
    }
  }, [(_vm.tab_view.descr) ? _c('div', [_c('div', {
    staticClass: "w-richtext"
  }, [_c('p', {
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_vm._v(_vm._s(_vm.product.product_description) + " ")])])]) : _vm._e(), _vm._v(" "), (_vm.tab_view.info) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "info-blocks"
  }, [(_vm.product.product_business_delivery_options.length > 0) ? _c('div', {
    staticClass: "info-block col-md-12 col-xs-12 card-colord-pad card-colord-01",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-right-2 col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "prd-delivery-list"
  }, _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return (delivery.business_delivery_business != 1) ? _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦\r\n                                  "), (delivery.business_products_delivery_fees.length > 0) ? _c('span', _vm._l((delivery.business_products_delivery_fees), function(fee, fdex) {
      return _c('span', [((fee.product_delivery_product == _vm.product.product_id)) ? _c('span', [_vm._v(_vm._s(fee.product_delivery_fee) + "\r\n                                      ")]) : _vm._e()])
    })) : _c('span', [_vm._v("\r\n                                    " + _vm._s(delivery.business_delivery_option_price) + "\r\n                                  ")])]) : _vm._e()
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.tab_view.reviews) ? _c('div', [_c('br'), _vm._v(" "), (_vm.product.product_reviews && Object.keys(_vm.product.product_reviews).length == 0) ? _c('p', {
    staticStyle: {
      "color": "#129efc"
    }
  }, [_vm._v("\r\n                        No reviews yet.\r\n                      ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.product.product_reviews), function(review, rdex) {
    return _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-circle"
    }, [(review.product_reviewed_by_image && (review.product_reviewed_by_image != '')) ? _c('img', {
      attrs: {
        "src": review.product_reviewed_by_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right",
      staticStyle: {
        "padding-left": "6px"
      }
    }, [_c('div', {}, [_c('p', [_vm._v(_vm._s(review.product_review) + "\r\n                              ")]), _c('div', {
      staticStyle: {
        "color": "#ffd900"
      }
    }, [_vm._l((parseInt(review.product_rate)), function(index) {
      return _c('span', {
        staticClass: "fa is-filled"
      }, [_vm._v("")])
    }), _vm._l(((5 - parseInt(review.product_rate))), function(index) {
      return _c('span', {
        staticClass: "fa is-filled"
      }, [_vm._v("")])
    })], 2), _vm._v("\r\n                              " + _vm._s(review.product_reviewed_by)), _c('br'), _vm._v("\r\n                              " + _vm._s(review.product_review_date) + "\r\n                            "), _c('p')])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })], 2) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section",
    staticStyle: {
      "margin-bottom": "5em"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "3em"
    }
  }, _vm._l((_vm.related_products), function(product, index) {
    return _c('div', {
      staticClass: "card card-row card-col-2 col-xs-12",
      staticStyle: {
        "text-align": "left",
        "background": "#ffffff",
        "border-radius": "0px",
        "margin-bottom": "0.6em"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + product.product_business_username + '/' + product.product_url_name
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "45%"
      }
    }, [_c('div', {
      staticClass: "card-col-img"
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "width": "55%",
        "padding-top": "0.1em"
      }
    }, [_c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block",
        "padding": "3px",
        "padding-left": "2em"
      }
    }, [_c('p', [_vm._m(2, true), _vm._v(" "), _c('span', {
      staticClass: "prd-name"
    }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('p', [_vm._m(3, true), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticClass: "p-info"
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._m(4, true), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticClass: "p-info"
    }, [_vm._v("YES")]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._m(5, true), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticClass: "p-info"
    }, [_vm._v("6")]) : _vm._e()]), _vm._v(" "), _vm._m(6, true)])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  }))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "section",
    staticStyle: {
      "margin-bottom": "10em"
    }
  }, [_vm._v("   ")]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "z-index": "2"
    },
    attrs: {
      "id": "sumBrief"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "bottom": "0",
      "margin": "0 -1.2em",
      "background": "none",
      "z-index": "1"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "block",
      "width": "100%",
      "height": "auto",
      "padding": "0.1em",
      "background-color": "rgba(0, 0, 0, 0)",
      "color": "#ffffff",
      "border-top": "none",
      "border-radius": "45px 45px 0px 0px"
    },
    attrs: {
      "id": "sumBrief2"
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "background-color": "none",
      "height": "3em",
      "float": "right"
    }
  }, [_c('a', {
    staticClass: "cta-btn class",
    staticStyle: {
      "background-color": "#000000",
      "color": "#ffffff",
      "padding": "15px 14px",
      "height": "3em",
      "border-radius": "4px"
    },
    attrs: {
      "href": '/make/order/' + _vm.product.product_url_name
    }
  }, [_vm._v("Make Order")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000"
    },
    attrs: {
      "id": "shareBox"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": _vm.showCartOptions
    }
  }, [_c('span', {
    staticClass: "s-backdrop"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "bottom": "0",
      "margin": "0 -1.2em",
      "background": "none",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "0.1em",
      "background": "#ffffff",
      "color": "#000000",
      "border-top": "#061433 solid",
      "border-radius": "45px 45px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.toggleSection('shareBox')
      }
    }
  }, [_vm._m(7), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _vm._m(8)])])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000"
    },
    attrs: {
      "id": "shareBox"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": _vm.showCartOptions
    }
  }, [_c('span', {
    staticClass: "s-backdrop"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "bottom": "0",
      "margin": "0 -1.2em",
      "background": "none",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "0.1em",
      "background": "#ffffff",
      "color": "#000000",
      "border-top": "#061433 solid",
      "border-radius": "45px 45px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.toggleSection('shareBox')
      }
    }
  }, [_vm._m(9), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _vm._m(10)])])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000"
    },
    attrs: {
      "id": "activeProductAddonModal"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": _vm.showCartOptions
    }
  }, [_c('span', {
    staticClass: "s-backdrop"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "bottom": "0",
      "margin": "0 -1.2em",
      "background": "none",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "0.1em",
      "background": "#ffffff",
      "color": "#000000",
      "border-top": "#061433 solid",
      "border-radius": "45px 45px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.toggleSection('activeProductAddonModal')
      }
    }
  }, [_vm._m(11), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    key: _vm.setproductAddonKey,
    staticClass: "card"
  }, [_c('div', {
    staticClass: "sp-prd-attr-block",
    staticStyle: {
      "width": "100%",
      "margin-top": "2em"
    }
  }, [_c('div', {
    staticClass: "card pb_img_box",
    staticStyle: {
      "z-index": "1",
      "padding": "0"
    }
  }, [((_vm.product_addon.product_images && _vm.product_addon.product_images[0].product_image != 'error')) ? _c('img', {
    staticStyle: {
      "max-height": "150px"
    },
    attrs: {
      "src": _vm.img_product_url + _vm.product_addon.product_images[0].product_image,
      "alt": ""
    }
  }) : _c('img', {
    staticStyle: {
      "max-height": "150px"
    },
    attrs: {
      "src": "/static/assets/images/dummy-image.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h5', {
    staticStyle: {
      "color": "#ff5566"
    }
  }, [_vm._v(_vm._s(_vm.product_addon.product_name))]), _vm._v(" "), (_vm.product_addon.product_can_set_custom_price == 1) ? _c('table', {
    staticClass: "tb-cols",
    staticStyle: {
      "width": "100%",
      "margin": "0"
    }
  }, [_c('tr', [_vm._m(12), _vm._v(" "), _c('td', {
    staticClass: "td-col-8"
  }, [_c('div', {
    staticClass: "info-right form-group",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.product_addon_item.product_item_price))]), _vm._v(" "), (_vm.product_addon_item.product_item_actual_price != 0) ? _c('p', {
    staticClass: "attr-intro-desc prd-price prd-discounted-price"
  }, [_c('del', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_addon_item.product_item_actual_price_f))])]) : _c('p', {
    staticClass: "attr-intro-desc prd-price"
  }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_addon_item.product_item_price_f))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_addon_item.product_item_order_custom_set_price),
      expression: "product_addon_item.product_item_order_custom_set_price"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100px !important"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product_addon_item.product_item_order_custom_set_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_addon_item.product_item_order_custom_set_price = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setProductCustomPrice
    }
  }, [_vm._v("OK")])])])])]) : _c('table', {
    staticClass: "tb-cols",
    staticStyle: {
      "width": "100%",
      "margin": "0"
    }
  }, [_c('tr', [_vm._m(13), _vm._v(" "), _c('td', {
    staticClass: "td-col-8"
  }, [_c('div', {
    staticClass: "info-right",
    staticStyle: {
      "padding": "5px"
    }
  }, [(_vm.product_addon_item.product_item_actual_price != 0) ? _c('p', {
    staticClass: "attr-intro-desc prd-price prd-discounted-price"
  }, [_c('del', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_addon_item.product_item_actual_price_f))])]) : _c('p', {
    staticClass: "attr-intro-desc prd-price"
  }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_addon_item.product_item_price_f))])])])]), _vm._v(" "), (_vm.product_addon_item.product_item_actual_price != 0) ? _c('tr', [_vm._m(14), _vm._v(" "), _c('td', {
    staticClass: "td-col-8"
  }, [_c('div', {
    staticClass: "info-right col-xs-8",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('p', {
    staticClass: "attr-intro-desc prd-discount-price"
  }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_addon_item.product_item_price_f))])])])]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "tb-cols",
    staticStyle: {
      "width": "100%",
      "margin": "0"
    }
  }, [(((_vm.product_addon.product_set_groups != 0))) ? _c('tr', [_c('td', {
    staticClass: "td-col-2"
  }, [(((_vm.product_addon.product_set_groups != 0))) ? _c('div', {
    staticClass: "info-left"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Select: ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "td-col-8"
  }, [_c('div', {
    staticClass: "info-right"
  }, [_c('table', [_c('tr', _vm._l((_vm.product_addon.product_item_groups), function(pg) {
    return _c('td', {
      staticStyle: {
        "padding-right": "2px"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item-group', pg)
        }
      }
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('span', {
      staticClass: "product-item-group box-cube",
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    }, [((pg.product_item_group_image && (pg.product_item_group_image != 'error'))) ? _c('img', {
      staticStyle: {
        "width": "45px",
        "height": "45px"
      },
      attrs: {
        "src": pg.product_item_group_image
      }
    }) : _c('img', {
      staticStyle: {
        "width": "45px",
        "height": "45px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    }), _c('br')]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('span', {}, [_c('span', {
      staticClass: "product-item-group box-color-cube",
      style: ({
        background: pg.product_item_group_color
      }),
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.product.product_item_groups.length > 1) ? _c('span', {
      staticStyle: {
        "font-size": "12px",
        "font-weight": "500"
      }
    }, [_vm._v(_vm._s(pg.product_item_group_name))]) : _vm._e()])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.data_cart_group_message) ? _c('p', {
    staticClass: "p-tiny-info",
    staticStyle: {
      "margin-top": "-1em",
      "padding-top": "1em",
      "float": "left",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_cart_group_message))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (((_vm.product_addon_item_group.product_items) && (_vm.product_addon_item_group.product_items.length != 0))) ? _c('tr', {
    staticStyle: {
      "clear": "both"
    }
  }) : _vm._e(), (((_vm.product_addon.product_set_items != 0) && (_vm.product_addon.product_set_items_params_check != 0))) ? _c('tr', [_vm._m(15), _vm._v(" "), _c('td', {
    staticClass: "td-col-8"
  }, [_c('div', {
    staticClass: "info-right"
  }, [_c('ul', {
    staticClass: "prd-color-block",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, _vm._l((_vm.product_addon_item_group.product_items), function(pt) {
    return _c('li', {
      staticClass: "items-list-tiny listnone"
    }, [_c('span', {
      staticClass: "product-item listnone",
      attrs: {
        "id": pt.product_item_id + 'PRT'
      }
    }, [(_vm.product.product_service == 'P') ? _c('a', {
      staticClass: "box-wrap",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_vm._v(_vm._s(pt.product_item_size))]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "product-item listnone",
      attrs: {
        "id": pt.product_item_id + 'PRT'
      }
    }, [(_vm.product.product_service == 'S') ? _c('a', {
      staticClass: "box-wrap",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_vm._v(_vm._s(pt.product_item_service_tag))]) : _vm._e()])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.data_cart_item_message) ? _c('p', {
    staticClass: "p-tiny-info",
    staticStyle: {
      "margin-top": "-0.1em",
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.data_cart_item_message))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('tr', [_vm._m(16), _vm._v(" "), _c('td', {
    staticClass: "td-col-8"
  }, [_c('div', {
    staticClass: "info-right",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('p', {
    staticClass: "attr-intro-desc"
  }, [_vm._v(_vm._s(_vm.product_addon_item.product_item_weight) + " (Kg)")])])])]), _vm._v(" "), (_vm.is_product_in_cart) ? _c('tr', {
    staticStyle: {
      "border": "dotted 1px #96c5f5",
      "padding": "5px 2px"
    }
  }, [_c('td', {
    staticClass: "td-col-10"
  }, [_c('p', [_vm._v("This Item is in your cart \r\n                          "), _c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "width": "12em",
      "cursor": "pointer",
      "line-height": "1.8"
    },
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View Cart")])])])]) : _c('tr', [_vm._m(17), _vm._v(" "), _c('td', {
    staticClass: "td-col-8"
  }, [_c('div', {
    staticClass: "info-right",
    staticStyle: {
      "margin": "-1em 5px"
    }
  }, [_c('div', {}, [_c('a', {
    staticClass: "col-xs-2 qty-btn qty-btn-sm",
    staticStyle: {
      "cursor": "pointer",
      "text-decoration": "none",
      "padding": "0"
    },
    on: {
      "click": function($event) {
        _vm.removeQuantity(_vm.product_addon_item.product_item_order_quantity)
      }
    }
  }, [_vm._v("–")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_addon_item.product_item_order_quantity),
      expression: "product_addon_item.product_item_order_quantity"
    }],
    key: _vm.product_item_quantity_key,
    staticClass: "col-xs-4 qty-input qty-input-sm",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product_addon_item.product_item_order_quantity)
    },
    on: {
      "change": function($event) {
        _vm.checkOrderQuantity(_vm.product_addon_item.product_item_order_quantity)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_addon_item.product_item_order_quantity = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "col-xs-2 qty-btn qty-btn-sm",
    staticStyle: {
      "cursor": "pointer",
      "text-decoration": "none",
      "padding": "0"
    },
    on: {
      "click": function($event) {
        _vm.addQuantity(_vm.product_addon_item.product_item_order_quantity)
      }
    }
  }, [_vm._v("+")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.check_order_quantity))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [((_vm.product_addon.selected)) ? _c('p', {
    staticClass: "sp-app-default-color",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Selected")]) : _c('button', {
    staticClass: "btn sp-button-sm",
    staticStyle: {
      "background": "#fc4112 !important",
      "color": "#ffffff !important"
    },
    attrs: {
      "id": "myBtn",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setSelectedProductAddOns(_vm.product_addon)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add to Purchase")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h6', [_vm._v("SHIPPING DETAILS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "sp-app-default-color",
    staticStyle: {
      "font-size": "18px",
      "text-transform": "capitalize"
    }
  }, [_vm._v("Also check these")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "p-title"
  }, [_c('b', [_vm._v("Name: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "p-title"
  }, [_c('b', [_vm._v("Price: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "p-title"
  }, [_c('b', [_vm._v("In Stock: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "p-title"
  }, [_c('b', [_vm._v("Available Type: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-arm-alt-bottom",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "card-analytics"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-tag"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "0 1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left"
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-right"
  }, [_c('span', [_vm._v("Whatsapp")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left"
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "sms:?body=hello world"
    }
  }, [_vm._v("Send SMS")])]), _vm._v(" "), _c('div', {
    staticClass: "card-right"
  }, [_c('span', [_vm._v("Whatsapp")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "0 1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left"
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-right"
  }, [_c('span', [_vm._v("Whatsapp")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left"
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "sms:?body=hello world"
    }
  }, [_vm._v("Send SMS")])]), _vm._v(" "), _c('div', {
    staticClass: "card-right"
  }, [_c('span', [_vm._v("Whatsapp")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "td-col-2"
  }, [_c('div', {
    staticClass: "info-left"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Price: ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "td-col-2"
  }, [_c('div', {
    staticClass: "info-left"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Price: ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "td-col-2"
  }, [_c('div', {
    staticClass: "info-left"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Discount Price: ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "td-col-2"
  }, [_c('div', {
    staticClass: "info-left"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Select: ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "td-col-2"
  }, [_c('div', {
    staticClass: "info-left"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Weight: ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "td-col-2"
  }, [_c('div', {
    staticClass: "info-left"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Quantity:  ")])])])
}]}

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('component-menu-bottom')], 1)
},staticRenderFns: []}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager"
  }, [(_vm.show_all) ? _c('div', {
    staticClass: "section",
    staticStyle: {
      "margin": "0 1em"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "orders-panel",
    staticStyle: {
      "margin": "0 1em"
    }
  }, _vm._l((_vm.orders), function(order) {
    return _c('div', {
      on: {
        "click": function($event) {
          _vm.setOrder(order)
        }
      }
    }, [_c('div', {
      staticClass: "card card-flat-pad",
      staticStyle: {
        "background": "#ffffff",
        "border-radius": "15px"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('div', [_c('span', {
      staticStyle: {
        "color": "#df4d4d",
        "font-size": "10px"
      }
    }, [_c('u', [_c('b', [_vm._v(_vm._s(order.order_no))])])]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(order.order_date))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [((order.order_business_agent_type && (order.order_business_agent_type == 20))) ? _c('span', {
      staticStyle: {
        "color": "inherit",
        "font-weight": "bolder"
      }
    }, [_vm._v(_vm._s(order.order_business_agent_name))]) : _c('span', {
      staticStyle: {
        "color": "inherit",
        "font-weight": "bolder"
      }
    }, [_vm._v(_vm._s(order.order_business))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "0.45em"
      }
    }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.formatCurrency_2(order.order_total))), _c('br'), _vm._v(" ")]), _vm._v(" "), (order.order_payment_status_id == 7) ? _c('div', [_c('span', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("*Not Paid")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [((order.order_items.length > 0) && Object.keys(order.order_items[0]).length > 0) ? _c('div', {
      staticStyle: {
        "display": "inline"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + order.order_items[0].product_item_group_image,
        "height": "50",
        "width": "50"
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(order.order_items.length) + " item(s)")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "0.65em"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-backdrop": "false",
        "data-target": "#ordersModal"
      },
      on: {
        "click": function($event) {
          _vm.setOrder(order)
        }
      }
    }, [_c('span', {
      staticClass: "p-tiny"
    }, [_vm._v("View >>")])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.show_single) ? _c('div', {
    staticClass: "section",
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('div', {
    staticClass: "container"
  }), _vm._v(" "), (!_vm.show_products_for_review) ? _c('div', [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "background-color": "#ffffff"
    }
  }, [_c('div', {
    staticClass: "col lg-12"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "28px",
      "font-weight": "bolder"
    },
    on: {
      "click": _vm.viewOrders
    }
  }, [_vm._v("X")])])]), _vm._v(" "), _c('div', {
    staticClass: "col lg-12"
  }, [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.is_new) ? _c('h3', {
    staticClass: "text-align-left margin-bottom-double"
  }, [_vm._v("Thank you. Your order has been received.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flexh-justify-left sm-flexv"
  }, [_c('div', [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("Order number:")]), _vm._v(" " + _vm._s(_vm.order.order_no))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("Date:")]), _vm._v(" " + _vm._s(_vm.order.order_date))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("From:")]), _vm._v(" "), _c('span', [((_vm.order.order_business_agent_type && (_vm.order.order_business_agent_type == 20))) ? _c('a', {
    staticStyle: {
      "color": "inherit",
      "font-weight": "bolder",
      "text-decoration": "underline"
    },
    attrs: {
      "href": '/' + _vm.order.order_business_agent_username
    }
  }, [_vm._v(_vm._s(_vm.order.order_business_agent_name))]) : _c('a', {
    staticStyle: {
      "color": "inherit",
      "font-weight": "bolder",
      "text-decoration": "underline"
    },
    attrs: {
      "href": '/' + _vm.order.order_business_username
    }
  }, [_vm._v(_vm._s(_vm.order.order_business))])])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("Payment method: ")]), _vm._v(_vm._s(_vm.order.order_payment_mode_name))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("Status:")]), _vm._v(" "), _c('span', {
    style: ({
      color: _vm.order.order_payment_status_color
    })
  }, [_vm._v(_vm._s(_vm.order.order_payment_status))])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.order.order_payment_status_id == 7) ? _c('div', [_c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "href": '/checkout/re/' + _vm.order.order_no
    }
  }, [_vm._v("Make Payment")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flexh-justify-left sm-flexv",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("Order Amount:")]), _vm._v(" ₦" + _vm._s(_vm.order.order_items_total))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("Shipping:")]), _vm._v(" ₦" + _vm._s(_vm.order.order_shipping_total))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("Total:")]), _vm._v(" ₦" + _vm._s(_vm.order.order_total))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flexh-justify-center sm-flexv",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("Delivery Location:")]), _vm._v(" " + _vm._s(_vm.order.order_delivery_city))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("Address:")]), _vm._v(" " + _vm._s(_vm.order.order_user_delivery_address))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "flexh-justify-center sm-flexv",
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "1em"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.show_brokers = true
      }
    }
  }, [_vm._v("Broker this Deal?")]), _vm._v(" "), (_vm.show_brokers) ? _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit",
      "text-decoration": "none",
      "font-size": "18px",
      "margin-left": "2em"
    },
    on: {
      "click": function($event) {
        _vm.show_brokers = false;
        _vm.data_processing_message = '';
      }
    }
  }, [_vm._v("X")]) : _vm._e(), _vm._v(" "), (_vm.show_brokers && !(Object.keys(_vm.brokers).length === 0)) ? _c('div', {
    staticClass: "row card"
  }, _vm._l((_vm.brokers), function(broker) {
    return _c('div', {
      staticClass: "card",
      staticStyle: {
        "padding": "1em",
        "margin": "1em",
        "border": "1px solid #1d1d1d"
      }
    }, [_c('div', {
      staticClass: "col-xs-2",
      staticStyle: {
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle card-avatar-circle-sm"
    }, [(broker.broker_profile_image && (broker.broker_profile_image != '')) ? _c('img', {
      attrs: {
        "src": broker.broker_profile_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10"
    }, [_c('p', [_vm._v(_vm._s(broker.broker_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Starting Fee: ")]), _vm._v("₦" + _vm._s(broker.broker_starting_fee))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "sp-app-default-color"
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "sp-button-1 sp-button-sm",
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          _vm.sendMessageToBroker(broker)
        }
      }
    }, [_vm._v("Request Service")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })) : _vm._e()]), _vm._v(" "), (_vm.order.order_notifications && (_vm.order.order_notifications > 0)) ? _c('div', {
    staticClass: "flexh-justify-center sm-flexv",
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "1em"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.show_order_notifications = true
      }
    }
  }, [_vm._v("Order Notifications"), _c('span', {
    staticStyle: {
      "margin-left": "3px",
      "float": "right"
    }
  }, [_c('sup', [_c('span', {
    staticClass: "notify-alert"
  }, [_vm._v(_vm._s(_vm.order.order_notifications))])])])]), _vm._v(" "), (_vm.show_order_notifications) ? _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit",
      "text-decoration": "none",
      "font-size": "18px",
      "margin-left": "2em"
    },
    on: {
      "click": function($event) {
        _vm.show_order_notifications = false;
        _vm.data_processing_message = '';
      }
    }
  }, [_vm._v("X")]) : _vm._e(), _vm._v(" "), (_vm.show_order_notifications) ? _c('div', {
    staticClass: "row card"
  }, [(Object.keys(_vm.order.order_broker_requests).length !== 0) ? _c('div', [_c('h5', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Brokers Requests")]), _vm._v(" "), _vm._l((_vm.order.order_broker_requests), function(broker_rq) {
    return _c('div', {
      staticClass: "card",
      staticStyle: {
        "padding": "1em",
        "margin": "1em",
        "border": "1px solid #1d1d1d"
      }
    }, [_c('div', {
      staticClass: "col-xs-2",
      staticStyle: {
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle card-avatar-circle-sm"
    }, [(broker_rq.broker_profile_image && (broker_rq.broker_profile_image != '')) ? _c('img', {
      attrs: {
        "src": broker_rq.broker_profile_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10"
    }, [_c('p', [_vm._v(_vm._s(broker_rq.broker_request_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Broker Fee: ")]), _vm._v("₦" + _vm._s(broker_rq.broker_request_fee))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "sp-app-default-color"
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "sp-button-1 sp-button-sm",
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          _vm.show_payment_service = true;
          _vm.broker_request = broker_rq;
          _vm.setBrokerOrderPaymentData();
        }
      }
    }, [_vm._v("PAY")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(_vm._s(_vm.show_empty_fields) + "\r\n                          "), (_vm.show_payment_service && (_vm.broker_request.broker_request_ref == broker_rq.broker_request_ref)) ? _c('div', {
      staticClass: "card col-xs-12"
    }, [(_vm.show_empty_fields && (_vm.broker_request.broker_request_ref == broker_rq.broker_request_ref)) ? _c('div', [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Please provide these details")]), _vm._v(" "), _c('form', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.user.user_email),
        expression: "user.user_email"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Email"
      },
      domProps: {
        "value": (_vm.user.user_email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.user.user_email = $event.target.value
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.user.user_phone),
        expression: "user.user_phone"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "placeholder": "Phone Number"
      },
      domProps: {
        "value": (_vm.user.user_phone)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.user.user_phone = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "sp-button-1 sp-button-sm",
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setBrokerOrderPaymentData();
        }
      }
    }, [_vm._v("SET")])])]) : _c('div', [_c('component-payment-service', {
      attrs: {
        "paymentdata": _vm.broker_request_payment_data
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })], 2) : _vm._e()]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "background": "#ffffff"
    }
  }, [_c('div', {
    staticClass: "col lg-12 position-relative",
    staticStyle: {
      "margin-bottom": "5em",
      "margin-top": "2em"
    }
  }, [_c('div', {
    staticClass: "c-shop-order__wrapper sm-overflow-scroll orders-panel"
  }, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v("Order")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Qty")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _vm._l((_vm.order.order_items), function(item) {
    return _c('tr', {
      staticStyle: {
        "padding-bottom": "10em !important"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "70%"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_c('b', [_vm._v("ORD NO: ")]), _vm._v(_vm._s(item.order_item_no))]), _c('br'), _vm._v("\r\n                          " + _vm._s(item.product_name) + "\r\n                          "), _c('br'), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline",
        "padding-bottom": "1em"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + item.product_item_group_image,
        "height": "50",
        "width": "50"
      }
    }), _c('br'), _c('br')])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.order_item_quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.order_item_total.toFixed(2)))])])
  })], 2)])])]), _vm._v(" "), (_vm.order.order_can_review == 0) ? _c('div', {
    staticClass: "mobile-fix-nav-2"
  }, [_c('p', {
    staticStyle: {
      "padding": "0 5px"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.updateOrders(_vm.order, 'received')
      }
    }
  }, [(_vm.order.order_status_id == 18) ? _c('div', {
    staticStyle: {
      "background": "#337ab7",
      "width": "100vw",
      "padding": "0.8em",
      "text-align": "center"
    }
  }, [_vm._v("\r\n            Mark order as received\r\n          ")]) : _vm._e()]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.prepareProductsForReview()
      }
    }
  }, [_c('div', {
    staticStyle: {
      "background": "#e94b4b",
      "width": "100vw",
      "padding": "0.8em",
      "text-align": "center"
    }
  }, [_vm._v("\r\n            Review Products\r\n          ")])])]) : _vm._e()]) : _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col lg-12"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "28px",
      "font-weight": "bolder"
    },
    on: {
      "click": function($event) {
        _vm.show_products_for_review = false
      }
    }
  }, [_vm._v("X")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.order.order_items), function(item, idex) {
    return (item.order_item_can_review == 1) ? _c('div', {
      staticClass: "card-flat-pad",
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('div', [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "20%"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + item.product_item_group_image,
        "height": "50",
        "width": "50"
      }
    }), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.product_name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "width": "80%"
      }
    }, [(_vm.order_item.data_processing_message != '') ? _c('p', {
      key: _vm.componentOrderItemReviewKey,
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.order_item.data_processing_message))]) : _vm._e(), _vm._v(" "), _c('form', {
      staticClass: "sp-form"
    }, [_c('div', {}, [_vm._m(2, true), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.order_item.product_item_review),
        expression: "order_item.product_item_review"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "write a review"
      },
      domProps: {
        "value": (_vm.order_item.product_item_review)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.order_item.product_item_review = $event.target.value
        }
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_c('b', [_vm._v("Rate Product:")]), _vm._v(" "), _vm._l((_vm.order_item.star_rates), function(star, sdex) {
      return _c('a', {
        staticStyle: {
          "padding": "2px",
          "color": "#ffffff",
          "display": "inline",
          "cursor": "pointer",
          "text-decoration": "none"
        },
        on: {
          "click": function($event) {
            _vm.setRating(sdex, idex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-star rate-stars i-default",
        attrs: {
          "id": sdex + 'STR' + idex
        }
      })])
    })], 2)]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02 sp-button-md",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.submitReview
      }
    }, [_vm._v("submit")])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]) : _vm._e()
  }))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sp-app-default-color"
  }, [_c('i', {
    staticClass: "fas fa-circle-notch fa-spin fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "padding": "1.7em",
      "border": "solid 1px",
      "border-radius": "15px",
      "background-color": "#be0a4f"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "o-node a1"
  }, [_c('div', {
    staticClass: "o-node-left"
  }, [_c('div', {
    staticClass: "o-node-left-icon"
  }, [_vm._v("\r\n                          1\r\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "o-node-right"
  }, [_c('p', [_vm._v("Order Placed")])])]), _vm._v(" "), _c('div', {
    staticClass: "o-node a2",
    staticStyle: {
      "background-color": "#d8d50b"
    }
  }, [_c('div', {
    staticClass: "o-node-left"
  }, [_c('div', {
    staticClass: "o-node-left-icon"
  }, [_vm._v("\r\n                        2\r\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "o-node-right"
  }, [_c('p', [_vm._v("Order Confirmed")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Review Product")])])
}]}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrap-inner",
    staticStyle: {
      "background-color": "#ffffff",
      "margin": "0",
      "padding": "0.8em",
      "padding-left": "1.08em",
      "padding-top": "1.28em",
      "border-bottom": "none",
      "border": "none"
    }
  }, [_c('li', {
    staticClass: "header-left-2",
    staticStyle: {
      "min-width": "60%",
      "max-width": "65%"
    }
  }, [(_vm.can_show_back_nav) ? _c('a', {
    staticClass: "header-nav-back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "16px",
      "color": "#000000"
    }
  })]) : _vm._e(), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#000000",
      "text-transform": "capitalize",
      "font-size": "18px",
      "font-weight": "bolder",
      "cursor": "pointer",
      "text-decoration": "none"
    },
    attrs: {
      "href": "/"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "0px",
      "margin-top": "-1.52em",
      "padding-top": "0",
      "display": "block"
    },
    attrs: {
      "id": "appName"
    }
  }, [(_vm.headerdata.name && (_vm.headerdata.name != '')) ? _c('span', [_vm._v(_vm._s(_vm.headerdata.name))]) : _c('span', {
    staticStyle: {
      "font-family": "Arial, Helvetica, sans-serif",
      "font-size": "20px",
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.app_name))])])])]), _vm._v(" "), (_vm.can_show_side_nav) ? _c('li', {
    staticClass: "header-right-2",
    staticStyle: {
      "padding-top": "0.81em"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    staticStyle: {
      "background-color": "#eee",
      "border-radius": "50%",
      "color": "#000000",
      "cursor": "pointer",
      "margin-top": "-0.9em",
      "padding": "5px 8px",
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.dropMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-search",
    staticStyle: {
      "font-size": "1.28em",
      "color": "#5703a5"
    }
  })])]), _vm._v(" "), _c('li', [_c('component-account-menu')], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin": "0.1em",
      "margin-top": "-0.2em"
    }
  }, [(_vm.loading) ? _c('div', [_vm._m(0)]) : _c('div', {
    staticClass: "card card-box"
  }, [(_vm.menu_tab_inner_view['general_goods_category_products']) ? _c('div', {
    staticClass: "card"
  }, [_c('h3', [_c('span', [_c('button', {
    staticClass: "btn sp-button-02-lt",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-left"
  })])]), _vm._v(_vm._s(_vm.general_goods_category.category_name))]), _vm._v(" "), _vm._l((_vm.general_goods_category_products), function(set_product, index) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "col-xs-3"
    }, [_c('div', {
      staticClass: "card-avatar-square"
    }, [(set_product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": set_product.product_images[0].product_image
      }
    }) : _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('div', [_c('p', [_vm._v(_vm._s(set_product.product_name)), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("₦‎" + _vm._s(set_product.product_items[0].product_item_price_f))])]), _vm._v(" "), _c('p', [_c('button', {
      staticClass: "btn sp-button-02-lt",
      on: {
        "click": function($event) {
          _vm.product = set_product;
          _vm.add_general_products = 1;
          _vm.addProduct();
        }
      }
    }, [_vm._v("SELECT")])])])])])
  })], 2) : (_vm.menu_tab_inner_view['custom_add']) ? _c('div', {
    staticClass: "card"
  }, [_vm._v("\r\n          Custom Add New\r\n        ")]) : _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('div', [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "padding-right": "1em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("General Products  ")]), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    staticStyle: {
      "padding-left": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('custom_add')
      }
    }
  }, [_vm._v("Your Product")])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', [_c('h4', [_vm._v("select from these categories")]), _vm._v(" "), ((Object.keys(_vm.general_goods).length > 0)) ? _c('div', {
    key: _vm.componentKey
  }, _vm._l((_vm.general_goods), function(category, index) {
    return _c('div', {
      staticClass: "card card-row"
    }, [_c('p', [_c('a', {
      staticClass: "card",
      on: {
        "click": function($event) {
          _vm.setGeneralGoodsCategoryProducts(category)
        }
      }
    }, [_vm._v(_vm._s(category.category_name))])])])
  })) : _vm._e()])])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
}]}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [(_vm.menu_tab_inner_view['premiumMember']) ? _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('');
        _vm.toggleSingleComponent('xInfo');
      }
    }
  }, [_c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Become a premium shop owner")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "background-color": "rgb(41, 122, 245)",
      "border-radius": "18px",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('premiumMember')
      }
    }
  }, [_c('span', [_vm._v("Your Plan starts at N35,000 per year")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "letter-spacing": "2.2"
    }
  }, [_vm._v("ACTIVATE")])])])])]) : _c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin": "0.1em",
      "margin-top": "-0.2em"
    }
  }, [_c('div', {
    staticClass: "card card-box"
  }, [_vm._m(2), _vm._v(" "), _c('h4', [_vm._v("Welcome " + _vm._s(_vm.user.user_name))]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "13px",
      "text-transform": "uppercase"
    }
  }, [_vm._v("sales today")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#5703a5"
    }
  }, [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.total_sales_today)))])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-box"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', [_c('table', [_vm._m(4), _vm._v(" "), _vm._l((_vm.set_ordered_items), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s((index + 1)))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-3"
    }, [(item.product_item_group_image && (item.product_item_group_image != '')) ? _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "border-radius": "5px"
      },
      attrs: {
        "src": item.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "border-radius": "5px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('p', [_vm._v(_vm._s(item.product_name)), _c('br'), _vm._v(" "), (item.product_item_service_tag != 'Nill') ? _c('span', [_vm._v("(" + _vm._s(item.product_item_service_tag) + ")")]) : _vm._e()])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.set_order_quantity))])])
  })], 2)])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "block",
      "position": "fixed",
      "width": "100%",
      "bottom": "6em",
      "background": "#ffffff",
      "z-index": "10000"
    },
    attrs: {
      "id": "xInfo"
    }
  }, [(!_vm.menu_tab_inner_view['premiumMember']) ? _c('div', {
    staticClass: "container"
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('xInfo')
      }
    }
  }, [_c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "background-color": "rgb(41, 122, 245)",
      "border-radius": "18px",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('premiumMember')
      }
    }
  }, [_vm._v("\r\n        Become a premium shop owner")]), _vm._v(" "), _vm._m(7)])]) : _vm._e()]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")]), _vm._v("Only Premuim Shop Oners get verified and have access to benefits")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "left",
      "color": "#2c2c2c"
    }
  }, [_c('p', [_vm._v("1. Access Professional Dashboard")]), _vm._v(" "), _c('p', [_vm._v("2. Manage your shop with more than one persons")]), _vm._v(" "), _c('p', [_vm._v("3. Enjoy Shopping pst referrals")]), _vm._v(" "), _c('p', [_vm._v("4. Offer Discounts and Coupon Codes")]), _vm._v(" "), _c('p', [_vm._v("5. Access Professional Dashboard")]), _vm._v(" "), _c('p', [_vm._v("6. Manage your shop with more than one persons")]), _vm._v(" "), _c('p', [_vm._v("7. Enjoy Shopping pst referrals")]), _vm._v(" "), _c('p', [_vm._v("8. Offer Discounts and Coupon Codes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h4', [_vm._v("Items Sold Today")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('th', [_vm._v("-")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding-left": "1em",
      "padding-bottom": "1em",
      "font-size": "0"
    }
  }, [_vm._v("item")]), _vm._v(" "), _c('th', [_vm._v("Qty")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-box"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h4', [_vm._v("Shopping List")])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-box"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h4', [_vm._v("Market List")])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")]), _vm._v("Only Premuim Shop Oners get verified and have access to benefits")])
}]}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.show_landing) ? _c('div', {
    staticClass: "main-wrap",
    staticStyle: {
      "background-color": "#ffffff"
    },
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.site_view == 1) ? _c('div', [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pager",
    staticStyle: {
      "background-color": "none",
      "margin-top": "3.8em",
      "padding": "0.5em",
      "text-align": "left"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0.8em",
      "margin-top": "1em",
      "margin-bottom": "0"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "container-x",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin-top": "-0.29em",
      "margin-left": "-1.8em",
      "color": "#000000"
    }
  }, [_c('ul', _vm._l((_vm.set_categories), function(data, index) {
    return _c('li', [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "margin": "0",
        "padding": "0.31em"
      }
    }, [_c('a', {
      staticClass: "card-link"
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "padding": "0.2em",
        "margin-bottom": "1em"
      }
    }, [_vm._m(4, true), _vm._v(" "), _c('p', [_vm._v(_vm._s(data.category_name))])])])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0.8em",
      "margin-top": "-2.5em"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin-top": "-0.29em",
      "margin-left": "-0.8em",
      "color": "#000000"
    }
  }, [_c('ul', _vm._l((_vm.set_categories), function(data, index) {
    return _c('li', {
      staticStyle: {
        "width": "85%"
      }
    }, [_c('div', {
      staticStyle: {
        "height": "180px",
        "margin": "0",
        "padding": "0.31em"
      },
      style: ('backgroundColor:' + data.category_color)
    }, [_c('a', {
      staticClass: "card-link"
    }, [_c('div', {
      staticStyle: {
        "padding": "0.2em",
        "margin-bottom": "1em"
      }
    }, [_vm._m(6, true), _vm._v(" "), _c('p', [_vm._v(_vm._s(data.category_name))])])])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  }), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "8em",
      "padding": "0.8em",
      "margin-top": "-2.5em",
      "background-color": "#f9f9f9"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(7), _vm._v(" "), _c('div', _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "col-xs-6",
      staticStyle: {
        "padding": "8px"
      }
    }, [_c('div', {
      staticClass: "card-col-pr"
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setProductView(product, index, product.product_items[0], 0)
        }
      }
    }, [_c('div', {
      staticClass: "pr-top",
      staticStyle: {
        "padding": "0.5em"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "75%"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle",
      staticStyle: {
        "height": "30px",
        "width": "30px"
      }
    }, [(product.product_images[0]) ? _c('img', {
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _vm._m(8, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-img-boxx-x"
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "card-col-pr-img",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      staticClass: "card-col-pr-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "0.8em",
        "padding-top": "0.0em"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "85%"
      }
    }, [_c('h4', {
      staticStyle: {
        "font-weight": "bolder",
        "margin-top": "-0px"
      }
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))]), _vm._v(" "), _c('p', {
      staticClass: "pr-name-1-lines",
      staticStyle: {
        "margin-top": "-0.25em",
        "line-height": "0.8",
        "font-size": "14px"
      }
    }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _vm._m(9, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "container-x",
    staticStyle: {
      "background-color": "none",
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "row-x"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "container card",
    staticStyle: {
      "margin": "1em 0.8em",
      "padding": "2em 1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin": "0.2em",
      "margin-top": "1em",
      "background": "#ffffff"
    }
  }, [_c('ul', _vm._l((_vm.categories), function(data, index) {
    return _c('li', {
      staticClass: "card-col-2"
    }, [_c('div', {
      staticClass: "card-col-img"
    }, [(data.category_image) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": data.category_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block",
        "padding": "3px",
        "padding-left": "2em"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(data.category_name) + " "), _c('br')])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "border-radius": "1px",
      "border": "none",
      "margin": "0em",
      "margin-top": "1em",
      "background": "#ffffff"
    }
  }, _vm._l((_vm.products), function(product, index) {
    return (product.product_images.length > 0) ? _c('div', {
      staticClass: "card-col-2c"
    }, [_c('div', {
      staticClass: "card col-xs-6"
    }, [_c('a', {
      staticClass: "card-link",
      attrs: {
        "href": '/make/order/' + product.product_url_name
      }
    }, [_c('div', {
      staticClass: "card-col-2c-img",
      staticStyle: {
        "background-repeat": "no-repeat",
        "background-size": "contain"
      },
      style: ({
        'background-image': 'linear-gradient(to bottom, rgba(17, 17, 17, 0.247), rgba(8, 8, 8, 0.211)),' + 'url(' + product.product_images[0].product_image + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "card-badge"
    }, [_c('div', {
      staticClass: "container",
      staticStyle: {
        "background": "#ffffff"
      }
    }, [_c('h6', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px",
        "text-align": "left",
        "background": "#ffffff"
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('span', [_vm._v(_vm._s(product.product_name))]), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "text-transform": "capitalize",
        "font-size": "22px"
      }
    }, [_c('b', [_vm._v(_vm._s(product.product_business_ownername))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])]), _vm._v(" "), _vm._m(12, true)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('hr')])])]), _vm._v(" "), _c('div', {}, [_c('span', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'prdQty' + index
      }
    }, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'sub', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(product.product_items[0].product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'add', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])])]), _vm._v(" "), (_vm.checkOrderItems(product.product_items[0])) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(1, product.product_items[0], index, 0);
          _vm.toggleSingleComponent('prdQty' + index)
        }
      }
    }, [_vm._m(13, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(1, product.product_items[0], index, 0);
          _vm.toggleSingleComponent('prdQty' + index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])])])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin": "1.5em"
    }
  }, [_c('div', {
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin": "0em",
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, _vm._l((_vm.businesses), function(business) {
    return _c('div', {
      staticClass: "col-xs-6",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('a', {
      staticClass: "card-link",
      attrs: {
        "href": '/' + business.business_username
      }
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "padding": "0.2em",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "card-colxx",
      staticStyle: {
        "margin-bottom": "-1em",
        "z-index": "5"
      }
    }, [_c('img', {
      staticClass: "card-col-img",
      attrs: {
        "src": business.business_brand_image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-details",
      staticStyle: {
        "z-index": "1",
        "height": "75px",
        "border-radius": "0 0 14px 14px",
        "background": "#ffffff",
        "padding": "1em",
        "padding-top": "1.6em"
      }
    }, [_c('p', [_vm._v(_vm._s(business.business_name))])])])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000",
      "width": "100%",
      "margin-left": "-0.11em",
      "border-left": "#ffffff solid"
    },
    attrs: {
      "id": "shareBox"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "max-height": "100vh",
      "overflow": "scroll",
      "bottom": "0",
      "margin": "0 -1.2em",
      "background": "#ffffff",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticClass: "z-box",
    staticStyle: {
      "width": "100%",
      "padding": "0.1em",
      "border-radius": "35px 35px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "100vh",
      "padding": "2em",
      "text-align": "left"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "#000000",
      "padding": "0.6em 0.8em",
      "font-size": "28px"
    },
    on: {
      "click": function($event) {
        _vm.setViewBox('')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('shareBox')
      }
    }
  }, [_vm._m(15), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em",
      "margin-bottom": "5em"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#000000",
      "padding": "0.6em 0.8em",
      "font-size": "28px"
    },
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setOrderAddons'
      }
    }
  }, [_vm._v("Proceed")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#000000",
      "padding": "0.6em 0.8em",
      "font-size": "28px"
    },
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setOrderCheckout'
      }
    }
  }, [_vm._v("Checkout")]), _vm._v(" "), (_vm.set_view_box == '') ? _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Order List")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "128%"
    }
  }, _vm._l((_vm.set_order_list), function(item, index) {
    return _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "col-xs-2 card-avatar-square",
      staticStyle: {
        "width": "80px",
        "height": "80px",
        "margin": "0",
        "padding": "0",
        "margin-right": "0"
      }
    }, [(item.product_item_group_image && (item.product_item_group_image != '')) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": item.product_item_group_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4",
      staticStyle: {
        "padding": "3px",
        "padding-left": "8px",
        "margin": "0",
        "text-align": "left"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_c('b', [_vm._v("Add ")]), _vm._v(_vm._s(item.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x",
      staticStyle: {
        "color": "#ff0000",
        "font-weight": "600"
      }
    }, [_vm._v("₦‎" + _vm._s(item.product_item_price_f))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-5",
      staticStyle: {
        "margin": "0",
        "padding": "0",
        "width": "39.87%"
      }
    }, [_c('div', {}, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 2, 'sub', 0, item, index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(item.product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 2, 'add', 0, item, index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])]), _vm._v(" "), (_vm.checkOrderItems(item)) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(2, item, 0, index)
        }
      }
    }, [_vm._m(16, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(2, item, 0, index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])])])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setOrderAddons') ? _c('div', {
    staticClass: "row"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "0"
    }
  }, _vm._l((_vm.set_order_addons), function(product, index) {
    return _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "col-xs-2 card-avatar-square",
      staticStyle: {
        "width": "80px",
        "height": "80px",
        "margin": "0",
        "padding": "0",
        "margin-right": "0"
      }
    }, [(product.product_images && (Object.keys(product.product_images).length > 0)) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4",
      staticStyle: {
        "padding": "3px",
        "padding-left": "8px",
        "margin": "0",
        "text-align": "left"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_c('b', [_vm._v("Add ")]), _vm._v(_vm._s(product.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x",
      staticStyle: {
        "color": "#ff0000",
        "font-weight": "600"
      }
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-5",
      staticStyle: {
        "margin": "0",
        "padding": "0",
        "width": "39.87%"
      }
    }, [_c('div', {}, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 3, 'sub', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(product.product_items[0].product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 3, 'add', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])]), _vm._v(" "), (_vm.checkOrderItems(product.product_items[0])) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(3, product.product_items[0], index, 0)
        }
      }
    }, [_vm._m(18, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(3, product.product_items[0], index, 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])])])])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setOrderCheckout') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setOrderCheckout"
    }
  }, [(_vm.set_view_box == 'setOrderCheckout') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setDeliveryLocation"
    }
  }, [(Object.keys(_vm.business_delivery_locations).length > 0) ? _c('div', [_vm._m(19), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-1em"
    }
  }, [_vm._l((_vm.business_delivery_locations), function(location, index) {
    return _c('div', [_c('p', [_c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.set_order_delivery_location),
        expression: "set_order_delivery_location"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": location.business_delivery_option_id,
        "checked": _vm._q(_vm.set_order_delivery_location, location.business_delivery_option_id)
      },
      on: {
        "click": function($event) {
          _vm.setOrderDeliveryLocation(location)
        },
        "__c": function($event) {
          _vm.set_order_delivery_location = location.business_delivery_option_id
        }
      }
    })]), _vm._v("\r\n                          " + _vm._s(location.business_delivery_state) + " - " + _vm._s(location.business_delivery_option) + " - " + _vm._s(location.business_delivery_option_price) + "\r\n                        ")])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setOrderCheckout') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setContactDetails"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Order Contact Details")]), _vm._v(" "), (_vm.user.user_id && (_vm.user.user_id > 0)) ? _c('div', [_c('p', [_vm._v("Review contact details")]), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.user.user_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.user.user_email))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.user.user_phone))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivety Address: ")]), _vm._v(_vm._s(_vm.user.user_order_delivey_address))]), _vm._v(" "), _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), ((_vm.set_payment_mode == 1) && (_vm.user.user_email == '')) ? _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]) : _vm._e()]) : _c('div', [(_vm.menu_tab_inner_view['showUserDetails']) ? _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.user.user_name))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.user.user_email))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.user.user_phone))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivety Address: ")]), _vm._v(_vm._s(_vm.user.user_order_delivey_address))]), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Reset")])])]) : _c('div', [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('showUserDetails')
      }
    }
  }, [_vm._v("Ok")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setOrderCheckout') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setPaymentOptions"
    }
  }, [(_vm.menu_tab_inner_view['showOrderPaymentConfirmation']) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setPaymentSuccess"
    }
  }, [_c('p', [_vm._v("Payment Made")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn card-link",
    attrs: {
      "href": '/placed/order/' + _vm.order.order_no
    }
  }, [_vm._v("View Order")])]) : _c('div', [_vm._m(20), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Payment Method")]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_payment_mode),
      expression: "set_payment_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.set_payment_mode, "4")
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('payBank')
      },
      "__c": function($event) {
        _vm.set_payment_mode = "4"
      }
    }
  })]), _vm._v("\r\n                          Pay to Bank")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "payBank"
    }
  }, [_vm._m(21), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Bank: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account Name: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_account_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account Number: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_account_number))])])])]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_payment_mode),
      expression: "set_payment_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.set_payment_mode, "1")
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('payDirect')
      },
      "__c": function($event) {
        _vm.set_payment_mode = "1"
      }
    }
  })]), _vm._v("\r\n                          Pay to Direct")]), _vm._v(" "), _vm._m(22)]), _vm._v(" "), _c('div', [(_vm.data_processing_messages.mode_err) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_messages.mode_err))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.setMakeOrder(_vm.set_payment_mode)
      }
    }
  }, [_vm._v("Place Order")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "position": "fixed",
      "background-color": "#ffffff",
      "bottom": "0",
      "width": "100%",
      "padding-left": "1.81em",
      "padding-top": "6px",
      "margin-top": "10px",
      "border-top": "1px solid #eee"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "x-totals"
  }, [(_vm.set_order_total_amount && (_vm.set_order_total_amount > 0)) ? _c('h3', [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.set_order_total_amount)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.set_view_box == 'setPaymentOptions') ? _c('div', [_c('div', [_c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setContactDetails'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])])]) : (_vm.set_view_box == 'setContactDetails') ? _c('div', [_c('div', [_c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setDeliveryLocation'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setPaymentOptions'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])]) : (_vm.set_view_box == 'setDeliveryLocation') ? _c('div', [_c('div', [_c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setContactDetails'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])]) : _c('div', [_c('div', [_c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setDeliveryLocation'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "border": "none",
      "width": "100%",
      "bottom": "0em",
      "margin": "0",
      "padding": "0 2em",
      "padding-top": "1.2em",
      "padding-right": "0",
      "background": "#ffffff",
      "z-index": "1"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "block",
      "width": "100%",
      "height": "auto",
      "padding": "0.1em",
      "background-color": "rgba(0, 0, 0, 0)",
      "border-top": "none",
      "border-radius": "45px 45px 0px 0px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "x-totals"
  }, [(_vm.set_order_total_amount && (_vm.set_order_total_amount > 0)) ? _c('h3', [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.set_order_total_amount)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "x-cta-btn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('shareBox');
      }
    }
  }, [_vm._v("Order Now>>")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])]), _vm._v(" "), _c('component-footer')], 1) : _c('div', [_c('component-desktop')], 1)]) : _c('div', [_c('component-landing')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0 10px",
      "margin-top": "0em"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "75%"
    }
  }, [_c('h5', [_vm._v("Location . Awka")]), _vm._v(" "), _c('p', {
    staticClass: "pr-name-1-lines",
    staticStyle: {
      "margin-top": "-0.81em",
      "font-size": "12px"
    }
  }, [_vm._v("Munchit, Trust Hotel, near Aroma Secretarait Junction")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "25%",
      "padding-left": "1em",
      "padding-top": "1em"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "border-radius": "10px",
      "background-color": "#5703a5",
      "color": "#ffffff",
      "line-height": "0.8"
    }
  }, [_vm._v("Change")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0 0.2em",
      "margin-top": "-1em"
    }
  }, [_c('div', {
    staticClass: "col-xs-6 mp0",
    staticStyle: {
      "padding": "0 8px"
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "background-color": "#421A7A",
      "border-radius": "8px",
      "padding": "0.4em 0.8em",
      "padding-bottom": "0",
      "color": "#ffffff"
    }
  }, [_c('h4', {
    staticStyle: {
      "float": "left",
      "width": "65%",
      "margin-bottom": "1em"
    }
  }, [_vm._v("Last "), _c('br'), _vm._v("Shopping")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "35%",
      "margin-top": "0.46em",
      "margin-bottom": "0em",
      "padding-left": "0.12em"
    }
  }, [_c('i', {
    staticClass: "fas fa-shopping-bag",
    staticStyle: {
      "font-size": "3.4em",
      "margin-top": "-0.46em",
      "margin-left": "0.3em",
      "color": "#e68f74"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-shopping-bag",
    staticStyle: {
      "font-size": "3.0em",
      "margin-top": "-1.46em",
      "color": "#ebb1a2"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 mp0",
    staticStyle: {
      "padding": "0 8px"
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "background-color": "#421A7A",
      "border-radius": "8px",
      "padding": "0.4em 0.8em",
      "padding-bottom": "0",
      "color": "#ffffff"
    }
  }, [_c('h4', {
    staticStyle: {
      "float": "left",
      "width": "65%",
      "margin-bottom": "1em"
    }
  }, [_vm._v("Saved "), _c('br'), _vm._v("Shops")]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-store",
    staticStyle: {
      "float": "right",
      "width": "35%",
      "font-size": "3.4em",
      "margin-top": "0.46em",
      "margin-bottom": "0em",
      "padding-left": "0.12em",
      "color": "#e68f74"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0.5em",
      "margin-top": "1.5em"
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "background-color": "#eee2fd",
      "border-radius": "12px",
      "padding": "1em"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "65%"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "12",
      "color": "#333"
    }
  }, [_vm._v("Premium offer")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "800",
      "text-transform": "uppercase"
    }
  }, [_vm._v("Create your"), _c('br'), _vm._v("Shopping List")]), _vm._v(" "), _c('p', [_vm._v("excellent offers await you")]), _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "border-radius": "10px",
      "background-color": "#5703a5",
      "color": "#ffffff",
      "line-height": "0.8"
    }
  }, [_vm._v("Change")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "35%"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "margin-top": "3em"
    },
    attrs: {
      "src": "/static/assets/images/shopping-bags.webp"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticStyle: {
      "font-weight": "800"
    }
  }, [_vm._v("Shop by category")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-avatar-square",
    staticStyle: {
      "padding": "1em",
      "background-color": "#f3f3f3"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticStyle: {
      "font-weight": "800"
    }
  }, [_vm._v("Near By")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-avatar-square",
    staticStyle: {
      "padding": "1em",
      "background-color": "#f3f3f3"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "8px"
    }
  }, [_c('h4', {
    staticStyle: {
      "float": "left",
      "font-weight": "800"
    }
  }, [_vm._v("Top Picks")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "float": "right",
      "font-size": "13px"
    }
  }, [_vm._v("Select / Filter")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "width": "25%",
      "padding-top": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "font-size": "14px",
      "color": "#f5e50a"
    }
  }), _vm._v(" 4.5\r\n                      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "width": "15%",
      "padding-top": "8px"
    }
  }, [_c('i', {
    staticClass: "fas fa-shopping-bag",
    staticStyle: {
      "font-size": "22px",
      "color": "#949393"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container card",
    staticStyle: {
      "margin": "1em 0.8em",
      "padding": "2em 1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card col-xs-6"
  }, [_c('a', {
    staticClass: "card-link"
  }, [_c('div', {
    staticClass: "card-col-2c-img",
    staticStyle: {
      "background": "#750647",
      "background-repeat": "no-repeat",
      "background-size": "contain"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card col-xs-6"
  }, [_c('a', {
    staticClass: "card-link"
  }, [_c('div', {
    staticClass: "card-col-2c-img",
    staticStyle: {
      "background": "#750647",
      "background-repeat": "no-repeat",
      "background-size": "contain"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "htro"
  }, [_c('h3', [_vm._v("\r\n                Trending\r\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#f7df2b",
      "border-radius": "38%",
      "color": "#000000",
      "padding": "0.62em 0.81em"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart",
    staticStyle: {
      "font-size": "1.3em"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "htro"
  }, [_c('h3', [_vm._v("\r\n                  in stock\r\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "display": "none",
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', {
    staticStyle: {
      "line-height": "1.2"
    }
  }, [_vm._v("Add to Order"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "0.05em",
      "font-size": "13px"
    }
  }, [_vm._v("items you should buy with this order")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-shopping-bag",
    staticStyle: {
      "font-size": "3em"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-right",
    staticStyle: {
      "margin-top": "-1.4em"
    }
  }, [_c('h3', [_vm._v("Delivery Locations")]), _vm._v(" "), _c('p', [_vm._v("set where you want this order delivered to")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-shopping-bag",
    staticStyle: {
      "font-size": "3em"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-right",
    staticStyle: {
      "margin-top": "-1.4em"
    }
  }, [_c('h3', [_vm._v("Payment")]), _vm._v(" "), _c('p', [_vm._v("set where you want this order delivered to")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Send to:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "payDirect"
    }
  }, [_c('p', [_vm._v("Pay with your Credit/ATM card")])])
}]}

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.set_headers
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "1em",
      "text-align": "left"
    }
  }, [_c('h4', [_vm._v("Join " + _vm._s(_vm.group.name))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._v("bb\r\n                " + _vm._s(_vm.group_details) + "\r\n            ")])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "2em",
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("Sign in for a personalised tribe experience")]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "margin": "1em"
    },
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("login")]), _vm._v(" - \r\n                    "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "margin": "1em"
    },
    attrs: {
      "href": "/register"
    }
  }, [_vm._v("signup")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "2em",
      "text-align": "center"
    }
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("continue without signing in")])])])
}]}

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin": "0.1em",
      "margin-top": "-0.2em"
    }
  }, [(_vm.loading) ? _c('div', [_vm._m(0)]) : _c('div', {
    staticClass: "card card-box"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h4', [_c('span', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "padding-right": "1em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Shopping Lists "), _c('br'), _c('span', [_vm._v("Items to sell")])])]), _vm._v("|\r\n            "), _c('span', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "padding-left": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('marketLists')
      }
    }
  }, [_vm._v("Market Lists "), _c('br'), _c('span', [_vm._v("Items to buy")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [(_vm.menu_tab_inner_view['marketLists']) ? _c('div', [_vm._v("\r\n            market list\r\n          ")]) : _c('div', [_c('div', [((Object.keys(_vm.sellpoint_orders).length > 0)) ? _c('div', {
    key: _vm.componentKey
  }, _vm._l((_vm.sellpoint_orders), function(order) {
    return _c('div', {
      staticClass: "row card-box card-02",
      staticStyle: {
        "border-bottom": "#eee solid",
        "margin-bottom": "2em"
      }
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "card-link",
      attrs: {
        "href": '/manage/lists/shopping/' + order.order_no
      }
    }, [_c('div', {
      staticClass: "col-xs-4"
    }, [_c('div', {
      staticStyle: {
        "display": "inline",
        "padding-bottom": "1em"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "80px",
        "height": "100px",
        "border-radius": "8px"
      },
      attrs: {
        "src": _vm.img_product_url + order.order_items[0].product_item_group_image
      }
    }), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8"
    }, [_c('h4', {
      staticStyle: {
        "font-weight": "800"
      }
    }, [_vm._v(_vm._s(order.order_items[0].product_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(order.order_details))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(order.order_time_ago) + " >")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  })) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No Orders yet")])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    staticStyle: {
      "color": "#ff0000",
      "font-weight": "600"
    }
  }), _vm._v(" Re-Order")])
}]}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "card card-flat"
  }, [_c('h6', [_vm._v("You have "), _c('span', [_vm._v("(" + _vm._s(Object.keys(_vm.categories).length) + ")")]), _vm._v(" Shop Category")]), _vm._v(" "), _vm._l((_vm.categories), function(category, index) {
    return _c('div', {
      staticClass: "card"
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.setCategory(category)
        }
      }
    }, [_c('div', {
      staticClass: "card-row"
    }, [_c('p', {
      staticStyle: {
        "color": "#353434"
      }
    }, [(category.business_parent_category != 'None') ? _c('span', [_c('span', {
      staticStyle: {
        "color": "#000000"
      }
    }, [_vm._v(_vm._s(category.business_parent_category))]), (category.business_category && (category.business_category != '')) ? _c('span', [_c('br'), _vm._v(_vm._s(category.business_category))]) : _vm._e()]) : _c('span', [_vm._v(_vm._s(category.business_category_name))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(category.business_category_total_products) + " product(s) ")])]), _vm._v(" "), _vm._m(1, true), _c('br')]), _vm._v(" "), _c('hr')])])])
  }), _vm._v(" "), ((_vm.categories && Object.keys(_vm.categories).length == 0)) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#e94b4b"
    }
  }, [_vm._v("You have not added any Category yet")])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "href": "/account/business/newcategory"
    }
  }, [_vm._v("Add New Category")])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\r\n              O P E N "), _c('i', {
    staticClass: "fa fa-long-arrow-right",
    staticStyle: {
      "color": "inherit",
      "outline": "0"
    }
  })])
}]}

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap"
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "8em",
      "margin-bottom": "10em"
    }
  }, [(_vm.menu_tab_inner_view['setForm']) ? _c('div', {
    staticClass: "card"
  }, [_c('div', [_c('p', {
    staticStyle: {
      "color": "#242323"
    }
  }, [_vm._v("Contact details")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Shop Owner Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custom_data.user_name),
      expression: "custom_data.user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Name"
    },
    domProps: {
      "value": (_vm.custom_data.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.custom_data.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custom_data.user_phone),
      expression: "custom_data.user_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Phune"
    },
    domProps: {
      "value": (_vm.custom_data.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.custom_data.user_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custom_data.user_email),
      expression: "custom_data.user_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Email"
    },
    domProps: {
      "value": (_vm.custom_data.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.custom_data.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10em"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#242323"
    }
  }, [_vm._v("Shop details")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custom_data.business_name),
      expression: "custom_data.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Name"
    },
    domProps: {
      "value": (_vm.custom_data.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.custom_data.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Category or Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custom_data.business_category_id),
      expression: "custom_data.business_category_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.custom_data.business_category_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select a Category")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "cardbox"
  }, [_c('p', [_vm._v("Bank Information")]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Add your Bank Details to receive order payments")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [(_vm.ravepay_bank_list && ((Object.keys(_vm.ravepay_bank_list).length == 0))) ? _c('div', [_vm._m(0)]) : _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custom_data.bank_name),
      expression: "custom_data.bank_name"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.custom_data.bank_name = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select your bank")]), _vm._v(" "), _vm._l((_vm.ravepay_bank_list), function(bank) {
    return _c('option', {
      domProps: {
        "value": bank.Name
      }
    }, [_vm._v(_vm._s(bank.Name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custom_data.bank_account_name),
      expression: "custom_data.bank_account_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.custom_data.bank_account_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.custom_data.bank_account_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custom_data.bank_account_number),
      expression: "custom_data.bank_account_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.custom_data.bank_account_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.custom_data.bank_account_number = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    staticStyle: {
      "margin-top": "5px",
      "background-color": "#5703a5",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.customSetAgentServices(1, 1)
      }
    }
  }, [_vm._v("Enter")])])])]) : _c('div', {
    staticClass: "card"
  }, [_c('p', [_vm._v("Set up Shop Account for a Business. You will provide Owner's Contact details snd Business details.")]), _vm._v(" "), _c('p', [_vm._v("After successful set up, Shop Owner can request for an activation code to Activate Shop.")]), _vm._v(" "), _c('p', [_vm._v("You can also upload maximum of 10 products for Shop to complete Set up.")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 mp0"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 w-any"
  }, [_c('h5', [_c('span', {
    staticClass: "nra-fmt"
  }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(_vm.service_charge_balance)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "nra-fmt"
  }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(_vm.service_charge_balance)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "nra-fmt"
  }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(_vm.service_charge_balance)))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "background-color": "rgb(41, 122, 245)",
      "width": "100%",
      "border-radius": "8px",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('setForm')
      }
    }
  }, [_vm._v("\r\n        Continue")])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v("Bank Name:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v("Account Name:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v("Account No:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6 w-any",
    staticStyle: {
      "border-right": "solid 3px #eee"
    }
  }, [_c('h5', [_vm._v("Shop Set Up"), _c('br'), _c('b', [_vm._v("Service Charge")])]), _vm._v(" "), _c('p', [_vm._v("Service Charge Balance")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Total to remain")])])])
}]}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap"
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "4em"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "0.3em"
    }
  }, [(_vm.set_view == 'deluxe') ? _c('div', [_vm._m(0)]) : _vm._e()])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "min-height": "80vh",
      "margin": "1em",
      "padding": "8em 3em",
      "border-radius": "5px",
      "box-shadow": "0 0 30px 4px rgba(0,0,0,0.03)"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "min-height": "125px",
      "padding": "1em",
      "background-color": "#ffffff",
      "border-radius": "5px",
      "box-shadow": "0 0 30px 4px rgba(0,0,0,0.03)"
    }
  }, [_c('h3', [_vm._v("Deluxe Shopping")]), _vm._v(" "), _c('p', [_vm._v("Unlimited Collections and Saved Shops")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/register"
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('h3', [_vm._v("₦5000 "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("/ monthly")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "min-height": "125px",
      "padding": "1em",
      "background-color": "#ffffff",
      "border-radius": "5px",
      "box-shadow": "0 0 30px 4px rgba(0,0,0,0.03)"
    }
  }, [_c('h3', [_vm._v("Deluxe Business")]), _vm._v(" "), _c('p', [_vm._v("Unlimited Shops and more")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/register"
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('h3', [_vm._v("₦5000 "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("/ monthly")])])])])
}]}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap"
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "6em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.agent_services_data && (Object.keys(_vm.agent_services_data).length > 0)) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('h4', {
    staticStyle: {
      "color": "#5703a5"
    }
  }, [_c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Total accounts added:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(Object.keys(_vm.agent_services_data).length))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.agent_services_data), function(business, index) {
    return _c('div', {
      staticClass: "card card-blosq card-blosq-lt"
    }, [_c('a', {
      staticClass: "card-link",
      attrs: {
        "href": "/agentservices/setupshop"
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9",
      staticStyle: {
        "margin-left": "-0.2em"
      }
    }, [_c('p', [_vm._v(_vm._s(business.business_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Added On: ")]), _c('br'), _vm._v(_vm._s(business.business_reg_date))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 mp0"
    }, [_c('span', {
      staticStyle: {
        "font-weight": "bolder",
        "color": "#5703a5"
      }
    }, [_vm._v("Status")]), _c('br'), _vm._v(" "), (business.business_status == 1) ? _c('span', [_vm._v("Active")]) : _c('span', [_vm._v("Pending")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  })], 2)]) : _vm._e()])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-1 mp0",
    staticStyle: {
      "margin-left": "-1em"
    }
  }, [_c('span', [_c('i', {
    staticClass: "fas fa-store",
    staticStyle: {
      "color": "#3b3737",
      "font-size": "18px",
      "margin-top": "0.3em"
    }
  })])])
}]}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "background": "#ffffff"
    },
    attrs: {
      "id": "topPanel"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h6', [_vm._v("Settings")])])])])])
}]}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.action_loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "container"
  }, [_c('div', {}, [_c('div', [_vm._v("Order number: " + _vm._s(_vm.order_data.order_no))]), _vm._v(" "), _c('div', [_vm._v("Date: " + _vm._s(_vm.order_data.order_date))]), _vm._v(" "), _c('div', [_vm._v("Order Amount: ₦" + _vm._s(_vm.order_data.order_items_total))]), _vm._v(" "), _c('div', [_vm._v("Shipping:  ₦" + _vm._s(_vm.order_data.order_shipping_total))]), _vm._v(" "), _c('div', [_vm._v("Total: ₦" + _vm._s(_vm.order_data.order_total))]), _vm._v(" "), _c('div', [_vm._v("Status: "), _c('span', {
    style: ({
      color: _vm.order_data.order_status_color
    })
  }, [_vm._v(_vm._s(_vm.order_data.order_status))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "background-color": "bisque",
      "padding": "1em",
      "border-radius": "12px"
    }
  }, [_c('h3', {
    staticStyle: {
      "float": "right",
      "text-decoration": "underline"
    }
  }, [_vm._v("SELLER")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "clear": "right"
    }
  }, [_c('h4', [_vm._v("Shopping List")]), _vm._v(" "), _vm._l((_vm.order_data.order_items), function(item) {
    return _c('p', {
      key: item.order_item_no
    }, [_vm._v("\n              " + _vm._s(item.product_name) + " - ₦" + _vm._s(item.order_item_total.toFixed(2)) + "\n            ")])
  }), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn sp-button-02",
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('setPaymentDetails')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Yes, I have these Items")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "setPaymentDetails"
    }
  }, [_c('div', [_c('hr'), _vm._v(" "), _c('b', [_vm._v("Send Bank Details")]), _c('br'), _vm._v(" "), (_vm.sellpoint.business_bank_details && (Object.keys(_vm.sellpoint.business_bank_details).length > 0)) ? _c('div', [_c('span', [_vm._v("Send bank details details to receive order payment")]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "color": "#444444"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_name)), _c('br'), _vm._v("\n                      " + _vm._s(_vm.sellpoint.business_bank_details.bank_account_name)), _c('br'), _vm._v("\n                      " + _vm._s(_vm.sellpoint.business_bank_details.bank_account_number) + "\n                    ")])]), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderCustomOrderDetailsUpdate(_vm.order_data)
      }
    }
  }, [_vm._v("Send")])]) : _c('div', [_vm._m(1)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('ConfirmPaymentUpdate')
      }
    }
  }, [_vm._v("Confirm Payment")]), _vm._v(" "), (_vm.menu_tab_inner_view['ConfirmPaymentUpdate']) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Confirm Order Payment ?")]), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderCustomConfirmPaymentUpdate(_vm.order_data)
      }
    }
  }, [_vm._v("Yes, Confirm Payment")])]) : _vm._e(), _vm._v(" "), _c('hr')])], 2)]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "card-row"
  }, [_c('h5', [_vm._v("Order Additional Information")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#e94b4b"
    }
  }, [_vm._v("Add any order addtional information")]), _vm._v(" "), (_vm.setAddOrderAdditionalView) ? _c('div', [_c('form', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_add_info.title),
      expression: "order_add_info.title"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.order_add_info.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.order_add_info.title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_add_info.details),
      expression: "order_add_info.details"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.order_add_info.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.order_add_info.details = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Cost")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_add_info.cost),
      expression: "order_add_info.cost"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.order_add_info.cost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.order_add_info.cost = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff",
      "text-decoration": "none"
    },
    on: {
      "click": _vm.addOrderAdditionalView
    }
  }, [_vm._v("Add Information to Order")])])]) : _c('div', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.setAddOrderAdditionalView = true
      }
    }
  }, [_vm._v("Add Information")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_c('h5', [_vm._v("Process Order Request")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderCustomUpdates(_vm.order_data, 'delivered', 3)
      }
    }
  }, [_vm._v("Mark as delivered")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderCustomUpdates(_vm.order_data, 'closed', 3)
      }
    }
  }, [_vm._v("Close Order")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div')])]), _vm._v(" "), (_vm.order_data.order_payment_status_id != 18) ? _c('div', {
    staticClass: "mobile-fix-nav-2"
  }, [_c('p', {
    staticStyle: {
      "padding": "0 5px"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.order_data.order_status_id == 7) ? _c('div', {
    staticStyle: {
      "background": "#e94b4b",
      "width": "100vw",
      "padding": "0.8em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.updateOrders(_vm.order, 'delivered')
      }
    }
  }, [_vm._v("Confirm Order Delivered ")])]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Set Bank details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Send Payment Link")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("A Payment link with payment details would be generated for payment")]), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Send Payment Link")])])
}]}

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('header', {
    staticClass: "header-wrap-sticky",
    staticStyle: {
      "background": "#000000",
      "color": "#ffffff",
      "border-bottom": "none"
    },
    attrs: {
      "id": "mainStickyHeader"
    }
  }, [_c('div', {
    staticClass: "row header-wrap-inner",
    staticStyle: {
      "border-bottom": "none",
      "margin": "0"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [(_vm.set_menu) ? _c('a', {
    staticClass: "card-link",
    staticStyle: {
      "background": "#000000 !important",
      "color": "#ffffff",
      "text-decoration": "none"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "14px"
    }
  }), _c('span', {}, [_vm._v("  "), _c('b', [_vm._v(_vm._s(_vm.header_name))])])]) : _c('a', {
    staticClass: "header-nav-back",
    staticStyle: {
      "background": "#000000 !important",
      "color": "#ffffff"
    },
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "color": "#ffffff",
      "font-size": "14px"
    }
  }), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("  "), _c('b', [_vm._v(_vm._s(_vm.header_name))])])])]), _vm._v(" "), _c('li', {
    staticClass: "header-right-2",
    staticStyle: {
      "margin-right": "1em"
    }
  }, [_c('a', {
    staticStyle: {
      "background": "#000000 !important"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-list",
    staticStyle: {
      "color": "#ffffff",
      "margin-top": "1em"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pager pager-clear-sticky",
    staticStyle: {
      "background": "#ffffff"
    },
    attrs: {
      "id": "topPanel"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "container"
  }, [(_vm.set_menu) ? _c('div', {
    staticClass: "banner-menu",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticClass: "menu-links menu-links-strip"
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('profile', 'profile')
      }
    }
  }, [_vm._m(1)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.routeToPage('/account')
      }
    }
  }, [_vm._m(2)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('orders', 'orders')
      }
    }
  }, [_vm._m(3)])]), _vm._v(" "), (!_vm.loading) ? _c('li', [(_vm.can_multiple_shops) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.routeToPage('/account/businesses')
      }
    }
  }, [_vm._m(4)]) : _c('a', {
    on: {
      "click": function($event) {
        _vm.routeToPage('/account/business')
      }
    }
  }, [_vm._m(5)])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('savedshops', 'savedshops')
      }
    }
  }, [_vm._m(6)])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.routeToPage('/account/groups')
      }
    }
  }, [_vm._m(7)])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('settings', 'settings')
      }
    }
  }, [_vm._m(8)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('invite', 'invite')
      }
    }
  }, [_vm._m(9)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('knowledge', 'knowledge')
      }
    }
  }, [_vm._m(10)])])])])]) : _c('div', {
    staticClass: "page-body"
  }, [(this.$route.path != '/account') ? _c('div', [_c('router-view')], 1) : _c('div', {
    staticStyle: {
      "margin-top": "-1em"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "page-header",
    staticStyle: {
      "padding": "0 1em",
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn sp-button-02 sp-button-02-lt",
    on: {
      "click": function($event) {
        _vm.setMenuLink('profile', 'profile')
      }
    }
  }, [_vm._v("View Profile")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('profile', 'profile')
      }
    }
  }, [_vm._m(11), _vm._v(" "), (_vm.user && (Object.keys(_vm.user).length > 0)) ? _c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "padding": "1em"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.user.user_name))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "menu-links menu-links-strip"
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('profile', 'profile')
      }
    }
  }, [_vm._m(12)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.routeToPage('/account')
      }
    }
  }, [_vm._m(13)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('orders', 'orders')
      }
    }
  }, [_vm._m(14)])]), _vm._v(" "), (!_vm.loading) ? _c('li', [(_vm.can_multiple_shops) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.routeToPage('/account/businesses')
      }
    }
  }, [_vm._m(15)]) : _c('a', {
    on: {
      "click": function($event) {
        _vm.routeToPage('/account/business')
      }
    }
  }, [_vm._m(16)])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('savedshops', 'savedshops')
      }
    }
  }, [_vm._m(17)])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.routeToPage('/account/groups')
      }
    }
  }, [_vm._m(18)])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('settings', 'settings')
      }
    }
  }, [_vm._m(19)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('invite', 'invite')
      }
    }
  }, [_vm._m(20)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('knowledge', 'knowledge')
      }
    }
  }, [_vm._m(21)])])])])])])])])]), _vm._v(" "), (_vm.can_show_footer) ? _c('component-footer', {
    staticStyle: {
      "z-index": "5"
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Profile")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Account Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Stores")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Store")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("My Saved Shops")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Market Groups")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Settings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Invite a Friend")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Help")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "src": "/static/assets/images/dummy-image.png",
      "width": "50",
      "height": "50"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Profile")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Account Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Stores")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Store")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("My Saved Shops")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Market Groups")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Settings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Invite a Friend")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Help")])])
}]}

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "background": "#ffffff"
    },
    attrs: {
      "id": "topPanel"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h6', [_vm._v("Groups")]), _vm._v(" "), (_vm.menu_view.showCreateGroup) ? _c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v("Create new Group")]), _vm._v(" "), _c('div', {
    staticClass: "form-card"
  }, [_c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" Group Name  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.group.group_name),
      expression: "group.group_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.group.group_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.group.group_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h4', [_vm._v("Select Group Type")]), _vm._v(" "), _c('div', [_c('h5', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.group.group_type),
      expression: "group.group_type"
    }],
    attrs: {
      "type": "radio",
      "value": "55"
    },
    domProps: {
      "checked": _vm._q(_vm.group.group_type, "55")
    },
    on: {
      "__c": function($event) {
        _vm.group.group_type = "55"
      }
    }
  }), _vm._v("  "), _c('b', [_vm._v("Business to Business Group")])]), _vm._v(" "), _c('p', [_vm._v("Add Only Businesses here")])]), _vm._v(" "), _c('div', [_c('h5', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.group.group_type),
      expression: "group.group_type"
    }],
    attrs: {
      "type": "radio",
      "value": "56"
    },
    domProps: {
      "checked": _vm._q(_vm.group.group_type, "56")
    },
    on: {
      "__c": function($event) {
        _vm.group.group_type = "56"
      }
    }
  }), _vm._v("  "), _c('b', [_vm._v("Business to Customer Group")])]), _vm._v(" "), _c('p', [_vm._v("Add Only Customers here...")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" Group Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.group.group_description),
      expression: "group.group_description"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.group.group_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.group.group_description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.createGroup
    }
  }, [_vm._v("Create")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "card-link btn sp-button-02 sp-button-02-lt",
    staticStyle: {
      "float": "right",
      "font-size": "13px",
      "margin-top": "0.1em",
      "text-transform": "inherit",
      "background-color": "#21a6f3",
      "color": "#ffffff",
      "border-radius": "5px",
      "padding": "3px 10px"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('')
      }
    }
  }, [_vm._v("\r\n                Cancel\r\n              ")])])])]) : _c('div', [_vm._l((_vm.groups), function(group, index) {
    return _c('div', {
      staticClass: "card card-row",
      staticStyle: {
        "border-radius": "0px",
        "margin-bottom": "0.6em"
      }
    }, [_c('div', [_c('a', {
      staticClass: "card-link",
      attrs: {
        "href": '/account/group/' + group.group_ref
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "80%"
      }
    }, [_c('p', [_c('b', [_vm._v(_vm._s(group.group_name))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(Object.keys(group.group_members).length) + " Members")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "width": "20%"
      }
    }, [_c('a', {
      staticClass: "card-link btn sp-button-02 sp-button-02-lt",
      staticStyle: {
        "float": "right",
        "font-size": "13px",
        "margin-top": "0.1em",
        "text-transform": "inherit",
        "background-color": "#21a6f3",
        "color": "#ffffff",
        "border-radius": "5px",
        "padding": "3px 10px"
      },
      attrs: {
        "href": '/account/group/' + group.group_ref
      }
    }, [_vm._v("\r\n                    Open\r\n                  ")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "card-link btn sp-button-02 sp-button-02-lt",
    staticStyle: {
      "font-size": "13px",
      "margin-top": "0.1em",
      "text-transform": "inherit",
      "background-color": "#21a6f3",
      "color": "#ffffff",
      "border-radius": "5px",
      "padding": "3px 10px"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('showCreateGroup')
      }
    }
  }, [_vm._v("\r\n            Create Group\r\n          ")])], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap"
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "6em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('div', {
    staticClass: "card card-blosq card-active"
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/agentservices/shopaccounts"
    }
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Shop Accounts")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.agent_services_numbers.data_businesses_count && (_vm.agent_services_numbers.data_businesses_count > 0)) ? _c('span', [_vm._v("(" + _vm._s(_vm.agent_services_numbers.data_businesses_count) + ")")]) : _c('span', [_vm._v("(0)")]), _vm._v("   "), _c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card card-blosq"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.agent_services_numbers.data_productss_count && (_vm.agent_services_numbers.data_products_count > 0)) ? _c('span', [_vm._v("(" + _vm._s(_vm.agent_services_numbers.data_orders_count) + ")")]) : _c('span', [_vm._v("(0)")]), _vm._v("   "), _c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-blosq"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Orders")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.agent_services_numbers.data_orders_count && (_vm.agent_services_numbers.data_orders_count > 0)) ? _c('span', [_vm._v("(" + _vm._s(_vm.agent_services_numbers.data_orders_count) + ")")]) : _c('span', [_vm._v("(0)")]), _vm._v("   "), _c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    staticStyle: {
      "background-color": "#ffffff"
    },
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "height": "100vh",
      "text-align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-2em"
    }
  }, [_c('a', {
    staticClass: "header-nav-back",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "16px",
      "color": "#ffffff"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "text-align": "center",
      "margin": "0.61em 0",
      "margin-bottom": "3em",
      "padding-top": "1em"
    }
  }, [_c('p', [_vm._v("Order Details")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-0.31em"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.product.product_name))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.menu_tab_inner_view['confirmOrder']) ? _c('div', [_c('div', {
    staticClass: "row card-box-o",
    staticStyle: {
      "text-align": "left",
      "color": "#ffffff"
    }
  }, [_c('h3', [_c('span', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])]), _vm._v(" Order Confirmation")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.product_ref))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "padding": "2em"
    }
  }, [(_vm.set_order_data.order_items && (Object.keys(_vm.set_order_data.order_items).length > 0)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "-1em"
    }
  }, _vm._l((_vm.set_order_data.order_items), function(product_item, index) {
    return _c('div', {
      staticClass: "card col-xs-12"
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "card-avatar-square",
      staticStyle: {
        "width": "100px",
        "height": "95px"
      }
    }, [(product_item.product_item_group_image) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product_item.product_item_group_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block",
        "padding": "3px",
        "text-align": "center"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(product_item.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(product_item.product_item_price_f))])]), _vm._v("\r\n                      Quantity:"), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (product_item.product_item_order_quantity),
        expression: "product_item.product_item_order_quantity"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (product_item.product_item_order_quantity)
      },
      on: {
        "change": function($event) {
          _vm.setOrderQuantity(product_item)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          product_item.product_item_order_quantity = $event.target.value
        }
      }
    })])])])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "1em",
      "padding-bottom": "2em"
    }
  }, [(_vm.menu_tab_inner_view['confirmOrder']) ? _c('div') : _vm._e()])]) : _c('div', [_c('div', {
    staticClass: "card pb_img_box"
  }, [((_vm.product.product_images && (_vm.product.product_images.length > 0)) && (_vm.product.product_images[0].product_image != '' && _vm.product.product_images[0].product_image != 'error')) ? _c('img', {
    staticClass: "pb_img",
    attrs: {
      "src": _vm.img_product_url + _vm.product.product_images[0].product_image,
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "pb_img",
    attrs: {
      "src": "/static/assets/images/dummy-image.png",
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000",
      "width": "100%",
      "margin-left": "-0.11em",
      "border-left": "#ffffff solid"
    },
    attrs: {
      "id": "shareBox"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {}
    }
  }, [_c('span', {
    staticClass: "s-backdrop"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "max-height": "75vh",
      "overflow": "scroll",
      "bottom": "0",
      "margin": "0 -1.2em",
      "background": "none",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticClass: "z-box",
    staticStyle: {
      "width": "100%",
      "padding": "0.1em",
      "border-radius": "35px 35px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "200px",
      "padding": "2em",
      "text-align": "left"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('shareBox')
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em",
      "margin-bottom": "5em"
    }
  }, [(_vm.set_view_box == '') ? _c('div', {
    staticClass: "row"
  }, [(((!_vm.product.product_addons) || (_vm.product.product_addons && (_vm.product.product_addons.length == 0)))) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.2"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderQuantity(0, 'sub', 0, _vm.product_item, 0)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "38px"
    }
  }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0 0.61em"
    }
  }, [_vm._v(_vm._s(_vm.product_item.product_item_order_quantity))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.6"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderQuantity(0, 'add', 0, _vm.product_item, 0)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "28px"
    }
  }, [_vm._v("+")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _c('div', [_c('h3', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Your Order")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "width": "120%",
      "margin": "0",
      "padding": "0",
      "margin-left": "-1em"
    }
  }, [_c('div', {
    staticClass: "col-xs-2 card-avatar-square",
    staticStyle: {
      "width": "80px",
      "height": "80px"
    }
  }, [(_vm.product.product_images && (Object.keys(_vm.product.product_images).length > 0)) ? _c('img', {
    attrs: {
      "src": _vm.product.product_images[0].product_image
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4",
    staticStyle: {
      "margin-left": "0",
      "margin-top": "0.5em"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.product.product_name))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5",
    staticStyle: {
      "margin-top": "1.4em"
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.2"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderQuantity(0, 'sub', 0, _vm.product_item, 0)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "38px"
    }
  }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0 0.61em"
    }
  }, [_vm._v(_vm._s(_vm.product_item.product_item_order_quantity))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.6"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderQuantity(0, 'add', 0, _vm.product_item, 0)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "28px"
    }
  }, [_vm._v("+")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.product.product_addons && (_vm.product.product_addons.length > 0)) ? _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "128%"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "600"
    }
  }, [_vm._v("you can also add these to your order")]), _vm._v(" "), _vm._l((_vm.product.product_addons), function(product, index) {
    return _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "col-xs-2 card-avatar-square",
      staticStyle: {
        "width": "80px",
        "height": "80px",
        "margin": "0",
        "padding": "0",
        "margin-right": "0"
      }
    }, [(product.product_images && (Object.keys(product.product_images).length > 0)) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4",
      staticStyle: {
        "padding": "3px",
        "padding-left": "8px",
        "margin": "0",
        "text-align": "left"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_c('b', [_vm._v("Add ")]), _vm._v(_vm._s(product.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x",
      staticStyle: {
        "color": "#ff0000",
        "font-weight": "600"
      }
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-5",
      staticStyle: {
        "margin": "0",
        "padding": "0",
        "width": "39.87%"
      }
    }, [_c('div', {}, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 'sub', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(product.product_items[0].product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 'add', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])]), _vm._v(" "), (_vm.checkOrderItems(product.product_items[0])) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(product.product_items[0], index, 0)
        }
      }
    }, [_vm._m(2, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(product.product_items[0], index, 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setDeliveryLocation') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setDeliveryLocation"
    }
  }, [(Object.keys(_vm.business_delivery_locations).length > 0) ? _c('div', [_vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-1em"
    }
  }, [_vm._l((_vm.business_delivery_locations), function(location, index) {
    return _c('div', [_c('p', [_c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.set_order_delivery_location),
        expression: "set_order_delivery_location"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": location.business_delivery_option_id,
        "checked": _vm._q(_vm.set_order_delivery_location, location.business_delivery_option_id)
      },
      on: {
        "click": function($event) {
          _vm.setOrderDeliveryLocation(location)
        },
        "__c": function($event) {
          _vm.set_order_delivery_location = location.business_delivery_option_id
        }
      }
    })]), _vm._v("\r\n                        " + _vm._s(location.business_delivery_state) + " - " + _vm._s(location.business_delivery_option) + " - " + _vm._s(location.business_delivery_option_price) + "\r\n                      ")])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setContactDetails') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setContactDetails"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Order Contact Details")]), _vm._v(" "), (_vm.user.user_id && (_vm.user.user_id > 0)) ? _c('div', [_c('p', [_vm._v("Review contact details")]), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.user.user_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.user.user_email))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.user.user_phone))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivety Address: ")]), _vm._v(_vm._s(_vm.user.user_order_delivey_address))]), _vm._v(" "), _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), ((_vm.set_payment_mode == 1) && (_vm.user.user_email == '')) ? _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]) : _vm._e()]) : _c('div', [(_vm.menu_tab_inner_view['showUserDetails']) ? _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.user.user_name))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.user.user_email))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.user.user_phone))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivety Address: ")]), _vm._v(_vm._s(_vm.user.user_order_delivey_address))]), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Reset")])])]) : _c('div', [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('showUserDetails')
      }
    }
  }, [_vm._v("Ok")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setPaymentOptions') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setPaymentOptions"
    }
  }, [(_vm.menu_tab_inner_view['showOrderPaymentConfirmation']) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setPaymentSuccess"
    }
  }, [_c('p', [_vm._v("Payment Made")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn card-link",
    attrs: {
      "href": '/placed/order/' + _vm.order.order_no
    }
  }, [_vm._v("View Order")])]) : _c('div', [_vm._m(4), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Payment Method")]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_payment_mode),
      expression: "set_payment_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.set_payment_mode, "4")
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('payBank')
      },
      "__c": function($event) {
        _vm.set_payment_mode = "4"
      }
    }
  })]), _vm._v("\r\n                        Pay to Bank")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "payBank"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Bank: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account Name: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_account_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account Number: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_account_number))])])])]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_payment_mode),
      expression: "set_payment_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.set_payment_mode, "1")
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('payDirect')
      },
      "__c": function($event) {
        _vm.set_payment_mode = "1"
      }
    }
  })]), _vm._v("\r\n                        Pay to Direct")]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', [(_vm.data_processing_messages.mode_err) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_messages.mode_err))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.setMakeOrder(_vm.set_payment_mode)
      }
    }
  }, [_vm._v("Place Order")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em",
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.2"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewBox('setDeliveryLocation')
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "38px"
    }
  }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0 0.61em"
    }
  }, [_vm._v("900")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.6"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewBox('setDeliveryLocation')
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "28px"
    }
  }, [_vm._v("+")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (_vm.product.product_addons && (_vm.product.product_addons.length > 0)) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('setOptions');
        _vm.set_view_box = 'setAddons'
      }
    }
  }, [_c('ul', {
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, _vm._l((_vm.product.product_addons), function(product, index) {
    return _c('li', [_c('div', {
      staticClass: "card",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle",
      staticStyle: {
        "width": "50px",
        "height": "45px"
      }
    }, [(product.product_images && (Object.keys(product.product_images).length > 0)) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "none",
        "padding": "3px",
        "text-align": "center"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(product.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])]), _vm._v(" "), (_vm.checkOrderProductAddons(product)) ? _c('div', [_c('input', {
      attrs: {
        "checked": "true",
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setOrderProductAddons(product)
        }
      }
    }), _vm._v(" Added\r\n                            ")]) : _c('div', [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setOrderProductAddons(product)
        }
      }
    }), _vm._v(" Add")])])])])
  }))])])]) : _c('div', {
    staticStyle: {
      "height": "0em"
    }
  }), _vm._v(" "), (Object.keys(_vm.business_delivery_locations).length > 0) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "background-color": "#f5e61d"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewBox('setDeliveryLocation')
      }
    }
  }, [_vm._v("select")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "position": "fixed",
      "background-color": "#ffffff",
      "bottom": "0",
      "width": "100%",
      "padding-left": "1.81em",
      "padding-top": "6px",
      "margin-top": "10px",
      "border-top": "1px solid #eee"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "x-totals"
  }, [(_vm.set_order_total_amount && (_vm.set_order_total_amount > 0)) ? _c('h3', [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.set_order_total_amount)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.set_view_box == 'setPaymentOptions') ? _c('div', [_c('div', [_c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setContactDetails'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])])]) : (_vm.set_view_box == 'setContactDetails') ? _c('div', [_c('div', [_c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setDeliveryLocation'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setPaymentOptions'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])]) : (_vm.set_view_box == 'setDeliveryLocation') ? _c('div', [_c('div', [_c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setContactDetails'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])]) : _c('div', [_c('div', [_c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setDeliveryLocation'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "border": "none",
      "width": "100%",
      "bottom": "0em",
      "margin": "0",
      "padding": "0 2em",
      "padding-top": "1.2em",
      "padding-right": "0",
      "background": "#ffffff",
      "z-index": "1"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "block",
      "width": "100%",
      "height": "auto",
      "padding": "0.1em",
      "background-color": "rgba(0, 0, 0, 0)",
      "border-top": "none",
      "border-radius": "45px 45px 0px 0px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "x-totals"
  }, [(_vm.set_order_total_amount && (_vm.set_order_total_amount > 0)) ? _c('h3', [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.set_order_total_amount)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "x-cta-btn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.processMakeOrder();
        _vm.toggleSingleComponent('shareBox');
      }
    }
  }, [_vm._v("Order Now")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h4', [_vm._v("Quantity")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-shopping-bag",
    staticStyle: {
      "font-size": "3em"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-right",
    staticStyle: {
      "margin-top": "-1.4em"
    }
  }, [_c('h3', [_vm._v("Delivery Locations")]), _vm._v(" "), _c('p', [_vm._v("set where you want this order delivered to")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-shopping-bag",
    staticStyle: {
      "font-size": "3em"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-right",
    staticStyle: {
      "margin-top": "-1.4em"
    }
  }, [_c('h3', [_vm._v("Payment")]), _vm._v(" "), _c('p', [_vm._v("set where you want this order delivered to")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Send to:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "payDirect"
    }
  }, [_c('p', [_vm._v("Pay with your Credit/ATM card")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', [_vm._v("Quantity")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', {
    staticStyle: {
      "line-height": "1.2"
    }
  }, [_vm._v("Add to Order"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "0.05em",
      "font-size": "13px"
    }
  }, [_vm._v("items you should buy with this order")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', [_vm._v("Delivery Location")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
}]}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    staticStyle: {
      "background-color": "#ffffff"
    },
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "1em",
      "margin-right": "1em"
    }
  }, [_c('a', {
    staticClass: "col-xs-1 card-link",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _vm._v("   \r\n      "), _c('a', {
    staticClass: "col-xs-2 x-cta-btn card-link",
    staticStyle: {
      "float": "left",
      "width": "30px",
      "height": "40px",
      "text-align": "center"
    },
    attrs: {
      "href": '/' + _vm.order.order_business_username
    }
  }, [_c('p', {
    staticClass: "ltr-1"
  }, [_vm._v(_vm._s(_vm.order.order_user))])]), _vm._v(" "), _c('p', {
    staticClass: "col-xs-9"
  }, [_vm._v(_vm._s(_vm.order.order_user))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "pager",
    staticStyle: {
      "text-align": "left",
      "margin-top": "5em"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin-bottom": "5em"
    }
  }, [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.menu_tab_inner_view['order_details']) ? _c('div', {}, [_c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "800",
      "font-size": "22px",
      "line-height": "1.6"
    }
  }, [_vm._v("Order Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Order No: ")]), _vm._v(_vm._s(_vm.order.order_no))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Date: ")]), _vm._v(_vm._s(_vm.order.order_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("By: ")]), _vm._v(_vm._s(_vm.order.order_user))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("From: ")]), _vm._v(_vm._s(_vm.order.order_business))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Cost: ")]), _vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_items_total)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivery Charge: ")]), _vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_shipping_total)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Total to pay: ")]), _vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_total)))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right",
      "padding": "0.51em",
      "border-radius": "5px",
      "background-color": "#f7df2b",
      "color": "#000000"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.order.order_status))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Items Ordered")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "category-slide"
  }, [_c('ul', _vm._l((_vm.order.order_items), function(item, index) {
    return _c('li', {}, [(item.product_item_group_image && (item.product_item_group_image != '' && item.product_item_group_image != 'error')) ? _c('img', {
      staticStyle: {
        "width": "80px",
        "height": "100px",
        "border-radius": "8px"
      },
      attrs: {
        "src": _vm.img_product_url + item.product_item_group_image
      }
    }) : _c('img', {
      staticStyle: {
        "width": "80px",
        "height": "100px",
        "border-radius": "8px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('h6', [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), _c('h6', {
      staticStyle: {
        "font-size": "18px",
        "text-align": "left"
      }
    }, [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(item.order_item_total)) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "14px"
      }
    }, [_c('b', [_vm._v("Quantity: ")]), _vm._v(_vm._s(item.order_item_quantity))])])])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Delivery Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [(_vm.order.order_user_delivery_address != '') ? _c('p', [_vm._v(_vm._s(_vm.order.order_user_delivery_address))]) : _c('p', [_vm._v("Not set")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Order Contact Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.order.order_business))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email Address: ")]), _vm._v(_vm._s(_vm.order.order_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone Number: ")]), _vm._v(_vm._s(_vm.order.order_user))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Order Additional Information")]), _vm._v(" "), _c('hr'), _vm._v(" "), (Object.keys(_vm.order_additionals).length > 0) ? _c('div', _vm._l((_vm.order_additionals), function(detail, index) {
    return _c('div', [_c('p', [_c('b', [_vm._v(_vm._s(++index) + ". ")]), _vm._v(_vm._s(detail.order_additional_details))])])
  })) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No additional information")])])]) : _c('div', {}, [_c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Shopping on "), _c('b', [_vm._v(_vm._s(_vm.order.order_date))])]), _vm._v(" "), _c('p', [_vm._v("Status: "), _c('b', [_c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.order.order_status))])])]), _vm._v(" "), _c('p', [_vm._v("Deliver Items and Close this Shopping List Request")]), _vm._v(" "), _c('hr'), _vm._v(" "), (Object.keys(_vm.order_chart).length > 0) ? _c('div', [_c('div', [_c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "container container-right"
  }, [_c('div', {
    staticClass: "card-box card-02"
  }, [_c('h5', [_vm._v("Shopping List "), _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "float": "right"
    }
  }, [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_total)))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_vm._l((_vm.order.order_items), function(item, index) {
    return (index < 4) ? _c('p', {
      key: item.order_item_no
    }, [_vm._v("\r\n                        " + _vm._s(item.product_name) + " - ₦" + _vm._s(item.order_item_total.toFixed(2)) + "\r\n                      ")]) : _vm._e()
  }), _vm._v(" "), _c('a', {}, [_vm._v("see Items")])], 2), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('h5', [_vm._v("Delivery"), _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "float": "right"
    }
  }, [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_shipping_total)))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [(_vm.order.order_user_delivery_address != '') ? _c('p', [_vm._v(_vm._s(_vm.order.order_user_delivery_address))]) : _c('p', [_vm._v("Not set")])])]), _vm._v(" "), (_vm.checkOrderChart('status', 35)) ? _c('div', [_c('hr'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You confirmed these Items are available")])]) : _c('div', [_c('div', [_c('button', {
    staticClass: "btn sp-button-02",
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('setPaymentDetails')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Yes, I have these Items")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "setPaymentDetails"
    }
  }, [_c('div', [_c('hr'), _vm._v(" "), _c('b', [_vm._v("Send Bank Details")]), _c('br'), _vm._v(" "), (_vm.sellpoint.business_bank_details && (Object.keys(_vm.sellpoint.business_bank_details).length > 0)) ? _c('div', [_c('span', [_vm._v("Send bank details details to receive order payment")]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "color": "#444444"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_name)), _c('br'), _vm._v("\r\n                                " + _vm._s(_vm.sellpoint.business_bank_details.bank_account_name)), _c('br'), _vm._v("\r\n                                " + _vm._s(_vm.sellpoint.business_bank_details.bank_account_number) + "\r\n                              ")])]), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderCustomOrderDetailsUpdate(_vm.order)
      }
    }
  }, [_vm._v("Send")])]) : _c('div', [_vm._m(0)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('ConfirmPaymentUpdate')
      }
    }
  }, [_vm._v("Confirm Payment")]), _vm._v(" "), (_vm.menu_tab_inner_view['ConfirmPaymentUpdate']) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Confirm Order Payment ?")]), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderCustomConfirmPaymentUpdate(_vm.order)
      }
    }
  }, [_vm._v("Yes, Confirm Payment")])]) : _vm._e(), _vm._v(" "), _c('hr')])])])])])]), _vm._v(" "), _vm._l((_vm.order_chart), function(track) {
    return _c('div', [_c('div', {
      staticClass: "timeline"
    }, [(track.order_status_id == 20) ? _c('div', {
      staticClass: "container container-left"
    }, [_c('div', {
      staticClass: "card-box card-02"
    }, [_c('h5', [_vm._v("Proof of payment")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', [_vm._v("Please confirm payment")]), _vm._v(" "), _c('div', [(track.order_status_id == 20) ? _c('div', _vm._l((track.order_set_uploads), function(images) {
      return (images.data_image != '') ? _c('div', [(images.data_image) ? _c('img', {
        staticClass: "img-responsive",
        attrs: {
          "src": images.data_image
        }
      }) : _vm._e()]) : _vm._e()
    })) : _vm._e()]), _vm._v(" "), _c('div', [_c('hr'), _vm._v(" "), _c('button', {
      staticClass: "sp-button sp-button-lt",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('ConfirmPaymentUpdate')
        }
      }
    }, [_vm._v("Confirm Payment")]), _vm._v(" "), _c('div', {
      attrs: {
        "id": "ConfirmPaymentUpdate"
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Confirm Order Payment ?")]), _vm._v(" "), _c('button', {
      staticClass: "sp-button sp-button-lt",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderCustomConfirmPaymentUpdate(_vm.order)
        }
      }
    }, [_vm._v("Yes, Confirm Payment")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "timeline"
    }, [_c('div', {
      staticClass: "container container-right"
    }, [(track.order_status_id == 35) ? _c('div', {
      staticClass: "card-box card-02"
    }, [_c('h5', [_vm._v("How to Pay")]), _vm._v(" "), _c('hr'), _vm._v(" "), (track.order_set_bank_name != '') ? _c('h6', [_vm._v("Use the below account details to make payment")]) : _vm._e(), _vm._v(" "), (track.order_set_payment_link != '') ? _c('h6', [_vm._v("click the link below to make payment")]) : _vm._e(), _vm._v(" "), _c('div', [(track.order_status_id == 35) ? _c('div', [(track.order_set_bank_name != '') ? _c('div', [_c('p', [_c('b', [_vm._v("Bank Name: ")]), _vm._v(_vm._s(track.order_set_bank_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Bank Account Name: ")]), _vm._v(_vm._s(track.order_set_bank_account_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Bank Account No: ")]), _vm._v(_vm._s(track.order_set_bank_account_no))])]) : _vm._e()]) : _vm._e()])]) : _vm._e()])])])
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('hr'), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "prImagePreview"
    }
  }), _vm._v(" "), ((Object.keys(_vm.file_info).length == 0)) ? _c('div', [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn sp-button-02",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Upload Receipt")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeNewPhoto($event, 'transfer-receipt')
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.file_info[0]) ? _c('div', [_c('button', {
    staticClass: "btn btn-default wnf-button",
    staticStyle: {
      "width": "30vw",
      "margin-left": "0vw",
      "padding": "5px 3px"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.uploadFlexiPaymentReceipt(_vm.order, _vm.order.order_no, 'transferred')
      }
    }
  }, [_vm._v("Yes, Upload")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default wnf-button",
    staticStyle: {
      "width": "30vw",
      "margin-left": "0vw",
      "padding": "5px 3px",
      "background-color": "#f5f4e6",
      "color": "#000000"
    },
    on: {
      "click": function($event) {
        _vm.resetImageUpload()
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])])], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000",
      "width": "100%",
      "margin-left": "-0.11em",
      "border-left": "#ffffff solid"
    },
    attrs: {
      "id": "shareBox"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {}
    }
  }, [_c('span', {
    staticClass: "s-backdrop"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "max-height": "75vh",
      "overflow": "scroll",
      "bottom": "0",
      "margin": "0 -1.2em",
      "background": "none",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticClass: "z-box",
    staticStyle: {
      "width": "100%",
      "padding": "0.1em",
      "border-radius": "35px 35px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "200px",
      "padding": "2em",
      "margin-bottom": "5.8em",
      "border-bottom": "#eee solid",
      "text-align": "left"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('shareBox')
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em",
      "margin-bottom": "5em"
    }
  }, [(_vm.set_view_box == '') ? _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Give a star rating")]), _vm._v(" "), _vm._l((5), function(star) {
    return _c('div', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "margin-right": "2em",
        "font-size": "28px",
        "line-height": "0.4",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.setRate(_vm.order.order_items[0], star)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-star-o",
      attrs: {
        "id": 'rate-' + star
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-star",
      staticStyle: {
        "display": "none",
        "color": "#f7df2b"
      },
      attrs: {
        "id": 'rated-' + star
      }
    })]), _vm._v(" "), _c('p', {
      staticStyle: {
        "margin-top": "0.2em",
        "color": "#000000",
        "font-size": "12px",
        "font-weight": "600"
      }
    }, [(star == 1) ? _c('span', [_vm._v("Bad")]) : _vm._e(), _vm._v(" "), (star == 2) ? _c('span', [_vm._v("Not Bad")]) : _vm._e(), _vm._v(" "), (star == 3) ? _c('span', [_vm._v("Okay")]) : _vm._e(), _vm._v(" "), (star == 4) ? _c('span', [_vm._v("Good")]) : _vm._e(), _vm._v(" "), (star == 5) ? _c('span', [_vm._v("Great")]) : _vm._e()])])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('a', {
    staticClass: "card-link x-cta-btn",
    on: {
      "click": function($event) {
        _vm.submitReview()
      }
    }
  }, [_vm._v("Send\r\n                    "), (_vm.action_loading) ? _c('span', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]) : _vm._e()])])], 2) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setDeliveryLocation') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setDeliveryLocation"
    }
  }, [(Object.keys(_vm.business_delivery_locations).length > 0) ? _c('div', [_vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-1em"
    }
  }, [_vm._l((_vm.business_delivery_locations), function(location, index) {
    return _c('div', [_c('p', [_c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.set_order_delivery_location),
        expression: "set_order_delivery_location"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": location.business_delivery_option_id,
        "checked": _vm._q(_vm.set_order_delivery_location, location.business_delivery_option_id)
      },
      on: {
        "click": function($event) {
          _vm.setOrderDeliveryLocation(location)
        },
        "__c": function($event) {
          _vm.set_order_delivery_location = location.business_delivery_option_id
        }
      }
    })]), _vm._v("\r\n                        " + _vm._s(location.business_delivery_state) + " - " + _vm._s(location.business_delivery_option) + " - " + _vm._s(location.business_delivery_option_price) + "\r\n                      ")])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setContactDetails') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setContactDetails"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Order Contact Details")]), _vm._v(" "), (_vm.user.user_id && (_vm.user.user_id > 0)) ? _c('div', [_c('p', [_vm._v("Review contact details")]), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.user.user_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.user.user_email))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.user.user_phone))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivety Address: ")]), _vm._v(_vm._s(_vm.user.user_order_delivey_address))]), _vm._v(" "), _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), ((_vm.set_payment_mode == 1) && (_vm.user.user_email == '')) ? _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]) : _vm._e()]) : _c('div', [(_vm.menu_tab_inner_view['showUserDetails']) ? _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.user.user_name))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.user.user_email))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.user.user_phone))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivety Address: ")]), _vm._v(_vm._s(_vm.user.user_order_delivey_address))]), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Reset")])])]) : _c('div', [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('showUserDetails')
      }
    }
  }, [_vm._v("Ok")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setPaymentOptions') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setPaymentOptions"
    }
  }, [(_vm.menu_tab_inner_view['showOrderPaymentConfirmation']) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setPaymentSuccess"
    }
  }, [_c('p', [_vm._v("Payment Made")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn card-link",
    attrs: {
      "href": '/placed/order/' + _vm.order.order_no
    }
  }, [_vm._v("View Order")])]) : _c('div', [_vm._m(4), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Payment Method")]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_payment_mode),
      expression: "set_payment_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.set_payment_mode, "4")
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('payBank')
      },
      "__c": function($event) {
        _vm.set_payment_mode = "4"
      }
    }
  })]), _vm._v("\r\n                        Pay to Bank")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "payBank"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Bank: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account Name: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_account_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account Number: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_account_number))])])])]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_payment_mode),
      expression: "set_payment_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.set_payment_mode, "1")
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('payDirect')
      },
      "__c": function($event) {
        _vm.set_payment_mode = "1"
      }
    }
  })]), _vm._v("\r\n                        Pay to Direct")]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', [(_vm.data_processing_messages.mode_err) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_messages.mode_err))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.setMakeOrder(_vm.set_payment_mode)
      }
    }
  }, [_vm._v("Place Order")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em",
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.2"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewBox('setDeliveryLocation')
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "38px"
    }
  }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0 0.61em"
    }
  }, [_vm._v("900")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.6"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewBox('setDeliveryLocation')
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "28px"
    }
  }, [_vm._v("+")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (_vm.product.product_addons && (_vm.product.product_addons.length > 0)) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('setOptions');
        _vm.set_view_box = 'setAddons'
      }
    }
  }, [_c('ul', {
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, _vm._l((_vm.product.product_addons), function(product, index) {
    return _c('li', [_c('div', {
      staticClass: "card",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle",
      staticStyle: {
        "width": "50px",
        "height": "45px"
      }
    }, [(product.product_images && (Object.keys(product.product_images).length > 0)) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "none",
        "padding": "3px",
        "text-align": "center"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(product.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])]), _vm._v(" "), (_vm.checkOrderProductAddons(product)) ? _c('div', [_c('input', {
      attrs: {
        "checked": "true",
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setOrderProductAddons(product)
        }
      }
    }), _vm._v(" Added\r\n                            ")]) : _c('div', [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setOrderProductAddons(product)
        }
      }
    }), _vm._v(" Add")])])])])
  }))])])]) : _c('div', {
    staticStyle: {
      "height": "0em"
    }
  }), _vm._v(" "), (Object.keys(_vm.business_delivery_locations).length > 0) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "background-color": "#f5e61d"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewBox('setDeliveryLocation')
      }
    }
  }, [_vm._v("select")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "position": "fixed",
      "border": "none",
      "width": "100%",
      "bottom": "0",
      "margin": "0",
      "padding-top": "1.2em",
      "padding-right": "0",
      "background": "#ffffff",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "block",
      "width": "100%",
      "height": "auto",
      "background-color": "rgba(0, 0, 0, 0)"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000",
      "width": "100%"
    },
    attrs: {
      "id": "shareBoxtt"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {}
    }
  }, [_c('span', {
    staticClass: "s-backdrop",
    staticStyle: {
      "bottom": "5em"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "max-height": "75vh",
      "overflow": "scroll",
      "bottom": "5em",
      "margin": "0 -1.2em",
      "background": "none",
      "z-index": "10000"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('shareBox')
      }
    }
  }, [_vm._m(10), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em",
      "margin-bottom": "5em"
    }
  }, [(_vm.set_view_box == '') ? _c('div', {
    staticClass: "row"
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "border-top": "#f5f3f3 solid"
    }
  }, [_c('div', {
    staticClass: "row-ic-02",
    staticStyle: {
      "margin-top": "0.01em"
    }
  }, [_c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "padding-left": "0",
      "background-color": "#f7df2b"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._m(11), _c('span', {
    staticClass: "ct-dsc"
  }, [_vm._v("Confirm Purchase")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "background-color": "#fae570"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('order_details')
      }
    }
  }, [_vm._m(12), _c('span', {
    staticClass: "ct-dsc",
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v("Shopping List")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Set Bank details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Send Payment Link")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("A Payment link with payment details would be generated for payment")]), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "sp-button sp-button-lt",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Send Payment Link")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-shopping-bag",
    staticStyle: {
      "font-size": "3em"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-right",
    staticStyle: {
      "margin-top": "-1.4em"
    }
  }, [_c('h3', [_vm._v("Delivery Locations")]), _vm._v(" "), _c('p', [_vm._v("set where you want this order delivered to")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-shopping-bag",
    staticStyle: {
      "font-size": "3em"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-right",
    staticStyle: {
      "margin-top": "-1.4em"
    }
  }, [_c('h3', [_vm._v("Payment")]), _vm._v(" "), _c('p', [_vm._v("set where you want this order delivered to")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Send to:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "payDirect"
    }
  }, [_c('p', [_vm._v("Pay with your Credit/ATM card")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', [_vm._v("Quantity")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', {
    staticStyle: {
      "line-height": "1.2"
    }
  }, [_vm._v("Add to Order"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "0.05em",
      "font-size": "13px"
    }
  }, [_vm._v("items you should buy with this order")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', [_vm._v("Delivery Location")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin": "0 1em",
      "border-radius": "38%",
      "color": "#000000",
      "padding": "0.22em 0.31em"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right",
    staticStyle: {
      "font-size": "1.6em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin": "0 1em",
      "border-radius": "38%",
      "color": "#000000",
      "padding": "0.22em 0.31em"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    staticStyle: {
      "font-size": "1.6em"
    }
  })])
}]}

/***/ }),
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[161]);


// WEBPACK FOOTER //
// static/js/app.2a1905214d9fa8fb2002.js